


import { vars } from '../models/globalVars';
/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v8.6.6221.23503 (NJsonSchema v7.6.6221.22528) (http://NSwag.org)
// </auto-generated>
//----------------------


export class AccountApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getUsername(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            this.getUsernameWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getUsernameWithCallbacks(onSuccess?: (result: string) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Account/GetUsername";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetUsernameWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetUsernameWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetUsernameWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetUsername(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetUsername(xhr: any): string {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: string = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getCaptcha(): Promise<CaptchaResponse> {
        return new Promise<CaptchaResponse>((resolve, reject) => {
            this.getCaptchaWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getCaptchaWithCallbacks(onSuccess?: (result: CaptchaResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Account/GetCaptcha";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetCaptchaWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetCaptchaWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetCaptchaWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetCaptcha(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetCaptcha(xhr: any): CaptchaResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: CaptchaResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? CaptchaResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    login(request: AccountLoginRequest): Promise<AccountLoginResponse> {
        return new Promise<AccountLoginResponse>((resolve, reject) => {
            this.loginWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private loginWithCallbacks(request: AccountLoginRequest, onSuccess?: (result: AccountLoginResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Account/Login";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processLoginWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLoginWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLoginWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLogin(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLogin(xhr: any): AccountLoginResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: AccountLoginResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? AccountLoginResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    updateUserLatestActiveDateAndReturnUserActiveCount(lobbyId: number): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            this.updateUserLatestActiveDateAndReturnUserActiveCountWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private updateUserLatestActiveDateAndReturnUserActiveCountWithCallbacks(lobbyId: number, onSuccess?: (result: number) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/UpdateUserLatestActiveDate?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processUpdateUserLatestActiveDateAndReturnUserActiveCountWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdateUserLatestActiveDateAndReturnUserActiveCountWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdateUserLatestActiveDateAndReturnUserActiveCountWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdateUserLatestActiveDateAndReturnUserActiveCount(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdateUserLatestActiveDateAndReturnUserActiveCount(xhr: any): number {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: number = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    changePassword(lobbyId: number, request: ChangePasswordRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.changePasswordWithCallbacks(lobbyId, request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private changePasswordWithCallbacks(lobbyId: number, request: ChangePasswordRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/ChangePassword?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processChangePasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processChangePasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processChangePasswordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processChangePassword(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processChangePassword(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    changeUserPassword(lobbyId: number, request: ChangeUserPasswordRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.changeUserPasswordWithCallbacks(lobbyId, request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private changeUserPasswordWithCallbacks(lobbyId: number, request: ChangeUserPasswordRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/ChangeUserPassword?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processChangeUserPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processChangeUserPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processChangeUserPasswordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processChangeUserPassword(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processChangeUserPassword(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class AuthorizeRoleBehaviorApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getBehaviors(actionType: string): Promise<AuthorizeRoleBehaviorPerPageDao[]> {
        return new Promise<AuthorizeRoleBehaviorPerPageDao[]>((resolve, reject) => {
            this.getBehaviorsWithCallbacks(actionType, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getBehaviorsWithCallbacks(actionType: string, onSuccess?: (result: AuthorizeRoleBehaviorPerPageDao[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/AuthorizeRoleBehavior/GetBehaviors?";
        if (actionType === undefined)
            throw new Error("The parameter 'actionType' must be defined.");
        else
            url_ += "actionType=" + encodeURIComponent("" + actionType) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetBehaviorsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetBehaviorsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetBehaviorsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetBehaviors(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetBehaviors(xhr: any): AuthorizeRoleBehaviorPerPageDao[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: AuthorizeRoleBehaviorPerPageDao[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AuthorizeRoleBehaviorPerPageDao.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class AuthorizeUserActionApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    isAuthorize(actionType: string, currentToken: string, urlKey: string): Promise<AuthorizeUserActionResposne> {
        return new Promise<AuthorizeUserActionResposne>((resolve, reject) => {
            this.isAuthorizeWithCallbacks(actionType, currentToken, urlKey, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private isAuthorizeWithCallbacks(actionType: string, currentToken: string, urlKey: string, onSuccess?: (result: AuthorizeUserActionResposne) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/AuthorizeUserAction/IsAuthorize?";
        if (actionType === undefined)
            throw new Error("The parameter 'actionType' must be defined.");
        else
            url_ += "actionType=" + encodeURIComponent("" + actionType) + "&"; 
        
        if (currentToken === undefined)
            throw new Error("The parameter 'currentToken' must be defined.");
        else
            url_ += "currentToken=" + encodeURIComponent("" + currentToken) + "&"; 
        
        if (urlKey === undefined)
            throw new Error("The parameter 'urlKey' must be defined.");
        else
            url_ += "urlKey=" + encodeURIComponent("" + urlKey) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processIsAuthorizeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processIsAuthorizeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processIsAuthorizeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processIsAuthorize(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processIsAuthorize(xhr: any): AuthorizeUserActionResposne {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: AuthorizeUserActionResposne = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthorizeUserActionResposne.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    isAuthorizeBehavior(actionType: string, currentToken: string, urlKey: string, behavior: string): Promise<AuthorizeUserBehaviorResposne> {
        return new Promise<AuthorizeUserBehaviorResposne>((resolve, reject) => {
            this.isAuthorizeBehaviorWithCallbacks(actionType, currentToken, urlKey, behavior, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private isAuthorizeBehaviorWithCallbacks(actionType: string, currentToken: string, urlKey: string, behavior: string, onSuccess?: (result: AuthorizeUserBehaviorResposne) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/AuthorizeUserAction/IsAuthorizeBehavior?";
        if (actionType === undefined)
            throw new Error("The parameter 'actionType' must be defined.");
        else
            url_ += "actionType=" + encodeURIComponent("" + actionType) + "&"; 
        
        if (currentToken === undefined)
            throw new Error("The parameter 'currentToken' must be defined.");
        else
            url_ += "currentToken=" + encodeURIComponent("" + currentToken) + "&"; 
        
        if (urlKey === undefined)
            throw new Error("The parameter 'urlKey' must be defined.");
        else
            url_ += "urlKey=" + encodeURIComponent("" + urlKey) + "&"; 
        
        if (behavior === undefined)
            throw new Error("The parameter 'behavior' must be defined.");
        else
            url_ += "behavior=" + encodeURIComponent("" + behavior) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processIsAuthorizeBehaviorWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processIsAuthorizeBehaviorWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processIsAuthorizeBehaviorWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processIsAuthorizeBehavior(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processIsAuthorizeBehavior(xhr: any): AuthorizeUserBehaviorResposne {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: AuthorizeUserBehaviorResposne = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthorizeUserBehaviorResposne.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class AutoPromotionApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getForIndex(lobbyId: number, autoPromotionId: AutoPromotionId, language: LanguageCode): Promise<GetForIndexResponse[]> {
        return new Promise<GetForIndexResponse[]>((resolve, reject) => {
            this.getForIndexWithCallbacks(lobbyId, autoPromotionId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForIndexWithCallbacks(lobbyId: number, autoPromotionId: AutoPromotionId, language: LanguageCode, onSuccess?: (result: GetForIndexResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/AutoPromotion/GetForIndex?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (autoPromotionId === undefined || autoPromotionId === null)
            throw new Error("The parameter 'autoPromotionId' must be defined and cannot be null.");
        else
            url_ += "autoPromotionId=" + encodeURIComponent("" + autoPromotionId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForIndexWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForIndex(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForIndex(xhr: any): GetForIndexResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: GetForIndexResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetForIndexResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForPart(lobbyId: number, autoPromotionId: AutoPromotionId, lobbyPromotionId: number, language: LanguageCode): Promise<GetForPartResponse[]> {
        return new Promise<GetForPartResponse[]>((resolve, reject) => {
            this.getForPartWithCallbacks(lobbyId, autoPromotionId, lobbyPromotionId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForPartWithCallbacks(lobbyId: number, autoPromotionId: AutoPromotionId, lobbyPromotionId: number, language: LanguageCode, onSuccess?: (result: GetForPartResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/AutoPromotion/GetForPart?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (autoPromotionId === undefined || autoPromotionId === null)
            throw new Error("The parameter 'autoPromotionId' must be defined and cannot be null.");
        else
            url_ += "autoPromotionId=" + encodeURIComponent("" + autoPromotionId) + "&"; 
        
        if (lobbyPromotionId === undefined || lobbyPromotionId === null)
            throw new Error("The parameter 'lobbyPromotionId' must be defined and cannot be null.");
        else
            url_ += "lobbyPromotionId=" + encodeURIComponent("" + lobbyPromotionId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForPartWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForPartWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForPartWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForPart(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForPart(xhr: any): GetForPartResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: GetForPartResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetForPartResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForDetail(request: GetForDetailRequest): Promise<GetForDetailResponse[]> {
        return new Promise<GetForDetailResponse[]>((resolve, reject) => {
            this.getForDetailWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForDetailWithCallbacks(request: GetForDetailRequest, onSuccess?: (result: GetForDetailResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/AutoPromotion/GetForDetail";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForDetailWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForDetail(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForDetail(xhr: any): GetForDetailResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: GetForDetailResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetForDetailResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForPartDetail(request: GetForPartDetailRequest): Promise<GetForPartDetailResponse> {
        return new Promise<GetForPartDetailResponse>((resolve, reject) => {
            this.getForPartDetailWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForPartDetailWithCallbacks(request: GetForPartDetailRequest, onSuccess?: (result: GetForPartDetailResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/AutoPromotion/GetForPartDetail";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForPartDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForPartDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForPartDetailWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForPartDetail(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForPartDetail(xhr: any): GetForPartDetailResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: GetForPartDetailResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetForPartDetailResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    addPart(request: AddLobbyAutoPromotionPlayersRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.addPartWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addPartWithCallbacks(request: AddLobbyAutoPromotionPlayersRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/AutoPromotion/AddPart";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAddPartWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddPartWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddPartWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAddPart(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAddPart(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    add(lobbyAutoPromotionId: number, request: AddLobbyAutoPromotionPlayersRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.addWithCallbacks(lobbyAutoPromotionId, request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addWithCallbacks(lobbyAutoPromotionId: number, request: AddLobbyAutoPromotionPlayersRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/AutoPromotion/Add?";
        if (lobbyAutoPromotionId === undefined || lobbyAutoPromotionId === null)
            throw new Error("The parameter 'lobbyAutoPromotionId' must be defined and cannot be null.");
        else
            url_ += "lobbyAutoPromotionId=" + encodeURIComponent("" + lobbyAutoPromotionId) + "&";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAdd(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(lobbyAutoPromotionId: number, language: LanguageCode): Promise<GetForEditResponse> {
        return new Promise<GetForEditResponse>((resolve, reject) => {
            this.getForEditWithCallbacks(lobbyAutoPromotionId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(lobbyAutoPromotionId: number, language: LanguageCode, onSuccess?: (result: GetForEditResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/AutoPromotion/GetForEdit?";
        if (lobbyAutoPromotionId === undefined || lobbyAutoPromotionId === null)
            throw new Error("The parameter 'lobbyAutoPromotionId' must be defined and cannot be null.");
        else
            url_ += "lobbyAutoPromotionId=" + encodeURIComponent("" + lobbyAutoPromotionId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): GetForEditResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: GetForEditResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetForEditResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: EditRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.editWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: EditRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/AutoPromotion/Edit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    addAndRedeem(request: ApplyAutoPromotionRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.addAndRedeemWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addAndRedeemWithCallbacks(request: ApplyAutoPromotionRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/AutoPromotion/AddAndRedeem";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAddAndRedeemWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddAndRedeemWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddAndRedeemWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAddAndRedeem(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAddAndRedeem(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class ClientPushApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    insertDeposit(lobbyId: number, transactionNo: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.insertDepositWithCallbacks(lobbyId, transactionNo, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private insertDepositWithCallbacks(lobbyId: number, transactionNo: string, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ClientPush/InsertDeposit?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (transactionNo === undefined)
            throw new Error("The parameter 'transactionNo' must be defined.");
        else
            url_ += "transactionNo=" + encodeURIComponent("" + transactionNo) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processInsertDepositWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processInsertDepositWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processInsertDepositWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processInsertDeposit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processInsertDeposit(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    insertDigitalWalletDeposit(lobbyId: number, transactionNo: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.insertDigitalWalletDepositWithCallbacks(lobbyId, transactionNo, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private insertDigitalWalletDepositWithCallbacks(lobbyId: number, transactionNo: string, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ClientPush/InsertDigitalWalletDeposit?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (transactionNo === undefined)
            throw new Error("The parameter 'transactionNo' must be defined.");
        else
            url_ += "transactionNo=" + encodeURIComponent("" + transactionNo) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processInsertDigitalWalletDepositWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processInsertDigitalWalletDepositWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processInsertDigitalWalletDepositWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processInsertDigitalWalletDeposit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processInsertDigitalWalletDeposit(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    insertManualAlipay(lobbyId: number, transactionNo: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.insertManualAlipayWithCallbacks(lobbyId, transactionNo, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private insertManualAlipayWithCallbacks(lobbyId: number, transactionNo: string, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ClientPush/InsertManualAlipay?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (transactionNo === undefined)
            throw new Error("The parameter 'transactionNo' must be defined.");
        else
            url_ += "transactionNo=" + encodeURIComponent("" + transactionNo) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processInsertManualAlipayWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processInsertManualAlipayWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processInsertManualAlipayWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processInsertManualAlipay(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processInsertManualAlipay(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    insertPromotion(lobbyId: number, transactionNo: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.insertPromotionWithCallbacks(lobbyId, transactionNo, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private insertPromotionWithCallbacks(lobbyId: number, transactionNo: string, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ClientPush/InsertPromotion?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (transactionNo === undefined)
            throw new Error("The parameter 'transactionNo' must be defined.");
        else
            url_ += "transactionNo=" + encodeURIComponent("" + transactionNo) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processInsertPromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processInsertPromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processInsertPromotionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processInsertPromotion(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processInsertPromotion(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    insertWithdraw(lobbyId: number, transactionNo: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.insertWithdrawWithCallbacks(lobbyId, transactionNo, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private insertWithdrawWithCallbacks(lobbyId: number, transactionNo: string, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ClientPush/InsertWithdraw?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (transactionNo === undefined)
            throw new Error("The parameter 'transactionNo' must be defined.");
        else
            url_ += "transactionNo=" + encodeURIComponent("" + transactionNo) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processInsertWithdrawWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processInsertWithdrawWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processInsertWithdrawWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processInsertWithdraw(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processInsertWithdraw(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    joinGroup(connectionId: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.joinGroupWithCallbacks(connectionId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private joinGroupWithCallbacks(connectionId: string, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ClientPush/JoinGroup?";
        if (connectionId === undefined)
            throw new Error("The parameter 'connectionId' must be defined.");
        else
            url_ += "connectionId=" + encodeURIComponent("" + connectionId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processJoinGroupWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processJoinGroupWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processJoinGroupWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processJoinGroup(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processJoinGroup(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    updateGiftPointApplicationCount(lobbyId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.updateGiftPointApplicationCountWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private updateGiftPointApplicationCountWithCallbacks(lobbyId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ClientPush/UpdateGiftPointApplicationCount?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processUpdateGiftPointApplicationCountWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdateGiftPointApplicationCountWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdateGiftPointApplicationCountWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdateGiftPointApplicationCount(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdateGiftPointApplicationCount(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    refreshWithdraw(lobbyId: number, transactionNo: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.refreshWithdrawWithCallbacks(lobbyId, transactionNo, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private refreshWithdrawWithCallbacks(lobbyId: number, transactionNo: string, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ClientPush/RefreshWithdraw?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (transactionNo === undefined)
            throw new Error("The parameter 'transactionNo' must be defined.");
        else
            url_ += "transactionNo=" + encodeURIComponent("" + transactionNo) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processRefreshWithdrawWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processRefreshWithdrawWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processRefreshWithdrawWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processRefreshWithdraw(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processRefreshWithdraw(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class ComplainAdviceApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    get(request: ComplainAdvice_GetAll_Request): Promise<StandardResponseOfComplainAdvice_GetAll_Response> {
        return new Promise<StandardResponseOfComplainAdvice_GetAll_Response>((resolve, reject) => {
            this.getWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWithCallbacks(request: ComplainAdvice_GetAll_Request, onSuccess?: (result: StandardResponseOfComplainAdvice_GetAll_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ComplainAdvice/Get";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): StandardResponseOfComplainAdvice_GetAll_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfComplainAdvice_GetAll_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfComplainAdvice_GetAll_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getById(request: ComplainAdvice_GetById_Request): Promise<StandardResponseOfComplainAdvice_GetById_Response> {
        return new Promise<StandardResponseOfComplainAdvice_GetById_Response>((resolve, reject) => {
            this.getByIdWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByIdWithCallbacks(request: ComplainAdvice_GetById_Request, onSuccess?: (result: StandardResponseOfComplainAdvice_GetById_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ComplainAdvice/GetById";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetById(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetById(xhr: any): StandardResponseOfComplainAdvice_GetById_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfComplainAdvice_GetById_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfComplainAdvice_GetById_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class ContentTypeApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getById(request: CT_GetById_Request): Promise<StandardResponseOfCT_GetBetId_Response> {
        return new Promise<StandardResponseOfCT_GetBetId_Response>((resolve, reject) => {
            this.getByIdWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByIdWithCallbacks(request: CT_GetById_Request, onSuccess?: (result: StandardResponseOfCT_GetBetId_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ContentType/GetById";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetById(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetById(xhr: any): StandardResponseOfCT_GetBetId_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfCT_GetBetId_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfCT_GetBetId_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getAll(): Promise<StandardResponseOfCT_GetAll_Response> {
        return new Promise<StandardResponseOfCT_GetAll_Response>((resolve, reject) => {
            this.getAllWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllWithCallbacks(onSuccess?: (result: StandardResponseOfCT_GetAll_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ContentType/GetAll";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAll(xhr: any): StandardResponseOfCT_GetAll_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfCT_GetAll_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfCT_GetAll_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class DebugLogApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    createDebugLog(logMessage: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.createDebugLogWithCallbacks(logMessage, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createDebugLogWithCallbacks(logMessage: string, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/DebugLog/CreateDebugLog?";
        if (logMessage === undefined)
            throw new Error("The parameter 'logMessage' must be defined.");
        else
            url_ += "logMessage=" + encodeURIComponent("" + logMessage) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateDebugLogWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateDebugLogWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateDebugLogWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreateDebugLog(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreateDebugLog(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class InternalTransferApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getRecords(request: IT_GetRecordsRequest): Promise<IT_GetRecordsResponse> {
        return new Promise<IT_GetRecordsResponse>((resolve, reject) => {
            this.getRecordsWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getRecordsWithCallbacks(request: IT_GetRecordsRequest, onSuccess?: (result: IT_GetRecordsResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/InternalTransfer/GetRecords";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetRecordsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetRecordsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetRecordsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetRecords(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetRecords(xhr: any): IT_GetRecordsResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: IT_GetRecordsResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? IT_GetRecordsResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getById(request: IT_GetByIdRequest): Promise<IT_GetByIdResponse> {
        return new Promise<IT_GetByIdResponse>((resolve, reject) => {
            this.getByIdWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByIdWithCallbacks(request: IT_GetByIdRequest, onSuccess?: (result: IT_GetByIdResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/InternalTransfer/GetById";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetById(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetById(xhr: any): IT_GetByIdResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: IT_GetByIdResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? IT_GetByIdResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    refillMissingPoint(request: IT_RefillMissingPointRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.refillMissingPointWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private refillMissingPointWithCallbacks(request: IT_RefillMissingPointRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/InternalTransfer/RefillMissingPoint";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processRefillMissingPointWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processRefillMissingPointWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processRefillMissingPointWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processRefillMissingPoint(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processRefillMissingPoint(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    completeWithoutRefilling(request: IT_CompleteWithoutRefillingRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.completeWithoutRefillingWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private completeWithoutRefillingWithCallbacks(request: IT_CompleteWithoutRefillingRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/InternalTransfer/CompleteWithoutRefilling";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCompleteWithoutRefillingWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCompleteWithoutRefillingWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCompleteWithoutRefillingWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCompleteWithoutRefilling(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCompleteWithoutRefilling(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyDomainApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    get(request: LobbyDomainGetRequest): Promise<StandardResponseOfLobbyDomainGetResponse> {
        return new Promise<StandardResponseOfLobbyDomainGetResponse>((resolve, reject) => {
            this.getWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWithCallbacks(request: LobbyDomainGetRequest, onSuccess?: (result: StandardResponseOfLobbyDomainGetResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyDomain/Get";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): StandardResponseOfLobbyDomainGetResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfLobbyDomainGetResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfLobbyDomainGetResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    updateIsEnable(request: LobbyDomainUpdateIsEnableRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.updateIsEnableWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private updateIsEnableWithCallbacks(request: LobbyDomainUpdateIsEnableRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyDomain/UpdateIsEnable";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processUpdateIsEnableWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdateIsEnableWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdateIsEnableWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdateIsEnable(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdateIsEnable(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyDigitalWalletAccountApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAll(): Promise<StandardResponseOfListOfLobbyDigitalWalletAccountDao> {
        return new Promise<StandardResponseOfListOfLobbyDigitalWalletAccountDao>((resolve, reject) => {
            this.getAllWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllWithCallbacks(onSuccess?: (result: StandardResponseOfListOfLobbyDigitalWalletAccountDao) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyDigitalWalletAccount/GetAll";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAll(xhr: any): StandardResponseOfListOfLobbyDigitalWalletAccountDao {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfListOfLobbyDigitalWalletAccountDao = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfListOfLobbyDigitalWalletAccountDao.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(lobbyDigitalWalletAccountId: number): Promise<StandardResponseOfLobbyDigitalWalletAccountGetForEditResponse> {
        return new Promise<StandardResponseOfLobbyDigitalWalletAccountGetForEditResponse>((resolve, reject) => {
            this.getForEditWithCallbacks(lobbyDigitalWalletAccountId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(lobbyDigitalWalletAccountId: number, onSuccess?: (result: StandardResponseOfLobbyDigitalWalletAccountGetForEditResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyDigitalWalletAccount/GetForEdit?";
        if (lobbyDigitalWalletAccountId === undefined || lobbyDigitalWalletAccountId === null)
            throw new Error("The parameter 'lobbyDigitalWalletAccountId' must be defined and cannot be null.");
        else
            url_ += "lobbyDigitalWalletAccountId=" + encodeURIComponent("" + lobbyDigitalWalletAccountId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): StandardResponseOfLobbyDigitalWalletAccountGetForEditResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfLobbyDigitalWalletAccountGetForEditResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfLobbyDigitalWalletAccountGetForEditResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForAdd(): Promise<StandardResponseOfLobbyDigitalWalletAccountGetForAddResponse> {
        return new Promise<StandardResponseOfLobbyDigitalWalletAccountGetForAddResponse>((resolve, reject) => {
            this.getForAddWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForAddWithCallbacks(onSuccess?: (result: StandardResponseOfLobbyDigitalWalletAccountGetForAddResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyDigitalWalletAccount/GetForAdd";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForAdd(xhr: any): StandardResponseOfLobbyDigitalWalletAccountGetForAddResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfLobbyDigitalWalletAccountGetForAddResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfLobbyDigitalWalletAccountGetForAddResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    create(request: LobbyDigitalWalletAccountCreateEditRequest): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.createWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createWithCallbacks(request: LobbyDigitalWalletAccountCreateEditRequest, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyDigitalWalletAccount/Create";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreate(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: LobbyDigitalWalletAccountCreateEditRequest): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.editWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: LobbyDigitalWalletAccountCreateEditRequest, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyDigitalWalletAccount/Edit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    delete(lobbyDigitalWalletAccountId: number): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.deleteWithCallbacks(lobbyDigitalWalletAccountId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private deleteWithCallbacks(lobbyDigitalWalletAccountId: number, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyDigitalWalletAccount/Delete?";
        if (lobbyDigitalWalletAccountId === undefined || lobbyDigitalWalletAccountId === null)
            throw new Error("The parameter 'lobbyDigitalWalletAccountId' must be defined and cannot be null.");
        else
            url_ += "lobbyDigitalWalletAccountId=" + encodeURIComponent("" + lobbyDigitalWalletAccountId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDeleteWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDelete(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDelete(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    restore(lobbyDigitalWalletAccountId: number): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.restoreWithCallbacks(lobbyDigitalWalletAccountId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private restoreWithCallbacks(lobbyDigitalWalletAccountId: number, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyDigitalWalletAccount/Restore?";
        if (lobbyDigitalWalletAccountId === undefined || lobbyDigitalWalletAccountId === null)
            throw new Error("The parameter 'lobbyDigitalWalletAccountId' must be defined and cannot be null.");
        else
            url_ += "lobbyDigitalWalletAccountId=" + encodeURIComponent("" + lobbyDigitalWalletAccountId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processRestoreWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processRestoreWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processRestoreWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processRestore(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processRestore(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    isAccountNoExist(lobbyDigitalWalletId: number, accountNo: string): Promise<StandardResultOfLobbyDigitalWalletAccountIsAccountNoExistResponse> {
        return new Promise<StandardResultOfLobbyDigitalWalletAccountIsAccountNoExistResponse>((resolve, reject) => {
            this.isAccountNoExistWithCallbacks(lobbyDigitalWalletId, accountNo, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private isAccountNoExistWithCallbacks(lobbyDigitalWalletId: number, accountNo: string, onSuccess?: (result: StandardResultOfLobbyDigitalWalletAccountIsAccountNoExistResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyDigitalWalletAccount/IsAccountNoExist?";
        if (lobbyDigitalWalletId === undefined || lobbyDigitalWalletId === null)
            throw new Error("The parameter 'lobbyDigitalWalletId' must be defined and cannot be null.");
        else
            url_ += "lobbyDigitalWalletId=" + encodeURIComponent("" + lobbyDigitalWalletId) + "&"; 
        
        if (accountNo === undefined)
            throw new Error("The parameter 'accountNo' must be defined.");
        else
            url_ += "accountNo=" + encodeURIComponent("" + accountNo) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processIsAccountNoExistWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processIsAccountNoExistWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processIsAccountNoExistWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processIsAccountNoExist(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processIsAccountNoExist(xhr: any): StandardResultOfLobbyDigitalWalletAccountIsAccountNoExistResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResultOfLobbyDigitalWalletAccountIsAccountNoExistResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResultOfLobbyDigitalWalletAccountIsAccountNoExistResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyBankAccountApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAll(lobbyId: number, language: LanguageCode): Promise<LobbyBankAccountResponse[]> {
        return new Promise<LobbyBankAccountResponse[]>((resolve, reject) => {
            this.getAllWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllWithCallbacks(lobbyId: number, language: LanguageCode, onSuccess?: (result: LobbyBankAccountResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyBankAccount/GetAll?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAll(xhr: any): LobbyBankAccountResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyBankAccountResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyBankAccountResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getByLobbyBankAccountId(lobbyId: number, languageId: LanguageCode, lobbyBankAccountId: number): Promise<LobbyBankAccountResponse> {
        return new Promise<LobbyBankAccountResponse>((resolve, reject) => {
            this.getByLobbyBankAccountIdWithCallbacks(lobbyId, languageId, lobbyBankAccountId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByLobbyBankAccountIdWithCallbacks(lobbyId: number, languageId: LanguageCode, lobbyBankAccountId: number, onSuccess?: (result: LobbyBankAccountResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyBankAccount/GetByLobbyBankAccountId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&"; 
        
        if (lobbyBankAccountId === undefined || lobbyBankAccountId === null)
            throw new Error("The parameter 'lobbyBankAccountId' must be defined and cannot be null.");
        else
            url_ += "lobbyBankAccountId=" + encodeURIComponent("" + lobbyBankAccountId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByLobbyBankAccountIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByLobbyBankAccountIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByLobbyBankAccountIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByLobbyBankAccountId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByLobbyBankAccountId(xhr: any): LobbyBankAccountResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyBankAccountResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyBankAccountResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForAdd(lobbyId: number, language: LanguageCode): Promise<LobbyBankAccountGetForAddResponse> {
        return new Promise<LobbyBankAccountGetForAddResponse>((resolve, reject) => {
            this.getForAddWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForAddWithCallbacks(lobbyId: number, language: LanguageCode, onSuccess?: (result: LobbyBankAccountGetForAddResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyBankAccount/GetForAdd?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForAdd(xhr: any): LobbyBankAccountGetForAddResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyBankAccountGetForAddResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyBankAccountGetForAddResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    create(request: LobbyBankAccountCreateRequest): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.createWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createWithCallbacks(request: LobbyBankAccountCreateRequest, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyBankAccount/Create";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreate(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(lobbyBankAccountId: number, lobbyId: number, language: LanguageCode): Promise<LobbyBankAccountGetForEditResponse> {
        return new Promise<LobbyBankAccountGetForEditResponse>((resolve, reject) => {
            this.getForEditWithCallbacks(lobbyBankAccountId, lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(lobbyBankAccountId: number, lobbyId: number, language: LanguageCode, onSuccess?: (result: LobbyBankAccountGetForEditResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyBankAccount/GetForEdit?";
        if (lobbyBankAccountId === undefined || lobbyBankAccountId === null)
            throw new Error("The parameter 'lobbyBankAccountId' must be defined and cannot be null.");
        else
            url_ += "lobbyBankAccountId=" + encodeURIComponent("" + lobbyBankAccountId) + "&"; 
        
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): LobbyBankAccountGetForEditResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyBankAccountGetForEditResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyBankAccountGetForEditResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: LobbyBankAccountEditRequest): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.editWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: LobbyBankAccountEditRequest, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyBankAccount/Edit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    delete(lobbyBankAccountId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.deleteWithCallbacks(lobbyBankAccountId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private deleteWithCallbacks(lobbyBankAccountId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyBankAccount/Delete?";
        if (lobbyBankAccountId === undefined || lobbyBankAccountId === null)
            throw new Error("The parameter 'lobbyBankAccountId' must be defined and cannot be null.");
        else
            url_ += "lobbyBankAccountId=" + encodeURIComponent("" + lobbyBankAccountId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDeleteWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDelete(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDelete(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    restore(lobbyBankAccountId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.restoreWithCallbacks(lobbyBankAccountId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private restoreWithCallbacks(lobbyBankAccountId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyBankAccount/Restore?";
        if (lobbyBankAccountId === undefined || lobbyBankAccountId === null)
            throw new Error("The parameter 'lobbyBankAccountId' must be defined and cannot be null.");
        else
            url_ += "lobbyBankAccountId=" + encodeURIComponent("" + lobbyBankAccountId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processRestoreWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processRestoreWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processRestoreWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processRestore(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processRestore(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    isAccountNoExist(accountNo: string, lobbyBankId: number): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.isAccountNoExistWithCallbacks(accountNo, lobbyBankId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private isAccountNoExistWithCallbacks(accountNo: string, lobbyBankId: number, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyBankAccount/IsAccountNoExist?";
        if (accountNo === undefined)
            throw new Error("The parameter 'accountNo' must be defined.");
        else
            url_ += "accountNo=" + encodeURIComponent("" + accountNo) + "&"; 
        
        if (lobbyBankId === undefined || lobbyBankId === null)
            throw new Error("The parameter 'lobbyBankId' must be defined and cannot be null.");
        else
            url_ += "lobbyBankId=" + encodeURIComponent("" + lobbyBankId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processIsAccountNoExistWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processIsAccountNoExistWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processIsAccountNoExistWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processIsAccountNoExist(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processIsAccountNoExist(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getThirdPartyApiTransactionRecords(lobbyBankAccountId: number): Promise<StandardResultOfLobbyBankAccountGetThirdPartyApiTransactionRecordsResponse> {
        return new Promise<StandardResultOfLobbyBankAccountGetThirdPartyApiTransactionRecordsResponse>((resolve, reject) => {
            this.getThirdPartyApiTransactionRecordsWithCallbacks(lobbyBankAccountId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getThirdPartyApiTransactionRecordsWithCallbacks(lobbyBankAccountId: number, onSuccess?: (result: StandardResultOfLobbyBankAccountGetThirdPartyApiTransactionRecordsResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyBankAccount/GetThirdPartyApiTransactionRecords?";
        if (lobbyBankAccountId === undefined || lobbyBankAccountId === null)
            throw new Error("The parameter 'lobbyBankAccountId' must be defined and cannot be null.");
        else
            url_ += "lobbyBankAccountId=" + encodeURIComponent("" + lobbyBankAccountId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetThirdPartyApiTransactionRecordsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetThirdPartyApiTransactionRecordsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetThirdPartyApiTransactionRecordsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetThirdPartyApiTransactionRecords(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetThirdPartyApiTransactionRecords(xhr: any): StandardResultOfLobbyBankAccountGetThirdPartyApiTransactionRecordsResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResultOfLobbyBankAccountGetThirdPartyApiTransactionRecordsResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResultOfLobbyBankAccountGetThirdPartyApiTransactionRecordsResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyBOFieldsAccessApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getEnabledByLobbyId(lobbyId: number): Promise<number[]> {
        return new Promise<number[]>((resolve, reject) => {
            this.getEnabledByLobbyIdWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getEnabledByLobbyIdWithCallbacks(lobbyId: number, onSuccess?: (result: number[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyBOFieldsAccess/GetEnabledByLobbyId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetEnabledByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetEnabledByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetEnabledByLobbyIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetEnabledByLobbyId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetEnabledByLobbyId(xhr: any): number[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: number[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class GetENumApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    bOFieldsAccessId(): Promise<Response> {
        return new Promise<Response>((resolve, reject) => {
            this.bOFieldsAccessIdWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private bOFieldsAccessIdWithCallbacks(onSuccess?: (result: Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyBOFieldsAccess/GetENum_BOFieldsAccessId";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processBOFieldsAccessIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processBOFieldsAccessIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processBOFieldsAccessIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processBOFieldsAccessId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processBOFieldsAccessId(xhr: any): Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class BoUserTableColumnHiddenApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    checkColHiddenNameExist(actionType: string, colHiddenName: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.checkColHiddenNameExistWithCallbacks(actionType, colHiddenName, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private checkColHiddenNameExistWithCallbacks(actionType: string, colHiddenName: string, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/BoUserTableColumnHidden/CheckColHiddenNameExist?";
        if (actionType === undefined)
            throw new Error("The parameter 'actionType' must be defined.");
        else
            url_ += "actionType=" + encodeURIComponent("" + actionType) + "&"; 
        
        if (colHiddenName === undefined)
            throw new Error("The parameter 'colHiddenName' must be defined.");
        else
            url_ += "colHiddenName=" + encodeURIComponent("" + colHiddenName) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCheckColHiddenNameExistWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCheckColHiddenNameExistWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCheckColHiddenNameExistWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCheckColHiddenNameExist(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCheckColHiddenNameExist(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getColHiddenNameListByAuthorizeActionType(actionType: string): Promise<BoUserTableColumnHiddenItem[]> {
        return new Promise<BoUserTableColumnHiddenItem[]>((resolve, reject) => {
            this.getColHiddenNameListByAuthorizeActionTypeWithCallbacks(actionType, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getColHiddenNameListByAuthorizeActionTypeWithCallbacks(actionType: string, onSuccess?: (result: BoUserTableColumnHiddenItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/BoUserTableColumnHidden/GetColHiddenNameListByAuthorizeActionType?";
        if (actionType === undefined)
            throw new Error("The parameter 'actionType' must be defined.");
        else
            url_ += "actionType=" + encodeURIComponent("" + actionType) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetColHiddenNameListByAuthorizeActionTypeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetColHiddenNameListByAuthorizeActionTypeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetColHiddenNameListByAuthorizeActionTypeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetColHiddenNameListByAuthorizeActionType(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetColHiddenNameListByAuthorizeActionType(xhr: any): BoUserTableColumnHiddenItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: BoUserTableColumnHiddenItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(BoUserTableColumnHiddenItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    addColHiddenName(actionType: string, colHiddenName: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.addColHiddenNameWithCallbacks(actionType, colHiddenName, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addColHiddenNameWithCallbacks(actionType: string, colHiddenName: string, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/BoUserTableColumnHidden/AddColHiddenName?";
        if (actionType === undefined)
            throw new Error("The parameter 'actionType' must be defined.");
        else
            url_ += "actionType=" + encodeURIComponent("" + actionType) + "&"; 
        
        if (colHiddenName === undefined)
            throw new Error("The parameter 'colHiddenName' must be defined.");
        else
            url_ += "colHiddenName=" + encodeURIComponent("" + colHiddenName) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAddColHiddenNameWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddColHiddenNameWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddColHiddenNameWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAddColHiddenName(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAddColHiddenName(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    delColHiddenName(actionType: string, colHiddenName: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.delColHiddenNameWithCallbacks(actionType, colHiddenName, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private delColHiddenNameWithCallbacks(actionType: string, colHiddenName: string, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/BoUserTableColumnHidden/DelColHiddenName?";
        if (actionType === undefined)
            throw new Error("The parameter 'actionType' must be defined.");
        else
            url_ += "actionType=" + encodeURIComponent("" + actionType) + "&"; 
        
        if (colHiddenName === undefined)
            throw new Error("The parameter 'colHiddenName' must be defined.");
        else
            url_ += "colHiddenName=" + encodeURIComponent("" + colHiddenName) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDelColHiddenNameWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDelColHiddenNameWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDelColHiddenNameWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDelColHiddenName(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDelColHiddenName(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    delAllColHiddenName(actionType: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.delAllColHiddenNameWithCallbacks(actionType, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private delAllColHiddenNameWithCallbacks(actionType: string, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/BoUserTableColumnHidden/DelAllColHiddenName?";
        if (actionType === undefined)
            throw new Error("The parameter 'actionType' must be defined.");
        else
            url_ += "actionType=" + encodeURIComponent("" + actionType) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDelAllColHiddenNameWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDelAllColHiddenNameWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDelAllColHiddenNameWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDelAllColHiddenName(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDelAllColHiddenName(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    addColHiddenNameByList(actionType: string, list: string[]): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.addColHiddenNameByListWithCallbacks(actionType, list, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addColHiddenNameByListWithCallbacks(actionType: string, list: string[], onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/BoUserTableColumnHidden/AddColHiddenNameByList?";
        if (actionType === undefined)
            throw new Error("The parameter 'actionType' must be defined.");
        else
            url_ += "actionType=" + encodeURIComponent("" + actionType) + "&";

        const content_ = JSON.stringify(list);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAddColHiddenNameByListWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddColHiddenNameByListWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddColHiddenNameByListWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAddColHiddenNameByList(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAddColHiddenNameByList(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    updateColHiddenNameList(actionType: string, list: string[]): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.updateColHiddenNameListWithCallbacks(actionType, list, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private updateColHiddenNameListWithCallbacks(actionType: string, list: string[], onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/BoUserTableColumnHidden/UpdateColHiddenNameList?";
        if (actionType === undefined)
            throw new Error("The parameter 'actionType' must be defined.");
        else
            url_ += "actionType=" + encodeURIComponent("" + actionType) + "&";

        const content_ = JSON.stringify(list);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processUpdateColHiddenNameListWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdateColHiddenNameListWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdateColHiddenNameListWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdateColHiddenNameList(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdateColHiddenNameList(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class DashboardApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getIndexStat(lobbyId: number): Promise<DashboardIndexResponse> {
        return new Promise<DashboardIndexResponse>((resolve, reject) => {
            this.getIndexStatWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getIndexStatWithCallbacks(lobbyId: number, onSuccess?: (result: DashboardIndexResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Dashboard/GetIndexStat?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetIndexStatWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetIndexStatWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetIndexStatWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetIndexStat(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetIndexStat(xhr: any): DashboardIndexResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: DashboardIndexResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? DashboardIndexResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getDailyRegistrationByLobbyId(lobbyId: number): Promise<DashboardIndexDailyResponse> {
        return new Promise<DashboardIndexDailyResponse>((resolve, reject) => {
            this.getDailyRegistrationByLobbyIdWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getDailyRegistrationByLobbyIdWithCallbacks(lobbyId: number, onSuccess?: (result: DashboardIndexDailyResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Dashboard/GetDailyRegistrationByLobbyId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetDailyRegistrationByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetDailyRegistrationByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetDailyRegistrationByLobbyIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetDailyRegistrationByLobbyId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetDailyRegistrationByLobbyId(xhr: any): DashboardIndexDailyResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: DashboardIndexDailyResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? DashboardIndexDailyResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    get(request: DashboardIndexGetRequest): Promise<DashboardIndexDailyResponse> {
        return new Promise<DashboardIndexDailyResponse>((resolve, reject) => {
            this.getWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWithCallbacks(request: DashboardIndexGetRequest, onSuccess?: (result: DashboardIndexDailyResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Dashboard/Get";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): DashboardIndexDailyResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: DashboardIndexDailyResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? DashboardIndexDailyResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class HomeApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    index(): Promise<ActionResult> {
        return new Promise<ActionResult>((resolve, reject) => {
            this.indexWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private indexWithCallbacks(onSuccess?: (result: ActionResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Home/Index";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processIndexWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processIndex(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processIndex(xhr: any): ActionResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: ActionResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? ActionResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LanguageApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getPublishByLobbyId(lobbyId: number): Promise<LanguageResponse[]> {
        return new Promise<LanguageResponse[]>((resolve, reject) => {
            this.getPublishByLobbyIdWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getPublishByLobbyIdWithCallbacks(lobbyId: number, onSuccess?: (result: LanguageResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Language/GetPublishByLobbyId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetPublishByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetPublishByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetPublishByLobbyIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetPublishByLobbyId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetPublishByLobbyId(xhr: any): LanguageResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LanguageResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LanguageResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyAdminApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAdminUsers(): Promise<StandardResponseOfListOfAdminUserDao> {
        return new Promise<StandardResponseOfListOfAdminUserDao>((resolve, reject) => {
            this.getAdminUsersWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAdminUsersWithCallbacks(onSuccess?: (result: StandardResponseOfListOfAdminUserDao) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAdmin/GetAdminUsers";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAdminUsersWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAdminUsersWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAdminUsersWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAdminUsers(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAdminUsers(xhr: any): StandardResponseOfListOfAdminUserDao {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfListOfAdminUserDao = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfListOfAdminUserDao.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    createLobbyAdmin(request: LobbyAdminAddRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.createLobbyAdminWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createLobbyAdminWithCallbacks(request: LobbyAdminAddRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAdmin/CreateLobbyAdmin";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateLobbyAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateLobbyAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateLobbyAdminWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreateLobbyAdmin(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreateLobbyAdmin(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(request: GetForEditRequest): Promise<StandardResponseOfLobbyAdminGetForEditResponse> {
        return new Promise<StandardResponseOfLobbyAdminGetForEditResponse>((resolve, reject) => {
            this.getForEditWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(request: GetForEditRequest, onSuccess?: (result: StandardResponseOfLobbyAdminGetForEditResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAdmin/GetForEdit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): StandardResponseOfLobbyAdminGetForEditResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfLobbyAdminGetForEditResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfLobbyAdminGetForEditResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    editLobbyAdmin(request: LobbyAdminEditRequest): Promise<StandardResponseOfLobbyAdminEditResponse> {
        return new Promise<StandardResponseOfLobbyAdminEditResponse>((resolve, reject) => {
            this.editLobbyAdminWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editLobbyAdminWithCallbacks(request: LobbyAdminEditRequest, onSuccess?: (result: StandardResponseOfLobbyAdminEditResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAdmin/EditLobbyAdmin";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditLobbyAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditLobbyAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditLobbyAdminWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEditLobbyAdmin(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEditLobbyAdmin(xhr: any): StandardResponseOfLobbyAdminEditResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfLobbyAdminEditResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfLobbyAdminEditResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getAdminUser(): Promise<AdminUserDao> {
        return new Promise<AdminUserDao>((resolve, reject) => {
            this.getAdminUserWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAdminUserWithCallbacks(onSuccess?: (result: AdminUserDao) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAdmin/GetAdminUser";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAdminUserWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAdminUserWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAdminUserWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAdminUser(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAdminUser(xhr: any): AdminUserDao {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: AdminUserDao = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? AdminUserDao.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    editLobbyAdminBasicInfo(request: LobbyAdminBaicInfoEditRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.editLobbyAdminBasicInfoWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editLobbyAdminBasicInfoWithCallbacks(request: LobbyAdminBaicInfoEditRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAdmin/EditLobbyAdminBasicInfo";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditLobbyAdminBasicInfoWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditLobbyAdminBasicInfoWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditLobbyAdminBasicInfoWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEditLobbyAdminBasicInfo(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEditLobbyAdminBasicInfo(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    delete(userId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.deleteWithCallbacks(userId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private deleteWithCallbacks(userId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAdmin/Delete?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDeleteWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDelete(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDelete(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    resetRandomPassword(request: ResetRandomPasswordRequest): Promise<StandardResponseOfResetRandomPasswordResponse> {
        return new Promise<StandardResponseOfResetRandomPasswordResponse>((resolve, reject) => {
            this.resetRandomPasswordWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private resetRandomPasswordWithCallbacks(request: ResetRandomPasswordRequest, onSuccess?: (result: StandardResponseOfResetRandomPasswordResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAdmin/ResetRandomPassword";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processResetRandomPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processResetRandomPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processResetRandomPasswordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processResetRandomPassword(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processResetRandomPassword(xhr: any): StandardResponseOfResetRandomPasswordResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfResetRandomPasswordResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfResetRandomPasswordResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyAgentApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    lobbyAgentCreate(request: LobbyAgentCreateRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.lobbyAgentCreateWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private lobbyAgentCreateWithCallbacks(request: LobbyAgentCreateRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/LobbyAgentCreate";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processLobbyAgentCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLobbyAgentCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLobbyAgentCreateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLobbyAgentCreate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLobbyAgentCreate(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    lobbyAgentEdit(request: LobbyAgentEditRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.lobbyAgentEditWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private lobbyAgentEditWithCallbacks(request: LobbyAgentEditRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/LobbyAgentEdit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processLobbyAgentEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLobbyAgentEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLobbyAgentEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLobbyAgentEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLobbyAgentEdit(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getPlayerLevelGroup(lobbyId: number): Promise<LobbyPlayerLevelGroup> {
        return new Promise<LobbyPlayerLevelGroup>((resolve, reject) => {
            this.getPlayerLevelGroupWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getPlayerLevelGroupWithCallbacks(lobbyId: number, onSuccess?: (result: LobbyPlayerLevelGroup) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/GetPlayerLevelGroup?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetPlayerLevelGroupWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetPlayerLevelGroupWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetPlayerLevelGroupWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetPlayerLevelGroup(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetPlayerLevelGroup(xhr: any): LobbyPlayerLevelGroup {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyPlayerLevelGroup = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyPlayerLevelGroup.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    lobbyAgentSetEnable(request: LobbyAgentSetEnableRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.lobbyAgentSetEnableWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private lobbyAgentSetEnableWithCallbacks(request: LobbyAgentSetEnableRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/LobbyAgentSetEnable";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processLobbyAgentSetEnableWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLobbyAgentSetEnableWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLobbyAgentSetEnableWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLobbyAgentSetEnable(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLobbyAgentSetEnable(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    lobbyAgentGetById(lobbyAgentId: number): Promise<LobbyAgentItem> {
        return new Promise<LobbyAgentItem>((resolve, reject) => {
            this.lobbyAgentGetByIdWithCallbacks(lobbyAgentId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private lobbyAgentGetByIdWithCallbacks(lobbyAgentId: number, onSuccess?: (result: LobbyAgentItem) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/LobbyAgentGetById?";
        if (lobbyAgentId === undefined || lobbyAgentId === null)
            throw new Error("The parameter 'lobbyAgentId' must be defined and cannot be null.");
        else
            url_ += "lobbyAgentId=" + encodeURIComponent("" + lobbyAgentId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processLobbyAgentGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLobbyAgentGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLobbyAgentGetByIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLobbyAgentGetById(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLobbyAgentGetById(xhr: any): LobbyAgentItem {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyAgentItem = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyAgentItem.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    lobbyAgentGetAll(): Promise<LobbyAgentItem[]> {
        return new Promise<LobbyAgentItem[]>((resolve, reject) => {
            this.lobbyAgentGetAllWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private lobbyAgentGetAllWithCallbacks(onSuccess?: (result: LobbyAgentItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/LobbyAgentGetAll";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processLobbyAgentGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLobbyAgentGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLobbyAgentGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLobbyAgentGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLobbyAgentGetAll(xhr: any): LobbyAgentItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyAgentItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyAgentItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getDownline(): Promise<StandardResponseOfGetDownlineResponse> {
        return new Promise<StandardResponseOfGetDownlineResponse>((resolve, reject) => {
            this.getDownlineWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getDownlineWithCallbacks(onSuccess?: (result: StandardResponseOfGetDownlineResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/GetDownline";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetDownlineWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetDownlineWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetDownlineWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetDownline(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetDownline(xhr: any): StandardResponseOfGetDownlineResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfGetDownlineResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfGetDownlineResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getMaxCommissionRatio(): Promise<StandardResponseOfGetMaxCommissionRatioResponse> {
        return new Promise<StandardResponseOfGetMaxCommissionRatioResponse>((resolve, reject) => {
            this.getMaxCommissionRatioWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getMaxCommissionRatioWithCallbacks(onSuccess?: (result: StandardResponseOfGetMaxCommissionRatioResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/GetMaxCommissionRatio";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetMaxCommissionRatioWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetMaxCommissionRatioWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetMaxCommissionRatioWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetMaxCommissionRatio(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetMaxCommissionRatio(xhr: any): StandardResponseOfGetMaxCommissionRatioResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfGetMaxCommissionRatioResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfGetMaxCommissionRatioResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getDownlineForEdit(request: GetDownlineForEditRequest): Promise<StandardResponseOfGetDownlineForEditResponse> {
        return new Promise<StandardResponseOfGetDownlineForEditResponse>((resolve, reject) => {
            this.getDownlineForEditWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getDownlineForEditWithCallbacks(request: GetDownlineForEditRequest, onSuccess?: (result: StandardResponseOfGetDownlineForEditResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/GetDownlineForEdit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetDownlineForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetDownlineForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetDownlineForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetDownlineForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetDownlineForEdit(xhr: any): StandardResponseOfGetDownlineForEditResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfGetDownlineForEditResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfGetDownlineForEditResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    createDownline(request: CreateDownlineRequest): Promise<StandardResponseOfCreateDownlineResponse> {
        return new Promise<StandardResponseOfCreateDownlineResponse>((resolve, reject) => {
            this.createDownlineWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createDownlineWithCallbacks(request: CreateDownlineRequest, onSuccess?: (result: StandardResponseOfCreateDownlineResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/CreateDownline";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateDownlineWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateDownlineWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateDownlineWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreateDownline(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreateDownline(xhr: any): StandardResponseOfCreateDownlineResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfCreateDownlineResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfCreateDownlineResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    editDownline(request: EditDownlineRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.editDownlineWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editDownlineWithCallbacks(request: EditDownlineRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/EditDownline";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditDownlineWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditDownlineWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditDownlineWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEditDownline(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEditDownline(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getAgentList(lobbyId: number): Promise<LobbyAgentTree> {
        return new Promise<LobbyAgentTree>((resolve, reject) => {
            this.getAgentListWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAgentListWithCallbacks(lobbyId: number, onSuccess?: (result: LobbyAgentTree) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/GetAgentList?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAgentListWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAgentListWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAgentListWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAgentList(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAgentList(xhr: any): LobbyAgentTree {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyAgentTree = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyAgentTree.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    updateAgentParent(request: LobbyAgentUpdateRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.updateAgentParentWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private updateAgentParentWithCallbacks(request: LobbyAgentUpdateRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/UpdateAgentParent";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processUpdateAgentParentWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdateAgentParentWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdateAgentParentWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdateAgentParent(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdateAgentParent(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    lobbyAgentGetChild(lobbyId: number): Promise<LobbyAgentItem[]> {
        return new Promise<LobbyAgentItem[]>((resolve, reject) => {
            this.lobbyAgentGetChildWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private lobbyAgentGetChildWithCallbacks(lobbyId: number, onSuccess?: (result: LobbyAgentItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/LobbyAgentGetChild?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processLobbyAgentGetChildWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLobbyAgentGetChildWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLobbyAgentGetChildWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLobbyAgentGetChild(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLobbyAgentGetChild(xhr: any): LobbyAgentItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyAgentItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyAgentItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getByLobbyAgentIdForIndex(lobbyId: number, lobbyAgentId: number): Promise<LobbyAgentItem> {
        return new Promise<LobbyAgentItem>((resolve, reject) => {
            this.getByLobbyAgentIdForIndexWithCallbacks(lobbyId, lobbyAgentId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByLobbyAgentIdForIndexWithCallbacks(lobbyId: number, lobbyAgentId: number, onSuccess?: (result: LobbyAgentItem) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/GetByLobbyAgentIdForIndex?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (lobbyAgentId === undefined || lobbyAgentId === null)
            throw new Error("The parameter 'lobbyAgentId' must be defined and cannot be null.");
        else
            url_ += "lobbyAgentId=" + encodeURIComponent("" + lobbyAgentId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByLobbyAgentIdForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByLobbyAgentIdForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByLobbyAgentIdForIndexWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByLobbyAgentIdForIndex(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByLobbyAgentIdForIndex(xhr: any): LobbyAgentItem {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyAgentItem = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyAgentItem.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getLobbyAgentPlayerByName(lobbyId: number, username: string): Promise<GetLobbyAgentPlayerByNameResponse> {
        return new Promise<GetLobbyAgentPlayerByNameResponse>((resolve, reject) => {
            this.getLobbyAgentPlayerByNameWithCallbacks(lobbyId, username, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getLobbyAgentPlayerByNameWithCallbacks(lobbyId: number, username: string, onSuccess?: (result: GetLobbyAgentPlayerByNameResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/GetLobbyAgentPlayerByName?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (username === undefined)
            throw new Error("The parameter 'username' must be defined.");
        else
            url_ += "username=" + encodeURIComponent("" + username) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetLobbyAgentPlayerByNameWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetLobbyAgentPlayerByNameWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetLobbyAgentPlayerByNameWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetLobbyAgentPlayerByName(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetLobbyAgentPlayerByName(xhr: any): GetLobbyAgentPlayerByNameResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: GetLobbyAgentPlayerByNameResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetLobbyAgentPlayerByNameResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    lobbyAgentGetAgentId(): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            this.lobbyAgentGetAgentIdWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private lobbyAgentGetAgentIdWithCallbacks(onSuccess?: (result: number) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgent/LobbyAgentGetAgentId";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processLobbyAgentGetAgentIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLobbyAgentGetAgentIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLobbyAgentGetAgentIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLobbyAgentGetAgentId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLobbyAgentGetAgentId(xhr: any): number {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: number = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyAgentReportApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    playerTransactionListByLobbyAgentId(request: PlayerTransactionListByLobbyAgentIdRequest): Promise<PlayerTransactionListAgentItem[]> {
        return new Promise<PlayerTransactionListAgentItem[]>((resolve, reject) => {
            this.playerTransactionListByLobbyAgentIdWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerTransactionListByLobbyAgentIdWithCallbacks(request: PlayerTransactionListByLobbyAgentIdRequest, onSuccess?: (result: PlayerTransactionListAgentItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgentReport/PlayerTransactionListByLobbyAgentId";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerTransactionListByLobbyAgentIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerTransactionListByLobbyAgentIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerTransactionListByLobbyAgentIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerTransactionListByLobbyAgentId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerTransactionListByLobbyAgentId(xhr: any): PlayerTransactionListAgentItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerTransactionListAgentItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlayerTransactionListAgentItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerPromotionListByLobbyAgentId(request: PlayerPromotionListByLobbyAgentIdRequest): Promise<PlayerPromotionListAgentItem[]> {
        return new Promise<PlayerPromotionListAgentItem[]>((resolve, reject) => {
            this.playerPromotionListByLobbyAgentIdWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerPromotionListByLobbyAgentIdWithCallbacks(request: PlayerPromotionListByLobbyAgentIdRequest, onSuccess?: (result: PlayerPromotionListAgentItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgentReport/PlayerPromotionListByLobbyAgentId";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerPromotionListByLobbyAgentIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerPromotionListByLobbyAgentIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerPromotionListByLobbyAgentIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerPromotionListByLobbyAgentId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerPromotionListByLobbyAgentId(xhr: any): PlayerPromotionListAgentItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerPromotionListAgentItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlayerPromotionListAgentItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerDWRecordsByLobbyAgentId(request: PlayerDWRecordsByLobbyAgentIdRequest): Promise<PlayerDWRecordsAgentItem[]> {
        return new Promise<PlayerDWRecordsAgentItem[]>((resolve, reject) => {
            this.playerDWRecordsByLobbyAgentIdWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerDWRecordsByLobbyAgentIdWithCallbacks(request: PlayerDWRecordsByLobbyAgentIdRequest, onSuccess?: (result: PlayerDWRecordsAgentItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgentReport/PlayerDWRecordsByLobbyAgentId";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerDWRecordsByLobbyAgentIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerDWRecordsByLobbyAgentIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerDWRecordsByLobbyAgentIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerDWRecordsByLobbyAgentId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerDWRecordsByLobbyAgentId(xhr: any): PlayerDWRecordsAgentItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerDWRecordsAgentItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlayerDWRecordsAgentItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerRegisterListByLobbyAgentId(request: PlayerRegisterListByLobbyAgentIdRequest): Promise<PlayerRegisterListAgentItem[]> {
        return new Promise<PlayerRegisterListAgentItem[]>((resolve, reject) => {
            this.playerRegisterListByLobbyAgentIdWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerRegisterListByLobbyAgentIdWithCallbacks(request: PlayerRegisterListByLobbyAgentIdRequest, onSuccess?: (result: PlayerRegisterListAgentItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgentReport/PlayerRegisterListByLobbyAgentId";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerRegisterListByLobbyAgentIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerRegisterListByLobbyAgentIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerRegisterListByLobbyAgentIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerRegisterListByLobbyAgentId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerRegisterListByLobbyAgentId(xhr: any): PlayerRegisterListAgentItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerRegisterListAgentItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlayerRegisterListAgentItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerSummaryGetAllAgent(request: PlayerSummaryGetAllAgentRequest): Promise<PlayerSummaryAgentReponse> {
        return new Promise<PlayerSummaryAgentReponse>((resolve, reject) => {
            this.playerSummaryGetAllAgentWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerSummaryGetAllAgentWithCallbacks(request: PlayerSummaryGetAllAgentRequest, onSuccess?: (result: PlayerSummaryAgentReponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgentReport/PlayerSummaryGetAllAgent";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerSummaryGetAllAgentWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerSummaryGetAllAgentWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerSummaryGetAllAgentWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerSummaryGetAllAgent(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerSummaryGetAllAgent(xhr: any): PlayerSummaryAgentReponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerSummaryAgentReponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PlayerSummaryAgentReponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    friendUnionSummary(request: FriendUnionSummaryRequest): Promise<FU_SummaryResponse> {
        return new Promise<FU_SummaryResponse>((resolve, reject) => {
            this.friendUnionSummaryWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private friendUnionSummaryWithCallbacks(request: FriendUnionSummaryRequest, onSuccess?: (result: FU_SummaryResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgentReport/FriendUnionSummary";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processFriendUnionSummaryWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processFriendUnionSummaryWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processFriendUnionSummaryWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processFriendUnionSummary(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processFriendUnionSummary(xhr: any): FU_SummaryResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: FU_SummaryResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? FU_SummaryResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    payFriendUnionCommission(request: FU_PayCommissionRequest): Promise<FU_PayCommissionResponse> {
        return new Promise<FU_PayCommissionResponse>((resolve, reject) => {
            this.payFriendUnionCommissionWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private payFriendUnionCommissionWithCallbacks(request: FU_PayCommissionRequest, onSuccess?: (result: FU_PayCommissionResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgentReport/PayFriendUnionCommission";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPayFriendUnionCommissionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPayFriendUnionCommissionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPayFriendUnionCommissionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPayFriendUnionCommission(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPayFriendUnionCommission(xhr: any): FU_PayCommissionResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: FU_PayCommissionResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? FU_PayCommissionResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerTransactionPlayerFriendLevelDetail(request: PlayerTransactionDetailByLobbyAgentIdRequest): Promise<PlayerTransactionAgentPlayerLevelItem[]> {
        return new Promise<PlayerTransactionAgentPlayerLevelItem[]>((resolve, reject) => {
            this.playerTransactionPlayerFriendLevelDetailWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerTransactionPlayerFriendLevelDetailWithCallbacks(request: PlayerTransactionDetailByLobbyAgentIdRequest, onSuccess?: (result: PlayerTransactionAgentPlayerLevelItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAgentReport/PlayerTransactionPlayerFriendLevelDetail";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerTransactionPlayerFriendLevelDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerTransactionPlayerFriendLevelDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerTransactionPlayerFriendLevelDetailWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerTransactionPlayerFriendLevelDetail(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerTransactionPlayerFriendLevelDetail(xhr: any): PlayerTransactionAgentPlayerLevelItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerTransactionAgentPlayerLevelItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlayerTransactionAgentPlayerLevelItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyAuthorizeActionApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getPermissions(lobbyRoleId: number, lobbyId: number, language: LanguageCode): Promise<LobbyAuthorizeActionDao[]> {
        return new Promise<LobbyAuthorizeActionDao[]>((resolve, reject) => {
            this.getPermissionsWithCallbacks(lobbyRoleId, lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getPermissionsWithCallbacks(lobbyRoleId: number, lobbyId: number, language: LanguageCode, onSuccess?: (result: LobbyAuthorizeActionDao[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAuthorizeAction/GetPermissions?";
        if (lobbyRoleId === undefined || lobbyRoleId === null)
            throw new Error("The parameter 'lobbyRoleId' must be defined and cannot be null.");
        else
            url_ += "lobbyRoleId=" + encodeURIComponent("" + lobbyRoleId) + "&"; 
        
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetPermissionsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetPermissionsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetPermissionsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetPermissions(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetPermissions(xhr: any): LobbyAuthorizeActionDao[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyAuthorizeActionDao[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyAuthorizeActionDao.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getPermissionsByLobbyId(lobbyId: number, languageId: LanguageCode): Promise<LobbyAuthorizeActionDao[]> {
        return new Promise<LobbyAuthorizeActionDao[]>((resolve, reject) => {
            this.getPermissionsByLobbyIdWithCallbacks(lobbyId, languageId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getPermissionsByLobbyIdWithCallbacks(lobbyId: number, languageId: LanguageCode, onSuccess?: (result: LobbyAuthorizeActionDao[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAuthorizeAction/GetPermissionsByLobbyId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetPermissionsByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetPermissionsByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetPermissionsByLobbyIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetPermissionsByLobbyId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetPermissionsByLobbyId(xhr: any): LobbyAuthorizeActionDao[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyAuthorizeActionDao[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyAuthorizeActionDao.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    editPermissions(request: PermissionsRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.editPermissionsWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editPermissionsWithCallbacks(request: PermissionsRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAuthorizeAction/EditPermissions";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditPermissionsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditPermissionsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditPermissionsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEditPermissions(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEditPermissions(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    updatePermissions(request: PermissionUpdateRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.updatePermissionsWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private updatePermissionsWithCallbacks(request: PermissionUpdateRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAuthorizeAction/UpdatePermissions";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processUpdatePermissionsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdatePermissionsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdatePermissionsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdatePermissions(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdatePermissions(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getPermissionForMenu(lobbyId: number): Promise<SectionMenus[]> {
        return new Promise<SectionMenus[]>((resolve, reject) => {
            this.getPermissionForMenuWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getPermissionForMenuWithCallbacks(lobbyId: number, onSuccess?: (result: SectionMenus[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAuthorizeAction/GetPermissionForMenu?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetPermissionForMenuWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetPermissionForMenuWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetPermissionForMenuWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetPermissionForMenu(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetPermissionForMenu(xhr: any): SectionMenus[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: SectionMenus[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SectionMenus.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getApplicationNumCount(lobbyId: number): Promise<GetApplicationCountResponse> {
        return new Promise<GetApplicationCountResponse>((resolve, reject) => {
            this.getApplicationNumCountWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getApplicationNumCountWithCallbacks(lobbyId: number, onSuccess?: (result: GetApplicationCountResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyAuthorizeAction/GetApplicationNumCount?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetApplicationNumCountWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetApplicationNumCountWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetApplicationNumCountWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetApplicationNumCount(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetApplicationNumCount(xhr: any): GetApplicationCountResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: GetApplicationCountResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetApplicationCountResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyBankApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAll(lobbyId: number, language: LanguageCode): Promise<LobbyBankResponse[]> {
        return new Promise<LobbyBankResponse[]>((resolve, reject) => {
            this.getAllWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllWithCallbacks(lobbyId: number, language: LanguageCode, onSuccess?: (result: LobbyBankResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyBank/GetAll?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAll(xhr: any): LobbyBankResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyBankResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyBankResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    setPublish(request: LobbyBankSetPublishRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.setPublishWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private setPublishWithCallbacks(request: LobbyBankSetPublishRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyBank/SetPublish";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSetPublishWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetPublishWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSetPublishWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetPublish(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetPublish(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getPreloadData(request: L_GetPreloadData_Request): Promise<LobbyPreloadResponse> {
        return new Promise<LobbyPreloadResponse>((resolve, reject) => {
            this.getPreloadDataWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getPreloadDataWithCallbacks(request: L_GetPreloadData_Request, onSuccess?: (result: LobbyPreloadResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Lobby/GetPreloadData";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetPreloadDataWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetPreloadDataWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetPreloadDataWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetPreloadData(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetPreloadData(xhr: any): LobbyPreloadResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyPreloadResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyPreloadResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyDepositMethodApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAll(lobbyId: number, language: LanguageCode): Promise<LobbyDepositMethodResponse[]> {
        return new Promise<LobbyDepositMethodResponse[]>((resolve, reject) => {
            this.getAllWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllWithCallbacks(lobbyId: number, language: LanguageCode, onSuccess?: (result: LobbyDepositMethodResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyDepositMethod/GetAll?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAll(xhr: any): LobbyDepositMethodResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyDepositMethodResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyDepositMethodResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getById(lobbyDepositMethodId: number, language: LanguageCode): Promise<LobbyDepositMethodResponse> {
        return new Promise<LobbyDepositMethodResponse>((resolve, reject) => {
            this.getByIdWithCallbacks(lobbyDepositMethodId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByIdWithCallbacks(lobbyDepositMethodId: number, language: LanguageCode, onSuccess?: (result: LobbyDepositMethodResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyDepositMethod/GetById?";
        if (lobbyDepositMethodId === undefined || lobbyDepositMethodId === null)
            throw new Error("The parameter 'lobbyDepositMethodId' must be defined and cannot be null.");
        else
            url_ += "lobbyDepositMethodId=" + encodeURIComponent("" + lobbyDepositMethodId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetById(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetById(xhr: any): LobbyDepositMethodResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyDepositMethodResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyDepositMethodResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    setPublish(request: LobbyDepositMethodSetPublishRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.setPublishWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private setPublishWithCallbacks(request: LobbyDepositMethodSetPublishRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyDepositMethod/SetPublish";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSetPublishWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetPublishWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSetPublishWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetPublish(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetPublish(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getNameById(lobbyDepositMethodId: number, language: LanguageCode): Promise<LobbyDepositMethodNameResponse> {
        return new Promise<LobbyDepositMethodNameResponse>((resolve, reject) => {
            this.getNameByIdWithCallbacks(lobbyDepositMethodId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getNameByIdWithCallbacks(lobbyDepositMethodId: number, language: LanguageCode, onSuccess?: (result: LobbyDepositMethodNameResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyDepositMethod/GetNameById?";
        if (lobbyDepositMethodId === undefined || lobbyDepositMethodId === null)
            throw new Error("The parameter 'lobbyDepositMethodId' must be defined and cannot be null.");
        else
            url_ += "lobbyDepositMethodId=" + encodeURIComponent("" + lobbyDepositMethodId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetNameByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetNameByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetNameByIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetNameById(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetNameById(xhr: any): LobbyDepositMethodNameResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyDepositMethodNameResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyDepositMethodNameResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    updateLobbyDepositMethodName(request: LobbyDepositMethodNameUpdateRequest[]): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.updateLobbyDepositMethodNameWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private updateLobbyDepositMethodNameWithCallbacks(request: LobbyDepositMethodNameUpdateRequest[], onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyDepositMethod/UpdateLobbyDepositMethodName";

        let contentData_: any = [];
        if (request) {
            for (let item of request)
                contentData_.push(item.toJS());
        }
        const content_ = JSON.stringify(request ? contentData_ : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processUpdateLobbyDepositMethodNameWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdateLobbyDepositMethodNameWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdateLobbyDepositMethodNameWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdateLobbyDepositMethodName(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdateLobbyDepositMethodName(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyPlayerDisableAutoRebateApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getForIndex(request: LPDAR_GetForIndex_Request): Promise<LPDAR_GetForIndex_Response> {
        return new Promise<LPDAR_GetForIndex_Response>((resolve, reject) => {
            this.getForIndexWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForIndexWithCallbacks(request: LPDAR_GetForIndex_Request, onSuccess?: (result: LPDAR_GetForIndex_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerDisableAutoRebate/GetForIndex";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForIndexWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForIndex(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForIndex(xhr: any): LPDAR_GetForIndex_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LPDAR_GetForIndex_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LPDAR_GetForIndex_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForAdd(request: LPDAR_GetForAdd_Request): Promise<LPDAR_GetForAdd_Response> {
        return new Promise<LPDAR_GetForAdd_Response>((resolve, reject) => {
            this.getForAddWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForAddWithCallbacks(request: LPDAR_GetForAdd_Request, onSuccess?: (result: LPDAR_GetForAdd_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerDisableAutoRebate/GetForAdd";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForAdd(xhr: any): LPDAR_GetForAdd_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LPDAR_GetForAdd_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LPDAR_GetForAdd_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    add(request: LPDAR_Add_Request): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.addWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addWithCallbacks(request: LPDAR_Add_Request, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerDisableAutoRebate/Add";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAdd(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(request: LPDAR_GetForEdit_Request): Promise<LPDAR_GetForEdit_Response> {
        return new Promise<LPDAR_GetForEdit_Response>((resolve, reject) => {
            this.getForEditWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(request: LPDAR_GetForEdit_Request, onSuccess?: (result: LPDAR_GetForEdit_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerDisableAutoRebate/GetForEdit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): LPDAR_GetForEdit_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LPDAR_GetForEdit_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LPDAR_GetForEdit_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: LPDAR_Edit_Request): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.editWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: LPDAR_Edit_Request, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerDisableAutoRebate/Edit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyReferenceGroupApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    get(): Promise<StandardResponseOfIEnumerableOfLobbyReferenceGroupGetResponse> {
        return new Promise<StandardResponseOfIEnumerableOfLobbyReferenceGroupGetResponse>((resolve, reject) => {
            this.getWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWithCallbacks(onSuccess?: (result: StandardResponseOfIEnumerableOfLobbyReferenceGroupGetResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyReferenceGroup/Get";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): StandardResponseOfIEnumerableOfLobbyReferenceGroupGetResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfIEnumerableOfLobbyReferenceGroupGetResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfIEnumerableOfLobbyReferenceGroupGetResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getDetails(): Promise<StandardResponseOfIEnumerableOfLobbyReferenceGroupGetDetailsResponse> {
        return new Promise<StandardResponseOfIEnumerableOfLobbyReferenceGroupGetDetailsResponse>((resolve, reject) => {
            this.getDetailsWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getDetailsWithCallbacks(onSuccess?: (result: StandardResponseOfIEnumerableOfLobbyReferenceGroupGetDetailsResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyReferenceGroup/GetDetails";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetDetailsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetDetailsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetDetailsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetDetails(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetDetails(xhr: any): StandardResponseOfIEnumerableOfLobbyReferenceGroupGetDetailsResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfIEnumerableOfLobbyReferenceGroupGetDetailsResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfIEnumerableOfLobbyReferenceGroupGetDetailsResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    create(fileParameterForGenerateApi: FileParameter, name: string, remark: string): Promise<StandardResponseOfLobbyReferenceGroupCreateResponse> {
        return new Promise<StandardResponseOfLobbyReferenceGroupCreateResponse>((resolve, reject) => {
            this.createWithCallbacks(fileParameterForGenerateApi, name, remark, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createWithCallbacks(fileParameterForGenerateApi: FileParameter, name: string, remark: string, onSuccess?: (result: StandardResponseOfLobbyReferenceGroupCreateResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyReferenceGroup/Create?";
        if (name === undefined)
            throw new Error("The parameter 'name' must be defined.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        
        if (remark === undefined)
            throw new Error("The parameter 'remark' must be defined.");
        else
            url_ += "remark=" + encodeURIComponent("" + remark) + "&";

        const content_ = new FormData();
        if (fileParameterForGenerateApi !== null)
            content_.append("fileParameterForGenerateApi", fileParameterForGenerateApi.data, fileParameterForGenerateApi.fileName ? fileParameterForGenerateApi.fileName : "fileParameterForGenerateApi");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            processData: false,
            contentType: false,
            headers: {
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken'), 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId()
 
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreate(xhr: any): StandardResponseOfLobbyReferenceGroupCreateResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfLobbyReferenceGroupCreateResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfLobbyReferenceGroupCreateResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    update(fileParameterForGenerateApi: FileParameter, lobbyReferenceGroupId: number, name: string, remark: string): Promise<StandardResponseOfLobbyReferenceGroupUpdateResponse> {
        return new Promise<StandardResponseOfLobbyReferenceGroupUpdateResponse>((resolve, reject) => {
            this.updateWithCallbacks(fileParameterForGenerateApi, lobbyReferenceGroupId, name, remark, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private updateWithCallbacks(fileParameterForGenerateApi: FileParameter, lobbyReferenceGroupId: number, name: string, remark: string, onSuccess?: (result: StandardResponseOfLobbyReferenceGroupUpdateResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyReferenceGroup/Update?";
        if (lobbyReferenceGroupId === undefined || lobbyReferenceGroupId === null)
            throw new Error("The parameter 'lobbyReferenceGroupId' must be defined and cannot be null.");
        else
            url_ += "lobbyReferenceGroupId=" + encodeURIComponent("" + lobbyReferenceGroupId) + "&"; 
        
        if (name === undefined)
            throw new Error("The parameter 'name' must be defined.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        
        if (remark === undefined)
            throw new Error("The parameter 'remark' must be defined.");
        else
            url_ += "remark=" + encodeURIComponent("" + remark) + "&";

        const content_ = new FormData();
        if (fileParameterForGenerateApi !== null)
            content_.append("fileParameterForGenerateApi", fileParameterForGenerateApi.data, fileParameterForGenerateApi.fileName ? fileParameterForGenerateApi.fileName : "fileParameterForGenerateApi");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            processData: false,
            contentType: false,
            headers: {
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken'), 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId()
 
            }
        }).done((data, textStatus, xhr) => {
            this.processUpdateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdate(xhr: any): StandardResponseOfLobbyReferenceGroupUpdateResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfLobbyReferenceGroupUpdateResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfLobbyReferenceGroupUpdateResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LuckyDrawApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    createRewardGroup(fileParameterForGenerateApi: FileParameter, groupName: string): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.createRewardGroupWithCallbacks(fileParameterForGenerateApi, groupName, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createRewardGroupWithCallbacks(fileParameterForGenerateApi: FileParameter, groupName: string, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LuckyDraw/CreateRewardGroup?";
        if (groupName === undefined)
            throw new Error("The parameter 'groupName' must be defined.");
        else
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";

        const content_ = new FormData();
        if (fileParameterForGenerateApi !== null)
            content_.append("fileParameterForGenerateApi", fileParameterForGenerateApi.data, fileParameterForGenerateApi.fileName ? fileParameterForGenerateApi.fileName : "fileParameterForGenerateApi");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            processData: false,
            contentType: false,
            headers: {
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken'), 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId()
 
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateRewardGroupWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateRewardGroupWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateRewardGroupWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreateRewardGroup(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreateRewardGroup(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getAllLuckyDrawGroup(): Promise<StandardResponseOfGetAllLuckyDrawGroupResponse> {
        return new Promise<StandardResponseOfGetAllLuckyDrawGroupResponse>((resolve, reject) => {
            this.getAllLuckyDrawGroupWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllLuckyDrawGroupWithCallbacks(onSuccess?: (result: StandardResponseOfGetAllLuckyDrawGroupResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LuckyDraw/GetAllLuckyDrawGroup";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllLuckyDrawGroupWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllLuckyDrawGroupWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllLuckyDrawGroupWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAllLuckyDrawGroup(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAllLuckyDrawGroup(xhr: any): StandardResponseOfGetAllLuckyDrawGroupResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfGetAllLuckyDrawGroupResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfGetAllLuckyDrawGroupResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getLuckyDrawGroup(request: GetLuckyDrawGroupRequest): Promise<StandardResponseOfGetLuckyDrawGroupResponse> {
        return new Promise<StandardResponseOfGetLuckyDrawGroupResponse>((resolve, reject) => {
            this.getLuckyDrawGroupWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getLuckyDrawGroupWithCallbacks(request: GetLuckyDrawGroupRequest, onSuccess?: (result: StandardResponseOfGetLuckyDrawGroupResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LuckyDraw/GetLuckyDrawGroup";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetLuckyDrawGroupWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetLuckyDrawGroupWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetLuckyDrawGroupWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetLuckyDrawGroup(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetLuckyDrawGroup(xhr: any): StandardResponseOfGetLuckyDrawGroupResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfGetLuckyDrawGroupResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfGetLuckyDrawGroupResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    createRewardRecord(fileParameterForGenerateApi: FileParameter, name: string, remark: string, rewardGroupId: number): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.createRewardRecordWithCallbacks(fileParameterForGenerateApi, name, remark, rewardGroupId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createRewardRecordWithCallbacks(fileParameterForGenerateApi: FileParameter, name: string, remark: string, rewardGroupId: number, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LuckyDraw/CreateRewardRecord?";
        if (name === undefined)
            throw new Error("The parameter 'name' must be defined.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        
        if (remark === undefined)
            throw new Error("The parameter 'remark' must be defined.");
        else
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        
        if (rewardGroupId === undefined || rewardGroupId === null)
            throw new Error("The parameter 'rewardGroupId' must be defined and cannot be null.");
        else
            url_ += "rewardGroupId=" + encodeURIComponent("" + rewardGroupId) + "&";

        const content_ = new FormData();
        if (fileParameterForGenerateApi !== null)
            content_.append("fileParameterForGenerateApi", fileParameterForGenerateApi.data, fileParameterForGenerateApi.fileName ? fileParameterForGenerateApi.fileName : "fileParameterForGenerateApi");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            processData: false,
            contentType: false,
            headers: {
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken'), 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId()
 
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateRewardRecordWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateRewardRecordWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateRewardRecordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreateRewardRecord(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreateRewardRecord(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    updateLuckyDrawRecord(request: UpdateLuckyDrawRecordRequest): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.updateLuckyDrawRecordWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private updateLuckyDrawRecordWithCallbacks(request: UpdateLuckyDrawRecordRequest, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LuckyDraw/UpdateLuckyDrawRecord";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processUpdateLuckyDrawRecordWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdateLuckyDrawRecordWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdateLuckyDrawRecordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdateLuckyDrawRecord(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdateLuckyDrawRecord(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    updateRewardRecord(fileParameterForUpdateApi: FileParameter, luckyDrawRecordId: number): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.updateRewardRecordWithCallbacks(fileParameterForUpdateApi, luckyDrawRecordId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private updateRewardRecordWithCallbacks(fileParameterForUpdateApi: FileParameter, luckyDrawRecordId: number, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LuckyDraw/UpdateRewardRecord?";
        if (luckyDrawRecordId === undefined || luckyDrawRecordId === null)
            throw new Error("The parameter 'luckyDrawRecordId' must be defined and cannot be null.");
        else
            url_ += "luckyDrawRecordId=" + encodeURIComponent("" + luckyDrawRecordId) + "&";

        const content_ = new FormData();
        if (fileParameterForUpdateApi !== null)
            content_.append("fileParameterForUpdateApi", fileParameterForUpdateApi.data, fileParameterForUpdateApi.fileName ? fileParameterForUpdateApi.fileName : "fileParameterForUpdateApi");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            processData: false,
            contentType: false,
            headers: {
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken'), 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId()
 
            }
        }).done((data, textStatus, xhr) => {
            this.processUpdateRewardRecordWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdateRewardRecordWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdateRewardRecordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdateRewardRecord(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdateRewardRecord(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    distribute(request: LuckyDrawRecordDistributeRequest): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.distributeWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private distributeWithCallbacks(request: LuckyDrawRecordDistributeRequest, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LuckyDraw/Distribute";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDistributeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDistributeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDistributeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDistribute(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDistribute(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getLuckyDrawRecord(request: GetLuckyDrawRecordRequest): Promise<StandardResponseOfGetLuckyDrawRecordResponse> {
        return new Promise<StandardResponseOfGetLuckyDrawRecordResponse>((resolve, reject) => {
            this.getLuckyDrawRecordWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getLuckyDrawRecordWithCallbacks(request: GetLuckyDrawRecordRequest, onSuccess?: (result: StandardResponseOfGetLuckyDrawRecordResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LuckyDraw/GetLuckyDrawRecord";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetLuckyDrawRecordWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetLuckyDrawRecordWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetLuckyDrawRecordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetLuckyDrawRecord(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetLuckyDrawRecord(xhr: any): StandardResponseOfGetLuckyDrawRecordResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfGetLuckyDrawRecordResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfGetLuckyDrawRecordResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getLuckyDrawRecordDetail(request: GetLuckyDrawRecordDetailRequest): Promise<StandardResponseOfGetLuckyDrawRecordDetailResponse> {
        return new Promise<StandardResponseOfGetLuckyDrawRecordDetailResponse>((resolve, reject) => {
            this.getLuckyDrawRecordDetailWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getLuckyDrawRecordDetailWithCallbacks(request: GetLuckyDrawRecordDetailRequest, onSuccess?: (result: StandardResponseOfGetLuckyDrawRecordDetailResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LuckyDraw/GetLuckyDrawRecordDetail";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetLuckyDrawRecordDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetLuckyDrawRecordDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetLuckyDrawRecordDetailWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetLuckyDrawRecordDetail(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetLuckyDrawRecordDetail(xhr: any): StandardResponseOfGetLuckyDrawRecordDetailResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfGetLuckyDrawRecordDetailResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfGetLuckyDrawRecordDetailResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PaymentCryptoFundOutApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getForIndex(request: PaymentCryptoFundOutGetForIndexRequest): Promise<PaymentCryptoFundOutGetForIndexResponse> {
        return new Promise<PaymentCryptoFundOutGetForIndexResponse>((resolve, reject) => {
            this.getForIndexWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForIndexWithCallbacks(request: PaymentCryptoFundOutGetForIndexRequest, onSuccess?: (result: PaymentCryptoFundOutGetForIndexResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentCryptoFundOut/GetForIndex";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForIndexWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForIndex(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForIndex(xhr: any): PaymentCryptoFundOutGetForIndexResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PaymentCryptoFundOutGetForIndexResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentCryptoFundOutGetForIndexResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    isExistingPayment(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.isExistingPaymentWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private isExistingPaymentWithCallbacks(onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentCryptoFundOut/IsExistingPayment";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processIsExistingPaymentWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processIsExistingPaymentWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processIsExistingPaymentWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processIsExistingPayment(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processIsExistingPayment(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getEnablePayments(): Promise<PaymentCryptoFundOutPaymentItem[]> {
        return new Promise<PaymentCryptoFundOutPaymentItem[]>((resolve, reject) => {
            this.getEnablePaymentsWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getEnablePaymentsWithCallbacks(onSuccess?: (result: PaymentCryptoFundOutPaymentItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentCryptoFundOut/GetEnablePayments";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetEnablePaymentsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetEnablePaymentsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetEnablePaymentsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetEnablePayments(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetEnablePayments(xhr: any): PaymentCryptoFundOutPaymentItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PaymentCryptoFundOutPaymentItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PaymentCryptoFundOutPaymentItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getBalance(paymentPlatformId: PaymentGatewayPlatformId, currencyId: CurrencyId): Promise<PlatformCryptoFundOutAccounts> {
        return new Promise<PlatformCryptoFundOutAccounts>((resolve, reject) => {
            this.getBalanceWithCallbacks(paymentPlatformId, currencyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getBalanceWithCallbacks(paymentPlatformId: PaymentGatewayPlatformId, currencyId: CurrencyId, onSuccess?: (result: PlatformCryptoFundOutAccounts) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentCryptoFundOut/GetBalance?";
        if (paymentPlatformId === undefined || paymentPlatformId === null)
            throw new Error("The parameter 'paymentPlatformId' must be defined and cannot be null.");
        else
            url_ += "paymentPlatformId=" + encodeURIComponent("" + paymentPlatformId) + "&"; 
        
        if (currencyId === undefined || currencyId === null)
            throw new Error("The parameter 'currencyId' must be defined and cannot be null.");
        else
            url_ += "currencyId=" + encodeURIComponent("" + currencyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetBalanceWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetBalanceWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetBalanceWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetBalance(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetBalance(xhr: any): PlatformCryptoFundOutAccounts {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlatformCryptoFundOutAccounts = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PlatformCryptoFundOutAccounts.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    cryptoFundOut(request: PaymentCryptoFundOutApplyRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.cryptoFundOutWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private cryptoFundOutWithCallbacks(request: PaymentCryptoFundOutApplyRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentCryptoFundOut/CryptoFundOut";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCryptoFundOutWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCryptoFundOutWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCryptoFundOutWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCryptoFundOut(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCryptoFundOut(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    inquiry(request: PaymentCryptoFundOutInquiryRequest): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.inquiryWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private inquiryWithCallbacks(request: PaymentCryptoFundOutInquiryRequest, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentCryptoFundOut/Inquiry";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processInquiryWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processInquiryWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processInquiryWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processInquiry(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processInquiry(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    cancel(request: PaymentCryptoFundOutCancelRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.cancelWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private cancelWithCallbacks(request: PaymentCryptoFundOutCancelRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentCryptoFundOut/Cancel";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCancelWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCancelWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCancelWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCancel(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCancel(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyTransferRateApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAll(): Promise<StandardResponseOfLobbyTransferRateGetAllResponse> {
        return new Promise<StandardResponseOfLobbyTransferRateGetAllResponse>((resolve, reject) => {
            this.getAllWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllWithCallbacks(onSuccess?: (result: StandardResponseOfLobbyTransferRateGetAllResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyTransferRate/GetAll";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAll(xhr: any): StandardResponseOfLobbyTransferRateGetAllResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfLobbyTransferRateGetAllResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfLobbyTransferRateGetAllResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    get(request: LobbyTransferRateGetRequest): Promise<StandardResponseOfLobbyTransferRateGetResponse> {
        return new Promise<StandardResponseOfLobbyTransferRateGetResponse>((resolve, reject) => {
            this.getWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWithCallbacks(request: LobbyTransferRateGetRequest, onSuccess?: (result: StandardResponseOfLobbyTransferRateGetResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyTransferRate/Get";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): StandardResponseOfLobbyTransferRateGetResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfLobbyTransferRateGetResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfLobbyTransferRateGetResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: LobbyTransferRateEditRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.editWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: LobbyTransferRateEditRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyTransferRate/Edit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PlaformLogApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAlert(): Promise<StandardResponseOfListOfPlaformLogGetAlertResponse> {
        return new Promise<StandardResponseOfListOfPlaformLogGetAlertResponse>((resolve, reject) => {
            this.getAlertWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAlertWithCallbacks(onSuccess?: (result: StandardResponseOfListOfPlaformLogGetAlertResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlaformLog/GetAlert";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAlertWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAlertWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAlertWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAlert(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAlert(xhr: any): StandardResponseOfListOfPlaformLogGetAlertResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfListOfPlaformLogGetAlertResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfListOfPlaformLogGetAlertResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    get(request: PlaformLogGetRequest): Promise<StandardResponseOfPlaformLogGetResponse> {
        return new Promise<StandardResponseOfPlaformLogGetResponse>((resolve, reject) => {
            this.getWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWithCallbacks(request: PlaformLogGetRequest, onSuccess?: (result: StandardResponseOfPlaformLogGetResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlaformLog/Get";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): StandardResponseOfPlaformLogGetResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfPlaformLogGetResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfPlaformLogGetResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyGiftPointSettingApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAll(): Promise<StandardResponseOfLGPS_GetAll_Response> {
        return new Promise<StandardResponseOfLGPS_GetAll_Response>((resolve, reject) => {
            this.getAllWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllWithCallbacks(onSuccess?: (result: StandardResponseOfLGPS_GetAll_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyGiftPointSetting/GetAll";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAll(xhr: any): StandardResponseOfLGPS_GetAll_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfLGPS_GetAll_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfLGPS_GetAll_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForAdd(request: LGPS_GetForAdd_Request): Promise<StandardResponseOfLGPS_GetForAdd_Response> {
        return new Promise<StandardResponseOfLGPS_GetForAdd_Response>((resolve, reject) => {
            this.getForAddWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForAddWithCallbacks(request: LGPS_GetForAdd_Request, onSuccess?: (result: StandardResponseOfLGPS_GetForAdd_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyGiftPointSetting/GetForAdd";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForAdd(xhr: any): StandardResponseOfLGPS_GetForAdd_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfLGPS_GetForAdd_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfLGPS_GetForAdd_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(request: LGPS_GetForEdit_Request): Promise<StandardResponseOfLGPS_GetForEdit_Response> {
        return new Promise<StandardResponseOfLGPS_GetForEdit_Response>((resolve, reject) => {
            this.getForEditWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(request: LGPS_GetForEdit_Request, onSuccess?: (result: StandardResponseOfLGPS_GetForEdit_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyGiftPointSetting/GetForEdit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): StandardResponseOfLGPS_GetForEdit_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfLGPS_GetForEdit_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfLGPS_GetForEdit_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    create(request: LGPS_Create_Request): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.createWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createWithCallbacks(request: LGPS_Create_Request, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyGiftPointSetting/Create";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreate(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: LGPS_Edit_Request): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.editWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: LGPS_Edit_Request, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyGiftPointSetting/Edit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyItemCountingApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAll(): Promise<StandardResponseOfLIC_GetAll_Response> {
        return new Promise<StandardResponseOfLIC_GetAll_Response>((resolve, reject) => {
            this.getAllWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllWithCallbacks(onSuccess?: (result: StandardResponseOfLIC_GetAll_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyItemCounting/GetAll";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAll(xhr: any): StandardResponseOfLIC_GetAll_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfLIC_GetAll_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfLIC_GetAll_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForAdd(request: LIC_GetForAdd_Request): Promise<StandardResponseOfLIC_GetForAdd_Response> {
        return new Promise<StandardResponseOfLIC_GetForAdd_Response>((resolve, reject) => {
            this.getForAddWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForAddWithCallbacks(request: LIC_GetForAdd_Request, onSuccess?: (result: StandardResponseOfLIC_GetForAdd_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyItemCounting/GetForAdd";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForAdd(xhr: any): StandardResponseOfLIC_GetForAdd_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfLIC_GetForAdd_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfLIC_GetForAdd_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(request: LIC_GetForEdit_Request): Promise<StandardResponseOfLIC_GetForEdit_Response> {
        return new Promise<StandardResponseOfLIC_GetForEdit_Response>((resolve, reject) => {
            this.getForEditWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(request: LIC_GetForEdit_Request, onSuccess?: (result: StandardResponseOfLIC_GetForEdit_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyItemCounting/GetForEdit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): StandardResponseOfLIC_GetForEdit_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfLIC_GetForEdit_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfLIC_GetForEdit_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    create(request: LIC_Create_Request): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.createWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createWithCallbacks(request: LIC_Create_Request, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyItemCounting/Create";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreate(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: LIC_Edit_Request): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.editWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: LIC_Edit_Request, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyItemCounting/Edit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PaymentFundOutApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getForIndex(request: PaymentFundOutGetForIndexRequest): Promise<PaymentFundOutGetForIndexResponse> {
        return new Promise<PaymentFundOutGetForIndexResponse>((resolve, reject) => {
            this.getForIndexWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForIndexWithCallbacks(request: PaymentFundOutGetForIndexRequest, onSuccess?: (result: PaymentFundOutGetForIndexResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentFundOut/GetForIndex";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForIndexWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForIndex(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForIndex(xhr: any): PaymentFundOutGetForIndexResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PaymentFundOutGetForIndexResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PaymentFundOutGetForIndexResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    isExistingPayment(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.isExistingPaymentWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private isExistingPaymentWithCallbacks(onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentFundOut/IsExistingPayment";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processIsExistingPaymentWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processIsExistingPaymentWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processIsExistingPaymentWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processIsExistingPayment(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processIsExistingPayment(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getEnablePayments(bankId: number): Promise<PaymentFundOutPaymentItem[]> {
        return new Promise<PaymentFundOutPaymentItem[]>((resolve, reject) => {
            this.getEnablePaymentsWithCallbacks(bankId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getEnablePaymentsWithCallbacks(bankId: number, onSuccess?: (result: PaymentFundOutPaymentItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentFundOut/GetEnablePayments?";
        if (bankId === undefined || bankId === null)
            throw new Error("The parameter 'bankId' must be defined and cannot be null.");
        else
            url_ += "bankId=" + encodeURIComponent("" + bankId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetEnablePaymentsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetEnablePaymentsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetEnablePaymentsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetEnablePayments(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetEnablePayments(xhr: any): PaymentFundOutPaymentItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PaymentFundOutPaymentItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PaymentFundOutPaymentItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getBalance(paymentPlatformId: PaymentGatewayPlatformId): Promise<PlatformFundOutAccounts> {
        return new Promise<PlatformFundOutAccounts>((resolve, reject) => {
            this.getBalanceWithCallbacks(paymentPlatformId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getBalanceWithCallbacks(paymentPlatformId: PaymentGatewayPlatformId, onSuccess?: (result: PlatformFundOutAccounts) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentFundOut/GetBalance?";
        if (paymentPlatformId === undefined || paymentPlatformId === null)
            throw new Error("The parameter 'paymentPlatformId' must be defined and cannot be null.");
        else
            url_ += "paymentPlatformId=" + encodeURIComponent("" + paymentPlatformId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetBalanceWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetBalanceWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetBalanceWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetBalance(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetBalance(xhr: any): PlatformFundOutAccounts {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlatformFundOutAccounts = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PlatformFundOutAccounts.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    inquiry(request: PaymentFundOutInquiryRequest): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.inquiryWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private inquiryWithCallbacks(request: PaymentFundOutInquiryRequest, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentFundOut/Inquiry";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processInquiryWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processInquiryWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processInquiryWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processInquiry(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processInquiry(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    apply(request: PaymentFundOutApplyRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.applyWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private applyWithCallbacks(request: PaymentFundOutApplyRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentFundOut/Apply";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processApplyWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processApplyWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processApplyWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processApply(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processApply(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    cancel(request: PaymentFundOutCancelRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.cancelWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private cancelWithCallbacks(request: PaymentFundOutCancelRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentFundOut/Cancel";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCancelWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCancelWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCancelWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCancel(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCancel(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PaymentMethodApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    get(request: GetPaymentPlatformDetailsRequest): Promise<StandardResponseOfPM_GetDetail_Response> {
        return new Promise<StandardResponseOfPM_GetDetail_Response>((resolve, reject) => {
            this.getWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWithCallbacks(request: GetPaymentPlatformDetailsRequest, onSuccess?: (result: StandardResponseOfPM_GetDetail_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentMethod/Get";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): StandardResponseOfPM_GetDetail_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfPM_GetDetail_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfPM_GetDetail_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: PmcEditDetailRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.editWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: PmcEditDetailRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentMethod/Edit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getAll(): Promise<StandardResponseOfPM_GetAll_Response> {
        return new Promise<StandardResponseOfPM_GetAll_Response>((resolve, reject) => {
            this.getAllWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllWithCallbacks(onSuccess?: (result: StandardResponseOfPM_GetAll_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentMethod/GetAll";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAll(xhr: any): StandardResponseOfPM_GetAll_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfPM_GetAll_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfPM_GetAll_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getTransactionType(): Promise<StandardResponseOfPM_TransactionType_Response> {
        return new Promise<StandardResponseOfPM_TransactionType_Response>((resolve, reject) => {
            this.getTransactionTypeWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getTransactionTypeWithCallbacks(onSuccess?: (result: StandardResponseOfPM_TransactionType_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentMethod/GetTransactionType";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetTransactionTypeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetTransactionTypeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetTransactionTypeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetTransactionType(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetTransactionType(xhr: any): StandardResponseOfPM_TransactionType_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfPM_TransactionType_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfPM_TransactionType_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getChannels(request: PmcGetChannelsRequest): Promise<StandardResponseOfPM_GetChannels_Response> {
        return new Promise<StandardResponseOfPM_GetChannels_Response>((resolve, reject) => {
            this.getChannelsWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getChannelsWithCallbacks(request: PmcGetChannelsRequest, onSuccess?: (result: StandardResponseOfPM_GetChannels_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentMethod/GetChannels";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetChannelsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetChannelsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetChannelsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetChannels(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetChannels(xhr: any): StandardResponseOfPM_GetChannels_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfPM_GetChannels_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfPM_GetChannels_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    setSortByList(request: PmcSetSortByListRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.setSortByListWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private setSortByListWithCallbacks(request: PmcSetSortByListRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PaymentMethod/SetSortByList";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSetSortByListWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetSortByListWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSetSortByListWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetSortByList(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetSortByList(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyEGameApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAllEgame(): Promise<LobbyEGameItem[]> {
        return new Promise<LobbyEGameItem[]>((resolve, reject) => {
            this.getAllEgameWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllEgameWithCallbacks(onSuccess?: (result: LobbyEGameItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyEGame/GetAllEgame";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllEgameWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllEgameWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllEgameWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAllEgame(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAllEgame(xhr: any): LobbyEGameItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyEGameItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyEGameItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    get(request: LobbyEGameGetRequest): Promise<LobbyEGameItem[]> {
        return new Promise<LobbyEGameItem[]>((resolve, reject) => {
            this.getWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWithCallbacks(request: LobbyEGameGetRequest, onSuccess?: (result: LobbyEGameItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyEGame/Get";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): LobbyEGameItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyEGameItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyEGameItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForIndex(): Promise<LobbyEGame_GetForIndexResponse> {
        return new Promise<LobbyEGame_GetForIndexResponse>((resolve, reject) => {
            this.getForIndexWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForIndexWithCallbacks(onSuccess?: (result: LobbyEGame_GetForIndexResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyEGame/GetForIndex";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForIndexWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForIndex(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForIndex(xhr: any): LobbyEGame_GetForIndexResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyEGame_GetForIndexResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyEGame_GetForIndexResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(lobbyId: number, lobbyEGameId: number): Promise<LobbyEGameEditResponse> {
        return new Promise<LobbyEGameEditResponse>((resolve, reject) => {
            this.getForEditWithCallbacks(lobbyId, lobbyEGameId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(lobbyId: number, lobbyEGameId: number, onSuccess?: (result: LobbyEGameEditResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyEGame/GetForEdit?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (lobbyEGameId === undefined || lobbyEGameId === null)
            throw new Error("The parameter 'lobbyEGameId' must be defined and cannot be null.");
        else
            url_ += "lobbyEGameId=" + encodeURIComponent("" + lobbyEGameId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): LobbyEGameEditResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyEGameEditResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyEGameEditResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: LobbyEGameEditRequestDao, lobbyId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.editWithCallbacks(request, lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: LobbyEGameEditRequestDao, lobbyId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyEGame/Edit?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    setProperty(request: LobbyEGameSetPropertyRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.setPropertyWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private setPropertyWithCallbacks(request: LobbyEGameSetPropertyRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyEGame/SetProperty";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSetPropertyWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetPropertyWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSetPropertyWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetProperty(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetProperty(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    setSort(request: LobbyEGameSetSortNoRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.setSortWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private setSortWithCallbacks(request: LobbyEGameSetSortNoRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyEGame/SetSort";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSetSortWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetSortWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSetSortWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetSort(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetSort(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    setSortByList(request: LobbyEGameSetSortByListRequest): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.setSortByListWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private setSortByListWithCallbacks(request: LobbyEGameSetSortByListRequest, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyEGame/SetSortByList";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSetSortByListWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetSortByListWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSetSortByListWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetSortByList(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetSortByList(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getGameCodeExample(request: LobbyEGame_GetGameCodeExampleRequest): Promise<LobbyEGame_GetGameCodeExampleResponse> {
        return new Promise<LobbyEGame_GetGameCodeExampleResponse>((resolve, reject) => {
            this.getGameCodeExampleWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getGameCodeExampleWithCallbacks(request: LobbyEGame_GetGameCodeExampleRequest, onSuccess?: (result: LobbyEGame_GetGameCodeExampleResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyEGame/GetGameCodeExample";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetGameCodeExampleWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetGameCodeExampleWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetGameCodeExampleWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetGameCodeExample(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetGameCodeExample(xhr: any): LobbyEGame_GetGameCodeExampleResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyEGame_GetGameCodeExampleResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyEGame_GetGameCodeExampleResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    addNewGame(request: LobbyEGame_AddNewGameRequest): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.addNewGameWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addNewGameWithCallbacks(request: LobbyEGame_AddNewGameRequest, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyEGame/AddNewGame";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAddNewGameWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddNewGameWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddNewGameWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAddNewGame(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAddNewGame(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    addNewGameMulti(fileParameterForGenerateApi: FileParameter): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.addNewGameMultiWithCallbacks(fileParameterForGenerateApi, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addNewGameMultiWithCallbacks(fileParameterForGenerateApi: FileParameter, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyEGame/AddNewGameMulti";

        const content_ = new FormData();
        if (fileParameterForGenerateApi !== null)
            content_.append("fileParameterForGenerateApi", fileParameterForGenerateApi.data, fileParameterForGenerateApi.fileName ? fileParameterForGenerateApi.fileName : "fileParameterForGenerateApi");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            processData: false,
            contentType: false,
            headers: {
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken'), 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId()
 
            }
        }).done((data, textStatus, xhr) => {
            this.processAddNewGameMultiWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddNewGameMultiWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddNewGameMultiWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAddNewGameMulti(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAddNewGameMulti(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyGameDevApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    lobbyGameDevGetAllWithoutKey(lobbyId: number): Promise<LobbyGameDevSimpleItem[]> {
        return new Promise<LobbyGameDevSimpleItem[]>((resolve, reject) => {
            this.lobbyGameDevGetAllWithoutKeyWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private lobbyGameDevGetAllWithoutKeyWithCallbacks(lobbyId: number, onSuccess?: (result: LobbyGameDevSimpleItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyGameDev/LobbyGameDevGetAllWithoutKey?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processLobbyGameDevGetAllWithoutKeyWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLobbyGameDevGetAllWithoutKeyWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLobbyGameDevGetAllWithoutKeyWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLobbyGameDevGetAllWithoutKey(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLobbyGameDevGetAllWithoutKey(xhr: any): LobbyGameDevSimpleItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyGameDevSimpleItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyGameDevSimpleItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyLiveStreamApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAll(lobbyId: number): Promise<LobbyLiveStreamGetAllResponse[]> {
        return new Promise<LobbyLiveStreamGetAllResponse[]>((resolve, reject) => {
            this.getAllWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllWithCallbacks(lobbyId: number, onSuccess?: (result: LobbyLiveStreamGetAllResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyLiveStream/GetAll?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAll(xhr: any): LobbyLiveStreamGetAllResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyLiveStreamGetAllResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyLiveStreamGetAllResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    setEnable(request: LobbyLiveStreamSetEnableRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.setEnableWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private setEnableWithCallbacks(request: LobbyLiveStreamSetEnableRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyLiveStream/SetEnable";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSetEnableWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetEnableWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSetEnableWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetEnable(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetEnable(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyMaintenanceItemApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getByLobbyId(lobbyId: number, language: LanguageCode): Promise<LobbyMaintenanceItemDao[]> {
        return new Promise<LobbyMaintenanceItemDao[]>((resolve, reject) => {
            this.getByLobbyIdWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByLobbyIdWithCallbacks(lobbyId: number, language: LanguageCode, onSuccess?: (result: LobbyMaintenanceItemDao[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyMaintenanceItem/GetByLobbyId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByLobbyIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByLobbyId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByLobbyId(xhr: any): LobbyMaintenanceItemDao[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyMaintenanceItemDao[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyMaintenanceItemDao.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForAdd(lobbyId: number, language: LanguageCode): Promise<CmsSelectionOptionDao[]> {
        return new Promise<CmsSelectionOptionDao[]>((resolve, reject) => {
            this.getForAddWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForAddWithCallbacks(lobbyId: number, language: LanguageCode, onSuccess?: (result: CmsSelectionOptionDao[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyMaintenanceItem/GetForAdd?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForAdd(xhr: any): CmsSelectionOptionDao[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: CmsSelectionOptionDao[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CmsSelectionOptionDao.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    add(lobbyId: number, request: LobbyMaintenanceItemAddRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.addWithCallbacks(lobbyId, request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addWithCallbacks(lobbyId: number, request: LobbyMaintenanceItemAddRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyMaintenanceItem/Add?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAdd(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(lobbyMaintenanceItemId: number, language: LanguageCode): Promise<LobbyMaintenanceItemEditDao> {
        return new Promise<LobbyMaintenanceItemEditDao>((resolve, reject) => {
            this.getForEditWithCallbacks(lobbyMaintenanceItemId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(lobbyMaintenanceItemId: number, language: LanguageCode, onSuccess?: (result: LobbyMaintenanceItemEditDao) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyMaintenanceItem/GetForEdit?";
        if (lobbyMaintenanceItemId === undefined || lobbyMaintenanceItemId === null)
            throw new Error("The parameter 'lobbyMaintenanceItemId' must be defined and cannot be null.");
        else
            url_ += "lobbyMaintenanceItemId=" + encodeURIComponent("" + lobbyMaintenanceItemId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): LobbyMaintenanceItemEditDao {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyMaintenanceItemEditDao = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyMaintenanceItemEditDao.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(lobbyId: number, request: LobbyMaintenanceItemEditRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.editWithCallbacks(lobbyId, request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(lobbyId: number, request: LobbyMaintenanceItemEditRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyMaintenanceItem/Edit?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    delete(lobbyMaintenanceItemId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.deleteWithCallbacks(lobbyMaintenanceItemId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private deleteWithCallbacks(lobbyMaintenanceItemId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyMaintenanceItem/Delete?";
        if (lobbyMaintenanceItemId === undefined || lobbyMaintenanceItemId === null)
            throw new Error("The parameter 'lobbyMaintenanceItemId' must be defined and cannot be null.");
        else
            url_ += "lobbyMaintenanceItemId=" + encodeURIComponent("" + lobbyMaintenanceItemId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDeleteWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDelete(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDelete(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyNoticeApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAll(lobbyId: number, languageId: LanguageCode): Promise<LobbyNoticeItemSimple[]> {
        return new Promise<LobbyNoticeItemSimple[]>((resolve, reject) => {
            this.getAllWithCallbacks(lobbyId, languageId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllWithCallbacks(lobbyId: number, languageId: LanguageCode, onSuccess?: (result: LobbyNoticeItemSimple[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyNotice/GetAll?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAll(xhr: any): LobbyNoticeItemSimple[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyNoticeItemSimple[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyNoticeItemSimple.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForIndexByLobbyNoticeId(lobbyId: number, languageId: LanguageCode, lobbyNoticeId: number): Promise<LobbyNoticeItemSimple> {
        return new Promise<LobbyNoticeItemSimple>((resolve, reject) => {
            this.getForIndexByLobbyNoticeIdWithCallbacks(lobbyId, languageId, lobbyNoticeId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForIndexByLobbyNoticeIdWithCallbacks(lobbyId: number, languageId: LanguageCode, lobbyNoticeId: number, onSuccess?: (result: LobbyNoticeItemSimple) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyNotice/GetForIndexByLobbyNoticeId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&"; 
        
        if (lobbyNoticeId === undefined || lobbyNoticeId === null)
            throw new Error("The parameter 'lobbyNoticeId' must be defined and cannot be null.");
        else
            url_ += "lobbyNoticeId=" + encodeURIComponent("" + lobbyNoticeId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForIndexByLobbyNoticeIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForIndexByLobbyNoticeIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForIndexByLobbyNoticeIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForIndexByLobbyNoticeId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForIndexByLobbyNoticeId(xhr: any): LobbyNoticeItemSimple {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyNoticeItemSimple = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyNoticeItemSimple.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getNoticeTypeSelection(): Promise<NoticeTypeSelectionResponse> {
        return new Promise<NoticeTypeSelectionResponse>((resolve, reject) => {
            this.getNoticeTypeSelectionWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getNoticeTypeSelectionWithCallbacks(onSuccess?: (result: NoticeTypeSelectionResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyNotice/GetNoticeTypeSelection";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetNoticeTypeSelectionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetNoticeTypeSelectionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetNoticeTypeSelectionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetNoticeTypeSelection(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetNoticeTypeSelection(xhr: any): NoticeTypeSelectionResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: NoticeTypeSelectionResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? NoticeTypeSelectionResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    create(request: LobbyNoticeForCreateRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.createWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createWithCallbacks(request: LobbyNoticeForCreateRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyNotice/Create";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreate(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getByLobbyNoticeId(lobbyNoticeId: number): Promise<LobbyNoticeItem> {
        return new Promise<LobbyNoticeItem>((resolve, reject) => {
            this.getByLobbyNoticeIdWithCallbacks(lobbyNoticeId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByLobbyNoticeIdWithCallbacks(lobbyNoticeId: number, onSuccess?: (result: LobbyNoticeItem) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyNotice/GetByLobbyNoticeId?";
        if (lobbyNoticeId === undefined || lobbyNoticeId === null)
            throw new Error("The parameter 'lobbyNoticeId' must be defined and cannot be null.");
        else
            url_ += "lobbyNoticeId=" + encodeURIComponent("" + lobbyNoticeId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByLobbyNoticeIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByLobbyNoticeIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByLobbyNoticeIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByLobbyNoticeId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByLobbyNoticeId(xhr: any): LobbyNoticeItem {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyNoticeItem = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyNoticeItem.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: LobbyNoticeForEditRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.editWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: LobbyNoticeForEditRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyNotice/Edit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    delete(lobbyId: LobbyId, lobbyNoticeId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.deleteWithCallbacks(lobbyId, lobbyNoticeId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private deleteWithCallbacks(lobbyId: LobbyId, lobbyNoticeId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyNotice/Delete?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (lobbyNoticeId === undefined || lobbyNoticeId === null)
            throw new Error("The parameter 'lobbyNoticeId' must be defined and cannot be null.");
        else
            url_ += "lobbyNoticeId=" + encodeURIComponent("" + lobbyNoticeId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDeleteWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDelete(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDelete(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyPlayerGroupApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getByLobbyId(lobbyId: number): Promise<LobbyPlayerGroupDao[]> {
        return new Promise<LobbyPlayerGroupDao[]>((resolve, reject) => {
            this.getByLobbyIdWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByLobbyIdWithCallbacks(lobbyId: number, onSuccess?: (result: LobbyPlayerGroupDao[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerGroup/GetByLobbyId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByLobbyIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByLobbyId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByLobbyId(xhr: any): LobbyPlayerGroupDao[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyPlayerGroupDao[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyPlayerGroupDao.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    create(request: LobbyPlayerGroupRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.createWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createWithCallbacks(request: LobbyPlayerGroupRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerGroup/Create";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreate(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(lobbyPlayerGroupId: number): Promise<LobbyPlayerGroupEditResponse> {
        return new Promise<LobbyPlayerGroupEditResponse>((resolve, reject) => {
            this.getForEditWithCallbacks(lobbyPlayerGroupId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(lobbyPlayerGroupId: number, onSuccess?: (result: LobbyPlayerGroupEditResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerGroup/GetForEdit?";
        if (lobbyPlayerGroupId === undefined || lobbyPlayerGroupId === null)
            throw new Error("The parameter 'lobbyPlayerGroupId' must be defined and cannot be null.");
        else
            url_ += "lobbyPlayerGroupId=" + encodeURIComponent("" + lobbyPlayerGroupId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): LobbyPlayerGroupEditResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyPlayerGroupEditResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyPlayerGroupEditResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: LobbyPlayerGroupEditRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.editWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: LobbyPlayerGroupEditRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerGroup/Edit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    delete(lobbyPlayerGroupId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.deleteWithCallbacks(lobbyPlayerGroupId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private deleteWithCallbacks(lobbyPlayerGroupId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerGroup/Delete?";
        if (lobbyPlayerGroupId === undefined || lobbyPlayerGroupId === null)
            throw new Error("The parameter 'lobbyPlayerGroupId' must be defined and cannot be null.");
        else
            url_ += "lobbyPlayerGroupId=" + encodeURIComponent("" + lobbyPlayerGroupId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDeleteWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDelete(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDelete(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    restore(lobbyPlayerGroupId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.restoreWithCallbacks(lobbyPlayerGroupId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private restoreWithCallbacks(lobbyPlayerGroupId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerGroup/Restore?";
        if (lobbyPlayerGroupId === undefined || lobbyPlayerGroupId === null)
            throw new Error("The parameter 'lobbyPlayerGroupId' must be defined and cannot be null.");
        else
            url_ += "lobbyPlayerGroupId=" + encodeURIComponent("" + lobbyPlayerGroupId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processRestoreWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processRestoreWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processRestoreWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processRestore(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processRestore(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    isNameExist(name: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.isNameExistWithCallbacks(name, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private isNameExistWithCallbacks(name: string, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerGroup/IsNameExist?";
        if (name === undefined)
            throw new Error("The parameter 'name' must be defined.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processIsNameExistWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processIsNameExistWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processIsNameExistWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processIsNameExist(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processIsNameExist(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyPlayerLevelApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getByLobbyId(lobbyId: number, languageId: number): Promise<LobbyPlayerLevelDao[]> {
        return new Promise<LobbyPlayerLevelDao[]>((resolve, reject) => {
            this.getByLobbyIdWithCallbacks(lobbyId, languageId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByLobbyIdWithCallbacks(lobbyId: number, languageId: number, onSuccess?: (result: LobbyPlayerLevelDao[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerLevel/GetByLobbyId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByLobbyIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByLobbyId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByLobbyId(xhr: any): LobbyPlayerLevelDao[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyPlayerLevelDao[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyPlayerLevelDao.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    create(request: LobbyPlayerLevelForCreateRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.createWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createWithCallbacks(request: LobbyPlayerLevelForCreateRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerLevel/Create";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreate(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getByLobbyPlayerLevelId(lobbyPlayerLevelId: number): Promise<LobbyPlayerLevelEditItem> {
        return new Promise<LobbyPlayerLevelEditItem>((resolve, reject) => {
            this.getByLobbyPlayerLevelIdWithCallbacks(lobbyPlayerLevelId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByLobbyPlayerLevelIdWithCallbacks(lobbyPlayerLevelId: number, onSuccess?: (result: LobbyPlayerLevelEditItem) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerLevel/GetByLobbyPlayerLevelId?";
        if (lobbyPlayerLevelId === undefined || lobbyPlayerLevelId === null)
            throw new Error("The parameter 'lobbyPlayerLevelId' must be defined and cannot be null.");
        else
            url_ += "lobbyPlayerLevelId=" + encodeURIComponent("" + lobbyPlayerLevelId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByLobbyPlayerLevelIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByLobbyPlayerLevelIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByLobbyPlayerLevelIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByLobbyPlayerLevelId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByLobbyPlayerLevelId(xhr: any): LobbyPlayerLevelEditItem {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyPlayerLevelEditItem = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyPlayerLevelEditItem.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: LobbyPlayerLevelForEditRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.editWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: LobbyPlayerLevelForEditRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerLevel/Edit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    delete(lobbyPlayerLevelId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.deleteWithCallbacks(lobbyPlayerLevelId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private deleteWithCallbacks(lobbyPlayerLevelId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerLevel/Delete?";
        if (lobbyPlayerLevelId === undefined || lobbyPlayerLevelId === null)
            throw new Error("The parameter 'lobbyPlayerLevelId' must be defined and cannot be null.");
        else
            url_ += "lobbyPlayerLevelId=" + encodeURIComponent("" + lobbyPlayerLevelId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDeleteWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDelete(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDelete(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    restore(lobbyPlayerLevelId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.restoreWithCallbacks(lobbyPlayerLevelId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private restoreWithCallbacks(lobbyPlayerLevelId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerLevel/Restore?";
        if (lobbyPlayerLevelId === undefined || lobbyPlayerLevelId === null)
            throw new Error("The parameter 'lobbyPlayerLevelId' must be defined and cannot be null.");
        else
            url_ += "lobbyPlayerLevelId=" + encodeURIComponent("" + lobbyPlayerLevelId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processRestoreWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processRestoreWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processRestoreWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processRestore(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processRestore(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    isNameExist(name: string, language: LanguageCode): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.isNameExistWithCallbacks(name, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private isNameExistWithCallbacks(name: string, language: LanguageCode, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerLevel/IsNameExist?";
        if (name === undefined)
            throw new Error("The parameter 'name' must be defined.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processIsNameExistWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processIsNameExistWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processIsNameExistWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processIsNameExist(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processIsNameExist(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyPlayerPayoutApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAll(lobbyId: LobbyId, language: LanguageCode): Promise<LobbyPlayerPayoutItem[]> {
        return new Promise<LobbyPlayerPayoutItem[]>((resolve, reject) => {
            this.getAllWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllWithCallbacks(lobbyId: LobbyId, language: LanguageCode, onSuccess?: (result: LobbyPlayerPayoutItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerPayout/GetAll?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAll(xhr: any): LobbyPlayerPayoutItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyPlayerPayoutItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyPlayerPayoutItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForAdd(lobbyId: LobbyId, language: LanguageCode): Promise<LobbyPlayerPayoutGetForAddResponse> {
        return new Promise<LobbyPlayerPayoutGetForAddResponse>((resolve, reject) => {
            this.getForAddWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForAddWithCallbacks(lobbyId: LobbyId, language: LanguageCode, onSuccess?: (result: LobbyPlayerPayoutGetForAddResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerPayout/GetForAdd?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForAdd(xhr: any): LobbyPlayerPayoutGetForAddResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyPlayerPayoutGetForAddResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyPlayerPayoutGetForAddResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getGamesListByLobbyIdProviderId(lobbyId: LobbyId, gameDevId: GameDevId, language: LanguageCode): Promise<SelectionOption[]> {
        return new Promise<SelectionOption[]>((resolve, reject) => {
            this.getGamesListByLobbyIdProviderIdWithCallbacks(lobbyId, gameDevId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getGamesListByLobbyIdProviderIdWithCallbacks(lobbyId: LobbyId, gameDevId: GameDevId, language: LanguageCode, onSuccess?: (result: SelectionOption[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerPayout/GetGamesListByLobbyIdProviderId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (gameDevId === undefined || gameDevId === null)
            throw new Error("The parameter 'gameDevId' must be defined and cannot be null.");
        else
            url_ += "gameDevId=" + encodeURIComponent("" + gameDevId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetGamesListByLobbyIdProviderIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetGamesListByLobbyIdProviderIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetGamesListByLobbyIdProviderIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetGamesListByLobbyIdProviderId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetGamesListByLobbyIdProviderId(xhr: any): SelectionOption[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: SelectionOption[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SelectionOption.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    add(request: LobbyPlayerPayoutAddRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.addWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addWithCallbacks(request: LobbyPlayerPayoutAddRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerPayout/Add";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAdd(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(lobbyId: LobbyId, lobbyPlayerPayoutId: number, language: LanguageCode): Promise<LobbyPlayerPayoutGetForEditResponse> {
        return new Promise<LobbyPlayerPayoutGetForEditResponse>((resolve, reject) => {
            this.getForEditWithCallbacks(lobbyId, lobbyPlayerPayoutId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(lobbyId: LobbyId, lobbyPlayerPayoutId: number, language: LanguageCode, onSuccess?: (result: LobbyPlayerPayoutGetForEditResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerPayout/GetForEdit?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (lobbyPlayerPayoutId === undefined || lobbyPlayerPayoutId === null)
            throw new Error("The parameter 'lobbyPlayerPayoutId' must be defined and cannot be null.");
        else
            url_ += "lobbyPlayerPayoutId=" + encodeURIComponent("" + lobbyPlayerPayoutId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): LobbyPlayerPayoutGetForEditResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyPlayerPayoutGetForEditResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyPlayerPayoutGetForEditResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: LobbyPlayerPayoutEditRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.editWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: LobbyPlayerPayoutEditRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerPayout/Edit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    delete(lobbyId: LobbyId, lobbyPlayerPayoutId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.deleteWithCallbacks(lobbyId, lobbyPlayerPayoutId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private deleteWithCallbacks(lobbyId: LobbyId, lobbyPlayerPayoutId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPlayerPayout/Delete?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (lobbyPlayerPayoutId === undefined || lobbyPlayerPayoutId === null)
            throw new Error("The parameter 'lobbyPlayerPayoutId' must be defined and cannot be null.");
        else
            url_ += "lobbyPlayerPayoutId=" + encodeURIComponent("" + lobbyPlayerPayoutId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDeleteWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDelete(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDelete(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyPromotionApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getPublishedByLanguage(lobbyId: number, language: LanguageCode): Promise<CmsSelectionOptionDao[]> {
        return new Promise<CmsSelectionOptionDao[]>((resolve, reject) => {
            this.getPublishedByLanguageWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getPublishedByLanguageWithCallbacks(lobbyId: number, language: LanguageCode, onSuccess?: (result: CmsSelectionOptionDao[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPromotion/GetPublishedByLanguage?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetPublishedByLanguageWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetPublishedByLanguageWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetPublishedByLanguageWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetPublishedByLanguage(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetPublishedByLanguage(xhr: any): CmsSelectionOptionDao[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: CmsSelectionOptionDao[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CmsSelectionOptionDao.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getEnabledAndNotChoiceablePromotion(): Promise<GetPublishedRespones[]> {
        return new Promise<GetPublishedRespones[]>((resolve, reject) => {
            this.getEnabledAndNotChoiceablePromotionWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getEnabledAndNotChoiceablePromotionWithCallbacks(onSuccess?: (result: GetPublishedRespones[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPromotion/GetEnabledAndNotChoiceablePromotion";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetEnabledAndNotChoiceablePromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetEnabledAndNotChoiceablePromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetEnabledAndNotChoiceablePromotionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetEnabledAndNotChoiceablePromotion(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetEnabledAndNotChoiceablePromotion(xhr: any): GetPublishedRespones[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: GetPublishedRespones[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetPublishedRespones.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getChoiceablePromotion(): Promise<GetChoiceablePromotionRespones[]> {
        return new Promise<GetChoiceablePromotionRespones[]>((resolve, reject) => {
            this.getChoiceablePromotionWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getChoiceablePromotionWithCallbacks(onSuccess?: (result: GetChoiceablePromotionRespones[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPromotion/GetChoiceablePromotion";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetChoiceablePromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetChoiceablePromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetChoiceablePromotionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetChoiceablePromotion(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetChoiceablePromotion(xhr: any): GetChoiceablePromotionRespones[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: GetChoiceablePromotionRespones[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(GetChoiceablePromotionRespones.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getPromotionTitle(lobbyPromotionId: number, language: LanguageCode): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            this.getPromotionTitleWithCallbacks(lobbyPromotionId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getPromotionTitleWithCallbacks(lobbyPromotionId: number, language: LanguageCode, onSuccess?: (result: string) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPromotion/GetPromotionTitle?";
        if (lobbyPromotionId === undefined || lobbyPromotionId === null)
            throw new Error("The parameter 'lobbyPromotionId' must be defined and cannot be null.");
        else
            url_ += "lobbyPromotionId=" + encodeURIComponent("" + lobbyPromotionId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetPromotionTitleWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetPromotionTitleWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetPromotionTitleWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetPromotionTitle(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetPromotionTitle(xhr: any): string {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: string = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getAllByLanguage(lobbyId: number, language: LanguageCode): Promise<CmsSelectionOptionDao[]> {
        return new Promise<CmsSelectionOptionDao[]>((resolve, reject) => {
            this.getAllByLanguageWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllByLanguageWithCallbacks(lobbyId: number, language: LanguageCode, onSuccess?: (result: CmsSelectionOptionDao[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPromotion/GetAllByLanguage?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllByLanguageWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllByLanguageWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllByLanguageWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAllByLanguage(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAllByLanguage(xhr: any): CmsSelectionOptionDao[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: CmsSelectionOptionDao[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CmsSelectionOptionDao.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getManualGiveOut(request: GetManualGiveOutRequest): Promise<StandardResultOfGetManualGiveOutResponse> {
        return new Promise<StandardResultOfGetManualGiveOutResponse>((resolve, reject) => {
            this.getManualGiveOutWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getManualGiveOutWithCallbacks(request: GetManualGiveOutRequest, onSuccess?: (result: StandardResultOfGetManualGiveOutResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPromotion/GetManualGiveOut";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetManualGiveOutWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetManualGiveOutWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetManualGiveOutWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetManualGiveOut(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetManualGiveOut(xhr: any): StandardResultOfGetManualGiveOutResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResultOfGetManualGiveOutResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResultOfGetManualGiveOutResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyPromotionReportApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getSummary(request: LPR_GetSummaryRequest): Promise<LPR_GetSummaryResponse> {
        return new Promise<LPR_GetSummaryResponse>((resolve, reject) => {
            this.getSummaryWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getSummaryWithCallbacks(request: LPR_GetSummaryRequest, onSuccess?: (result: LPR_GetSummaryResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPromotionReport/GetSummary";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetSummaryWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetSummaryWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetSummaryWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetSummary(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetSummary(xhr: any): LPR_GetSummaryResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LPR_GetSummaryResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LPR_GetSummaryResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getSummaryGpByPromotion(request: LPR_GetSummaryGpByPromotionRequest): Promise<LPR_GetSummaryGpByPromotionResponse[]> {
        return new Promise<LPR_GetSummaryGpByPromotionResponse[]>((resolve, reject) => {
            this.getSummaryGpByPromotionWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getSummaryGpByPromotionWithCallbacks(request: LPR_GetSummaryGpByPromotionRequest, onSuccess?: (result: LPR_GetSummaryGpByPromotionResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPromotionReport/GetSummaryGpByPromotion";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetSummaryGpByPromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetSummaryGpByPromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetSummaryGpByPromotionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetSummaryGpByPromotion(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetSummaryGpByPromotion(xhr: any): LPR_GetSummaryGpByPromotionResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LPR_GetSummaryGpByPromotionResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LPR_GetSummaryGpByPromotionResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getSummaryGpByPlayer(apiRequest: LPR_SummaryByPromotionRequest): Promise<LPR_GetSummaryGpByPlayerResponse> {
        return new Promise<LPR_GetSummaryGpByPlayerResponse>((resolve, reject) => {
            this.getSummaryGpByPlayerWithCallbacks(apiRequest, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getSummaryGpByPlayerWithCallbacks(apiRequest: LPR_SummaryByPromotionRequest, onSuccess?: (result: LPR_GetSummaryGpByPlayerResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPromotionReport/GetSummaryGpByPlayer";

        const content_ = JSON.stringify(apiRequest ? apiRequest.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetSummaryGpByPlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetSummaryGpByPlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetSummaryGpByPlayerWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetSummaryGpByPlayer(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetSummaryGpByPlayer(xhr: any): LPR_GetSummaryGpByPlayerResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LPR_GetSummaryGpByPlayerResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LPR_GetSummaryGpByPlayerResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getDetails(apiRequest: LPR_SummaryByPromotionRequest): Promise<LPR_GetDetailsResponse> {
        return new Promise<LPR_GetDetailsResponse>((resolve, reject) => {
            this.getDetailsWithCallbacks(apiRequest, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getDetailsWithCallbacks(apiRequest: LPR_SummaryByPromotionRequest, onSuccess?: (result: LPR_GetDetailsResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyPromotionReport/GetDetails";

        const content_ = JSON.stringify(apiRequest ? apiRequest.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetDetailsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetDetailsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetDetailsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetDetails(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetDetails(xhr: any): LPR_GetDetailsResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LPR_GetDetailsResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LPR_GetDetailsResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyRoleApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAllByLobbyId(lobbyId: number): Promise<LobbyRoleDao[]> {
        return new Promise<LobbyRoleDao[]>((resolve, reject) => {
            this.getAllByLobbyIdWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllByLobbyIdWithCallbacks(lobbyId: number, onSuccess?: (result: LobbyRoleDao[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRole/GetAllByLobbyId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllByLobbyIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAllByLobbyId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAllByLobbyId(xhr: any): LobbyRoleDao[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyRoleDao[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyRoleDao.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getByLobbyRoleId(lobbyId: number, lobbyRoleId: number): Promise<LobbyRoleDao> {
        return new Promise<LobbyRoleDao>((resolve, reject) => {
            this.getByLobbyRoleIdWithCallbacks(lobbyId, lobbyRoleId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByLobbyRoleIdWithCallbacks(lobbyId: number, lobbyRoleId: number, onSuccess?: (result: LobbyRoleDao) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRole/GetByLobbyRoleId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (lobbyRoleId === undefined || lobbyRoleId === null)
            throw new Error("The parameter 'lobbyRoleId' must be defined and cannot be null.");
        else
            url_ += "lobbyRoleId=" + encodeURIComponent("" + lobbyRoleId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByLobbyRoleIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByLobbyRoleIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByLobbyRoleIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByLobbyRoleId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByLobbyRoleId(xhr: any): LobbyRoleDao {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyRoleDao = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyRoleDao.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getLobbyRoleOptionsByLobbyId(lobbyId: number): Promise<CmsSelectionOption[]> {
        return new Promise<CmsSelectionOption[]>((resolve, reject) => {
            this.getLobbyRoleOptionsByLobbyIdWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getLobbyRoleOptionsByLobbyIdWithCallbacks(lobbyId: number, onSuccess?: (result: CmsSelectionOption[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRole/GetLobbyRoleOptionsByLobbyId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetLobbyRoleOptionsByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetLobbyRoleOptionsByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetLobbyRoleOptionsByLobbyIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetLobbyRoleOptionsByLobbyId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetLobbyRoleOptionsByLobbyId(xhr: any): CmsSelectionOption[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: CmsSelectionOption[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CmsSelectionOption.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    addRole(roleName: string, lobbyId: number): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            this.addRoleWithCallbacks(roleName, lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addRoleWithCallbacks(roleName: string, lobbyId: number, onSuccess?: (result: number) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRole/AddRole?";
        if (roleName === undefined)
            throw new Error("The parameter 'roleName' must be defined.");
        else
            url_ += "roleName=" + encodeURIComponent("" + roleName) + "&"; 
        
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAddRoleWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddRoleWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddRoleWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAddRole(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAddRole(xhr: any): number {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: number = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    addRolePermission(request: AddRolePermissionRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.addRolePermissionWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addRolePermissionWithCallbacks(request: AddRolePermissionRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRole/AddRolePermission";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAddRolePermissionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddRolePermissionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddRolePermissionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAddRolePermission(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAddRolePermission(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(lobbyRoleId: number, lobbyId: number): Promise<LobbyRoleEditDao> {
        return new Promise<LobbyRoleEditDao>((resolve, reject) => {
            this.getForEditWithCallbacks(lobbyRoleId, lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(lobbyRoleId: number, lobbyId: number, onSuccess?: (result: LobbyRoleEditDao) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRole/GetForEdit?";
        if (lobbyRoleId === undefined || lobbyRoleId === null)
            throw new Error("The parameter 'lobbyRoleId' must be defined and cannot be null.");
        else
            url_ += "lobbyRoleId=" + encodeURIComponent("" + lobbyRoleId) + "&"; 
        
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): LobbyRoleEditDao {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyRoleEditDao = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbyRoleEditDao.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    editRoleName(request: LobbyRoleEditRequest, lobbyId: number): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.editRoleNameWithCallbacks(request, lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editRoleNameWithCallbacks(request: LobbyRoleEditRequest, lobbyId: number, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRole/EditRoleName?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditRoleNameWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditRoleNameWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditRoleNameWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEditRoleName(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEditRoleName(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    deleteRole(lobbyRoleId: number): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.deleteRoleWithCallbacks(lobbyRoleId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private deleteRoleWithCallbacks(lobbyRoleId: number, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRole/DeleteRole?";
        if (lobbyRoleId === undefined || lobbyRoleId === null)
            throw new Error("The parameter 'lobbyRoleId' must be defined and cannot be null.");
        else
            url_ += "lobbyRoleId=" + encodeURIComponent("" + lobbyRoleId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDeleteRoleWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDeleteRoleWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDeleteRoleWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDeleteRole(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDeleteRole(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyTVBannerApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    tvBannerGetAll(lobbyId: number): Promise<TVBannerGetAllResponse[]> {
        return new Promise<TVBannerGetAllResponse[]>((resolve, reject) => {
            this.tvBannerGetAllWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private tvBannerGetAllWithCallbacks(lobbyId: number, onSuccess?: (result: TVBannerGetAllResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyTVBanner/TvBannerGetAll?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processTvBannerGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processTvBannerGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processTvBannerGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processTvBannerGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processTvBannerGetAll(xhr: any): TVBannerGetAllResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: TVBannerGetAllResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TVBannerGetAllResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    tvBannerDetailGetAll(request: TVBannerDetailGetAllRequest): Promise<TVBannerDetailGetAllResponse[]> {
        return new Promise<TVBannerDetailGetAllResponse[]>((resolve, reject) => {
            this.tvBannerDetailGetAllWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private tvBannerDetailGetAllWithCallbacks(request: TVBannerDetailGetAllRequest, onSuccess?: (result: TVBannerDetailGetAllResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyTVBanner/TvBannerDetailGetAll";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processTvBannerDetailGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processTvBannerDetailGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processTvBannerDetailGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processTvBannerDetailGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processTvBannerDetailGetAll(xhr: any): TVBannerDetailGetAllResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: TVBannerDetailGetAllResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(TVBannerDetailGetAllResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    tvBannerDetailGetById(request: TVBannerDetailGetByIdRequest): Promise<TVBannerDetailGetAllResponse> {
        return new Promise<TVBannerDetailGetAllResponse>((resolve, reject) => {
            this.tvBannerDetailGetByIdWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private tvBannerDetailGetByIdWithCallbacks(request: TVBannerDetailGetByIdRequest, onSuccess?: (result: TVBannerDetailGetAllResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyTVBanner/TvBannerDetailGetById";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processTvBannerDetailGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processTvBannerDetailGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processTvBannerDetailGetByIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processTvBannerDetailGetById(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processTvBannerDetailGetById(xhr: any): TVBannerDetailGetAllResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: TVBannerDetailGetAllResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? TVBannerDetailGetAllResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForAdd(lobbyId: number): Promise<LobbyLanguageResponse[]> {
        return new Promise<LobbyLanguageResponse[]>((resolve, reject) => {
            this.getForAddWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForAddWithCallbacks(lobbyId: number, onSuccess?: (result: LobbyLanguageResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyTVBanner/GetForAdd?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForAdd(xhr: any): LobbyLanguageResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyLanguageResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyLanguageResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    createLobbyTVBannerDetail(request: CreateTVBannerRequestDao, lobbyId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.createLobbyTVBannerDetailWithCallbacks(request, lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createLobbyTVBannerDetailWithCallbacks(request: CreateTVBannerRequestDao, lobbyId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyTVBanner/CreateLobbyTVBannerDetail?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateLobbyTVBannerDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateLobbyTVBannerDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateLobbyTVBannerDetailWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreateLobbyTVBannerDetail(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreateLobbyTVBannerDetail(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(lobbyId: number, lobbyTVBannerDetailId: number): Promise<TVBannerDetailEditResponse> {
        return new Promise<TVBannerDetailEditResponse>((resolve, reject) => {
            this.getForEditWithCallbacks(lobbyId, lobbyTVBannerDetailId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(lobbyId: number, lobbyTVBannerDetailId: number, onSuccess?: (result: TVBannerDetailEditResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyTVBanner/GetForEdit?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (lobbyTVBannerDetailId === undefined || lobbyTVBannerDetailId === null)
            throw new Error("The parameter 'lobbyTVBannerDetailId' must be defined and cannot be null.");
        else
            url_ += "lobbyTVBannerDetailId=" + encodeURIComponent("" + lobbyTVBannerDetailId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): TVBannerDetailEditResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: TVBannerDetailEditResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? TVBannerDetailEditResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    editLobbyTVBannerDetail(request: TVBannerDetailEditRequestDao, lobbyId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.editLobbyTVBannerDetailWithCallbacks(request, lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editLobbyTVBannerDetailWithCallbacks(request: TVBannerDetailEditRequestDao, lobbyId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyTVBanner/EditLobbyTVBannerDetail?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditLobbyTVBannerDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditLobbyTVBannerDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditLobbyTVBannerDetailWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEditLobbyTVBannerDetail(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEditLobbyTVBannerDetail(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    moveUpLobbyTVBannerSorting(lobbyTVBannerDetailId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.moveUpLobbyTVBannerSortingWithCallbacks(lobbyTVBannerDetailId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private moveUpLobbyTVBannerSortingWithCallbacks(lobbyTVBannerDetailId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyTVBanner/MoveUpLobbyTVBannerSorting?";
        if (lobbyTVBannerDetailId === undefined || lobbyTVBannerDetailId === null)
            throw new Error("The parameter 'lobbyTVBannerDetailId' must be defined and cannot be null.");
        else
            url_ += "lobbyTVBannerDetailId=" + encodeURIComponent("" + lobbyTVBannerDetailId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processMoveUpLobbyTVBannerSortingWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processMoveUpLobbyTVBannerSortingWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processMoveUpLobbyTVBannerSortingWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processMoveUpLobbyTVBannerSorting(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processMoveUpLobbyTVBannerSorting(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    moveDownLobbyTVBannerSorting(lobbyTVBannerDetailId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.moveDownLobbyTVBannerSortingWithCallbacks(lobbyTVBannerDetailId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private moveDownLobbyTVBannerSortingWithCallbacks(lobbyTVBannerDetailId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyTVBanner/MoveDownLobbyTVBannerSorting?";
        if (lobbyTVBannerDetailId === undefined || lobbyTVBannerDetailId === null)
            throw new Error("The parameter 'lobbyTVBannerDetailId' must be defined and cannot be null.");
        else
            url_ += "lobbyTVBannerDetailId=" + encodeURIComponent("" + lobbyTVBannerDetailId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processMoveDownLobbyTVBannerSortingWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processMoveDownLobbyTVBannerSortingWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processMoveDownLobbyTVBannerSortingWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processMoveDownLobbyTVBannerSorting(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processMoveDownLobbyTVBannerSorting(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    lobbyTVBannerDetailSetEnable(request: LobbyTVBannerDetailSetEnableRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.lobbyTVBannerDetailSetEnableWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private lobbyTVBannerDetailSetEnableWithCallbacks(request: LobbyTVBannerDetailSetEnableRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyTVBanner/LobbyTVBannerDetailSetEnable";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processLobbyTVBannerDetailSetEnableWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLobbyTVBannerDetailSetEnableWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLobbyTVBannerDetailSetEnableWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLobbyTVBannerDetailSetEnable(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLobbyTVBannerDetailSetEnable(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    lobbyTVBannerDetailSetDelete(request: LobbyTVBannerDetailSetDeleteRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.lobbyTVBannerDetailSetDeleteWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private lobbyTVBannerDetailSetDeleteWithCallbacks(request: LobbyTVBannerDetailSetDeleteRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyTVBanner/LobbyTVBannerDetailSetDelete";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processLobbyTVBannerDetailSetDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processLobbyTVBannerDetailSetDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processLobbyTVBannerDetailSetDeleteWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processLobbyTVBannerDetailSetDelete(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processLobbyTVBannerDetailSetDelete(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PlayerAmountRecordApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getWinLostReportItems(request: PlayerAmountRecordWinLostRequest): Promise<StandardResultOfWinLossReportResponse> {
        return new Promise<StandardResultOfWinLossReportResponse>((resolve, reject) => {
            this.getWinLostReportItemsWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWinLostReportItemsWithCallbacks(request: PlayerAmountRecordWinLostRequest, onSuccess?: (result: StandardResultOfWinLossReportResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerAmountRecord/GetWinLostReportItems";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWinLostReportItemsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWinLostReportItemsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWinLostReportItemsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetWinLostReportItems(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetWinLostReportItems(xhr: any): StandardResultOfWinLossReportResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResultOfWinLossReportResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResultOfWinLossReportResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getWinLostReportDetail(request: WinLostReportDetailRequest): Promise<StandardResultOfIEnumerableOfWinLostReportDetailItem> {
        return new Promise<StandardResultOfIEnumerableOfWinLostReportDetailItem>((resolve, reject) => {
            this.getWinLostReportDetailWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWinLostReportDetailWithCallbacks(request: WinLostReportDetailRequest, onSuccess?: (result: StandardResultOfIEnumerableOfWinLostReportDetailItem) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerAmountRecord/GetWinLostReportDetail";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWinLostReportDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWinLostReportDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWinLostReportDetailWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetWinLostReportDetail(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetWinLostReportDetail(xhr: any): StandardResultOfIEnumerableOfWinLostReportDetailItem {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResultOfIEnumerableOfWinLostReportDetailItem = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResultOfIEnumerableOfWinLostReportDetailItem.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerTransactionList(request: PlayerTransactionListRequest): Promise<PlayerTransactionItem[]> {
        return new Promise<PlayerTransactionItem[]>((resolve, reject) => {
            this.playerTransactionListWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerTransactionListWithCallbacks(request: PlayerTransactionListRequest, onSuccess?: (result: PlayerTransactionItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerAmountRecord/PlayerTransactionList";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerTransactionListWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerTransactionListWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerTransactionListWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerTransactionList(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerTransactionList(xhr: any): PlayerTransactionItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerTransactionItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlayerTransactionItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getPlayerTransactionListGroupByUsername(request: PlayerTransactionListGroupByUsernameRequest): Promise<StandardResultOfIEnumerableOfPlayerTransactionListGroupByUserDao> {
        return new Promise<StandardResultOfIEnumerableOfPlayerTransactionListGroupByUserDao>((resolve, reject) => {
            this.getPlayerTransactionListGroupByUsernameWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getPlayerTransactionListGroupByUsernameWithCallbacks(request: PlayerTransactionListGroupByUsernameRequest, onSuccess?: (result: StandardResultOfIEnumerableOfPlayerTransactionListGroupByUserDao) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerAmountRecord/GetPlayerTransactionListGroupByUsername";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetPlayerTransactionListGroupByUsernameWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetPlayerTransactionListGroupByUsernameWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetPlayerTransactionListGroupByUsernameWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetPlayerTransactionListGroupByUsername(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetPlayerTransactionListGroupByUsername(xhr: any): StandardResultOfIEnumerableOfPlayerTransactionListGroupByUserDao {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResultOfIEnumerableOfPlayerTransactionListGroupByUserDao = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResultOfIEnumerableOfPlayerTransactionListGroupByUserDao.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PlayerBankAccountApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    playerBankAccountGetByPlayerId(languageId: LanguageCode, playerId: number): Promise<PlayerBankAccountItemDao[]> {
        return new Promise<PlayerBankAccountItemDao[]>((resolve, reject) => {
            this.playerBankAccountGetByPlayerIdWithCallbacks(languageId, playerId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerBankAccountGetByPlayerIdWithCallbacks(languageId: LanguageCode, playerId: number, onSuccess?: (result: PlayerBankAccountItemDao[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerBankAccount/PlayerBankAccountGetByPlayerId?";
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&"; 
        
        if (playerId === undefined || playerId === null)
            throw new Error("The parameter 'playerId' must be defined and cannot be null.");
        else
            url_ += "playerId=" + encodeURIComponent("" + playerId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerBankAccountGetByPlayerIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerBankAccountGetByPlayerIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerBankAccountGetByPlayerIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerBankAccountGetByPlayerId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerBankAccountGetByPlayerId(xhr: any): PlayerBankAccountItemDao[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerBankAccountItemDao[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlayerBankAccountItemDao.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerBankAccountGetByPlayerName(playerName: string): Promise<StandardResponseOfPlayerBankAccountGetByPlayerNameResponse> {
        return new Promise<StandardResponseOfPlayerBankAccountGetByPlayerNameResponse>((resolve, reject) => {
            this.playerBankAccountGetByPlayerNameWithCallbacks(playerName, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerBankAccountGetByPlayerNameWithCallbacks(playerName: string, onSuccess?: (result: StandardResponseOfPlayerBankAccountGetByPlayerNameResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerBankAccount/PlayerBankAccountGetByPlayerName?";
        if (playerName === undefined)
            throw new Error("The parameter 'playerName' must be defined.");
        else
            url_ += "playerName=" + encodeURIComponent("" + playerName) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerBankAccountGetByPlayerNameWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerBankAccountGetByPlayerNameWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerBankAccountGetByPlayerNameWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerBankAccountGetByPlayerName(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerBankAccountGetByPlayerName(xhr: any): StandardResponseOfPlayerBankAccountGetByPlayerNameResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfPlayerBankAccountGetByPlayerNameResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfPlayerBankAccountGetByPlayerNameResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerBankAccountGetById(languageId: LanguageCode, playerId: number): Promise<PlayerBankAccountItemDao> {
        return new Promise<PlayerBankAccountItemDao>((resolve, reject) => {
            this.playerBankAccountGetByIdWithCallbacks(languageId, playerId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerBankAccountGetByIdWithCallbacks(languageId: LanguageCode, playerId: number, onSuccess?: (result: PlayerBankAccountItemDao) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerBankAccount/PlayerBankAccountGetById?";
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&"; 
        
        if (playerId === undefined || playerId === null)
            throw new Error("The parameter 'playerId' must be defined and cannot be null.");
        else
            url_ += "playerId=" + encodeURIComponent("" + playerId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerBankAccountGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerBankAccountGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerBankAccountGetByIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerBankAccountGetById(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerBankAccountGetById(xhr: any): PlayerBankAccountItemDao {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerBankAccountItemDao = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PlayerBankAccountItemDao.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerBankAccountCreate(request: PlayerBankAccountCreateRequestDao): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.playerBankAccountCreateWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerBankAccountCreateWithCallbacks(request: PlayerBankAccountCreateRequestDao, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerBankAccount/PlayerBankAccountCreate";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerBankAccountCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerBankAccountCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerBankAccountCreateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerBankAccountCreate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerBankAccountCreate(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerBankAccountDelete(playerBankAccountId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.playerBankAccountDeleteWithCallbacks(playerBankAccountId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerBankAccountDeleteWithCallbacks(playerBankAccountId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerBankAccount/PlayerBankAccountDelete?";
        if (playerBankAccountId === undefined || playerBankAccountId === null)
            throw new Error("The parameter 'playerBankAccountId' must be defined and cannot be null.");
        else
            url_ += "playerBankAccountId=" + encodeURIComponent("" + playerBankAccountId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerBankAccountDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerBankAccountDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerBankAccountDeleteWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerBankAccountDelete(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerBankAccountDelete(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForAdd(lobbyId: number): Promise<StandardResponseOfPlayerBankAccountGetForAddResponse> {
        return new Promise<StandardResponseOfPlayerBankAccountGetForAddResponse>((resolve, reject) => {
            this.getForAddWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForAddWithCallbacks(lobbyId: number, onSuccess?: (result: StandardResponseOfPlayerBankAccountGetForAddResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerBankAccount/GetForAdd?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForAdd(xhr: any): StandardResponseOfPlayerBankAccountGetForAddResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfPlayerBankAccountGetForAddResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfPlayerBankAccountGetForAddResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerBankAccountSetDefault(playerBankAccountId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.playerBankAccountSetDefaultWithCallbacks(playerBankAccountId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerBankAccountSetDefaultWithCallbacks(playerBankAccountId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerBankAccount/PlayerBankAccountSetDefault?";
        if (playerBankAccountId === undefined || playerBankAccountId === null)
            throw new Error("The parameter 'playerBankAccountId' must be defined and cannot be null.");
        else
            url_ += "playerBankAccountId=" + encodeURIComponent("" + playerBankAccountId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerBankAccountSetDefaultWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerBankAccountSetDefaultWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerBankAccountSetDefaultWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerBankAccountSetDefault(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerBankAccountSetDefault(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    isAccountNoExists(bankAccountNo: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.isAccountNoExistsWithCallbacks(bankAccountNo, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private isAccountNoExistsWithCallbacks(bankAccountNo: string, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerBankAccount/IsAccountNoExists?";
        if (bankAccountNo === undefined)
            throw new Error("The parameter 'bankAccountNo' must be defined.");
        else
            url_ += "bankAccountNo=" + encodeURIComponent("" + bankAccountNo) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processIsAccountNoExistsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processIsAccountNoExistsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processIsAccountNoExistsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processIsAccountNoExists(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processIsAccountNoExists(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PlayerApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getPlayerDetails(playerId: number): Promise<PlayerDetailsResponse> {
        return new Promise<PlayerDetailsResponse>((resolve, reject) => {
            this.getPlayerDetailsWithCallbacks(playerId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getPlayerDetailsWithCallbacks(playerId: number, onSuccess?: (result: PlayerDetailsResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/GetPlayerDetails?";
        if (playerId === undefined || playerId === null)
            throw new Error("The parameter 'playerId' must be defined and cannot be null.");
        else
            url_ += "playerId=" + encodeURIComponent("" + playerId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetPlayerDetailsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetPlayerDetailsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetPlayerDetailsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetPlayerDetails(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetPlayerDetails(xhr: any): PlayerDetailsResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerDetailsResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PlayerDetailsResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerGetForSections(lobbyId: number, languageId: LanguageCode): Promise<PlayerGetForSectionsResponse> {
        return new Promise<PlayerGetForSectionsResponse>((resolve, reject) => {
            this.playerGetForSectionsWithCallbacks(lobbyId, languageId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerGetForSectionsWithCallbacks(lobbyId: number, languageId: LanguageCode, onSuccess?: (result: PlayerGetForSectionsResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/PlayerGetForSections?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerGetForSectionsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerGetForSectionsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerGetForSectionsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerGetForSections(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerGetForSections(xhr: any): PlayerGetForSectionsResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerGetForSectionsResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PlayerGetForSectionsResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getByFiltering(lobbyId: number, language: LanguageCode, dateRangeRequest: FilterRequest): Promise<PlayerItem[]> {
        return new Promise<PlayerItem[]>((resolve, reject) => {
            this.getByFilteringWithCallbacks(lobbyId, language, dateRangeRequest, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByFilteringWithCallbacks(lobbyId: number, language: LanguageCode, dateRangeRequest: FilterRequest, onSuccess?: (result: PlayerItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/GetByFiltering?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = JSON.stringify(dateRangeRequest ? dateRangeRequest.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByFilteringWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByFilteringWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByFilteringWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByFiltering(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByFiltering(xhr: any): PlayerItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlayerItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getByFilteringIPIntervals(lobbyId: number, language: LanguageCode, ipAddress: string): Promise<PlayerItem[]> {
        return new Promise<PlayerItem[]>((resolve, reject) => {
            this.getByFilteringIPIntervalsWithCallbacks(lobbyId, language, ipAddress, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByFilteringIPIntervalsWithCallbacks(lobbyId: number, language: LanguageCode, ipAddress: string, onSuccess?: (result: PlayerItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/GetByFilteringIPIntervals?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&"; 
        
        if (ipAddress === undefined)
            throw new Error("The parameter 'ipAddress' must be defined.");
        else
            url_ += "ipAddress=" + encodeURIComponent("" + ipAddress) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByFilteringIPIntervalsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByFilteringIPIntervalsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByFilteringIPIntervalsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByFilteringIPIntervals(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByFilteringIPIntervals(xhr: any): PlayerItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlayerItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getAllAgentPlayerByLobbyId(lobbyId: number, languageId: number): Promise<PlayerItem[]> {
        return new Promise<PlayerItem[]>((resolve, reject) => {
            this.getAllAgentPlayerByLobbyIdWithCallbacks(lobbyId, languageId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllAgentPlayerByLobbyIdWithCallbacks(lobbyId: number, languageId: number, onSuccess?: (result: PlayerItem[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/GetAllAgentPlayerByLobbyId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllAgentPlayerByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllAgentPlayerByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllAgentPlayerByLobbyIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAllAgentPlayerByLobbyId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAllAgentPlayerByLobbyId(xhr: any): PlayerItem[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerItem[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlayerItem.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getAllByPlayerId(playerId: number, languageId: number): Promise<PlayerItem> {
        return new Promise<PlayerItem>((resolve, reject) => {
            this.getAllByPlayerIdWithCallbacks(playerId, languageId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllByPlayerIdWithCallbacks(playerId: number, languageId: number, onSuccess?: (result: PlayerItem) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/GetAllByPlayerId?";
        if (playerId === undefined || playerId === null)
            throw new Error("The parameter 'playerId' must be defined and cannot be null.");
        else
            url_ += "playerId=" + encodeURIComponent("" + playerId) + "&"; 
        
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllByPlayerIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllByPlayerIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllByPlayerIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAllByPlayerId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAllByPlayerId(xhr: any): PlayerItem {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerItem = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PlayerItem.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForPlayerEdit(lobbyId: number, playerId: number, language: LanguageCode): Promise<GetForPlayerEditResponse> {
        return new Promise<GetForPlayerEditResponse>((resolve, reject) => {
            this.getForPlayerEditWithCallbacks(lobbyId, playerId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForPlayerEditWithCallbacks(lobbyId: number, playerId: number, language: LanguageCode, onSuccess?: (result: GetForPlayerEditResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/GetForPlayerEdit?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (playerId === undefined || playerId === null)
            throw new Error("The parameter 'playerId' must be defined and cannot be null.");
        else
            url_ += "playerId=" + encodeURIComponent("" + playerId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForPlayerEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForPlayerEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForPlayerEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForPlayerEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForPlayerEdit(xhr: any): GetForPlayerEditResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: GetForPlayerEditResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetForPlayerEditResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getLobbyPlayerLevelLanguageByLanguageId(lobbyId: number, languageId: number): Promise<LobbyPlayerLevelLanguageResponse[]> {
        return new Promise<LobbyPlayerLevelLanguageResponse[]>((resolve, reject) => {
            this.getLobbyPlayerLevelLanguageByLanguageIdWithCallbacks(lobbyId, languageId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getLobbyPlayerLevelLanguageByLanguageIdWithCallbacks(lobbyId: number, languageId: number, onSuccess?: (result: LobbyPlayerLevelLanguageResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/GetLobbyPlayerLevelLanguageByLanguageId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetLobbyPlayerLevelLanguageByLanguageIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetLobbyPlayerLevelLanguageByLanguageIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetLobbyPlayerLevelLanguageByLanguageIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetLobbyPlayerLevelLanguageByLanguageId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetLobbyPlayerLevelLanguageByLanguageId(xhr: any): LobbyPlayerLevelLanguageResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyPlayerLevelLanguageResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyPlayerLevelLanguageResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getLobbyPlayerGroupLanguageByLanguageId(lobbyId: number): Promise<LobbyPlayerGroupResponse[]> {
        return new Promise<LobbyPlayerGroupResponse[]>((resolve, reject) => {
            this.getLobbyPlayerGroupLanguageByLanguageIdWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getLobbyPlayerGroupLanguageByLanguageIdWithCallbacks(lobbyId: number, onSuccess?: (result: LobbyPlayerGroupResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/GetLobbyPlayerGroupLanguageByLanguageId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetLobbyPlayerGroupLanguageByLanguageIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetLobbyPlayerGroupLanguageByLanguageIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetLobbyPlayerGroupLanguageByLanguageIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetLobbyPlayerGroupLanguageByLanguageId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetLobbyPlayerGroupLanguageByLanguageId(xhr: any): LobbyPlayerGroupResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbyPlayerGroupResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbyPlayerGroupResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    editPlayer(request: EditPlayerRequest, lobbyId: number): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.editPlayerWithCallbacks(request, lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editPlayerWithCallbacks(request: EditPlayerRequest, lobbyId: number, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/EditPlayer?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditPlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditPlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditPlayerWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEditPlayer(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEditPlayer(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    setEnableLogin(request: PlayerSetEnableLoginRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.setEnableLoginWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private setEnableLoginWithCallbacks(request: PlayerSetEnableLoginRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/setEnableLogin";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSetEnableLoginWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetEnableLoginWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSetEnableLoginWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetEnableLogin(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetEnableLogin(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    setEnablePlay(request: PlayerSetEnablePlayRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.setEnablePlayWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private setEnablePlayWithCallbacks(request: PlayerSetEnablePlayRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/setEnablePlay";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSetEnablePlayWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetEnablePlayWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSetEnablePlayWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetEnablePlay(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetEnablePlay(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    resetPlayerAutoPasswordBySendSms(request: ResetPlayerAutoPasswordRequest): Promise<SendSMSResult> {
        return new Promise<SendSMSResult>((resolve, reject) => {
            this.resetPlayerAutoPasswordBySendSmsWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private resetPlayerAutoPasswordBySendSmsWithCallbacks(request: ResetPlayerAutoPasswordRequest, onSuccess?: (result: SendSMSResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/ResetPlayerAutoPasswordBySendSms";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processResetPlayerAutoPasswordBySendSmsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processResetPlayerAutoPasswordBySendSmsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processResetPlayerAutoPasswordBySendSmsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processResetPlayerAutoPasswordBySendSms(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processResetPlayerAutoPasswordBySendSms(xhr: any): SendSMSResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: SendSMSResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? SendSMSResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    resetPlayerAutoPasswordBySendEmail(request: ResetPlayerAutoPasswordRequest): Promise<SendEmailResult> {
        return new Promise<SendEmailResult>((resolve, reject) => {
            this.resetPlayerAutoPasswordBySendEmailWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private resetPlayerAutoPasswordBySendEmailWithCallbacks(request: ResetPlayerAutoPasswordRequest, onSuccess?: (result: SendEmailResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/ResetPlayerAutoPasswordBySendEmail";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processResetPlayerAutoPasswordBySendEmailWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processResetPlayerAutoPasswordBySendEmailWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processResetPlayerAutoPasswordBySendEmailWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processResetPlayerAutoPasswordBySendEmail(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processResetPlayerAutoPasswordBySendEmail(xhr: any): SendEmailResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: SendEmailResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? SendEmailResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    resetPlayerManualPassword(request: ResetPlayerManualPasswordRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.resetPlayerManualPasswordWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private resetPlayerManualPasswordWithCallbacks(request: ResetPlayerManualPasswordRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/ResetPlayerManualPassword";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processResetPlayerManualPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processResetPlayerManualPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processResetPlayerManualPasswordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processResetPlayerManualPassword(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processResetPlayerManualPassword(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    resetPlayerAutoPassword(request: ResetPlayerAutoPasswordRequest): Promise<ResetPlayerAutoPasswordRespone> {
        return new Promise<ResetPlayerAutoPasswordRespone>((resolve, reject) => {
            this.resetPlayerAutoPasswordWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private resetPlayerAutoPasswordWithCallbacks(request: ResetPlayerAutoPasswordRequest, onSuccess?: (result: ResetPlayerAutoPasswordRespone) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/ResetPlayerAutoPassword";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processResetPlayerAutoPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processResetPlayerAutoPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processResetPlayerAutoPasswordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processResetPlayerAutoPassword(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processResetPlayerAutoPassword(xhr: any): ResetPlayerAutoPasswordRespone {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: ResetPlayerAutoPasswordRespone = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResetPlayerAutoPasswordRespone.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    resetWithdrawAutoPasswordBySendSms(request: ResetWithdrawAutoPasswordRequest): Promise<SendSMSResult> {
        return new Promise<SendSMSResult>((resolve, reject) => {
            this.resetWithdrawAutoPasswordBySendSmsWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private resetWithdrawAutoPasswordBySendSmsWithCallbacks(request: ResetWithdrawAutoPasswordRequest, onSuccess?: (result: SendSMSResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/ResetWithdrawAutoPasswordBySendSms";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processResetWithdrawAutoPasswordBySendSmsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processResetWithdrawAutoPasswordBySendSmsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processResetWithdrawAutoPasswordBySendSmsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processResetWithdrawAutoPasswordBySendSms(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processResetWithdrawAutoPasswordBySendSms(xhr: any): SendSMSResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: SendSMSResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? SendSMSResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    resetWithdrawAutoPasswordBySendEmail(request: ResetWithdrawAutoPasswordRequest): Promise<SendEmailResult> {
        return new Promise<SendEmailResult>((resolve, reject) => {
            this.resetWithdrawAutoPasswordBySendEmailWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private resetWithdrawAutoPasswordBySendEmailWithCallbacks(request: ResetWithdrawAutoPasswordRequest, onSuccess?: (result: SendEmailResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/ResetWithdrawAutoPasswordBySendEmail";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processResetWithdrawAutoPasswordBySendEmailWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processResetWithdrawAutoPasswordBySendEmailWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processResetWithdrawAutoPasswordBySendEmailWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processResetWithdrawAutoPasswordBySendEmail(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processResetWithdrawAutoPasswordBySendEmail(xhr: any): SendEmailResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: SendEmailResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? SendEmailResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    resetWithdrawManualPassword(request: ResetWithdrawManualPasswordRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.resetWithdrawManualPasswordWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private resetWithdrawManualPasswordWithCallbacks(request: ResetWithdrawManualPasswordRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/ResetWithdrawManualPassword";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processResetWithdrawManualPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processResetWithdrawManualPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processResetWithdrawManualPasswordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processResetWithdrawManualPassword(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processResetWithdrawManualPassword(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    resetWithdrawAutoPassword(request: ResetWithdrawAutoPasswordRequest): Promise<ResetWithdrawAutoPasswordRespone> {
        return new Promise<ResetWithdrawAutoPasswordRespone>((resolve, reject) => {
            this.resetWithdrawAutoPasswordWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private resetWithdrawAutoPasswordWithCallbacks(request: ResetWithdrawAutoPasswordRequest, onSuccess?: (result: ResetWithdrawAutoPasswordRespone) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/ResetWithdrawAutoPassword";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processResetWithdrawAutoPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processResetWithdrawAutoPasswordWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processResetWithdrawAutoPasswordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processResetWithdrawAutoPassword(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processResetWithdrawAutoPassword(xhr: any): ResetWithdrawAutoPasswordRespone {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: ResetWithdrawAutoPasswordRespone = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResetWithdrawAutoPasswordRespone.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    isEmailExistsExcludeUser(lobbyId: number, email: string, playerId: number): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.isEmailExistsExcludeUserWithCallbacks(lobbyId, email, playerId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private isEmailExistsExcludeUserWithCallbacks(lobbyId: number, email: string, playerId: number, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/IsEmailExistsExcludeUser?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (email === undefined)
            throw new Error("The parameter 'email' must be defined.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        
        if (playerId === undefined || playerId === null)
            throw new Error("The parameter 'playerId' must be defined and cannot be null.");
        else
            url_ += "playerId=" + encodeURIComponent("" + playerId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processIsEmailExistsExcludeUserWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processIsEmailExistsExcludeUserWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processIsEmailExistsExcludeUserWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processIsEmailExistsExcludeUser(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processIsEmailExistsExcludeUser(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    isPhoneNumberExistsExcludeUser(request: PlayerIsPhoneNumberExistsExcludeUserRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.isPhoneNumberExistsExcludeUserWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private isPhoneNumberExistsExcludeUserWithCallbacks(request: PlayerIsPhoneNumberExistsExcludeUserRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/IsPhoneNumberExistsExcludeUser";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processIsPhoneNumberExistsExcludeUserWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processIsPhoneNumberExistsExcludeUserWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processIsPhoneNumberExistsExcludeUserWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processIsPhoneNumberExistsExcludeUser(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processIsPhoneNumberExistsExcludeUser(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getLoginLogByUsernameAndDate(request: PlayerGetLoginLogByUserIdAndDateRequest): Promise<PlayerGetLoginLogByUserIdAndDateResponse[]> {
        return new Promise<PlayerGetLoginLogByUserIdAndDateResponse[]>((resolve, reject) => {
            this.getLoginLogByUsernameAndDateWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getLoginLogByUsernameAndDateWithCallbacks(request: PlayerGetLoginLogByUserIdAndDateRequest, onSuccess?: (result: PlayerGetLoginLogByUserIdAndDateResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/GetLoginLogByUsernameAndDate";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetLoginLogByUsernameAndDateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetLoginLogByUsernameAndDateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetLoginLogByUsernameAndDateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetLoginLogByUsernameAndDate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetLoginLogByUsernameAndDate(xhr: any): PlayerGetLoginLogByUserIdAndDateResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerGetLoginLogByUserIdAndDateResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlayerGetLoginLogByUserIdAndDateResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getLoginLog(request: PlayerGetLoginLogRequest): Promise<PlayerGetLoginLogResponse[]> {
        return new Promise<PlayerGetLoginLogResponse[]>((resolve, reject) => {
            this.getLoginLogWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getLoginLogWithCallbacks(request: PlayerGetLoginLogRequest, onSuccess?: (result: PlayerGetLoginLogResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/GetLoginLog";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetLoginLogWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetLoginLogWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetLoginLogWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetLoginLog(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetLoginLog(xhr: any): PlayerGetLoginLogResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerGetLoginLogResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlayerGetLoginLogResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    batchUpdatePlayerLobbyPlayerLevelGroup(request: BatchUpdatePlayerLobbyPlayerLevelGroupRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.batchUpdatePlayerLobbyPlayerLevelGroupWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private batchUpdatePlayerLobbyPlayerLevelGroupWithCallbacks(request: BatchUpdatePlayerLobbyPlayerLevelGroupRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/BatchUpdatePlayerLobbyPlayerLevelGroup";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processBatchUpdatePlayerLobbyPlayerLevelGroupWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processBatchUpdatePlayerLobbyPlayerLevelGroupWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processBatchUpdatePlayerLobbyPlayerLevelGroupWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processBatchUpdatePlayerLobbyPlayerLevelGroup(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processBatchUpdatePlayerLobbyPlayerLevelGroup(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getPhoneNumber(playerId: number): Promise<GetPhoneNumberRespone> {
        return new Promise<GetPhoneNumberRespone>((resolve, reject) => {
            this.getPhoneNumberWithCallbacks(playerId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getPhoneNumberWithCallbacks(playerId: number, onSuccess?: (result: GetPhoneNumberRespone) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/GetPhoneNumber?";
        if (playerId === undefined || playerId === null)
            throw new Error("The parameter 'playerId' must be defined and cannot be null.");
        else
            url_ += "playerId=" + encodeURIComponent("" + playerId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetPhoneNumberWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetPhoneNumberWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetPhoneNumberWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetPhoneNumber(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetPhoneNumber(xhr: any): GetPhoneNumberRespone {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: GetPhoneNumberRespone = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetPhoneNumberRespone.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    importPlayerGroup(fileParameterForGenerateApi: FileParameter, lobbyId: number): Promise<ImportPlayerGroup_Response> {
        return new Promise<ImportPlayerGroup_Response>((resolve, reject) => {
            this.importPlayerGroupWithCallbacks(fileParameterForGenerateApi, lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private importPlayerGroupWithCallbacks(fileParameterForGenerateApi: FileParameter, lobbyId: number, onSuccess?: (result: ImportPlayerGroup_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/ImportPlayerGroup?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = new FormData();
        if (fileParameterForGenerateApi !== null)
            content_.append("fileParameterForGenerateApi", fileParameterForGenerateApi.data, fileParameterForGenerateApi.fileName ? fileParameterForGenerateApi.fileName : "fileParameterForGenerateApi");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            processData: false,
            contentType: false,
            headers: {
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken'), 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId()
 
            }
        }).done((data, textStatus, xhr) => {
            this.processImportPlayerGroupWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processImportPlayerGroupWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processImportPlayerGroupWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processImportPlayerGroup(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processImportPlayerGroup(xhr: any): ImportPlayerGroup_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: ImportPlayerGroup_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? ImportPlayerGroup_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    createPlayer(request: CreatePlayerRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.createPlayerWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createPlayerWithCallbacks(request: CreatePlayerRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/CreatePlayer";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreatePlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreatePlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreatePlayerWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreatePlayer(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreatePlayer(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    createPlayerWithPhoneNumber(fileParameterForGenerateApi: FileParameter, prefix: string, password: string, agentCode: string, lobbyPlayerLevelId: number, lobbyPlayerGroupId: number, remark: string): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.createPlayerWithPhoneNumberWithCallbacks(fileParameterForGenerateApi, prefix, password, agentCode, lobbyPlayerLevelId, lobbyPlayerGroupId, remark, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createPlayerWithPhoneNumberWithCallbacks(fileParameterForGenerateApi: FileParameter, prefix: string, password: string, agentCode: string, lobbyPlayerLevelId: number, lobbyPlayerGroupId: number, remark: string, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/CreatePlayerWithPhoneNumber?";
        if (prefix === undefined)
            throw new Error("The parameter 'prefix' must be defined.");
        else
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&"; 
        
        if (password === undefined)
            throw new Error("The parameter 'password' must be defined.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&"; 
        
        if (agentCode === undefined)
            throw new Error("The parameter 'agentCode' must be defined.");
        else
            url_ += "agentCode=" + encodeURIComponent("" + agentCode) + "&"; 
        
        if (lobbyPlayerLevelId === undefined || lobbyPlayerLevelId === null)
            throw new Error("The parameter 'lobbyPlayerLevelId' must be defined and cannot be null.");
        else
            url_ += "lobbyPlayerLevelId=" + encodeURIComponent("" + lobbyPlayerLevelId) + "&"; 
        
        if (lobbyPlayerGroupId === undefined || lobbyPlayerGroupId === null)
            throw new Error("The parameter 'lobbyPlayerGroupId' must be defined and cannot be null.");
        else
            url_ += "lobbyPlayerGroupId=" + encodeURIComponent("" + lobbyPlayerGroupId) + "&"; 
        
        if (remark === undefined)
            throw new Error("The parameter 'remark' must be defined.");
        else
            url_ += "remark=" + encodeURIComponent("" + remark) + "&";

        const content_ = new FormData();
        if (fileParameterForGenerateApi !== null)
            content_.append("fileParameterForGenerateApi", fileParameterForGenerateApi.data, fileParameterForGenerateApi.fileName ? fileParameterForGenerateApi.fileName : "fileParameterForGenerateApi");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            processData: false,
            contentType: false,
            headers: {
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken'), 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId()
 
            }
        }).done((data, textStatus, xhr) => {
            this.processCreatePlayerWithPhoneNumberWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreatePlayerWithPhoneNumberWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreatePlayerWithPhoneNumberWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreatePlayerWithPhoneNumber(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreatePlayerWithPhoneNumber(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getPlayerTotalDepositAndWithdrawAmount(request: GetPlayerTotalDepositAndWithdrawAmountRequest): Promise<StandardResponseOfGetPlayerTotalDepositAndWithdrawAmountResponse> {
        return new Promise<StandardResponseOfGetPlayerTotalDepositAndWithdrawAmountResponse>((resolve, reject) => {
            this.getPlayerTotalDepositAndWithdrawAmountWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getPlayerTotalDepositAndWithdrawAmountWithCallbacks(request: GetPlayerTotalDepositAndWithdrawAmountRequest, onSuccess?: (result: StandardResponseOfGetPlayerTotalDepositAndWithdrawAmountResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/GetPlayerTotalDepositAndWithdrawAmount";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetPlayerTotalDepositAndWithdrawAmountWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetPlayerTotalDepositAndWithdrawAmountWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetPlayerTotalDepositAndWithdrawAmountWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetPlayerTotalDepositAndWithdrawAmount(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetPlayerTotalDepositAndWithdrawAmount(xhr: any): StandardResponseOfGetPlayerTotalDepositAndWithdrawAmountResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfGetPlayerTotalDepositAndWithdrawAmountResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfGetPlayerTotalDepositAndWithdrawAmountResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getAllPlayerListReportUrl(): Promise<StandardResponseOfGetAllPlayerListReportUrlResponse> {
        return new Promise<StandardResponseOfGetAllPlayerListReportUrlResponse>((resolve, reject) => {
            this.getAllPlayerListReportUrlWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllPlayerListReportUrlWithCallbacks(onSuccess?: (result: StandardResponseOfGetAllPlayerListReportUrlResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Player/GetAllPlayerListReportUrl";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllPlayerListReportUrlWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllPlayerListReportUrlWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllPlayerListReportUrlWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAllPlayerListReportUrl(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAllPlayerListReportUrl(xhr: any): StandardResponseOfGetAllPlayerListReportUrlResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfGetAllPlayerListReportUrlResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfGetAllPlayerListReportUrlResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PlayerCryptocurrencyAddressApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    create(request: PCCA_Create_Request): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.createWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createWithCallbacks(request: PCCA_Create_Request, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerCryptocurrencyAddress/Create";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreate(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    delete(request: PCCA_Delete_Request): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.deleteWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private deleteWithCallbacks(request: PCCA_Delete_Request, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerCryptocurrencyAddress/Delete";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDeleteWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDelete(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDelete(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PlayerDepositApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAddPointsRecordByDateRange(request: DepositGetAddPointsRecordByDateRangeRequest): Promise<GetAddPointsRecordByDateRangeResponse> {
        return new Promise<GetAddPointsRecordByDateRangeResponse>((resolve, reject) => {
            this.getAddPointsRecordByDateRangeWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAddPointsRecordByDateRangeWithCallbacks(request: DepositGetAddPointsRecordByDateRangeRequest, onSuccess?: (result: GetAddPointsRecordByDateRangeResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/GetAddPointsRecordByDateRange";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAddPointsRecordByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAddPointsRecordByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAddPointsRecordByDateRangeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAddPointsRecordByDateRange(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAddPointsRecordByDateRange(xhr: any): GetAddPointsRecordByDateRangeResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: GetAddPointsRecordByDateRangeResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetAddPointsRecordByDateRangeResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getBankTransferRecordByDateRangeWithLobbyAgentId(request: GetBankTransferRecordByDateRangeWithLobbyAgentIdRequest): Promise<DepositGetByDateRangeResponse[]> {
        return new Promise<DepositGetByDateRangeResponse[]>((resolve, reject) => {
            this.getBankTransferRecordByDateRangeWithLobbyAgentIdWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getBankTransferRecordByDateRangeWithLobbyAgentIdWithCallbacks(request: GetBankTransferRecordByDateRangeWithLobbyAgentIdRequest, onSuccess?: (result: DepositGetByDateRangeResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/GetBankTransferRecordByDateRangeWithLobbyAgentId";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetBankTransferRecordByDateRangeWithLobbyAgentIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetBankTransferRecordByDateRangeWithLobbyAgentIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetBankTransferRecordByDateRangeWithLobbyAgentIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetBankTransferRecordByDateRangeWithLobbyAgentId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetBankTransferRecordByDateRangeWithLobbyAgentId(xhr: any): DepositGetByDateRangeResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: DepositGetByDateRangeResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DepositGetByDateRangeResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    manualDepositGetByDateRange(request: ManualDepositGetByDateRangeRequest): Promise<DepositGetByDateRangeResponse[]> {
        return new Promise<DepositGetByDateRangeResponse[]>((resolve, reject) => {
            this.manualDepositGetByDateRangeWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private manualDepositGetByDateRangeWithCallbacks(request: ManualDepositGetByDateRangeRequest, onSuccess?: (result: DepositGetByDateRangeResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/ManualDepositGetByDateRange";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processManualDepositGetByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processManualDepositGetByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processManualDepositGetByDateRangeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processManualDepositGetByDateRange(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processManualDepositGetByDateRange(xhr: any): DepositGetByDateRangeResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: DepositGetByDateRangeResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DepositGetByDateRangeResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    digitalWalletDepositGetByDateRange(request: ManualDepositGetByDateRangeRequest): Promise<DepositGetByDateRangeResponse[]> {
        return new Promise<DepositGetByDateRangeResponse[]>((resolve, reject) => {
            this.digitalWalletDepositGetByDateRangeWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private digitalWalletDepositGetByDateRangeWithCallbacks(request: ManualDepositGetByDateRangeRequest, onSuccess?: (result: DepositGetByDateRangeResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/DigitalWalletDepositGetByDateRange";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDigitalWalletDepositGetByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDigitalWalletDepositGetByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDigitalWalletDepositGetByDateRangeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDigitalWalletDepositGetByDateRange(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDigitalWalletDepositGetByDateRange(xhr: any): DepositGetByDateRangeResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: DepositGetByDateRangeResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DepositGetByDateRangeResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    manualAlipayGetByDateRange(request: ManualDepositGetByDateRangeRequest): Promise<DepositGetByDateRangeResponse[]> {
        return new Promise<DepositGetByDateRangeResponse[]>((resolve, reject) => {
            this.manualAlipayGetByDateRangeWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private manualAlipayGetByDateRangeWithCallbacks(request: ManualDepositGetByDateRangeRequest, onSuccess?: (result: DepositGetByDateRangeResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/ManualAlipayGetByDateRange";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processManualAlipayGetByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processManualAlipayGetByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processManualAlipayGetByDateRangeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processManualAlipayGetByDateRange(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processManualAlipayGetByDateRange(xhr: any): DepositGetByDateRangeResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: DepositGetByDateRangeResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(DepositGetByDateRangeResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getById(id: number, language: LanguageCode): Promise<DepositGetByDateRangeResponse> {
        return new Promise<DepositGetByDateRangeResponse>((resolve, reject) => {
            this.getByIdWithCallbacks(id, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByIdWithCallbacks(id: number, language: LanguageCode, onSuccess?: (result: DepositGetByDateRangeResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/GetById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetById(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetById(xhr: any): DepositGetByDateRangeResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: DepositGetByDateRangeResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? DepositGetByDateRangeResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getByTranscationNo(transactionNo: string, language: LanguageCode, lobbyId: number): Promise<DepositGetByDateRangeResponse> {
        return new Promise<DepositGetByDateRangeResponse>((resolve, reject) => {
            this.getByTranscationNoWithCallbacks(transactionNo, language, lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByTranscationNoWithCallbacks(transactionNo: string, language: LanguageCode, lobbyId: number, onSuccess?: (result: DepositGetByDateRangeResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/GetByTranscationNo?";
        if (transactionNo === undefined)
            throw new Error("The parameter 'transactionNo' must be defined.");
        else
            url_ += "transactionNo=" + encodeURIComponent("" + transactionNo) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&"; 
        
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByTranscationNoWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByTranscationNoWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByTranscationNoWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByTranscationNo(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByTranscationNo(xhr: any): DepositGetByDateRangeResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: DepositGetByDateRangeResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? DepositGetByDateRangeResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForAgentById(id: number, language: LanguageCode): Promise<DepositGetByDateRangeResponse> {
        return new Promise<DepositGetByDateRangeResponse>((resolve, reject) => {
            this.getForAgentByIdWithCallbacks(id, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForAgentByIdWithCallbacks(id: number, language: LanguageCode, onSuccess?: (result: DepositGetByDateRangeResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/GetForAgentById?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForAgentByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForAgentByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForAgentByIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForAgentById(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForAgentById(xhr: any): DepositGetByDateRangeResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: DepositGetByDateRangeResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? DepositGetByDateRangeResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForSections(lobbyId: number, language: LanguageCode): Promise<DepositGetForSectionsResponse> {
        return new Promise<DepositGetForSectionsResponse>((resolve, reject) => {
            this.getForSectionsWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForSectionsWithCallbacks(lobbyId: number, language: LanguageCode, onSuccess?: (result: DepositGetForSectionsResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/GetForSections?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForSectionsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForSectionsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForSectionsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForSections(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForSections(xhr: any): DepositGetForSectionsResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: DepositGetForSectionsResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? DepositGetForSectionsResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    approve(id: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.approveWithCallbacks(id, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private approveWithCallbacks(id: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/Approve?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processApproveWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processApproveWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processApproveWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processApprove(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processApprove(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    approvePromotion(id: number, amount: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.approvePromotionWithCallbacks(id, amount, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private approvePromotionWithCallbacks(id: number, amount: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/ApprovePromotion?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        
        if (amount === undefined || amount === null)
            throw new Error("The parameter 'amount' must be defined and cannot be null.");
        else
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processApprovePromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processApprovePromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processApprovePromotionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processApprovePromotion(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processApprovePromotion(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    reject(request: DepositRejectRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.rejectWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private rejectWithCallbacks(request: DepositRejectRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/Reject";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processRejectWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processRejectWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processRejectWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processReject(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processReject(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    rejectPromotion(request: PromotionRejectRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.rejectPromotionWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private rejectPromotionWithCallbacks(request: PromotionRejectRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/RejectPromotion";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processRejectPromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processRejectPromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processRejectPromotionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processRejectPromotion(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processRejectPromotion(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    depositFormGetFormData(lobbyId: number, language: LanguageCode): Promise<DepositFormGetFormDataResponse> {
        return new Promise<DepositFormGetFormDataResponse>((resolve, reject) => {
            this.depositFormGetFormDataWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private depositFormGetFormDataWithCallbacks(lobbyId: number, language: LanguageCode, onSuccess?: (result: DepositFormGetFormDataResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/DepositFormGetFormData?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDepositFormGetFormDataWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDepositFormGetFormDataWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDepositFormGetFormDataWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDepositFormGetFormData(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDepositFormGetFormData(xhr: any): DepositFormGetFormDataResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: DepositFormGetFormDataResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? DepositFormGetFormDataResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    createByAdmin(request: DepositByAdminSubmitRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.createByAdminWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createByAdminWithCallbacks(request: DepositByAdminSubmitRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/CreateByAdmin";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateByAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateByAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateByAdminWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreateByAdmin(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreateByAdmin(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    createPointsByAdmin(request: DepositByAdminSubmitRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.createPointsByAdminWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createPointsByAdminWithCallbacks(request: DepositByAdminSubmitRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/CreatePointsByAdmin";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreatePointsByAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreatePointsByAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreatePointsByAdminWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreatePointsByAdmin(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreatePointsByAdmin(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    createPointsToBlukPlayerByAdmin(fileParameterForGenerateApi: FileParameter): Promise<StandardResultOfCreatePointsToBlukPlayerByAdminResponse> {
        return new Promise<StandardResultOfCreatePointsToBlukPlayerByAdminResponse>((resolve, reject) => {
            this.createPointsToBlukPlayerByAdminWithCallbacks(fileParameterForGenerateApi, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createPointsToBlukPlayerByAdminWithCallbacks(fileParameterForGenerateApi: FileParameter, onSuccess?: (result: StandardResultOfCreatePointsToBlukPlayerByAdminResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/CreatePointsToBlukPlayerByAdmin";

        const content_ = new FormData();
        if (fileParameterForGenerateApi !== null)
            content_.append("fileParameterForGenerateApi", fileParameterForGenerateApi.data, fileParameterForGenerateApi.fileName ? fileParameterForGenerateApi.fileName : "fileParameterForGenerateApi");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            processData: false,
            contentType: false,
            headers: {
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken'), 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId()
 
            }
        }).done((data, textStatus, xhr) => {
            this.processCreatePointsToBlukPlayerByAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreatePointsToBlukPlayerByAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreatePointsToBlukPlayerByAdminWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreatePointsToBlukPlayerByAdmin(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreatePointsToBlukPlayerByAdmin(xhr: any): StandardResultOfCreatePointsToBlukPlayerByAdminResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResultOfCreatePointsToBlukPlayerByAdminResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResultOfCreatePointsToBlukPlayerByAdminResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    createBankTransferByAdmin(request: CreateBankTransferByAdminRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.createBankTransferByAdminWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createBankTransferByAdminWithCallbacks(request: CreateBankTransferByAdminRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/CreateBankTransferByAdmin";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateBankTransferByAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateBankTransferByAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateBankTransferByAdminWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreateBankTransferByAdmin(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreateBankTransferByAdmin(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    completeEvent(request: EventCompleteRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.completeEventWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private completeEventWithCallbacks(request: EventCompleteRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/CompleteEvent";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCompleteEventWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCompleteEventWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCompleteEventWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCompleteEvent(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCompleteEvent(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    cancelEvent(request: EventCancelRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.cancelEventWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private cancelEventWithCallbacks(request: EventCancelRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/CancelEvent";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCancelEventWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCancelEventWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCancelEventWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCancelEvent(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCancelEvent(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    settleAutoPromotion(request: SettleAutoPromotionRequest): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.settleAutoPromotionWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private settleAutoPromotionWithCallbacks(request: SettleAutoPromotionRequest, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/SettleAutoPromotion";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSettleAutoPromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSettleAutoPromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSettleAutoPromotionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSettleAutoPromotion(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSettleAutoPromotion(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    cancelAutoPromotion(request: CancelAutoPromotionRequest): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.cancelAutoPromotionWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private cancelAutoPromotionWithCallbacks(request: CancelAutoPromotionRequest, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/CancelAutoPromotion";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCancelAutoPromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCancelAutoPromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCancelAutoPromotionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCancelAutoPromotion(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCancelAutoPromotion(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    checkPlayerEnoughTurnoverForDeposit(request: CheckPlayerEnoughTurnoverRequest): Promise<StandardResultOfCheckPlayerEnoughTurnoverForDepositResponse> {
        return new Promise<StandardResultOfCheckPlayerEnoughTurnoverForDepositResponse>((resolve, reject) => {
            this.checkPlayerEnoughTurnoverForDepositWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private checkPlayerEnoughTurnoverForDepositWithCallbacks(request: CheckPlayerEnoughTurnoverRequest, onSuccess?: (result: StandardResultOfCheckPlayerEnoughTurnoverForDepositResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/CheckPlayerEnoughTurnoverForDeposit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCheckPlayerEnoughTurnoverForDepositWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCheckPlayerEnoughTurnoverForDepositWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCheckPlayerEnoughTurnoverForDepositWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCheckPlayerEnoughTurnoverForDeposit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCheckPlayerEnoughTurnoverForDeposit(xhr: any): StandardResultOfCheckPlayerEnoughTurnoverForDepositResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResultOfCheckPlayerEnoughTurnoverForDepositResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResultOfCheckPlayerEnoughTurnoverForDepositResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    checkPlayerEnoughTurnoverForAutoPromotion(request: CheckPlayerEnoughTurnoverRequest): Promise<StandardResultOfCheckPlayerEnoughTurnoverForAutoPromotionResponse> {
        return new Promise<StandardResultOfCheckPlayerEnoughTurnoverForAutoPromotionResponse>((resolve, reject) => {
            this.checkPlayerEnoughTurnoverForAutoPromotionWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private checkPlayerEnoughTurnoverForAutoPromotionWithCallbacks(request: CheckPlayerEnoughTurnoverRequest, onSuccess?: (result: StandardResultOfCheckPlayerEnoughTurnoverForAutoPromotionResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/CheckPlayerEnoughTurnoverForAutoPromotion";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCheckPlayerEnoughTurnoverForAutoPromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCheckPlayerEnoughTurnoverForAutoPromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCheckPlayerEnoughTurnoverForAutoPromotionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCheckPlayerEnoughTurnoverForAutoPromotion(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCheckPlayerEnoughTurnoverForAutoPromotion(xhr: any): StandardResultOfCheckPlayerEnoughTurnoverForAutoPromotionResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResultOfCheckPlayerEnoughTurnoverForAutoPromotionResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResultOfCheckPlayerEnoughTurnoverForAutoPromotionResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    addManualDepositByAddmin(request: AddManualDepositByAddmin_Request): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.addManualDepositByAddminWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addManualDepositByAddminWithCallbacks(request: AddManualDepositByAddmin_Request, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/AddManualDepositByAddmin";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAddManualDepositByAddminWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddManualDepositByAddminWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddManualDepositByAddminWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAddManualDepositByAddmin(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAddManualDepositByAddmin(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    addDigitalDepositByAddmin(request: AddDigitalDepositByAddmin_Request): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.addDigitalDepositByAddminWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addDigitalDepositByAddminWithCallbacks(request: AddDigitalDepositByAddmin_Request, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDeposit/AddDigitalDepositByAddmin";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAddDigitalDepositByAddminWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddDigitalDepositByAddminWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddDigitalDepositByAddminWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAddDigitalDepositByAddmin(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAddDigitalDepositByAddmin(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PlayerDepositOnlinePaymentApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getByDateRange(request: DepositOnlineGetByDateRangeRequest): Promise<PlayerDepositOnlinePaymentResponse[]> {
        return new Promise<PlayerDepositOnlinePaymentResponse[]>((resolve, reject) => {
            this.getByDateRangeWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByDateRangeWithCallbacks(request: DepositOnlineGetByDateRangeRequest, onSuccess?: (result: PlayerDepositOnlinePaymentResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDepositOnlinePayment/GetByDateRange";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByDateRangeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByDateRange(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByDateRange(xhr: any): PlayerDepositOnlinePaymentResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerDepositOnlinePaymentResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlayerDepositOnlinePaymentResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForSections(lobbyId: number, language: LanguageCode): Promise<DepositOnlinePaymentGetForSectionsResponse> {
        return new Promise<DepositOnlinePaymentGetForSectionsResponse>((resolve, reject) => {
            this.getForSectionsWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForSectionsWithCallbacks(lobbyId: number, language: LanguageCode, onSuccess?: (result: DepositOnlinePaymentGetForSectionsResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDepositOnlinePayment/GetForSections?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForSectionsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForSectionsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForSectionsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForSections(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForSections(xhr: any): DepositOnlinePaymentGetForSectionsResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: DepositOnlinePaymentGetForSectionsResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? DepositOnlinePaymentGetForSectionsResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getById(request: OnlinePaymentGetByIdRequest): Promise<PlayerDepositOnlinePaymentResponse> {
        return new Promise<PlayerDepositOnlinePaymentResponse>((resolve, reject) => {
            this.getByIdWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByIdWithCallbacks(request: OnlinePaymentGetByIdRequest, onSuccess?: (result: PlayerDepositOnlinePaymentResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDepositOnlinePayment/GetById";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetById(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetById(xhr: any): PlayerDepositOnlinePaymentResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerDepositOnlinePaymentResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PlayerDepositOnlinePaymentResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    checkOrderStatus(orderId: string, playerTransactionId: number): Promise<ProcessCheckOrderStatusResponse> {
        return new Promise<ProcessCheckOrderStatusResponse>((resolve, reject) => {
            this.checkOrderStatusWithCallbacks(orderId, playerTransactionId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private checkOrderStatusWithCallbacks(orderId: string, playerTransactionId: number, onSuccess?: (result: ProcessCheckOrderStatusResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDepositOnlinePayment/CheckOrderStatus?";
        if (orderId === undefined)
            throw new Error("The parameter 'orderId' must be defined.");
        else
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&"; 
        
        if (playerTransactionId === undefined || playerTransactionId === null)
            throw new Error("The parameter 'playerTransactionId' must be defined and cannot be null.");
        else
            url_ += "playerTransactionId=" + encodeURIComponent("" + playerTransactionId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCheckOrderStatusWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCheckOrderStatusWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCheckOrderStatusWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCheckOrderStatus(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCheckOrderStatus(xhr: any): ProcessCheckOrderStatusResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: ProcessCheckOrderStatusResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProcessCheckOrderStatusResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    approvePayment(request: PDOP_ApprovePaymentRequest): Promise<ProcessCheckOrderStatusResponse> {
        return new Promise<ProcessCheckOrderStatusResponse>((resolve, reject) => {
            this.approvePaymentWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private approvePaymentWithCallbacks(request: PDOP_ApprovePaymentRequest, onSuccess?: (result: ProcessCheckOrderStatusResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDepositOnlinePayment/ApprovePayment";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processApprovePaymentWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processApprovePaymentWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processApprovePaymentWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processApprovePayment(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processApprovePayment(xhr: any): ProcessCheckOrderStatusResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: ProcessCheckOrderStatusResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? ProcessCheckOrderStatusResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    addPaymentByAdmin(request: PDOP_AddPaymentByAdminRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.addPaymentByAdminWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addPaymentByAdminWithCallbacks(request: PDOP_AddPaymentByAdminRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDepositOnlinePayment/AddPaymentByAdmin";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAddPaymentByAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddPaymentByAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddPaymentByAdminWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAddPaymentByAdmin(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAddPaymentByAdmin(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForAdd(): Promise<StandardResponseOfOnlinePaymentGetForAddResponse> {
        return new Promise<StandardResponseOfOnlinePaymentGetForAddResponse>((resolve, reject) => {
            this.getForAddWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForAddWithCallbacks(onSuccess?: (result: StandardResponseOfOnlinePaymentGetForAddResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerDepositOnlinePayment/GetForAdd";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForAdd(xhr: any): StandardResponseOfOnlinePaymentGetForAddResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfOnlinePaymentGetForAddResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfOnlinePaymentGetForAddResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PlayerGameDevBlockApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getForCreate(request: GetForCreateRequest): Promise<GetForCreateResponse> {
        return new Promise<GetForCreateResponse>((resolve, reject) => {
            this.getForCreateWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForCreateWithCallbacks(request: GetForCreateRequest, onSuccess?: (result: GetForCreateResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerGameDevBlock/GetForCreate";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForCreateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForCreate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForCreate(xhr: any): GetForCreateResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: GetForCreateResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetForCreateResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    updatePlatformBehaviorStatus(request: UpdateBlockItemRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.updatePlatformBehaviorStatusWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private updatePlatformBehaviorStatusWithCallbacks(request: UpdateBlockItemRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerGameDevBlock/UpdatePlatformBehaviorStatus";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processUpdatePlatformBehaviorStatusWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdatePlatformBehaviorStatusWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdatePlatformBehaviorStatusWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdatePlatformBehaviorStatus(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdatePlatformBehaviorStatus(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PlayerGiftPointApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    playerGiftPointGetById(request: PlayerGiftPointGetByIdRequest): Promise<PlayerGiftPointItem> {
        return new Promise<PlayerGiftPointItem>((resolve, reject) => {
            this.playerGiftPointGetByIdWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerGiftPointGetByIdWithCallbacks(request: PlayerGiftPointGetByIdRequest, onSuccess?: (result: PlayerGiftPointItem) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerGiftPoint/PlayerGiftPointGetById";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerGiftPointGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerGiftPointGetByIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerGiftPointGetByIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerGiftPointGetById(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerGiftPointGetById(xhr: any): PlayerGiftPointItem {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerGiftPointItem = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PlayerGiftPointItem.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getByDateRange(request: PlayerGiftPointGetByDateRangeRequest): Promise<PlayerGiftPointListResponse> {
        return new Promise<PlayerGiftPointListResponse>((resolve, reject) => {
            this.getByDateRangeWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByDateRangeWithCallbacks(request: PlayerGiftPointGetByDateRangeRequest, onSuccess?: (result: PlayerGiftPointListResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerGiftPoint/GetByDateRange";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByDateRangeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByDateRange(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByDateRange(xhr: any): PlayerGiftPointListResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerGiftPointListResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PlayerGiftPointListResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerGiftPointGetByPlayerId(request: PlayerGiftPointGetByPlayerIdRequest): Promise<PlayerGiftPointGetByPlayerIdResponse> {
        return new Promise<PlayerGiftPointGetByPlayerIdResponse>((resolve, reject) => {
            this.playerGiftPointGetByPlayerIdWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerGiftPointGetByPlayerIdWithCallbacks(request: PlayerGiftPointGetByPlayerIdRequest, onSuccess?: (result: PlayerGiftPointGetByPlayerIdResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerGiftPoint/PlayerGiftPointGetByPlayerId";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerGiftPointGetByPlayerIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerGiftPointGetByPlayerIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerGiftPointGetByPlayerIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerGiftPointGetByPlayerId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerGiftPointGetByPlayerId(xhr: any): PlayerGiftPointGetByPlayerIdResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerGiftPointGetByPlayerIdResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PlayerGiftPointGetByPlayerIdResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerGiftPointAddPoint(request: PlayerGiftPointAddPointRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.playerGiftPointAddPointWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerGiftPointAddPointWithCallbacks(request: PlayerGiftPointAddPointRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerGiftPoint/PlayerGiftPointAddPoint";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerGiftPointAddPointWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerGiftPointAddPointWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerGiftPointAddPointWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerGiftPointAddPoint(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerGiftPointAddPoint(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerGiftPointDeducePoint(request: PlayerGiftPointDeducePointRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.playerGiftPointDeducePointWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerGiftPointDeducePointWithCallbacks(request: PlayerGiftPointDeducePointRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerGiftPoint/PlayerGiftPointDeducePoint";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerGiftPointDeducePointWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerGiftPointDeducePointWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerGiftPointDeducePointWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerGiftPointDeducePoint(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerGiftPointDeducePoint(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerGiftPointCreateRecord(request: PlayerGiftPointCreateRecordRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.playerGiftPointCreateRecordWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerGiftPointCreateRecordWithCallbacks(request: PlayerGiftPointCreateRecordRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerGiftPoint/PlayerGiftPointCreateRecord";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerGiftPointCreateRecordWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerGiftPointCreateRecordWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerGiftPointCreateRecordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerGiftPointCreateRecord(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerGiftPointCreateRecord(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerGiftPointRecordSettle(request: PlayerGiftPointRecordHandleRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.playerGiftPointRecordSettleWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerGiftPointRecordSettleWithCallbacks(request: PlayerGiftPointRecordHandleRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerGiftPoint/PlayerGiftPointRecordSettle";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerGiftPointRecordSettleWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerGiftPointRecordSettleWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerGiftPointRecordSettleWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerGiftPointRecordSettle(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerGiftPointRecordSettle(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerGiftPointRecordReject(request: PlayerGiftPointRecordHandleRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.playerGiftPointRecordRejectWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerGiftPointRecordRejectWithCallbacks(request: PlayerGiftPointRecordHandleRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerGiftPoint/PlayerGiftPointRecordReject";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerGiftPointRecordRejectWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerGiftPointRecordRejectWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerGiftPointRecordRejectWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerGiftPointRecordReject(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerGiftPointRecordReject(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerGiftPointGetNotCompleteCount(lobbyId: number): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            this.playerGiftPointGetNotCompleteCountWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerGiftPointGetNotCompleteCountWithCallbacks(lobbyId: number, onSuccess?: (result: number) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerGiftPoint/PlayerGiftPointGetNotCompleteCount?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerGiftPointGetNotCompleteCountWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerGiftPointGetNotCompleteCountWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerGiftPointGetNotCompleteCountWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerGiftPointGetNotCompleteCount(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerGiftPointGetNotCompleteCount(xhr: any): number {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: number = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    importFromExcel(fileParameterForGenerateApi: FileParameter, lobbyId: number): Promise<string[]> {
        return new Promise<string[]>((resolve, reject) => {
            this.importFromExcelWithCallbacks(fileParameterForGenerateApi, lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private importFromExcelWithCallbacks(fileParameterForGenerateApi: FileParameter, lobbyId: number, onSuccess?: (result: string[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerGiftPoint/ImportFromExcel?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = new FormData();
        if (fileParameterForGenerateApi !== null)
            content_.append("fileParameterForGenerateApi", fileParameterForGenerateApi.data, fileParameterForGenerateApi.fileName ? fileParameterForGenerateApi.fileName : "fileParameterForGenerateApi");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            processData: false,
            contentType: false,
            headers: {
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken'), 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId()
 
            }
        }).done((data, textStatus, xhr) => {
            this.processImportFromExcelWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processImportFromExcelWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processImportFromExcelWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processImportFromExcel(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processImportFromExcel(xhr: any): string[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: string[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PlayerPromoApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    createPlayerPromoCode(lobbyId: LobbyId, playerId: number): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.createPlayerPromoCodeWithCallbacks(lobbyId, playerId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createPlayerPromoCodeWithCallbacks(lobbyId: LobbyId, playerId: number, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerPromo/CreatePlayerPromoCode?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (playerId === undefined || playerId === null)
            throw new Error("The parameter 'playerId' must be defined and cannot be null.");
        else
            url_ += "playerId=" + encodeURIComponent("" + playerId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreatePlayerPromoCodeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreatePlayerPromoCodeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreatePlayerPromoCodeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreatePlayerPromoCode(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreatePlayerPromoCode(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PlayerPromotionApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    playerPromotionGetPlayerPromotion(request: PlayerPromotionGetPlayerPromotionRequest): Promise<PlayerPromotionGetPlayerPromotionResponse> {
        return new Promise<PlayerPromotionGetPlayerPromotionResponse>((resolve, reject) => {
            this.playerPromotionGetPlayerPromotionWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerPromotionGetPlayerPromotionWithCallbacks(request: PlayerPromotionGetPlayerPromotionRequest, onSuccess?: (result: PlayerPromotionGetPlayerPromotionResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerPromotion/PlayerPromotionGetPlayerPromotion";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerPromotionGetPlayerPromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerPromotionGetPlayerPromotionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerPromotionGetPlayerPromotionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerPromotionGetPlayerPromotion(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerPromotionGetPlayerPromotion(xhr: any): PlayerPromotionGetPlayerPromotionResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerPromotionGetPlayerPromotionResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PlayerPromotionGetPlayerPromotionResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    promotionCancel(request: PromotionCancelRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.promotionCancelWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private promotionCancelWithCallbacks(request: PromotionCancelRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerPromotion/PromotionCancel";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPromotionCancelWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPromotionCancelWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPromotionCancelWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPromotionCancel(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPromotionCancel(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    checkImportedRecently(lobbyId: number): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.checkImportedRecentlyWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private checkImportedRecentlyWithCallbacks(lobbyId: number, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerPromotion/CheckImportedRecently?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCheckImportedRecentlyWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCheckImportedRecentlyWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCheckImportedRecentlyWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCheckImportedRecently(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCheckImportedRecently(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    importMemberData(fileParameterForGenerateApi: FileParameter, remark: string, lobbyId: number): Promise<string[]> {
        return new Promise<string[]>((resolve, reject) => {
            this.importMemberDataWithCallbacks(fileParameterForGenerateApi, remark, lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private importMemberDataWithCallbacks(fileParameterForGenerateApi: FileParameter, remark: string, lobbyId: number, onSuccess?: (result: string[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerPromotion/ImportMemberData?";
        if (remark === undefined)
            throw new Error("The parameter 'remark' must be defined.");
        else
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = new FormData();
        if (fileParameterForGenerateApi !== null)
            content_.append("fileParameterForGenerateApi", fileParameterForGenerateApi.data, fileParameterForGenerateApi.fileName ? fileParameterForGenerateApi.fileName : "fileParameterForGenerateApi");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            processData: false,
            contentType: false,
            headers: {
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken'), 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId()
 
            }
        }).done((data, textStatus, xhr) => {
            this.processImportMemberDataWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processImportMemberDataWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processImportMemberDataWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processImportMemberData(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processImportMemberData(xhr: any): string[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: string[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForIndex(lobbyId: number): Promise<RebateImportHistory[]> {
        return new Promise<RebateImportHistory[]>((resolve, reject) => {
            this.getForIndexWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForIndexWithCallbacks(lobbyId: number, onSuccess?: (result: RebateImportHistory[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerPromotion/GetForIndex?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForIndexWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForIndex(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForIndex(xhr: any): RebateImportHistory[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: RebateImportHistory[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RebateImportHistory.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getChoiceRecord(request: PlayerPromotionGetChoiceRecordRequest): Promise<PlayerPromotionGetChoiceRecordResponse[]> {
        return new Promise<PlayerPromotionGetChoiceRecordResponse[]>((resolve, reject) => {
            this.getChoiceRecordWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getChoiceRecordWithCallbacks(request: PlayerPromotionGetChoiceRecordRequest, onSuccess?: (result: PlayerPromotionGetChoiceRecordResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerPromotion/GetChoiceRecord";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetChoiceRecordWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetChoiceRecordWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetChoiceRecordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetChoiceRecord(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetChoiceRecord(xhr: any): PlayerPromotionGetChoiceRecordResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerPromotionGetChoiceRecordResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlayerPromotionGetChoiceRecordResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerPromotionChoiceRecordGet(request: PlayerPromotionChoiceRecordGetRequest): Promise<StandardResultOfIEnumerableOfPlayerPromotionChoiceRecordGetResponse> {
        return new Promise<StandardResultOfIEnumerableOfPlayerPromotionChoiceRecordGetResponse>((resolve, reject) => {
            this.playerPromotionChoiceRecordGetWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerPromotionChoiceRecordGetWithCallbacks(request: PlayerPromotionChoiceRecordGetRequest, onSuccess?: (result: StandardResultOfIEnumerableOfPlayerPromotionChoiceRecordGetResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerPromotion/PlayerPromotionChoiceRecordGet";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerPromotionChoiceRecordGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerPromotionChoiceRecordGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerPromotionChoiceRecordGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerPromotionChoiceRecordGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerPromotionChoiceRecordGet(xhr: any): StandardResultOfIEnumerableOfPlayerPromotionChoiceRecordGetResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResultOfIEnumerableOfPlayerPromotionChoiceRecordGetResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResultOfIEnumerableOfPlayerPromotionChoiceRecordGetResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getRecordForRedeem(request: PlayerPromotionGetRecordForRedeemRequest): Promise<StandardResultOfIEnumerableOfPlayerPromotionGetRecordForRedeemesponse> {
        return new Promise<StandardResultOfIEnumerableOfPlayerPromotionGetRecordForRedeemesponse>((resolve, reject) => {
            this.getRecordForRedeemWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getRecordForRedeemWithCallbacks(request: PlayerPromotionGetRecordForRedeemRequest, onSuccess?: (result: StandardResultOfIEnumerableOfPlayerPromotionGetRecordForRedeemesponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerPromotion/GetRecordForRedeem";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetRecordForRedeemWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetRecordForRedeemWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetRecordForRedeemWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetRecordForRedeem(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetRecordForRedeem(xhr: any): StandardResultOfIEnumerableOfPlayerPromotionGetRecordForRedeemesponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResultOfIEnumerableOfPlayerPromotionGetRecordForRedeemesponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResultOfIEnumerableOfPlayerPromotionGetRecordForRedeemesponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getEstimatedManualRedeemAmount(request: PlayerPromotionGetEstimatedManualRedeemAmountRequest): Promise<StandardResultOfPlayerPromotionGetEstimatedManualRedeemAmountResponse> {
        return new Promise<StandardResultOfPlayerPromotionGetEstimatedManualRedeemAmountResponse>((resolve, reject) => {
            this.getEstimatedManualRedeemAmountWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getEstimatedManualRedeemAmountWithCallbacks(request: PlayerPromotionGetEstimatedManualRedeemAmountRequest, onSuccess?: (result: StandardResultOfPlayerPromotionGetEstimatedManualRedeemAmountResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerPromotion/GetEstimatedManualRedeemAmount";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetEstimatedManualRedeemAmountWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetEstimatedManualRedeemAmountWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetEstimatedManualRedeemAmountWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetEstimatedManualRedeemAmount(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetEstimatedManualRedeemAmount(xhr: any): StandardResultOfPlayerPromotionGetEstimatedManualRedeemAmountResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResultOfPlayerPromotionGetEstimatedManualRedeemAmountResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResultOfPlayerPromotionGetEstimatedManualRedeemAmountResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    manualRedeemChoiceRecord(request: PlayerPromotionManualRedeemChoiceRecordRequest): Promise<StandardResult> {
        return new Promise<StandardResult>((resolve, reject) => {
            this.manualRedeemChoiceRecordWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private manualRedeemChoiceRecordWithCallbacks(request: PlayerPromotionManualRedeemChoiceRecordRequest, onSuccess?: (result: StandardResult) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerPromotion/ManualRedeemChoiceRecord";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processManualRedeemChoiceRecordWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processManualRedeemChoiceRecordWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processManualRedeemChoiceRecordWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processManualRedeemChoiceRecord(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processManualRedeemChoiceRecord(xhr: any): StandardResult {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResult = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResult.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getAllStatusSection(request: PlayerPromotionGetAllStatusSectionRequest): Promise<StandardResultOfListOfCmsSelectionOptionDao> {
        return new Promise<StandardResultOfListOfCmsSelectionOptionDao>((resolve, reject) => {
            this.getAllStatusSectionWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllStatusSectionWithCallbacks(request: PlayerPromotionGetAllStatusSectionRequest, onSuccess?: (result: StandardResultOfListOfCmsSelectionOptionDao) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerPromotion/GetAllStatusSection";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllStatusSectionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllStatusSectionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllStatusSectionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAllStatusSection(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAllStatusSection(xhr: any): StandardResultOfListOfCmsSelectionOptionDao {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResultOfListOfCmsSelectionOptionDao = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResultOfListOfCmsSelectionOptionDao.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getAllPendingRedeemDateKey(): Promise<StandardResultOfListOfCmsSelectionOptionDao> {
        return new Promise<StandardResultOfListOfCmsSelectionOptionDao>((resolve, reject) => {
            this.getAllPendingRedeemDateKeyWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllPendingRedeemDateKeyWithCallbacks(onSuccess?: (result: StandardResultOfListOfCmsSelectionOptionDao) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerPromotion/GetAllPendingRedeemDateKey";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllPendingRedeemDateKeyWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllPendingRedeemDateKeyWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllPendingRedeemDateKeyWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAllPendingRedeemDateKey(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAllPendingRedeemDateKey(xhr: any): StandardResultOfListOfCmsSelectionOptionDao {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResultOfListOfCmsSelectionOptionDao = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResultOfListOfCmsSelectionOptionDao.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PlayerRankingApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    playerRankingGet(request: PlayerRankingGetListRequest): Promise<PlayerRankingGetListResponse[]> {
        return new Promise<PlayerRankingGetListResponse[]>((resolve, reject) => {
            this.playerRankingGetWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerRankingGetWithCallbacks(request: PlayerRankingGetListRequest, onSuccess?: (result: PlayerRankingGetListResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/PlayerRankingGet";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerRankingGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerRankingGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerRankingGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerRankingGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerRankingGet(xhr: any): PlayerRankingGetListResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerRankingGetListResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PlayerRankingGetListResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerRankingCreateByList(requestList: PlayerRankingCreateByListRequest[]): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.playerRankingCreateByListWithCallbacks(requestList, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerRankingCreateByListWithCallbacks(requestList: PlayerRankingCreateByListRequest[], onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerRanking/PlayerRankingCreateByList";

        let contentData_: any = [];
        if (requestList) {
            for (let item of requestList)
                contentData_.push(item.toJS());
        }
        const content_ = JSON.stringify(requestList ? contentData_ : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerRankingCreateByListWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerRankingCreateByListWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerRankingCreateByListWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerRankingCreateByList(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerRankingCreateByList(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    playerRankingSetItem(request: PlayerRankingItem): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.playerRankingSetItemWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private playerRankingSetItemWithCallbacks(request: PlayerRankingItem, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerRanking/PlayerRankingSetItem";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processPlayerRankingSetItemWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processPlayerRankingSetItemWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processPlayerRankingSetItemWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processPlayerRankingSetItem(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processPlayerRankingSetItem(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PlayerReferenceGroupApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    get(request: PlayerReferenceGroupGetRequest): Promise<StandardResponseOfIEnumerableOfPlayerReferenceGroupGetResponse> {
        return new Promise<StandardResponseOfIEnumerableOfPlayerReferenceGroupGetResponse>((resolve, reject) => {
            this.getWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWithCallbacks(request: PlayerReferenceGroupGetRequest, onSuccess?: (result: StandardResponseOfIEnumerableOfPlayerReferenceGroupGetResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerReferenceGroup/Get";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): StandardResponseOfIEnumerableOfPlayerReferenceGroupGetResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfIEnumerableOfPlayerReferenceGroupGetResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfIEnumerableOfPlayerReferenceGroupGetResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    update(request: PlayerReferenceGroupUpdateRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.updateWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private updateWithCallbacks(request: PlayerReferenceGroupUpdateRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PlayerReferenceGroup/Update";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processUpdateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdate(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PromotionApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    create(request: PromotionCreateRequestDao): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.createWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createWithCallbacks(request: PromotionCreateRequestDao, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Promotion/Create";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreate(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForAdd(lobbyId: number): Promise<StandardResponseOfPromotionGetForAddResponse> {
        return new Promise<StandardResponseOfPromotionGetForAddResponse>((resolve, reject) => {
            this.getForAddWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForAddWithCallbacks(lobbyId: number, onSuccess?: (result: StandardResponseOfPromotionGetForAddResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Promotion/GetForAdd?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForAdd(xhr: any): StandardResponseOfPromotionGetForAddResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfPromotionGetForAddResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfPromotionGetForAddResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getPromotionTypes(lobbyId: number, language: LanguageCode): Promise<SelectionOption[]> {
        return new Promise<SelectionOption[]>((resolve, reject) => {
            this.getPromotionTypesWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getPromotionTypesWithCallbacks(lobbyId: number, language: LanguageCode, onSuccess?: (result: SelectionOption[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Promotion/GetPromotionTypes?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetPromotionTypesWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetPromotionTypesWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetPromotionTypesWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetPromotionTypes(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetPromotionTypes(xhr: any): SelectionOption[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: SelectionOption[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SelectionOption.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: PromotionEditRequestDao): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.editWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: PromotionEditRequestDao, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Promotion/Edit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getAll(lobbyId: number, language: LanguageCode): Promise<PromotionResponse[]> {
        return new Promise<PromotionResponse[]>((resolve, reject) => {
            this.getAllWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllWithCallbacks(lobbyId: number, language: LanguageCode, onSuccess?: (result: PromotionResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Promotion/GetAll?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAll(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAll(xhr: any): PromotionResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PromotionResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PromotionResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    get(request: PromotionGetRequest): Promise<StandardResponseOfPromotionGetResponse> {
        return new Promise<StandardResponseOfPromotionGetResponse>((resolve, reject) => {
            this.getWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWithCallbacks(request: PromotionGetRequest, onSuccess?: (result: StandardResponseOfPromotionGetResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Promotion/Get";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): StandardResponseOfPromotionGetResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfPromotionGetResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfPromotionGetResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getNotDeletedByLobbyPromotionId(lobbyId: number, lobbyPromotionId: number, language: LanguageCode): Promise<PromotionResponse> {
        return new Promise<PromotionResponse>((resolve, reject) => {
            this.getNotDeletedByLobbyPromotionIdWithCallbacks(lobbyId, lobbyPromotionId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getNotDeletedByLobbyPromotionIdWithCallbacks(lobbyId: number, lobbyPromotionId: number, language: LanguageCode, onSuccess?: (result: PromotionResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Promotion/GetNotDeletedByLobbyPromotionId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (lobbyPromotionId === undefined || lobbyPromotionId === null)
            throw new Error("The parameter 'lobbyPromotionId' must be defined and cannot be null.");
        else
            url_ += "lobbyPromotionId=" + encodeURIComponent("" + lobbyPromotionId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetNotDeletedByLobbyPromotionIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetNotDeletedByLobbyPromotionIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetNotDeletedByLobbyPromotionIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetNotDeletedByLobbyPromotionId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetNotDeletedByLobbyPromotionId(xhr: any): PromotionResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PromotionResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PromotionResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(lobbyId: number, lobbyPromotionId: number): Promise<StandardResponseOfPromotionEditResponse> {
        return new Promise<StandardResponseOfPromotionEditResponse>((resolve, reject) => {
            this.getForEditWithCallbacks(lobbyId, lobbyPromotionId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(lobbyId: number, lobbyPromotionId: number, onSuccess?: (result: StandardResponseOfPromotionEditResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Promotion/GetForEdit?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (lobbyPromotionId === undefined || lobbyPromotionId === null)
            throw new Error("The parameter 'lobbyPromotionId' must be defined and cannot be null.");
        else
            url_ += "lobbyPromotionId=" + encodeURIComponent("" + lobbyPromotionId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): StandardResponseOfPromotionEditResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfPromotionEditResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfPromotionEditResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    setSortByList(request: SetSortByListRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.setSortByListWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private setSortByListWithCallbacks(request: SetSortByListRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Promotion/SetSortByList";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSetSortByListWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetSortByListWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSetSortByListWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetSortByList(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetSortByList(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForSorting(request: PromotionGetForSortingRequest): Promise<StandardResponseOfPromotionGetForSortingResponse> {
        return new Promise<StandardResponseOfPromotionGetForSortingResponse>((resolve, reject) => {
            this.getForSortingWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForSortingWithCallbacks(request: PromotionGetForSortingRequest, onSuccess?: (result: StandardResponseOfPromotionGetForSortingResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Promotion/GetForSorting";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForSortingWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForSortingWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForSortingWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForSorting(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForSorting(xhr: any): StandardResponseOfPromotionGetForSortingResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfPromotionGetForSortingResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfPromotionGetForSortingResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForIndex(): Promise<StandardResponseOfPromotionGetForIndexResponse> {
        return new Promise<StandardResponseOfPromotionGetForIndexResponse>((resolve, reject) => {
            this.getForIndexWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForIndexWithCallbacks(onSuccess?: (result: StandardResponseOfPromotionGetForIndexResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Promotion/GetForIndex";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForIndexWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForIndex(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForIndex(xhr: any): StandardResponseOfPromotionGetForIndexResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfPromotionGetForIndexResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfPromotionGetForIndexResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbyRebateApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getByLobbyId(lobbyId: number): Promise<RebateActiveDao[]> {
        return new Promise<RebateActiveDao[]>((resolve, reject) => {
            this.getByLobbyIdWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByLobbyIdWithCallbacks(lobbyId: number, onSuccess?: (result: RebateActiveDao[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRebate/GetByLobbyId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByLobbyIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByLobbyIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByLobbyId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByLobbyId(xhr: any): RebateActiveDao[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: RebateActiveDao[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RebateActiveDao.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getIndividualEffectiveList(lobbyId: number, gameDevId: number, gameTypeId: number): Promise<RebateRateIndividualDao[]> {
        return new Promise<RebateRateIndividualDao[]>((resolve, reject) => {
            this.getIndividualEffectiveListWithCallbacks(lobbyId, gameDevId, gameTypeId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getIndividualEffectiveListWithCallbacks(lobbyId: number, gameDevId: number, gameTypeId: number, onSuccess?: (result: RebateRateIndividualDao[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRebate/GetIndividualEffectiveList?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (gameDevId === undefined || gameDevId === null)
            throw new Error("The parameter 'gameDevId' must be defined and cannot be null.");
        else
            url_ += "gameDevId=" + encodeURIComponent("" + gameDevId) + "&"; 
        
        if (gameTypeId === undefined || gameTypeId === null)
            throw new Error("The parameter 'gameTypeId' must be defined and cannot be null.");
        else
            url_ += "gameTypeId=" + encodeURIComponent("" + gameTypeId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetIndividualEffectiveListWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetIndividualEffectiveListWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetIndividualEffectiveListWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetIndividualEffectiveList(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetIndividualEffectiveList(xhr: any): RebateRateIndividualDao[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: RebateRateIndividualDao[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RebateRateIndividualDao.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    add(request: RebateRateAddRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.addWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private addWithCallbacks(request: RebateRateAddRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRebate/Add";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAdd(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(lobbyId: number, rebateRateId: number): Promise<RebateRateEditResponse> {
        return new Promise<RebateRateEditResponse>((resolve, reject) => {
            this.getForEditWithCallbacks(lobbyId, rebateRateId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(lobbyId: number, rebateRateId: number, onSuccess?: (result: RebateRateEditResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRebate/GetForEdit?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (rebateRateId === undefined || rebateRateId === null)
            throw new Error("The parameter 'rebateRateId' must be defined and cannot be null.");
        else
            url_ += "rebateRateId=" + encodeURIComponent("" + rebateRateId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): RebateRateEditResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: RebateRateEditResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? RebateRateEditResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: RebateRateEditRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.editWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: RebateRateEditRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRebate/Edit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    delete(lobbyId: number, lobbyRebateRateId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.deleteWithCallbacks(lobbyId, lobbyRebateRateId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private deleteWithCallbacks(lobbyId: number, lobbyRebateRateId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRebate/Delete?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (lobbyRebateRateId === undefined || lobbyRebateRateId === null)
            throw new Error("The parameter 'lobbyRebateRateId' must be defined and cannot be null.");
        else
            url_ += "lobbyRebateRateId=" + encodeURIComponent("" + lobbyRebateRateId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDeleteWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDelete(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDelete(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    checkImportedRecently(lobbyId: number): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.checkImportedRecentlyWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private checkImportedRecentlyWithCallbacks(lobbyId: number, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRebate/CheckImportedRecently?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCheckImportedRecentlyWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCheckImportedRecentlyWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCheckImportedRecentlyWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCheckImportedRecently(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCheckImportedRecently(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    importMemberData(fileParameterForGenerateApi: FileParameter, remark: string, lobbyId: number): Promise<LR_ImportMemberData_Response> {
        return new Promise<LR_ImportMemberData_Response>((resolve, reject) => {
            this.importMemberDataWithCallbacks(fileParameterForGenerateApi, remark, lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private importMemberDataWithCallbacks(fileParameterForGenerateApi: FileParameter, remark: string, lobbyId: number, onSuccess?: (result: LR_ImportMemberData_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRebate/ImportMemberData?";
        if (remark === undefined)
            throw new Error("The parameter 'remark' must be defined.");
        else
            url_ += "remark=" + encodeURIComponent("" + remark) + "&"; 
        
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = new FormData();
        if (fileParameterForGenerateApi !== null)
            content_.append("fileParameterForGenerateApi", fileParameterForGenerateApi.data, fileParameterForGenerateApi.fileName ? fileParameterForGenerateApi.fileName : "fileParameterForGenerateApi");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            processData: false,
            contentType: false,
            headers: {
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken'), 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId()
 
            }
        }).done((data, textStatus, xhr) => {
            this.processImportMemberDataWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processImportMemberDataWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processImportMemberDataWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processImportMemberData(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processImportMemberData(xhr: any): LR_ImportMemberData_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LR_ImportMemberData_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LR_ImportMemberData_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForIndex(lobbyId: number): Promise<RebateImportHistory[]> {
        return new Promise<RebateImportHistory[]>((resolve, reject) => {
            this.getForIndexWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForIndexWithCallbacks(lobbyId: number, onSuccess?: (result: RebateImportHistory[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbyRebate/GetForIndex?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForIndexWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForIndex(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForIndex(xhr: any): RebateImportHistory[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: RebateImportHistory[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RebateImportHistory.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class ReportAutoRebateApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getAutoRebateReportItems(request: AutoRebateReportRequest): Promise<AutoRebateReport[]> {
        return new Promise<AutoRebateReport[]>((resolve, reject) => {
            this.getAutoRebateReportItemsWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAutoRebateReportItemsWithCallbacks(request: AutoRebateReportRequest, onSuccess?: (result: AutoRebateReport[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ReportAutoRebate/GetAutoRebateReportItems";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAutoRebateReportItemsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAutoRebateReportItemsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAutoRebateReportItemsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAutoRebateReportItems(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAutoRebateReportItems(xhr: any): AutoRebateReport[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: AutoRebateReport[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AutoRebateReport.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getAutoRebateReportDetail(request: AutoRebateReportDetailRequest): Promise<AutoRebatePlayerDetail[]> {
        return new Promise<AutoRebatePlayerDetail[]>((resolve, reject) => {
            this.getAutoRebateReportDetailWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAutoRebateReportDetailWithCallbacks(request: AutoRebateReportDetailRequest, onSuccess?: (result: AutoRebatePlayerDetail[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ReportAutoRebate/GetAutoRebateReportDetail";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAutoRebateReportDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAutoRebateReportDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAutoRebateReportDetailWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAutoRebateReportDetail(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAutoRebateReportDetail(xhr: any): AutoRebatePlayerDetail[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: AutoRebatePlayerDetail[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AutoRebatePlayerDetail.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    doAutoRebate(request: DoAutoRebateRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.doAutoRebateWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private doAutoRebateWithCallbacks(request: DoAutoRebateRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ReportAutoRebate/DoAutoRebate";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDoAutoRebateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDoAutoRebateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDoAutoRebateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDoAutoRebate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDoAutoRebate(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getAutoRebateSetting(request: GetAutoRebateSettingRequest): Promise<AutoRebateSetting[]> {
        return new Promise<AutoRebateSetting[]>((resolve, reject) => {
            this.getAutoRebateSettingWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAutoRebateSettingWithCallbacks(request: GetAutoRebateSettingRequest, onSuccess?: (result: AutoRebateSetting[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ReportAutoRebate/GetAutoRebateSetting";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAutoRebateSettingWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAutoRebateSettingWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAutoRebateSettingWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAutoRebateSetting(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAutoRebateSetting(xhr: any): AutoRebateSetting[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: AutoRebateSetting[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(AutoRebateSetting.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getDisableRebateSetting(): Promise<DisableRebateSetting> {
        return new Promise<DisableRebateSetting>((resolve, reject) => {
            this.getDisableRebateSettingWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getDisableRebateSettingWithCallbacks(onSuccess?: (result: DisableRebateSetting) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ReportAutoRebate/GetDisableRebateSetting";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetDisableRebateSettingWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetDisableRebateSettingWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetDisableRebateSettingWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetDisableRebateSetting(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetDisableRebateSetting(xhr: any): DisableRebateSetting {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: DisableRebateSetting = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? DisableRebateSetting.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class ReportOnlinePaymentApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getOnlinePayments(request: OnlinePaymentRequest): Promise<OnlinePaymentGateway[]> {
        return new Promise<OnlinePaymentGateway[]>((resolve, reject) => {
            this.getOnlinePaymentsWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getOnlinePaymentsWithCallbacks(request: OnlinePaymentRequest, onSuccess?: (result: OnlinePaymentGateway[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ReportOnlinePayment/GetOnlinePayments";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetOnlinePaymentsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetOnlinePaymentsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetOnlinePaymentsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetOnlinePayments(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetOnlinePayments(xhr: any): OnlinePaymentGateway[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: OnlinePaymentGateway[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(OnlinePaymentGateway.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getOnlinePaymentsByPlayer(request: OnlinePaymentRequest): Promise<ReportDepositByUserAndDateVm[]> {
        return new Promise<ReportDepositByUserAndDateVm[]>((resolve, reject) => {
            this.getOnlinePaymentsByPlayerWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getOnlinePaymentsByPlayerWithCallbacks(request: OnlinePaymentRequest, onSuccess?: (result: ReportDepositByUserAndDateVm[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ReportOnlinePayment/GetOnlinePaymentsByPlayer";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetOnlinePaymentsByPlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetOnlinePaymentsByPlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetOnlinePaymentsByPlayerWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetOnlinePaymentsByPlayer(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetOnlinePaymentsByPlayer(xhr: any): ReportDepositByUserAndDateVm[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: ReportDepositByUserAndDateVm[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ReportDepositByUserAndDateVm.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getOnlinePaymentsByGateway(request: OnlinePaymentRequest): Promise<ReportDepositDetailVm[]> {
        return new Promise<ReportDepositDetailVm[]>((resolve, reject) => {
            this.getOnlinePaymentsByGatewayWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getOnlinePaymentsByGatewayWithCallbacks(request: OnlinePaymentRequest, onSuccess?: (result: ReportDepositDetailVm[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ReportOnlinePayment/GetOnlinePaymentsByGateway";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetOnlinePaymentsByGatewayWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetOnlinePaymentsByGatewayWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetOnlinePaymentsByGatewayWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetOnlinePaymentsByGateway(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetOnlinePaymentsByGateway(xhr: any): ReportDepositDetailVm[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: ReportDepositDetailVm[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ReportDepositDetailVm.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class ReportRebateApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getByDateRange(request: ReportRebateRequest): Promise<ReportRebateResposne[]> {
        return new Promise<ReportRebateResposne[]>((resolve, reject) => {
            this.getByDateRangeWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByDateRangeWithCallbacks(request: ReportRebateRequest, onSuccess?: (result: ReportRebateResposne[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ReportRebate/GetByDateRange";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByDateRangeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByDateRange(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByDateRange(xhr: any): ReportRebateResposne[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: ReportRebateResposne[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ReportRebateResposne.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getByDate(request: ReportRebateRequest): Promise<ReportRebateDetailResposne[]> {
        return new Promise<ReportRebateDetailResposne[]>((resolve, reject) => {
            this.getByDateWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByDateWithCallbacks(request: ReportRebateRequest, onSuccess?: (result: ReportRebateDetailResposne[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ReportRebate/GetByDate";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByDateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByDateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByDateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByDate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByDate(xhr: any): ReportRebateDetailResposne[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: ReportRebateDetailResposne[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ReportRebateDetailResposne.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class ReportRegistrationLoginApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getRecordByDateRange(request: RegistrationLoginRequest): Promise<RegistrationLoginResponse> {
        return new Promise<RegistrationLoginResponse>((resolve, reject) => {
            this.getRecordByDateRangeWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getRecordByDateRangeWithCallbacks(request: RegistrationLoginRequest, onSuccess?: (result: RegistrationLoginResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ReportRegistrationLogin/GetRecordByDateRange";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetRecordByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetRecordByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetRecordByDateRangeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetRecordByDateRange(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetRecordByDateRange(xhr: any): RegistrationLoginResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: RegistrationLoginResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegistrationLoginResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getRecordByDateRangeNew(request: RegistrationLoginRequest): Promise<RegistrationLoginResponseNew> {
        return new Promise<RegistrationLoginResponseNew>((resolve, reject) => {
            this.getRecordByDateRangeNewWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getRecordByDateRangeNewWithCallbacks(request: RegistrationLoginRequest, onSuccess?: (result: RegistrationLoginResponseNew) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ReportRegistrationLogin/GetRecordByDateRangeNew";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetRecordByDateRangeNewWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetRecordByDateRangeNewWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetRecordByDateRangeNewWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetRecordByDateRangeNew(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetRecordByDateRangeNew(xhr: any): RegistrationLoginResponseNew {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: RegistrationLoginResponseNew = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegistrationLoginResponseNew.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getRegistrationLoginDetailByColumnOfRegister(request: RegistrationLoginDetailRequest): Promise<RegistrationLoginDetailResponse[]> {
        return new Promise<RegistrationLoginDetailResponse[]>((resolve, reject) => {
            this.getRegistrationLoginDetailByColumnOfRegisterWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getRegistrationLoginDetailByColumnOfRegisterWithCallbacks(request: RegistrationLoginDetailRequest, onSuccess?: (result: RegistrationLoginDetailResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ReportRegistrationLogin/GetRegistrationLoginDetailByColumnOfRegister";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetRegistrationLoginDetailByColumnOfRegisterWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetRegistrationLoginDetailByColumnOfRegisterWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetRegistrationLoginDetailByColumnOfRegisterWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetRegistrationLoginDetailByColumnOfRegister(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetRegistrationLoginDetailByColumnOfRegister(xhr: any): RegistrationLoginDetailResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: RegistrationLoginDetailResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RegistrationLoginDetailResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getRegistrationLoginDetailByColumnOfUserLogin(request: RegistrationLoginDetailRequest): Promise<RegistrationLoginDetailResponse[]> {
        return new Promise<RegistrationLoginDetailResponse[]>((resolve, reject) => {
            this.getRegistrationLoginDetailByColumnOfUserLoginWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getRegistrationLoginDetailByColumnOfUserLoginWithCallbacks(request: RegistrationLoginDetailRequest, onSuccess?: (result: RegistrationLoginDetailResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ReportRegistrationLogin/GetRegistrationLoginDetailByColumnOfUserLogin";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetRegistrationLoginDetailByColumnOfUserLoginWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetRegistrationLoginDetailByColumnOfUserLoginWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetRegistrationLoginDetailByColumnOfUserLoginWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetRegistrationLoginDetailByColumnOfUserLogin(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetRegistrationLoginDetailByColumnOfUserLogin(xhr: any): RegistrationLoginDetailResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: RegistrationLoginDetailResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RegistrationLoginDetailResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getRegistrationLoginDetailByColumnOfLogin(request: RegistrationLoginDetailRequest): Promise<RegistrationLoginDetailResponse[]> {
        return new Promise<RegistrationLoginDetailResponse[]>((resolve, reject) => {
            this.getRegistrationLoginDetailByColumnOfLoginWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getRegistrationLoginDetailByColumnOfLoginWithCallbacks(request: RegistrationLoginDetailRequest, onSuccess?: (result: RegistrationLoginDetailResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/ReportRegistrationLogin/GetRegistrationLoginDetailByColumnOfLogin";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetRegistrationLoginDetailByColumnOfLoginWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetRegistrationLoginDetailByColumnOfLoginWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetRegistrationLoginDetailByColumnOfLoginWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetRegistrationLoginDetailByColumnOfLogin(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetRegistrationLoginDetailByColumnOfLogin(xhr: any): RegistrationLoginDetailResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: RegistrationLoginDetailResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(RegistrationLoginDetailResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class LobbySmsMessageTemplateApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getForIndex(): Promise<LobbySmsMessageTemplateGetForIndexResponse[]> {
        return new Promise<LobbySmsMessageTemplateGetForIndexResponse[]>((resolve, reject) => {
            this.getForIndexWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForIndexWithCallbacks(onSuccess?: (result: LobbySmsMessageTemplateGetForIndexResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbySmsMessageTemplate/GetForIndex";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForIndexWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForIndex(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForIndex(xhr: any): LobbySmsMessageTemplateGetForIndexResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbySmsMessageTemplateGetForIndexResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbySmsMessageTemplateGetForIndexResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForAdd(): Promise<LobbySmsMessageTemplateGetForAddResponse[]> {
        return new Promise<LobbySmsMessageTemplateGetForAddResponse[]>((resolve, reject) => {
            this.getForAddWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForAddWithCallbacks(onSuccess?: (result: LobbySmsMessageTemplateGetForAddResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbySmsMessageTemplate/GetForAdd";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForAdd(xhr: any): LobbySmsMessageTemplateGetForAddResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbySmsMessageTemplateGetForAddResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbySmsMessageTemplateGetForAddResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForEdit(smsMessgeTemplateId: number): Promise<LobbySmsMessageTemplateGetForEditResponse[]> {
        return new Promise<LobbySmsMessageTemplateGetForEditResponse[]>((resolve, reject) => {
            this.getForEditWithCallbacks(smsMessgeTemplateId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForEditWithCallbacks(smsMessgeTemplateId: number, onSuccess?: (result: LobbySmsMessageTemplateGetForEditResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbySmsMessageTemplate/GetForEdit?";
        if (smsMessgeTemplateId === undefined || smsMessgeTemplateId === null)
            throw new Error("The parameter 'smsMessgeTemplateId' must be defined and cannot be null.");
        else
            url_ += "smsMessgeTemplateId=" + encodeURIComponent("" + smsMessgeTemplateId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForEdit(xhr: any): LobbySmsMessageTemplateGetForEditResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbySmsMessageTemplateGetForEditResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(LobbySmsMessageTemplateGetForEditResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    create(request: LobbySmsMessageTemplateCreateRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.createWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createWithCallbacks(request: LobbySmsMessageTemplateCreateRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbySmsMessageTemplate/Create";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreate(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    edit(request: LobbySmsMessageTemplateEditRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.editWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private editWithCallbacks(request: LobbySmsMessageTemplateEditRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbySmsMessageTemplate/Edit";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processEditWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processEditWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processEdit(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processEdit(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    get(request: LobbySmsMessageTemplateGetRequest): Promise<LobbySmsMessageTemplateGetResponse> {
        return new Promise<LobbySmsMessageTemplateGetResponse>((resolve, reject) => {
            this.getWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWithCallbacks(request: LobbySmsMessageTemplateGetRequest, onSuccess?: (result: LobbySmsMessageTemplateGetResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbySmsMessageTemplate/Get";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): LobbySmsMessageTemplateGetResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbySmsMessageTemplateGetResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbySmsMessageTemplateGetResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getLast(): Promise<LobbySmsMessageTemplateGetResponse> {
        return new Promise<LobbySmsMessageTemplateGetResponse>((resolve, reject) => {
            this.getLastWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getLastWithCallbacks(onSuccess?: (result: LobbySmsMessageTemplateGetResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbySmsMessageTemplate/GetLast";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetLastWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetLastWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetLastWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetLast(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetLast(xhr: any): LobbySmsMessageTemplateGetResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: LobbySmsMessageTemplateGetResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? LobbySmsMessageTemplateGetResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    delete(smsMessageTemplateId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.deleteWithCallbacks(smsMessageTemplateId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private deleteWithCallbacks(smsMessageTemplateId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/LobbySmsMessageTemplate/Delete?";
        if (smsMessageTemplateId === undefined || smsMessageTemplateId === null)
            throw new Error("The parameter 'smsMessageTemplateId' must be defined and cannot be null.");
        else
            url_ += "smsMessageTemplateId=" + encodeURIComponent("" + smsMessageTemplateId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processDeleteWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processDeleteWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processDelete(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processDelete(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class AdminCreatePlayerRecordApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    get(request: GetAdminCreatePlayerRecordRequest): Promise<StandardResponseOfListOfGetAdminCreatePlayerRecordResponse> {
        return new Promise<StandardResponseOfListOfGetAdminCreatePlayerRecordResponse>((resolve, reject) => {
            this.getWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWithCallbacks(request: GetAdminCreatePlayerRecordRequest, onSuccess?: (result: StandardResponseOfListOfGetAdminCreatePlayerRecordResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/AdminCreatePlayerRecord/Get";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): StandardResponseOfListOfGetAdminCreatePlayerRecordResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfListOfGetAdminCreatePlayerRecordResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfListOfGetAdminCreatePlayerRecordResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class TeleMarketingApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getOwnedPlayer(request: Telemarketing_GetOwnedPlayerRequest): Promise<StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse> {
        return new Promise<StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse>((resolve, reject) => {
            this.getOwnedPlayerWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getOwnedPlayerWithCallbacks(request: Telemarketing_GetOwnedPlayerRequest, onSuccess?: (result: StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/TeleMarketing/GetOwnedPlayer";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetOwnedPlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetOwnedPlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetOwnedPlayerWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetOwnedPlayer(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetOwnedPlayer(xhr: any): StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getNotAssignedPlayer(request: Telemarketing_GetNotAssignedPlayerRequest): Promise<StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse> {
        return new Promise<StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse>((resolve, reject) => {
            this.getNotAssignedPlayerWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getNotAssignedPlayerWithCallbacks(request: Telemarketing_GetNotAssignedPlayerRequest, onSuccess?: (result: StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/TeleMarketing/GetNotAssignedPlayer";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetNotAssignedPlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetNotAssignedPlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetNotAssignedPlayerWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetNotAssignedPlayer(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetNotAssignedPlayer(xhr: any): StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getAllAssignedPlayer(request: Telemarketing_GetAllAssignedPlayerRequest): Promise<StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse> {
        return new Promise<StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse>((resolve, reject) => {
            this.getAllAssignedPlayerWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getAllAssignedPlayerWithCallbacks(request: Telemarketing_GetAllAssignedPlayerRequest, onSuccess?: (result: StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/TeleMarketing/GetAllAssignedPlayer";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetAllAssignedPlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetAllAssignedPlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetAllAssignedPlayerWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetAllAssignedPlayer(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetAllAssignedPlayer(xhr: any): StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getTelemarketAdmin(): Promise<StandardResponseOfIEnumerableOfGetTelemarketAdminResponse> {
        return new Promise<StandardResponseOfIEnumerableOfGetTelemarketAdminResponse>((resolve, reject) => {
            this.getTelemarketAdminWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getTelemarketAdminWithCallbacks(onSuccess?: (result: StandardResponseOfIEnumerableOfGetTelemarketAdminResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/TeleMarketing/GetTelemarketAdmin";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetTelemarketAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetTelemarketAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetTelemarketAdminWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetTelemarketAdmin(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetTelemarketAdmin(xhr: any): StandardResponseOfIEnumerableOfGetTelemarketAdminResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfIEnumerableOfGetTelemarketAdminResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfIEnumerableOfGetTelemarketAdminResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    create(playerId: number): Promise<StandardResponseOfCreateTeleMarketingPlayerResponse> {
        return new Promise<StandardResponseOfCreateTeleMarketingPlayerResponse>((resolve, reject) => {
            this.createWithCallbacks(playerId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private createWithCallbacks(playerId: number, onSuccess?: (result: StandardResponseOfCreateTeleMarketingPlayerResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/TeleMarketing/Create?";
        if (playerId === undefined || playerId === null)
            throw new Error("The parameter 'playerId' must be defined and cannot be null.");
        else
            url_ += "PlayerId=" + encodeURIComponent("" + playerId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processCreateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processCreateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processCreate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processCreate(xhr: any): StandardResponseOfCreateTeleMarketingPlayerResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfCreateTeleMarketingPlayerResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfCreateTeleMarketingPlayerResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    remove(id: number): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.removeWithCallbacks(id, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private removeWithCallbacks(id: number, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/TeleMarketing/Remove?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processRemoveWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processRemoveWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processRemoveWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processRemove(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processRemove(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    assign(request: Telemarketing_AssignRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.assignWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private assignWithCallbacks(request: Telemarketing_AssignRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/TeleMarketing/Assign";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processAssignWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processAssignWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processAssignWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processAssign(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processAssign(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    update(request: Telemarketing_ReassignRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.updateWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private updateWithCallbacks(request: Telemarketing_ReassignRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/TeleMarketing/Update";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processUpdateWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processUpdateWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processUpdateWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processUpdate(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processUpdate(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    get(teleMarketingPlayerId: number): Promise<StandardResponseOfGetTeleMarketingPlayerResponse> {
        return new Promise<StandardResponseOfGetTeleMarketingPlayerResponse>((resolve, reject) => {
            this.getWithCallbacks(teleMarketingPlayerId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWithCallbacks(teleMarketingPlayerId: number, onSuccess?: (result: StandardResponseOfGetTeleMarketingPlayerResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/TeleMarketing/Get?";
        if (teleMarketingPlayerId === undefined || teleMarketingPlayerId === null)
            throw new Error("The parameter 'teleMarketingPlayerId' must be defined and cannot be null.");
        else
            url_ += "teleMarketingPlayerId=" + encodeURIComponent("" + teleMarketingPlayerId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): StandardResponseOfGetTeleMarketingPlayerResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponseOfGetTeleMarketingPlayerResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponseOfGetTeleMarketingPlayerResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    isEnableToSend(playerId: number): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.isEnableToSendWithCallbacks(playerId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private isEnableToSendWithCallbacks(playerId: number, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/TeleMarketing/IsEnableToSend?";
        if (playerId === undefined || playerId === null)
            throw new Error("The parameter 'playerId' must be defined and cannot be null.");
        else
            url_ += "playerId=" + encodeURIComponent("" + playerId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processIsEnableToSendWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processIsEnableToSendWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processIsEnableToSendWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processIsEnableToSend(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processIsEnableToSend(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class SubscriptionMessageApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getForIndex(lobbyId: number, languageId: number): Promise<SubscriptionMessageIndexResponse[]> {
        return new Promise<SubscriptionMessageIndexResponse[]>((resolve, reject) => {
            this.getForIndexWithCallbacks(lobbyId, languageId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForIndexWithCallbacks(lobbyId: number, languageId: number, onSuccess?: (result: SubscriptionMessageIndexResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/SubscriptionMessage/GetForIndex?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForIndexWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForIndex(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForIndex(xhr: any): SubscriptionMessageIndexResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: SubscriptionMessageIndexResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SubscriptionMessageIndexResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    send(request: SubscriptionMessageSendRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.sendWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private sendWithCallbacks(request: SubscriptionMessageSendRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/SubscriptionMessage/Send";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSendWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSendWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSendWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSend(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSend(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForSend(lobbyId: number, languageId: number): Promise<SubscriptionMessageGetForSendResponse> {
        return new Promise<SubscriptionMessageGetForSendResponse>((resolve, reject) => {
            this.getForSendWithCallbacks(lobbyId, languageId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForSendWithCallbacks(lobbyId: number, languageId: number, onSuccess?: (result: SubscriptionMessageGetForSendResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/SubscriptionMessage/GetForSend?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForSendWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForSendWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForSendWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForSend(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForSend(xhr: any): SubscriptionMessageGetForSendResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: SubscriptionMessageGetForSendResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? SubscriptionMessageGetForSendResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class TransferWalletApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getBalance(lobbyId: number, gameDevId: number, playerId: number): Promise<TransferWalletGetBalanceReponse> {
        return new Promise<TransferWalletGetBalanceReponse>((resolve, reject) => {
            this.getBalanceWithCallbacks(lobbyId, gameDevId, playerId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getBalanceWithCallbacks(lobbyId: number, gameDevId: number, playerId: number, onSuccess?: (result: TransferWalletGetBalanceReponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/TransferWallet/GetBalance?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (gameDevId === undefined || gameDevId === null)
            throw new Error("The parameter 'gameDevId' must be defined and cannot be null.");
        else
            url_ += "gameDevId=" + encodeURIComponent("" + gameDevId) + "&"; 
        
        if (playerId === undefined || playerId === null)
            throw new Error("The parameter 'playerId' must be defined and cannot be null.");
        else
            url_ += "playerId=" + encodeURIComponent("" + playerId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetBalanceWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetBalanceWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetBalanceWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetBalance(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetBalance(xhr: any): TransferWalletGetBalanceReponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: TransferWalletGetBalanceReponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransferWalletGetBalanceReponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getTransferWalletGameDevId(lobbyId: number): Promise<GameDevId[]> {
        return new Promise<GameDevId[]>((resolve, reject) => {
            this.getTransferWalletGameDevIdWithCallbacks(lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getTransferWalletGameDevIdWithCallbacks(lobbyId: number, onSuccess?: (result: GameDevId[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/TransferWallet/GetTransferWalletGameDevId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetTransferWalletGameDevIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetTransferWalletGameDevIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetTransferWalletGameDevIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetTransferWalletGameDevId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetTransferWalletGameDevId(xhr: any): GameDevId[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: GameDevId[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(item);
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class PhoneCallLogApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    get(startDate: Date, endDate: Date): Promise<PhoneCallLogResponse[]> {
        return new Promise<PhoneCallLogResponse[]>((resolve, reject) => {
            this.getWithCallbacks(startDate, endDate, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getWithCallbacks(startDate: Date, endDate: Date, onSuccess?: (result: PhoneCallLogResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/PhoneCallLog/Get?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent("" + startDate.toJSON()) + "&"; 
        
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent("" + endDate.toJSON()) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGet(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGet(xhr: any): PhoneCallLogResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PhoneCallLogResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(PhoneCallLogResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class SmsMessageApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    sendSmsToPlayer(request: SendSmsToPlayerRequest): Promise<SendSmsResponse> {
        return new Promise<SendSmsResponse>((resolve, reject) => {
            this.sendSmsToPlayerWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private sendSmsToPlayerWithCallbacks(request: SendSmsToPlayerRequest, onSuccess?: (result: SendSmsResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/SmsMessage/SendSmsToPlayer";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSendSmsToPlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSendSmsToPlayerWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSendSmsToPlayerWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSendSmsToPlayer(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSendSmsToPlayer(xhr: any): SendSmsResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: SendSmsResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? SendSmsResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    sendMultipleSms(fileParameterForGenerateApi: FileParameter, taskName: string, message: string, countryId: number, lobbySmsMessgeTemplateId: number): Promise<SendMutipleSmsResponse> {
        return new Promise<SendMutipleSmsResponse>((resolve, reject) => {
            this.sendMultipleSmsWithCallbacks(fileParameterForGenerateApi, taskName, message, countryId, lobbySmsMessgeTemplateId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private sendMultipleSmsWithCallbacks(fileParameterForGenerateApi: FileParameter, taskName: string, message: string, countryId: number, lobbySmsMessgeTemplateId: number, onSuccess?: (result: SendMutipleSmsResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/SmsMessage/SendMultipleSms?";
        if (taskName === undefined)
            throw new Error("The parameter 'taskName' must be defined.");
        else
            url_ += "TaskName=" + encodeURIComponent("" + taskName) + "&"; 
        
        if (message === undefined)
            throw new Error("The parameter 'message' must be defined.");
        else
            url_ += "Message=" + encodeURIComponent("" + message) + "&"; 
        
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined and cannot be null.");
        else
            url_ += "CountryId=" + encodeURIComponent("" + countryId) + "&"; 
        
        if (lobbySmsMessgeTemplateId === undefined)
            throw new Error("The parameter 'lobbySmsMessgeTemplateId' must be defined.");
        else
            url_ += "LobbySmsMessgeTemplateId=" + encodeURIComponent("" + lobbySmsMessgeTemplateId) + "&";

        const content_ = new FormData();
        if (fileParameterForGenerateApi !== null)
            content_.append("fileParameterForGenerateApi", fileParameterForGenerateApi.data, fileParameterForGenerateApi.fileName ? fileParameterForGenerateApi.fileName : "fileParameterForGenerateApi");

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            mimeType: "multipart/form-data",
            processData: false,
            contentType: false,
            headers: {
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken'), 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId()
 
            }
        }).done((data, textStatus, xhr) => {
            this.processSendMultipleSmsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSendMultipleSmsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSendMultipleSmsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSendMultipleSms(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSendMultipleSms(xhr: any): SendMutipleSmsResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: SendMutipleSmsResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? SendMutipleSmsResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    reSendSms(request: ReSendSmsRequest): Promise<ReSendSmsResponse> {
        return new Promise<ReSendSmsResponse>((resolve, reject) => {
            this.reSendSmsWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private reSendSmsWithCallbacks(request: ReSendSmsRequest, onSuccess?: (result: ReSendSmsResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/SmsMessage/ReSendSms";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processReSendSmsWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processReSendSmsWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processReSendSmsWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processReSendSms(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processReSendSms(xhr: any): ReSendSmsResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: ReSendSmsResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? ReSendSmsResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    setFailTaskToPending(request: SetFailTaskToPendingRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.setFailTaskToPendingWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private setFailTaskToPendingWithCallbacks(request: SetFailTaskToPendingRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/SmsMessage/SetFailTaskToPending";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSetFailTaskToPendingWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSetFailTaskToPendingWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSetFailTaskToPendingWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSetFailTaskToPending(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSetFailTaskToPending(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForIndex(request: SmsMessageGetForIndexRequest): Promise<SmsMessageGetForIndexResponse[]> {
        return new Promise<SmsMessageGetForIndexResponse[]>((resolve, reject) => {
            this.getForIndexWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForIndexWithCallbacks(request: SmsMessageGetForIndexRequest, onSuccess?: (result: SmsMessageGetForIndexResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/SmsMessage/GetForIndex";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForIndexWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForIndex(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForIndex(xhr: any): SmsMessageGetForIndexResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: SmsMessageGetForIndexResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(SmsMessageGetForIndexResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForAdd(): Promise<SmsMessageGetForAddResponse> {
        return new Promise<SmsMessageGetForAddResponse>((resolve, reject) => {
            this.getForAddWithCallbacks((result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForAddWithCallbacks(onSuccess?: (result: SmsMessageGetForAddResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/SmsMessage/GetForAdd";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForAdd(xhr: any): SmsMessageGetForAddResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: SmsMessageGetForAddResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? SmsMessageGetForAddResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForDetail(request: SmsMessageGetForDetailRequest): Promise<SmsMessageGetForDetailResponse> {
        return new Promise<SmsMessageGetForDetailResponse>((resolve, reject) => {
            this.getForDetailWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForDetailWithCallbacks(request: SmsMessageGetForDetailRequest, onSuccess?: (result: SmsMessageGetForDetailResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/SmsMessage/GetForDetail";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForDetailWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForDetailWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForDetail(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForDetail(xhr: any): SmsMessageGetForDetailResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: SmsMessageGetForDetailResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? SmsMessageGetForDetailResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class UserMessageApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getForAdd(lobbyId: LobbyId, languageId: LanguageCode): Promise<UserMessageFormDataResponse> {
        return new Promise<UserMessageFormDataResponse>((resolve, reject) => {
            this.getForAddWithCallbacks(lobbyId, languageId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForAddWithCallbacks(lobbyId: LobbyId, languageId: LanguageCode, onSuccess?: (result: UserMessageFormDataResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/UserMessage/GetForAdd?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined and cannot be null.");
        else
            url_ += "languageId=" + encodeURIComponent("" + languageId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForAddWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForAddWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForAdd(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForAdd(xhr: any): UserMessageFormDataResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: UserMessageFormDataResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserMessageFormDataResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getPlayersForSelection(lobbyId: number, partOfUsername: string, nRecords: number): Promise<CmsSelectionOption[]> {
        return new Promise<CmsSelectionOption[]>((resolve, reject) => {
            this.getPlayersForSelectionWithCallbacks(lobbyId, partOfUsername, nRecords, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getPlayersForSelectionWithCallbacks(lobbyId: number, partOfUsername: string, nRecords: number, onSuccess?: (result: CmsSelectionOption[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/UserMessage/GetPlayersForSelection?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (partOfUsername === undefined)
            throw new Error("The parameter 'partOfUsername' must be defined.");
        else
            url_ += "partOfUsername=" + encodeURIComponent("" + partOfUsername) + "&"; 
        
        if (nRecords === undefined || nRecords === null)
            throw new Error("The parameter 'nRecords' must be defined and cannot be null.");
        else
            url_ += "nRecords=" + encodeURIComponent("" + nRecords) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetPlayersForSelectionWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetPlayersForSelectionWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetPlayersForSelectionWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetPlayersForSelection(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetPlayersForSelection(xhr: any): CmsSelectionOption[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: CmsSelectionOption[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(CmsSelectionOption.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    send(request: UserMessageSendRequest): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.sendWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private sendWithCallbacks(request: UserMessageSendRequest, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/UserMessage/Send";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSendWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSendWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSendWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSend(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSend(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getForIndex(request: UserMessageIndexRequest): Promise<UserMessageIndexResponse[]> {
        return new Promise<UserMessageIndexResponse[]>((resolve, reject) => {
            this.getForIndexWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getForIndexWithCallbacks(request: UserMessageIndexRequest, onSuccess?: (result: UserMessageIndexResponse[]) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/UserMessage/GetForIndex";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetForIndexWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetForIndexWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetForIndex(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetForIndex(xhr: any): UserMessageIndexResponse[] {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: UserMessageIndexResponse[] = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(UserMessageIndexResponse.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getByUserMessageId(lobbyId: number, language: LanguageCode, userMessageId: number): Promise<UM_GetDetail_Response> {
        return new Promise<UM_GetDetail_Response>((resolve, reject) => {
            this.getByUserMessageIdWithCallbacks(lobbyId, language, userMessageId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByUserMessageIdWithCallbacks(lobbyId: number, language: LanguageCode, userMessageId: number, onSuccess?: (result: UM_GetDetail_Response) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/UserMessage/GetByUserMessageId?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&"; 
        
        if (userMessageId === undefined || userMessageId === null)
            throw new Error("The parameter 'userMessageId' must be defined and cannot be null.");
        else
            url_ += "userMessageId=" + encodeURIComponent("" + userMessageId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByUserMessageIdWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByUserMessageIdWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByUserMessageIdWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByUserMessageId(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByUserMessageId(xhr: any): UM_GetDetail_Response {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: UM_GetDetail_Response = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? UM_GetDetail_Response.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getLast(lobbyId: number, language: LanguageCode): Promise<UserMessageIndexResponse> {
        return new Promise<UserMessageIndexResponse>((resolve, reject) => {
            this.getLastWithCallbacks(lobbyId, language, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getLastWithCallbacks(lobbyId: number, language: LanguageCode, onSuccess?: (result: UserMessageIndexResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/UserMessage/GetLast?";
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetLastWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetLastWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetLastWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetLast(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetLast(xhr: any): UserMessageIndexResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: UserMessageIndexResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserMessageIndexResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class WithdrawApi {
    baseUrl: string = undefined; 
    beforeSend: any = undefined; 
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(baseUrl?: string) {
        this.baseUrl = baseUrl !== undefined ? baseUrl : ""; 
    }

    getPlayerSummary(request: WithdrawGetPlayerSummaryRequest): Promise<PlayerSummary> {
        return new Promise<PlayerSummary>((resolve, reject) => {
            this.getPlayerSummaryWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getPlayerSummaryWithCallbacks(request: WithdrawGetPlayerSummaryRequest, onSuccess?: (result: PlayerSummary) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Withdraw/GetPlayerSummary";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetPlayerSummaryWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetPlayerSummaryWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetPlayerSummaryWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetPlayerSummary(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetPlayerSummary(xhr: any): PlayerSummary {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: PlayerSummary = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? PlayerSummary.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getByDateRange(request: WithdrawGetByDateRangeRequest): Promise<WithdrawListResponse> {
        return new Promise<WithdrawListResponse>((resolve, reject) => {
            this.getByDateRangeWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByDateRangeWithCallbacks(request: WithdrawGetByDateRangeRequest, onSuccess?: (result: WithdrawListResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Withdraw/GetByDateRange";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByDateRangeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByDateRange(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByDateRange(xhr: any): WithdrawListResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: WithdrawListResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? WithdrawListResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getCryptocurrencyByDateRange(request: WithdrawGetCryptocurrencyByDateRangeRequest): Promise<WithdrawCryptocurrencyResponse> {
        return new Promise<WithdrawCryptocurrencyResponse>((resolve, reject) => {
            this.getCryptocurrencyByDateRangeWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getCryptocurrencyByDateRangeWithCallbacks(request: WithdrawGetCryptocurrencyByDateRangeRequest, onSuccess?: (result: WithdrawCryptocurrencyResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Withdraw/GetCryptocurrencyByDateRange";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetCryptocurrencyByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetCryptocurrencyByDateRangeWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetCryptocurrencyByDateRangeWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetCryptocurrencyByDateRange(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetCryptocurrencyByDateRange(xhr: any): WithdrawCryptocurrencyResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: WithdrawCryptocurrencyResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? WithdrawCryptocurrencyResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    getByTranscationNo(transactionNo: string, language: LanguageCode, lobbyId: number): Promise<WithdrawListItemResponse> {
        return new Promise<WithdrawListItemResponse>((resolve, reject) => {
            this.getByTranscationNoWithCallbacks(transactionNo, language, lobbyId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private getByTranscationNoWithCallbacks(transactionNo: string, language: LanguageCode, lobbyId: number, onSuccess?: (result: WithdrawListItemResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Withdraw/GetByTranscationNo?";
        if (transactionNo === undefined)
            throw new Error("The parameter 'transactionNo' must be defined.");
        else
            url_ += "transactionNo=" + encodeURIComponent("" + transactionNo) + "&"; 
        
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&"; 
        
        if (lobbyId === undefined || lobbyId === null)
            throw new Error("The parameter 'lobbyId' must be defined and cannot be null.");
        else
            url_ += "lobbyId=" + encodeURIComponent("" + lobbyId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "get",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processGetByTranscationNoWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processGetByTranscationNoWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processGetByTranscationNoWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processGetByTranscationNo(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processGetByTranscationNo(xhr: any): WithdrawListItemResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: WithdrawListItemResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? WithdrawListItemResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    resetAndSettle(request: W_ResetAndSettle_Request): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.resetAndSettleWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private resetAndSettleWithCallbacks(request: W_ResetAndSettle_Request, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Withdraw/ResetAndSettle";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processResetAndSettleWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processResetAndSettleWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processResetAndSettleWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processResetAndSettle(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processResetAndSettle(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    settle(request: W_Settle_Request): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.settleWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private settleWithCallbacks(request: W_Settle_Request, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Withdraw/Settle";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSettleWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSettleWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSettleWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSettle(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSettle(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    resetAndReject(request: WithdrawRejectRequest): Promise<StandardResponse> {
        return new Promise<StandardResponse>((resolve, reject) => {
            this.resetAndRejectWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private resetAndRejectWithCallbacks(request: WithdrawRejectRequest, onSuccess?: (result: StandardResponse) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Withdraw/ResetAndReject";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processResetAndRejectWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processResetAndRejectWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processResetAndRejectWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processResetAndReject(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processResetAndReject(xhr: any): StandardResponse {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: StandardResponse = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 ? StandardResponse.fromJS(resultData200) : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    reject(request: WithdrawRejectRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.rejectWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private rejectWithCallbacks(request: WithdrawRejectRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Withdraw/Reject";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processRejectWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processRejectWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processRejectWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processReject(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processReject(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    rollback(playerAmountRecordId: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.rollbackWithCallbacks(playerAmountRecordId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private rollbackWithCallbacks(playerAmountRecordId: number, onSuccess?: (result: void) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Withdraw/Rollback?";
        if (playerAmountRecordId === undefined || playerAmountRecordId === null)
            throw new Error("The parameter 'playerAmountRecordId' must be defined and cannot be null.");
        else
            url_ += "playerAmountRecordId=" + encodeURIComponent("" + playerAmountRecordId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processRollbackWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processRollbackWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processRollbackWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processRollback(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processRollback(xhr: any): void {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 204) {
            return null;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    markAsUnderReview(request: WithdrawReviewRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.markAsUnderReviewWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private markAsUnderReviewWithCallbacks(request: WithdrawReviewRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Withdraw/MarkAsUnderReview";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processMarkAsUnderReviewWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processMarkAsUnderReviewWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processMarkAsUnderReviewWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processMarkAsUnderReview(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processMarkAsUnderReview(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    submitDeductPointsByAdmin(request: WithdrawByAdminSubmitRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.submitDeductPointsByAdminWithCallbacks(request, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private submitDeductPointsByAdminWithCallbacks(request: WithdrawByAdminSubmitRequest, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Withdraw/SubmitDeductPointsByAdmin";

        const content_ = JSON.stringify(request ? request.toJS() : null);

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processSubmitDeductPointsByAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processSubmitDeductPointsByAdminWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processSubmitDeductPointsByAdminWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processSubmitDeductPointsByAdmin(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processSubmitDeductPointsByAdmin(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    markAsFollowing(playerAmountRecordId: number): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.markAsFollowingWithCallbacks(playerAmountRecordId, (result) => resolve(result), (exception, reason) => reject(exception));
        });
    }
    
    private markAsFollowingWithCallbacks(playerAmountRecordId: number, onSuccess?: (result: boolean) => void, onFail?: (exception: string, reason: string) => void) {
        let url_ = this.baseUrl + "/api/Withdraw/MarkAsFollowing?";
        if (playerAmountRecordId === undefined || playerAmountRecordId === null)
            throw new Error("The parameter 'playerAmountRecordId' must be defined and cannot be null.");
        else
            url_ += "playerAmountRecordId=" + encodeURIComponent("" + playerAmountRecordId) + "&";

        const content_ = "";

        jQuery.ajax({
            url: url_,
            beforeSend: this.beforeSend,
            type: "post",
            data: content_,
            dataType: "text",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                "Authorization": 'Bearer ' + localStorage.getItem('accessToken') , 'lobbyId': vars.lobbyId(), 'Accept-Language': vars.languageId(), 'userDeviceTypeId': vars.deviceTypeId() 
,
				"Accept": "application/json; charset=UTF-8"
            }
        }).done((data, textStatus, xhr) => {
            this.processMarkAsFollowingWithCallbacks(url_, xhr, onSuccess, onFail);
        }).fail((xhr) => {
            this.processMarkAsFollowingWithCallbacks(url_, xhr, onSuccess, onFail);
        });
    }

    private processMarkAsFollowingWithCallbacks(url: string, xhr: any, onSuccess?: any, onFail?: any): void {
        try {
            let result = this.processMarkAsFollowing(xhr);
            if (onSuccess !== undefined)
                onSuccess(result);
        } catch (e) {
            if (onFail !== undefined)
                onFail(e, "http_service_exception");
        }
    }

    protected processMarkAsFollowing(xhr: any): boolean {
        const responseText = xhr.responseText; 
        const status = xhr.status; 

        if (status === 200) {
            let result200: boolean = null;
            let resultData200 = responseText === "" ? null : JSON.parse(responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : null;
            return result200;
        } else if (status !== 200 && status !== 204) {
            this.throwException("An unexpected server error occurred.", status, responseText);
        }
        return null;
    }

    protected throwException(message: string, status: number, response: string, result?: any): any {
        if(result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response);
    }
}

export class CaptchaResponse { 
    captchaId: string; 
    captchaImgBase64: string; 
    check: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.captchaId = data["captchaId"] !== undefined ? data["captchaId"] : null;
            this.captchaImgBase64 = data["captchaImgBase64"] !== undefined ? data["captchaImgBase64"] : null;
            this.check = data["check"] !== undefined ? data["check"] : null;
        }
    }

    static fromJS(data: any): CaptchaResponse {
        return new CaptchaResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["captchaId"] = this.captchaId !== undefined ? this.captchaId : null;
        data["captchaImgBase64"] = this.captchaImgBase64 !== undefined ? this.captchaImgBase64 : null;
        data["check"] = this.check !== undefined ? this.check : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CaptchaResponse(JSON.parse(json));
    }
}

export class AccountLoginRequest { 
    captchaId: string; 
    captchaCode: string; 
    username: string; 
    password: string; 
    tenantId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.captchaId = data["captchaId"] !== undefined ? data["captchaId"] : null;
            this.captchaCode = data["captchaCode"] !== undefined ? data["captchaCode"] : null;
            this.username = data["username"] !== undefined ? data["username"] : null;
            this.password = data["password"] !== undefined ? data["password"] : null;
            this.tenantId = data["tenantId"] !== undefined ? data["tenantId"] : null;
        }
    }

    static fromJS(data: any): AccountLoginRequest {
        return new AccountLoginRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["captchaId"] = this.captchaId !== undefined ? this.captchaId : null;
        data["captchaCode"] = this.captchaCode !== undefined ? this.captchaCode : null;
        data["username"] = this.username !== undefined ? this.username : null;
        data["password"] = this.password !== undefined ? this.password : null;
        data["tenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AccountLoginRequest(JSON.parse(json));
    }
}

export class AccountLoginResponse { 
    isSuccessLogin: boolean; 
    token: string; 
    lobbyAgentId: number; 
    errMsg: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccessLogin = data["isSuccessLogin"] !== undefined ? data["isSuccessLogin"] : null;
            this.token = data["token"] !== undefined ? data["token"] : null;
            this.lobbyAgentId = data["lobbyAgentId"] !== undefined ? data["lobbyAgentId"] : null;
            this.errMsg = data["errMsg"] !== undefined ? data["errMsg"] : null;
        }
    }

    static fromJS(data: any): AccountLoginResponse {
        return new AccountLoginResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccessLogin"] = this.isSuccessLogin !== undefined ? this.isSuccessLogin : null;
        data["token"] = this.token !== undefined ? this.token : null;
        data["lobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["errMsg"] = this.errMsg !== undefined ? this.errMsg : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AccountLoginResponse(JSON.parse(json));
    }
}

export class ChangePasswordRequest { 
    oldPassword: string; 
    newPassword: string; 
    confirmNewPassword: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.oldPassword = data["OldPassword"] !== undefined ? data["OldPassword"] : null;
            this.newPassword = data["NewPassword"] !== undefined ? data["NewPassword"] : null;
            this.confirmNewPassword = data["ConfirmNewPassword"] !== undefined ? data["ConfirmNewPassword"] : null;
        }
    }

    static fromJS(data: any): ChangePasswordRequest {
        return new ChangePasswordRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["OldPassword"] = this.oldPassword !== undefined ? this.oldPassword : null;
        data["NewPassword"] = this.newPassword !== undefined ? this.newPassword : null;
        data["ConfirmNewPassword"] = this.confirmNewPassword !== undefined ? this.confirmNewPassword : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ChangePasswordRequest(JSON.parse(json));
    }
}

export class ChangeUserPasswordRequest { 
    userId: number; 
    newPassword: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.userId = data["UserId"] !== undefined ? data["UserId"] : null;
            this.newPassword = data["NewPassword"] !== undefined ? data["NewPassword"] : null;
        }
    }

    static fromJS(data: any): ChangeUserPasswordRequest {
        return new ChangeUserPasswordRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["UserId"] = this.userId !== undefined ? this.userId : null;
        data["NewPassword"] = this.newPassword !== undefined ? this.newPassword : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ChangeUserPasswordRequest(JSON.parse(json));
    }
}

export class AuthorizeRoleBehaviorPerPageDao { 
    id: number; 
    behavior: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.behavior = data["Behavior"] !== undefined ? data["Behavior"] : null;
        }
    }

    static fromJS(data: any): AuthorizeRoleBehaviorPerPageDao {
        return new AuthorizeRoleBehaviorPerPageDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Behavior"] = this.behavior !== undefined ? this.behavior : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AuthorizeRoleBehaviorPerPageDao(JSON.parse(json));
    }
}

export class AuthorizeUserActionResposne { 
    isAuthorize: boolean; 
    code: number; 
    message: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.isAuthorize = data["isAuthorize"] !== undefined ? data["isAuthorize"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.message = data["message"] !== undefined ? data["message"] : null;
        }
    }

    static fromJS(data: any): AuthorizeUserActionResposne {
        return new AuthorizeUserActionResposne(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isAuthorize"] = this.isAuthorize !== undefined ? this.isAuthorize : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["message"] = this.message !== undefined ? this.message : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AuthorizeUserActionResposne(JSON.parse(json));
    }
}

export class AuthorizeUserBehaviorResposne { 
    isAuthorize: boolean; 
    code: number; 
    message: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.isAuthorize = data["isAuthorize"] !== undefined ? data["isAuthorize"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.message = data["message"] !== undefined ? data["message"] : null;
        }
    }

    static fromJS(data: any): AuthorizeUserBehaviorResposne {
        return new AuthorizeUserBehaviorResposne(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isAuthorize"] = this.isAuthorize !== undefined ? this.isAuthorize : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["message"] = this.message !== undefined ? this.message : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AuthorizeUserBehaviorResposne(JSON.parse(json));
    }
}

export enum AutoPromotionId {
    RedPacket = 3, 
    SwipeCard = 5, 
    Birthday = 6, 
    Wheel = 7, 
    FriendUnion = 8, 
    NewMemberRegister = 9, 
    FirstWithdraw = 10, 
    FirstDeposit = 11, 
    DailyFirstDeposit = 12, 
    DailySecondDeposit = 13, 
    WeeklyLiveGamePromotion = 14, 
    WeeklySlotGamePromotion = 15, 
    WeeklySportGamePromotion = 16, 
    DailyDepositXTimes = 17, 
    SecondDeposit = 18, 
    FirstDepositDepositXGiveN = 19, 
    SlotGameHierarchy1 = 20, 
    SlotGameHierarchy2 = 21, 
    DailySportGamePromotion = 22, 
    WorldCup2022DailySportGamePromotion = 23, 
    WorldCup2022SportGameOnceTimePromotion = 24, 
    ApplyThenGetPromotion = 25, 
    SlotGameHierarchy1_6 = 26, 
    SlotGameHierarchy2_6 = 27, 
    SlotGameHierarchy3_6 = 28, 
    SlotGameHierarchy4_6 = 29, 
    SlotGameHierarchy5_6 = 30, 
    DepositXGiveNHierarchy2_3 = 31, 
    DepositXGiveNHierarch3_3 = 32, 
    DailyDepositXGiveN_1 = 33, 
    DailyDepositXGiveN_2 = 34, 
    DailyDepositXGiveN_3 = 35, 
    DailyDepositXGiveN_4 = 36, 
    DailyDepositXGiveN_5 = 37, 
    DepositXGiveN_Hierarchy2 = 38, 
    DailyDepositXGiveXPencentage_1 = 39, 
    DailyDepositXGiveXPencentage_2 = 40, 
    FirstDeposit_2 = 41, 
    DailyThirdDeposit = 42, 
    FirstTimeAddBankCard = 43, 
    Insurance = 44, 
    ManualApplied_1 = 45, 
    ManualApplied_2 = 46, 
    SlotGameMissionHierarchy1_10 = 47, 
    SlotGameMissionHierarchy2_10 = 48, 
    SlotGameMissionHierarchy3_10 = 49, 
    SlotGameMissionHierarchy4_10 = 50, 
    SlotGameMissionHierarchy5_10 = 51, 
    SlotGameMissionHierarchy6_10 = 52, 
    SlotGameMissionHierarchy7_10 = 53, 
    SlotGameMissionHierarchy8_10 = 54, 
    SlotGameMissionHierarchy9_10 = 55, 
    SlotGameMissionHierarchy10_10 = 56, 
    LiveGameMissionHierarchy1_8 = 57, 
    LiveGameMissionHierarchy2_8 = 58, 
    LiveGameMissionHierarchy3_8 = 59, 
    LiveGameMissionHierarchy4_8 = 60, 
    LiveGameMissionHierarchy5_8 = 61, 
    LiveGameMissionHierarchy6_8 = 62, 
    LiveGameMissionHierarchy7_8 = 63, 
    LiveGameMissionHierarchy8_8 = 64, 
    DailyDepositXGiveXPencentage_3 = 65, 
    DailyDepositXGiveXPencentage_4 = 66, 
    DailyDepositXGiveXPencentage_5 = 67, 
    DailyDepositXGiveXPencentage_6 = 68, 
    WithoutBetInDateRange = 69, 
    Sportbook_DailyDepositXGiveNPercent = 70, 
    Sportbook_OnceTimeDepositXGiveXPencentage = 71, 
}

export enum LanguageCode {
    ZH_CN = 1, 
    EN = 2, 
    ZH = 3, 
    TH = 4, 
    KO = 5, 
    JA = 6, 
    VI = 7, 
    ID = 8, 
    MY = 9, 
    IN = 10, 
    LO = 11, 
}

export class GetForIndexResponse { 
    lobbyPromotionId: number; 
    promotionName: string; 
    totalCount: number; 
    redeemCount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.promotionName = data["PromotionName"] !== undefined ? data["PromotionName"] : null;
            this.totalCount = data["TotalCount"] !== undefined ? data["TotalCount"] : null;
            this.redeemCount = data["RedeemCount"] !== undefined ? data["RedeemCount"] : null;
        }
    }

    static fromJS(data: any): GetForIndexResponse {
        return new GetForIndexResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["PromotionName"] = this.promotionName !== undefined ? this.promotionName : null;
        data["TotalCount"] = this.totalCount !== undefined ? this.totalCount : null;
        data["RedeemCount"] = this.redeemCount !== undefined ? this.redeemCount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetForIndexResponse(JSON.parse(json));
    }
}

export class GetForPartResponse { 
    lobbyAutoPromotionId: number; 
    name: string; 
    promotionName: string; 
    startDate: Date; 
    endDate: Date; 
    totalCount: number; 
    redeemCount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyAutoPromotionId = data["LobbyAutoPromotionId"] !== undefined ? data["LobbyAutoPromotionId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.promotionName = data["PromotionName"] !== undefined ? data["PromotionName"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.totalCount = data["TotalCount"] !== undefined ? data["TotalCount"] : null;
            this.redeemCount = data["RedeemCount"] !== undefined ? data["RedeemCount"] : null;
        }
    }

    static fromJS(data: any): GetForPartResponse {
        return new GetForPartResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyAutoPromotionId"] = this.lobbyAutoPromotionId !== undefined ? this.lobbyAutoPromotionId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["PromotionName"] = this.promotionName !== undefined ? this.promotionName : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["TotalCount"] = this.totalCount !== undefined ? this.totalCount : null;
        data["RedeemCount"] = this.redeemCount !== undefined ? this.redeemCount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetForPartResponse(JSON.parse(json));
    }
}

export class GetForDetailRequest { 
    lobbyId: number; 
    autoPromotionId: AutoPromotionId; 
    lobbyPromotionId: number; 
    language: LanguageCode;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.autoPromotionId = data["AutoPromotionId"] !== undefined ? data["AutoPromotionId"] : null;
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
        }
    }

    static fromJS(data: any): GetForDetailRequest {
        return new GetForDetailRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["AutoPromotionId"] = this.autoPromotionId !== undefined ? this.autoPromotionId : null;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetForDetailRequest(JSON.parse(json));
    }
}

export class GetForDetailResponse { 
    lobbyAutoPromotionPlayerId: number; 
    name: string; 
    promotionName: string; 
    promotionNo: string; 
    amount: number; 
    isRedeem: boolean; 
    expiryDate: Date; 
    redeemBy: string; 
    redeemDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyAutoPromotionPlayerId = data["LobbyAutoPromotionPlayerId"] !== undefined ? data["LobbyAutoPromotionPlayerId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.promotionName = data["PromotionName"] !== undefined ? data["PromotionName"] : null;
            this.promotionNo = data["PromotionNo"] !== undefined ? data["PromotionNo"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.isRedeem = data["IsRedeem"] !== undefined ? data["IsRedeem"] : null;
            this.expiryDate = data["ExpiryDate"] ? new Date(data["ExpiryDate"].toString()) : null;
            this.redeemBy = data["RedeemBy"] !== undefined ? data["RedeemBy"] : null;
            this.redeemDate = data["RedeemDate"] ? new Date(data["RedeemDate"].toString()) : null;
        }
    }

    static fromJS(data: any): GetForDetailResponse {
        return new GetForDetailResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyAutoPromotionPlayerId"] = this.lobbyAutoPromotionPlayerId !== undefined ? this.lobbyAutoPromotionPlayerId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["PromotionName"] = this.promotionName !== undefined ? this.promotionName : null;
        data["PromotionNo"] = this.promotionNo !== undefined ? this.promotionNo : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["IsRedeem"] = this.isRedeem !== undefined ? this.isRedeem : null;
        data["ExpiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : null;
        data["RedeemBy"] = this.redeemBy !== undefined ? this.redeemBy : null;
        data["RedeemDate"] = this.redeemDate ? this.redeemDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetForDetailResponse(JSON.parse(json));
    }
}

export class GetForPartDetailRequest { 
    lobbyId: number; 
    autoPromotionId: AutoPromotionId; 
    lobbyAutoPromotionId: number; 
    language: LanguageCode;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.autoPromotionId = data["AutoPromotionId"] !== undefined ? data["AutoPromotionId"] : null;
            this.lobbyAutoPromotionId = data["LobbyAutoPromotionId"] !== undefined ? data["LobbyAutoPromotionId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
        }
    }

    static fromJS(data: any): GetForPartDetailRequest {
        return new GetForPartDetailRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["AutoPromotionId"] = this.autoPromotionId !== undefined ? this.autoPromotionId : null;
        data["LobbyAutoPromotionId"] = this.lobbyAutoPromotionId !== undefined ? this.lobbyAutoPromotionId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetForPartDetailRequest(JSON.parse(json));
    }
}

export class GetForPartDetailResponse { 
    lobbyPromotionId: number; 
    autoPromotions: GetForDetailResponse[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            if (data["AutoPromotions"] && data["AutoPromotions"].constructor === Array) {
                this.autoPromotions = [];
                for (let item of data["AutoPromotions"])
                    this.autoPromotions.push(GetForDetailResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetForPartDetailResponse {
        return new GetForPartDetailResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        if (this.autoPromotions && this.autoPromotions.constructor === Array) {
            data["AutoPromotions"] = [];
            for (let item of this.autoPromotions)
                data["AutoPromotions"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetForPartDetailResponse(JSON.parse(json));
    }
}

export class AddLobbyAutoPromotionPlayersRequest { 
    lobbyId: number; 
    autoPromotionId: AutoPromotionId; 
    lobbyPromotionId: number; 
    limit: number; 
    showAnimation: boolean; 
    startDate: Date; 
    endDate: Date; 
    name: string; 
    redPacket: RedPacket; 
    swipeCard: SwipeCard;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.autoPromotionId = data["AutoPromotionId"] !== undefined ? data["AutoPromotionId"] : null;
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.limit = data["Limit"] !== undefined ? data["Limit"] : null;
            this.showAnimation = data["ShowAnimation"] !== undefined ? data["ShowAnimation"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.redPacket = data["redPacket"] ? RedPacket.fromJS(data["redPacket"]) : null;
            this.swipeCard = data["swipeCard"] ? SwipeCard.fromJS(data["swipeCard"]) : null;
        }
    }

    static fromJS(data: any): AddLobbyAutoPromotionPlayersRequest {
        return new AddLobbyAutoPromotionPlayersRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["AutoPromotionId"] = this.autoPromotionId !== undefined ? this.autoPromotionId : null;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["Limit"] = this.limit !== undefined ? this.limit : null;
        data["ShowAnimation"] = this.showAnimation !== undefined ? this.showAnimation : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["redPacket"] = this.redPacket ? this.redPacket.toJS() : null;
        data["swipeCard"] = this.swipeCard ? this.swipeCard.toJS() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AddLobbyAutoPromotionPlayersRequest(JSON.parse(json));
    }
}

export class RedPacket { 
    playerAmounts: PlayerAmount[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["playerAmounts"] && data["playerAmounts"].constructor === Array) {
                this.playerAmounts = [];
                for (let item of data["playerAmounts"])
                    this.playerAmounts.push(PlayerAmount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RedPacket {
        return new RedPacket(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.playerAmounts && this.playerAmounts.constructor === Array) {
            data["playerAmounts"] = [];
            for (let item of this.playerAmounts)
                data["playerAmounts"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new RedPacket(JSON.parse(json));
    }
}

export class PlayerAmount { 
    playerId: number; 
    amount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
        }
    }

    static fromJS(data: any): PlayerAmount {
        return new PlayerAmount(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerAmount(JSON.parse(json));
    }
}

export class SwipeCard { 
    amount: number; 
    counts: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.counts = data["Counts"] !== undefined ? data["Counts"] : null;
        }
    }

    static fromJS(data: any): SwipeCard {
        return new SwipeCard(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["Counts"] = this.counts !== undefined ? this.counts : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SwipeCard(JSON.parse(json));
    }
}

export class GetForEditResponse { 
    lobbyAutoPromotionId: number; 
    lobbyPromotionId: number; 
    promotionName: string; 
    name: string; 
    startDate: Date; 
    endDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyAutoPromotionId = data["LobbyAutoPromotionId"] !== undefined ? data["LobbyAutoPromotionId"] : null;
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.promotionName = data["PromotionName"] !== undefined ? data["PromotionName"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
        }
    }

    static fromJS(data: any): GetForEditResponse {
        return new GetForEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyAutoPromotionId"] = this.lobbyAutoPromotionId !== undefined ? this.lobbyAutoPromotionId : null;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["PromotionName"] = this.promotionName !== undefined ? this.promotionName : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetForEditResponse(JSON.parse(json));
    }
}

export class EditRequest { 
    lobbyAutoPromotionId: number; 
    name: string; 
    startDate: Date; 
    endDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyAutoPromotionId = data["LobbyAutoPromotionId"] !== undefined ? data["LobbyAutoPromotionId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
        }
    }

    static fromJS(data: any): EditRequest {
        return new EditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyAutoPromotionId"] = this.lobbyAutoPromotionId !== undefined ? this.lobbyAutoPromotionId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new EditRequest(JSON.parse(json));
    }
}

export class ApplyAutoPromotionRequest { 
    playerName: string; 
    autoPromotionId: AutoPromotionId; 
    lobbyPromotionId: number; 
    promotionDate: Date; 
    transactionNo: string; 
    remark: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.autoPromotionId = data["AutoPromotionId"] !== undefined ? data["AutoPromotionId"] : null;
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.promotionDate = data["PromotionDate"] ? new Date(data["PromotionDate"].toString()) : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
        }
    }

    static fromJS(data: any): ApplyAutoPromotionRequest {
        return new ApplyAutoPromotionRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["AutoPromotionId"] = this.autoPromotionId !== undefined ? this.autoPromotionId : null;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["PromotionDate"] = this.promotionDate ? this.promotionDate.toISOString() : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ApplyAutoPromotionRequest(JSON.parse(json));
    }
}

export class StandardResponse { 
    isSuccess: boolean; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[]; 
    success: StandardResponse;

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
            this.success = data["Success"] ? StandardResponse.fromJS(data["Success"]) : null;
        }
    }

    static fromJS(data: any): StandardResponse {
        return new StandardResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["Success"] = this.success ? this.success.toJS() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponse(JSON.parse(json));
    }
}

export class StandardResponseErrorOfErrorId { 
    errorId: ErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.errorId = data["errorId"] !== undefined ? data["errorId"] : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseErrorOfErrorId {
        return new StandardResponseErrorOfErrorId(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["errorId"] = this.errorId !== undefined ? this.errorId : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseErrorOfErrorId(JSON.parse(json));
    }
}

export enum ErrorId {
    INSUFFICIENT_FUND = 1, 
    INVALID_CARD = 2, 
    INCORRECT_PARAMETERS = 3, 
    GENERAL_ERROR = 999, 
}

export class ComplainAdvice_GetAll_Request { 
    startDate: Date; 
    endDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
        }
    }

    static fromJS(data: any): ComplainAdvice_GetAll_Request {
        return new ComplainAdvice_GetAll_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ComplainAdvice_GetAll_Request(JSON.parse(json));
    }
}

export class StandardResponseOfComplainAdvice_GetAll_Response { 
    isSuccess: boolean; 
    payload: ComplainAdvice_GetAll_Response; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? ComplainAdvice_GetAll_Response.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfComplainAdvice_GetAll_Response {
        return new StandardResponseOfComplainAdvice_GetAll_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfComplainAdvice_GetAll_Response(JSON.parse(json));
    }
}

export class ComplainAdvice_GetAll_Response { 
    data: ComplainAdviceDto[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["Data"] && data["Data"].constructor === Array) {
                this.data = [];
                for (let item of data["Data"])
                    this.data.push(ComplainAdviceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComplainAdvice_GetAll_Response {
        return new ComplainAdvice_GetAll_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.data && this.data.constructor === Array) {
            data["Data"] = [];
            for (let item of this.data)
                data["Data"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ComplainAdvice_GetAll_Response(JSON.parse(json));
    }
}

export class ComplainAdviceDto { 
    id: number; 
    userName: string; 
    firstName: string; 
    lastName: string; 
    email: string; 
    phoneNo: string; 
    message: string; 
    createDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
            this.firstName = data["FirstName"] !== undefined ? data["FirstName"] : null;
            this.lastName = data["LastName"] !== undefined ? data["LastName"] : null;
            this.email = data["Email"] !== undefined ? data["Email"] : null;
            this.phoneNo = data["PhoneNo"] !== undefined ? data["PhoneNo"] : null;
            this.message = data["Message"] !== undefined ? data["Message"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
        }
    }

    static fromJS(data: any): ComplainAdviceDto {
        return new ComplainAdviceDto(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        data["FirstName"] = this.firstName !== undefined ? this.firstName : null;
        data["LastName"] = this.lastName !== undefined ? this.lastName : null;
        data["Email"] = this.email !== undefined ? this.email : null;
        data["PhoneNo"] = this.phoneNo !== undefined ? this.phoneNo : null;
        data["Message"] = this.message !== undefined ? this.message : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ComplainAdviceDto(JSON.parse(json));
    }
}

export class ComplainAdvice_GetById_Request { 
    id: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
        }
    }

    static fromJS(data: any): ComplainAdvice_GetById_Request {
        return new ComplainAdvice_GetById_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ComplainAdvice_GetById_Request(JSON.parse(json));
    }
}

export class StandardResponseOfComplainAdvice_GetById_Response { 
    isSuccess: boolean; 
    payload: ComplainAdvice_GetById_Response; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? ComplainAdvice_GetById_Response.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfComplainAdvice_GetById_Response {
        return new StandardResponseOfComplainAdvice_GetById_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfComplainAdvice_GetById_Response(JSON.parse(json));
    }
}

export class ComplainAdvice_GetById_Response { 
    data: ComplainAdviceDto;

    constructor(data?: any) {
        if (data !== undefined) {
            this.data = data["Data"] ? ComplainAdviceDto.fromJS(data["Data"]) : null;
        }
    }

    static fromJS(data: any): ComplainAdvice_GetById_Response {
        return new ComplainAdvice_GetById_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Data"] = this.data ? this.data.toJS() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ComplainAdvice_GetById_Response(JSON.parse(json));
    }
}

export class CT_GetById_Request { 
    contentTypeId: ContentTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.contentTypeId = data["contentTypeId"] !== undefined ? data["contentTypeId"] : null;
        }
    }

    static fromJS(data: any): CT_GetById_Request {
        return new CT_GetById_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["contentTypeId"] = this.contentTypeId !== undefined ? this.contentTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CT_GetById_Request(JSON.parse(json));
    }
}

export enum ContentTypeId {
    FOOTBALL_TEAM = 1, 
    FOOTBALL_MATCH = 2, 
    TODAY_WINNER = 3, 
    WEEK_WINNER = 4, 
    MONTH_WINNER = 5, 
    TOP_100_WINNER = 6, 
    LATEST_NEWS = 7, 
    NAVIGATION_BANNER = 8, 
}

export class StandardResponseOfCT_GetBetId_Response { 
    isSuccess: boolean; 
    payload: CT_GetBetId_Response; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? CT_GetBetId_Response.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfCT_GetBetId_Response {
        return new StandardResponseOfCT_GetBetId_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfCT_GetBetId_Response(JSON.parse(json));
    }
}

export class CT_GetBetId_Response { 
    contentTypeId: ContentTypeId; 
    contentTypeDescription: string; 
    masterSchema: string; 
    translationSchema: string; 
    allowAdd: boolean; 
    allowSort: boolean; 
    languages: Language[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.contentTypeId = data["contentTypeId"] !== undefined ? data["contentTypeId"] : null;
            this.contentTypeDescription = data["contentTypeDescription"] !== undefined ? data["contentTypeDescription"] : null;
            this.masterSchema = data["MasterSchema"] !== undefined ? data["MasterSchema"] : null;
            this.translationSchema = data["TranslationSchema"] !== undefined ? data["TranslationSchema"] : null;
            this.allowAdd = data["AllowAdd"] !== undefined ? data["AllowAdd"] : null;
            this.allowSort = data["AllowSort"] !== undefined ? data["AllowSort"] : null;
            if (data["Languages"] && data["Languages"].constructor === Array) {
                this.languages = [];
                for (let item of data["Languages"])
                    this.languages.push(Language.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CT_GetBetId_Response {
        return new CT_GetBetId_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["contentTypeId"] = this.contentTypeId !== undefined ? this.contentTypeId : null;
        data["contentTypeDescription"] = this.contentTypeDescription !== undefined ? this.contentTypeDescription : null;
        data["MasterSchema"] = this.masterSchema !== undefined ? this.masterSchema : null;
        data["TranslationSchema"] = this.translationSchema !== undefined ? this.translationSchema : null;
        data["AllowAdd"] = this.allowAdd !== undefined ? this.allowAdd : null;
        data["AllowSort"] = this.allowSort !== undefined ? this.allowSort : null;
        if (this.languages && this.languages.constructor === Array) {
            data["Languages"] = [];
            for (let item of this.languages)
                data["Languages"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CT_GetBetId_Response(JSON.parse(json));
    }
}

export class Language { 
    languageId: LanguageCode; 
    languageName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.languageName = data["LanguageName"] !== undefined ? data["LanguageName"] : null;
        }
    }

    static fromJS(data: any): Language {
        return new Language(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["LanguageName"] = this.languageName !== undefined ? this.languageName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new Language(JSON.parse(json));
    }
}

export class StandardResponseOfCT_GetAll_Response { 
    isSuccess: boolean; 
    payload: CT_GetAll_Response; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? CT_GetAll_Response.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfCT_GetAll_Response {
        return new StandardResponseOfCT_GetAll_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfCT_GetAll_Response(JSON.parse(json));
    }
}

export class CT_GetAll_Response { 
    items: CT_GetAll_Item[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(CT_GetAll_Item.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CT_GetAll_Response {
        return new CT_GetAll_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CT_GetAll_Response(JSON.parse(json));
    }
}

export class CT_GetAll_Item { 
    contentTypeId: ContentTypeId; 
    name: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.contentTypeId = data["contentTypeId"] !== undefined ? data["contentTypeId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
        }
    }

    static fromJS(data: any): CT_GetAll_Item {
        return new CT_GetAll_Item(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["contentTypeId"] = this.contentTypeId !== undefined ? this.contentTypeId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CT_GetAll_Item(JSON.parse(json));
    }
}

export class IT_GetRecordsRequest { 
    startDate: Date; 
    endDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
        }
    }

    static fromJS(data: any): IT_GetRecordsRequest {
        return new IT_GetRecordsRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new IT_GetRecordsRequest(JSON.parse(json));
    }
}

export class IT_GetRecordsResponse { 
    items: IT_GetRecordsResponseItem[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["Items"] && data["Items"].constructor === Array) {
                this.items = [];
                for (let item of data["Items"])
                    this.items.push(IT_GetRecordsResponseItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IT_GetRecordsResponse {
        return new IT_GetRecordsResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.items && this.items.constructor === Array) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new IT_GetRecordsResponse(JSON.parse(json));
    }
}

export class IT_GetRecordsResponseItem { 
    playerTransactionId: number; 
    createDate: Date; 
    updateDate: Date; 
    playerName: string; 
    updateBy: string; 
    transactionNo: string; 
    transactionStatus: string; 
    subGameDevId: GameDevId; 
    subGameDev: string; 
    plannedAmount: number; 
    resultAmount: number; 
    remarkByAdmin: string; 
    transactionStatusId: NewTransactionStatusId; 
    transactionType: string; 
    transactionTypeId: NewTransactionTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerTransactionId = data["PlayerTransactionId"] !== undefined ? data["PlayerTransactionId"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
            this.transactionStatus = data["TransactionStatus"] !== undefined ? data["TransactionStatus"] : null;
            this.subGameDevId = data["SubGameDevId"] !== undefined ? data["SubGameDevId"] : null;
            this.subGameDev = data["SubGameDev"] !== undefined ? data["SubGameDev"] : null;
            this.plannedAmount = data["PlannedAmount"] !== undefined ? data["PlannedAmount"] : null;
            this.resultAmount = data["ResultAmount"] !== undefined ? data["ResultAmount"] : null;
            this.remarkByAdmin = data["RemarkByAdmin"] !== undefined ? data["RemarkByAdmin"] : null;
            this.transactionStatusId = data["TransactionStatusId"] !== undefined ? data["TransactionStatusId"] : null;
            this.transactionType = data["TransactionType"] !== undefined ? data["TransactionType"] : null;
            this.transactionTypeId = data["TransactionTypeId"] !== undefined ? data["TransactionTypeId"] : null;
        }
    }

    static fromJS(data: any): IT_GetRecordsResponseItem {
        return new IT_GetRecordsResponseItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerTransactionId"] = this.playerTransactionId !== undefined ? this.playerTransactionId : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        data["TransactionStatus"] = this.transactionStatus !== undefined ? this.transactionStatus : null;
        data["SubGameDevId"] = this.subGameDevId !== undefined ? this.subGameDevId : null;
        data["SubGameDev"] = this.subGameDev !== undefined ? this.subGameDev : null;
        data["PlannedAmount"] = this.plannedAmount !== undefined ? this.plannedAmount : null;
        data["ResultAmount"] = this.resultAmount !== undefined ? this.resultAmount : null;
        data["RemarkByAdmin"] = this.remarkByAdmin !== undefined ? this.remarkByAdmin : null;
        data["TransactionStatusId"] = this.transactionStatusId !== undefined ? this.transactionStatusId : null;
        data["TransactionType"] = this.transactionType !== undefined ? this.transactionType : null;
        data["TransactionTypeId"] = this.transactionTypeId !== undefined ? this.transactionTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new IT_GetRecordsResponseItem(JSON.parse(json));
    }
}

export enum GameDevId {
    SA = 1, 
    AG = 2, 
    IM = 3, 
    SUNBET = 4, 
    BS = 5, 
    GG = 6, 
    GD = 7, 
    TTG = 8, 
    BG = 9, 
    PS = 10, 
    PP = 11, 
    SG = 12, 
    IBC = 13, 
    PT = 14, 
    MG = 15, 
    Allbet = 16, 
    ISB = 17, 
    EP = 18, 
    EBET = 19, 
    BBIN = 20, 
    WFT = 21, 
    ONES = 22, 
    HG = 23, 
    RTG = 24, 
    ThreeSing = 25, 
    IDNPlay = 27, 
    ZF = 28, 
    MyGirls = 29, 
    LEBO = 30, 
    CQ9 = 31, 
    PNG = 32, 
    Gti = 33, 
    BigGaming = 34, 
    JS = 35, 
    Sexy = 36, 
    VR = 37, 
    JDB = 38, 
    SKYWIND = 39, 
    HB = 40, 
    FG = 41, 
    NETENT = 42, 
    MW = 43, 
    GSS = 44, 
    SimplePlay = 46, 
    DG = 47, 
    Jenda = 48, 
    DS = 49, 
    Lottech = 50, 
    GamePlay = 52, 
    DT = 53, 
    KY = 54, 
    SBO = 55, 
    SlotFactory = 56, 
    HL = 57, 
    EA = 58, 
    N2 = 59, 
    ShengGame = 60, 
    JDY = 61, 
    BCS = 62, 
    PrettyGaming = 63, 
    Evolution = 64, 
    YYGaming = 65, 
    PocketGames = 66, 
    RedTiger = 67, 
    KingMaker = 68, 
    SV3888 = 69, 
    FGG = 70, 
    VivoGaming = 71, 
    Joker = 72, 
    MPPoker = 73, 
    IAEsport = 74, 
    Live22 = 75, 
    Mega888 = 76, 
    XE88 = 77, 
    TFGaming = 78, 
    Kiss918 = 79, 
    TCGaming = 80, 
    WM = 81, 
    LuckyLotto = 82, 
    PragmaticPlay = 83, 
    Jili = 84, 
    A_PocketGames = 85, 
    KAGaming = 86, 
    MarioClub = 87, 
    NextSpin = 88, 
    FC = 89, 
    AELotto = 90, 
    CMD = 91, 
    Sea_Jili = 92, 
    AWC_SEXY = 93, 
    AIGaming = 94, 
}

export enum NewTransactionStatusId {
    PENDING = 1, 
    REJECTED = 2, 
    UNPAID = 3, 
    SETTLE = 4, 
    UNDER_REVIEW = 5, 
    CANCELLED = 6, 
    FOLLOWING = 7, 
    FAIL = 8, 
    PAYMENT_FUNDOUT = 9, 
    JOINING = 10, 
    CANCELLING = 11, 
    PENDINGPAID = 12, 
}

export enum NewTransactionTypeId {
    WITHDRAW_APPLY = 1, 
    WITHDRAW_REJECT = 2, 
    REBATE = 3, 
    BET = 4, 
    PROMOTION_APPLY = 5, 
    ADMIN_ADD_POINT = 6, 
    ADMIN_DEDUCT_POINT = 7, 
    INTERNAL_TRANSFER_MAIN_TO_PLATFORM = 8, 
    INTERNAL_TRANSFER_PLATFORM_TO_MAIN = 9, 
    SYSTEM_ERROR = 10, 
    SYSTEM_REFUND = 11, 
    MANUAL_DEPOSIT = 12, 
    ONLINE_BANK = 13, 
    WECHAT = 14, 
    ALIPAY = 15, 
    QQPAY = 16, 
    JDPAY = 17, 
    PROMOTION_CANCEL = 18, 
    AGENT_DEPOSIT = 19, 
    UNIONPAY = 20, 
    ALIPAY_TRANSFER_BANK = 21, 
    QUICK_PAYMENT = 22, 
    RECHARGE_CARD = 23, 
    BONUS_POINT_ADD_POINT = 24, 
    BONUS_POINT_DEDUCT_POINT = 25, 
    ALIPAY_3 = 26, 
    FUND_OUT = 27, 
    WECHAT_2 = 28, 
    CRYPTOCURRENCY = 29, 
    WITHDRAW_CRYPTOCURRENCY_APPLY = 30, 
    WITHDRAW_CRYPTOCURRENCY_REJECTED = 31, 
    QRCODE = 32, 
    MOMOPAY = 33, 
    ZALOPAY = 34, 
    VIETTELPAY = 35, 
    CRYPTO_FUND_OUT = 36, 
    DIGITAL_WALLET_DEPOSIT = 37, 
    PURCHASE = 38, 
    REWARDING_HARSH_OFFICAIALS = 39, 
}

export class IT_GetByIdRequest { 
    playerTransactionId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerTransactionId = data["PlayerTransactionId"] !== undefined ? data["PlayerTransactionId"] : null;
        }
    }

    static fromJS(data: any): IT_GetByIdRequest {
        return new IT_GetByIdRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerTransactionId"] = this.playerTransactionId !== undefined ? this.playerTransactionId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new IT_GetByIdRequest(JSON.parse(json));
    }
}

export class IT_GetByIdResponse { 
    item: IT_GetRecordsResponseItem;

    constructor(data?: any) {
        if (data !== undefined) {
            this.item = data["Item"] ? IT_GetRecordsResponseItem.fromJS(data["Item"]) : null;
        }
    }

    static fromJS(data: any): IT_GetByIdResponse {
        return new IT_GetByIdResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Item"] = this.item ? this.item.toJS() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new IT_GetByIdResponse(JSON.parse(json));
    }
}

export class IT_RefillMissingPointRequest { 
    playerTransactionId: number; 
    remark: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerTransactionId = data["PlayerTransactionId"] !== undefined ? data["PlayerTransactionId"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
        }
    }

    static fromJS(data: any): IT_RefillMissingPointRequest {
        return new IT_RefillMissingPointRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerTransactionId"] = this.playerTransactionId !== undefined ? this.playerTransactionId : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new IT_RefillMissingPointRequest(JSON.parse(json));
    }
}

export class IT_CompleteWithoutRefillingRequest { 
    playerTransactionId: number; 
    remark: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerTransactionId = data["PlayerTransactionId"] !== undefined ? data["PlayerTransactionId"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
        }
    }

    static fromJS(data: any): IT_CompleteWithoutRefillingRequest {
        return new IT_CompleteWithoutRefillingRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerTransactionId"] = this.playerTransactionId !== undefined ? this.playerTransactionId : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new IT_CompleteWithoutRefillingRequest(JSON.parse(json));
    }
}

export class LobbyDomainGetRequest { 
    domainTypeId: DomainTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.domainTypeId = data["DomainTypeId"] !== undefined ? data["DomainTypeId"] : null;
        }
    }

    static fromJS(data: any): LobbyDomainGetRequest {
        return new LobbyDomainGetRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["DomainTypeId"] = this.domainTypeId !== undefined ? this.domainTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyDomainGetRequest(JSON.parse(json));
    }
}

export enum DomainTypeId {
    CashSite = 1, 
    BO = 2, 
    BOApi = 3, 
    LandingPage = 4, 
}

export class StandardResponseOfLobbyDomainGetResponse { 
    isSuccess: boolean; 
    payload: LobbyDomainGetResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? LobbyDomainGetResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfLobbyDomainGetResponse {
        return new StandardResponseOfLobbyDomainGetResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfLobbyDomainGetResponse(JSON.parse(json));
    }
}

export class LobbyDomainGetResponse { 
    lobbyDomainList: BOLobbyDomainDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["LobbyDomainList"] && data["LobbyDomainList"].constructor === Array) {
                this.lobbyDomainList = [];
                for (let item of data["LobbyDomainList"])
                    this.lobbyDomainList.push(BOLobbyDomainDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyDomainGetResponse {
        return new LobbyDomainGetResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.lobbyDomainList && this.lobbyDomainList.constructor === Array) {
            data["LobbyDomainList"] = [];
            for (let item of this.lobbyDomainList)
                data["LobbyDomainList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyDomainGetResponse(JSON.parse(json));
    }
}

export class BOLobbyDomainDao { 
    id: number; 
    domainTypeId: DomainTypeId; 
    domain: string; 
    remark: string; 
    isEnable: boolean; 
    createDate: Date; 
    updateDate: Date; 
    updateBy: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.domainTypeId = data["DomainTypeId"] !== undefined ? data["DomainTypeId"] : null;
            this.domain = data["Domain"] !== undefined ? data["Domain"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
        }
    }

    static fromJS(data: any): BOLobbyDomainDao {
        return new BOLobbyDomainDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["DomainTypeId"] = this.domainTypeId !== undefined ? this.domainTypeId : null;
        data["Domain"] = this.domain !== undefined ? this.domain : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new BOLobbyDomainDao(JSON.parse(json));
    }
}

export class LobbyDomainUpdateIsEnableRequest { 
    id: number; 
    isEnable: boolean; 
    remark: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
        }
    }

    static fromJS(data: any): LobbyDomainUpdateIsEnableRequest {
        return new LobbyDomainUpdateIsEnableRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyDomainUpdateIsEnableRequest(JSON.parse(json));
    }
}

export class StandardResponseOfListOfLobbyDigitalWalletAccountDao { 
    isSuccess: boolean; 
    payload: LobbyDigitalWalletAccountDao[]; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            if (data["payload"] && data["payload"].constructor === Array) {
                this.payload = [];
                for (let item of data["payload"])
                    this.payload.push(LobbyDigitalWalletAccountDao.fromJS(item));
            }
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfListOfLobbyDigitalWalletAccountDao {
        return new StandardResponseOfListOfLobbyDigitalWalletAccountDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.payload && this.payload.constructor === Array) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item.toJS());
        }
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfListOfLobbyDigitalWalletAccountDao(JSON.parse(json));
    }
}

export class LobbyDigitalWalletAccountDao { 
    id: number; 
    lobbyDigitalWalletId: number; 
    lobbyDigitalWalletName: string; 
    accountNo: string; 
    userName: string; 
    updateBy: number; 
    updateByUserName: string; 
    updateDate: Date; 
    createDate: Date; 
    isPublish: boolean; 
    qrcodeDesktop: string; 
    qrcodeMobile: string; 
    lobbyPlayerLevelId: number; 
    lobbyPlayerLevel: string; 
    lobbyPlayerGroupId: number; 
    lobbyPlayerGroup: string; 
    isDelete: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.lobbyDigitalWalletId = data["LobbyDigitalWalletId"] !== undefined ? data["LobbyDigitalWalletId"] : null;
            this.lobbyDigitalWalletName = data["LobbyDigitalWalletName"] !== undefined ? data["LobbyDigitalWalletName"] : null;
            this.accountNo = data["AccountNo"] !== undefined ? data["AccountNo"] : null;
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.updateByUserName = data["UpdateByUserName"] !== undefined ? data["UpdateByUserName"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
            this.qrcodeDesktop = data["QrcodeDesktop"] !== undefined ? data["QrcodeDesktop"] : null;
            this.qrcodeMobile = data["QrcodeMobile"] !== undefined ? data["QrcodeMobile"] : null;
            this.lobbyPlayerLevelId = data["LobbyPlayerLevelId"] !== undefined ? data["LobbyPlayerLevelId"] : null;
            this.lobbyPlayerLevel = data["LobbyPlayerLevel"] !== undefined ? data["LobbyPlayerLevel"] : null;
            this.lobbyPlayerGroupId = data["LobbyPlayerGroupId"] !== undefined ? data["LobbyPlayerGroupId"] : null;
            this.lobbyPlayerGroup = data["LobbyPlayerGroup"] !== undefined ? data["LobbyPlayerGroup"] : null;
            this.isDelete = data["IsDelete"] !== undefined ? data["IsDelete"] : null;
        }
    }

    static fromJS(data: any): LobbyDigitalWalletAccountDao {
        return new LobbyDigitalWalletAccountDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["LobbyDigitalWalletId"] = this.lobbyDigitalWalletId !== undefined ? this.lobbyDigitalWalletId : null;
        data["LobbyDigitalWalletName"] = this.lobbyDigitalWalletName !== undefined ? this.lobbyDigitalWalletName : null;
        data["AccountNo"] = this.accountNo !== undefined ? this.accountNo : null;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["UpdateByUserName"] = this.updateByUserName !== undefined ? this.updateByUserName : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        data["QrcodeDesktop"] = this.qrcodeDesktop !== undefined ? this.qrcodeDesktop : null;
        data["QrcodeMobile"] = this.qrcodeMobile !== undefined ? this.qrcodeMobile : null;
        data["LobbyPlayerLevelId"] = this.lobbyPlayerLevelId !== undefined ? this.lobbyPlayerLevelId : null;
        data["LobbyPlayerLevel"] = this.lobbyPlayerLevel !== undefined ? this.lobbyPlayerLevel : null;
        data["LobbyPlayerGroupId"] = this.lobbyPlayerGroupId !== undefined ? this.lobbyPlayerGroupId : null;
        data["LobbyPlayerGroup"] = this.lobbyPlayerGroup !== undefined ? this.lobbyPlayerGroup : null;
        data["IsDelete"] = this.isDelete !== undefined ? this.isDelete : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyDigitalWalletAccountDao(JSON.parse(json));
    }
}

export class StandardResponseOfLobbyDigitalWalletAccountGetForEditResponse { 
    isSuccess: boolean; 
    payload: LobbyDigitalWalletAccountGetForEditResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? LobbyDigitalWalletAccountGetForEditResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfLobbyDigitalWalletAccountGetForEditResponse {
        return new StandardResponseOfLobbyDigitalWalletAccountGetForEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfLobbyDigitalWalletAccountGetForEditResponse(JSON.parse(json));
    }
}

export class LobbyDigitalWalletAccountGetForEditResponse { 
    lobbyDigitalWalletAccount: LobbyDigitalWalletAccountDao; 
    lobbyDigitalWalletOptions: CmsSelectionOptionDao[]; 
    lobbyPlayerLevelOptions: CmsSelectionOptionDao[]; 
    lobbyPlayerGroupOptions: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyDigitalWalletAccount = data["LobbyDigitalWalletAccount"] ? LobbyDigitalWalletAccountDao.fromJS(data["LobbyDigitalWalletAccount"]) : null;
            if (data["LobbyDigitalWalletOptions"] && data["LobbyDigitalWalletOptions"].constructor === Array) {
                this.lobbyDigitalWalletOptions = [];
                for (let item of data["LobbyDigitalWalletOptions"])
                    this.lobbyDigitalWalletOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["LobbyPlayerLevelOptions"] && data["LobbyPlayerLevelOptions"].constructor === Array) {
                this.lobbyPlayerLevelOptions = [];
                for (let item of data["LobbyPlayerLevelOptions"])
                    this.lobbyPlayerLevelOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["LobbyPlayerGroupOptions"] && data["LobbyPlayerGroupOptions"].constructor === Array) {
                this.lobbyPlayerGroupOptions = [];
                for (let item of data["LobbyPlayerGroupOptions"])
                    this.lobbyPlayerGroupOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyDigitalWalletAccountGetForEditResponse {
        return new LobbyDigitalWalletAccountGetForEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyDigitalWalletAccount"] = this.lobbyDigitalWalletAccount ? this.lobbyDigitalWalletAccount.toJS() : null;
        if (this.lobbyDigitalWalletOptions && this.lobbyDigitalWalletOptions.constructor === Array) {
            data["LobbyDigitalWalletOptions"] = [];
            for (let item of this.lobbyDigitalWalletOptions)
                data["LobbyDigitalWalletOptions"].push(item.toJS());
        }
        if (this.lobbyPlayerLevelOptions && this.lobbyPlayerLevelOptions.constructor === Array) {
            data["LobbyPlayerLevelOptions"] = [];
            for (let item of this.lobbyPlayerLevelOptions)
                data["LobbyPlayerLevelOptions"].push(item.toJS());
        }
        if (this.lobbyPlayerGroupOptions && this.lobbyPlayerGroupOptions.constructor === Array) {
            data["LobbyPlayerGroupOptions"] = [];
            for (let item of this.lobbyPlayerGroupOptions)
                data["LobbyPlayerGroupOptions"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyDigitalWalletAccountGetForEditResponse(JSON.parse(json));
    }
}

export class CmsSelectionOptionDao { 
    value: string; 
    label: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.value = data["Value"] !== undefined ? data["Value"] : null;
            this.label = data["Label"] !== undefined ? data["Label"] : null;
        }
    }

    static fromJS(data: any): CmsSelectionOptionDao {
        return new CmsSelectionOptionDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Value"] = this.value !== undefined ? this.value : null;
        data["Label"] = this.label !== undefined ? this.label : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CmsSelectionOptionDao(JSON.parse(json));
    }
}

export class StandardResponseOfLobbyDigitalWalletAccountGetForAddResponse { 
    isSuccess: boolean; 
    payload: LobbyDigitalWalletAccountGetForAddResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? LobbyDigitalWalletAccountGetForAddResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfLobbyDigitalWalletAccountGetForAddResponse {
        return new StandardResponseOfLobbyDigitalWalletAccountGetForAddResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfLobbyDigitalWalletAccountGetForAddResponse(JSON.parse(json));
    }
}

export class LobbyDigitalWalletAccountGetForAddResponse { 
    lobbyDigitalWalletOptions: CmsSelectionOptionDao[]; 
    lobbyPlayerLevelOptions: CmsSelectionOptionDao[]; 
    lobbyPlayerGroupOptions: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["LobbyDigitalWalletOptions"] && data["LobbyDigitalWalletOptions"].constructor === Array) {
                this.lobbyDigitalWalletOptions = [];
                for (let item of data["LobbyDigitalWalletOptions"])
                    this.lobbyDigitalWalletOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["LobbyPlayerLevelOptions"] && data["LobbyPlayerLevelOptions"].constructor === Array) {
                this.lobbyPlayerLevelOptions = [];
                for (let item of data["LobbyPlayerLevelOptions"])
                    this.lobbyPlayerLevelOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["LobbyPlayerGroupOptions"] && data["LobbyPlayerGroupOptions"].constructor === Array) {
                this.lobbyPlayerGroupOptions = [];
                for (let item of data["LobbyPlayerGroupOptions"])
                    this.lobbyPlayerGroupOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyDigitalWalletAccountGetForAddResponse {
        return new LobbyDigitalWalletAccountGetForAddResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.lobbyDigitalWalletOptions && this.lobbyDigitalWalletOptions.constructor === Array) {
            data["LobbyDigitalWalletOptions"] = [];
            for (let item of this.lobbyDigitalWalletOptions)
                data["LobbyDigitalWalletOptions"].push(item.toJS());
        }
        if (this.lobbyPlayerLevelOptions && this.lobbyPlayerLevelOptions.constructor === Array) {
            data["LobbyPlayerLevelOptions"] = [];
            for (let item of this.lobbyPlayerLevelOptions)
                data["LobbyPlayerLevelOptions"].push(item.toJS());
        }
        if (this.lobbyPlayerGroupOptions && this.lobbyPlayerGroupOptions.constructor === Array) {
            data["LobbyPlayerGroupOptions"] = [];
            for (let item of this.lobbyPlayerGroupOptions)
                data["LobbyPlayerGroupOptions"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyDigitalWalletAccountGetForAddResponse(JSON.parse(json));
    }
}

export class LobbyDigitalWalletAccountCreateEditRequest { 
    lobbyDigitalWalletAccount: LobbyDigitalWalletAccountDao;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyDigitalWalletAccount = data["LobbyDigitalWalletAccount"] ? LobbyDigitalWalletAccountDao.fromJS(data["LobbyDigitalWalletAccount"]) : null;
        }
    }

    static fromJS(data: any): LobbyDigitalWalletAccountCreateEditRequest {
        return new LobbyDigitalWalletAccountCreateEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyDigitalWalletAccount"] = this.lobbyDigitalWalletAccount ? this.lobbyDigitalWalletAccount.toJS() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyDigitalWalletAccountCreateEditRequest(JSON.parse(json));
    }
}

export class StandardResult { 
    isSuccess: boolean; 
    errors: string[]; 
    success: StandardResult;

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            if (data["Errors"] && data["Errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["Errors"])
                    this.errors.push(item);
            }
            this.success = data["Success"] ? StandardResult.fromJS(data["Success"]) : null;
        }
    }

    static fromJS(data: any): StandardResult {
        return new StandardResult(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.errors && this.errors.constructor === Array) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        data["Success"] = this.success ? this.success.toJS() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResult(JSON.parse(json));
    }
}

export class StandardResultOfLobbyDigitalWalletAccountIsAccountNoExistResponse { 
    isSuccess: boolean; 
    payload: LobbyDigitalWalletAccountIsAccountNoExistResponse; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            this.payload = data["Payload"] ? LobbyDigitalWalletAccountIsAccountNoExistResponse.fromJS(data["Payload"]) : null;
            if (data["Errors"] && data["Errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["Errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResultOfLobbyDigitalWalletAccountIsAccountNoExistResponse {
        return new StandardResultOfLobbyDigitalWalletAccountIsAccountNoExistResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["Payload"] = this.payload ? this.payload.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResultOfLobbyDigitalWalletAccountIsAccountNoExistResponse(JSON.parse(json));
    }
}

export class LobbyDigitalWalletAccountIsAccountNoExistResponse { 
    isAccountNoExist: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.isAccountNoExist = data["IsAccountNoExist"] !== undefined ? data["IsAccountNoExist"] : null;
        }
    }

    static fromJS(data: any): LobbyDigitalWalletAccountIsAccountNoExistResponse {
        return new LobbyDigitalWalletAccountIsAccountNoExistResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsAccountNoExist"] = this.isAccountNoExist !== undefined ? this.isAccountNoExist : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyDigitalWalletAccountIsAccountNoExistResponse(JSON.parse(json));
    }
}

export class LobbyBankAccountResponse { 
    id: number; 
    lobbyBankId: number; 
    lobbyBankName: string; 
    accountNo: string; 
    username: string; 
    toPlayerLevelName: string; 
    toPlayerGroupName: string; 
    isPublish: boolean; 
    isPublishForAlipay: boolean; 
    isPublishForOnlineBank: boolean; 
    updateDate: Date; 
    createDate: Date; 
    isDelete: boolean; 
    apiCardNo: string; 
    apiBankAccount: string; 
    apiBankMark: string; 
    apiBankName: string; 
    apiCardIndex: string; 
    paymentPlatform: string; 
    currencyName: string; 
    currencyId: CurrencyId; 
    isMaintainRepeatEveryDay: boolean; 
    repeatEveryDayDateStart: string; 
    repeatEveryDayDateEnd: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.lobbyBankId = data["LobbyBankId"] !== undefined ? data["LobbyBankId"] : null;
            this.lobbyBankName = data["LobbyBankName"] !== undefined ? data["LobbyBankName"] : null;
            this.accountNo = data["AccountNo"] !== undefined ? data["AccountNo"] : null;
            this.username = data["Username"] !== undefined ? data["Username"] : null;
            this.toPlayerLevelName = data["ToPlayerLevelName"] !== undefined ? data["ToPlayerLevelName"] : null;
            this.toPlayerGroupName = data["ToPlayerGroupName"] !== undefined ? data["ToPlayerGroupName"] : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
            this.isPublishForAlipay = data["IsPublishForAlipay"] !== undefined ? data["IsPublishForAlipay"] : null;
            this.isPublishForOnlineBank = data["IsPublishForOnlineBank"] !== undefined ? data["IsPublishForOnlineBank"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.isDelete = data["IsDelete"] !== undefined ? data["IsDelete"] : null;
            this.apiCardNo = data["ApiCardNo"] !== undefined ? data["ApiCardNo"] : null;
            this.apiBankAccount = data["ApiBankAccount"] !== undefined ? data["ApiBankAccount"] : null;
            this.apiBankMark = data["ApiBankMark"] !== undefined ? data["ApiBankMark"] : null;
            this.apiBankName = data["ApiBankName"] !== undefined ? data["ApiBankName"] : null;
            this.apiCardIndex = data["ApiCardIndex"] !== undefined ? data["ApiCardIndex"] : null;
            this.paymentPlatform = data["PaymentPlatform"] !== undefined ? data["PaymentPlatform"] : null;
            this.currencyName = data["CurrencyName"] !== undefined ? data["CurrencyName"] : null;
            this.currencyId = data["CurrencyId"] !== undefined ? data["CurrencyId"] : null;
            this.isMaintainRepeatEveryDay = data["IsMaintainRepeatEveryDay"] !== undefined ? data["IsMaintainRepeatEveryDay"] : null;
            this.repeatEveryDayDateStart = data["RepeatEveryDayDateStart"] !== undefined ? data["RepeatEveryDayDateStart"] : null;
            this.repeatEveryDayDateEnd = data["RepeatEveryDayDateEnd"] !== undefined ? data["RepeatEveryDayDateEnd"] : null;
        }
    }

    static fromJS(data: any): LobbyBankAccountResponse {
        return new LobbyBankAccountResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["LobbyBankId"] = this.lobbyBankId !== undefined ? this.lobbyBankId : null;
        data["LobbyBankName"] = this.lobbyBankName !== undefined ? this.lobbyBankName : null;
        data["AccountNo"] = this.accountNo !== undefined ? this.accountNo : null;
        data["Username"] = this.username !== undefined ? this.username : null;
        data["ToPlayerLevelName"] = this.toPlayerLevelName !== undefined ? this.toPlayerLevelName : null;
        data["ToPlayerGroupName"] = this.toPlayerGroupName !== undefined ? this.toPlayerGroupName : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        data["IsPublishForAlipay"] = this.isPublishForAlipay !== undefined ? this.isPublishForAlipay : null;
        data["IsPublishForOnlineBank"] = this.isPublishForOnlineBank !== undefined ? this.isPublishForOnlineBank : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["IsDelete"] = this.isDelete !== undefined ? this.isDelete : null;
        data["ApiCardNo"] = this.apiCardNo !== undefined ? this.apiCardNo : null;
        data["ApiBankAccount"] = this.apiBankAccount !== undefined ? this.apiBankAccount : null;
        data["ApiBankMark"] = this.apiBankMark !== undefined ? this.apiBankMark : null;
        data["ApiBankName"] = this.apiBankName !== undefined ? this.apiBankName : null;
        data["ApiCardIndex"] = this.apiCardIndex !== undefined ? this.apiCardIndex : null;
        data["PaymentPlatform"] = this.paymentPlatform !== undefined ? this.paymentPlatform : null;
        data["CurrencyName"] = this.currencyName !== undefined ? this.currencyName : null;
        data["CurrencyId"] = this.currencyId !== undefined ? this.currencyId : null;
        data["IsMaintainRepeatEveryDay"] = this.isMaintainRepeatEveryDay !== undefined ? this.isMaintainRepeatEveryDay : null;
        data["RepeatEveryDayDateStart"] = this.repeatEveryDayDateStart !== undefined ? this.repeatEveryDayDateStart : null;
        data["RepeatEveryDayDateEnd"] = this.repeatEveryDayDateEnd !== undefined ? this.repeatEveryDayDateEnd : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyBankAccountResponse(JSON.parse(json));
    }
}

export enum CurrencyId {
    CNY = 1, 
    USD = 2, 
    THB = 3, 
    BTC = 4, 
    ETH = 5, 
    USDT_OMNI = 6, 
    USDT_ERC20 = 7, 
    USDC = 8, 
    TUSD = 9, 
    PAX = 10, 
    HKD = 11, 
    JPY = 12, 
    TTC = 13, 
    SAD = 14, 
    VND = 15, 
    USDT_TRC20 = 16, 
    LAK = 17, 
}

export class LobbyBankAccountGetForAddResponse { 
    lobbyBankOptions: CmsSelectionOptionDao[]; 
    lobbyPlayerLevelOptions: CmsSelectionOptionDao[]; 
    lobbyPlayerGroupOptions: CmsSelectionOptionDao[]; 
    lobbyLanguages: LanguageDao[]; 
    bankCardPaymentPlatformOptions: CmsSelectionOptionDao[]; 
    currencyOptions: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["lobbyBankOptions"] && data["lobbyBankOptions"].constructor === Array) {
                this.lobbyBankOptions = [];
                for (let item of data["lobbyBankOptions"])
                    this.lobbyBankOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["lobbyPlayerLevelOptions"] && data["lobbyPlayerLevelOptions"].constructor === Array) {
                this.lobbyPlayerLevelOptions = [];
                for (let item of data["lobbyPlayerLevelOptions"])
                    this.lobbyPlayerLevelOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["lobbyPlayerGroupOptions"] && data["lobbyPlayerGroupOptions"].constructor === Array) {
                this.lobbyPlayerGroupOptions = [];
                for (let item of data["lobbyPlayerGroupOptions"])
                    this.lobbyPlayerGroupOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["lobbyLanguages"] && data["lobbyLanguages"].constructor === Array) {
                this.lobbyLanguages = [];
                for (let item of data["lobbyLanguages"])
                    this.lobbyLanguages.push(LanguageDao.fromJS(item));
            }
            if (data["bankCardPaymentPlatformOptions"] && data["bankCardPaymentPlatformOptions"].constructor === Array) {
                this.bankCardPaymentPlatformOptions = [];
                for (let item of data["bankCardPaymentPlatformOptions"])
                    this.bankCardPaymentPlatformOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["currencyOptions"] && data["currencyOptions"].constructor === Array) {
                this.currencyOptions = [];
                for (let item of data["currencyOptions"])
                    this.currencyOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyBankAccountGetForAddResponse {
        return new LobbyBankAccountGetForAddResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.lobbyBankOptions && this.lobbyBankOptions.constructor === Array) {
            data["lobbyBankOptions"] = [];
            for (let item of this.lobbyBankOptions)
                data["lobbyBankOptions"].push(item.toJS());
        }
        if (this.lobbyPlayerLevelOptions && this.lobbyPlayerLevelOptions.constructor === Array) {
            data["lobbyPlayerLevelOptions"] = [];
            for (let item of this.lobbyPlayerLevelOptions)
                data["lobbyPlayerLevelOptions"].push(item.toJS());
        }
        if (this.lobbyPlayerGroupOptions && this.lobbyPlayerGroupOptions.constructor === Array) {
            data["lobbyPlayerGroupOptions"] = [];
            for (let item of this.lobbyPlayerGroupOptions)
                data["lobbyPlayerGroupOptions"].push(item.toJS());
        }
        if (this.lobbyLanguages && this.lobbyLanguages.constructor === Array) {
            data["lobbyLanguages"] = [];
            for (let item of this.lobbyLanguages)
                data["lobbyLanguages"].push(item.toJS());
        }
        if (this.bankCardPaymentPlatformOptions && this.bankCardPaymentPlatformOptions.constructor === Array) {
            data["bankCardPaymentPlatformOptions"] = [];
            for (let item of this.bankCardPaymentPlatformOptions)
                data["bankCardPaymentPlatformOptions"].push(item.toJS());
        }
        if (this.currencyOptions && this.currencyOptions.constructor === Array) {
            data["currencyOptions"] = [];
            for (let item of this.currencyOptions)
                data["currencyOptions"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyBankAccountGetForAddResponse(JSON.parse(json));
    }
}

export class LanguageDao { 
    languageId: number; 
    languageName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.languageName = data["LanguageName"] !== undefined ? data["LanguageName"] : null;
        }
    }

    static fromJS(data: any): LanguageDao {
        return new LanguageDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["LanguageName"] = this.languageName !== undefined ? this.languageName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LanguageDao(JSON.parse(json));
    }
}

export class LobbyBankAccountCreateRequest { 
    lobbyBankId: number; 
    accountNo: string; 
    username: string; 
    lobbyPlayerLevelId: number; 
    lobbyPlayerGroupId: number; 
    isPublish: boolean; 
    apiCardNo: string; 
    apiBankAccountNo: string; 
    apiBankMark: string; 
    apiBankName: string; 
    apiCardIndex: string; 
    isPublishForAlipay: boolean; 
    isPublishForOnlineBank: boolean; 
    lobbyBankAccountLanguages: LobbyBankAccountLanguageDao[]; 
    deviceId: string; 
    pin: string; 
    paymentPlatformId: PaymentGatewayPlatformId; 
    desktopQrcodePath: string; 
    mobileQrcodePath: string; 
    currencyId: CurrencyId; 
    password: string; 
    appUserName: string; 
    isMaintainRepeatEveryDay: boolean; 
    repeatEveryDayDateStart: string; 
    repeatEveryDayDateEnd: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyBankId = data["LobbyBankId"] !== undefined ? data["LobbyBankId"] : null;
            this.accountNo = data["AccountNo"] !== undefined ? data["AccountNo"] : null;
            this.username = data["Username"] !== undefined ? data["Username"] : null;
            this.lobbyPlayerLevelId = data["LobbyPlayerLevelId"] !== undefined ? data["LobbyPlayerLevelId"] : null;
            this.lobbyPlayerGroupId = data["LobbyPlayerGroupId"] !== undefined ? data["LobbyPlayerGroupId"] : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
            this.apiCardNo = data["ApiCardNo"] !== undefined ? data["ApiCardNo"] : null;
            this.apiBankAccountNo = data["ApiBankAccountNo"] !== undefined ? data["ApiBankAccountNo"] : null;
            this.apiBankMark = data["ApiBankMark"] !== undefined ? data["ApiBankMark"] : null;
            this.apiBankName = data["ApiBankName"] !== undefined ? data["ApiBankName"] : null;
            this.apiCardIndex = data["ApiCardIndex"] !== undefined ? data["ApiCardIndex"] : null;
            this.isPublishForAlipay = data["IsPublishForAlipay"] !== undefined ? data["IsPublishForAlipay"] : null;
            this.isPublishForOnlineBank = data["IsPublishForOnlineBank"] !== undefined ? data["IsPublishForOnlineBank"] : null;
            if (data["LobbyBankAccountLanguages"] && data["LobbyBankAccountLanguages"].constructor === Array) {
                this.lobbyBankAccountLanguages = [];
                for (let item of data["LobbyBankAccountLanguages"])
                    this.lobbyBankAccountLanguages.push(LobbyBankAccountLanguageDao.fromJS(item));
            }
            this.deviceId = data["DeviceId"] !== undefined ? data["DeviceId"] : null;
            this.pin = data["Pin"] !== undefined ? data["Pin"] : null;
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.desktopQrcodePath = data["DesktopQrcodePath"] !== undefined ? data["DesktopQrcodePath"] : null;
            this.mobileQrcodePath = data["MobileQrcodePath"] !== undefined ? data["MobileQrcodePath"] : null;
            this.currencyId = data["CurrencyId"] !== undefined ? data["CurrencyId"] : null;
            this.password = data["Password"] !== undefined ? data["Password"] : null;
            this.appUserName = data["AppUserName"] !== undefined ? data["AppUserName"] : null;
            this.isMaintainRepeatEveryDay = data["IsMaintainRepeatEveryDay"] !== undefined ? data["IsMaintainRepeatEveryDay"] : null;
            this.repeatEveryDayDateStart = data["RepeatEveryDayDateStart"] !== undefined ? data["RepeatEveryDayDateStart"] : null;
            this.repeatEveryDayDateEnd = data["RepeatEveryDayDateEnd"] !== undefined ? data["RepeatEveryDayDateEnd"] : null;
        }
    }

    static fromJS(data: any): LobbyBankAccountCreateRequest {
        return new LobbyBankAccountCreateRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyBankId"] = this.lobbyBankId !== undefined ? this.lobbyBankId : null;
        data["AccountNo"] = this.accountNo !== undefined ? this.accountNo : null;
        data["Username"] = this.username !== undefined ? this.username : null;
        data["LobbyPlayerLevelId"] = this.lobbyPlayerLevelId !== undefined ? this.lobbyPlayerLevelId : null;
        data["LobbyPlayerGroupId"] = this.lobbyPlayerGroupId !== undefined ? this.lobbyPlayerGroupId : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        data["ApiCardNo"] = this.apiCardNo !== undefined ? this.apiCardNo : null;
        data["ApiBankAccountNo"] = this.apiBankAccountNo !== undefined ? this.apiBankAccountNo : null;
        data["ApiBankMark"] = this.apiBankMark !== undefined ? this.apiBankMark : null;
        data["ApiBankName"] = this.apiBankName !== undefined ? this.apiBankName : null;
        data["ApiCardIndex"] = this.apiCardIndex !== undefined ? this.apiCardIndex : null;
        data["IsPublishForAlipay"] = this.isPublishForAlipay !== undefined ? this.isPublishForAlipay : null;
        data["IsPublishForOnlineBank"] = this.isPublishForOnlineBank !== undefined ? this.isPublishForOnlineBank : null;
        if (this.lobbyBankAccountLanguages && this.lobbyBankAccountLanguages.constructor === Array) {
            data["LobbyBankAccountLanguages"] = [];
            for (let item of this.lobbyBankAccountLanguages)
                data["LobbyBankAccountLanguages"].push(item.toJS());
        }
        data["DeviceId"] = this.deviceId !== undefined ? this.deviceId : null;
        data["Pin"] = this.pin !== undefined ? this.pin : null;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["DesktopQrcodePath"] = this.desktopQrcodePath !== undefined ? this.desktopQrcodePath : null;
        data["MobileQrcodePath"] = this.mobileQrcodePath !== undefined ? this.mobileQrcodePath : null;
        data["CurrencyId"] = this.currencyId !== undefined ? this.currencyId : null;
        data["Password"] = this.password !== undefined ? this.password : null;
        data["AppUserName"] = this.appUserName !== undefined ? this.appUserName : null;
        data["IsMaintainRepeatEveryDay"] = this.isMaintainRepeatEveryDay !== undefined ? this.isMaintainRepeatEveryDay : null;
        data["RepeatEveryDayDateStart"] = this.repeatEveryDayDateStart !== undefined ? this.repeatEveryDayDateStart : null;
        data["RepeatEveryDayDateEnd"] = this.repeatEveryDayDateEnd !== undefined ? this.repeatEveryDayDateEnd : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyBankAccountCreateRequest(JSON.parse(json));
    }
}

export class LobbyBankAccountLanguageDao { 
    lobbyBankAccountId: number; 
    languageId: number; 
    displayName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyBankAccountId = data["LobbyBankAccountId"] !== undefined ? data["LobbyBankAccountId"] : null;
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.displayName = data["DisplayName"] !== undefined ? data["DisplayName"] : null;
        }
    }

    static fromJS(data: any): LobbyBankAccountLanguageDao {
        return new LobbyBankAccountLanguageDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyBankAccountId"] = this.lobbyBankAccountId !== undefined ? this.lobbyBankAccountId : null;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["DisplayName"] = this.displayName !== undefined ? this.displayName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyBankAccountLanguageDao(JSON.parse(json));
    }
}

export enum PaymentGatewayPlatformId {
    XINBEI = 1, 
    ECPSS = 2, 
    RFU = 3, 
    MMPAY = 4, 
    UNPAY = 5, 
    SDPAY = 6, 
    XLPAY = 7, 
    RYPAY = 8, 
    CFPAY = 9, 
    ZHT = 10, 
    KHT = 11, 
    BossPay = 12, 
    KGPAY = 13, 
    HONORPAY = 14, 
    TOTALPAY = 15, 
    RYPAY2 = 16, 
    KHT2 = 17, 
    SMPAY = 18, 
    Jeepayment = 19, 
    Jeepayment2 = 20, 
    Sulongpay = 21, 
    Jevng = 22, 
    Zhi = 23, 
    Wonderfulsky = 24, 
    DfPayDeposit = 25, 
    DfPayWithdraw = 26, 
    SanhePay = 27, 
    FlvPay = 28, 
    FindPay = 29, 
    WinwinPay = 30, 
    BBPay = 31, 
    MachiPay = 32, 
    MachiPay2 = 33, 
    MachiPay3 = 34, 
    MachiPay4 = 35, 
    MangoPay = 36, 
    PeanutPay = 37, 
    HoneyPay = 38, 
    XinpaiShop = 39, 
    XinpaiShop2 = 40, 
    XinpaiShop3 = 41, 
    SMPay1 = 42, 
    KPay = 43, 
    URPay = 44, 
    DTPay = 45, 
    PDPay = 46, 
    XxPay = 47, 
    SftPay = 48, 
    YfPay = 49, 
    DfOldPayDeposit = 50, 
    DfOldPayWithdraw = 51, 
    KlPay = 52, 
    AstroPay = 53, 
    ZhPay = 54, 
    FPPay = 55, 
    WdPay = 56, 
    ManualAlipay = 57, 
    DyPay = 58, 
    WenPay = 59, 
    JBPay = 60, 
    EztroPay = 61, 
    XqPay = 62, 
    AiwaPay = 63, 
    ECPay = 64, 
    WhrtarePay = 65, 
    PonyPay = 66, 
    SwiftPay = 67, 
    SftPay2 = 68, 
    RyPay = 69, 
    GFPay = 70, 
    RbPay = 71, 
    NewECPay = 72, 
    XihaPay = 73, 
    BenePay = 75, 
    LinkPay = 76, 
    FXBit = 77, 
    DfOldPayFundOut = 78, 
    OneWallet = 79, 
    OneWalletFundOut = 80, 
    TrpPay = 81, 
    Zonic = 82, 
    UpPay = 83, 
    HappyPay = 84, 
    GTBFundOut = 85, 
    GTB = 86, 
    HBFundOut = 87, 
    HB = 88, 
    OKPay = 89, 
    OKPayFundOut = 90, 
    FbPay = 91, 
    FbPayFundOut = 92, 
    ApplePay = 93, 
    ApplePayFundOut = 94, 
    DiamondPay = 95, 
    DiamondPayFundOut = 96, 
    GSPay = 97, 
    GSPayFundOut = 98, 
    IFPay = 99, 
    IFPayFundOut = 100, 
    OKPay2 = 101, 
    OKPayFundOut2 = 102, 
    OKPay3 = 103, 
    OKPayFundOut3 = 104, 
    OD = 105, 
    ODFundOut = 106, 
    JSTPay = 107, 
    JSTPayFundOut = 108, 
    GPay = 109, 
    MyPay = 110, 
    MyPayFundOut = 111, 
    EiexPay = 112, 
    ODManual = 113, 
    AsiaPay = 114, 
    AsiaPayFundOut = 115, 
    RBPay = 116, 
    RBPayFundOut = 117, 
    QRPay = 118, 
    QRPayFundOut = 119, 
    VNPay = 120, 
    VNPayFundOut = 121, 
    TMBPay = 122, 
    TMBPayFundOut = 123, 
    JST168PayKZK = 124, 
    JST168PayKZKFundOut = 125, 
    JST168PayQR = 126, 
    JST168PayQRFundOut = 127, 
    FYPay = 128, 
    FYPayFundOut = 129, 
    FXBitCryptoFundOut = 130, 
    XinDovndPay = 131, 
    XinDovndPayFundOut = 132, 
    GPGPay = 133, 
    AsiaPayQr = 134, 
    ETGPay = 135, 
    CoinPay = 136, 
    GSPayPrompt = 137, 
    GPGPayKasikornBank = 138, 
    RapidPay = 139, 
    YFBPay = 140, 
    YFBPayFundOut = 141, 
    VizPay = 142, 
    VizPayFundOut = 143, 
    JST_THBPay = 144, 
    JST_THBFundOutPay = 145, 
    RJDJ88_Pay = 146, 
    RJDJ88_FundOutPay = 147, 
    HengPay = 148, 
    OOPay = 149, 
    OOPayFundOut = 150, 
    TopPay = 151, 
    TopPayFundOut = 152, 
    AlePay = 153, 
    AlePayFundOut = 154, 
    YZPay = 155, 
    YZPayFundOut = 156, 
    OnePay = 157, 
    OnePayFundOut = 158, 
    BitzPay = 159, 
    BitzPayFundOut = 160, 
    WePay = 161, 
    WePayFundOut = 162, 
    USOTCPay = 163, 
    DGPay = 164, 
    DGPayFundOut = 165, 
    JHPay = 166, 
    JHPayFundOut = 167, 
    GoldenPay = 168, 
    GoldenPayFundOut = 169, 
    TGCPay = 170, 
    TGCPayFundOut = 171, 
    NineMPay = 172, 
    NineMPayFundOut = 173, 
    IN8Pay = 174, 
}

export class LobbyBankAccountGetForEditResponse { 
    lobbyBankAccountDetail: LobbyBankAccountDetail; 
    lobbyBankOptions: CmsSelectionOptionDao[]; 
    lobbyPlayerLevelOptions: CmsSelectionOptionDao[]; 
    lobbyPlayerGroupOptions: CmsSelectionOptionDao[]; 
    lobbyLanguages: LanguageDao[]; 
    bankCardPaymentPlatformOptions: CmsSelectionOptionDao[]; 
    currencyOptions: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyBankAccountDetail = data["lobbyBankAccountDetail"] ? LobbyBankAccountDetail.fromJS(data["lobbyBankAccountDetail"]) : null;
            if (data["lobbyBankOptions"] && data["lobbyBankOptions"].constructor === Array) {
                this.lobbyBankOptions = [];
                for (let item of data["lobbyBankOptions"])
                    this.lobbyBankOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["lobbyPlayerLevelOptions"] && data["lobbyPlayerLevelOptions"].constructor === Array) {
                this.lobbyPlayerLevelOptions = [];
                for (let item of data["lobbyPlayerLevelOptions"])
                    this.lobbyPlayerLevelOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["lobbyPlayerGroupOptions"] && data["lobbyPlayerGroupOptions"].constructor === Array) {
                this.lobbyPlayerGroupOptions = [];
                for (let item of data["lobbyPlayerGroupOptions"])
                    this.lobbyPlayerGroupOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["lobbyLanguages"] && data["lobbyLanguages"].constructor === Array) {
                this.lobbyLanguages = [];
                for (let item of data["lobbyLanguages"])
                    this.lobbyLanguages.push(LanguageDao.fromJS(item));
            }
            if (data["bankCardPaymentPlatformOptions"] && data["bankCardPaymentPlatformOptions"].constructor === Array) {
                this.bankCardPaymentPlatformOptions = [];
                for (let item of data["bankCardPaymentPlatformOptions"])
                    this.bankCardPaymentPlatformOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["currencyOptions"] && data["currencyOptions"].constructor === Array) {
                this.currencyOptions = [];
                for (let item of data["currencyOptions"])
                    this.currencyOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyBankAccountGetForEditResponse {
        return new LobbyBankAccountGetForEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["lobbyBankAccountDetail"] = this.lobbyBankAccountDetail ? this.lobbyBankAccountDetail.toJS() : null;
        if (this.lobbyBankOptions && this.lobbyBankOptions.constructor === Array) {
            data["lobbyBankOptions"] = [];
            for (let item of this.lobbyBankOptions)
                data["lobbyBankOptions"].push(item.toJS());
        }
        if (this.lobbyPlayerLevelOptions && this.lobbyPlayerLevelOptions.constructor === Array) {
            data["lobbyPlayerLevelOptions"] = [];
            for (let item of this.lobbyPlayerLevelOptions)
                data["lobbyPlayerLevelOptions"].push(item.toJS());
        }
        if (this.lobbyPlayerGroupOptions && this.lobbyPlayerGroupOptions.constructor === Array) {
            data["lobbyPlayerGroupOptions"] = [];
            for (let item of this.lobbyPlayerGroupOptions)
                data["lobbyPlayerGroupOptions"].push(item.toJS());
        }
        if (this.lobbyLanguages && this.lobbyLanguages.constructor === Array) {
            data["lobbyLanguages"] = [];
            for (let item of this.lobbyLanguages)
                data["lobbyLanguages"].push(item.toJS());
        }
        if (this.bankCardPaymentPlatformOptions && this.bankCardPaymentPlatformOptions.constructor === Array) {
            data["bankCardPaymentPlatformOptions"] = [];
            for (let item of this.bankCardPaymentPlatformOptions)
                data["bankCardPaymentPlatformOptions"].push(item.toJS());
        }
        if (this.currencyOptions && this.currencyOptions.constructor === Array) {
            data["currencyOptions"] = [];
            for (let item of this.currencyOptions)
                data["currencyOptions"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyBankAccountGetForEditResponse(JSON.parse(json));
    }
}

export class LobbyBankAccountDetail { 
    id: number; 
    lobbyBankId: number; 
    accountNo: string; 
    username: string; 
    lobbyPlayerLevelId: number; 
    lobbyPlayerGroupId: number; 
    isPublish: boolean; 
    apiCardNo: string; 
    apiBankAccountNo: string; 
    apiBankMark: string; 
    apiBankName: string; 
    apiCardIndex: string; 
    isPublishForAlipay: boolean; 
    isPublishForOnlineBank: boolean; 
    deviceId: string; 
    pin: string; 
    paymentPlatformId: PaymentGatewayPlatformId; 
    desktopQrcodePath: string; 
    mobileQrcodePath: string; 
    updateDate: Date; 
    createDate: Date; 
    lobbyBankAccountLanguages: LobbyBankAccountLanguageDao[]; 
    currencyId: number; 
    password: string; 
    appUserName: string; 
    isMaintainRepeatEveryDay: boolean; 
    repeatEveryDayDateStart: string; 
    repeatEveryDayDateEnd: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.lobbyBankId = data["LobbyBankId"] !== undefined ? data["LobbyBankId"] : null;
            this.accountNo = data["AccountNo"] !== undefined ? data["AccountNo"] : null;
            this.username = data["Username"] !== undefined ? data["Username"] : null;
            this.lobbyPlayerLevelId = data["LobbyPlayerLevelId"] !== undefined ? data["LobbyPlayerLevelId"] : null;
            this.lobbyPlayerGroupId = data["LobbyPlayerGroupId"] !== undefined ? data["LobbyPlayerGroupId"] : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
            this.apiCardNo = data["ApiCardNo"] !== undefined ? data["ApiCardNo"] : null;
            this.apiBankAccountNo = data["ApiBankAccountNo"] !== undefined ? data["ApiBankAccountNo"] : null;
            this.apiBankMark = data["ApiBankMark"] !== undefined ? data["ApiBankMark"] : null;
            this.apiBankName = data["ApiBankName"] !== undefined ? data["ApiBankName"] : null;
            this.apiCardIndex = data["ApiCardIndex"] !== undefined ? data["ApiCardIndex"] : null;
            this.isPublishForAlipay = data["IsPublishForAlipay"] !== undefined ? data["IsPublishForAlipay"] : null;
            this.isPublishForOnlineBank = data["IsPublishForOnlineBank"] !== undefined ? data["IsPublishForOnlineBank"] : null;
            this.deviceId = data["DeviceId"] !== undefined ? data["DeviceId"] : null;
            this.pin = data["Pin"] !== undefined ? data["Pin"] : null;
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.desktopQrcodePath = data["DesktopQrcodePath"] !== undefined ? data["DesktopQrcodePath"] : null;
            this.mobileQrcodePath = data["MobileQrcodePath"] !== undefined ? data["MobileQrcodePath"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            if (data["LobbyBankAccountLanguages"] && data["LobbyBankAccountLanguages"].constructor === Array) {
                this.lobbyBankAccountLanguages = [];
                for (let item of data["LobbyBankAccountLanguages"])
                    this.lobbyBankAccountLanguages.push(LobbyBankAccountLanguageDao.fromJS(item));
            }
            this.currencyId = data["CurrencyId"] !== undefined ? data["CurrencyId"] : null;
            this.password = data["Password"] !== undefined ? data["Password"] : null;
            this.appUserName = data["AppUserName"] !== undefined ? data["AppUserName"] : null;
            this.isMaintainRepeatEveryDay = data["IsMaintainRepeatEveryDay"] !== undefined ? data["IsMaintainRepeatEveryDay"] : null;
            this.repeatEveryDayDateStart = data["RepeatEveryDayDateStart"] !== undefined ? data["RepeatEveryDayDateStart"] : null;
            this.repeatEveryDayDateEnd = data["RepeatEveryDayDateEnd"] !== undefined ? data["RepeatEveryDayDateEnd"] : null;
        }
    }

    static fromJS(data: any): LobbyBankAccountDetail {
        return new LobbyBankAccountDetail(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["LobbyBankId"] = this.lobbyBankId !== undefined ? this.lobbyBankId : null;
        data["AccountNo"] = this.accountNo !== undefined ? this.accountNo : null;
        data["Username"] = this.username !== undefined ? this.username : null;
        data["LobbyPlayerLevelId"] = this.lobbyPlayerLevelId !== undefined ? this.lobbyPlayerLevelId : null;
        data["LobbyPlayerGroupId"] = this.lobbyPlayerGroupId !== undefined ? this.lobbyPlayerGroupId : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        data["ApiCardNo"] = this.apiCardNo !== undefined ? this.apiCardNo : null;
        data["ApiBankAccountNo"] = this.apiBankAccountNo !== undefined ? this.apiBankAccountNo : null;
        data["ApiBankMark"] = this.apiBankMark !== undefined ? this.apiBankMark : null;
        data["ApiBankName"] = this.apiBankName !== undefined ? this.apiBankName : null;
        data["ApiCardIndex"] = this.apiCardIndex !== undefined ? this.apiCardIndex : null;
        data["IsPublishForAlipay"] = this.isPublishForAlipay !== undefined ? this.isPublishForAlipay : null;
        data["IsPublishForOnlineBank"] = this.isPublishForOnlineBank !== undefined ? this.isPublishForOnlineBank : null;
        data["DeviceId"] = this.deviceId !== undefined ? this.deviceId : null;
        data["Pin"] = this.pin !== undefined ? this.pin : null;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["DesktopQrcodePath"] = this.desktopQrcodePath !== undefined ? this.desktopQrcodePath : null;
        data["MobileQrcodePath"] = this.mobileQrcodePath !== undefined ? this.mobileQrcodePath : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        if (this.lobbyBankAccountLanguages && this.lobbyBankAccountLanguages.constructor === Array) {
            data["LobbyBankAccountLanguages"] = [];
            for (let item of this.lobbyBankAccountLanguages)
                data["LobbyBankAccountLanguages"].push(item.toJS());
        }
        data["CurrencyId"] = this.currencyId !== undefined ? this.currencyId : null;
        data["Password"] = this.password !== undefined ? this.password : null;
        data["AppUserName"] = this.appUserName !== undefined ? this.appUserName : null;
        data["IsMaintainRepeatEveryDay"] = this.isMaintainRepeatEveryDay !== undefined ? this.isMaintainRepeatEveryDay : null;
        data["RepeatEveryDayDateStart"] = this.repeatEveryDayDateStart !== undefined ? this.repeatEveryDayDateStart : null;
        data["RepeatEveryDayDateEnd"] = this.repeatEveryDayDateEnd !== undefined ? this.repeatEveryDayDateEnd : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyBankAccountDetail(JSON.parse(json));
    }
}

export class LobbyBankAccountEditRequest { 
    lobbyBankAccountId: number; 
    lobbyBankId: number; 
    accountNo: string; 
    username: string; 
    lobbyPlayerLevelId: number; 
    lobbyPlayerGroupId: number; 
    isPublish: boolean; 
    apiCardNo: string; 
    apiBankAccountNo: string; 
    apiBankMark: string; 
    apiBankName: string; 
    apiCardIndex: string; 
    isPublishForAlipay: boolean; 
    isPublishForOnlineBank: boolean; 
    deviceId: string; 
    pin: string; 
    paymentPlatformId: PaymentGatewayPlatformId; 
    lobbyBankAccountLanguages: LobbyBankAccountLanguageDao[]; 
    desktopQrcodePath: string; 
    mobileQrcodePath: string; 
    currencyId: CurrencyId; 
    password: string; 
    appUserName: string; 
    isMaintainRepeatEveryDay: boolean; 
    repeatEveryDayDateStart: string; 
    repeatEveryDayDateEnd: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyBankAccountId = data["LobbyBankAccountId"] !== undefined ? data["LobbyBankAccountId"] : null;
            this.lobbyBankId = data["LobbyBankId"] !== undefined ? data["LobbyBankId"] : null;
            this.accountNo = data["AccountNo"] !== undefined ? data["AccountNo"] : null;
            this.username = data["Username"] !== undefined ? data["Username"] : null;
            this.lobbyPlayerLevelId = data["LobbyPlayerLevelId"] !== undefined ? data["LobbyPlayerLevelId"] : null;
            this.lobbyPlayerGroupId = data["LobbyPlayerGroupId"] !== undefined ? data["LobbyPlayerGroupId"] : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
            this.apiCardNo = data["ApiCardNo"] !== undefined ? data["ApiCardNo"] : null;
            this.apiBankAccountNo = data["ApiBankAccountNo"] !== undefined ? data["ApiBankAccountNo"] : null;
            this.apiBankMark = data["ApiBankMark"] !== undefined ? data["ApiBankMark"] : null;
            this.apiBankName = data["ApiBankName"] !== undefined ? data["ApiBankName"] : null;
            this.apiCardIndex = data["ApiCardIndex"] !== undefined ? data["ApiCardIndex"] : null;
            this.isPublishForAlipay = data["IsPublishForAlipay"] !== undefined ? data["IsPublishForAlipay"] : null;
            this.isPublishForOnlineBank = data["IsPublishForOnlineBank"] !== undefined ? data["IsPublishForOnlineBank"] : null;
            this.deviceId = data["DeviceId"] !== undefined ? data["DeviceId"] : null;
            this.pin = data["Pin"] !== undefined ? data["Pin"] : null;
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            if (data["LobbyBankAccountLanguages"] && data["LobbyBankAccountLanguages"].constructor === Array) {
                this.lobbyBankAccountLanguages = [];
                for (let item of data["LobbyBankAccountLanguages"])
                    this.lobbyBankAccountLanguages.push(LobbyBankAccountLanguageDao.fromJS(item));
            }
            this.desktopQrcodePath = data["DesktopQrcodePath"] !== undefined ? data["DesktopQrcodePath"] : null;
            this.mobileQrcodePath = data["MobileQrcodePath"] !== undefined ? data["MobileQrcodePath"] : null;
            this.currencyId = data["CurrencyId"] !== undefined ? data["CurrencyId"] : null;
            this.password = data["Password"] !== undefined ? data["Password"] : null;
            this.appUserName = data["AppUserName"] !== undefined ? data["AppUserName"] : null;
            this.isMaintainRepeatEveryDay = data["IsMaintainRepeatEveryDay"] !== undefined ? data["IsMaintainRepeatEveryDay"] : null;
            this.repeatEveryDayDateStart = data["RepeatEveryDayDateStart"] !== undefined ? data["RepeatEveryDayDateStart"] : null;
            this.repeatEveryDayDateEnd = data["RepeatEveryDayDateEnd"] !== undefined ? data["RepeatEveryDayDateEnd"] : null;
        }
    }

    static fromJS(data: any): LobbyBankAccountEditRequest {
        return new LobbyBankAccountEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyBankAccountId"] = this.lobbyBankAccountId !== undefined ? this.lobbyBankAccountId : null;
        data["LobbyBankId"] = this.lobbyBankId !== undefined ? this.lobbyBankId : null;
        data["AccountNo"] = this.accountNo !== undefined ? this.accountNo : null;
        data["Username"] = this.username !== undefined ? this.username : null;
        data["LobbyPlayerLevelId"] = this.lobbyPlayerLevelId !== undefined ? this.lobbyPlayerLevelId : null;
        data["LobbyPlayerGroupId"] = this.lobbyPlayerGroupId !== undefined ? this.lobbyPlayerGroupId : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        data["ApiCardNo"] = this.apiCardNo !== undefined ? this.apiCardNo : null;
        data["ApiBankAccountNo"] = this.apiBankAccountNo !== undefined ? this.apiBankAccountNo : null;
        data["ApiBankMark"] = this.apiBankMark !== undefined ? this.apiBankMark : null;
        data["ApiBankName"] = this.apiBankName !== undefined ? this.apiBankName : null;
        data["ApiCardIndex"] = this.apiCardIndex !== undefined ? this.apiCardIndex : null;
        data["IsPublishForAlipay"] = this.isPublishForAlipay !== undefined ? this.isPublishForAlipay : null;
        data["IsPublishForOnlineBank"] = this.isPublishForOnlineBank !== undefined ? this.isPublishForOnlineBank : null;
        data["DeviceId"] = this.deviceId !== undefined ? this.deviceId : null;
        data["Pin"] = this.pin !== undefined ? this.pin : null;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        if (this.lobbyBankAccountLanguages && this.lobbyBankAccountLanguages.constructor === Array) {
            data["LobbyBankAccountLanguages"] = [];
            for (let item of this.lobbyBankAccountLanguages)
                data["LobbyBankAccountLanguages"].push(item.toJS());
        }
        data["DesktopQrcodePath"] = this.desktopQrcodePath !== undefined ? this.desktopQrcodePath : null;
        data["MobileQrcodePath"] = this.mobileQrcodePath !== undefined ? this.mobileQrcodePath : null;
        data["CurrencyId"] = this.currencyId !== undefined ? this.currencyId : null;
        data["Password"] = this.password !== undefined ? this.password : null;
        data["AppUserName"] = this.appUserName !== undefined ? this.appUserName : null;
        data["IsMaintainRepeatEveryDay"] = this.isMaintainRepeatEveryDay !== undefined ? this.isMaintainRepeatEveryDay : null;
        data["RepeatEveryDayDateStart"] = this.repeatEveryDayDateStart !== undefined ? this.repeatEveryDayDateStart : null;
        data["RepeatEveryDayDateEnd"] = this.repeatEveryDayDateEnd !== undefined ? this.repeatEveryDayDateEnd : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyBankAccountEditRequest(JSON.parse(json));
    }
}

export class StandardResultOfLobbyBankAccountGetThirdPartyApiTransactionRecordsResponse { 
    isSuccess: boolean; 
    payload: LobbyBankAccountGetThirdPartyApiTransactionRecordsResponse; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            this.payload = data["Payload"] ? LobbyBankAccountGetThirdPartyApiTransactionRecordsResponse.fromJS(data["Payload"]) : null;
            if (data["Errors"] && data["Errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["Errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResultOfLobbyBankAccountGetThirdPartyApiTransactionRecordsResponse {
        return new StandardResultOfLobbyBankAccountGetThirdPartyApiTransactionRecordsResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["Payload"] = this.payload ? this.payload.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResultOfLobbyBankAccountGetThirdPartyApiTransactionRecordsResponse(JSON.parse(json));
    }
}

export class LobbyBankAccountGetThirdPartyApiTransactionRecordsResponse { 
    apiUrl: string; 
    apiRequestBody: string; 
    apiResponseBody: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.apiUrl = data["ApiUrl"] !== undefined ? data["ApiUrl"] : null;
            this.apiRequestBody = data["ApiRequestBody"] !== undefined ? data["ApiRequestBody"] : null;
            this.apiResponseBody = data["ApiResponseBody"] !== undefined ? data["ApiResponseBody"] : null;
        }
    }

    static fromJS(data: any): LobbyBankAccountGetThirdPartyApiTransactionRecordsResponse {
        return new LobbyBankAccountGetThirdPartyApiTransactionRecordsResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["ApiUrl"] = this.apiUrl !== undefined ? this.apiUrl : null;
        data["ApiRequestBody"] = this.apiRequestBody !== undefined ? this.apiRequestBody : null;
        data["ApiResponseBody"] = this.apiResponseBody !== undefined ? this.apiResponseBody : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyBankAccountGetThirdPartyApiTransactionRecordsResponse(JSON.parse(json));
    }
}

export enum BOFieldsAccessId {
    Promo_LobbyPromotionTypeId = 1, 
    Promo_DetailImage = 2, 
    Promo_DetailImageMobile = 3, 
    BankAccountToPlayerLevel = 4, 
    BankAccountToPlayerGroup = 5, 
}

export class BoUserTableColumnHiddenItem { 
    id: number; 
    userId: number; 
    authorizeActionId: number; 
    colHiddenName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.userId = data["UserId"] !== undefined ? data["UserId"] : null;
            this.authorizeActionId = data["AuthorizeActionId"] !== undefined ? data["AuthorizeActionId"] : null;
            this.colHiddenName = data["ColHiddenName"] !== undefined ? data["ColHiddenName"] : null;
        }
    }

    static fromJS(data: any): BoUserTableColumnHiddenItem {
        return new BoUserTableColumnHiddenItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["UserId"] = this.userId !== undefined ? this.userId : null;
        data["AuthorizeActionId"] = this.authorizeActionId !== undefined ? this.authorizeActionId : null;
        data["ColHiddenName"] = this.colHiddenName !== undefined ? this.colHiddenName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new BoUserTableColumnHiddenItem(JSON.parse(json));
    }
}

export class DashboardIndexResponse { 
    summaryStat: DashboardSummaryStatDao; 
    past30DaysLoginStat: GraphDetail[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.summaryStat = data["SummaryStat"] ? DashboardSummaryStatDao.fromJS(data["SummaryStat"]) : null;
            if (data["Past30DaysLoginStat"] && data["Past30DaysLoginStat"].constructor === Array) {
                this.past30DaysLoginStat = [];
                for (let item of data["Past30DaysLoginStat"])
                    this.past30DaysLoginStat.push(GraphDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardIndexResponse {
        return new DashboardIndexResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["SummaryStat"] = this.summaryStat ? this.summaryStat.toJS() : null;
        if (this.past30DaysLoginStat && this.past30DaysLoginStat.constructor === Array) {
            data["Past30DaysLoginStat"] = [];
            for (let item of this.past30DaysLoginStat)
                data["Past30DaysLoginStat"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DashboardIndexResponse(JSON.parse(json));
    }
}

export class DashboardSummaryStatDao { 
    regDesktopCnt: number; 
    regMobileCnt: number; 
    loginDesktopCnt: number; 
    loginMobileCnt: number; 
    betCnt: number; 
    betAmount: number; 
    betPlayerCnt: number; 
    depositCnt: number; 
    depositAmount: number; 
    withdrawCnt: number; 
    withdrawAmount: number; 
    firstDepositCnt: number; 
    loginUserDesktopCnt: number; 
    loginUserMobileCnt: number; 
    firstDepositAmount: number; 
    promotionCount: number; 
    promotionAmount: number; 
    withdrawPlayerCnt: number; 
    depositPlayerCnt: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.regDesktopCnt = data["RegDesktopCnt"] !== undefined ? data["RegDesktopCnt"] : null;
            this.regMobileCnt = data["RegMobileCnt"] !== undefined ? data["RegMobileCnt"] : null;
            this.loginDesktopCnt = data["LoginDesktopCnt"] !== undefined ? data["LoginDesktopCnt"] : null;
            this.loginMobileCnt = data["LoginMobileCnt"] !== undefined ? data["LoginMobileCnt"] : null;
            this.betCnt = data["BetCnt"] !== undefined ? data["BetCnt"] : null;
            this.betAmount = data["BetAmount"] !== undefined ? data["BetAmount"] : null;
            this.betPlayerCnt = data["BetPlayerCnt"] !== undefined ? data["BetPlayerCnt"] : null;
            this.depositCnt = data["DepositCnt"] !== undefined ? data["DepositCnt"] : null;
            this.depositAmount = data["DepositAmount"] !== undefined ? data["DepositAmount"] : null;
            this.withdrawCnt = data["WithdrawCnt"] !== undefined ? data["WithdrawCnt"] : null;
            this.withdrawAmount = data["WithdrawAmount"] !== undefined ? data["WithdrawAmount"] : null;
            this.firstDepositCnt = data["FirstDepositCnt"] !== undefined ? data["FirstDepositCnt"] : null;
            this.loginUserDesktopCnt = data["LoginUserDesktopCnt"] !== undefined ? data["LoginUserDesktopCnt"] : null;
            this.loginUserMobileCnt = data["LoginUserMobileCnt"] !== undefined ? data["LoginUserMobileCnt"] : null;
            this.firstDepositAmount = data["FirstDepositAmount"] !== undefined ? data["FirstDepositAmount"] : null;
            this.promotionCount = data["PromotionCount"] !== undefined ? data["PromotionCount"] : null;
            this.promotionAmount = data["PromotionAmount"] !== undefined ? data["PromotionAmount"] : null;
            this.withdrawPlayerCnt = data["WithdrawPlayerCnt"] !== undefined ? data["WithdrawPlayerCnt"] : null;
            this.depositPlayerCnt = data["DepositPlayerCnt"] !== undefined ? data["DepositPlayerCnt"] : null;
        }
    }

    static fromJS(data: any): DashboardSummaryStatDao {
        return new DashboardSummaryStatDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["RegDesktopCnt"] = this.regDesktopCnt !== undefined ? this.regDesktopCnt : null;
        data["RegMobileCnt"] = this.regMobileCnt !== undefined ? this.regMobileCnt : null;
        data["LoginDesktopCnt"] = this.loginDesktopCnt !== undefined ? this.loginDesktopCnt : null;
        data["LoginMobileCnt"] = this.loginMobileCnt !== undefined ? this.loginMobileCnt : null;
        data["BetCnt"] = this.betCnt !== undefined ? this.betCnt : null;
        data["BetAmount"] = this.betAmount !== undefined ? this.betAmount : null;
        data["BetPlayerCnt"] = this.betPlayerCnt !== undefined ? this.betPlayerCnt : null;
        data["DepositCnt"] = this.depositCnt !== undefined ? this.depositCnt : null;
        data["DepositAmount"] = this.depositAmount !== undefined ? this.depositAmount : null;
        data["WithdrawCnt"] = this.withdrawCnt !== undefined ? this.withdrawCnt : null;
        data["WithdrawAmount"] = this.withdrawAmount !== undefined ? this.withdrawAmount : null;
        data["FirstDepositCnt"] = this.firstDepositCnt !== undefined ? this.firstDepositCnt : null;
        data["LoginUserDesktopCnt"] = this.loginUserDesktopCnt !== undefined ? this.loginUserDesktopCnt : null;
        data["LoginUserMobileCnt"] = this.loginUserMobileCnt !== undefined ? this.loginUserMobileCnt : null;
        data["FirstDepositAmount"] = this.firstDepositAmount !== undefined ? this.firstDepositAmount : null;
        data["PromotionCount"] = this.promotionCount !== undefined ? this.promotionCount : null;
        data["PromotionAmount"] = this.promotionAmount !== undefined ? this.promotionAmount : null;
        data["WithdrawPlayerCnt"] = this.withdrawPlayerCnt !== undefined ? this.withdrawPlayerCnt : null;
        data["DepositPlayerCnt"] = this.depositPlayerCnt !== undefined ? this.depositPlayerCnt : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DashboardSummaryStatDao(JSON.parse(json));
    }
}

export class GraphDetail { 
    date: Date; 
    desktopLoginCount: number; 
    iosH5LoginCount: number; 
    iosAppLoginCount: number; 
    androidH5LoginCount: number; 
    androidAppLoginCount: number; 
    otherMobileLoginCount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.date = data["Date"] ? new Date(data["Date"].toString()) : null;
            this.desktopLoginCount = data["DesktopLoginCount"] !== undefined ? data["DesktopLoginCount"] : null;
            this.iosH5LoginCount = data["IosH5LoginCount"] !== undefined ? data["IosH5LoginCount"] : null;
            this.iosAppLoginCount = data["IosAppLoginCount"] !== undefined ? data["IosAppLoginCount"] : null;
            this.androidH5LoginCount = data["AndroidH5LoginCount"] !== undefined ? data["AndroidH5LoginCount"] : null;
            this.androidAppLoginCount = data["AndroidAppLoginCount"] !== undefined ? data["AndroidAppLoginCount"] : null;
            this.otherMobileLoginCount = data["OtherMobileLoginCount"] !== undefined ? data["OtherMobileLoginCount"] : null;
        }
    }

    static fromJS(data: any): GraphDetail {
        return new GraphDetail(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Date"] = this.date ? this.date.toISOString() : null;
        data["DesktopLoginCount"] = this.desktopLoginCount !== undefined ? this.desktopLoginCount : null;
        data["IosH5LoginCount"] = this.iosH5LoginCount !== undefined ? this.iosH5LoginCount : null;
        data["IosAppLoginCount"] = this.iosAppLoginCount !== undefined ? this.iosAppLoginCount : null;
        data["AndroidH5LoginCount"] = this.androidH5LoginCount !== undefined ? this.androidH5LoginCount : null;
        data["AndroidAppLoginCount"] = this.androidAppLoginCount !== undefined ? this.androidAppLoginCount : null;
        data["OtherMobileLoginCount"] = this.otherMobileLoginCount !== undefined ? this.otherMobileLoginCount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GraphDetail(JSON.parse(json));
    }
}

export class DashboardIndexDailyResponse { 
    summaryStat: DashboardSummaryStatDao;

    constructor(data?: any) {
        if (data !== undefined) {
            this.summaryStat = data["SummaryStat"] ? DashboardSummaryStatDao.fromJS(data["SummaryStat"]) : null;
        }
    }

    static fromJS(data: any): DashboardIndexDailyResponse {
        return new DashboardIndexDailyResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["SummaryStat"] = this.summaryStat ? this.summaryStat.toJS() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DashboardIndexDailyResponse(JSON.parse(json));
    }
}

export class DashboardIndexGetRequest { 
    startDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
        }
    }

    static fromJS(data: any): DashboardIndexGetRequest {
        return new DashboardIndexGetRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DashboardIndexGetRequest(JSON.parse(json));
    }
}

/** Represents the result of an action method. */
export class ActionResult {

    constructor(data?: any) {
        if (data !== undefined) {
        }
    }

    static fromJS(data: any): ActionResult {
        return new ActionResult(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ActionResult(JSON.parse(json));
    }
}

export class LanguageResponse { 
    id: number; 
    name: string; 
    languageCode: string; 
    aAAA: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.languageCode = data["LanguageCode"] !== undefined ? data["LanguageCode"] : null;
            this.aAAA = data["AAAA"] !== undefined ? data["AAAA"] : null;
        }
    }

    static fromJS(data: any): LanguageResponse {
        return new LanguageResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["LanguageCode"] = this.languageCode !== undefined ? this.languageCode : null;
        data["AAAA"] = this.aAAA !== undefined ? this.aAAA : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LanguageResponse(JSON.parse(json));
    }
}

export class StandardResponseOfListOfAdminUserDao { 
    isSuccess: boolean; 
    payload: AdminUserDao[]; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            if (data["payload"] && data["payload"].constructor === Array) {
                this.payload = [];
                for (let item of data["payload"])
                    this.payload.push(AdminUserDao.fromJS(item));
            }
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfListOfAdminUserDao {
        return new StandardResponseOfListOfAdminUserDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.payload && this.payload.constructor === Array) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item.toJS());
        }
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfListOfAdminUserDao(JSON.parse(json));
    }
}

export class AdminUserDao { 
    id: number; 
    username: string; 
    lobbyRoleId: number; 
    lobbyRoleName: string; 
    email: string; 
    lobbyAgentId: number; 
    lobbyAgentName: string; 
    isEnableLogin: boolean; 
    updateDate: Date; 
    updateBy: string; 
    smsDailyLimit: number; 
    lobbyPlayerGroupIds: number[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.username = data["Username"] !== undefined ? data["Username"] : null;
            this.lobbyRoleId = data["LobbyRoleId"] !== undefined ? data["LobbyRoleId"] : null;
            this.lobbyRoleName = data["LobbyRoleName"] !== undefined ? data["LobbyRoleName"] : null;
            this.email = data["Email"] !== undefined ? data["Email"] : null;
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.lobbyAgentName = data["LobbyAgentName"] !== undefined ? data["LobbyAgentName"] : null;
            this.isEnableLogin = data["IsEnableLogin"] !== undefined ? data["IsEnableLogin"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.smsDailyLimit = data["SmsDailyLimit"] !== undefined ? data["SmsDailyLimit"] : null;
            if (data["LobbyPlayerGroupIds"] && data["LobbyPlayerGroupIds"].constructor === Array) {
                this.lobbyPlayerGroupIds = [];
                for (let item of data["LobbyPlayerGroupIds"])
                    this.lobbyPlayerGroupIds.push(item);
            }
        }
    }

    static fromJS(data: any): AdminUserDao {
        return new AdminUserDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Username"] = this.username !== undefined ? this.username : null;
        data["LobbyRoleId"] = this.lobbyRoleId !== undefined ? this.lobbyRoleId : null;
        data["LobbyRoleName"] = this.lobbyRoleName !== undefined ? this.lobbyRoleName : null;
        data["Email"] = this.email !== undefined ? this.email : null;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["LobbyAgentName"] = this.lobbyAgentName !== undefined ? this.lobbyAgentName : null;
        data["IsEnableLogin"] = this.isEnableLogin !== undefined ? this.isEnableLogin : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["SmsDailyLimit"] = this.smsDailyLimit !== undefined ? this.smsDailyLimit : null;
        if (this.lobbyPlayerGroupIds && this.lobbyPlayerGroupIds.constructor === Array) {
            data["LobbyPlayerGroupIds"] = [];
            for (let item of this.lobbyPlayerGroupIds)
                data["LobbyPlayerGroupIds"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AdminUserDao(JSON.parse(json));
    }
}

export class LobbyAdminAddRequest { 
    username: string; 
    password: string; 
    email: string; 
    lobbyId: number; 
    lobbyRoleId: number; 
    lobbyAgentId: number; 
    isEnableLogin: boolean; 
    smsDailyLimit: number; 
    lobbyPlayerGroupIds: number[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.username = data["Username"] !== undefined ? data["Username"] : null;
            this.password = data["Password"] !== undefined ? data["Password"] : null;
            this.email = data["Email"] !== undefined ? data["Email"] : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.lobbyRoleId = data["LobbyRoleId"] !== undefined ? data["LobbyRoleId"] : null;
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.isEnableLogin = data["IsEnableLogin"] !== undefined ? data["IsEnableLogin"] : null;
            this.smsDailyLimit = data["SmsDailyLimit"] !== undefined ? data["SmsDailyLimit"] : null;
            if (data["LobbyPlayerGroupIds"] && data["LobbyPlayerGroupIds"].constructor === Array) {
                this.lobbyPlayerGroupIds = [];
                for (let item of data["LobbyPlayerGroupIds"])
                    this.lobbyPlayerGroupIds.push(item);
            }
        }
    }

    static fromJS(data: any): LobbyAdminAddRequest {
        return new LobbyAdminAddRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Username"] = this.username !== undefined ? this.username : null;
        data["Password"] = this.password !== undefined ? this.password : null;
        data["Email"] = this.email !== undefined ? this.email : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["LobbyRoleId"] = this.lobbyRoleId !== undefined ? this.lobbyRoleId : null;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["IsEnableLogin"] = this.isEnableLogin !== undefined ? this.isEnableLogin : null;
        data["SmsDailyLimit"] = this.smsDailyLimit !== undefined ? this.smsDailyLimit : null;
        if (this.lobbyPlayerGroupIds && this.lobbyPlayerGroupIds.constructor === Array) {
            data["LobbyPlayerGroupIds"] = [];
            for (let item of this.lobbyPlayerGroupIds)
                data["LobbyPlayerGroupIds"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyAdminAddRequest(JSON.parse(json));
    }
}

export class GetForEditRequest { 
    adminUserId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.adminUserId = data["AdminUserId"] !== undefined ? data["AdminUserId"] : null;
        }
    }

    static fromJS(data: any): GetForEditRequest {
        return new GetForEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["AdminUserId"] = this.adminUserId !== undefined ? this.adminUserId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetForEditRequest(JSON.parse(json));
    }
}

export class StandardResponseOfLobbyAdminGetForEditResponse { 
    isSuccess: boolean; 
    payload: LobbyAdminGetForEditResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? LobbyAdminGetForEditResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfLobbyAdminGetForEditResponse {
        return new StandardResponseOfLobbyAdminGetForEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfLobbyAdminGetForEditResponse(JSON.parse(json));
    }
}

export class LobbyAdminGetForEditResponse { 
    user: AdminUserDao; 
    lobbyRoleOptions: CmsSelectionOption[]; 
    lobbyAgentOptions: CmsSelectionOption[]; 
    lobbyPlayerGroupOptions: CmsSelectionOption[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.user = data["User"] ? AdminUserDao.fromJS(data["User"]) : null;
            if (data["LobbyRoleOptions"] && data["LobbyRoleOptions"].constructor === Array) {
                this.lobbyRoleOptions = [];
                for (let item of data["LobbyRoleOptions"])
                    this.lobbyRoleOptions.push(CmsSelectionOption.fromJS(item));
            }
            if (data["LobbyAgentOptions"] && data["LobbyAgentOptions"].constructor === Array) {
                this.lobbyAgentOptions = [];
                for (let item of data["LobbyAgentOptions"])
                    this.lobbyAgentOptions.push(CmsSelectionOption.fromJS(item));
            }
            if (data["LobbyPlayerGroupOptions"] && data["LobbyPlayerGroupOptions"].constructor === Array) {
                this.lobbyPlayerGroupOptions = [];
                for (let item of data["LobbyPlayerGroupOptions"])
                    this.lobbyPlayerGroupOptions.push(CmsSelectionOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyAdminGetForEditResponse {
        return new LobbyAdminGetForEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["User"] = this.user ? this.user.toJS() : null;
        if (this.lobbyRoleOptions && this.lobbyRoleOptions.constructor === Array) {
            data["LobbyRoleOptions"] = [];
            for (let item of this.lobbyRoleOptions)
                data["LobbyRoleOptions"].push(item.toJS());
        }
        if (this.lobbyAgentOptions && this.lobbyAgentOptions.constructor === Array) {
            data["LobbyAgentOptions"] = [];
            for (let item of this.lobbyAgentOptions)
                data["LobbyAgentOptions"].push(item.toJS());
        }
        if (this.lobbyPlayerGroupOptions && this.lobbyPlayerGroupOptions.constructor === Array) {
            data["LobbyPlayerGroupOptions"] = [];
            for (let item of this.lobbyPlayerGroupOptions)
                data["LobbyPlayerGroupOptions"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyAdminGetForEditResponse(JSON.parse(json));
    }
}

export class CmsSelectionOption { 
    value: string; 
    label: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.value = data["Value"] !== undefined ? data["Value"] : null;
            this.label = data["Label"] !== undefined ? data["Label"] : null;
        }
    }

    static fromJS(data: any): CmsSelectionOption {
        return new CmsSelectionOption(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Value"] = this.value !== undefined ? this.value : null;
        data["Label"] = this.label !== undefined ? this.label : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CmsSelectionOption(JSON.parse(json));
    }
}

export class LobbyAdminEditRequest { 
    id: number; 
    lobbyRoleId: number; 
    newPassword: string; 
    email: string; 
    lobbyAgentId: number; 
    isEnableLogin: boolean; 
    smsDailyLimit: number; 
    lobbyPlayerGroupIds: number[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.lobbyRoleId = data["LobbyRoleId"] !== undefined ? data["LobbyRoleId"] : null;
            this.newPassword = data["NewPassword"] !== undefined ? data["NewPassword"] : null;
            this.email = data["Email"] !== undefined ? data["Email"] : null;
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.isEnableLogin = data["IsEnableLogin"] !== undefined ? data["IsEnableLogin"] : null;
            this.smsDailyLimit = data["SmsDailyLimit"] !== undefined ? data["SmsDailyLimit"] : null;
            if (data["LobbyPlayerGroupIds"] && data["LobbyPlayerGroupIds"].constructor === Array) {
                this.lobbyPlayerGroupIds = [];
                for (let item of data["LobbyPlayerGroupIds"])
                    this.lobbyPlayerGroupIds.push(item);
            }
        }
    }

    static fromJS(data: any): LobbyAdminEditRequest {
        return new LobbyAdminEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["LobbyRoleId"] = this.lobbyRoleId !== undefined ? this.lobbyRoleId : null;
        data["NewPassword"] = this.newPassword !== undefined ? this.newPassword : null;
        data["Email"] = this.email !== undefined ? this.email : null;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["IsEnableLogin"] = this.isEnableLogin !== undefined ? this.isEnableLogin : null;
        data["SmsDailyLimit"] = this.smsDailyLimit !== undefined ? this.smsDailyLimit : null;
        if (this.lobbyPlayerGroupIds && this.lobbyPlayerGroupIds.constructor === Array) {
            data["LobbyPlayerGroupIds"] = [];
            for (let item of this.lobbyPlayerGroupIds)
                data["LobbyPlayerGroupIds"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyAdminEditRequest(JSON.parse(json));
    }
}

export class StandardResponseOfLobbyAdminEditResponse { 
    isSuccess: boolean; 
    payload: LobbyAdminEditResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? LobbyAdminEditResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfLobbyAdminEditResponse {
        return new StandardResponseOfLobbyAdminEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfLobbyAdminEditResponse(JSON.parse(json));
    }
}

export class LobbyAdminEditResponse { 
    isLogout: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.isLogout = data["IsLogout"] !== undefined ? data["IsLogout"] : null;
        }
    }

    static fromJS(data: any): LobbyAdminEditResponse {
        return new LobbyAdminEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsLogout"] = this.isLogout !== undefined ? this.isLogout : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyAdminEditResponse(JSON.parse(json));
    }
}

export class LobbyAdminBaicInfoEditRequest { 
    email: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.email = data["Email"] !== undefined ? data["Email"] : null;
        }
    }

    static fromJS(data: any): LobbyAdminBaicInfoEditRequest {
        return new LobbyAdminBaicInfoEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Email"] = this.email !== undefined ? this.email : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyAdminBaicInfoEditRequest(JSON.parse(json));
    }
}

export class ResetRandomPasswordRequest { 
    adminId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.adminId = data["AdminId"] !== undefined ? data["AdminId"] : null;
        }
    }

    static fromJS(data: any): ResetRandomPasswordRequest {
        return new ResetRandomPasswordRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["AdminId"] = this.adminId !== undefined ? this.adminId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ResetRandomPasswordRequest(JSON.parse(json));
    }
}

export class StandardResponseOfResetRandomPasswordResponse { 
    isSuccess: boolean; 
    payload: ResetRandomPasswordResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? ResetRandomPasswordResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfResetRandomPasswordResponse {
        return new StandardResponseOfResetRandomPasswordResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfResetRandomPasswordResponse(JSON.parse(json));
    }
}

export class ResetRandomPasswordResponse { 
    newPassword: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.newPassword = data["NewPassword"] !== undefined ? data["NewPassword"] : null;
        }
    }

    static fromJS(data: any): ResetRandomPasswordResponse {
        return new ResetRandomPasswordResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["NewPassword"] = this.newPassword !== undefined ? this.newPassword : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ResetRandomPasswordResponse(JSON.parse(json));
    }
}

export class LobbyAgentCreateRequest { 
    lobbyId: number; 
    name: string; 
    promotionCode: string; 
    promotionUrl: string; 
    phoneNumber: string; 
    email: string; 
    iM: string; 
    bank: string; 
    bankAccount: string; 
    remark: string; 
    lobbyPlayerLevelId: number; 
    lobbyPlayerGroupId: number; 
    commissionRatio: number; 
    isEnableAutoRebate: boolean; 
    autoPromotionGroupId: number; 
    lobbyPromotionGroupId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.promotionCode = data["PromotionCode"] !== undefined ? data["PromotionCode"] : null;
            this.promotionUrl = data["PromotionUrl"] !== undefined ? data["PromotionUrl"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.email = data["Email"] !== undefined ? data["Email"] : null;
            this.iM = data["IM"] !== undefined ? data["IM"] : null;
            this.bank = data["Bank"] !== undefined ? data["Bank"] : null;
            this.bankAccount = data["BankAccount"] !== undefined ? data["BankAccount"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.lobbyPlayerLevelId = data["LobbyPlayerLevelId"] !== undefined ? data["LobbyPlayerLevelId"] : null;
            this.lobbyPlayerGroupId = data["LobbyPlayerGroupId"] !== undefined ? data["LobbyPlayerGroupId"] : null;
            this.commissionRatio = data["CommissionRatio"] !== undefined ? data["CommissionRatio"] : null;
            this.isEnableAutoRebate = data["IsEnableAutoRebate"] !== undefined ? data["IsEnableAutoRebate"] : null;
            this.autoPromotionGroupId = data["AutoPromotionGroupId"] !== undefined ? data["AutoPromotionGroupId"] : null;
            this.lobbyPromotionGroupId = data["LobbyPromotionGroupId"] !== undefined ? data["LobbyPromotionGroupId"] : null;
        }
    }

    static fromJS(data: any): LobbyAgentCreateRequest {
        return new LobbyAgentCreateRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["PromotionCode"] = this.promotionCode !== undefined ? this.promotionCode : null;
        data["PromotionUrl"] = this.promotionUrl !== undefined ? this.promotionUrl : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["Email"] = this.email !== undefined ? this.email : null;
        data["IM"] = this.iM !== undefined ? this.iM : null;
        data["Bank"] = this.bank !== undefined ? this.bank : null;
        data["BankAccount"] = this.bankAccount !== undefined ? this.bankAccount : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["LobbyPlayerLevelId"] = this.lobbyPlayerLevelId !== undefined ? this.lobbyPlayerLevelId : null;
        data["LobbyPlayerGroupId"] = this.lobbyPlayerGroupId !== undefined ? this.lobbyPlayerGroupId : null;
        data["CommissionRatio"] = this.commissionRatio !== undefined ? this.commissionRatio : null;
        data["IsEnableAutoRebate"] = this.isEnableAutoRebate !== undefined ? this.isEnableAutoRebate : null;
        data["AutoPromotionGroupId"] = this.autoPromotionGroupId !== undefined ? this.autoPromotionGroupId : null;
        data["LobbyPromotionGroupId"] = this.lobbyPromotionGroupId !== undefined ? this.lobbyPromotionGroupId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyAgentCreateRequest(JSON.parse(json));
    }
}

export class LobbyAgentEditRequest { 
    lobbyAgentId: number; 
    name: string; 
    promotionUrl: string; 
    phoneNumber: string; 
    email: string; 
    iM: string; 
    bank: string; 
    bankAccount: string; 
    remark: string; 
    lobbyPlayerLevelId: number; 
    lobbyPlayerGroupId: number; 
    commissionRatio: number; 
    isEnableAutoRebate: boolean; 
    autoPromotionGroupId: number; 
    lobbyPromotionGroupId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.promotionUrl = data["PromotionUrl"] !== undefined ? data["PromotionUrl"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.email = data["Email"] !== undefined ? data["Email"] : null;
            this.iM = data["IM"] !== undefined ? data["IM"] : null;
            this.bank = data["Bank"] !== undefined ? data["Bank"] : null;
            this.bankAccount = data["BankAccount"] !== undefined ? data["BankAccount"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.lobbyPlayerLevelId = data["LobbyPlayerLevelId"] !== undefined ? data["LobbyPlayerLevelId"] : null;
            this.lobbyPlayerGroupId = data["LobbyPlayerGroupId"] !== undefined ? data["LobbyPlayerGroupId"] : null;
            this.commissionRatio = data["CommissionRatio"] !== undefined ? data["CommissionRatio"] : null;
            this.isEnableAutoRebate = data["IsEnableAutoRebate"] !== undefined ? data["IsEnableAutoRebate"] : null;
            this.autoPromotionGroupId = data["AutoPromotionGroupId"] !== undefined ? data["AutoPromotionGroupId"] : null;
            this.lobbyPromotionGroupId = data["LobbyPromotionGroupId"] !== undefined ? data["LobbyPromotionGroupId"] : null;
        }
    }

    static fromJS(data: any): LobbyAgentEditRequest {
        return new LobbyAgentEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["PromotionUrl"] = this.promotionUrl !== undefined ? this.promotionUrl : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["Email"] = this.email !== undefined ? this.email : null;
        data["IM"] = this.iM !== undefined ? this.iM : null;
        data["Bank"] = this.bank !== undefined ? this.bank : null;
        data["BankAccount"] = this.bankAccount !== undefined ? this.bankAccount : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["LobbyPlayerLevelId"] = this.lobbyPlayerLevelId !== undefined ? this.lobbyPlayerLevelId : null;
        data["LobbyPlayerGroupId"] = this.lobbyPlayerGroupId !== undefined ? this.lobbyPlayerGroupId : null;
        data["CommissionRatio"] = this.commissionRatio !== undefined ? this.commissionRatio : null;
        data["IsEnableAutoRebate"] = this.isEnableAutoRebate !== undefined ? this.isEnableAutoRebate : null;
        data["AutoPromotionGroupId"] = this.autoPromotionGroupId !== undefined ? this.autoPromotionGroupId : null;
        data["LobbyPromotionGroupId"] = this.lobbyPromotionGroupId !== undefined ? this.lobbyPromotionGroupId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyAgentEditRequest(JSON.parse(json));
    }
}

export class LobbyPlayerLevelGroup { 
    lobbyPlayerGroups: CmsSelectionOptionDao[]; 
    lobbyPlayerLevels: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["LobbyPlayerGroups"] && data["LobbyPlayerGroups"].constructor === Array) {
                this.lobbyPlayerGroups = [];
                for (let item of data["LobbyPlayerGroups"])
                    this.lobbyPlayerGroups.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["LobbyPlayerLevels"] && data["LobbyPlayerLevels"].constructor === Array) {
                this.lobbyPlayerLevels = [];
                for (let item of data["LobbyPlayerLevels"])
                    this.lobbyPlayerLevels.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyPlayerLevelGroup {
        return new LobbyPlayerLevelGroup(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.lobbyPlayerGroups && this.lobbyPlayerGroups.constructor === Array) {
            data["LobbyPlayerGroups"] = [];
            for (let item of this.lobbyPlayerGroups)
                data["LobbyPlayerGroups"].push(item.toJS());
        }
        if (this.lobbyPlayerLevels && this.lobbyPlayerLevels.constructor === Array) {
            data["LobbyPlayerLevels"] = [];
            for (let item of this.lobbyPlayerLevels)
                data["LobbyPlayerLevels"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerLevelGroup(JSON.parse(json));
    }
}

export class LobbyAgentSetEnableRequest { 
    lobbyAgentId: number; 
    isEnable: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
        }
    }

    static fromJS(data: any): LobbyAgentSetEnableRequest {
        return new LobbyAgentSetEnableRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyAgentSetEnableRequest(JSON.parse(json));
    }
}

export class LobbyAgentItem { 
    id: number; 
    lobbyId: number; 
    name: string; 
    promotionCode: string; 
    promotionUrl: string; 
    url: string; 
    updateDate: Date; 
    updateBy: string; 
    phoneNumber: string; 
    email: string; 
    iM: string; 
    bank: string; 
    bankAccount: string; 
    remark: string; 
    lobbyPlayerLevel: number; 
    lobbyPlayerGroup: number; 
    agentLevelName: string; 
    commissionRatio: number; 
    createDate: Date; 
    createBy: string; 
    isEnableAutoRebate: boolean; 
    autoPromotionGroupId: number; 
    lobbyPromotionGroupId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.promotionCode = data["PromotionCode"] !== undefined ? data["PromotionCode"] : null;
            this.promotionUrl = data["PromotionUrl"] !== undefined ? data["PromotionUrl"] : null;
            this.url = data["Url"] !== undefined ? data["Url"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.email = data["Email"] !== undefined ? data["Email"] : null;
            this.iM = data["IM"] !== undefined ? data["IM"] : null;
            this.bank = data["Bank"] !== undefined ? data["Bank"] : null;
            this.bankAccount = data["BankAccount"] !== undefined ? data["BankAccount"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.lobbyPlayerLevel = data["LobbyPlayerLevel"] !== undefined ? data["LobbyPlayerLevel"] : null;
            this.lobbyPlayerGroup = data["LobbyPlayerGroup"] !== undefined ? data["LobbyPlayerGroup"] : null;
            this.agentLevelName = data["AgentLevelName"] !== undefined ? data["AgentLevelName"] : null;
            this.commissionRatio = data["CommissionRatio"] !== undefined ? data["CommissionRatio"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.createBy = data["CreateBy"] !== undefined ? data["CreateBy"] : null;
            this.isEnableAutoRebate = data["IsEnableAutoRebate"] !== undefined ? data["IsEnableAutoRebate"] : null;
            this.autoPromotionGroupId = data["AutoPromotionGroupId"] !== undefined ? data["AutoPromotionGroupId"] : null;
            this.lobbyPromotionGroupId = data["LobbyPromotionGroupId"] !== undefined ? data["LobbyPromotionGroupId"] : null;
        }
    }

    static fromJS(data: any): LobbyAgentItem {
        return new LobbyAgentItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["PromotionCode"] = this.promotionCode !== undefined ? this.promotionCode : null;
        data["PromotionUrl"] = this.promotionUrl !== undefined ? this.promotionUrl : null;
        data["Url"] = this.url !== undefined ? this.url : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["Email"] = this.email !== undefined ? this.email : null;
        data["IM"] = this.iM !== undefined ? this.iM : null;
        data["Bank"] = this.bank !== undefined ? this.bank : null;
        data["BankAccount"] = this.bankAccount !== undefined ? this.bankAccount : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["LobbyPlayerLevel"] = this.lobbyPlayerLevel !== undefined ? this.lobbyPlayerLevel : null;
        data["LobbyPlayerGroup"] = this.lobbyPlayerGroup !== undefined ? this.lobbyPlayerGroup : null;
        data["AgentLevelName"] = this.agentLevelName !== undefined ? this.agentLevelName : null;
        data["CommissionRatio"] = this.commissionRatio !== undefined ? this.commissionRatio : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["CreateBy"] = this.createBy !== undefined ? this.createBy : null;
        data["IsEnableAutoRebate"] = this.isEnableAutoRebate !== undefined ? this.isEnableAutoRebate : null;
        data["AutoPromotionGroupId"] = this.autoPromotionGroupId !== undefined ? this.autoPromotionGroupId : null;
        data["LobbyPromotionGroupId"] = this.lobbyPromotionGroupId !== undefined ? this.lobbyPromotionGroupId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyAgentItem(JSON.parse(json));
    }
}

export class StandardResponseOfGetDownlineResponse { 
    isSuccess: boolean; 
    payload: GetDownlineResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? GetDownlineResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfGetDownlineResponse {
        return new StandardResponseOfGetDownlineResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfGetDownlineResponse(JSON.parse(json));
    }
}

export class GetDownlineResponse { 
    downlines: LobbyAgentDownlineDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["Downlines"] && data["Downlines"].constructor === Array) {
                this.downlines = [];
                for (let item of data["Downlines"])
                    this.downlines.push(LobbyAgentDownlineDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDownlineResponse {
        return new GetDownlineResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.downlines && this.downlines.constructor === Array) {
            data["Downlines"] = [];
            for (let item of this.downlines)
                data["Downlines"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetDownlineResponse(JSON.parse(json));
    }
}

export class LobbyAgentDownlineDao { 
    lobbyAgentId: number; 
    parentId: number; 
    promotionCode: string; 
    agentName: string; 
    boAdminId: number; 
    boUserName: string; 
    url: string; 
    commissionRatio: number; 
    remark: string; 
    subLobbyAgents: LobbyAgentDownlineDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.parentId = data["ParentId"] !== undefined ? data["ParentId"] : null;
            this.promotionCode = data["PromotionCode"] !== undefined ? data["PromotionCode"] : null;
            this.agentName = data["AgentName"] !== undefined ? data["AgentName"] : null;
            this.boAdminId = data["BoAdminId"] !== undefined ? data["BoAdminId"] : null;
            this.boUserName = data["BoUserName"] !== undefined ? data["BoUserName"] : null;
            this.url = data["Url"] !== undefined ? data["Url"] : null;
            this.commissionRatio = data["CommissionRatio"] !== undefined ? data["CommissionRatio"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            if (data["SubLobbyAgents"] && data["SubLobbyAgents"].constructor === Array) {
                this.subLobbyAgents = [];
                for (let item of data["SubLobbyAgents"])
                    this.subLobbyAgents.push(LobbyAgentDownlineDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyAgentDownlineDao {
        return new LobbyAgentDownlineDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["ParentId"] = this.parentId !== undefined ? this.parentId : null;
        data["PromotionCode"] = this.promotionCode !== undefined ? this.promotionCode : null;
        data["AgentName"] = this.agentName !== undefined ? this.agentName : null;
        data["BoAdminId"] = this.boAdminId !== undefined ? this.boAdminId : null;
        data["BoUserName"] = this.boUserName !== undefined ? this.boUserName : null;
        data["Url"] = this.url !== undefined ? this.url : null;
        data["CommissionRatio"] = this.commissionRatio !== undefined ? this.commissionRatio : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        if (this.subLobbyAgents && this.subLobbyAgents.constructor === Array) {
            data["SubLobbyAgents"] = [];
            for (let item of this.subLobbyAgents)
                data["SubLobbyAgents"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyAgentDownlineDao(JSON.parse(json));
    }
}

export class StandardResponseOfGetMaxCommissionRatioResponse { 
    isSuccess: boolean; 
    payload: GetMaxCommissionRatioResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? GetMaxCommissionRatioResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfGetMaxCommissionRatioResponse {
        return new StandardResponseOfGetMaxCommissionRatioResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfGetMaxCommissionRatioResponse(JSON.parse(json));
    }
}

export class GetMaxCommissionRatioResponse { 
    maxCommissionRatio: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.maxCommissionRatio = data["MaxCommissionRatio"] !== undefined ? data["MaxCommissionRatio"] : null;
        }
    }

    static fromJS(data: any): GetMaxCommissionRatioResponse {
        return new GetMaxCommissionRatioResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["MaxCommissionRatio"] = this.maxCommissionRatio !== undefined ? this.maxCommissionRatio : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetMaxCommissionRatioResponse(JSON.parse(json));
    }
}

export class GetDownlineForEditRequest { 
    lobbyAgentId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
        }
    }

    static fromJS(data: any): GetDownlineForEditRequest {
        return new GetDownlineForEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetDownlineForEditRequest(JSON.parse(json));
    }
}

export class StandardResponseOfGetDownlineForEditResponse { 
    isSuccess: boolean; 
    payload: GetDownlineForEditResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? GetDownlineForEditResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfGetDownlineForEditResponse {
        return new StandardResponseOfGetDownlineForEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfGetDownlineForEditResponse(JSON.parse(json));
    }
}

export class GetDownlineForEditResponse { 
    lobbyAgentId: number; 
    maxCommissionRatio: number; 
    agentName: string; 
    phoneNumber: string; 
    email: string; 
    bank: string; 
    bankAccount: string; 
    remark: string; 
    commissionRatio: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.maxCommissionRatio = data["MaxCommissionRatio"] !== undefined ? data["MaxCommissionRatio"] : null;
            this.agentName = data["AgentName"] !== undefined ? data["AgentName"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.email = data["Email"] !== undefined ? data["Email"] : null;
            this.bank = data["Bank"] !== undefined ? data["Bank"] : null;
            this.bankAccount = data["BankAccount"] !== undefined ? data["BankAccount"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.commissionRatio = data["CommissionRatio"] !== undefined ? data["CommissionRatio"] : null;
        }
    }

    static fromJS(data: any): GetDownlineForEditResponse {
        return new GetDownlineForEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["MaxCommissionRatio"] = this.maxCommissionRatio !== undefined ? this.maxCommissionRatio : null;
        data["AgentName"] = this.agentName !== undefined ? this.agentName : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["Email"] = this.email !== undefined ? this.email : null;
        data["Bank"] = this.bank !== undefined ? this.bank : null;
        data["BankAccount"] = this.bankAccount !== undefined ? this.bankAccount : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["CommissionRatio"] = this.commissionRatio !== undefined ? this.commissionRatio : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetDownlineForEditResponse(JSON.parse(json));
    }
}

export class CreateDownlineRequest { 
    agentName: string; 
    phoneNumber: string; 
    email: string; 
    bank: string; 
    bankAccount: string; 
    remark: string; 
    commissionRatio: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.agentName = data["AgentName"] !== undefined ? data["AgentName"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.email = data["Email"] !== undefined ? data["Email"] : null;
            this.bank = data["Bank"] !== undefined ? data["Bank"] : null;
            this.bankAccount = data["BankAccount"] !== undefined ? data["BankAccount"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.commissionRatio = data["CommissionRatio"] !== undefined ? data["CommissionRatio"] : null;
        }
    }

    static fromJS(data: any): CreateDownlineRequest {
        return new CreateDownlineRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["AgentName"] = this.agentName !== undefined ? this.agentName : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["Email"] = this.email !== undefined ? this.email : null;
        data["Bank"] = this.bank !== undefined ? this.bank : null;
        data["BankAccount"] = this.bankAccount !== undefined ? this.bankAccount : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["CommissionRatio"] = this.commissionRatio !== undefined ? this.commissionRatio : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CreateDownlineRequest(JSON.parse(json));
    }
}

export class StandardResponseOfCreateDownlineResponse { 
    isSuccess: boolean; 
    payload: CreateDownlineResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? CreateDownlineResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfCreateDownlineResponse {
        return new StandardResponseOfCreateDownlineResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfCreateDownlineResponse(JSON.parse(json));
    }
}

export class CreateDownlineResponse { 
    agentName: string; 
    promotionCode: string; 
    boUserName: string; 
    boPassword: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.agentName = data["AgentName"] !== undefined ? data["AgentName"] : null;
            this.promotionCode = data["PromotionCode"] !== undefined ? data["PromotionCode"] : null;
            this.boUserName = data["BoUserName"] !== undefined ? data["BoUserName"] : null;
            this.boPassword = data["BoPassword"] !== undefined ? data["BoPassword"] : null;
        }
    }

    static fromJS(data: any): CreateDownlineResponse {
        return new CreateDownlineResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["AgentName"] = this.agentName !== undefined ? this.agentName : null;
        data["PromotionCode"] = this.promotionCode !== undefined ? this.promotionCode : null;
        data["BoUserName"] = this.boUserName !== undefined ? this.boUserName : null;
        data["BoPassword"] = this.boPassword !== undefined ? this.boPassword : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CreateDownlineResponse(JSON.parse(json));
    }
}

export class EditDownlineRequest { 
    lobbyAgentId: number; 
    agentName: string; 
    phoneNumber: string; 
    email: string; 
    bank: string; 
    bankAccount: string; 
    remark: string; 
    commissionRatio: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.agentName = data["AgentName"] !== undefined ? data["AgentName"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.email = data["Email"] !== undefined ? data["Email"] : null;
            this.bank = data["Bank"] !== undefined ? data["Bank"] : null;
            this.bankAccount = data["BankAccount"] !== undefined ? data["BankAccount"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.commissionRatio = data["CommissionRatio"] !== undefined ? data["CommissionRatio"] : null;
        }
    }

    static fromJS(data: any): EditDownlineRequest {
        return new EditDownlineRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["AgentName"] = this.agentName !== undefined ? this.agentName : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["Email"] = this.email !== undefined ? this.email : null;
        data["Bank"] = this.bank !== undefined ? this.bank : null;
        data["BankAccount"] = this.bankAccount !== undefined ? this.bankAccount : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["CommissionRatio"] = this.commissionRatio !== undefined ? this.commissionRatio : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new EditDownlineRequest(JSON.parse(json));
    }
}

export class LobbyAgentTree { 
    topAgent: AgentInfo; 
    subAgents: AgentInfo[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.topAgent = data["TopAgent"] ? AgentInfo.fromJS(data["TopAgent"]) : null;
            if (data["SubAgents"] && data["SubAgents"].constructor === Array) {
                this.subAgents = [];
                for (let item of data["SubAgents"])
                    this.subAgents.push(AgentInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyAgentTree {
        return new LobbyAgentTree(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["TopAgent"] = this.topAgent ? this.topAgent.toJS() : null;
        if (this.subAgents && this.subAgents.constructor === Array) {
            data["SubAgents"] = [];
            for (let item of this.subAgents)
                data["SubAgents"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyAgentTree(JSON.parse(json));
    }
}

export class AgentInfo { 
    lobbyAgentId: number; 
    nameWithPromotionCode: string; 
    parentId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.nameWithPromotionCode = data["NameWithPromotionCode"] !== undefined ? data["NameWithPromotionCode"] : null;
            this.parentId = data["ParentId"] !== undefined ? data["ParentId"] : null;
        }
    }

    static fromJS(data: any): AgentInfo {
        return new AgentInfo(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["NameWithPromotionCode"] = this.nameWithPromotionCode !== undefined ? this.nameWithPromotionCode : null;
        data["ParentId"] = this.parentId !== undefined ? this.parentId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AgentInfo(JSON.parse(json));
    }
}

export class LobbyAgentUpdateRequest { 
    agents: AgentInfo2[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["Agents"] && data["Agents"].constructor === Array) {
                this.agents = [];
                for (let item of data["Agents"])
                    this.agents.push(AgentInfo2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyAgentUpdateRequest {
        return new LobbyAgentUpdateRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.agents && this.agents.constructor === Array) {
            data["Agents"] = [];
            for (let item of this.agents)
                data["Agents"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyAgentUpdateRequest(JSON.parse(json));
    }
}

export class AgentInfo2 { 
    lobbyAgentId: number; 
    parentId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.parentId = data["ParentId"] !== undefined ? data["ParentId"] : null;
        }
    }

    static fromJS(data: any): AgentInfo2 {
        return new AgentInfo2(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["ParentId"] = this.parentId !== undefined ? this.parentId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AgentInfo2(JSON.parse(json));
    }
}

export class GetLobbyAgentPlayerByNameResponse { 
    playerId: number; 
    playerName: string; 
    lobbyAgentId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["playerId"] !== undefined ? data["playerId"] : null;
            this.playerName = data["playerName"] !== undefined ? data["playerName"] : null;
            this.lobbyAgentId = data["lobbyAgentId"] !== undefined ? data["lobbyAgentId"] : null;
        }
    }

    static fromJS(data: any): GetLobbyAgentPlayerByNameResponse {
        return new GetLobbyAgentPlayerByNameResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["playerId"] = this.playerId !== undefined ? this.playerId : null;
        data["playerName"] = this.playerName !== undefined ? this.playerName : null;
        data["lobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetLobbyAgentPlayerByNameResponse(JSON.parse(json));
    }
}

export class PlayerTransactionListByLobbyAgentIdRequest { 
    lobbyId: number; 
    lobbyAgentId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date; 
    groupById: number; 
    lobbyAgentTypeId: LobbyAgentTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.groupById = data["GroupById"] !== undefined ? data["GroupById"] : null;
            this.lobbyAgentTypeId = data["lobbyAgentTypeId"] !== undefined ? data["lobbyAgentTypeId"] : null;
        }
    }

    static fromJS(data: any): PlayerTransactionListByLobbyAgentIdRequest {
        return new PlayerTransactionListByLobbyAgentIdRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["GroupById"] = this.groupById !== undefined ? this.groupById : null;
        data["lobbyAgentTypeId"] = this.lobbyAgentTypeId !== undefined ? this.lobbyAgentTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerTransactionListByLobbyAgentIdRequest(JSON.parse(json));
    }
}

export enum LobbyAgentTypeId {
    Agent = 1, 
    Friend = 2, 
}

export class PlayerTransactionListAgentItem { 
    name: string; 
    playerCount: number; 
    betCount: number; 
    betTotal: number; 
    validBetTotal: number; 
    winLoss: number; 
    agentAmount: number; 
    subList: PlayerTransactionListAgentItem[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.playerCount = data["PlayerCount"] !== undefined ? data["PlayerCount"] : null;
            this.betCount = data["BetCount"] !== undefined ? data["BetCount"] : null;
            this.betTotal = data["BetTotal"] !== undefined ? data["BetTotal"] : null;
            this.validBetTotal = data["ValidBetTotal"] !== undefined ? data["ValidBetTotal"] : null;
            this.winLoss = data["WinLoss"] !== undefined ? data["WinLoss"] : null;
            this.agentAmount = data["agentAmount"] !== undefined ? data["agentAmount"] : null;
            if (data["SubList"] && data["SubList"].constructor === Array) {
                this.subList = [];
                for (let item of data["SubList"])
                    this.subList.push(PlayerTransactionListAgentItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerTransactionListAgentItem {
        return new PlayerTransactionListAgentItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["PlayerCount"] = this.playerCount !== undefined ? this.playerCount : null;
        data["BetCount"] = this.betCount !== undefined ? this.betCount : null;
        data["BetTotal"] = this.betTotal !== undefined ? this.betTotal : null;
        data["ValidBetTotal"] = this.validBetTotal !== undefined ? this.validBetTotal : null;
        data["WinLoss"] = this.winLoss !== undefined ? this.winLoss : null;
        data["agentAmount"] = this.agentAmount !== undefined ? this.agentAmount : null;
        if (this.subList && this.subList.constructor === Array) {
            data["SubList"] = [];
            for (let item of this.subList)
                data["SubList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerTransactionListAgentItem(JSON.parse(json));
    }
}

export class PlayerPromotionListByLobbyAgentIdRequest { 
    lobbyId: number; 
    lobbyAgentId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date; 
    groupById: number; 
    lobbyAgentTypeId: LobbyAgentTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.groupById = data["GroupById"] !== undefined ? data["GroupById"] : null;
            this.lobbyAgentTypeId = data["lobbyAgentTypeId"] !== undefined ? data["lobbyAgentTypeId"] : null;
        }
    }

    static fromJS(data: any): PlayerPromotionListByLobbyAgentIdRequest {
        return new PlayerPromotionListByLobbyAgentIdRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["GroupById"] = this.groupById !== undefined ? this.groupById : null;
        data["lobbyAgentTypeId"] = this.lobbyAgentTypeId !== undefined ? this.lobbyAgentTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerPromotionListByLobbyAgentIdRequest(JSON.parse(json));
    }
}

export class PlayerPromotionListAgentItem { 
    name: string; 
    playerCount: number; 
    promotionCount: number; 
    promotionAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.playerCount = data["PlayerCount"] !== undefined ? data["PlayerCount"] : null;
            this.promotionCount = data["PromotionCount"] !== undefined ? data["PromotionCount"] : null;
            this.promotionAmount = data["PromotionAmount"] !== undefined ? data["PromotionAmount"] : null;
        }
    }

    static fromJS(data: any): PlayerPromotionListAgentItem {
        return new PlayerPromotionListAgentItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["PlayerCount"] = this.playerCount !== undefined ? this.playerCount : null;
        data["PromotionCount"] = this.promotionCount !== undefined ? this.promotionCount : null;
        data["PromotionAmount"] = this.promotionAmount !== undefined ? this.promotionAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerPromotionListAgentItem(JSON.parse(json));
    }
}

export class PlayerDWRecordsByLobbyAgentIdRequest { 
    lobbyId: number; 
    lobbyAgentId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date; 
    groupById: number; 
    lobbyAgentTypeId: LobbyAgentTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.groupById = data["GroupById"] !== undefined ? data["GroupById"] : null;
            this.lobbyAgentTypeId = data["lobbyAgentTypeId"] !== undefined ? data["lobbyAgentTypeId"] : null;
        }
    }

    static fromJS(data: any): PlayerDWRecordsByLobbyAgentIdRequest {
        return new PlayerDWRecordsByLobbyAgentIdRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["GroupById"] = this.groupById !== undefined ? this.groupById : null;
        data["lobbyAgentTypeId"] = this.lobbyAgentTypeId !== undefined ? this.lobbyAgentTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerDWRecordsByLobbyAgentIdRequest(JSON.parse(json));
    }
}

export class PlayerDWRecordsAgentItem { 
    name: string; 
    depositCount: number; 
    depositAmount: number; 
    withdrawCount: number; 
    withdrawAmount: number; 
    amountDiff: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.depositCount = data["DepositCount"] !== undefined ? data["DepositCount"] : null;
            this.depositAmount = data["DepositAmount"] !== undefined ? data["DepositAmount"] : null;
            this.withdrawCount = data["WithdrawCount"] !== undefined ? data["WithdrawCount"] : null;
            this.withdrawAmount = data["WithdrawAmount"] !== undefined ? data["WithdrawAmount"] : null;
            this.amountDiff = data["AmountDiff"] !== undefined ? data["AmountDiff"] : null;
        }
    }

    static fromJS(data: any): PlayerDWRecordsAgentItem {
        return new PlayerDWRecordsAgentItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["DepositCount"] = this.depositCount !== undefined ? this.depositCount : null;
        data["DepositAmount"] = this.depositAmount !== undefined ? this.depositAmount : null;
        data["WithdrawCount"] = this.withdrawCount !== undefined ? this.withdrawCount : null;
        data["WithdrawAmount"] = this.withdrawAmount !== undefined ? this.withdrawAmount : null;
        data["AmountDiff"] = this.amountDiff !== undefined ? this.amountDiff : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerDWRecordsAgentItem(JSON.parse(json));
    }
}

export class PlayerRegisterListByLobbyAgentIdRequest { 
    lobbyId: number; 
    lobbyAgentId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date; 
    groupById: number; 
    lobbyAgentTypeId: LobbyAgentTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.groupById = data["GroupById"] !== undefined ? data["GroupById"] : null;
            this.lobbyAgentTypeId = data["lobbyAgentTypeId"] !== undefined ? data["lobbyAgentTypeId"] : null;
        }
    }

    static fromJS(data: any): PlayerRegisterListByLobbyAgentIdRequest {
        return new PlayerRegisterListByLobbyAgentIdRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["GroupById"] = this.groupById !== undefined ? this.groupById : null;
        data["lobbyAgentTypeId"] = this.lobbyAgentTypeId !== undefined ? this.lobbyAgentTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerRegisterListByLobbyAgentIdRequest(JSON.parse(json));
    }
}

export class PlayerRegisterListAgentItem { 
    playerId: number; 
    playerName: string; 
    playerRealName: string; 
    agentCodeName: string; 
    regIP: string; 
    regDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.playerRealName = data["PlayerRealName"] !== undefined ? data["PlayerRealName"] : null;
            this.agentCodeName = data["AgentCodeName"] !== undefined ? data["AgentCodeName"] : null;
            this.regIP = data["RegIP"] !== undefined ? data["RegIP"] : null;
            this.regDate = data["RegDate"] ? new Date(data["RegDate"].toString()) : null;
        }
    }

    static fromJS(data: any): PlayerRegisterListAgentItem {
        return new PlayerRegisterListAgentItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["PlayerRealName"] = this.playerRealName !== undefined ? this.playerRealName : null;
        data["AgentCodeName"] = this.agentCodeName !== undefined ? this.agentCodeName : null;
        data["RegIP"] = this.regIP !== undefined ? this.regIP : null;
        data["RegDate"] = this.regDate ? this.regDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerRegisterListAgentItem(JSON.parse(json));
    }
}

export class PlayerSummaryGetAllAgentRequest { 
    lobbyId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date; 
    lobbyAgentTypeId: LobbyAgentTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.lobbyAgentTypeId = data["lobbyAgentTypeId"] !== undefined ? data["lobbyAgentTypeId"] : null;
        }
    }

    static fromJS(data: any): PlayerSummaryGetAllAgentRequest {
        return new PlayerSummaryGetAllAgentRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["lobbyAgentTypeId"] = this.lobbyAgentTypeId !== undefined ? this.lobbyAgentTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerSummaryGetAllAgentRequest(JSON.parse(json));
    }
}

export class PlayerSummaryAgentReponse { 
    allSummary: PlayerSummaryGetAllAgentReponse[]; 
    allSummaryBySubItems: PlayerSummaryGetAllAgentReponse[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["allSummary"] && data["allSummary"].constructor === Array) {
                this.allSummary = [];
                for (let item of data["allSummary"])
                    this.allSummary.push(PlayerSummaryGetAllAgentReponse.fromJS(item));
            }
            if (data["allSummaryBySubItems"] && data["allSummaryBySubItems"].constructor === Array) {
                this.allSummaryBySubItems = [];
                for (let item of data["allSummaryBySubItems"])
                    this.allSummaryBySubItems.push(PlayerSummaryGetAllAgentReponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerSummaryAgentReponse {
        return new PlayerSummaryAgentReponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.allSummary && this.allSummary.constructor === Array) {
            data["allSummary"] = [];
            for (let item of this.allSummary)
                data["allSummary"].push(item.toJS());
        }
        if (this.allSummaryBySubItems && this.allSummaryBySubItems.constructor === Array) {
            data["allSummaryBySubItems"] = [];
            for (let item of this.allSummaryBySubItems)
                data["allSummaryBySubItems"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerSummaryAgentReponse(JSON.parse(json));
    }
}

export class PlayerSummaryGetAllAgentReponse { 
    lobbyAgentId: number; 
    lobbyAgentName: string; 
    parentId: number; 
    parentLobbyAgentName: string; 
    parentLobbyAgentPromotionCode: string; 
    memberCount: number; 
    winLossTotal: number; 
    promotionTotal: number; 
    dWDiffTotal: number; 
    pDWDiffTotal: number; 
    depositTotal: number; 
    withdrawTotal: number; 
    validBetTotal: number; 
    betTotal: number; 
    payoutTotal: number; 
    rebateTotal: number; 
    subItems: PlayerSummaryGetAllAgentReponse[]; 
    promotionCode: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.lobbyAgentName = data["LobbyAgentName"] !== undefined ? data["LobbyAgentName"] : null;
            this.parentId = data["ParentId"] !== undefined ? data["ParentId"] : null;
            this.parentLobbyAgentName = data["ParentLobbyAgentName"] !== undefined ? data["ParentLobbyAgentName"] : null;
            this.parentLobbyAgentPromotionCode = data["ParentLobbyAgentPromotionCode"] !== undefined ? data["ParentLobbyAgentPromotionCode"] : null;
            this.memberCount = data["MemberCount"] !== undefined ? data["MemberCount"] : null;
            this.winLossTotal = data["WinLossTotal"] !== undefined ? data["WinLossTotal"] : null;
            this.promotionTotal = data["PromotionTotal"] !== undefined ? data["PromotionTotal"] : null;
            this.dWDiffTotal = data["DWDiffTotal"] !== undefined ? data["DWDiffTotal"] : null;
            this.pDWDiffTotal = data["PDWDiffTotal"] !== undefined ? data["PDWDiffTotal"] : null;
            this.depositTotal = data["DepositTotal"] !== undefined ? data["DepositTotal"] : null;
            this.withdrawTotal = data["WithdrawTotal"] !== undefined ? data["WithdrawTotal"] : null;
            this.validBetTotal = data["ValidBetTotal"] !== undefined ? data["ValidBetTotal"] : null;
            this.betTotal = data["BetTotal"] !== undefined ? data["BetTotal"] : null;
            this.payoutTotal = data["PayoutTotal"] !== undefined ? data["PayoutTotal"] : null;
            this.rebateTotal = data["RebateTotal"] !== undefined ? data["RebateTotal"] : null;
            if (data["SubItems"] && data["SubItems"].constructor === Array) {
                this.subItems = [];
                for (let item of data["SubItems"])
                    this.subItems.push(PlayerSummaryGetAllAgentReponse.fromJS(item));
            }
            this.promotionCode = data["PromotionCode"] !== undefined ? data["PromotionCode"] : null;
        }
    }

    static fromJS(data: any): PlayerSummaryGetAllAgentReponse {
        return new PlayerSummaryGetAllAgentReponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["LobbyAgentName"] = this.lobbyAgentName !== undefined ? this.lobbyAgentName : null;
        data["ParentId"] = this.parentId !== undefined ? this.parentId : null;
        data["ParentLobbyAgentName"] = this.parentLobbyAgentName !== undefined ? this.parentLobbyAgentName : null;
        data["ParentLobbyAgentPromotionCode"] = this.parentLobbyAgentPromotionCode !== undefined ? this.parentLobbyAgentPromotionCode : null;
        data["MemberCount"] = this.memberCount !== undefined ? this.memberCount : null;
        data["WinLossTotal"] = this.winLossTotal !== undefined ? this.winLossTotal : null;
        data["PromotionTotal"] = this.promotionTotal !== undefined ? this.promotionTotal : null;
        data["DWDiffTotal"] = this.dWDiffTotal !== undefined ? this.dWDiffTotal : null;
        data["PDWDiffTotal"] = this.pDWDiffTotal !== undefined ? this.pDWDiffTotal : null;
        data["DepositTotal"] = this.depositTotal !== undefined ? this.depositTotal : null;
        data["WithdrawTotal"] = this.withdrawTotal !== undefined ? this.withdrawTotal : null;
        data["ValidBetTotal"] = this.validBetTotal !== undefined ? this.validBetTotal : null;
        data["BetTotal"] = this.betTotal !== undefined ? this.betTotal : null;
        data["PayoutTotal"] = this.payoutTotal !== undefined ? this.payoutTotal : null;
        data["RebateTotal"] = this.rebateTotal !== undefined ? this.rebateTotal : null;
        if (this.subItems && this.subItems.constructor === Array) {
            data["SubItems"] = [];
            for (let item of this.subItems)
                data["SubItems"].push(item.toJS());
        }
        data["PromotionCode"] = this.promotionCode !== undefined ? this.promotionCode : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerSummaryGetAllAgentReponse(JSON.parse(json));
    }
}

export class FriendUnionSummaryRequest { 
    lobbyId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date; 
    lobbyAgentTypeId: LobbyAgentTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.lobbyAgentTypeId = data["lobbyAgentTypeId"] !== undefined ? data["lobbyAgentTypeId"] : null;
        }
    }

    static fromJS(data: any): FriendUnionSummaryRequest {
        return new FriendUnionSummaryRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["lobbyAgentTypeId"] = this.lobbyAgentTypeId !== undefined ? this.lobbyAgentTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new FriendUnionSummaryRequest(JSON.parse(json));
    }
}

export class FU_SummaryResponse { 
    summaryByDate: FU_SummaryItem[]; 
    summaryByUser: FU_UserItem[]; 
    validSummaryByUser: FU_UserItem[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["SummaryByDate"] && data["SummaryByDate"].constructor === Array) {
                this.summaryByDate = [];
                for (let item of data["SummaryByDate"])
                    this.summaryByDate.push(FU_SummaryItem.fromJS(item));
            }
            if (data["SummaryByUser"] && data["SummaryByUser"].constructor === Array) {
                this.summaryByUser = [];
                for (let item of data["SummaryByUser"])
                    this.summaryByUser.push(FU_UserItem.fromJS(item));
            }
            if (data["ValidSummaryByUser"] && data["ValidSummaryByUser"].constructor === Array) {
                this.validSummaryByUser = [];
                for (let item of data["ValidSummaryByUser"])
                    this.validSummaryByUser.push(FU_UserItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FU_SummaryResponse {
        return new FU_SummaryResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.summaryByDate && this.summaryByDate.constructor === Array) {
            data["SummaryByDate"] = [];
            for (let item of this.summaryByDate)
                data["SummaryByDate"].push(item.toJS());
        }
        if (this.summaryByUser && this.summaryByUser.constructor === Array) {
            data["SummaryByUser"] = [];
            for (let item of this.summaryByUser)
                data["SummaryByUser"].push(item.toJS());
        }
        if (this.validSummaryByUser && this.validSummaryByUser.constructor === Array) {
            data["ValidSummaryByUser"] = [];
            for (let item of this.validSummaryByUser)
                data["ValidSummaryByUser"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new FU_SummaryResponse(JSON.parse(json));
    }
}

export class FU_SummaryItem { 
    date: Date; 
    dumpId: string; 
    updateBy: string; 
    updateDate: Date; 
    totalValidBetAmount: number; 
    totalCommissionAmount: number; 
    totalPaidCommissionAmount: number; 
    userItemCount: number; 
    showPayButton: boolean; 
    userItems: FU_UserItem[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.date = data["Date"] ? new Date(data["Date"].toString()) : null;
            this.dumpId = data["DumpId"] !== undefined ? data["DumpId"] : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.totalValidBetAmount = data["TotalValidBetAmount"] !== undefined ? data["TotalValidBetAmount"] : null;
            this.totalCommissionAmount = data["TotalCommissionAmount"] !== undefined ? data["TotalCommissionAmount"] : null;
            this.totalPaidCommissionAmount = data["TotalPaidCommissionAmount"] !== undefined ? data["TotalPaidCommissionAmount"] : null;
            this.userItemCount = data["UserItemCount"] !== undefined ? data["UserItemCount"] : null;
            this.showPayButton = data["ShowPayButton"] !== undefined ? data["ShowPayButton"] : null;
            if (data["UserItems"] && data["UserItems"].constructor === Array) {
                this.userItems = [];
                for (let item of data["UserItems"])
                    this.userItems.push(FU_UserItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FU_SummaryItem {
        return new FU_SummaryItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Date"] = this.date ? this.date.toISOString() : null;
        data["DumpId"] = this.dumpId !== undefined ? this.dumpId : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["TotalValidBetAmount"] = this.totalValidBetAmount !== undefined ? this.totalValidBetAmount : null;
        data["TotalCommissionAmount"] = this.totalCommissionAmount !== undefined ? this.totalCommissionAmount : null;
        data["TotalPaidCommissionAmount"] = this.totalPaidCommissionAmount !== undefined ? this.totalPaidCommissionAmount : null;
        data["UserItemCount"] = this.userItemCount !== undefined ? this.userItemCount : null;
        data["ShowPayButton"] = this.showPayButton !== undefined ? this.showPayButton : null;
        if (this.userItems && this.userItems.constructor === Array) {
            data["UserItems"] = [];
            for (let item of this.userItems)
                data["UserItems"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new FU_SummaryItem(JSON.parse(json));
    }
}

export class FU_UserItem { 
    userId: number; 
    username: string; 
    userPromotionCode: string; 
    totalValidBetAmount: number; 
    totalCommissionAmount: number; 
    totalPaidCommissionAmount: number; 
    friendItemCount: number; 
    friendsTotalCount: number; 
    friendItems: FU_FriendItem[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.userId = data["UserId"] !== undefined ? data["UserId"] : null;
            this.username = data["Username"] !== undefined ? data["Username"] : null;
            this.userPromotionCode = data["UserPromotionCode"] !== undefined ? data["UserPromotionCode"] : null;
            this.totalValidBetAmount = data["TotalValidBetAmount"] !== undefined ? data["TotalValidBetAmount"] : null;
            this.totalCommissionAmount = data["TotalCommissionAmount"] !== undefined ? data["TotalCommissionAmount"] : null;
            this.totalPaidCommissionAmount = data["TotalPaidCommissionAmount"] !== undefined ? data["TotalPaidCommissionAmount"] : null;
            this.friendItemCount = data["FriendItemCount"] !== undefined ? data["FriendItemCount"] : null;
            this.friendsTotalCount = data["FriendsTotalCount"] !== undefined ? data["FriendsTotalCount"] : null;
            if (data["FriendItems"] && data["FriendItems"].constructor === Array) {
                this.friendItems = [];
                for (let item of data["FriendItems"])
                    this.friendItems.push(FU_FriendItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FU_UserItem {
        return new FU_UserItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["UserId"] = this.userId !== undefined ? this.userId : null;
        data["Username"] = this.username !== undefined ? this.username : null;
        data["UserPromotionCode"] = this.userPromotionCode !== undefined ? this.userPromotionCode : null;
        data["TotalValidBetAmount"] = this.totalValidBetAmount !== undefined ? this.totalValidBetAmount : null;
        data["TotalCommissionAmount"] = this.totalCommissionAmount !== undefined ? this.totalCommissionAmount : null;
        data["TotalPaidCommissionAmount"] = this.totalPaidCommissionAmount !== undefined ? this.totalPaidCommissionAmount : null;
        data["FriendItemCount"] = this.friendItemCount !== undefined ? this.friendItemCount : null;
        data["FriendsTotalCount"] = this.friendsTotalCount !== undefined ? this.friendsTotalCount : null;
        if (this.friendItems && this.friendItems.constructor === Array) {
            data["FriendItems"] = [];
            for (let item of this.friendItems)
                data["FriendItems"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new FU_UserItem(JSON.parse(json));
    }
}

export class FU_FriendItem { 
    friendUserId: number; 
    friendUsername: string; 
    friendPromotionCode: string; 
    parentFriendUserId: number; 
    parentFriendUsername: string; 
    friendLevel: number; 
    transactionNos: string[]; 
    totalValidBetAmount: number; 
    totalCommissionAmount: number; 
    totalPaidCommissionAmount: number; 
    platfromItemCount: number; 
    platformItems: FU_PlatformItem[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.friendUserId = data["FriendUserId"] !== undefined ? data["FriendUserId"] : null;
            this.friendUsername = data["FriendUsername"] !== undefined ? data["FriendUsername"] : null;
            this.friendPromotionCode = data["FriendPromotionCode"] !== undefined ? data["FriendPromotionCode"] : null;
            this.parentFriendUserId = data["ParentFriendUserId"] !== undefined ? data["ParentFriendUserId"] : null;
            this.parentFriendUsername = data["ParentFriendUsername"] !== undefined ? data["ParentFriendUsername"] : null;
            this.friendLevel = data["FriendLevel"] !== undefined ? data["FriendLevel"] : null;
            if (data["TransactionNos"] && data["TransactionNos"].constructor === Array) {
                this.transactionNos = [];
                for (let item of data["TransactionNos"])
                    this.transactionNos.push(item);
            }
            this.totalValidBetAmount = data["TotalValidBetAmount"] !== undefined ? data["TotalValidBetAmount"] : null;
            this.totalCommissionAmount = data["TotalCommissionAmount"] !== undefined ? data["TotalCommissionAmount"] : null;
            this.totalPaidCommissionAmount = data["TotalPaidCommissionAmount"] !== undefined ? data["TotalPaidCommissionAmount"] : null;
            this.platfromItemCount = data["PlatfromItemCount"] !== undefined ? data["PlatfromItemCount"] : null;
            if (data["PlatformItems"] && data["PlatformItems"].constructor === Array) {
                this.platformItems = [];
                for (let item of data["PlatformItems"])
                    this.platformItems.push(FU_PlatformItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FU_FriendItem {
        return new FU_FriendItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["FriendUserId"] = this.friendUserId !== undefined ? this.friendUserId : null;
        data["FriendUsername"] = this.friendUsername !== undefined ? this.friendUsername : null;
        data["FriendPromotionCode"] = this.friendPromotionCode !== undefined ? this.friendPromotionCode : null;
        data["ParentFriendUserId"] = this.parentFriendUserId !== undefined ? this.parentFriendUserId : null;
        data["ParentFriendUsername"] = this.parentFriendUsername !== undefined ? this.parentFriendUsername : null;
        data["FriendLevel"] = this.friendLevel !== undefined ? this.friendLevel : null;
        if (this.transactionNos && this.transactionNos.constructor === Array) {
            data["TransactionNos"] = [];
            for (let item of this.transactionNos)
                data["TransactionNos"].push(item);
        }
        data["TotalValidBetAmount"] = this.totalValidBetAmount !== undefined ? this.totalValidBetAmount : null;
        data["TotalCommissionAmount"] = this.totalCommissionAmount !== undefined ? this.totalCommissionAmount : null;
        data["TotalPaidCommissionAmount"] = this.totalPaidCommissionAmount !== undefined ? this.totalPaidCommissionAmount : null;
        data["PlatfromItemCount"] = this.platfromItemCount !== undefined ? this.platfromItemCount : null;
        if (this.platformItems && this.platformItems.constructor === Array) {
            data["PlatformItems"] = [];
            for (let item of this.platformItems)
                data["PlatformItems"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new FU_FriendItem(JSON.parse(json));
    }
}

export class FU_PlatformItem { 
    subGameDevId: GameDevId; 
    gameDevName: string; 
    gameTypeName: string; 
    validBetAmount: number; 
    commissionAmount: number; 
    paidCommissionAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.subGameDevId = data["SubGameDevId"] !== undefined ? data["SubGameDevId"] : null;
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
            this.gameTypeName = data["GameTypeName"] !== undefined ? data["GameTypeName"] : null;
            this.validBetAmount = data["ValidBetAmount"] !== undefined ? data["ValidBetAmount"] : null;
            this.commissionAmount = data["CommissionAmount"] !== undefined ? data["CommissionAmount"] : null;
            this.paidCommissionAmount = data["PaidCommissionAmount"] !== undefined ? data["PaidCommissionAmount"] : null;
        }
    }

    static fromJS(data: any): FU_PlatformItem {
        return new FU_PlatformItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["SubGameDevId"] = this.subGameDevId !== undefined ? this.subGameDevId : null;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        data["GameTypeName"] = this.gameTypeName !== undefined ? this.gameTypeName : null;
        data["ValidBetAmount"] = this.validBetAmount !== undefined ? this.validBetAmount : null;
        data["CommissionAmount"] = this.commissionAmount !== undefined ? this.commissionAmount : null;
        data["PaidCommissionAmount"] = this.paidCommissionAmount !== undefined ? this.paidCommissionAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new FU_PlatformItem(JSON.parse(json));
    }
}

export class FU_PayCommissionRequest { 
    lobbyId: LobbyId; 
    language: LanguageCode; 
    date: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["lobbyId"] !== undefined ? data["lobbyId"] : null;
            this.language = data["language"] !== undefined ? data["language"] : null;
            this.date = data["date"] ? new Date(data["date"].toString()) : null;
        }
    }

    static fromJS(data: any): FU_PayCommissionRequest {
        return new FU_PayCommissionRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["lobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["language"] = this.language !== undefined ? this.language : null;
        data["date"] = this.date ? this.date.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new FU_PayCommissionRequest(JSON.parse(json));
    }
}

export enum LobbyId {
    Ja8 = 1, 
    S63 = 9, 
    SAG = 13, 
    SA36 = 14, 
    S36 = 15, 
    SalonSP = 16, 
    JLH = 17, 
    King99 = 18, 
    SAQA_Transfer = 19, 
    SAQA_Common = 20, 
    SA16 = 21, 
    Salon365 = 22, 
    SaGame = 23, 
    Sss98 = 24, 
    SaTransfer1 = 25, 
    SaCommon1 = 26, 
    SaTransfer2 = 27, 
    SaCommon2 = 28, 
    Winsplay = 29, 
    SaGameVi = 30, 
    LuckyLotto = 31, 
    JBC8 = 32, 
}

export class FU_PayCommissionResponse { 
    isSuccess: boolean; 
    errorMessage: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            if (data["ErrorMessage"] && data["ErrorMessage"].constructor === Array) {
                this.errorMessage = [];
                for (let item of data["ErrorMessage"])
                    this.errorMessage.push(item);
            }
        }
    }

    static fromJS(data: any): FU_PayCommissionResponse {
        return new FU_PayCommissionResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.errorMessage && this.errorMessage.constructor === Array) {
            data["ErrorMessage"] = [];
            for (let item of this.errorMessage)
                data["ErrorMessage"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new FU_PayCommissionResponse(JSON.parse(json));
    }
}

export class PlayerTransactionDetailByLobbyAgentIdRequest { 
    lobbyId: number; 
    playerName: string; 
    lobbyAgentId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date; 
    groupById: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.groupById = data["GroupById"] !== undefined ? data["GroupById"] : null;
        }
    }

    static fromJS(data: any): PlayerTransactionDetailByLobbyAgentIdRequest {
        return new PlayerTransactionDetailByLobbyAgentIdRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["GroupById"] = this.groupById !== undefined ? this.groupById : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerTransactionDetailByLobbyAgentIdRequest(JSON.parse(json));
    }
}

export class PlayerTransactionAgentPlayerLevelItem { 
    level: number; 
    playerCount: number; 
    betCount: number; 
    betTotal: number; 
    validBetTotal: number; 
    winLoss: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.level = data["Level"] !== undefined ? data["Level"] : null;
            this.playerCount = data["PlayerCount"] !== undefined ? data["PlayerCount"] : null;
            this.betCount = data["BetCount"] !== undefined ? data["BetCount"] : null;
            this.betTotal = data["BetTotal"] !== undefined ? data["BetTotal"] : null;
            this.validBetTotal = data["ValidBetTotal"] !== undefined ? data["ValidBetTotal"] : null;
            this.winLoss = data["WinLoss"] !== undefined ? data["WinLoss"] : null;
        }
    }

    static fromJS(data: any): PlayerTransactionAgentPlayerLevelItem {
        return new PlayerTransactionAgentPlayerLevelItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Level"] = this.level !== undefined ? this.level : null;
        data["PlayerCount"] = this.playerCount !== undefined ? this.playerCount : null;
        data["BetCount"] = this.betCount !== undefined ? this.betCount : null;
        data["BetTotal"] = this.betTotal !== undefined ? this.betTotal : null;
        data["ValidBetTotal"] = this.validBetTotal !== undefined ? this.validBetTotal : null;
        data["WinLoss"] = this.winLoss !== undefined ? this.winLoss : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerTransactionAgentPlayerLevelItem(JSON.parse(json));
    }
}

export class LobbyAuthorizeActionDao { 
    actionId: number; 
    category: string; 
    categoryType: string; 
    description: string; 
    isAuthorize: boolean; 
    behavior: LobbyAuthorizeBehaviorDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.actionId = data["ActionId"] !== undefined ? data["ActionId"] : null;
            this.category = data["Category"] !== undefined ? data["Category"] : null;
            this.categoryType = data["CategoryType"] !== undefined ? data["CategoryType"] : null;
            this.description = data["Description"] !== undefined ? data["Description"] : null;
            this.isAuthorize = data["IsAuthorize"] !== undefined ? data["IsAuthorize"] : null;
            if (data["Behavior"] && data["Behavior"].constructor === Array) {
                this.behavior = [];
                for (let item of data["Behavior"])
                    this.behavior.push(LobbyAuthorizeBehaviorDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyAuthorizeActionDao {
        return new LobbyAuthorizeActionDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["ActionId"] = this.actionId !== undefined ? this.actionId : null;
        data["Category"] = this.category !== undefined ? this.category : null;
        data["CategoryType"] = this.categoryType !== undefined ? this.categoryType : null;
        data["Description"] = this.description !== undefined ? this.description : null;
        data["IsAuthorize"] = this.isAuthorize !== undefined ? this.isAuthorize : null;
        if (this.behavior && this.behavior.constructor === Array) {
            data["Behavior"] = [];
            for (let item of this.behavior)
                data["Behavior"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyAuthorizeActionDao(JSON.parse(json));
    }
}

export class LobbyAuthorizeBehaviorDao { 
    lobbyBehaviorId: number; 
    actionId: number; 
    lobbyAuthorizeActionId: number; 
    behavior: string; 
    isAuthorize: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyBehaviorId = data["LobbyBehaviorId"] !== undefined ? data["LobbyBehaviorId"] : null;
            this.actionId = data["ActionId"] !== undefined ? data["ActionId"] : null;
            this.lobbyAuthorizeActionId = data["LobbyAuthorizeActionId"] !== undefined ? data["LobbyAuthorizeActionId"] : null;
            this.behavior = data["Behavior"] !== undefined ? data["Behavior"] : null;
            this.isAuthorize = data["IsAuthorize"] !== undefined ? data["IsAuthorize"] : null;
        }
    }

    static fromJS(data: any): LobbyAuthorizeBehaviorDao {
        return new LobbyAuthorizeBehaviorDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyBehaviorId"] = this.lobbyBehaviorId !== undefined ? this.lobbyBehaviorId : null;
        data["ActionId"] = this.actionId !== undefined ? this.actionId : null;
        data["LobbyAuthorizeActionId"] = this.lobbyAuthorizeActionId !== undefined ? this.lobbyAuthorizeActionId : null;
        data["Behavior"] = this.behavior !== undefined ? this.behavior : null;
        data["IsAuthorize"] = this.isAuthorize !== undefined ? this.isAuthorize : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyAuthorizeBehaviorDao(JSON.parse(json));
    }
}

export class PermissionsRequest { 
    lobbyRoleId: number; 
    permissions: LobbyAuthorizeActionUpdateDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyRoleId = data["lobbyRoleId"] !== undefined ? data["lobbyRoleId"] : null;
            if (data["Permissions"] && data["Permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["Permissions"])
                    this.permissions.push(LobbyAuthorizeActionUpdateDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionsRequest {
        return new PermissionsRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["lobbyRoleId"] = this.lobbyRoleId !== undefined ? this.lobbyRoleId : null;
        if (this.permissions && this.permissions.constructor === Array) {
            data["Permissions"] = [];
            for (let item of this.permissions)
                data["Permissions"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PermissionsRequest(JSON.parse(json));
    }
}

export class LobbyAuthorizeActionUpdateDao { 
    actionId: number; 
    isAuthorize: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.actionId = data["ActionId"] !== undefined ? data["ActionId"] : null;
            this.isAuthorize = data["IsAuthorize"] !== undefined ? data["IsAuthorize"] : null;
        }
    }

    static fromJS(data: any): LobbyAuthorizeActionUpdateDao {
        return new LobbyAuthorizeActionUpdateDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["ActionId"] = this.actionId !== undefined ? this.actionId : null;
        data["IsAuthorize"] = this.isAuthorize !== undefined ? this.isAuthorize : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyAuthorizeActionUpdateDao(JSON.parse(json));
    }
}

export class PermissionUpdateRequest { 
    lobbyRoleId: number; 
    permissions: UpdatedPermissions[]; 
    behaviors: UpdatedBehaviors[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyRoleId = data["lobbyRoleId"] !== undefined ? data["lobbyRoleId"] : null;
            if (data["Permissions"] && data["Permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["Permissions"])
                    this.permissions.push(UpdatedPermissions.fromJS(item));
            }
            if (data["Behaviors"] && data["Behaviors"].constructor === Array) {
                this.behaviors = [];
                for (let item of data["Behaviors"])
                    this.behaviors.push(UpdatedBehaviors.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionUpdateRequest {
        return new PermissionUpdateRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["lobbyRoleId"] = this.lobbyRoleId !== undefined ? this.lobbyRoleId : null;
        if (this.permissions && this.permissions.constructor === Array) {
            data["Permissions"] = [];
            for (let item of this.permissions)
                data["Permissions"].push(item.toJS());
        }
        if (this.behaviors && this.behaviors.constructor === Array) {
            data["Behaviors"] = [];
            for (let item of this.behaviors)
                data["Behaviors"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PermissionUpdateRequest(JSON.parse(json));
    }
}

export class UpdatedPermissions { 
    actionId: number; 
    isAuthorize: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.actionId = data["ActionId"] !== undefined ? data["ActionId"] : null;
            this.isAuthorize = data["IsAuthorize"] !== undefined ? data["IsAuthorize"] : null;
        }
    }

    static fromJS(data: any): UpdatedPermissions {
        return new UpdatedPermissions(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["ActionId"] = this.actionId !== undefined ? this.actionId : null;
        data["IsAuthorize"] = this.isAuthorize !== undefined ? this.isAuthorize : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new UpdatedPermissions(JSON.parse(json));
    }
}

export class UpdatedBehaviors { 
    actionId: number; 
    lobbyBehaviorId: number; 
    isAuthorize: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.actionId = data["ActionId"] !== undefined ? data["ActionId"] : null;
            this.lobbyBehaviorId = data["LobbyBehaviorId"] !== undefined ? data["LobbyBehaviorId"] : null;
            this.isAuthorize = data["IsAuthorize"] !== undefined ? data["IsAuthorize"] : null;
        }
    }

    static fromJS(data: any): UpdatedBehaviors {
        return new UpdatedBehaviors(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["ActionId"] = this.actionId !== undefined ? this.actionId : null;
        data["LobbyBehaviorId"] = this.lobbyBehaviorId !== undefined ? this.lobbyBehaviorId : null;
        data["IsAuthorize"] = this.isAuthorize !== undefined ? this.isAuthorize : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new UpdatedBehaviors(JSON.parse(json));
    }
}

export class SectionMenus { 
    sectionSeqId: number; 
    sectionName: string; 
    faIcon: string; 
    menuItems: MenuItems[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.sectionSeqId = data["SectionSeqId"] !== undefined ? data["SectionSeqId"] : null;
            this.sectionName = data["SectionName"] !== undefined ? data["SectionName"] : null;
            this.faIcon = data["faIcon"] !== undefined ? data["faIcon"] : null;
            if (data["MenuItems"] && data["MenuItems"].constructor === Array) {
                this.menuItems = [];
                for (let item of data["MenuItems"])
                    this.menuItems.push(MenuItems.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SectionMenus {
        return new SectionMenus(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["SectionSeqId"] = this.sectionSeqId !== undefined ? this.sectionSeqId : null;
        data["SectionName"] = this.sectionName !== undefined ? this.sectionName : null;
        data["faIcon"] = this.faIcon !== undefined ? this.faIcon : null;
        if (this.menuItems && this.menuItems.constructor === Array) {
            data["MenuItems"] = [];
            for (let item of this.menuItems)
                data["MenuItems"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SectionMenus(JSON.parse(json));
    }
}

export class MenuItems { 
    sectionSeqId: number; 
    sectionName: string; 
    faIcon: string; 
    menuSeqId: number; 
    path: string; 
    menuName: string; 
    categoryId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.sectionSeqId = data["SectionSeqId"] !== undefined ? data["SectionSeqId"] : null;
            this.sectionName = data["SectionName"] !== undefined ? data["SectionName"] : null;
            this.faIcon = data["faIcon"] !== undefined ? data["faIcon"] : null;
            this.menuSeqId = data["MenuSeqId"] !== undefined ? data["MenuSeqId"] : null;
            this.path = data["Path"] !== undefined ? data["Path"] : null;
            this.menuName = data["MenuName"] !== undefined ? data["MenuName"] : null;
            this.categoryId = data["CategoryId"] !== undefined ? data["CategoryId"] : null;
        }
    }

    static fromJS(data: any): MenuItems {
        return new MenuItems(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["SectionSeqId"] = this.sectionSeqId !== undefined ? this.sectionSeqId : null;
        data["SectionName"] = this.sectionName !== undefined ? this.sectionName : null;
        data["faIcon"] = this.faIcon !== undefined ? this.faIcon : null;
        data["MenuSeqId"] = this.menuSeqId !== undefined ? this.menuSeqId : null;
        data["Path"] = this.path !== undefined ? this.path : null;
        data["MenuName"] = this.menuName !== undefined ? this.menuName : null;
        data["CategoryId"] = this.categoryId !== undefined ? this.categoryId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new MenuItems(JSON.parse(json));
    }
}

export class GetApplicationCountResponse { 
    depositApplicationCount: number; 
    digitalWalletDepositApplicationCount: number; 
    withdrawApplicationCount: number; 
    giftPointApplicationCount: number; 
    manualAlipayApplicationCount: number; 
    cryptoCurrencyWithdrawApplicationCount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.depositApplicationCount = data["DepositApplicationCount"] !== undefined ? data["DepositApplicationCount"] : null;
            this.digitalWalletDepositApplicationCount = data["DigitalWalletDepositApplicationCount"] !== undefined ? data["DigitalWalletDepositApplicationCount"] : null;
            this.withdrawApplicationCount = data["WithdrawApplicationCount"] !== undefined ? data["WithdrawApplicationCount"] : null;
            this.giftPointApplicationCount = data["GiftPointApplicationCount"] !== undefined ? data["GiftPointApplicationCount"] : null;
            this.manualAlipayApplicationCount = data["ManualAlipayApplicationCount"] !== undefined ? data["ManualAlipayApplicationCount"] : null;
            this.cryptoCurrencyWithdrawApplicationCount = data["CryptoCurrencyWithdrawApplicationCount"] !== undefined ? data["CryptoCurrencyWithdrawApplicationCount"] : null;
        }
    }

    static fromJS(data: any): GetApplicationCountResponse {
        return new GetApplicationCountResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["DepositApplicationCount"] = this.depositApplicationCount !== undefined ? this.depositApplicationCount : null;
        data["DigitalWalletDepositApplicationCount"] = this.digitalWalletDepositApplicationCount !== undefined ? this.digitalWalletDepositApplicationCount : null;
        data["WithdrawApplicationCount"] = this.withdrawApplicationCount !== undefined ? this.withdrawApplicationCount : null;
        data["GiftPointApplicationCount"] = this.giftPointApplicationCount !== undefined ? this.giftPointApplicationCount : null;
        data["ManualAlipayApplicationCount"] = this.manualAlipayApplicationCount !== undefined ? this.manualAlipayApplicationCount : null;
        data["CryptoCurrencyWithdrawApplicationCount"] = this.cryptoCurrencyWithdrawApplicationCount !== undefined ? this.cryptoCurrencyWithdrawApplicationCount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetApplicationCountResponse(JSON.parse(json));
    }
}

export class LobbyBankResponse { 
    id: number; 
    bankId: number; 
    name: string; 
    isShowAtDeposit: boolean; 
    isShowAtWithdraw: boolean; 
    isPublish: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.bankId = data["BankId"] !== undefined ? data["BankId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.isShowAtDeposit = data["IsShowAtDeposit"] !== undefined ? data["IsShowAtDeposit"] : null;
            this.isShowAtWithdraw = data["IsShowAtWithdraw"] !== undefined ? data["IsShowAtWithdraw"] : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
        }
    }

    static fromJS(data: any): LobbyBankResponse {
        return new LobbyBankResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["BankId"] = this.bankId !== undefined ? this.bankId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["IsShowAtDeposit"] = this.isShowAtDeposit !== undefined ? this.isShowAtDeposit : null;
        data["IsShowAtWithdraw"] = this.isShowAtWithdraw !== undefined ? this.isShowAtWithdraw : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyBankResponse(JSON.parse(json));
    }
}

export class LobbyBankSetPublishRequest { 
    lobbyBankId: number; 
    isPublish: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyBankId = data["LobbyBankId"] !== undefined ? data["LobbyBankId"] : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
        }
    }

    static fromJS(data: any): LobbyBankSetPublishRequest {
        return new LobbyBankSetPublishRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyBankId"] = this.lobbyBankId !== undefined ? this.lobbyBankId : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyBankSetPublishRequest(JSON.parse(json));
    }
}

export class L_GetPreloadData_Request { 
    urlKey: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.urlKey = data["UrlKey"] !== undefined ? data["UrlKey"] : null;
        }
    }

    static fromJS(data: any): L_GetPreloadData_Request {
        return new L_GetPreloadData_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["UrlKey"] = this.urlKey !== undefined ? this.urlKey : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new L_GetPreloadData_Request(JSON.parse(json));
    }
}

export class LobbyPreloadResponse { 
    lobbyId: number; 
    tenantId: number; 
    urlKey: string; 
    apiDomain: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.tenantId = data["TenantId"] !== undefined ? data["TenantId"] : null;
            this.urlKey = data["UrlKey"] !== undefined ? data["UrlKey"] : null;
            this.apiDomain = data["ApiDomain"] !== undefined ? data["ApiDomain"] : null;
        }
    }

    static fromJS(data: any): LobbyPreloadResponse {
        return new LobbyPreloadResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["TenantId"] = this.tenantId !== undefined ? this.tenantId : null;
        data["UrlKey"] = this.urlKey !== undefined ? this.urlKey : null;
        data["ApiDomain"] = this.apiDomain !== undefined ? this.apiDomain : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPreloadResponse(JSON.parse(json));
    }
}

export class LobbyDepositMethodResponse { 
    id: number; 
    depositTypeId: number; 
    name: string; 
    depositTypeName: string; 
    lobbyDefinedName: string; 
    isPublished: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.depositTypeId = data["DepositTypeId"] !== undefined ? data["DepositTypeId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.depositTypeName = data["DepositTypeName"] !== undefined ? data["DepositTypeName"] : null;
            this.lobbyDefinedName = data["LobbyDefinedName"] !== undefined ? data["LobbyDefinedName"] : null;
            this.isPublished = data["IsPublished"] !== undefined ? data["IsPublished"] : null;
        }
    }

    static fromJS(data: any): LobbyDepositMethodResponse {
        return new LobbyDepositMethodResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["DepositTypeId"] = this.depositTypeId !== undefined ? this.depositTypeId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["DepositTypeName"] = this.depositTypeName !== undefined ? this.depositTypeName : null;
        data["LobbyDefinedName"] = this.lobbyDefinedName !== undefined ? this.lobbyDefinedName : null;
        data["IsPublished"] = this.isPublished !== undefined ? this.isPublished : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyDepositMethodResponse(JSON.parse(json));
    }
}

export class LobbyDepositMethodSetPublishRequest { 
    lobbyDepositMethodId: number; 
    isPublished: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyDepositMethodId = data["LobbyDepositMethodId"] !== undefined ? data["LobbyDepositMethodId"] : null;
            this.isPublished = data["IsPublished"] !== undefined ? data["IsPublished"] : null;
        }
    }

    static fromJS(data: any): LobbyDepositMethodSetPublishRequest {
        return new LobbyDepositMethodSetPublishRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyDepositMethodId"] = this.lobbyDepositMethodId !== undefined ? this.lobbyDepositMethodId : null;
        data["IsPublished"] = this.isPublished !== undefined ? this.isPublished : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyDepositMethodSetPublishRequest(JSON.parse(json));
    }
}

export class LobbyDepositMethodNameResponse { 
    depositMethodName: string; 
    translations: Trans[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.depositMethodName = data["DepositMethodName"] !== undefined ? data["DepositMethodName"] : null;
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(Trans.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyDepositMethodNameResponse {
        return new LobbyDepositMethodNameResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["DepositMethodName"] = this.depositMethodName !== undefined ? this.depositMethodName : null;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyDepositMethodNameResponse(JSON.parse(json));
    }
}

export class Trans { 
    id: number; 
    lobbyDefinedName: string; 
    languageId: number; 
    languageName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.lobbyDefinedName = data["LobbyDefinedName"] !== undefined ? data["LobbyDefinedName"] : null;
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.languageName = data["LanguageName"] !== undefined ? data["LanguageName"] : null;
        }
    }

    static fromJS(data: any): Trans {
        return new Trans(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["LobbyDefinedName"] = this.lobbyDefinedName !== undefined ? this.lobbyDefinedName : null;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["LanguageName"] = this.languageName !== undefined ? this.languageName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new Trans(JSON.parse(json));
    }
}

export class LobbyDepositMethodNameUpdateRequest { 
    id: number; 
    lobbyDefinedName: string; 
    languageId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.lobbyDefinedName = data["LobbyDefinedName"] !== undefined ? data["LobbyDefinedName"] : null;
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
        }
    }

    static fromJS(data: any): LobbyDepositMethodNameUpdateRequest {
        return new LobbyDepositMethodNameUpdateRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["LobbyDefinedName"] = this.lobbyDefinedName !== undefined ? this.lobbyDefinedName : null;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyDepositMethodNameUpdateRequest(JSON.parse(json));
    }
}

export class LPDAR_GetForIndex_Request { 
    lobbyId: LobbyId; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.language = data["language"] !== undefined ? data["language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
        }
    }

    static fromJS(data: any): LPDAR_GetForIndex_Request {
        return new LPDAR_GetForIndex_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPDAR_GetForIndex_Request(JSON.parse(json));
    }
}

export class LPDAR_GetForIndex_Response { 
    items: LPDAR_Item[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LPDAR_Item.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LPDAR_GetForIndex_Response {
        return new LPDAR_GetForIndex_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPDAR_GetForIndex_Response(JSON.parse(json));
    }
}

export class LPDAR_Item { 
    id: number; 
    playerName: string; 
    startDate: Date; 
    endDate: Date; 
    gameDevName: string; 
    gameType: string; 
    updateDate: Date; 
    updateBy: string; 
    canEdit: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
            this.gameType = data["GameType"] !== undefined ? data["GameType"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.canEdit = data["CanEdit"] !== undefined ? data["CanEdit"] : null;
        }
    }

    static fromJS(data: any): LPDAR_Item {
        return new LPDAR_Item(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        data["GameType"] = this.gameType !== undefined ? this.gameType : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["CanEdit"] = this.canEdit !== undefined ? this.canEdit : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPDAR_Item(JSON.parse(json));
    }
}

export class LPDAR_GetForAdd_Request { 
    language: LanguageCode;

    constructor(data?: any) {
        if (data !== undefined) {
            this.language = data["Language"] !== undefined ? data["Language"] : null;
        }
    }

    static fromJS(data: any): LPDAR_GetForAdd_Request {
        return new LPDAR_GetForAdd_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Language"] = this.language !== undefined ? this.language : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPDAR_GetForAdd_Request(JSON.parse(json));
    }
}

export class LPDAR_GetForAdd_Response { 
    gameDevOptions: CmsSelectionOption[]; 
    gameTypeOptions: CmsSelectionOption[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["GameDevOptions"] && data["GameDevOptions"].constructor === Array) {
                this.gameDevOptions = [];
                for (let item of data["GameDevOptions"])
                    this.gameDevOptions.push(CmsSelectionOption.fromJS(item));
            }
            if (data["GameTypeOptions"] && data["GameTypeOptions"].constructor === Array) {
                this.gameTypeOptions = [];
                for (let item of data["GameTypeOptions"])
                    this.gameTypeOptions.push(CmsSelectionOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LPDAR_GetForAdd_Response {
        return new LPDAR_GetForAdd_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.gameDevOptions && this.gameDevOptions.constructor === Array) {
            data["GameDevOptions"] = [];
            for (let item of this.gameDevOptions)
                data["GameDevOptions"].push(item.toJS());
        }
        if (this.gameTypeOptions && this.gameTypeOptions.constructor === Array) {
            data["GameTypeOptions"] = [];
            for (let item of this.gameTypeOptions)
                data["GameTypeOptions"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPDAR_GetForAdd_Response(JSON.parse(json));
    }
}

export class LPDAR_Add_Request { 
    lobbyId: LobbyId; 
    playerId: number; 
    startDate: Date; 
    endDate: Date; 
    subGameDevId: GameDevId; 
    gameTypeId: PlayerAmountRecordGameTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.subGameDevId = data["SubGameDevId"] !== undefined ? data["SubGameDevId"] : null;
            this.gameTypeId = data["GameTypeId"] !== undefined ? data["GameTypeId"] : null;
        }
    }

    static fromJS(data: any): LPDAR_Add_Request {
        return new LPDAR_Add_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["SubGameDevId"] = this.subGameDevId !== undefined ? this.subGameDevId : null;
        data["GameTypeId"] = this.gameTypeId !== undefined ? this.gameTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPDAR_Add_Request(JSON.parse(json));
    }
}

export enum PlayerAmountRecordGameTypeId {
    LIVE_GAME = 1, 
    EGAME = 2, 
    FISH_GAME = 3, 
    SPORTBOOK = 4, 
    LOTTERY = 5, 
    POKER_GAME = 6, 
}

export class LPDAR_GetForEdit_Request { 
    lobbyId: LobbyId; 
    language: LanguageCode; 
    lobbyPlayerDisableAutoRebateId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.lobbyPlayerDisableAutoRebateId = data["LobbyPlayerDisableAutoRebateId"] !== undefined ? data["LobbyPlayerDisableAutoRebateId"] : null;
        }
    }

    static fromJS(data: any): LPDAR_GetForEdit_Request {
        return new LPDAR_GetForEdit_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["LobbyPlayerDisableAutoRebateId"] = this.lobbyPlayerDisableAutoRebateId !== undefined ? this.lobbyPlayerDisableAutoRebateId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPDAR_GetForEdit_Request(JSON.parse(json));
    }
}

export class LPDAR_GetForEdit_Response { 
    itemDetail: LPDAR_GetForEdit_Detail;

    constructor(data?: any) {
        if (data !== undefined) {
            this.itemDetail = data["ItemDetail"] ? LPDAR_GetForEdit_Detail.fromJS(data["ItemDetail"]) : null;
        }
    }

    static fromJS(data: any): LPDAR_GetForEdit_Response {
        return new LPDAR_GetForEdit_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["ItemDetail"] = this.itemDetail ? this.itemDetail.toJS() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPDAR_GetForEdit_Response(JSON.parse(json));
    }
}

export class LPDAR_GetForEdit_Detail { 
    lobbyPlayerDisableAutoRebateId: number; 
    playerName: string; 
    startDate: Date; 
    endDate: Date; 
    gameDevName: string; 
    gameTypeName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPlayerDisableAutoRebateId = data["LobbyPlayerDisableAutoRebateId"] !== undefined ? data["LobbyPlayerDisableAutoRebateId"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
            this.gameTypeName = data["GameTypeName"] !== undefined ? data["GameTypeName"] : null;
        }
    }

    static fromJS(data: any): LPDAR_GetForEdit_Detail {
        return new LPDAR_GetForEdit_Detail(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPlayerDisableAutoRebateId"] = this.lobbyPlayerDisableAutoRebateId !== undefined ? this.lobbyPlayerDisableAutoRebateId : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        data["GameTypeName"] = this.gameTypeName !== undefined ? this.gameTypeName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPDAR_GetForEdit_Detail(JSON.parse(json));
    }
}

export class LPDAR_Edit_Request { 
    lobbyId: LobbyId; 
    lobbyPlayerDisableAutoRebateId: number; 
    endDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.lobbyPlayerDisableAutoRebateId = data["LobbyPlayerDisableAutoRebateId"] !== undefined ? data["LobbyPlayerDisableAutoRebateId"] : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
        }
    }

    static fromJS(data: any): LPDAR_Edit_Request {
        return new LPDAR_Edit_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["LobbyPlayerDisableAutoRebateId"] = this.lobbyPlayerDisableAutoRebateId !== undefined ? this.lobbyPlayerDisableAutoRebateId : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPDAR_Edit_Request(JSON.parse(json));
    }
}

export class StandardResponseOfIEnumerableOfLobbyReferenceGroupGetResponse { 
    isSuccess: boolean; 
    payload: LobbyReferenceGroupGetResponse[]; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            if (data["payload"] && data["payload"].constructor === Array) {
                this.payload = [];
                for (let item of data["payload"])
                    this.payload.push(LobbyReferenceGroupGetResponse.fromJS(item));
            }
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfIEnumerableOfLobbyReferenceGroupGetResponse {
        return new StandardResponseOfIEnumerableOfLobbyReferenceGroupGetResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.payload && this.payload.constructor === Array) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item.toJS());
        }
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfIEnumerableOfLobbyReferenceGroupGetResponse(JSON.parse(json));
    }
}

export class LobbyReferenceGroupGetResponse { 
    id: number; 
    name: string; 
    remark: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
        }
    }

    static fromJS(data: any): LobbyReferenceGroupGetResponse {
        return new LobbyReferenceGroupGetResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyReferenceGroupGetResponse(JSON.parse(json));
    }
}

export class StandardResponseOfIEnumerableOfLobbyReferenceGroupGetDetailsResponse { 
    isSuccess: boolean; 
    payload: LobbyReferenceGroupGetDetailsResponse[]; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            if (data["payload"] && data["payload"].constructor === Array) {
                this.payload = [];
                for (let item of data["payload"])
                    this.payload.push(LobbyReferenceGroupGetDetailsResponse.fromJS(item));
            }
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfIEnumerableOfLobbyReferenceGroupGetDetailsResponse {
        return new StandardResponseOfIEnumerableOfLobbyReferenceGroupGetDetailsResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.payload && this.payload.constructor === Array) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item.toJS());
        }
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfIEnumerableOfLobbyReferenceGroupGetDetailsResponse(JSON.parse(json));
    }
}

export class LobbyReferenceGroupGetDetailsResponse { 
    id: number; 
    lobbyId: number; 
    name: string; 
    remark: string; 
    createDate: Date; 
    createBy: string; 
    updateDate: Date; 
    updateBy: string; 
    playerCount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.createBy = data["CreateBy"] !== undefined ? data["CreateBy"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.playerCount = data["PlayerCount"] !== undefined ? data["PlayerCount"] : null;
        }
    }

    static fromJS(data: any): LobbyReferenceGroupGetDetailsResponse {
        return new LobbyReferenceGroupGetDetailsResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["CreateBy"] = this.createBy !== undefined ? this.createBy : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["PlayerCount"] = this.playerCount !== undefined ? this.playerCount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyReferenceGroupGetDetailsResponse(JSON.parse(json));
    }
}

export class StandardResponseOfLobbyReferenceGroupCreateResponse { 
    isSuccess: boolean; 
    payload: LobbyReferenceGroupCreateResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? LobbyReferenceGroupCreateResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfLobbyReferenceGroupCreateResponse {
        return new StandardResponseOfLobbyReferenceGroupCreateResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfLobbyReferenceGroupCreateResponse(JSON.parse(json));
    }
}

export class LobbyReferenceGroupCreateResponse { 
    failedUserNames: CreateMultiFailedItem[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["FailedUserNames"] && data["FailedUserNames"].constructor === Array) {
                this.failedUserNames = [];
                for (let item of data["FailedUserNames"])
                    this.failedUserNames.push(CreateMultiFailedItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyReferenceGroupCreateResponse {
        return new LobbyReferenceGroupCreateResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.failedUserNames && this.failedUserNames.constructor === Array) {
            data["FailedUserNames"] = [];
            for (let item of this.failedUserNames)
                data["FailedUserNames"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyReferenceGroupCreateResponse(JSON.parse(json));
    }
}

export class CreateMultiFailedItem { 
    userName: string; 
    reason: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
            this.reason = data["Reason"] !== undefined ? data["Reason"] : null;
        }
    }

    static fromJS(data: any): CreateMultiFailedItem {
        return new CreateMultiFailedItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        data["Reason"] = this.reason !== undefined ? this.reason : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CreateMultiFailedItem(JSON.parse(json));
    }
}

export class StandardResponseOfLobbyReferenceGroupUpdateResponse { 
    isSuccess: boolean; 
    payload: LobbyReferenceGroupUpdateResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? LobbyReferenceGroupUpdateResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfLobbyReferenceGroupUpdateResponse {
        return new StandardResponseOfLobbyReferenceGroupUpdateResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfLobbyReferenceGroupUpdateResponse(JSON.parse(json));
    }
}

export class LobbyReferenceGroupUpdateResponse { 
    failedUserNames: CreateMultiFailedItem[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["FailedUserNames"] && data["FailedUserNames"].constructor === Array) {
                this.failedUserNames = [];
                for (let item of data["FailedUserNames"])
                    this.failedUserNames.push(CreateMultiFailedItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyReferenceGroupUpdateResponse {
        return new LobbyReferenceGroupUpdateResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.failedUserNames && this.failedUserNames.constructor === Array) {
            data["FailedUserNames"] = [];
            for (let item of this.failedUserNames)
                data["FailedUserNames"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyReferenceGroupUpdateResponse(JSON.parse(json));
    }
}

export class StandardResponseOfGetAllLuckyDrawGroupResponse { 
    isSuccess: boolean; 
    payload: GetAllLuckyDrawGroupResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? GetAllLuckyDrawGroupResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfGetAllLuckyDrawGroupResponse {
        return new StandardResponseOfGetAllLuckyDrawGroupResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfGetAllLuckyDrawGroupResponse(JSON.parse(json));
    }
}

export class GetAllLuckyDrawGroupResponse { 
    rewardGroupList: RewardGroup[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["rewardGroupList"] && data["rewardGroupList"].constructor === Array) {
                this.rewardGroupList = [];
                for (let item of data["rewardGroupList"])
                    this.rewardGroupList.push(RewardGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAllLuckyDrawGroupResponse {
        return new GetAllLuckyDrawGroupResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.rewardGroupList && this.rewardGroupList.constructor === Array) {
            data["rewardGroupList"] = [];
            for (let item of this.rewardGroupList)
                data["rewardGroupList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetAllLuckyDrawGroupResponse(JSON.parse(json));
    }
}

export class RewardGroup { 
    id: number; 
    name: string; 
    createDate: Date; 
    createBy: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.createBy = data["CreateBy"] !== undefined ? data["CreateBy"] : null;
        }
    }

    static fromJS(data: any): RewardGroup {
        return new RewardGroup(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["CreateBy"] = this.createBy !== undefined ? this.createBy : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new RewardGroup(JSON.parse(json));
    }
}

export class GetLuckyDrawGroupRequest { 
    id: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["id"] !== undefined ? data["id"] : null;
        }
    }

    static fromJS(data: any): GetLuckyDrawGroupRequest {
        return new GetLuckyDrawGroupRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["id"] = this.id !== undefined ? this.id : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetLuckyDrawGroupRequest(JSON.parse(json));
    }
}

export class StandardResponseOfGetLuckyDrawGroupResponse { 
    isSuccess: boolean; 
    payload: GetLuckyDrawGroupResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? GetLuckyDrawGroupResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfGetLuckyDrawGroupResponse {
        return new StandardResponseOfGetLuckyDrawGroupResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfGetLuckyDrawGroupResponse(JSON.parse(json));
    }
}

export class GetLuckyDrawGroupResponse { 
    rewardGroupId: number; 
    rewardGroupName: string; 
    rewardList: Reward[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.rewardGroupId = data["rewardGroupId"] !== undefined ? data["rewardGroupId"] : null;
            this.rewardGroupName = data["rewardGroupName"] !== undefined ? data["rewardGroupName"] : null;
            if (data["rewardList"] && data["rewardList"].constructor === Array) {
                this.rewardList = [];
                for (let item of data["rewardList"])
                    this.rewardList.push(Reward.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLuckyDrawGroupResponse {
        return new GetLuckyDrawGroupResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["rewardGroupId"] = this.rewardGroupId !== undefined ? this.rewardGroupId : null;
        data["rewardGroupName"] = this.rewardGroupName !== undefined ? this.rewardGroupName : null;
        if (this.rewardList && this.rewardList.constructor === Array) {
            data["rewardList"] = [];
            for (let item of this.rewardList)
                data["rewardList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetLuckyDrawGroupResponse(JSON.parse(json));
    }
}

export class Reward { 
    name: string; 
    description: string; 
    seq: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.description = data["description"] !== undefined ? data["description"] : null;
            this.seq = data["seq"] !== undefined ? data["seq"] : null;
        }
    }

    static fromJS(data: any): Reward {
        return new Reward(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["name"] = this.name !== undefined ? this.name : null;
        data["description"] = this.description !== undefined ? this.description : null;
        data["seq"] = this.seq !== undefined ? this.seq : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new Reward(JSON.parse(json));
    }
}

export class UpdateLuckyDrawRecordRequest { 
    luckyDrawRecordId: number; 
    name: string; 
    remark: string; 
    rewardGroupId: number; 
    isDistributed: boolean; 
    password: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.luckyDrawRecordId = data["luckyDrawRecordId"] !== undefined ? data["luckyDrawRecordId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.remark = data["remark"] !== undefined ? data["remark"] : null;
            this.rewardGroupId = data["rewardGroupId"] !== undefined ? data["rewardGroupId"] : null;
            this.isDistributed = data["isDistributed"] !== undefined ? data["isDistributed"] : null;
            this.password = data["password"] !== undefined ? data["password"] : null;
        }
    }

    static fromJS(data: any): UpdateLuckyDrawRecordRequest {
        return new UpdateLuckyDrawRecordRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["luckyDrawRecordId"] = this.luckyDrawRecordId !== undefined ? this.luckyDrawRecordId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["remark"] = this.remark !== undefined ? this.remark : null;
        data["rewardGroupId"] = this.rewardGroupId !== undefined ? this.rewardGroupId : null;
        data["isDistributed"] = this.isDistributed !== undefined ? this.isDistributed : null;
        data["password"] = this.password !== undefined ? this.password : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new UpdateLuckyDrawRecordRequest(JSON.parse(json));
    }
}

export class LuckyDrawRecordDistributeRequest { 
    luckyDrawRecordId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.luckyDrawRecordId = data["luckyDrawRecordId"] !== undefined ? data["luckyDrawRecordId"] : null;
        }
    }

    static fromJS(data: any): LuckyDrawRecordDistributeRequest {
        return new LuckyDrawRecordDistributeRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["luckyDrawRecordId"] = this.luckyDrawRecordId !== undefined ? this.luckyDrawRecordId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LuckyDrawRecordDistributeRequest(JSON.parse(json));
    }
}

export class GetLuckyDrawRecordRequest { 
    startTime: Date; 
    endTime: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.startTime = data["startTime"] ? new Date(data["startTime"].toString()) : null;
            this.endTime = data["endTime"] ? new Date(data["endTime"].toString()) : null;
        }
    }

    static fromJS(data: any): GetLuckyDrawRecordRequest {
        return new GetLuckyDrawRecordRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetLuckyDrawRecordRequest(JSON.parse(json));
    }
}

export class StandardResponseOfGetLuckyDrawRecordResponse { 
    isSuccess: boolean; 
    payload: GetLuckyDrawRecordResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? GetLuckyDrawRecordResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfGetLuckyDrawRecordResponse {
        return new StandardResponseOfGetLuckyDrawRecordResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfGetLuckyDrawRecordResponse(JSON.parse(json));
    }
}

export class GetLuckyDrawRecordResponse { 
    itemList: LuckyDrawRecordItem[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["itemList"] && data["itemList"].constructor === Array) {
                this.itemList = [];
                for (let item of data["itemList"])
                    this.itemList.push(LuckyDrawRecordItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLuckyDrawRecordResponse {
        return new GetLuckyDrawRecordResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.itemList && this.itemList.constructor === Array) {
            data["itemList"] = [];
            for (let item of this.itemList)
                data["itemList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetLuckyDrawRecordResponse(JSON.parse(json));
    }
}

export class LuckyDrawRecordItem { 
    id: number; 
    name: string; 
    remark: string; 
    isDistributed: boolean; 
    createDate: Date; 
    createBy: string; 
    updateDate: Date; 
    updateBy: string; 
    distributedDate: Date; 
    distributedBy: string; 
    rewardGroupId: number; 
    rewardGroupName: string; 
    code: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.isDistributed = data["IsDistributed"] !== undefined ? data["IsDistributed"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.createBy = data["CreateBy"] !== undefined ? data["CreateBy"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.distributedDate = data["DistributedDate"] ? new Date(data["DistributedDate"].toString()) : null;
            this.distributedBy = data["DistributedBy"] !== undefined ? data["DistributedBy"] : null;
            this.rewardGroupId = data["RewardGroupId"] !== undefined ? data["RewardGroupId"] : null;
            this.rewardGroupName = data["RewardGroupName"] !== undefined ? data["RewardGroupName"] : null;
            this.code = data["Code"] !== undefined ? data["Code"] : null;
        }
    }

    static fromJS(data: any): LuckyDrawRecordItem {
        return new LuckyDrawRecordItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["IsDistributed"] = this.isDistributed !== undefined ? this.isDistributed : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["CreateBy"] = this.createBy !== undefined ? this.createBy : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["DistributedDate"] = this.distributedDate ? this.distributedDate.toISOString() : null;
        data["DistributedBy"] = this.distributedBy !== undefined ? this.distributedBy : null;
        data["RewardGroupId"] = this.rewardGroupId !== undefined ? this.rewardGroupId : null;
        data["RewardGroupName"] = this.rewardGroupName !== undefined ? this.rewardGroupName : null;
        data["Code"] = this.code !== undefined ? this.code : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LuckyDrawRecordItem(JSON.parse(json));
    }
}

export class GetLuckyDrawRecordDetailRequest { 
    id: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["id"] !== undefined ? data["id"] : null;
        }
    }

    static fromJS(data: any): GetLuckyDrawRecordDetailRequest {
        return new GetLuckyDrawRecordDetailRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["id"] = this.id !== undefined ? this.id : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetLuckyDrawRecordDetailRequest(JSON.parse(json));
    }
}

export class StandardResponseOfGetLuckyDrawRecordDetailResponse { 
    isSuccess: boolean; 
    payload: GetLuckyDrawRecordDetailResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? GetLuckyDrawRecordDetailResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfGetLuckyDrawRecordDetailResponse {
        return new StandardResponseOfGetLuckyDrawRecordDetailResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfGetLuckyDrawRecordDetailResponse(JSON.parse(json));
    }
}

export class GetLuckyDrawRecordDetailResponse { 
    id: number; 
    name: string; 
    remark: string; 
    isDistributed: boolean; 
    rewardGroupId: number; 
    code: string; 
    password: string; 
    playerRewardList: PlayerReward[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.isDistributed = data["IsDistributed"] !== undefined ? data["IsDistributed"] : null;
            this.rewardGroupId = data["RewardGroupId"] !== undefined ? data["RewardGroupId"] : null;
            this.code = data["Code"] !== undefined ? data["Code"] : null;
            this.password = data["Password"] !== undefined ? data["Password"] : null;
            if (data["playerRewardList"] && data["playerRewardList"].constructor === Array) {
                this.playerRewardList = [];
                for (let item of data["playerRewardList"])
                    this.playerRewardList.push(PlayerReward.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLuckyDrawRecordDetailResponse {
        return new GetLuckyDrawRecordDetailResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["IsDistributed"] = this.isDistributed !== undefined ? this.isDistributed : null;
        data["RewardGroupId"] = this.rewardGroupId !== undefined ? this.rewardGroupId : null;
        data["Code"] = this.code !== undefined ? this.code : null;
        data["Password"] = this.password !== undefined ? this.password : null;
        if (this.playerRewardList && this.playerRewardList.constructor === Array) {
            data["playerRewardList"] = [];
            for (let item of this.playerRewardList)
                data["playerRewardList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetLuckyDrawRecordDetailResponse(JSON.parse(json));
    }
}

export class PlayerReward { 
    userName: string; 
    rewardName: string; 
    seq: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
            this.rewardName = data["RewardName"] !== undefined ? data["RewardName"] : null;
            this.seq = data["Seq"] !== undefined ? data["Seq"] : null;
        }
    }

    static fromJS(data: any): PlayerReward {
        return new PlayerReward(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        data["RewardName"] = this.rewardName !== undefined ? this.rewardName : null;
        data["Seq"] = this.seq !== undefined ? this.seq : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerReward(JSON.parse(json));
    }
}

export class PaymentCryptoFundOutGetForIndexRequest { 
    transactionNo: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
        }
    }

    static fromJS(data: any): PaymentCryptoFundOutGetForIndexRequest {
        return new PaymentCryptoFundOutGetForIndexRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PaymentCryptoFundOutGetForIndexRequest(JSON.parse(json));
    }
}

export class PaymentCryptoFundOutGetForIndexResponse { 
    transactionNo: string; 
    transactionStatusId: NewTransactionStatusId; 
    transactionStatus: string; 
    amount: number; 
    cryptoAddress: string; 
    paymentPlatformId: number; 
    playerAmountRecordId: number; 
    fundoutStatusSetting: FundOutStatusId; 
    updateBy: string; 
    createDate: Date; 
    billedCurrencyId: CurrencyId; 
    billAmount: number; 
    billedCurrencyName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
            this.transactionStatusId = data["TransactionStatusId"] !== undefined ? data["TransactionStatusId"] : null;
            this.transactionStatus = data["TransactionStatus"] !== undefined ? data["TransactionStatus"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.cryptoAddress = data["CryptoAddress"] !== undefined ? data["CryptoAddress"] : null;
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.playerAmountRecordId = data["PlayerAmountRecordId"] !== undefined ? data["PlayerAmountRecordId"] : null;
            this.fundoutStatusSetting = data["FundoutStatusSetting"] !== undefined ? data["FundoutStatusSetting"] : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.billedCurrencyId = data["BilledCurrencyId"] !== undefined ? data["BilledCurrencyId"] : null;
            this.billAmount = data["BillAmount"] !== undefined ? data["BillAmount"] : null;
            this.billedCurrencyName = data["BilledCurrencyName"] !== undefined ? data["BilledCurrencyName"] : null;
        }
    }

    static fromJS(data: any): PaymentCryptoFundOutGetForIndexResponse {
        return new PaymentCryptoFundOutGetForIndexResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        data["TransactionStatusId"] = this.transactionStatusId !== undefined ? this.transactionStatusId : null;
        data["TransactionStatus"] = this.transactionStatus !== undefined ? this.transactionStatus : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["CryptoAddress"] = this.cryptoAddress !== undefined ? this.cryptoAddress : null;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["PlayerAmountRecordId"] = this.playerAmountRecordId !== undefined ? this.playerAmountRecordId : null;
        data["FundoutStatusSetting"] = this.fundoutStatusSetting !== undefined ? this.fundoutStatusSetting : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["BilledCurrencyId"] = this.billedCurrencyId !== undefined ? this.billedCurrencyId : null;
        data["BillAmount"] = this.billAmount !== undefined ? this.billAmount : null;
        data["BilledCurrencyName"] = this.billedCurrencyName !== undefined ? this.billedCurrencyName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PaymentCryptoFundOutGetForIndexResponse(JSON.parse(json));
    }
}

export enum FundOutStatusId {
    CanRedoWhenFundOutFail = 0, 
    CompleteWhenFundOutFail = 1, 
}

export class PaymentCryptoFundOutPaymentItem { 
    paymentPlatformId: PaymentGatewayPlatformId; 
    paymentPlatformName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.paymentPlatformName = data["PaymentPlatformName"] !== undefined ? data["PaymentPlatformName"] : null;
        }
    }

    static fromJS(data: any): PaymentCryptoFundOutPaymentItem {
        return new PaymentCryptoFundOutPaymentItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["PaymentPlatformName"] = this.paymentPlatformName !== undefined ? this.paymentPlatformName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PaymentCryptoFundOutPaymentItem(JSON.parse(json));
    }
}

export class PlatformCryptoFundOutAccounts { 
    paymentPlatformId: PaymentGatewayPlatformId; 
    platformCryptoFundOutAccountList: PlatformCryptoFundOutAccount[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            if (data["PlatformCryptoFundOutAccountList"] && data["PlatformCryptoFundOutAccountList"].constructor === Array) {
                this.platformCryptoFundOutAccountList = [];
                for (let item of data["PlatformCryptoFundOutAccountList"])
                    this.platformCryptoFundOutAccountList.push(PlatformCryptoFundOutAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlatformCryptoFundOutAccounts {
        return new PlatformCryptoFundOutAccounts(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        if (this.platformCryptoFundOutAccountList && this.platformCryptoFundOutAccountList.constructor === Array) {
            data["PlatformCryptoFundOutAccountList"] = [];
            for (let item of this.platformCryptoFundOutAccountList)
                data["PlatformCryptoFundOutAccountList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlatformCryptoFundOutAccounts(JSON.parse(json));
    }
}

export class PlatformCryptoFundOutAccount { 
    displayName: string; 
    reference1: string; 
    balance: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.displayName = data["DisplayName"] !== undefined ? data["DisplayName"] : null;
            this.reference1 = data["Reference1"] !== undefined ? data["Reference1"] : null;
            this.balance = data["Balance"] !== undefined ? data["Balance"] : null;
        }
    }

    static fromJS(data: any): PlatformCryptoFundOutAccount {
        return new PlatformCryptoFundOutAccount(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["DisplayName"] = this.displayName !== undefined ? this.displayName : null;
        data["Reference1"] = this.reference1 !== undefined ? this.reference1 : null;
        data["Balance"] = this.balance !== undefined ? this.balance : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlatformCryptoFundOutAccount(JSON.parse(json));
    }
}

export class PaymentCryptoFundOutApplyRequest { 
    paymentPlatformId: PaymentGatewayPlatformId; 
    currencyId: CurrencyId; 
    transactionNo: string; 
    reference1: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.currencyId = data["CurrencyId"] !== undefined ? data["CurrencyId"] : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
            this.reference1 = data["Reference1"] !== undefined ? data["Reference1"] : null;
        }
    }

    static fromJS(data: any): PaymentCryptoFundOutApplyRequest {
        return new PaymentCryptoFundOutApplyRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["CurrencyId"] = this.currencyId !== undefined ? this.currencyId : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        data["Reference1"] = this.reference1 !== undefined ? this.reference1 : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PaymentCryptoFundOutApplyRequest(JSON.parse(json));
    }
}

export class PaymentCryptoFundOutInquiryRequest { 
    paymentPlatformId: PaymentGatewayPlatformId; 
    transactionNo: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
        }
    }

    static fromJS(data: any): PaymentCryptoFundOutInquiryRequest {
        return new PaymentCryptoFundOutInquiryRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PaymentCryptoFundOutInquiryRequest(JSON.parse(json));
    }
}

export class PaymentCryptoFundOutCancelRequest { 
    paymentPlatformId: PaymentGatewayPlatformId; 
    transactionNo: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
        }
    }

    static fromJS(data: any): PaymentCryptoFundOutCancelRequest {
        return new PaymentCryptoFundOutCancelRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PaymentCryptoFundOutCancelRequest(JSON.parse(json));
    }
}

export class StandardResponseOfLobbyTransferRateGetAllResponse { 
    isSuccess: boolean; 
    payload: LobbyTransferRateGetAllResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? LobbyTransferRateGetAllResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfLobbyTransferRateGetAllResponse {
        return new StandardResponseOfLobbyTransferRateGetAllResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfLobbyTransferRateGetAllResponse(JSON.parse(json));
    }
}

export class LobbyTransferRateGetAllResponse { 
    transferRates: TransferRate[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["TransferRates"] && data["TransferRates"].constructor === Array) {
                this.transferRates = [];
                for (let item of data["TransferRates"])
                    this.transferRates.push(TransferRate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyTransferRateGetAllResponse {
        return new LobbyTransferRateGetAllResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.transferRates && this.transferRates.constructor === Array) {
            data["TransferRates"] = [];
            for (let item of this.transferRates)
                data["TransferRates"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyTransferRateGetAllResponse(JSON.parse(json));
    }
}

export class TransferRate { 
    currencyId: CurrencyId; 
    currencyName: string; 
    depositRate: number; 
    withdrawRate: number; 
    updateDate: Date; 
    updateBy: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.currencyId = data["CurrencyId"] !== undefined ? data["CurrencyId"] : null;
            this.currencyName = data["CurrencyName"] !== undefined ? data["CurrencyName"] : null;
            this.depositRate = data["DepositRate"] !== undefined ? data["DepositRate"] : null;
            this.withdrawRate = data["WithdrawRate"] !== undefined ? data["WithdrawRate"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
        }
    }

    static fromJS(data: any): TransferRate {
        return new TransferRate(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["CurrencyId"] = this.currencyId !== undefined ? this.currencyId : null;
        data["CurrencyName"] = this.currencyName !== undefined ? this.currencyName : null;
        data["DepositRate"] = this.depositRate !== undefined ? this.depositRate : null;
        data["WithdrawRate"] = this.withdrawRate !== undefined ? this.withdrawRate : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new TransferRate(JSON.parse(json));
    }
}

export class LobbyTransferRateGetRequest { 
    currencyId: CurrencyId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.currencyId = data["CurrencyId"] !== undefined ? data["CurrencyId"] : null;
        }
    }

    static fromJS(data: any): LobbyTransferRateGetRequest {
        return new LobbyTransferRateGetRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["CurrencyId"] = this.currencyId !== undefined ? this.currencyId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyTransferRateGetRequest(JSON.parse(json));
    }
}

export class StandardResponseOfLobbyTransferRateGetResponse { 
    isSuccess: boolean; 
    payload: LobbyTransferRateGetResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? LobbyTransferRateGetResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfLobbyTransferRateGetResponse {
        return new StandardResponseOfLobbyTransferRateGetResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfLobbyTransferRateGetResponse(JSON.parse(json));
    }
}

export class LobbyTransferRateGetResponse { 
    currencyId: number; 
    currencyName: string; 
    depositRate: number; 
    withdrawRate: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.currencyId = data["CurrencyId"] !== undefined ? data["CurrencyId"] : null;
            this.currencyName = data["CurrencyName"] !== undefined ? data["CurrencyName"] : null;
            this.depositRate = data["DepositRate"] !== undefined ? data["DepositRate"] : null;
            this.withdrawRate = data["WithdrawRate"] !== undefined ? data["WithdrawRate"] : null;
        }
    }

    static fromJS(data: any): LobbyTransferRateGetResponse {
        return new LobbyTransferRateGetResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["CurrencyId"] = this.currencyId !== undefined ? this.currencyId : null;
        data["CurrencyName"] = this.currencyName !== undefined ? this.currencyName : null;
        data["DepositRate"] = this.depositRate !== undefined ? this.depositRate : null;
        data["WithdrawRate"] = this.withdrawRate !== undefined ? this.withdrawRate : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyTransferRateGetResponse(JSON.parse(json));
    }
}

export class LobbyTransferRateEditRequest { 
    currencyId: CurrencyId; 
    depositRate: number; 
    withdrawRate: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.currencyId = data["CurrencyId"] !== undefined ? data["CurrencyId"] : null;
            this.depositRate = data["DepositRate"] !== undefined ? data["DepositRate"] : null;
            this.withdrawRate = data["WithdrawRate"] !== undefined ? data["WithdrawRate"] : null;
        }
    }

    static fromJS(data: any): LobbyTransferRateEditRequest {
        return new LobbyTransferRateEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["CurrencyId"] = this.currencyId !== undefined ? this.currencyId : null;
        data["DepositRate"] = this.depositRate !== undefined ? this.depositRate : null;
        data["WithdrawRate"] = this.withdrawRate !== undefined ? this.withdrawRate : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyTransferRateEditRequest(JSON.parse(json));
    }
}

export class StandardResponseOfListOfPlaformLogGetAlertResponse { 
    isSuccess: boolean; 
    payload: PlaformLogGetAlertResponse[]; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            if (data["payload"] && data["payload"].constructor === Array) {
                this.payload = [];
                for (let item of data["payload"])
                    this.payload.push(PlaformLogGetAlertResponse.fromJS(item));
            }
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfListOfPlaformLogGetAlertResponse {
        return new StandardResponseOfListOfPlaformLogGetAlertResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.payload && this.payload.constructor === Array) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item.toJS());
        }
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfListOfPlaformLogGetAlertResponse(JSON.parse(json));
    }
}

export class PlaformLogGetAlertResponse { 
    platformType: number; 
    paymentType: number; 
    platformName: string; 
    description: string; 
    totalLogs: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.platformType = data["PlatformType"] !== undefined ? data["PlatformType"] : null;
            this.paymentType = data["PaymentType"] !== undefined ? data["PaymentType"] : null;
            this.platformName = data["PlatformName"] !== undefined ? data["PlatformName"] : null;
            this.description = data["Description"] !== undefined ? data["Description"] : null;
            this.totalLogs = data["TotalLogs"] !== undefined ? data["TotalLogs"] : null;
        }
    }

    static fromJS(data: any): PlaformLogGetAlertResponse {
        return new PlaformLogGetAlertResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlatformType"] = this.platformType !== undefined ? this.platformType : null;
        data["PaymentType"] = this.paymentType !== undefined ? this.paymentType : null;
        data["PlatformName"] = this.platformName !== undefined ? this.platformName : null;
        data["Description"] = this.description !== undefined ? this.description : null;
        data["TotalLogs"] = this.totalLogs !== undefined ? this.totalLogs : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlaformLogGetAlertResponse(JSON.parse(json));
    }
}

export class PlaformLogGetRequest { 
    startTime: Date; 
    endTime: Date; 
    isException: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.startTime = data["StartTime"] ? new Date(data["StartTime"].toString()) : null;
            this.endTime = data["EndTime"] ? new Date(data["EndTime"].toString()) : null;
            this.isException = data["IsException"] !== undefined ? data["IsException"] : null;
        }
    }

    static fromJS(data: any): PlaformLogGetRequest {
        return new PlaformLogGetRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["StartTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["EndTime"] = this.endTime ? this.endTime.toISOString() : null;
        data["IsException"] = this.isException !== undefined ? this.isException : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlaformLogGetRequest(JSON.parse(json));
    }
}

export class StandardResponseOfPlaformLogGetResponse { 
    isSuccess: boolean; 
    payload: PlaformLogGetResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? PlaformLogGetResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfPlaformLogGetResponse {
        return new StandardResponseOfPlaformLogGetResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfPlaformLogGetResponse(JSON.parse(json));
    }
}

export class PlaformLogGetResponse { 
    isSuperUser: boolean; 
    plaformLogs: PlaformLog[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuperUser = data["IsSuperUser"] !== undefined ? data["IsSuperUser"] : null;
            if (data["PlaformLogs"] && data["PlaformLogs"].constructor === Array) {
                this.plaformLogs = [];
                for (let item of data["PlaformLogs"])
                    this.plaformLogs.push(PlaformLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlaformLogGetResponse {
        return new PlaformLogGetResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuperUser"] = this.isSuperUser !== undefined ? this.isSuperUser : null;
        if (this.plaformLogs && this.plaformLogs.constructor === Array) {
            data["PlaformLogs"] = [];
            for (let item of this.plaformLogs)
                data["PlaformLogs"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlaformLogGetResponse(JSON.parse(json));
    }
}

export class PlaformLog { 
    id: number; 
    lobbyId: number; 
    platformName: string; 
    logTypeId: number; 
    paymentTypeId: number; 
    userName: string; 
    createDate: Date; 
    isException: boolean; 
    apiCallInfo: string; 
    detailMessage: string; 
    iP: string; 
    absoluteUrl: string; 
    httpReferer: string; 
    headers: string; 
    requestBody: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.platformName = data["PlatformName"] !== undefined ? data["PlatformName"] : null;
            this.logTypeId = data["LogTypeId"] !== undefined ? data["LogTypeId"] : null;
            this.paymentTypeId = data["PaymentTypeId"] !== undefined ? data["PaymentTypeId"] : null;
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.isException = data["IsException"] !== undefined ? data["IsException"] : null;
            this.apiCallInfo = data["ApiCallInfo"] !== undefined ? data["ApiCallInfo"] : null;
            this.detailMessage = data["DetailMessage"] !== undefined ? data["DetailMessage"] : null;
            this.iP = data["IP"] !== undefined ? data["IP"] : null;
            this.absoluteUrl = data["AbsoluteUrl"] !== undefined ? data["AbsoluteUrl"] : null;
            this.httpReferer = data["HttpReferer"] !== undefined ? data["HttpReferer"] : null;
            this.headers = data["Headers"] !== undefined ? data["Headers"] : null;
            this.requestBody = data["RequestBody"] !== undefined ? data["RequestBody"] : null;
        }
    }

    static fromJS(data: any): PlaformLog {
        return new PlaformLog(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["PlatformName"] = this.platformName !== undefined ? this.platformName : null;
        data["LogTypeId"] = this.logTypeId !== undefined ? this.logTypeId : null;
        data["PaymentTypeId"] = this.paymentTypeId !== undefined ? this.paymentTypeId : null;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["IsException"] = this.isException !== undefined ? this.isException : null;
        data["ApiCallInfo"] = this.apiCallInfo !== undefined ? this.apiCallInfo : null;
        data["DetailMessage"] = this.detailMessage !== undefined ? this.detailMessage : null;
        data["IP"] = this.iP !== undefined ? this.iP : null;
        data["AbsoluteUrl"] = this.absoluteUrl !== undefined ? this.absoluteUrl : null;
        data["HttpReferer"] = this.httpReferer !== undefined ? this.httpReferer : null;
        data["Headers"] = this.headers !== undefined ? this.headers : null;
        data["RequestBody"] = this.requestBody !== undefined ? this.requestBody : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlaformLog(JSON.parse(json));
    }
}

export class StandardResponseOfLGPS_GetAll_Response { 
    isSuccess: boolean; 
    payload: LGPS_GetAll_Response; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? LGPS_GetAll_Response.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfLGPS_GetAll_Response {
        return new StandardResponseOfLGPS_GetAll_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfLGPS_GetAll_Response(JSON.parse(json));
    }
}

export class LGPS_GetAll_Response { 
    items: LobbyGiftPointSettingDataModel[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LobbyGiftPointSettingDataModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LGPS_GetAll_Response {
        return new LGPS_GetAll_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LGPS_GetAll_Response(JSON.parse(json));
    }
}

export class LobbyGiftPointSettingDataModel { 
    id: number; 
    lobbyId: number; 
    types: string; 
    typeId: string; 
    ratio: number; 
    updatedBy: string; 
    updatedDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["id"] !== undefined ? data["id"] : null;
            this.lobbyId = data["lobbyId"] !== undefined ? data["lobbyId"] : null;
            this.types = data["types"] !== undefined ? data["types"] : null;
            this.typeId = data["typeId"] !== undefined ? data["typeId"] : null;
            this.ratio = data["ratio"] !== undefined ? data["ratio"] : null;
            this.updatedBy = data["updatedBy"] !== undefined ? data["updatedBy"] : null;
            this.updatedDate = data["updatedDate"] ? new Date(data["updatedDate"].toString()) : null;
        }
    }

    static fromJS(data: any): LobbyGiftPointSettingDataModel {
        return new LobbyGiftPointSettingDataModel(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["id"] = this.id !== undefined ? this.id : null;
        data["lobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["types"] = this.types !== undefined ? this.types : null;
        data["typeId"] = this.typeId !== undefined ? this.typeId : null;
        data["ratio"] = this.ratio !== undefined ? this.ratio : null;
        data["updatedBy"] = this.updatedBy !== undefined ? this.updatedBy : null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyGiftPointSettingDataModel(JSON.parse(json));
    }
}

export class LGPS_GetForAdd_Request {

    constructor(data?: any) {
        if (data !== undefined) {
        }
    }

    static fromJS(data: any): LGPS_GetForAdd_Request {
        return new LGPS_GetForAdd_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LGPS_GetForAdd_Request(JSON.parse(json));
    }
}

export class StandardResponseOfLGPS_GetForAdd_Response { 
    isSuccess: boolean; 
    payload: LGPS_GetForAdd_Response; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? LGPS_GetForAdd_Response.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfLGPS_GetForAdd_Response {
        return new StandardResponseOfLGPS_GetForAdd_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfLGPS_GetForAdd_Response(JSON.parse(json));
    }
}

export class LGPS_GetForAdd_Response { 
    types: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["types"] && data["types"].constructor === Array) {
                this.types = [];
                for (let item of data["types"])
                    this.types.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LGPS_GetForAdd_Response {
        return new LGPS_GetForAdd_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.types && this.types.constructor === Array) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LGPS_GetForAdd_Response(JSON.parse(json));
    }
}

export class LGPS_GetForEdit_Request { 
    id: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["id"] !== undefined ? data["id"] : null;
        }
    }

    static fromJS(data: any): LGPS_GetForEdit_Request {
        return new LGPS_GetForEdit_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["id"] = this.id !== undefined ? this.id : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LGPS_GetForEdit_Request(JSON.parse(json));
    }
}

export class StandardResponseOfLGPS_GetForEdit_Response { 
    isSuccess: boolean; 
    payload: LGPS_GetForEdit_Response; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? LGPS_GetForEdit_Response.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfLGPS_GetForEdit_Response {
        return new StandardResponseOfLGPS_GetForEdit_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfLGPS_GetForEdit_Response(JSON.parse(json));
    }
}

export class LGPS_GetForEdit_Response extends LGPS_GetForAdd_Response { 
    item: LobbyGiftPointSettingDataModel;

    constructor(data?: any) {
        super(data);
        if (data !== undefined) {
            this.item = data["item"] ? LobbyGiftPointSettingDataModel.fromJS(data["item"]) : null;
        }
    }

    static fromJS(data: any): LGPS_GetForEdit_Response {
        return new LGPS_GetForEdit_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["item"] = this.item ? this.item.toJS() : null;
        super.toJS(data);
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LGPS_GetForEdit_Response(JSON.parse(json));
    }
}

export class LGPS_Create_Request { 
    typeId: NewTransactionMasterTypeId; 
    ratio: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.typeId = data["TypeId"] !== undefined ? data["TypeId"] : null;
            this.ratio = data["Ratio"] !== undefined ? data["Ratio"] : null;
        }
    }

    static fromJS(data: any): LGPS_Create_Request {
        return new LGPS_Create_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["TypeId"] = this.typeId !== undefined ? this.typeId : null;
        data["Ratio"] = this.ratio !== undefined ? this.ratio : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LGPS_Create_Request(JSON.parse(json));
    }
}

export enum NewTransactionMasterTypeId {
    DEPOSIT = 1, 
    WITHDRAW = 2, 
    REBATE = 3, 
    BET = 4, 
    PAYOUT = 5, 
    PROMOTION = 6, 
    ADMIN_ADD_POINT = 7, 
    INTERNAL_TRANSFER = 8, 
    SYSTEM = 9, 
    THIRD_PARTY_DEPOSIT = 10, 
    ADMIN_DEDUCT_POINT = 11, 
    MANUAL_DEPOSIT = 12, 
    BONUS_POINT = 13, 
    THIRD_PARTY_WITHDRAW = 14, 
    DIGITAL_WALLET_DEPOSIT = 15, 
    PURCHASE = 16, 
    GAME_PLATFORM_CONSUMPTION = 17, 
}

export class LGPS_Edit_Request extends LGPS_Create_Request {

    constructor(data?: any) {
        super(data);
        if (data !== undefined) {
        }
    }

    static fromJS(data: any): LGPS_Edit_Request {
        return new LGPS_Edit_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        super.toJS(data);
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LGPS_Edit_Request(JSON.parse(json));
    }
}

export class StandardResponseOfLIC_GetAll_Response { 
    isSuccess: boolean; 
    payload: LIC_GetAll_Response; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? LIC_GetAll_Response.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfLIC_GetAll_Response {
        return new StandardResponseOfLIC_GetAll_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfLIC_GetAll_Response(JSON.parse(json));
    }
}

export class LIC_GetAll_Response { 
    items: LobbyItemCountingDataModel[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(LobbyItemCountingDataModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LIC_GetAll_Response {
        return new LIC_GetAll_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LIC_GetAll_Response(JSON.parse(json));
    }
}

export class LobbyItemCountingDataModel { 
    id: number; 
    lobbyId: number; 
    code: string; 
    name: string; 
    trueNumber: number; 
    modifiedNumber: number; 
    lobbyItemCountingDataType: string; 
    lobbyItemCountingDataTypeId: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["id"] !== undefined ? data["id"] : null;
            this.lobbyId = data["lobbyId"] !== undefined ? data["lobbyId"] : null;
            this.code = data["code"] !== undefined ? data["code"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
            this.trueNumber = data["trueNumber"] !== undefined ? data["trueNumber"] : null;
            this.modifiedNumber = data["modifiedNumber"] !== undefined ? data["modifiedNumber"] : null;
            this.lobbyItemCountingDataType = data["lobbyItemCountingDataType"] !== undefined ? data["lobbyItemCountingDataType"] : null;
            this.lobbyItemCountingDataTypeId = data["lobbyItemCountingDataTypeId"] !== undefined ? data["lobbyItemCountingDataTypeId"] : null;
        }
    }

    static fromJS(data: any): LobbyItemCountingDataModel {
        return new LobbyItemCountingDataModel(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["id"] = this.id !== undefined ? this.id : null;
        data["lobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["code"] = this.code !== undefined ? this.code : null;
        data["name"] = this.name !== undefined ? this.name : null;
        data["trueNumber"] = this.trueNumber !== undefined ? this.trueNumber : null;
        data["modifiedNumber"] = this.modifiedNumber !== undefined ? this.modifiedNumber : null;
        data["lobbyItemCountingDataType"] = this.lobbyItemCountingDataType !== undefined ? this.lobbyItemCountingDataType : null;
        data["lobbyItemCountingDataTypeId"] = this.lobbyItemCountingDataTypeId !== undefined ? this.lobbyItemCountingDataTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyItemCountingDataModel(JSON.parse(json));
    }
}

export class LIC_GetForAdd_Request {

    constructor(data?: any) {
        if (data !== undefined) {
        }
    }

    static fromJS(data: any): LIC_GetForAdd_Request {
        return new LIC_GetForAdd_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LIC_GetForAdd_Request(JSON.parse(json));
    }
}

export class StandardResponseOfLIC_GetForAdd_Response { 
    isSuccess: boolean; 
    payload: LIC_GetForAdd_Response; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? LIC_GetForAdd_Response.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfLIC_GetForAdd_Response {
        return new StandardResponseOfLIC_GetForAdd_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfLIC_GetForAdd_Response(JSON.parse(json));
    }
}

export class LIC_GetForAdd_Response { 
    types: CountingTypeSelectionOption[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["types"] && data["types"].constructor === Array) {
                this.types = [];
                for (let item of data["types"])
                    this.types.push(CountingTypeSelectionOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LIC_GetForAdd_Response {
        return new LIC_GetForAdd_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.types && this.types.constructor === Array) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LIC_GetForAdd_Response(JSON.parse(json));
    }
}

export class CountingTypeSelectionOption { 
    value: string; 
    label: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.value = data["Value"] !== undefined ? data["Value"] : null;
            this.label = data["Label"] !== undefined ? data["Label"] : null;
        }
    }

    static fromJS(data: any): CountingTypeSelectionOption {
        return new CountingTypeSelectionOption(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Value"] = this.value !== undefined ? this.value : null;
        data["Label"] = this.label !== undefined ? this.label : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CountingTypeSelectionOption(JSON.parse(json));
    }
}

export class LIC_GetForEdit_Request { 
    itemId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.itemId = data["itemId"] !== undefined ? data["itemId"] : null;
        }
    }

    static fromJS(data: any): LIC_GetForEdit_Request {
        return new LIC_GetForEdit_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["itemId"] = this.itemId !== undefined ? this.itemId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LIC_GetForEdit_Request(JSON.parse(json));
    }
}

export class StandardResponseOfLIC_GetForEdit_Response { 
    isSuccess: boolean; 
    payload: LIC_GetForEdit_Response; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? LIC_GetForEdit_Response.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfLIC_GetForEdit_Response {
        return new StandardResponseOfLIC_GetForEdit_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfLIC_GetForEdit_Response(JSON.parse(json));
    }
}

export class LIC_GetForEdit_Response extends LIC_GetForAdd_Response { 
    item: LobbyItemCountingDataModel;

    constructor(data?: any) {
        super(data);
        if (data !== undefined) {
            this.item = data["item"] ? LobbyItemCountingDataModel.fromJS(data["item"]) : null;
        }
    }

    static fromJS(data: any): LIC_GetForEdit_Response {
        return new LIC_GetForEdit_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["item"] = this.item ? this.item.toJS() : null;
        super.toJS(data);
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LIC_GetForEdit_Response(JSON.parse(json));
    }
}

export class LIC_Create_Request { 
    code: string; 
    name: string; 
    modifiedNumber: number; 
    typeId: CountingDataTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.code = data["Code"] !== undefined ? data["Code"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.modifiedNumber = data["ModifiedNumber"] !== undefined ? data["ModifiedNumber"] : null;
            this.typeId = data["TypeId"] !== undefined ? data["TypeId"] : null;
        }
    }

    static fromJS(data: any): LIC_Create_Request {
        return new LIC_Create_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Code"] = this.code !== undefined ? this.code : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["ModifiedNumber"] = this.modifiedNumber !== undefined ? this.modifiedNumber : null;
        data["TypeId"] = this.typeId !== undefined ? this.typeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LIC_Create_Request(JSON.parse(json));
    }
}

export enum CountingDataTypeId {
    Registation = 1, 
    Promotion = 2, 
    Gift = 3, 
    GiftAmount = 4, 
    Video = 5, 
}

export class LIC_Edit_Request { 
    code: string; 
    name: string; 
    modifiedNumber: number; 
    typeId: CountingDataTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.code = data["Code"] !== undefined ? data["Code"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.modifiedNumber = data["ModifiedNumber"] !== undefined ? data["ModifiedNumber"] : null;
            this.typeId = data["TypeId"] !== undefined ? data["TypeId"] : null;
        }
    }

    static fromJS(data: any): LIC_Edit_Request {
        return new LIC_Edit_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Code"] = this.code !== undefined ? this.code : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["ModifiedNumber"] = this.modifiedNumber !== undefined ? this.modifiedNumber : null;
        data["TypeId"] = this.typeId !== undefined ? this.typeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LIC_Edit_Request(JSON.parse(json));
    }
}

export class PaymentFundOutGetForIndexRequest { 
    transactionNo: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
        }
    }

    static fromJS(data: any): PaymentFundOutGetForIndexRequest {
        return new PaymentFundOutGetForIndexRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PaymentFundOutGetForIndexRequest(JSON.parse(json));
    }
}

export class PaymentFundOutGetForIndexResponse { 
    transactionNo: string; 
    transactionStatusId: NewTransactionStatusId; 
    transactionStatus: string; 
    amount: number; 
    bankAccountName: string; 
    bankName: string; 
    bankBranch: string; 
    bankId: number; 
    paymentPlatformId: number; 
    playerAmountRecordId: number; 
    fundoutStatusSetting: FundOutStatusId; 
    updateBy: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
            this.transactionStatusId = data["TransactionStatusId"] !== undefined ? data["TransactionStatusId"] : null;
            this.transactionStatus = data["TransactionStatus"] !== undefined ? data["TransactionStatus"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.bankAccountName = data["BankAccountName"] !== undefined ? data["BankAccountName"] : null;
            this.bankName = data["BankName"] !== undefined ? data["BankName"] : null;
            this.bankBranch = data["BankBranch"] !== undefined ? data["BankBranch"] : null;
            this.bankId = data["BankId"] !== undefined ? data["BankId"] : null;
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.playerAmountRecordId = data["PlayerAmountRecordId"] !== undefined ? data["PlayerAmountRecordId"] : null;
            this.fundoutStatusSetting = data["FundoutStatusSetting"] !== undefined ? data["FundoutStatusSetting"] : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
        }
    }

    static fromJS(data: any): PaymentFundOutGetForIndexResponse {
        return new PaymentFundOutGetForIndexResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        data["TransactionStatusId"] = this.transactionStatusId !== undefined ? this.transactionStatusId : null;
        data["TransactionStatus"] = this.transactionStatus !== undefined ? this.transactionStatus : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["BankAccountName"] = this.bankAccountName !== undefined ? this.bankAccountName : null;
        data["BankName"] = this.bankName !== undefined ? this.bankName : null;
        data["BankBranch"] = this.bankBranch !== undefined ? this.bankBranch : null;
        data["BankId"] = this.bankId !== undefined ? this.bankId : null;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["PlayerAmountRecordId"] = this.playerAmountRecordId !== undefined ? this.playerAmountRecordId : null;
        data["FundoutStatusSetting"] = this.fundoutStatusSetting !== undefined ? this.fundoutStatusSetting : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PaymentFundOutGetForIndexResponse(JSON.parse(json));
    }
}

export class PaymentFundOutPaymentItem { 
    paymentPlatformId: PaymentGatewayPlatformId; 
    paymentPlatformName: string; 
    isBankAvailable: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.paymentPlatformName = data["PaymentPlatformName"] !== undefined ? data["PaymentPlatformName"] : null;
            this.isBankAvailable = data["IsBankAvailable"] !== undefined ? data["IsBankAvailable"] : null;
        }
    }

    static fromJS(data: any): PaymentFundOutPaymentItem {
        return new PaymentFundOutPaymentItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["PaymentPlatformName"] = this.paymentPlatformName !== undefined ? this.paymentPlatformName : null;
        data["IsBankAvailable"] = this.isBankAvailable !== undefined ? this.isBankAvailable : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PaymentFundOutPaymentItem(JSON.parse(json));
    }
}

export class PlatformFundOutAccounts { 
    paymentPlatformId: PaymentGatewayPlatformId; 
    platformFundOutAccountList: PlatformFundOutAccount[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            if (data["PlatformFundOutAccountList"] && data["PlatformFundOutAccountList"].constructor === Array) {
                this.platformFundOutAccountList = [];
                for (let item of data["PlatformFundOutAccountList"])
                    this.platformFundOutAccountList.push(PlatformFundOutAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlatformFundOutAccounts {
        return new PlatformFundOutAccounts(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        if (this.platformFundOutAccountList && this.platformFundOutAccountList.constructor === Array) {
            data["PlatformFundOutAccountList"] = [];
            for (let item of this.platformFundOutAccountList)
                data["PlatformFundOutAccountList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlatformFundOutAccounts(JSON.parse(json));
    }
}

export class PlatformFundOutAccount { 
    displayName: string; 
    reference1: string; 
    balance: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.displayName = data["DisplayName"] !== undefined ? data["DisplayName"] : null;
            this.reference1 = data["Reference1"] !== undefined ? data["Reference1"] : null;
            this.balance = data["Balance"] !== undefined ? data["Balance"] : null;
        }
    }

    static fromJS(data: any): PlatformFundOutAccount {
        return new PlatformFundOutAccount(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["DisplayName"] = this.displayName !== undefined ? this.displayName : null;
        data["Reference1"] = this.reference1 !== undefined ? this.reference1 : null;
        data["Balance"] = this.balance !== undefined ? this.balance : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlatformFundOutAccount(JSON.parse(json));
    }
}

export class PaymentFundOutInquiryRequest { 
    paymentPlatformId: PaymentGatewayPlatformId; 
    transactionNo: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
        }
    }

    static fromJS(data: any): PaymentFundOutInquiryRequest {
        return new PaymentFundOutInquiryRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PaymentFundOutInquiryRequest(JSON.parse(json));
    }
}

export class PaymentFundOutApplyRequest { 
    paymentPlatformId: PaymentGatewayPlatformId; 
    transactionNo: string; 
    reference1: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
            this.reference1 = data["Reference1"] !== undefined ? data["Reference1"] : null;
        }
    }

    static fromJS(data: any): PaymentFundOutApplyRequest {
        return new PaymentFundOutApplyRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        data["Reference1"] = this.reference1 !== undefined ? this.reference1 : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PaymentFundOutApplyRequest(JSON.parse(json));
    }
}

export class PaymentFundOutCancelRequest { 
    paymentPlatformId: PaymentGatewayPlatformId; 
    transactionNo: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
        }
    }

    static fromJS(data: any): PaymentFundOutCancelRequest {
        return new PaymentFundOutCancelRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PaymentFundOutCancelRequest(JSON.parse(json));
    }
}

export class GetPaymentPlatformDetailsRequest { 
    paymentPlatformId: PaymentGatewayPlatformId; 
    transactionTypeId: NewTransactionTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.transactionTypeId = data["TransactionTypeId"] !== undefined ? data["TransactionTypeId"] : null;
        }
    }

    static fromJS(data: any): GetPaymentPlatformDetailsRequest {
        return new GetPaymentPlatformDetailsRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["TransactionTypeId"] = this.transactionTypeId !== undefined ? this.transactionTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetPaymentPlatformDetailsRequest(JSON.parse(json));
    }
}

export class StandardResponseOfPM_GetDetail_Response { 
    isSuccess: boolean; 
    payload: PM_GetDetail_Response; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? PM_GetDetail_Response.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfPM_GetDetail_Response {
        return new StandardResponseOfPM_GetDetail_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfPM_GetDetail_Response(JSON.parse(json));
    }
}

export class PM_GetDetail_Response { 
    paymentPlatformName: string; 
    transactionTypeName: string; 
    translations: PM_GetDetail_Translation[]; 
    pcRules: PM_GetDetail_Rule; 
    mobileRules: PM_GetDetail_Rule; 
    banks: PM_GetDetail_Bank[]; 
    permissionRules: LobbyPaymentPermissionRuleDao[]; 
    createDate: Date; 
    maintainDateStart: Date; 
    maintainDateEnd: Date; 
    maintainDateStartTime: string; 
    maintainDateEndTime: string; 
    isMaintainRepeatEveryDay: boolean; 
    repeatEveryDayDateStart: string; 
    repeatEveryDayDateEnd: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformName = data["paymentPlatformName"] !== undefined ? data["paymentPlatformName"] : null;
            this.transactionTypeName = data["transactionTypeName"] !== undefined ? data["transactionTypeName"] : null;
            if (data["translations"] && data["translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["translations"])
                    this.translations.push(PM_GetDetail_Translation.fromJS(item));
            }
            this.pcRules = data["pcRules"] ? PM_GetDetail_Rule.fromJS(data["pcRules"]) : null;
            this.mobileRules = data["mobileRules"] ? PM_GetDetail_Rule.fromJS(data["mobileRules"]) : null;
            if (data["Banks"] && data["Banks"].constructor === Array) {
                this.banks = [];
                for (let item of data["Banks"])
                    this.banks.push(PM_GetDetail_Bank.fromJS(item));
            }
            if (data["permissionRules"] && data["permissionRules"].constructor === Array) {
                this.permissionRules = [];
                for (let item of data["permissionRules"])
                    this.permissionRules.push(LobbyPaymentPermissionRuleDao.fromJS(item));
            }
            this.createDate = data["createDate"] ? new Date(data["createDate"].toString()) : null;
            this.maintainDateStart = data["maintainDateStart"] ? new Date(data["maintainDateStart"].toString()) : null;
            this.maintainDateEnd = data["maintainDateEnd"] ? new Date(data["maintainDateEnd"].toString()) : null;
            this.maintainDateStartTime = data["maintainDateStartTime"] !== undefined ? data["maintainDateStartTime"] : null;
            this.maintainDateEndTime = data["maintainDateEndTime"] !== undefined ? data["maintainDateEndTime"] : null;
            this.isMaintainRepeatEveryDay = data["isMaintainRepeatEveryDay"] !== undefined ? data["isMaintainRepeatEveryDay"] : null;
            this.repeatEveryDayDateStart = data["repeatEveryDayDateStart"] !== undefined ? data["repeatEveryDayDateStart"] : null;
            this.repeatEveryDayDateEnd = data["repeatEveryDayDateEnd"] !== undefined ? data["repeatEveryDayDateEnd"] : null;
        }
    }

    static fromJS(data: any): PM_GetDetail_Response {
        return new PM_GetDetail_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["paymentPlatformName"] = this.paymentPlatformName !== undefined ? this.paymentPlatformName : null;
        data["transactionTypeName"] = this.transactionTypeName !== undefined ? this.transactionTypeName : null;
        if (this.translations && this.translations.constructor === Array) {
            data["translations"] = [];
            for (let item of this.translations)
                data["translations"].push(item.toJS());
        }
        data["pcRules"] = this.pcRules ? this.pcRules.toJS() : null;
        data["mobileRules"] = this.mobileRules ? this.mobileRules.toJS() : null;
        if (this.banks && this.banks.constructor === Array) {
            data["Banks"] = [];
            for (let item of this.banks)
                data["Banks"].push(item.toJS());
        }
        if (this.permissionRules && this.permissionRules.constructor === Array) {
            data["permissionRules"] = [];
            for (let item of this.permissionRules)
                data["permissionRules"].push(item.toJS());
        }
        data["createDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["maintainDateStart"] = this.maintainDateStart ? this.maintainDateStart.toISOString() : null;
        data["maintainDateEnd"] = this.maintainDateEnd ? this.maintainDateEnd.toISOString() : null;
        data["maintainDateStartTime"] = this.maintainDateStartTime !== undefined ? this.maintainDateStartTime : null;
        data["maintainDateEndTime"] = this.maintainDateEndTime !== undefined ? this.maintainDateEndTime : null;
        data["isMaintainRepeatEveryDay"] = this.isMaintainRepeatEveryDay !== undefined ? this.isMaintainRepeatEveryDay : null;
        data["repeatEveryDayDateStart"] = this.repeatEveryDayDateStart !== undefined ? this.repeatEveryDayDateStart : null;
        data["repeatEveryDayDateEnd"] = this.repeatEveryDayDateEnd !== undefined ? this.repeatEveryDayDateEnd : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PM_GetDetail_Response(JSON.parse(json));
    }
}

export class PM_GetDetail_Translation { 
    languageId: LanguageCode; 
    language: string; 
    channel: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.languageId = data["languageId"] !== undefined ? data["languageId"] : null;
            this.language = data["language"] !== undefined ? data["language"] : null;
            this.channel = data["channel"] !== undefined ? data["channel"] : null;
        }
    }

    static fromJS(data: any): PM_GetDetail_Translation {
        return new PM_GetDetail_Translation(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["languageId"] = this.languageId !== undefined ? this.languageId : null;
        data["language"] = this.language !== undefined ? this.language : null;
        data["channel"] = this.channel !== undefined ? this.channel : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PM_GetDetail_Translation(JSON.parse(json));
    }
}

export class PM_GetDetail_Rule { 
    deviceId: UserDeviceTypeId; 
    maxAmount: number; 
    minAmount: number; 
    isPublish: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.deviceId = data["deviceId"] !== undefined ? data["deviceId"] : null;
            this.maxAmount = data["maxAmount"] !== undefined ? data["maxAmount"] : null;
            this.minAmount = data["minAmount"] !== undefined ? data["minAmount"] : null;
            this.isPublish = data["isPublish"] !== undefined ? data["isPublish"] : null;
        }
    }

    static fromJS(data: any): PM_GetDetail_Rule {
        return new PM_GetDetail_Rule(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["deviceId"] = this.deviceId !== undefined ? this.deviceId : null;
        data["maxAmount"] = this.maxAmount !== undefined ? this.maxAmount : null;
        data["minAmount"] = this.minAmount !== undefined ? this.minAmount : null;
        data["isPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PM_GetDetail_Rule(JSON.parse(json));
    }
}

export enum UserDeviceTypeId {
    ALL = 1, 
    DESKTOP = 2, 
    IOS = 3, 
    ANDROID = 4, 
    WINDOWS_PHONE = 5, 
    ALL_MOBILE = 6, 
    PC_APPLICATION = 7, 
    NOT_DEVICE = 8, 
    IOS_APP = 9, 
    ANDROID_APP = 10, 
}

export class PM_GetDetail_Bank { 
    bankId: number; 
    bankName: string; 
    isEnable: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.bankId = data["BankId"] !== undefined ? data["BankId"] : null;
            this.bankName = data["BankName"] !== undefined ? data["BankName"] : null;
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
        }
    }

    static fromJS(data: any): PM_GetDetail_Bank {
        return new PM_GetDetail_Bank(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["BankId"] = this.bankId !== undefined ? this.bankId : null;
        data["BankName"] = this.bankName !== undefined ? this.bankName : null;
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PM_GetDetail_Bank(JSON.parse(json));
    }
}

export class LobbyPaymentPermissionRuleDao { 
    lobbyId: number; 
    paymentPlatformId: PaymentGatewayPlatformId; 
    transactionTypeId: NewTransactionTypeId; 
    paymentPermissionRuleId: number; 
    className: string; 
    config: any; 
    configSchema: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.transactionTypeId = data["transactionTypeId"] !== undefined ? data["transactionTypeId"] : null;
            this.paymentPermissionRuleId = data["PaymentPermissionRuleId"] !== undefined ? data["PaymentPermissionRuleId"] : null;
            this.className = data["ClassName"] !== undefined ? data["ClassName"] : null;
            this.config = data["Config"] !== undefined ? data["Config"] : null;
            this.configSchema = data["ConfigSchema"] !== undefined ? data["ConfigSchema"] : null;
        }
    }

    static fromJS(data: any): LobbyPaymentPermissionRuleDao {
        return new LobbyPaymentPermissionRuleDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["transactionTypeId"] = this.transactionTypeId !== undefined ? this.transactionTypeId : null;
        data["PaymentPermissionRuleId"] = this.paymentPermissionRuleId !== undefined ? this.paymentPermissionRuleId : null;
        data["ClassName"] = this.className !== undefined ? this.className : null;
        data["Config"] = this.config !== undefined ? this.config : null;
        data["ConfigSchema"] = this.configSchema !== undefined ? this.configSchema : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPaymentPermissionRuleDao(JSON.parse(json));
    }
}

export class PmcEditDetailRequest { 
    paymentPlatmentId: PaymentGatewayPlatformId; 
    transcationTypeId: NewTransactionTypeId; 
    channels: PmcEditDetailChannel[] = []; 
    deviceSettings: PmcEditDetailDeviceSetting[]; 
    enableBankIds: number[]; 
    paymentPermissionRules: PaymentPRule[]; 
    maintainDateStart: Date; 
    maintainDateEnd: Date; 
    maintainDateStartTime: string; 
    maintainDateEndTime: string; 
    isMaintainRepeatEveryDay: boolean; 
    repeatEveryDayDateStart: string; 
    repeatEveryDayDateEnd: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatmentId = data["paymentPlatmentId"] !== undefined ? data["paymentPlatmentId"] : null;
            this.transcationTypeId = data["transcationTypeId"] !== undefined ? data["transcationTypeId"] : null;
            if (data["channels"] && data["channels"].constructor === Array) {
                this.channels = [];
                for (let item of data["channels"])
                    this.channels.push(PmcEditDetailChannel.fromJS(item));
            }
            if (data["deviceSettings"] && data["deviceSettings"].constructor === Array) {
                this.deviceSettings = [];
                for (let item of data["deviceSettings"])
                    this.deviceSettings.push(PmcEditDetailDeviceSetting.fromJS(item));
            }
            if (data["enableBankIds"] && data["enableBankIds"].constructor === Array) {
                this.enableBankIds = [];
                for (let item of data["enableBankIds"])
                    this.enableBankIds.push(item);
            }
            if (data["paymentPermissionRules"] && data["paymentPermissionRules"].constructor === Array) {
                this.paymentPermissionRules = [];
                for (let item of data["paymentPermissionRules"])
                    this.paymentPermissionRules.push(PaymentPRule.fromJS(item));
            }
            this.maintainDateStart = data["maintainDateStart"] ? new Date(data["maintainDateStart"].toString()) : null;
            this.maintainDateEnd = data["maintainDateEnd"] ? new Date(data["maintainDateEnd"].toString()) : null;
            this.maintainDateStartTime = data["maintainDateStartTime"] !== undefined ? data["maintainDateStartTime"] : null;
            this.maintainDateEndTime = data["maintainDateEndTime"] !== undefined ? data["maintainDateEndTime"] : null;
            this.isMaintainRepeatEveryDay = data["isMaintainRepeatEveryDay"] !== undefined ? data["isMaintainRepeatEveryDay"] : null;
            this.repeatEveryDayDateStart = data["repeatEveryDayDateStart"] !== undefined ? data["repeatEveryDayDateStart"] : null;
            this.repeatEveryDayDateEnd = data["repeatEveryDayDateEnd"] !== undefined ? data["repeatEveryDayDateEnd"] : null;
        }
    }

    static fromJS(data: any): PmcEditDetailRequest {
        return new PmcEditDetailRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["paymentPlatmentId"] = this.paymentPlatmentId !== undefined ? this.paymentPlatmentId : null;
        data["transcationTypeId"] = this.transcationTypeId !== undefined ? this.transcationTypeId : null;
        if (this.channels && this.channels.constructor === Array) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item.toJS());
        }
        if (this.deviceSettings && this.deviceSettings.constructor === Array) {
            data["deviceSettings"] = [];
            for (let item of this.deviceSettings)
                data["deviceSettings"].push(item.toJS());
        }
        if (this.enableBankIds && this.enableBankIds.constructor === Array) {
            data["enableBankIds"] = [];
            for (let item of this.enableBankIds)
                data["enableBankIds"].push(item);
        }
        if (this.paymentPermissionRules && this.paymentPermissionRules.constructor === Array) {
            data["paymentPermissionRules"] = [];
            for (let item of this.paymentPermissionRules)
                data["paymentPermissionRules"].push(item.toJS());
        }
        data["maintainDateStart"] = this.maintainDateStart ? this.maintainDateStart.toISOString() : null;
        data["maintainDateEnd"] = this.maintainDateEnd ? this.maintainDateEnd.toISOString() : null;
        data["maintainDateStartTime"] = this.maintainDateStartTime !== undefined ? this.maintainDateStartTime : null;
        data["maintainDateEndTime"] = this.maintainDateEndTime !== undefined ? this.maintainDateEndTime : null;
        data["isMaintainRepeatEveryDay"] = this.isMaintainRepeatEveryDay !== undefined ? this.isMaintainRepeatEveryDay : null;
        data["repeatEveryDayDateStart"] = this.repeatEveryDayDateStart !== undefined ? this.repeatEveryDayDateStart : null;
        data["repeatEveryDayDateEnd"] = this.repeatEveryDayDateEnd !== undefined ? this.repeatEveryDayDateEnd : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PmcEditDetailRequest(JSON.parse(json));
    }
}

export class PmcEditDetailChannel { 
    languageId: LanguageCode; 
    name: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.languageId = data["languageId"] !== undefined ? data["languageId"] : null;
            this.name = data["name"] !== undefined ? data["name"] : null;
        }
    }

    static fromJS(data: any): PmcEditDetailChannel {
        return new PmcEditDetailChannel(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["languageId"] = this.languageId !== undefined ? this.languageId : null;
        data["name"] = this.name !== undefined ? this.name : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PmcEditDetailChannel(JSON.parse(json));
    }
}

export class PmcEditDetailDeviceSetting { 
    deviceId: UserDeviceTypeId; 
    maxAmount: number; 
    minAmount: number; 
    isPublish: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.deviceId = data["deviceId"] !== undefined ? data["deviceId"] : null;
            this.maxAmount = data["maxAmount"] !== undefined ? data["maxAmount"] : null;
            this.minAmount = data["minAmount"] !== undefined ? data["minAmount"] : null;
            this.isPublish = data["isPublish"] !== undefined ? data["isPublish"] : null;
        }
    }

    static fromJS(data: any): PmcEditDetailDeviceSetting {
        return new PmcEditDetailDeviceSetting(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["deviceId"] = this.deviceId !== undefined ? this.deviceId : null;
        data["maxAmount"] = this.maxAmount !== undefined ? this.maxAmount : null;
        data["minAmount"] = this.minAmount !== undefined ? this.minAmount : null;
        data["isPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PmcEditDetailDeviceSetting(JSON.parse(json));
    }
}

export class PaymentPRule { 
    id: number; 
    config: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["id"] !== undefined ? data["id"] : null;
            this.config = data["config"] !== undefined ? data["config"] : null;
        }
    }

    static fromJS(data: any): PaymentPRule {
        return new PaymentPRule(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["id"] = this.id !== undefined ? this.id : null;
        data["config"] = this.config !== undefined ? this.config : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PaymentPRule(JSON.parse(json));
    }
}

export class StandardResponseOfPM_GetAll_Response { 
    isSuccess: boolean; 
    payload: PM_GetAll_Response; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? PM_GetAll_Response.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfPM_GetAll_Response {
        return new StandardResponseOfPM_GetAll_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfPM_GetAll_Response(JSON.parse(json));
    }
}

export class PM_GetAll_Response { 
    items: PM_GetAll_Item[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(PM_GetAll_Item.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PM_GetAll_Response {
        return new PM_GetAll_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PM_GetAll_Response(JSON.parse(json));
    }
}

export class PM_GetAll_Item { 
    paymentPlatformName: string; 
    paymentPlatformId: PaymentGatewayPlatformId; 
    transactionTypeName: string; 
    transactionTypeId: NewTransactionTypeId; 
    channelName: string; 
    createDate: Date; 
    maintainDateStart: Date; 
    maintainDateEnd: Date; 
    pcRules: PM_GetAll_ItemRule; 
    mobileRules: PM_GetAll_ItemRule; 
    isMaintainRepeatEveryDay: boolean; 
    repeatEveryDayDateStart: string; 
    repeatEveryDayDateEnd: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformName = data["PaymentPlatformName"] !== undefined ? data["PaymentPlatformName"] : null;
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.transactionTypeName = data["TransactionTypeName"] !== undefined ? data["TransactionTypeName"] : null;
            this.transactionTypeId = data["TransactionTypeId"] !== undefined ? data["TransactionTypeId"] : null;
            this.channelName = data["ChannelName"] !== undefined ? data["ChannelName"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.maintainDateStart = data["MaintainDateStart"] ? new Date(data["MaintainDateStart"].toString()) : null;
            this.maintainDateEnd = data["MaintainDateEnd"] ? new Date(data["MaintainDateEnd"].toString()) : null;
            this.pcRules = data["PcRules"] ? PM_GetAll_ItemRule.fromJS(data["PcRules"]) : null;
            this.mobileRules = data["MobileRules"] ? PM_GetAll_ItemRule.fromJS(data["MobileRules"]) : null;
            this.isMaintainRepeatEveryDay = data["IsMaintainRepeatEveryDay"] !== undefined ? data["IsMaintainRepeatEveryDay"] : null;
            this.repeatEveryDayDateStart = data["RepeatEveryDayDateStart"] !== undefined ? data["RepeatEveryDayDateStart"] : null;
            this.repeatEveryDayDateEnd = data["RepeatEveryDayDateEnd"] !== undefined ? data["RepeatEveryDayDateEnd"] : null;
        }
    }

    static fromJS(data: any): PM_GetAll_Item {
        return new PM_GetAll_Item(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PaymentPlatformName"] = this.paymentPlatformName !== undefined ? this.paymentPlatformName : null;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["TransactionTypeName"] = this.transactionTypeName !== undefined ? this.transactionTypeName : null;
        data["TransactionTypeId"] = this.transactionTypeId !== undefined ? this.transactionTypeId : null;
        data["ChannelName"] = this.channelName !== undefined ? this.channelName : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["MaintainDateStart"] = this.maintainDateStart ? this.maintainDateStart.toISOString() : null;
        data["MaintainDateEnd"] = this.maintainDateEnd ? this.maintainDateEnd.toISOString() : null;
        data["PcRules"] = this.pcRules ? this.pcRules.toJS() : null;
        data["MobileRules"] = this.mobileRules ? this.mobileRules.toJS() : null;
        data["IsMaintainRepeatEveryDay"] = this.isMaintainRepeatEveryDay !== undefined ? this.isMaintainRepeatEveryDay : null;
        data["RepeatEveryDayDateStart"] = this.repeatEveryDayDateStart !== undefined ? this.repeatEveryDayDateStart : null;
        data["RepeatEveryDayDateEnd"] = this.repeatEveryDayDateEnd !== undefined ? this.repeatEveryDayDateEnd : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PM_GetAll_Item(JSON.parse(json));
    }
}

export class PM_GetAll_ItemRule { 
    deviceId: UserDeviceTypeId; 
    maxAmount: number; 
    minAmount: number; 
    isPublish: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.deviceId = data["DeviceId"] !== undefined ? data["DeviceId"] : null;
            this.maxAmount = data["MaxAmount"] !== undefined ? data["MaxAmount"] : null;
            this.minAmount = data["MinAmount"] !== undefined ? data["MinAmount"] : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
        }
    }

    static fromJS(data: any): PM_GetAll_ItemRule {
        return new PM_GetAll_ItemRule(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["DeviceId"] = this.deviceId !== undefined ? this.deviceId : null;
        data["MaxAmount"] = this.maxAmount !== undefined ? this.maxAmount : null;
        data["MinAmount"] = this.minAmount !== undefined ? this.minAmount : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PM_GetAll_ItemRule(JSON.parse(json));
    }
}

export class StandardResponseOfPM_TransactionType_Response { 
    isSuccess: boolean; 
    payload: PM_TransactionType_Response; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? PM_TransactionType_Response.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfPM_TransactionType_Response {
        return new StandardResponseOfPM_TransactionType_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfPM_TransactionType_Response(JSON.parse(json));
    }
}

export class PM_TransactionType_Response { 
    paymentPlatformTransactionTypes: TransactionTypeDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["PaymentPlatformTransactionTypes"] && data["PaymentPlatformTransactionTypes"].constructor === Array) {
                this.paymentPlatformTransactionTypes = [];
                for (let item of data["PaymentPlatformTransactionTypes"])
                    this.paymentPlatformTransactionTypes.push(TransactionTypeDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PM_TransactionType_Response {
        return new PM_TransactionType_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.paymentPlatformTransactionTypes && this.paymentPlatformTransactionTypes.constructor === Array) {
            data["PaymentPlatformTransactionTypes"] = [];
            for (let item of this.paymentPlatformTransactionTypes)
                data["PaymentPlatformTransactionTypes"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PM_TransactionType_Response(JSON.parse(json));
    }
}

export class TransactionTypeDao { 
    transactionTypeId: NewTransactionTypeId; 
    transactionTypeName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.transactionTypeId = data["TransactionTypeId"] !== undefined ? data["TransactionTypeId"] : null;
            this.transactionTypeName = data["TransactionTypeName"] !== undefined ? data["TransactionTypeName"] : null;
        }
    }

    static fromJS(data: any): TransactionTypeDao {
        return new TransactionTypeDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["TransactionTypeId"] = this.transactionTypeId !== undefined ? this.transactionTypeId : null;
        data["TransactionTypeName"] = this.transactionTypeName !== undefined ? this.transactionTypeName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new TransactionTypeDao(JSON.parse(json));
    }
}

export class PmcGetChannelsRequest { 
    transcationTypeId: NewTransactionTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.transcationTypeId = data["transcationTypeId"] !== undefined ? data["transcationTypeId"] : null;
        }
    }

    static fromJS(data: any): PmcGetChannelsRequest {
        return new PmcGetChannelsRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["transcationTypeId"] = this.transcationTypeId !== undefined ? this.transcationTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PmcGetChannelsRequest(JSON.parse(json));
    }
}

export class StandardResponseOfPM_GetChannels_Response { 
    isSuccess: boolean; 
    payload: PM_GetChannels_Response; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? PM_GetChannels_Response.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfPM_GetChannels_Response {
        return new StandardResponseOfPM_GetChannels_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfPM_GetChannels_Response(JSON.parse(json));
    }
}

export class PM_GetChannels_Response { 
    channels: PM_GetChannel_Item[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["channels"] && data["channels"].constructor === Array) {
                this.channels = [];
                for (let item of data["channels"])
                    this.channels.push(PM_GetChannel_Item.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PM_GetChannels_Response {
        return new PM_GetChannels_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.channels && this.channels.constructor === Array) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PM_GetChannels_Response(JSON.parse(json));
    }
}

export class PM_GetChannel_Item { 
    paymentPlatformName: string; 
    paymentPlatformId: PaymentGatewayPlatformId; 
    transactionTypeName: string; 
    transactionTypeId: NewTransactionTypeId; 
    channelName: string; 
    pcIspublish: boolean; 
    mobileIspublish: boolean; 
    seq: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformName = data["PaymentPlatformName"] !== undefined ? data["PaymentPlatformName"] : null;
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.transactionTypeName = data["TransactionTypeName"] !== undefined ? data["TransactionTypeName"] : null;
            this.transactionTypeId = data["TransactionTypeId"] !== undefined ? data["TransactionTypeId"] : null;
            this.channelName = data["ChannelName"] !== undefined ? data["ChannelName"] : null;
            this.pcIspublish = data["PcIspublish"] !== undefined ? data["PcIspublish"] : null;
            this.mobileIspublish = data["MobileIspublish"] !== undefined ? data["MobileIspublish"] : null;
            this.seq = data["Seq"] !== undefined ? data["Seq"] : null;
        }
    }

    static fromJS(data: any): PM_GetChannel_Item {
        return new PM_GetChannel_Item(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PaymentPlatformName"] = this.paymentPlatformName !== undefined ? this.paymentPlatformName : null;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["TransactionTypeName"] = this.transactionTypeName !== undefined ? this.transactionTypeName : null;
        data["TransactionTypeId"] = this.transactionTypeId !== undefined ? this.transactionTypeId : null;
        data["ChannelName"] = this.channelName !== undefined ? this.channelName : null;
        data["PcIspublish"] = this.pcIspublish !== undefined ? this.pcIspublish : null;
        data["MobileIspublish"] = this.mobileIspublish !== undefined ? this.mobileIspublish : null;
        data["Seq"] = this.seq !== undefined ? this.seq : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PM_GetChannel_Item(JSON.parse(json));
    }
}

export class PmcSetSortByListRequest { 
    lobbyPaymentPlatformTransactionType: LobbyPaymentPlatformTransactionType[] = [];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["lobbyPaymentPlatformTransactionType"] && data["lobbyPaymentPlatformTransactionType"].constructor === Array) {
                this.lobbyPaymentPlatformTransactionType = [];
                for (let item of data["lobbyPaymentPlatformTransactionType"])
                    this.lobbyPaymentPlatformTransactionType.push(LobbyPaymentPlatformTransactionType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PmcSetSortByListRequest {
        return new PmcSetSortByListRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.lobbyPaymentPlatformTransactionType && this.lobbyPaymentPlatformTransactionType.constructor === Array) {
            data["lobbyPaymentPlatformTransactionType"] = [];
            for (let item of this.lobbyPaymentPlatformTransactionType)
                data["lobbyPaymentPlatformTransactionType"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PmcSetSortByListRequest(JSON.parse(json));
    }
}

export class LobbyPaymentPlatformTransactionType { 
    paymentPlatformId: PaymentGatewayPlatformId; 
    transactionTypeId: NewTransactionTypeId; 
    seq: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformId = data["paymentPlatformId"] !== undefined ? data["paymentPlatformId"] : null;
            this.transactionTypeId = data["transactionTypeId"] !== undefined ? data["transactionTypeId"] : null;
            this.seq = data["seq"] !== undefined ? data["seq"] : null;
        }
    }

    static fromJS(data: any): LobbyPaymentPlatformTransactionType {
        return new LobbyPaymentPlatformTransactionType(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["paymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["transactionTypeId"] = this.transactionTypeId !== undefined ? this.transactionTypeId : null;
        data["seq"] = this.seq !== undefined ? this.seq : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPaymentPlatformTransactionType(JSON.parse(json));
    }
}

export class LobbyEGameItem { 
    id: number; 
    lobbyId: number; 
    gameDevEGameId: number; 
    gameDevEGameName: string; 
    gameDevId: number; 
    gameDevName: string; 
    isHot: boolean; 
    isJackpot: boolean; 
    isNewGame: boolean; 
    isPublish: boolean; 
    isSupportDesktop: boolean; 
    isSupportMobile: boolean; 
    sortNo: number; 
    createDate: Date; 
    updateBy: string; 
    updateDate: Date; 
    imageUrl: string; 
    playerAmountRecordGameType: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.gameDevEGameId = data["GameDevEGameId"] !== undefined ? data["GameDevEGameId"] : null;
            this.gameDevEGameName = data["GameDevEGameName"] !== undefined ? data["GameDevEGameName"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
            this.isHot = data["IsHot"] !== undefined ? data["IsHot"] : null;
            this.isJackpot = data["IsJackpot"] !== undefined ? data["IsJackpot"] : null;
            this.isNewGame = data["IsNewGame"] !== undefined ? data["IsNewGame"] : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
            this.isSupportDesktop = data["IsSupportDesktop"] !== undefined ? data["IsSupportDesktop"] : null;
            this.isSupportMobile = data["IsSupportMobile"] !== undefined ? data["IsSupportMobile"] : null;
            this.sortNo = data["SortNo"] !== undefined ? data["SortNo"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.imageUrl = data["imageUrl"] !== undefined ? data["imageUrl"] : null;
            this.playerAmountRecordGameType = data["PlayerAmountRecordGameType"] !== undefined ? data["PlayerAmountRecordGameType"] : null;
        }
    }

    static fromJS(data: any): LobbyEGameItem {
        return new LobbyEGameItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["GameDevEGameId"] = this.gameDevEGameId !== undefined ? this.gameDevEGameId : null;
        data["GameDevEGameName"] = this.gameDevEGameName !== undefined ? this.gameDevEGameName : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        data["IsHot"] = this.isHot !== undefined ? this.isHot : null;
        data["IsJackpot"] = this.isJackpot !== undefined ? this.isJackpot : null;
        data["IsNewGame"] = this.isNewGame !== undefined ? this.isNewGame : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        data["IsSupportDesktop"] = this.isSupportDesktop !== undefined ? this.isSupportDesktop : null;
        data["IsSupportMobile"] = this.isSupportMobile !== undefined ? this.isSupportMobile : null;
        data["SortNo"] = this.sortNo !== undefined ? this.sortNo : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["imageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null;
        data["PlayerAmountRecordGameType"] = this.playerAmountRecordGameType !== undefined ? this.playerAmountRecordGameType : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyEGameItem(JSON.parse(json));
    }
}

export class LobbyEGameGetRequest { 
    gameDevId: GameDevId; 
    playerAmountRecordGameTypeId: PlayerAmountRecordGameTypeId; 
    isPublish: boolean; 
    isHot: boolean; 
    isNew: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.playerAmountRecordGameTypeId = data["PlayerAmountRecordGameTypeId"] !== undefined ? data["PlayerAmountRecordGameTypeId"] : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
            this.isHot = data["isHot"] !== undefined ? data["isHot"] : null;
            this.isNew = data["isNew"] !== undefined ? data["isNew"] : null;
        }
    }

    static fromJS(data: any): LobbyEGameGetRequest {
        return new LobbyEGameGetRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["PlayerAmountRecordGameTypeId"] = this.playerAmountRecordGameTypeId !== undefined ? this.playerAmountRecordGameTypeId : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        data["isHot"] = this.isHot !== undefined ? this.isHot : null;
        data["isNew"] = this.isNew !== undefined ? this.isNew : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyEGameGetRequest(JSON.parse(json));
    }
}

export class LobbyEGame_GetForIndexResponse { 
    gameDevs: CmsSelectionOptionDao[]; 
    playerAmountRecordGameTypes: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["GameDevs"] && data["GameDevs"].constructor === Array) {
                this.gameDevs = [];
                for (let item of data["GameDevs"])
                    this.gameDevs.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["PlayerAmountRecordGameTypes"] && data["PlayerAmountRecordGameTypes"].constructor === Array) {
                this.playerAmountRecordGameTypes = [];
                for (let item of data["PlayerAmountRecordGameTypes"])
                    this.playerAmountRecordGameTypes.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyEGame_GetForIndexResponse {
        return new LobbyEGame_GetForIndexResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.gameDevs && this.gameDevs.constructor === Array) {
            data["GameDevs"] = [];
            for (let item of this.gameDevs)
                data["GameDevs"].push(item.toJS());
        }
        if (this.playerAmountRecordGameTypes && this.playerAmountRecordGameTypes.constructor === Array) {
            data["PlayerAmountRecordGameTypes"] = [];
            for (let item of this.playerAmountRecordGameTypes)
                data["PlayerAmountRecordGameTypes"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyEGame_GetForIndexResponse(JSON.parse(json));
    }
}

export class LobbyEGameEditResponse { 
    id: number; 
    name: string; 
    gameDevID: number; 
    gameDevName: string; 
    isEnableAutoRebate: boolean; 
    lobbyEGameTranslations: LobbyEGameTranslationDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.gameDevID = data["GameDevID"] !== undefined ? data["GameDevID"] : null;
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
            this.isEnableAutoRebate = data["IsEnableAutoRebate"] !== undefined ? data["IsEnableAutoRebate"] : null;
            if (data["LobbyEGameTranslations"] && data["LobbyEGameTranslations"].constructor === Array) {
                this.lobbyEGameTranslations = [];
                for (let item of data["LobbyEGameTranslations"])
                    this.lobbyEGameTranslations.push(LobbyEGameTranslationDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyEGameEditResponse {
        return new LobbyEGameEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["GameDevID"] = this.gameDevID !== undefined ? this.gameDevID : null;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        data["IsEnableAutoRebate"] = this.isEnableAutoRebate !== undefined ? this.isEnableAutoRebate : null;
        if (this.lobbyEGameTranslations && this.lobbyEGameTranslations.constructor === Array) {
            data["LobbyEGameTranslations"] = [];
            for (let item of this.lobbyEGameTranslations)
                data["LobbyEGameTranslations"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyEGameEditResponse(JSON.parse(json));
    }
}

export class LobbyEGameTranslationDao { 
    lobbyEGameId: number; 
    languageId: number; 
    languageName: string; 
    coverImagePath: string; 
    coverImagePathMobile: string; 
    detailContent: string; 
    detailImagePath: string; 
    detailImagePathMobile: string; 
    detailSubImagePath: string; 
    detailSubImagePathMobile: string; 
    backgroundImagePath: string; 
    backgroundImagePathMobile: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyEGameId = data["LobbyEGameId"] !== undefined ? data["LobbyEGameId"] : null;
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.languageName = data["LanguageName"] !== undefined ? data["LanguageName"] : null;
            this.coverImagePath = data["CoverImagePath"] !== undefined ? data["CoverImagePath"] : null;
            this.coverImagePathMobile = data["CoverImagePathMobile"] !== undefined ? data["CoverImagePathMobile"] : null;
            this.detailContent = data["DetailContent"] !== undefined ? data["DetailContent"] : null;
            this.detailImagePath = data["DetailImagePath"] !== undefined ? data["DetailImagePath"] : null;
            this.detailImagePathMobile = data["DetailImagePathMobile"] !== undefined ? data["DetailImagePathMobile"] : null;
            this.detailSubImagePath = data["DetailSubImagePath"] !== undefined ? data["DetailSubImagePath"] : null;
            this.detailSubImagePathMobile = data["DetailSubImagePathMobile"] !== undefined ? data["DetailSubImagePathMobile"] : null;
            this.backgroundImagePath = data["BackgroundImagePath"] !== undefined ? data["BackgroundImagePath"] : null;
            this.backgroundImagePathMobile = data["BackgroundImagePathMobile"] !== undefined ? data["BackgroundImagePathMobile"] : null;
        }
    }

    static fromJS(data: any): LobbyEGameTranslationDao {
        return new LobbyEGameTranslationDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyEGameId"] = this.lobbyEGameId !== undefined ? this.lobbyEGameId : null;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["LanguageName"] = this.languageName !== undefined ? this.languageName : null;
        data["CoverImagePath"] = this.coverImagePath !== undefined ? this.coverImagePath : null;
        data["CoverImagePathMobile"] = this.coverImagePathMobile !== undefined ? this.coverImagePathMobile : null;
        data["DetailContent"] = this.detailContent !== undefined ? this.detailContent : null;
        data["DetailImagePath"] = this.detailImagePath !== undefined ? this.detailImagePath : null;
        data["DetailImagePathMobile"] = this.detailImagePathMobile !== undefined ? this.detailImagePathMobile : null;
        data["DetailSubImagePath"] = this.detailSubImagePath !== undefined ? this.detailSubImagePath : null;
        data["DetailSubImagePathMobile"] = this.detailSubImagePathMobile !== undefined ? this.detailSubImagePathMobile : null;
        data["BackgroundImagePath"] = this.backgroundImagePath !== undefined ? this.backgroundImagePath : null;
        data["BackgroundImagePathMobile"] = this.backgroundImagePathMobile !== undefined ? this.backgroundImagePathMobile : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyEGameTranslationDao(JSON.parse(json));
    }
}

export class LobbyEGameEditRequestDao { 
    id: number; 
    isEnableAutoRebate: boolean; 
    lobbyEGameTranslations: LobbyEGameTranslationDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.isEnableAutoRebate = data["isEnableAutoRebate"] !== undefined ? data["isEnableAutoRebate"] : null;
            if (data["LobbyEGameTranslations"] && data["LobbyEGameTranslations"].constructor === Array) {
                this.lobbyEGameTranslations = [];
                for (let item of data["LobbyEGameTranslations"])
                    this.lobbyEGameTranslations.push(LobbyEGameTranslationDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyEGameEditRequestDao {
        return new LobbyEGameEditRequestDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["isEnableAutoRebate"] = this.isEnableAutoRebate !== undefined ? this.isEnableAutoRebate : null;
        if (this.lobbyEGameTranslations && this.lobbyEGameTranslations.constructor === Array) {
            data["LobbyEGameTranslations"] = [];
            for (let item of this.lobbyEGameTranslations)
                data["LobbyEGameTranslations"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyEGameEditRequestDao(JSON.parse(json));
    }
}

export class LobbyEGameSetPropertyRequest { 
    lobbyEGameId: number; 
    property: LobbyEGameProperty;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyEGameId = data["LobbyEGameId"] !== undefined ? data["LobbyEGameId"] : null;
            this.property = data["Property"] !== undefined ? data["Property"] : null;
        }
    }

    static fromJS(data: any): LobbyEGameSetPropertyRequest {
        return new LobbyEGameSetPropertyRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyEGameId"] = this.lobbyEGameId !== undefined ? this.lobbyEGameId : null;
        data["Property"] = this.property !== undefined ? this.property : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyEGameSetPropertyRequest(JSON.parse(json));
    }
}

export enum LobbyEGameProperty {
    IsNewGame = 1, 
    IsHot = 2, 
    IsJackpot = 3, 
    IsPublish = 4, 
}

export class LobbyEGameSetSortNoRequest { 
    lobbyEGameId: number; 
    sortNo: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyEGameId = data["LobbyEGameId"] !== undefined ? data["LobbyEGameId"] : null;
            this.sortNo = data["SortNo"] !== undefined ? data["SortNo"] : null;
        }
    }

    static fromJS(data: any): LobbyEGameSetSortNoRequest {
        return new LobbyEGameSetSortNoRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyEGameId"] = this.lobbyEGameId !== undefined ? this.lobbyEGameId : null;
        data["SortNo"] = this.sortNo !== undefined ? this.sortNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyEGameSetSortNoRequest(JSON.parse(json));
    }
}

export class LobbyEGameSetSortByListRequest { 
    gameDevId: GameDevId; 
    isHot: boolean; 
    isNew: boolean; 
    playerAmountRecordGameTypeId: PlayerAmountRecordGameTypeId; 
    sortItemList: LobbyEGameSortItemRequestDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.isHot = data["isHot"] !== undefined ? data["isHot"] : null;
            this.isNew = data["isNew"] !== undefined ? data["isNew"] : null;
            this.playerAmountRecordGameTypeId = data["PlayerAmountRecordGameTypeId"] !== undefined ? data["PlayerAmountRecordGameTypeId"] : null;
            if (data["SortItemList"] && data["SortItemList"].constructor === Array) {
                this.sortItemList = [];
                for (let item of data["SortItemList"])
                    this.sortItemList.push(LobbyEGameSortItemRequestDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyEGameSetSortByListRequest {
        return new LobbyEGameSetSortByListRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["isHot"] = this.isHot !== undefined ? this.isHot : null;
        data["isNew"] = this.isNew !== undefined ? this.isNew : null;
        data["PlayerAmountRecordGameTypeId"] = this.playerAmountRecordGameTypeId !== undefined ? this.playerAmountRecordGameTypeId : null;
        if (this.sortItemList && this.sortItemList.constructor === Array) {
            data["SortItemList"] = [];
            for (let item of this.sortItemList)
                data["SortItemList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyEGameSetSortByListRequest(JSON.parse(json));
    }
}

export class LobbyEGameSortItemRequestDao { 
    id: number; 
    sortNo: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.sortNo = data["SortNo"] !== undefined ? data["SortNo"] : null;
        }
    }

    static fromJS(data: any): LobbyEGameSortItemRequestDao {
        return new LobbyEGameSortItemRequestDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["SortNo"] = this.sortNo !== undefined ? this.sortNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyEGameSortItemRequestDao(JSON.parse(json));
    }
}

export class LobbyEGame_GetGameCodeExampleRequest { 
    gameDevId: GameDevId; 
    playerAmountRecordGameTypeId: PlayerAmountRecordGameTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.playerAmountRecordGameTypeId = data["PlayerAmountRecordGameTypeId"] !== undefined ? data["PlayerAmountRecordGameTypeId"] : null;
        }
    }

    static fromJS(data: any): LobbyEGame_GetGameCodeExampleRequest {
        return new LobbyEGame_GetGameCodeExampleRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["PlayerAmountRecordGameTypeId"] = this.playerAmountRecordGameTypeId !== undefined ? this.playerAmountRecordGameTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyEGame_GetGameCodeExampleRequest(JSON.parse(json));
    }
}

export class LobbyEGame_GetGameCodeExampleResponse { 
    launchGameCodePC: string; 
    launchGameCodeMobile: string; 
    schedulerGameCode: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.launchGameCodePC = data["LaunchGameCodePC"] !== undefined ? data["LaunchGameCodePC"] : null;
            this.launchGameCodeMobile = data["LaunchGameCodeMobile"] !== undefined ? data["LaunchGameCodeMobile"] : null;
            this.schedulerGameCode = data["SchedulerGameCode"] !== undefined ? data["SchedulerGameCode"] : null;
        }
    }

    static fromJS(data: any): LobbyEGame_GetGameCodeExampleResponse {
        return new LobbyEGame_GetGameCodeExampleResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LaunchGameCodePC"] = this.launchGameCodePC !== undefined ? this.launchGameCodePC : null;
        data["LaunchGameCodeMobile"] = this.launchGameCodeMobile !== undefined ? this.launchGameCodeMobile : null;
        data["SchedulerGameCode"] = this.schedulerGameCode !== undefined ? this.schedulerGameCode : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyEGame_GetGameCodeExampleResponse(JSON.parse(json));
    }
}

export class LobbyEGame_AddNewGameRequest { 
    keyGameName: string; 
    gameNameEN: string; 
    gameNameZH: string; 
    gameNameTW: string; 
    subGameDevId: GameDevId; 
    playerAmountRecordGameTypeId: PlayerAmountRecordGameTypeId; 
    isSupportPC: boolean; 
    launchGameCodePC: string; 
    isSupportMobile: boolean; 
    launchGameCodeMobile: string; 
    schedulerGameCode: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.keyGameName = data["KeyGameName"] !== undefined ? data["KeyGameName"] : null;
            this.gameNameEN = data["GameNameEN"] !== undefined ? data["GameNameEN"] : null;
            this.gameNameZH = data["GameNameZH"] !== undefined ? data["GameNameZH"] : null;
            this.gameNameTW = data["GameNameTW"] !== undefined ? data["GameNameTW"] : null;
            this.subGameDevId = data["SubGameDevId"] !== undefined ? data["SubGameDevId"] : null;
            this.playerAmountRecordGameTypeId = data["PlayerAmountRecordGameTypeId"] !== undefined ? data["PlayerAmountRecordGameTypeId"] : null;
            this.isSupportPC = data["IsSupportPC"] !== undefined ? data["IsSupportPC"] : null;
            this.launchGameCodePC = data["LaunchGameCodePC"] !== undefined ? data["LaunchGameCodePC"] : null;
            this.isSupportMobile = data["IsSupportMobile"] !== undefined ? data["IsSupportMobile"] : null;
            this.launchGameCodeMobile = data["LaunchGameCodeMobile"] !== undefined ? data["LaunchGameCodeMobile"] : null;
            this.schedulerGameCode = data["SchedulerGameCode"] !== undefined ? data["SchedulerGameCode"] : null;
        }
    }

    static fromJS(data: any): LobbyEGame_AddNewGameRequest {
        return new LobbyEGame_AddNewGameRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["KeyGameName"] = this.keyGameName !== undefined ? this.keyGameName : null;
        data["GameNameEN"] = this.gameNameEN !== undefined ? this.gameNameEN : null;
        data["GameNameZH"] = this.gameNameZH !== undefined ? this.gameNameZH : null;
        data["GameNameTW"] = this.gameNameTW !== undefined ? this.gameNameTW : null;
        data["SubGameDevId"] = this.subGameDevId !== undefined ? this.subGameDevId : null;
        data["PlayerAmountRecordGameTypeId"] = this.playerAmountRecordGameTypeId !== undefined ? this.playerAmountRecordGameTypeId : null;
        data["IsSupportPC"] = this.isSupportPC !== undefined ? this.isSupportPC : null;
        data["LaunchGameCodePC"] = this.launchGameCodePC !== undefined ? this.launchGameCodePC : null;
        data["IsSupportMobile"] = this.isSupportMobile !== undefined ? this.isSupportMobile : null;
        data["LaunchGameCodeMobile"] = this.launchGameCodeMobile !== undefined ? this.launchGameCodeMobile : null;
        data["SchedulerGameCode"] = this.schedulerGameCode !== undefined ? this.schedulerGameCode : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyEGame_AddNewGameRequest(JSON.parse(json));
    }
}

export class LobbyGameDevSimpleItem { 
    id: number; 
    gameDevId: number; 
    gameDevName: string; 
    enable: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
            this.enable = data["Enable"] !== undefined ? data["Enable"] : null;
        }
    }

    static fromJS(data: any): LobbyGameDevSimpleItem {
        return new LobbyGameDevSimpleItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        data["Enable"] = this.enable !== undefined ? this.enable : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyGameDevSimpleItem(JSON.parse(json));
    }
}

export class LobbyLiveStreamGetAllResponse { 
    lobbyLiveStreamId: number; 
    lobbyId: number; 
    name: string; 
    roomCode: string; 
    isEnable: boolean; 
    imageUrl: string; 
    sorting: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyLiveStreamId = data["LobbyLiveStreamId"] !== undefined ? data["LobbyLiveStreamId"] : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.roomCode = data["RoomCode"] !== undefined ? data["RoomCode"] : null;
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
            this.imageUrl = data["ImageUrl"] !== undefined ? data["ImageUrl"] : null;
            this.sorting = data["Sorting"] !== undefined ? data["Sorting"] : null;
        }
    }

    static fromJS(data: any): LobbyLiveStreamGetAllResponse {
        return new LobbyLiveStreamGetAllResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyLiveStreamId"] = this.lobbyLiveStreamId !== undefined ? this.lobbyLiveStreamId : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["RoomCode"] = this.roomCode !== undefined ? this.roomCode : null;
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        data["ImageUrl"] = this.imageUrl !== undefined ? this.imageUrl : null;
        data["Sorting"] = this.sorting !== undefined ? this.sorting : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyLiveStreamGetAllResponse(JSON.parse(json));
    }
}

export class LobbyLiveStreamSetEnableRequest { 
    lobbyLiveStreamId: number; 
    isEnable: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyLiveStreamId = data["LobbyLiveStreamId"] !== undefined ? data["LobbyLiveStreamId"] : null;
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
        }
    }

    static fromJS(data: any): LobbyLiveStreamSetEnableRequest {
        return new LobbyLiveStreamSetEnableRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyLiveStreamId"] = this.lobbyLiveStreamId !== undefined ? this.lobbyLiveStreamId : null;
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyLiveStreamSetEnableRequest(JSON.parse(json));
    }
}

export class LobbyMaintenanceItemDao { 
    id: number; 
    lobbyId: number; 
    maintenanceItemId: number; 
    maintenanceItemName: string; 
    startDate: Date; 
    startTime: string; 
    endDate: Date; 
    endTime: string; 
    isRepeat: boolean; 
    repeatEveryNDays: number; 
    repeatEndDate: Date; 
    durationMinutes: number; 
    isEnable: boolean; 
    updateDate: Date; 
    updateBy: number; 
    updateByUserName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.maintenanceItemId = data["MaintenanceItemId"] !== undefined ? data["MaintenanceItemId"] : null;
            this.maintenanceItemName = data["MaintenanceItemName"] !== undefined ? data["MaintenanceItemName"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.startTime = data["StartTime"] !== undefined ? data["StartTime"] : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.endTime = data["EndTime"] !== undefined ? data["EndTime"] : null;
            this.isRepeat = data["IsRepeat"] !== undefined ? data["IsRepeat"] : null;
            this.repeatEveryNDays = data["RepeatEveryNDays"] !== undefined ? data["RepeatEveryNDays"] : null;
            this.repeatEndDate = data["RepeatEndDate"] ? new Date(data["RepeatEndDate"].toString()) : null;
            this.durationMinutes = data["DurationMinutes"] !== undefined ? data["DurationMinutes"] : null;
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.updateByUserName = data["UpdateByUserName"] !== undefined ? data["UpdateByUserName"] : null;
        }
    }

    static fromJS(data: any): LobbyMaintenanceItemDao {
        return new LobbyMaintenanceItemDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["MaintenanceItemId"] = this.maintenanceItemId !== undefined ? this.maintenanceItemId : null;
        data["MaintenanceItemName"] = this.maintenanceItemName !== undefined ? this.maintenanceItemName : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["StartTime"] = this.startTime !== undefined ? this.startTime : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["EndTime"] = this.endTime !== undefined ? this.endTime : null;
        data["IsRepeat"] = this.isRepeat !== undefined ? this.isRepeat : null;
        data["RepeatEveryNDays"] = this.repeatEveryNDays !== undefined ? this.repeatEveryNDays : null;
        data["RepeatEndDate"] = this.repeatEndDate ? this.repeatEndDate.toISOString() : null;
        data["DurationMinutes"] = this.durationMinutes !== undefined ? this.durationMinutes : null;
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["UpdateByUserName"] = this.updateByUserName !== undefined ? this.updateByUserName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyMaintenanceItemDao(JSON.parse(json));
    }
}

export class LobbyMaintenanceItemAddRequest { 
    maintenanceItemId: number; 
    startDate: Date; 
    startTime: string; 
    endDate: Date; 
    endTime: string; 
    isRepeat: boolean; 
    repeatEveryNDays: number; 
    repeatEndDate: Date; 
    durationMinutes: number; 
    isEnable: boolean; 
    updateDate: Date; 
    updateBy: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.maintenanceItemId = data["MaintenanceItemId"] !== undefined ? data["MaintenanceItemId"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.startTime = data["StartTime"] !== undefined ? data["StartTime"] : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.endTime = data["EndTime"] !== undefined ? data["EndTime"] : null;
            this.isRepeat = data["IsRepeat"] !== undefined ? data["IsRepeat"] : null;
            this.repeatEveryNDays = data["RepeatEveryNDays"] !== undefined ? data["RepeatEveryNDays"] : null;
            this.repeatEndDate = data["RepeatEndDate"] ? new Date(data["RepeatEndDate"].toString()) : null;
            this.durationMinutes = data["DurationMinutes"] !== undefined ? data["DurationMinutes"] : null;
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
        }
    }

    static fromJS(data: any): LobbyMaintenanceItemAddRequest {
        return new LobbyMaintenanceItemAddRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["MaintenanceItemId"] = this.maintenanceItemId !== undefined ? this.maintenanceItemId : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["StartTime"] = this.startTime !== undefined ? this.startTime : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["EndTime"] = this.endTime !== undefined ? this.endTime : null;
        data["IsRepeat"] = this.isRepeat !== undefined ? this.isRepeat : null;
        data["RepeatEveryNDays"] = this.repeatEveryNDays !== undefined ? this.repeatEveryNDays : null;
        data["RepeatEndDate"] = this.repeatEndDate ? this.repeatEndDate.toISOString() : null;
        data["DurationMinutes"] = this.durationMinutes !== undefined ? this.durationMinutes : null;
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyMaintenanceItemAddRequest(JSON.parse(json));
    }
}

export class LobbyMaintenanceItemEditDao { 
    item: LobbyMaintenanceItemDao; 
    maintenanceItemOptions: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.item = data["Item"] ? LobbyMaintenanceItemDao.fromJS(data["Item"]) : null;
            if (data["MaintenanceItemOptions"] && data["MaintenanceItemOptions"].constructor === Array) {
                this.maintenanceItemOptions = [];
                for (let item of data["MaintenanceItemOptions"])
                    this.maintenanceItemOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyMaintenanceItemEditDao {
        return new LobbyMaintenanceItemEditDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Item"] = this.item ? this.item.toJS() : null;
        if (this.maintenanceItemOptions && this.maintenanceItemOptions.constructor === Array) {
            data["MaintenanceItemOptions"] = [];
            for (let item of this.maintenanceItemOptions)
                data["MaintenanceItemOptions"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyMaintenanceItemEditDao(JSON.parse(json));
    }
}

export class LobbyMaintenanceItemEditRequest { 
    lobbyMaintenanceItemId: number; 
    maintenanceItemId: number; 
    startDate: Date; 
    startTime: string; 
    endDate: Date; 
    endTime: string; 
    isRepeat: boolean; 
    repeatEveryNDays: number; 
    repeatEndDate: Date; 
    durationMinutes: number; 
    isEnable: boolean; 
    updateDate: Date; 
    updateBy: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyMaintenanceItemId = data["LobbyMaintenanceItemId"] !== undefined ? data["LobbyMaintenanceItemId"] : null;
            this.maintenanceItemId = data["MaintenanceItemId"] !== undefined ? data["MaintenanceItemId"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.startTime = data["StartTime"] !== undefined ? data["StartTime"] : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.endTime = data["EndTime"] !== undefined ? data["EndTime"] : null;
            this.isRepeat = data["IsRepeat"] !== undefined ? data["IsRepeat"] : null;
            this.repeatEveryNDays = data["RepeatEveryNDays"] !== undefined ? data["RepeatEveryNDays"] : null;
            this.repeatEndDate = data["RepeatEndDate"] ? new Date(data["RepeatEndDate"].toString()) : null;
            this.durationMinutes = data["DurationMinutes"] !== undefined ? data["DurationMinutes"] : null;
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
        }
    }

    static fromJS(data: any): LobbyMaintenanceItemEditRequest {
        return new LobbyMaintenanceItemEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyMaintenanceItemId"] = this.lobbyMaintenanceItemId !== undefined ? this.lobbyMaintenanceItemId : null;
        data["MaintenanceItemId"] = this.maintenanceItemId !== undefined ? this.maintenanceItemId : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["StartTime"] = this.startTime !== undefined ? this.startTime : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["EndTime"] = this.endTime !== undefined ? this.endTime : null;
        data["IsRepeat"] = this.isRepeat !== undefined ? this.isRepeat : null;
        data["RepeatEveryNDays"] = this.repeatEveryNDays !== undefined ? this.repeatEveryNDays : null;
        data["RepeatEndDate"] = this.repeatEndDate ? this.repeatEndDate.toISOString() : null;
        data["DurationMinutes"] = this.durationMinutes !== undefined ? this.durationMinutes : null;
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyMaintenanceItemEditRequest(JSON.parse(json));
    }
}

export class LobbyNoticeItemSimple { 
    id: number; 
    noticeTypeName: string; 
    content: string; 
    description: string; 
    publishDate: Date; 
    updateDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.noticeTypeName = data["NoticeTypeName"] !== undefined ? data["NoticeTypeName"] : null;
            this.content = data["Content"] !== undefined ? data["Content"] : null;
            this.description = data["Description"] !== undefined ? data["Description"] : null;
            this.publishDate = data["PublishDate"] ? new Date(data["PublishDate"].toString()) : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
        }
    }

    static fromJS(data: any): LobbyNoticeItemSimple {
        return new LobbyNoticeItemSimple(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["NoticeTypeName"] = this.noticeTypeName !== undefined ? this.noticeTypeName : null;
        data["Content"] = this.content !== undefined ? this.content : null;
        data["Description"] = this.description !== undefined ? this.description : null;
        data["PublishDate"] = this.publishDate ? this.publishDate.toISOString() : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyNoticeItemSimple(JSON.parse(json));
    }
}

export class NoticeTypeSelectionResponse { 
    lobbyNoticeTypeSelectionOption: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["LobbyNoticeTypeSelectionOption"] && data["LobbyNoticeTypeSelectionOption"].constructor === Array) {
                this.lobbyNoticeTypeSelectionOption = [];
                for (let item of data["LobbyNoticeTypeSelectionOption"])
                    this.lobbyNoticeTypeSelectionOption.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NoticeTypeSelectionResponse {
        return new NoticeTypeSelectionResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.lobbyNoticeTypeSelectionOption && this.lobbyNoticeTypeSelectionOption.constructor === Array) {
            data["LobbyNoticeTypeSelectionOption"] = [];
            for (let item of this.lobbyNoticeTypeSelectionOption)
                data["LobbyNoticeTypeSelectionOption"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new NoticeTypeSelectionResponse(JSON.parse(json));
    }
}

export class LobbyNoticeForCreateRequest { 
    lobbyId: number; 
    noticeTypeId: number; 
    translations: LobbyNoticeLanguageTranslation[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.noticeTypeId = data["NoticeTypeId"] !== undefined ? data["NoticeTypeId"] : null;
            if (data["Translations"] && data["Translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["Translations"])
                    this.translations.push(LobbyNoticeLanguageTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyNoticeForCreateRequest {
        return new LobbyNoticeForCreateRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["NoticeTypeId"] = this.noticeTypeId !== undefined ? this.noticeTypeId : null;
        if (this.translations && this.translations.constructor === Array) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyNoticeForCreateRequest(JSON.parse(json));
    }
}

export class LobbyNoticeLanguageTranslation { 
    id: number; 
    name: string; 
    description: string; 
    languageId: number; 
    languageName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.description = data["Description"] !== undefined ? data["Description"] : null;
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.languageName = data["LanguageName"] !== undefined ? data["LanguageName"] : null;
        }
    }

    static fromJS(data: any): LobbyNoticeLanguageTranslation {
        return new LobbyNoticeLanguageTranslation(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["Description"] = this.description !== undefined ? this.description : null;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["LanguageName"] = this.languageName !== undefined ? this.languageName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyNoticeLanguageTranslation(JSON.parse(json));
    }
}

export class LobbyNoticeItem { 
    id: number; 
    noticeTypeId: number; 
    noticeTypeName: string; 
    description: string; 
    translation: LobbyNoticeLanguageTranslation[]; 
    publishDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.noticeTypeId = data["NoticeTypeId"] !== undefined ? data["NoticeTypeId"] : null;
            this.noticeTypeName = data["NoticeTypeName"] !== undefined ? data["NoticeTypeName"] : null;
            this.description = data["Description"] !== undefined ? data["Description"] : null;
            if (data["Translation"] && data["Translation"].constructor === Array) {
                this.translation = [];
                for (let item of data["Translation"])
                    this.translation.push(LobbyNoticeLanguageTranslation.fromJS(item));
            }
            this.publishDate = data["PublishDate"] ? new Date(data["PublishDate"].toString()) : null;
        }
    }

    static fromJS(data: any): LobbyNoticeItem {
        return new LobbyNoticeItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["NoticeTypeId"] = this.noticeTypeId !== undefined ? this.noticeTypeId : null;
        data["NoticeTypeName"] = this.noticeTypeName !== undefined ? this.noticeTypeName : null;
        data["Description"] = this.description !== undefined ? this.description : null;
        if (this.translation && this.translation.constructor === Array) {
            data["Translation"] = [];
            for (let item of this.translation)
                data["Translation"].push(item.toJS());
        }
        data["PublishDate"] = this.publishDate ? this.publishDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyNoticeItem(JSON.parse(json));
    }
}

export class LobbyNoticeForEditRequest { 
    lobbyNoticeId: number; 
    lobbyId: number; 
    noticeTypeId: number; 
    translations: LobbyNoticeLanguageTranslation[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyNoticeId = data["LobbyNoticeId"] !== undefined ? data["LobbyNoticeId"] : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.noticeTypeId = data["NoticeTypeId"] !== undefined ? data["NoticeTypeId"] : null;
            if (data["Translations"] && data["Translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["Translations"])
                    this.translations.push(LobbyNoticeLanguageTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyNoticeForEditRequest {
        return new LobbyNoticeForEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyNoticeId"] = this.lobbyNoticeId !== undefined ? this.lobbyNoticeId : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["NoticeTypeId"] = this.noticeTypeId !== undefined ? this.noticeTypeId : null;
        if (this.translations && this.translations.constructor === Array) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyNoticeForEditRequest(JSON.parse(json));
    }
}

export class LobbyPlayerGroupDao { 
    id: number; 
    name: string; 
    playersInGroup: number; 
    isDelete: boolean; 
    groupNo: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.playersInGroup = data["PlayersInGroup"] !== undefined ? data["PlayersInGroup"] : null;
            this.isDelete = data["IsDelete"] !== undefined ? data["IsDelete"] : null;
            this.groupNo = data["GroupNo"] !== undefined ? data["GroupNo"] : null;
        }
    }

    static fromJS(data: any): LobbyPlayerGroupDao {
        return new LobbyPlayerGroupDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["PlayersInGroup"] = this.playersInGroup !== undefined ? this.playersInGroup : null;
        data["IsDelete"] = this.isDelete !== undefined ? this.isDelete : null;
        data["GroupNo"] = this.groupNo !== undefined ? this.groupNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerGroupDao(JSON.parse(json));
    }
}

export class LobbyPlayerGroupRequest { 
    lobbyId: number; 
    name: string; 
    groupNo: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["lobbyId"] !== undefined ? data["lobbyId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.groupNo = data["GroupNo"] !== undefined ? data["GroupNo"] : null;
        }
    }

    static fromJS(data: any): LobbyPlayerGroupRequest {
        return new LobbyPlayerGroupRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["lobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["GroupNo"] = this.groupNo !== undefined ? this.groupNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerGroupRequest(JSON.parse(json));
    }
}

export class LobbyPlayerGroupEditResponse { 
    id: number; 
    name: string; 
    groupNo: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.groupNo = data["GroupNo"] !== undefined ? data["GroupNo"] : null;
        }
    }

    static fromJS(data: any): LobbyPlayerGroupEditResponse {
        return new LobbyPlayerGroupEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["GroupNo"] = this.groupNo !== undefined ? this.groupNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerGroupEditResponse(JSON.parse(json));
    }
}

export class LobbyPlayerGroupEditRequest { 
    lobbyPlayerGroupId: number; 
    name: string; 
    groupNo: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPlayerGroupId = data["LobbyPlayerGroupId"] !== undefined ? data["LobbyPlayerGroupId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.groupNo = data["GroupNo"] !== undefined ? data["GroupNo"] : null;
        }
    }

    static fromJS(data: any): LobbyPlayerGroupEditRequest {
        return new LobbyPlayerGroupEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPlayerGroupId"] = this.lobbyPlayerGroupId !== undefined ? this.lobbyPlayerGroupId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["GroupNo"] = this.groupNo !== undefined ? this.groupNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerGroupEditRequest(JSON.parse(json));
    }
}

export class LobbyPlayerLevelDao { 
    id: number; 
    name: string; 
    playersInLevel: number; 
    isDefault: boolean; 
    isDelete: boolean; 
    daliyWithdrawTimes: number; 
    daliyWithdrawLimit: number; 
    minWithdrawLimit: number; 
    maxWithdrawLimit: number; 
    levelNo: string; 
    isCheckRequiredValidBetMultiple: boolean; 
    minDepositLimit: number; 
    maxDepositLimit: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.playersInLevel = data["PlayersInLevel"] !== undefined ? data["PlayersInLevel"] : null;
            this.isDefault = data["IsDefault"] !== undefined ? data["IsDefault"] : null;
            this.isDelete = data["IsDelete"] !== undefined ? data["IsDelete"] : null;
            this.daliyWithdrawTimes = data["DaliyWithdrawTimes"] !== undefined ? data["DaliyWithdrawTimes"] : null;
            this.daliyWithdrawLimit = data["DaliyWithdrawLimit"] !== undefined ? data["DaliyWithdrawLimit"] : null;
            this.minWithdrawLimit = data["MinWithdrawLimit"] !== undefined ? data["MinWithdrawLimit"] : null;
            this.maxWithdrawLimit = data["MaxWithdrawLimit"] !== undefined ? data["MaxWithdrawLimit"] : null;
            this.levelNo = data["LevelNo"] !== undefined ? data["LevelNo"] : null;
            this.isCheckRequiredValidBetMultiple = data["IsCheckRequiredValidBetMultiple"] !== undefined ? data["IsCheckRequiredValidBetMultiple"] : null;
            this.minDepositLimit = data["MinDepositLimit"] !== undefined ? data["MinDepositLimit"] : null;
            this.maxDepositLimit = data["MaxDepositLimit"] !== undefined ? data["MaxDepositLimit"] : null;
        }
    }

    static fromJS(data: any): LobbyPlayerLevelDao {
        return new LobbyPlayerLevelDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["PlayersInLevel"] = this.playersInLevel !== undefined ? this.playersInLevel : null;
        data["IsDefault"] = this.isDefault !== undefined ? this.isDefault : null;
        data["IsDelete"] = this.isDelete !== undefined ? this.isDelete : null;
        data["DaliyWithdrawTimes"] = this.daliyWithdrawTimes !== undefined ? this.daliyWithdrawTimes : null;
        data["DaliyWithdrawLimit"] = this.daliyWithdrawLimit !== undefined ? this.daliyWithdrawLimit : null;
        data["MinWithdrawLimit"] = this.minWithdrawLimit !== undefined ? this.minWithdrawLimit : null;
        data["MaxWithdrawLimit"] = this.maxWithdrawLimit !== undefined ? this.maxWithdrawLimit : null;
        data["LevelNo"] = this.levelNo !== undefined ? this.levelNo : null;
        data["IsCheckRequiredValidBetMultiple"] = this.isCheckRequiredValidBetMultiple !== undefined ? this.isCheckRequiredValidBetMultiple : null;
        data["MinDepositLimit"] = this.minDepositLimit !== undefined ? this.minDepositLimit : null;
        data["MaxDepositLimit"] = this.maxDepositLimit !== undefined ? this.maxDepositLimit : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerLevelDao(JSON.parse(json));
    }
}

export class LobbyPlayerLevelForCreateRequest { 
    lobbyId: number; 
    translations: LobbyPlayerLevelLanguageTranslation[]; 
    daliyWithdrawTimes: number; 
    daliyWithdrawLimit: number; 
    minWithdrawLimit: number; 
    maxWithdrawLimit: number; 
    levelNo: string; 
    isCheckRequiredValidBetMultiple: boolean; 
    minDepositLimit: number; 
    maxDepositLimit: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            if (data["Translations"] && data["Translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["Translations"])
                    this.translations.push(LobbyPlayerLevelLanguageTranslation.fromJS(item));
            }
            this.daliyWithdrawTimes = data["DaliyWithdrawTimes"] !== undefined ? data["DaliyWithdrawTimes"] : null;
            this.daliyWithdrawLimit = data["DaliyWithdrawLimit"] !== undefined ? data["DaliyWithdrawLimit"] : null;
            this.minWithdrawLimit = data["MinWithdrawLimit"] !== undefined ? data["MinWithdrawLimit"] : null;
            this.maxWithdrawLimit = data["MaxWithdrawLimit"] !== undefined ? data["MaxWithdrawLimit"] : null;
            this.levelNo = data["LevelNo"] !== undefined ? data["LevelNo"] : null;
            this.isCheckRequiredValidBetMultiple = data["IsCheckRequiredValidBetMultiple"] !== undefined ? data["IsCheckRequiredValidBetMultiple"] : null;
            this.minDepositLimit = data["MinDepositLimit"] !== undefined ? data["MinDepositLimit"] : null;
            this.maxDepositLimit = data["MaxDepositLimit"] !== undefined ? data["MaxDepositLimit"] : null;
        }
    }

    static fromJS(data: any): LobbyPlayerLevelForCreateRequest {
        return new LobbyPlayerLevelForCreateRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        if (this.translations && this.translations.constructor === Array) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item.toJS());
        }
        data["DaliyWithdrawTimes"] = this.daliyWithdrawTimes !== undefined ? this.daliyWithdrawTimes : null;
        data["DaliyWithdrawLimit"] = this.daliyWithdrawLimit !== undefined ? this.daliyWithdrawLimit : null;
        data["MinWithdrawLimit"] = this.minWithdrawLimit !== undefined ? this.minWithdrawLimit : null;
        data["MaxWithdrawLimit"] = this.maxWithdrawLimit !== undefined ? this.maxWithdrawLimit : null;
        data["LevelNo"] = this.levelNo !== undefined ? this.levelNo : null;
        data["IsCheckRequiredValidBetMultiple"] = this.isCheckRequiredValidBetMultiple !== undefined ? this.isCheckRequiredValidBetMultiple : null;
        data["MinDepositLimit"] = this.minDepositLimit !== undefined ? this.minDepositLimit : null;
        data["MaxDepositLimit"] = this.maxDepositLimit !== undefined ? this.maxDepositLimit : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerLevelForCreateRequest(JSON.parse(json));
    }
}

export class LobbyPlayerLevelLanguageTranslation { 
    id: number; 
    name: string; 
    languageId: number; 
    languageName: string; 
    imagePath: string; 
    daliyWithdrawTimes: number; 
    daliyWithdrawLimit: number; 
    minWithdrawLimit: number; 
    maxWithdrawLimit: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.languageName = data["LanguageName"] !== undefined ? data["LanguageName"] : null;
            this.imagePath = data["ImagePath"] !== undefined ? data["ImagePath"] : null;
            this.daliyWithdrawTimes = data["DaliyWithdrawTimes"] !== undefined ? data["DaliyWithdrawTimes"] : null;
            this.daliyWithdrawLimit = data["DaliyWithdrawLimit"] !== undefined ? data["DaliyWithdrawLimit"] : null;
            this.minWithdrawLimit = data["MinWithdrawLimit"] !== undefined ? data["MinWithdrawLimit"] : null;
            this.maxWithdrawLimit = data["MaxWithdrawLimit"] !== undefined ? data["MaxWithdrawLimit"] : null;
        }
    }

    static fromJS(data: any): LobbyPlayerLevelLanguageTranslation {
        return new LobbyPlayerLevelLanguageTranslation(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["LanguageName"] = this.languageName !== undefined ? this.languageName : null;
        data["ImagePath"] = this.imagePath !== undefined ? this.imagePath : null;
        data["DaliyWithdrawTimes"] = this.daliyWithdrawTimes !== undefined ? this.daliyWithdrawTimes : null;
        data["DaliyWithdrawLimit"] = this.daliyWithdrawLimit !== undefined ? this.daliyWithdrawLimit : null;
        data["MinWithdrawLimit"] = this.minWithdrawLimit !== undefined ? this.minWithdrawLimit : null;
        data["MaxWithdrawLimit"] = this.maxWithdrawLimit !== undefined ? this.maxWithdrawLimit : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerLevelLanguageTranslation(JSON.parse(json));
    }
}

export class LobbyPlayerLevelEditItem { 
    id: number; 
    daliyWithdrawTimes: number; 
    daliyWithdrawLimit: number; 
    minWithdrawLimit: number; 
    maxWithdrawLimit: number; 
    levelNo: string; 
    isCheckRequiredValidBetMultiple: boolean; 
    minDepositLimit: number; 
    maxDepositLimit: number; 
    translation: LobbyPlayerLevelLanguageTranslation[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.daliyWithdrawTimes = data["DaliyWithdrawTimes"] !== undefined ? data["DaliyWithdrawTimes"] : null;
            this.daliyWithdrawLimit = data["DaliyWithdrawLimit"] !== undefined ? data["DaliyWithdrawLimit"] : null;
            this.minWithdrawLimit = data["MinWithdrawLimit"] !== undefined ? data["MinWithdrawLimit"] : null;
            this.maxWithdrawLimit = data["MaxWithdrawLimit"] !== undefined ? data["MaxWithdrawLimit"] : null;
            this.levelNo = data["LevelNo"] !== undefined ? data["LevelNo"] : null;
            this.isCheckRequiredValidBetMultiple = data["IsCheckRequiredValidBetMultiple"] !== undefined ? data["IsCheckRequiredValidBetMultiple"] : null;
            this.minDepositLimit = data["MinDepositLimit"] !== undefined ? data["MinDepositLimit"] : null;
            this.maxDepositLimit = data["MaxDepositLimit"] !== undefined ? data["MaxDepositLimit"] : null;
            if (data["Translation"] && data["Translation"].constructor === Array) {
                this.translation = [];
                for (let item of data["Translation"])
                    this.translation.push(LobbyPlayerLevelLanguageTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyPlayerLevelEditItem {
        return new LobbyPlayerLevelEditItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["DaliyWithdrawTimes"] = this.daliyWithdrawTimes !== undefined ? this.daliyWithdrawTimes : null;
        data["DaliyWithdrawLimit"] = this.daliyWithdrawLimit !== undefined ? this.daliyWithdrawLimit : null;
        data["MinWithdrawLimit"] = this.minWithdrawLimit !== undefined ? this.minWithdrawLimit : null;
        data["MaxWithdrawLimit"] = this.maxWithdrawLimit !== undefined ? this.maxWithdrawLimit : null;
        data["LevelNo"] = this.levelNo !== undefined ? this.levelNo : null;
        data["IsCheckRequiredValidBetMultiple"] = this.isCheckRequiredValidBetMultiple !== undefined ? this.isCheckRequiredValidBetMultiple : null;
        data["MinDepositLimit"] = this.minDepositLimit !== undefined ? this.minDepositLimit : null;
        data["MaxDepositLimit"] = this.maxDepositLimit !== undefined ? this.maxDepositLimit : null;
        if (this.translation && this.translation.constructor === Array) {
            data["Translation"] = [];
            for (let item of this.translation)
                data["Translation"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerLevelEditItem(JSON.parse(json));
    }
}

export class LobbyPlayerLevelForEditRequest { 
    lobbyPlayerLevelId: number; 
    lobbyId: number; 
    translations: LobbyPlayerLevelLanguageTranslation[]; 
    daliyWithdrawTimes: number; 
    daliyWithdrawLimit: number; 
    minWithdrawLimit: number; 
    maxWithdrawLimit: number; 
    levelNo: string; 
    isCheckRequiredValidBetMultiple: boolean; 
    minDepositLimit: number; 
    maxDepositLimit: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPlayerLevelId = data["LobbyPlayerLevelId"] !== undefined ? data["LobbyPlayerLevelId"] : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            if (data["Translations"] && data["Translations"].constructor === Array) {
                this.translations = [];
                for (let item of data["Translations"])
                    this.translations.push(LobbyPlayerLevelLanguageTranslation.fromJS(item));
            }
            this.daliyWithdrawTimes = data["DaliyWithdrawTimes"] !== undefined ? data["DaliyWithdrawTimes"] : null;
            this.daliyWithdrawLimit = data["DaliyWithdrawLimit"] !== undefined ? data["DaliyWithdrawLimit"] : null;
            this.minWithdrawLimit = data["MinWithdrawLimit"] !== undefined ? data["MinWithdrawLimit"] : null;
            this.maxWithdrawLimit = data["MaxWithdrawLimit"] !== undefined ? data["MaxWithdrawLimit"] : null;
            this.levelNo = data["LevelNo"] !== undefined ? data["LevelNo"] : null;
            this.isCheckRequiredValidBetMultiple = data["IsCheckRequiredValidBetMultiple"] !== undefined ? data["IsCheckRequiredValidBetMultiple"] : null;
            this.minDepositLimit = data["MinDepositLimit"] !== undefined ? data["MinDepositLimit"] : null;
            this.maxDepositLimit = data["MaxDepositLimit"] !== undefined ? data["MaxDepositLimit"] : null;
        }
    }

    static fromJS(data: any): LobbyPlayerLevelForEditRequest {
        return new LobbyPlayerLevelForEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPlayerLevelId"] = this.lobbyPlayerLevelId !== undefined ? this.lobbyPlayerLevelId : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        if (this.translations && this.translations.constructor === Array) {
            data["Translations"] = [];
            for (let item of this.translations)
                data["Translations"].push(item.toJS());
        }
        data["DaliyWithdrawTimes"] = this.daliyWithdrawTimes !== undefined ? this.daliyWithdrawTimes : null;
        data["DaliyWithdrawLimit"] = this.daliyWithdrawLimit !== undefined ? this.daliyWithdrawLimit : null;
        data["MinWithdrawLimit"] = this.minWithdrawLimit !== undefined ? this.minWithdrawLimit : null;
        data["MaxWithdrawLimit"] = this.maxWithdrawLimit !== undefined ? this.maxWithdrawLimit : null;
        data["LevelNo"] = this.levelNo !== undefined ? this.levelNo : null;
        data["IsCheckRequiredValidBetMultiple"] = this.isCheckRequiredValidBetMultiple !== undefined ? this.isCheckRequiredValidBetMultiple : null;
        data["MinDepositLimit"] = this.minDepositLimit !== undefined ? this.minDepositLimit : null;
        data["MaxDepositLimit"] = this.maxDepositLimit !== undefined ? this.maxDepositLimit : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerLevelForEditRequest(JSON.parse(json));
    }
}

export class LobbyPlayerPayoutItem { 
    lobbyPlayerPayoutId: number; 
    playerName: string; 
    betAmount: number; 
    payoutAmount: number; 
    gameDevId: GameDevId; 
    lobbyEGameId: number; 
    gameName: string; 
    playerAmountRecordGameTypeId: PlayerAmountRecordGameTypeId; 
    gameTypeTranslateString: string; 
    updateDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPlayerPayoutId = data["LobbyPlayerPayoutId"] !== undefined ? data["LobbyPlayerPayoutId"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.betAmount = data["BetAmount"] !== undefined ? data["BetAmount"] : null;
            this.payoutAmount = data["PayoutAmount"] !== undefined ? data["PayoutAmount"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.lobbyEGameId = data["LobbyEGameId"] !== undefined ? data["LobbyEGameId"] : null;
            this.gameName = data["GameName"] !== undefined ? data["GameName"] : null;
            this.playerAmountRecordGameTypeId = data["PlayerAmountRecordGameTypeId"] !== undefined ? data["PlayerAmountRecordGameTypeId"] : null;
            this.gameTypeTranslateString = data["GameTypeTranslateString"] !== undefined ? data["GameTypeTranslateString"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
        }
    }

    static fromJS(data: any): LobbyPlayerPayoutItem {
        return new LobbyPlayerPayoutItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPlayerPayoutId"] = this.lobbyPlayerPayoutId !== undefined ? this.lobbyPlayerPayoutId : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["BetAmount"] = this.betAmount !== undefined ? this.betAmount : null;
        data["PayoutAmount"] = this.payoutAmount !== undefined ? this.payoutAmount : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["LobbyEGameId"] = this.lobbyEGameId !== undefined ? this.lobbyEGameId : null;
        data["GameName"] = this.gameName !== undefined ? this.gameName : null;
        data["PlayerAmountRecordGameTypeId"] = this.playerAmountRecordGameTypeId !== undefined ? this.playerAmountRecordGameTypeId : null;
        data["GameTypeTranslateString"] = this.gameTypeTranslateString !== undefined ? this.gameTypeTranslateString : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerPayoutItem(JSON.parse(json));
    }
}

export class LobbyPlayerPayoutGetForAddResponse { 
    lobbyEGame_GameDevOptions: SelectionOption[]; 
    lobbyGameDev_GameDevOptions: SelectionOption[]; 
    playerAmountRecordGameTypeOptions: SelectionOption[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["LobbyEGame_GameDevOptions"] && data["LobbyEGame_GameDevOptions"].constructor === Array) {
                this.lobbyEGame_GameDevOptions = [];
                for (let item of data["LobbyEGame_GameDevOptions"])
                    this.lobbyEGame_GameDevOptions.push(SelectionOption.fromJS(item));
            }
            if (data["LobbyGameDev_GameDevOptions"] && data["LobbyGameDev_GameDevOptions"].constructor === Array) {
                this.lobbyGameDev_GameDevOptions = [];
                for (let item of data["LobbyGameDev_GameDevOptions"])
                    this.lobbyGameDev_GameDevOptions.push(SelectionOption.fromJS(item));
            }
            if (data["PlayerAmountRecordGameTypeOptions"] && data["PlayerAmountRecordGameTypeOptions"].constructor === Array) {
                this.playerAmountRecordGameTypeOptions = [];
                for (let item of data["PlayerAmountRecordGameTypeOptions"])
                    this.playerAmountRecordGameTypeOptions.push(SelectionOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyPlayerPayoutGetForAddResponse {
        return new LobbyPlayerPayoutGetForAddResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.lobbyEGame_GameDevOptions && this.lobbyEGame_GameDevOptions.constructor === Array) {
            data["LobbyEGame_GameDevOptions"] = [];
            for (let item of this.lobbyEGame_GameDevOptions)
                data["LobbyEGame_GameDevOptions"].push(item.toJS());
        }
        if (this.lobbyGameDev_GameDevOptions && this.lobbyGameDev_GameDevOptions.constructor === Array) {
            data["LobbyGameDev_GameDevOptions"] = [];
            for (let item of this.lobbyGameDev_GameDevOptions)
                data["LobbyGameDev_GameDevOptions"].push(item.toJS());
        }
        if (this.playerAmountRecordGameTypeOptions && this.playerAmountRecordGameTypeOptions.constructor === Array) {
            data["PlayerAmountRecordGameTypeOptions"] = [];
            for (let item of this.playerAmountRecordGameTypeOptions)
                data["PlayerAmountRecordGameTypeOptions"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerPayoutGetForAddResponse(JSON.parse(json));
    }
}

export class SelectionOption { 
    value: string; 
    label: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.value = data["Value"] !== undefined ? data["Value"] : null;
            this.label = data["Label"] !== undefined ? data["Label"] : null;
        }
    }

    static fromJS(data: any): SelectionOption {
        return new SelectionOption(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Value"] = this.value !== undefined ? this.value : null;
        data["Label"] = this.label !== undefined ? this.label : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SelectionOption(JSON.parse(json));
    }
}

export class LobbyPlayerPayoutAddRequest { 
    lobbyId: LobbyId; 
    playerName: string; 
    betAmount: number; 
    payoutAmount: number; 
    gameDevId: GameDevId; 
    lobbyEGameId: number; 
    playerAmountRecordGameTypeId: PlayerAmountRecordGameTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.betAmount = data["BetAmount"] !== undefined ? data["BetAmount"] : null;
            this.payoutAmount = data["PayoutAmount"] !== undefined ? data["PayoutAmount"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.lobbyEGameId = data["LobbyEGameId"] !== undefined ? data["LobbyEGameId"] : null;
            this.playerAmountRecordGameTypeId = data["PlayerAmountRecordGameTypeId"] !== undefined ? data["PlayerAmountRecordGameTypeId"] : null;
        }
    }

    static fromJS(data: any): LobbyPlayerPayoutAddRequest {
        return new LobbyPlayerPayoutAddRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["BetAmount"] = this.betAmount !== undefined ? this.betAmount : null;
        data["PayoutAmount"] = this.payoutAmount !== undefined ? this.payoutAmount : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["LobbyEGameId"] = this.lobbyEGameId !== undefined ? this.lobbyEGameId : null;
        data["PlayerAmountRecordGameTypeId"] = this.playerAmountRecordGameTypeId !== undefined ? this.playerAmountRecordGameTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerPayoutAddRequest(JSON.parse(json));
    }
}

export class LobbyPlayerPayoutGetForEditResponse { 
    lobbyPlayerPayoutItem: LobbyPlayerPayoutItem; 
    lobbyEGame_GameDevOptions: SelectionOption[]; 
    lobbyGameDev_GameDevOptions: SelectionOption[]; 
    lobbyEGameOptions: SelectionOption[]; 
    playerAmountRecordGameTypeOptions: SelectionOption[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPlayerPayoutItem = data["LobbyPlayerPayoutItem"] ? LobbyPlayerPayoutItem.fromJS(data["LobbyPlayerPayoutItem"]) : null;
            if (data["LobbyEGame_GameDevOptions"] && data["LobbyEGame_GameDevOptions"].constructor === Array) {
                this.lobbyEGame_GameDevOptions = [];
                for (let item of data["LobbyEGame_GameDevOptions"])
                    this.lobbyEGame_GameDevOptions.push(SelectionOption.fromJS(item));
            }
            if (data["LobbyGameDev_GameDevOptions"] && data["LobbyGameDev_GameDevOptions"].constructor === Array) {
                this.lobbyGameDev_GameDevOptions = [];
                for (let item of data["LobbyGameDev_GameDevOptions"])
                    this.lobbyGameDev_GameDevOptions.push(SelectionOption.fromJS(item));
            }
            if (data["LobbyEGameOptions"] && data["LobbyEGameOptions"].constructor === Array) {
                this.lobbyEGameOptions = [];
                for (let item of data["LobbyEGameOptions"])
                    this.lobbyEGameOptions.push(SelectionOption.fromJS(item));
            }
            if (data["PlayerAmountRecordGameTypeOptions"] && data["PlayerAmountRecordGameTypeOptions"].constructor === Array) {
                this.playerAmountRecordGameTypeOptions = [];
                for (let item of data["PlayerAmountRecordGameTypeOptions"])
                    this.playerAmountRecordGameTypeOptions.push(SelectionOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbyPlayerPayoutGetForEditResponse {
        return new LobbyPlayerPayoutGetForEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPlayerPayoutItem"] = this.lobbyPlayerPayoutItem ? this.lobbyPlayerPayoutItem.toJS() : null;
        if (this.lobbyEGame_GameDevOptions && this.lobbyEGame_GameDevOptions.constructor === Array) {
            data["LobbyEGame_GameDevOptions"] = [];
            for (let item of this.lobbyEGame_GameDevOptions)
                data["LobbyEGame_GameDevOptions"].push(item.toJS());
        }
        if (this.lobbyGameDev_GameDevOptions && this.lobbyGameDev_GameDevOptions.constructor === Array) {
            data["LobbyGameDev_GameDevOptions"] = [];
            for (let item of this.lobbyGameDev_GameDevOptions)
                data["LobbyGameDev_GameDevOptions"].push(item.toJS());
        }
        if (this.lobbyEGameOptions && this.lobbyEGameOptions.constructor === Array) {
            data["LobbyEGameOptions"] = [];
            for (let item of this.lobbyEGameOptions)
                data["LobbyEGameOptions"].push(item.toJS());
        }
        if (this.playerAmountRecordGameTypeOptions && this.playerAmountRecordGameTypeOptions.constructor === Array) {
            data["PlayerAmountRecordGameTypeOptions"] = [];
            for (let item of this.playerAmountRecordGameTypeOptions)
                data["PlayerAmountRecordGameTypeOptions"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerPayoutGetForEditResponse(JSON.parse(json));
    }
}

export class LobbyPlayerPayoutEditRequest { 
    lobbyPlayerPayoutId: number; 
    lobbyId: LobbyId; 
    playerName: string; 
    betAmount: number; 
    payoutAmount: number; 
    gameDevId: GameDevId; 
    lobbyEGameId: number; 
    playerAmountRecordGameTypeId: PlayerAmountRecordGameTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPlayerPayoutId = data["LobbyPlayerPayoutId"] !== undefined ? data["LobbyPlayerPayoutId"] : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.betAmount = data["BetAmount"] !== undefined ? data["BetAmount"] : null;
            this.payoutAmount = data["PayoutAmount"] !== undefined ? data["PayoutAmount"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.lobbyEGameId = data["LobbyEGameId"] !== undefined ? data["LobbyEGameId"] : null;
            this.playerAmountRecordGameTypeId = data["PlayerAmountRecordGameTypeId"] !== undefined ? data["PlayerAmountRecordGameTypeId"] : null;
        }
    }

    static fromJS(data: any): LobbyPlayerPayoutEditRequest {
        return new LobbyPlayerPayoutEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPlayerPayoutId"] = this.lobbyPlayerPayoutId !== undefined ? this.lobbyPlayerPayoutId : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["BetAmount"] = this.betAmount !== undefined ? this.betAmount : null;
        data["PayoutAmount"] = this.payoutAmount !== undefined ? this.payoutAmount : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["LobbyEGameId"] = this.lobbyEGameId !== undefined ? this.lobbyEGameId : null;
        data["PlayerAmountRecordGameTypeId"] = this.playerAmountRecordGameTypeId !== undefined ? this.playerAmountRecordGameTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerPayoutEditRequest(JSON.parse(json));
    }
}

export class GetPublishedRespones { 
    id: number; 
    name: string; 
    maxAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.maxAmount = data["MaxAmount"] !== undefined ? data["MaxAmount"] : null;
        }
    }

    static fromJS(data: any): GetPublishedRespones {
        return new GetPublishedRespones(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["MaxAmount"] = this.maxAmount !== undefined ? this.maxAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetPublishedRespones(JSON.parse(json));
    }
}

export class GetChoiceablePromotionRespones { 
    lobbyPromotionId: number; 
    name: string; 
    autoPromotionId: AutoPromotionId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.autoPromotionId = data["AutoPromotionId"] !== undefined ? data["AutoPromotionId"] : null;
        }
    }

    static fromJS(data: any): GetChoiceablePromotionRespones {
        return new GetChoiceablePromotionRespones(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["AutoPromotionId"] = this.autoPromotionId !== undefined ? this.autoPromotionId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetChoiceablePromotionRespones(JSON.parse(json));
    }
}

export class GetManualGiveOutRequest { 
    autoPromotionTypeId: AutoPromotionTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.autoPromotionTypeId = data["AutoPromotionTypeId"] !== undefined ? data["AutoPromotionTypeId"] : null;
        }
    }

    static fromJS(data: any): GetManualGiveOutRequest {
        return new GetManualGiveOutRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["AutoPromotionTypeId"] = this.autoPromotionTypeId !== undefined ? this.autoPromotionTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetManualGiveOutRequest(JSON.parse(json));
    }
}

export enum AutoPromotionTypeId {
    Deposit = 1, 
    Login = 2, 
    Card = 3, 
    Other = 4, 
    Register = 5, 
    Withdraw = 6, 
    AddBankCard = 7, 
    PurchaseDiscount = 8, 
    ManualApplied = 9, 
    Mission = 10, 
}

export class StandardResultOfGetManualGiveOutResponse { 
    isSuccess: boolean; 
    payload: GetManualGiveOutResponse; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            this.payload = data["Payload"] ? GetManualGiveOutResponse.fromJS(data["Payload"]) : null;
            if (data["Errors"] && data["Errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["Errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResultOfGetManualGiveOutResponse {
        return new StandardResultOfGetManualGiveOutResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["Payload"] = this.payload ? this.payload.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResultOfGetManualGiveOutResponse(JSON.parse(json));
    }
}

export class GetManualGiveOutResponse { 
    optionsList: CmsSelectionOptionDao[]; 
    estimateMethodList: EstimateMethodIdMap[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["OptionsList"] && data["OptionsList"].constructor === Array) {
                this.optionsList = [];
                for (let item of data["OptionsList"])
                    this.optionsList.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["EstimateMethodList"] && data["EstimateMethodList"].constructor === Array) {
                this.estimateMethodList = [];
                for (let item of data["EstimateMethodList"])
                    this.estimateMethodList.push(EstimateMethodIdMap.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetManualGiveOutResponse {
        return new GetManualGiveOutResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.optionsList && this.optionsList.constructor === Array) {
            data["OptionsList"] = [];
            for (let item of this.optionsList)
                data["OptionsList"].push(item.toJS());
        }
        if (this.estimateMethodList && this.estimateMethodList.constructor === Array) {
            data["EstimateMethodList"] = [];
            for (let item of this.estimateMethodList)
                data["EstimateMethodList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetManualGiveOutResponse(JSON.parse(json));
    }
}

export class EstimateMethodIdMap { 
    promotionId: string; 
    autoPromotionEstimateMethodId: AutoPromotionEstimateMethodId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.promotionId = data["PromotionId"] !== undefined ? data["PromotionId"] : null;
            this.autoPromotionEstimateMethodId = data["AutoPromotionEstimateMethodId"] !== undefined ? data["AutoPromotionEstimateMethodId"] : null;
        }
    }

    static fromJS(data: any): EstimateMethodIdMap {
        return new EstimateMethodIdMap(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PromotionId"] = this.promotionId !== undefined ? this.promotionId : null;
        data["AutoPromotionEstimateMethodId"] = this.autoPromotionEstimateMethodId !== undefined ? this.autoPromotionEstimateMethodId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new EstimateMethodIdMap(JSON.parse(json));
    }
}

export enum AutoPromotionEstimateMethodId {
    BetsWinLoseInDateRange = 1, 
    SingleBetRecordWinLose = 2, 
}

export class LPR_GetSummaryRequest { 
    lobbyId: number; 
    startDate: Date; 
    endDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
        }
    }

    static fromJS(data: any): LPR_GetSummaryRequest {
        return new LPR_GetSummaryRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPR_GetSummaryRequest(JSON.parse(json));
    }
}

export class LPR_GetSummaryResponse { 
    playerCount: number; 
    recordCount: number; 
    totalAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerCount = data["PlayerCount"] !== undefined ? data["PlayerCount"] : null;
            this.recordCount = data["RecordCount"] !== undefined ? data["RecordCount"] : null;
            this.totalAmount = data["TotalAmount"] !== undefined ? data["TotalAmount"] : null;
        }
    }

    static fromJS(data: any): LPR_GetSummaryResponse {
        return new LPR_GetSummaryResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerCount"] = this.playerCount !== undefined ? this.playerCount : null;
        data["RecordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["TotalAmount"] = this.totalAmount !== undefined ? this.totalAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPR_GetSummaryResponse(JSON.parse(json));
    }
}

export class LPR_GetSummaryGpByPromotionRequest { 
    lobbyId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
        }
    }

    static fromJS(data: any): LPR_GetSummaryGpByPromotionRequest {
        return new LPR_GetSummaryGpByPromotionRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPR_GetSummaryGpByPromotionRequest(JSON.parse(json));
    }
}

export class LPR_GetSummaryGpByPromotionResponse { 
    lobbyPromotionId: number; 
    lobbyPromotionName: string; 
    playerCount: number; 
    recordCount: number; 
    totalAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.lobbyPromotionName = data["LobbyPromotionName"] !== undefined ? data["LobbyPromotionName"] : null;
            this.playerCount = data["PlayerCount"] !== undefined ? data["PlayerCount"] : null;
            this.recordCount = data["RecordCount"] !== undefined ? data["RecordCount"] : null;
            this.totalAmount = data["TotalAmount"] !== undefined ? data["TotalAmount"] : null;
        }
    }

    static fromJS(data: any): LPR_GetSummaryGpByPromotionResponse {
        return new LPR_GetSummaryGpByPromotionResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["LobbyPromotionName"] = this.lobbyPromotionName !== undefined ? this.lobbyPromotionName : null;
        data["PlayerCount"] = this.playerCount !== undefined ? this.playerCount : null;
        data["RecordCount"] = this.recordCount !== undefined ? this.recordCount : null;
        data["TotalAmount"] = this.totalAmount !== undefined ? this.totalAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPR_GetSummaryGpByPromotionResponse(JSON.parse(json));
    }
}

export class LPR_SummaryByPromotionRequest { 
    lobbyId: number; 
    lobbyPromotionId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
        }
    }

    static fromJS(data: any): LPR_SummaryByPromotionRequest {
        return new LPR_SummaryByPromotionRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPR_SummaryByPromotionRequest(JSON.parse(json));
    }
}

export class LPR_GetSummaryGpByPlayerResponse { 
    lobbyPromotionName: string; 
    items: LobbyPromotionGetSummaryGpByPlayerResponseItem[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPromotionName = data["LobbyPromotionName"] !== undefined ? data["LobbyPromotionName"] : null;
            if (data["Items"] && data["Items"].constructor === Array) {
                this.items = [];
                for (let item of data["Items"])
                    this.items.push(LobbyPromotionGetSummaryGpByPlayerResponseItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LPR_GetSummaryGpByPlayerResponse {
        return new LPR_GetSummaryGpByPlayerResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPromotionName"] = this.lobbyPromotionName !== undefined ? this.lobbyPromotionName : null;
        if (this.items && this.items.constructor === Array) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPR_GetSummaryGpByPlayerResponse(JSON.parse(json));
    }
}

export class LobbyPromotionGetSummaryGpByPlayerResponseItem { 
    playerId: number; 
    playerName: string; 
    recordsCount: number; 
    amount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.recordsCount = data["RecordsCount"] !== undefined ? data["RecordsCount"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
        }
    }

    static fromJS(data: any): LobbyPromotionGetSummaryGpByPlayerResponseItem {
        return new LobbyPromotionGetSummaryGpByPlayerResponseItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["RecordsCount"] = this.recordsCount !== undefined ? this.recordsCount : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPromotionGetSummaryGpByPlayerResponseItem(JSON.parse(json));
    }
}

export class LPR_GetDetailsResponse { 
    lobbyPromotionName: string; 
    items: LobbyPromotionReportGetDetailsResponseItem[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPromotionName = data["LobbyPromotionName"] !== undefined ? data["LobbyPromotionName"] : null;
            if (data["Items"] && data["Items"].constructor === Array) {
                this.items = [];
                for (let item of data["Items"])
                    this.items.push(LobbyPromotionReportGetDetailsResponseItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LPR_GetDetailsResponse {
        return new LPR_GetDetailsResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPromotionName"] = this.lobbyPromotionName !== undefined ? this.lobbyPromotionName : null;
        if (this.items && this.items.constructor === Array) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LPR_GetDetailsResponse(JSON.parse(json));
    }
}

export class LobbyPromotionReportGetDetailsResponseItem { 
    playerId: number; 
    playerName: string; 
    amount: number; 
    depositDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.depositDate = data["DepositDate"] ? new Date(data["DepositDate"].toString()) : null;
        }
    }

    static fromJS(data: any): LobbyPromotionReportGetDetailsResponseItem {
        return new LobbyPromotionReportGetDetailsResponseItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["DepositDate"] = this.depositDate ? this.depositDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPromotionReportGetDetailsResponseItem(JSON.parse(json));
    }
}

export class LobbyRoleDao { 
    id: number; 
    roleName: string; 
    noOfUsers: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.roleName = data["RoleName"] !== undefined ? data["RoleName"] : null;
            this.noOfUsers = data["NoOfUsers"] !== undefined ? data["NoOfUsers"] : null;
        }
    }

    static fromJS(data: any): LobbyRoleDao {
        return new LobbyRoleDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["RoleName"] = this.roleName !== undefined ? this.roleName : null;
        data["NoOfUsers"] = this.noOfUsers !== undefined ? this.noOfUsers : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyRoleDao(JSON.parse(json));
    }
}

export class AddRolePermissionRequest { 
    lobbyId: number; 
    roleName: string; 
    isAgent: boolean; 
    permissions: UpdatedPermissions[]; 
    behaviors: UpdatedBehaviors[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.roleName = data["RoleName"] !== undefined ? data["RoleName"] : null;
            this.isAgent = data["IsAgent"] !== undefined ? data["IsAgent"] : null;
            if (data["Permissions"] && data["Permissions"].constructor === Array) {
                this.permissions = [];
                for (let item of data["Permissions"])
                    this.permissions.push(UpdatedPermissions.fromJS(item));
            }
            if (data["Behaviors"] && data["Behaviors"].constructor === Array) {
                this.behaviors = [];
                for (let item of data["Behaviors"])
                    this.behaviors.push(UpdatedBehaviors.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddRolePermissionRequest {
        return new AddRolePermissionRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["RoleName"] = this.roleName !== undefined ? this.roleName : null;
        data["IsAgent"] = this.isAgent !== undefined ? this.isAgent : null;
        if (this.permissions && this.permissions.constructor === Array) {
            data["Permissions"] = [];
            for (let item of this.permissions)
                data["Permissions"].push(item.toJS());
        }
        if (this.behaviors && this.behaviors.constructor === Array) {
            data["Behaviors"] = [];
            for (let item of this.behaviors)
                data["Behaviors"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AddRolePermissionRequest(JSON.parse(json));
    }
}

export class LobbyRoleEditDao { 
    id: number; 
    roleName: string; 
    isAgent: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.roleName = data["RoleName"] !== undefined ? data["RoleName"] : null;
            this.isAgent = data["IsAgent"] !== undefined ? data["IsAgent"] : null;
        }
    }

    static fromJS(data: any): LobbyRoleEditDao {
        return new LobbyRoleEditDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["RoleName"] = this.roleName !== undefined ? this.roleName : null;
        data["IsAgent"] = this.isAgent !== undefined ? this.isAgent : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyRoleEditDao(JSON.parse(json));
    }
}

export class LobbyRoleEditRequest { 
    lobbyRoleId: number; 
    roleName: string; 
    isAgent: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyRoleId = data["LobbyRoleId"] !== undefined ? data["LobbyRoleId"] : null;
            this.roleName = data["RoleName"] !== undefined ? data["RoleName"] : null;
            this.isAgent = data["IsAgent"] !== undefined ? data["IsAgent"] : null;
        }
    }

    static fromJS(data: any): LobbyRoleEditRequest {
        return new LobbyRoleEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyRoleId"] = this.lobbyRoleId !== undefined ? this.lobbyRoleId : null;
        data["RoleName"] = this.roleName !== undefined ? this.roleName : null;
        data["IsAgent"] = this.isAgent !== undefined ? this.isAgent : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyRoleEditRequest(JSON.parse(json));
    }
}

export class TVBannerGetAllResponse { 
    lobbyTVBannerId: number; 
    lobbyId: number; 
    name: string; 
    enable: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyTVBannerId = data["LobbyTVBannerId"] !== undefined ? data["LobbyTVBannerId"] : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.enable = data["Enable"] !== undefined ? data["Enable"] : null;
        }
    }

    static fromJS(data: any): TVBannerGetAllResponse {
        return new TVBannerGetAllResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyTVBannerId"] = this.lobbyTVBannerId !== undefined ? this.lobbyTVBannerId : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["Enable"] = this.enable !== undefined ? this.enable : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new TVBannerGetAllResponse(JSON.parse(json));
    }
}

export class TVBannerDetailGetAllRequest { 
    lobbyTVBannerId: number; 
    languageId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyTVBannerId = data["LobbyTVBannerId"] !== undefined ? data["LobbyTVBannerId"] : null;
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
        }
    }

    static fromJS(data: any): TVBannerDetailGetAllRequest {
        return new TVBannerDetailGetAllRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyTVBannerId"] = this.lobbyTVBannerId !== undefined ? this.lobbyTVBannerId : null;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new TVBannerDetailGetAllRequest(JSON.parse(json));
    }
}

export class TVBannerDetailGetAllResponse { 
    lobbyTVBannerDetailId: number; 
    lobbyTVBannerId: number; 
    name: string; 
    languageId: number; 
    desktopImagePath: string; 
    mobileImagePath: string; 
    startDate: Date; 
    endDate: Date; 
    enable: boolean; 
    updateDate: Date; 
    updateBy: string; 
    sortNo: number; 
    title: string; 
    description: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyTVBannerDetailId = data["LobbyTVBannerDetailId"] !== undefined ? data["LobbyTVBannerDetailId"] : null;
            this.lobbyTVBannerId = data["LobbyTVBannerId"] !== undefined ? data["LobbyTVBannerId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.desktopImagePath = data["DesktopImagePath"] !== undefined ? data["DesktopImagePath"] : null;
            this.mobileImagePath = data["MobileImagePath"] !== undefined ? data["MobileImagePath"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.enable = data["Enable"] !== undefined ? data["Enable"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.sortNo = data["SortNo"] !== undefined ? data["SortNo"] : null;
            this.title = data["Title"] !== undefined ? data["Title"] : null;
            this.description = data["Description"] !== undefined ? data["Description"] : null;
        }
    }

    static fromJS(data: any): TVBannerDetailGetAllResponse {
        return new TVBannerDetailGetAllResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyTVBannerDetailId"] = this.lobbyTVBannerDetailId !== undefined ? this.lobbyTVBannerDetailId : null;
        data["LobbyTVBannerId"] = this.lobbyTVBannerId !== undefined ? this.lobbyTVBannerId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["DesktopImagePath"] = this.desktopImagePath !== undefined ? this.desktopImagePath : null;
        data["MobileImagePath"] = this.mobileImagePath !== undefined ? this.mobileImagePath : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["Enable"] = this.enable !== undefined ? this.enable : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["SortNo"] = this.sortNo !== undefined ? this.sortNo : null;
        data["Title"] = this.title !== undefined ? this.title : null;
        data["Description"] = this.description !== undefined ? this.description : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new TVBannerDetailGetAllResponse(JSON.parse(json));
    }
}

export class TVBannerDetailGetByIdRequest { 
    lobbyTVBannerDetailId: number; 
    languageId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyTVBannerDetailId = data["LobbyTVBannerDetailId"] !== undefined ? data["LobbyTVBannerDetailId"] : null;
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
        }
    }

    static fromJS(data: any): TVBannerDetailGetByIdRequest {
        return new TVBannerDetailGetByIdRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyTVBannerDetailId"] = this.lobbyTVBannerDetailId !== undefined ? this.lobbyTVBannerDetailId : null;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new TVBannerDetailGetByIdRequest(JSON.parse(json));
    }
}

export class LobbyLanguageResponse { 
    id: number; 
    name: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
        }
    }

    static fromJS(data: any): LobbyLanguageResponse {
        return new LobbyLanguageResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyLanguageResponse(JSON.parse(json));
    }
}

export class CreateTVBannerRequestDao { 
    lobbyTVBannerId: number; 
    name: string; 
    startDate: Date; 
    endDate: Date; 
    enable: boolean; 
    updateDate: Date; 
    updateBy: number; 
    desktopLinkTo: string; 
    mobileLinkTo: string; 
    tVBannerTranslations: TVBannerTranslationsDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyTVBannerId = data["LobbyTVBannerId"] !== undefined ? data["LobbyTVBannerId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.enable = data["Enable"] !== undefined ? data["Enable"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.desktopLinkTo = data["DesktopLinkTo"] !== undefined ? data["DesktopLinkTo"] : null;
            this.mobileLinkTo = data["MobileLinkTo"] !== undefined ? data["MobileLinkTo"] : null;
            if (data["TVBannerTranslations"] && data["TVBannerTranslations"].constructor === Array) {
                this.tVBannerTranslations = [];
                for (let item of data["TVBannerTranslations"])
                    this.tVBannerTranslations.push(TVBannerTranslationsDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTVBannerRequestDao {
        return new CreateTVBannerRequestDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyTVBannerId"] = this.lobbyTVBannerId !== undefined ? this.lobbyTVBannerId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["Enable"] = this.enable !== undefined ? this.enable : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["DesktopLinkTo"] = this.desktopLinkTo !== undefined ? this.desktopLinkTo : null;
        data["MobileLinkTo"] = this.mobileLinkTo !== undefined ? this.mobileLinkTo : null;
        if (this.tVBannerTranslations && this.tVBannerTranslations.constructor === Array) {
            data["TVBannerTranslations"] = [];
            for (let item of this.tVBannerTranslations)
                data["TVBannerTranslations"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CreateTVBannerRequestDao(JSON.parse(json));
    }
}

export class TVBannerTranslationsDao { 
    languageId: number; 
    languageName: string; 
    lobbyTVBannerDetailId: number; 
    name: string; 
    desktopImagePath: string; 
    mobileImagePath: string; 
    title: string; 
    description: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.languageName = data["LanguageName"] !== undefined ? data["LanguageName"] : null;
            this.lobbyTVBannerDetailId = data["LobbyTVBannerDetailId"] !== undefined ? data["LobbyTVBannerDetailId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.desktopImagePath = data["DesktopImagePath"] !== undefined ? data["DesktopImagePath"] : null;
            this.mobileImagePath = data["MobileImagePath"] !== undefined ? data["MobileImagePath"] : null;
            this.title = data["Title"] !== undefined ? data["Title"] : null;
            this.description = data["Description"] !== undefined ? data["Description"] : null;
        }
    }

    static fromJS(data: any): TVBannerTranslationsDao {
        return new TVBannerTranslationsDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["LanguageName"] = this.languageName !== undefined ? this.languageName : null;
        data["LobbyTVBannerDetailId"] = this.lobbyTVBannerDetailId !== undefined ? this.lobbyTVBannerDetailId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["DesktopImagePath"] = this.desktopImagePath !== undefined ? this.desktopImagePath : null;
        data["MobileImagePath"] = this.mobileImagePath !== undefined ? this.mobileImagePath : null;
        data["Title"] = this.title !== undefined ? this.title : null;
        data["Description"] = this.description !== undefined ? this.description : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new TVBannerTranslationsDao(JSON.parse(json));
    }
}

export class TVBannerDetailEditResponse { 
    lobbyTVBannerId: number; 
    lobbyTVBannerDetailId: number; 
    name: string; 
    startDate: Date; 
    endDate: Date; 
    enable: boolean; 
    updateDate: Date; 
    updateBy: string; 
    desktopLinkTo: string; 
    mobileLinkTo: string; 
    tVBannerTranslations: TVBannerTranslationsDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyTVBannerId = data["LobbyTVBannerId"] !== undefined ? data["LobbyTVBannerId"] : null;
            this.lobbyTVBannerDetailId = data["LobbyTVBannerDetailId"] !== undefined ? data["LobbyTVBannerDetailId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.enable = data["Enable"] !== undefined ? data["Enable"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.desktopLinkTo = data["DesktopLinkTo"] !== undefined ? data["DesktopLinkTo"] : null;
            this.mobileLinkTo = data["MobileLinkTo"] !== undefined ? data["MobileLinkTo"] : null;
            if (data["TVBannerTranslations"] && data["TVBannerTranslations"].constructor === Array) {
                this.tVBannerTranslations = [];
                for (let item of data["TVBannerTranslations"])
                    this.tVBannerTranslations.push(TVBannerTranslationsDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TVBannerDetailEditResponse {
        return new TVBannerDetailEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyTVBannerId"] = this.lobbyTVBannerId !== undefined ? this.lobbyTVBannerId : null;
        data["LobbyTVBannerDetailId"] = this.lobbyTVBannerDetailId !== undefined ? this.lobbyTVBannerDetailId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["Enable"] = this.enable !== undefined ? this.enable : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["DesktopLinkTo"] = this.desktopLinkTo !== undefined ? this.desktopLinkTo : null;
        data["MobileLinkTo"] = this.mobileLinkTo !== undefined ? this.mobileLinkTo : null;
        if (this.tVBannerTranslations && this.tVBannerTranslations.constructor === Array) {
            data["TVBannerTranslations"] = [];
            for (let item of this.tVBannerTranslations)
                data["TVBannerTranslations"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new TVBannerDetailEditResponse(JSON.parse(json));
    }
}

export class TVBannerDetailEditRequestDao { 
    lobbyTVBannerDetailId: number; 
    lobbyTVBannerId: number; 
    name: string; 
    startDate: Date; 
    endDate: Date; 
    enable: boolean; 
    updateDate: Date; 
    updateBy: number; 
    desktopLinkTo: string; 
    mobileLinkTo: string; 
    tVBannerTranslations: TVBannerTranslationsDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyTVBannerDetailId = data["LobbyTVBannerDetailId"] !== undefined ? data["LobbyTVBannerDetailId"] : null;
            this.lobbyTVBannerId = data["LobbyTVBannerId"] !== undefined ? data["LobbyTVBannerId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.enable = data["Enable"] !== undefined ? data["Enable"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.desktopLinkTo = data["DesktopLinkTo"] !== undefined ? data["DesktopLinkTo"] : null;
            this.mobileLinkTo = data["MobileLinkTo"] !== undefined ? data["MobileLinkTo"] : null;
            if (data["TVBannerTranslations"] && data["TVBannerTranslations"].constructor === Array) {
                this.tVBannerTranslations = [];
                for (let item of data["TVBannerTranslations"])
                    this.tVBannerTranslations.push(TVBannerTranslationsDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TVBannerDetailEditRequestDao {
        return new TVBannerDetailEditRequestDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyTVBannerDetailId"] = this.lobbyTVBannerDetailId !== undefined ? this.lobbyTVBannerDetailId : null;
        data["LobbyTVBannerId"] = this.lobbyTVBannerId !== undefined ? this.lobbyTVBannerId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["Enable"] = this.enable !== undefined ? this.enable : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["DesktopLinkTo"] = this.desktopLinkTo !== undefined ? this.desktopLinkTo : null;
        data["MobileLinkTo"] = this.mobileLinkTo !== undefined ? this.mobileLinkTo : null;
        if (this.tVBannerTranslations && this.tVBannerTranslations.constructor === Array) {
            data["TVBannerTranslations"] = [];
            for (let item of this.tVBannerTranslations)
                data["TVBannerTranslations"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new TVBannerDetailEditRequestDao(JSON.parse(json));
    }
}

export class LobbyTVBannerDetailSetEnableRequest { 
    lobbyTVBannerDetailId: number; 
    enable: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyTVBannerDetailId = data["LobbyTVBannerDetailId"] !== undefined ? data["LobbyTVBannerDetailId"] : null;
            this.enable = data["Enable"] !== undefined ? data["Enable"] : null;
        }
    }

    static fromJS(data: any): LobbyTVBannerDetailSetEnableRequest {
        return new LobbyTVBannerDetailSetEnableRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyTVBannerDetailId"] = this.lobbyTVBannerDetailId !== undefined ? this.lobbyTVBannerDetailId : null;
        data["Enable"] = this.enable !== undefined ? this.enable : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyTVBannerDetailSetEnableRequest(JSON.parse(json));
    }
}

export class LobbyTVBannerDetailSetDeleteRequest { 
    lobbyTVBannerDetailId: number; 
    isDelete: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyTVBannerDetailId = data["LobbyTVBannerDetailId"] !== undefined ? data["LobbyTVBannerDetailId"] : null;
            this.isDelete = data["IsDelete"] !== undefined ? data["IsDelete"] : null;
        }
    }

    static fromJS(data: any): LobbyTVBannerDetailSetDeleteRequest {
        return new LobbyTVBannerDetailSetDeleteRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyTVBannerDetailId"] = this.lobbyTVBannerDetailId !== undefined ? this.lobbyTVBannerDetailId : null;
        data["IsDelete"] = this.isDelete !== undefined ? this.isDelete : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyTVBannerDetailSetDeleteRequest(JSON.parse(json));
    }
}

export class PlayerAmountRecordWinLostRequest { 
    startDate: Date; 
    endDate: Date; 
    lobbyId: number; 
    language: LanguageCode; 
    lobbyPlayerGroupId: number; 
    playerName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.lobbyPlayerGroupId = data["LobbyPlayerGroupId"] !== undefined ? data["LobbyPlayerGroupId"] : null;
            this.playerName = data["playerName"] !== undefined ? data["playerName"] : null;
        }
    }

    static fromJS(data: any): PlayerAmountRecordWinLostRequest {
        return new PlayerAmountRecordWinLostRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["LobbyPlayerGroupId"] = this.lobbyPlayerGroupId !== undefined ? this.lobbyPlayerGroupId : null;
        data["playerName"] = this.playerName !== undefined ? this.playerName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerAmountRecordWinLostRequest(JSON.parse(json));
    }
}

export class StandardResultOfWinLossReportResponse { 
    isSuccess: boolean; 
    payload: WinLossReportResponse; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            this.payload = data["Payload"] ? WinLossReportResponse.fromJS(data["Payload"]) : null;
            if (data["Errors"] && data["Errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["Errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResultOfWinLossReportResponse {
        return new StandardResultOfWinLossReportResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["Payload"] = this.payload ? this.payload.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResultOfWinLossReportResponse(JSON.parse(json));
    }
}

export class WinLossReportResponse { 
    numberOfPlayerCount: number; 
    items: WinLossItem[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.numberOfPlayerCount = data["numberOfPlayerCount"] !== undefined ? data["numberOfPlayerCount"] : null;
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (let item of data["items"])
                    this.items.push(WinLossItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WinLossReportResponse {
        return new WinLossReportResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["numberOfPlayerCount"] = this.numberOfPlayerCount !== undefined ? this.numberOfPlayerCount : null;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new WinLossReportResponse(JSON.parse(json));
    }
}

export class WinLossItem { 
    key: string; 
    gameDevId: number; 
    gameDevName: string; 
    totalBet: number; 
    totalValidBet: number; 
    totalPayoff: number; 
    winnings: number; 
    netProfit: number; 
    numberOfBets: number; 
    updateDate: Date; 
    subItems: WinLossSubItem[]; 
    billedCurrencyId: CurrencyId; 
    billedCurrencyName: string; 
    numberOfPlayers: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.key = data["Key"] !== undefined ? data["Key"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
            this.totalBet = data["TotalBet"] !== undefined ? data["TotalBet"] : null;
            this.totalValidBet = data["TotalValidBet"] !== undefined ? data["TotalValidBet"] : null;
            this.totalPayoff = data["TotalPayoff"] !== undefined ? data["TotalPayoff"] : null;
            this.winnings = data["Winnings"] !== undefined ? data["Winnings"] : null;
            this.netProfit = data["NetProfit"] !== undefined ? data["NetProfit"] : null;
            this.numberOfBets = data["NumberOfBets"] !== undefined ? data["NumberOfBets"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            if (data["SubItems"] && data["SubItems"].constructor === Array) {
                this.subItems = [];
                for (let item of data["SubItems"])
                    this.subItems.push(WinLossSubItem.fromJS(item));
            }
            this.billedCurrencyId = data["BilledCurrencyId"] !== undefined ? data["BilledCurrencyId"] : null;
            this.billedCurrencyName = data["BilledCurrencyName"] !== undefined ? data["BilledCurrencyName"] : null;
            this.numberOfPlayers = data["NumberOfPlayers"] !== undefined ? data["NumberOfPlayers"] : null;
        }
    }

    static fromJS(data: any): WinLossItem {
        return new WinLossItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Key"] = this.key !== undefined ? this.key : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        data["TotalBet"] = this.totalBet !== undefined ? this.totalBet : null;
        data["TotalValidBet"] = this.totalValidBet !== undefined ? this.totalValidBet : null;
        data["TotalPayoff"] = this.totalPayoff !== undefined ? this.totalPayoff : null;
        data["Winnings"] = this.winnings !== undefined ? this.winnings : null;
        data["NetProfit"] = this.netProfit !== undefined ? this.netProfit : null;
        data["NumberOfBets"] = this.numberOfBets !== undefined ? this.numberOfBets : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        if (this.subItems && this.subItems.constructor === Array) {
            data["SubItems"] = [];
            for (let item of this.subItems)
                data["SubItems"].push(item.toJS());
        }
        data["BilledCurrencyId"] = this.billedCurrencyId !== undefined ? this.billedCurrencyId : null;
        data["BilledCurrencyName"] = this.billedCurrencyName !== undefined ? this.billedCurrencyName : null;
        data["NumberOfPlayers"] = this.numberOfPlayers !== undefined ? this.numberOfPlayers : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new WinLossItem(JSON.parse(json));
    }
}

export class WinLossSubItem { 
    key: string; 
    gameDevId: number; 
    gameDevName: string; 
    gameTypeId: number; 
    gameTypeName: string; 
    totalBet: number; 
    totalPayoff: number; 
    totalValidBet: number; 
    winnings: number; 
    netProfit: number; 
    numberOfBets: number; 
    numberOfPlayers: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.key = data["Key"] !== undefined ? data["Key"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
            this.gameTypeId = data["GameTypeId"] !== undefined ? data["GameTypeId"] : null;
            this.gameTypeName = data["GameTypeName"] !== undefined ? data["GameTypeName"] : null;
            this.totalBet = data["TotalBet"] !== undefined ? data["TotalBet"] : null;
            this.totalPayoff = data["TotalPayoff"] !== undefined ? data["TotalPayoff"] : null;
            this.totalValidBet = data["TotalValidBet"] !== undefined ? data["TotalValidBet"] : null;
            this.winnings = data["Winnings"] !== undefined ? data["Winnings"] : null;
            this.netProfit = data["NetProfit"] !== undefined ? data["NetProfit"] : null;
            this.numberOfBets = data["NumberOfBets"] !== undefined ? data["NumberOfBets"] : null;
            this.numberOfPlayers = data["NumberOfPlayers"] !== undefined ? data["NumberOfPlayers"] : null;
        }
    }

    static fromJS(data: any): WinLossSubItem {
        return new WinLossSubItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Key"] = this.key !== undefined ? this.key : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        data["GameTypeId"] = this.gameTypeId !== undefined ? this.gameTypeId : null;
        data["GameTypeName"] = this.gameTypeName !== undefined ? this.gameTypeName : null;
        data["TotalBet"] = this.totalBet !== undefined ? this.totalBet : null;
        data["TotalPayoff"] = this.totalPayoff !== undefined ? this.totalPayoff : null;
        data["TotalValidBet"] = this.totalValidBet !== undefined ? this.totalValidBet : null;
        data["Winnings"] = this.winnings !== undefined ? this.winnings : null;
        data["NetProfit"] = this.netProfit !== undefined ? this.netProfit : null;
        data["NumberOfBets"] = this.numberOfBets !== undefined ? this.numberOfBets : null;
        data["NumberOfPlayers"] = this.numberOfPlayers !== undefined ? this.numberOfPlayers : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new WinLossSubItem(JSON.parse(json));
    }
}

export class WinLostReportDetailRequest { 
    startDate: Date; 
    endDate: Date; 
    gameDevId: GameDevId; 
    gameTypeId: PlayerAmountRecordGameTypeId; 
    lobbyPlayerGroupId: number; 
    playerName: string; 
    lobbyAgentId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.gameTypeId = data["GameTypeId"] !== undefined ? data["GameTypeId"] : null;
            this.lobbyPlayerGroupId = data["LobbyPlayerGroupId"] !== undefined ? data["LobbyPlayerGroupId"] : null;
            this.playerName = data["playerName"] !== undefined ? data["playerName"] : null;
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
        }
    }

    static fromJS(data: any): WinLostReportDetailRequest {
        return new WinLostReportDetailRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["GameTypeId"] = this.gameTypeId !== undefined ? this.gameTypeId : null;
        data["LobbyPlayerGroupId"] = this.lobbyPlayerGroupId !== undefined ? this.lobbyPlayerGroupId : null;
        data["playerName"] = this.playerName !== undefined ? this.playerName : null;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new WinLostReportDetailRequest(JSON.parse(json));
    }
}

export class StandardResultOfIEnumerableOfWinLostReportDetailItem { 
    isSuccess: boolean; 
    payload: WinLostReportDetailItem[]; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            if (data["Payload"] && data["Payload"].constructor === Array) {
                this.payload = [];
                for (let item of data["Payload"])
                    this.payload.push(WinLostReportDetailItem.fromJS(item));
            }
            if (data["Errors"] && data["Errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["Errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResultOfIEnumerableOfWinLostReportDetailItem {
        return new StandardResultOfIEnumerableOfWinLostReportDetailItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.payload && this.payload.constructor === Array) {
            data["Payload"] = [];
            for (let item of this.payload)
                data["Payload"].push(item.toJS());
        }
        if (this.errors && this.errors.constructor === Array) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResultOfIEnumerableOfWinLostReportDetailItem(JSON.parse(json));
    }
}

export class WinLostReportDetailItem { 
    playerId: number; 
    playerName: string; 
    playerRealName: string; 
    totalBet: number; 
    totalValidBet: number; 
    totalPayoff: number; 
    winnings: number; 
    numberOfBets: number; 
    agentCode: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.playerRealName = data["PlayerRealName"] !== undefined ? data["PlayerRealName"] : null;
            this.totalBet = data["TotalBet"] !== undefined ? data["TotalBet"] : null;
            this.totalValidBet = data["TotalValidBet"] !== undefined ? data["TotalValidBet"] : null;
            this.totalPayoff = data["TotalPayoff"] !== undefined ? data["TotalPayoff"] : null;
            this.winnings = data["Winnings"] !== undefined ? data["Winnings"] : null;
            this.numberOfBets = data["NumberOfBets"] !== undefined ? data["NumberOfBets"] : null;
            this.agentCode = data["AgentCode"] !== undefined ? data["AgentCode"] : null;
        }
    }

    static fromJS(data: any): WinLostReportDetailItem {
        return new WinLostReportDetailItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["PlayerRealName"] = this.playerRealName !== undefined ? this.playerRealName : null;
        data["TotalBet"] = this.totalBet !== undefined ? this.totalBet : null;
        data["TotalValidBet"] = this.totalValidBet !== undefined ? this.totalValidBet : null;
        data["TotalPayoff"] = this.totalPayoff !== undefined ? this.totalPayoff : null;
        data["Winnings"] = this.winnings !== undefined ? this.winnings : null;
        data["NumberOfBets"] = this.numberOfBets !== undefined ? this.numberOfBets : null;
        data["AgentCode"] = this.agentCode !== undefined ? this.agentCode : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new WinLostReportDetailItem(JSON.parse(json));
    }
}

export class PlayerTransactionListRequest { 
    lobbyId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date; 
    playerName: string; 
    transactionTypeList: TransactionTypeId[]; 
    gameDevId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            if (data["TransactionTypeList"] && data["TransactionTypeList"].constructor === Array) {
                this.transactionTypeList = [];
                for (let item of data["TransactionTypeList"])
                    this.transactionTypeList.push(item);
            }
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
        }
    }

    static fromJS(data: any): PlayerTransactionListRequest {
        return new PlayerTransactionListRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        if (this.transactionTypeList && this.transactionTypeList.constructor === Array) {
            data["TransactionTypeList"] = [];
            for (let item of this.transactionTypeList)
                data["TransactionTypeList"].push(item);
        }
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerTransactionListRequest(JSON.parse(json));
    }
}

export enum TransactionTypeId {
    Deposit = 1, 
    Withdraw = 2, 
    Rebate = 3, 
    Promotion = 4, 
    BetPayout = 5, 
    Admin_Add_Points = 6, 
    Admin_Deduct_Points = 7, 
    InternalTransfer = 8, 
    Admin_Amend_Points = 9, 
    Purchase = 10, 
    GAME_PLATFORM_CONSUMPTION = 11, 
}

export class PlayerTransactionItem { 
    id: number; 
    playerName: string; 
    playerAmountRecordTypeId: number; 
    platform: string; 
    totalBetAmount: number; 
    totalValidBetAmount: number; 
    totalPayoutAmount: number; 
    totalAmount: number; 
    mainBalanceBefore: number; 
    mainBalanceAfter: number; 
    gameDevBalanceBefore: number; 
    gameDevBalanceAfter: number; 
    betTime: Date; 
    settleTime: Date; 
    updateBy: string; 
    updateDate: Date; 
    transactionNo: string; 
    paymentGatewayReferenceNo: string; 
    isPublish: boolean; 
    topTransactionMasterTypeId: NewTransactionMasterTypeId; 
    topTransactionMasterType: string; 
    transactionType: string; 
    detail: string; 
    betType: string; 
    gameType: string; 
    sessionNo: string; 
    transactionStatusId: NewTransactionStatusId; 
    transactionTypeId: NewTransactionTypeId; 
    transactionStatus: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.playerAmountRecordTypeId = data["PlayerAmountRecordTypeId"] !== undefined ? data["PlayerAmountRecordTypeId"] : null;
            this.platform = data["Platform"] !== undefined ? data["Platform"] : null;
            this.totalBetAmount = data["TotalBetAmount"] !== undefined ? data["TotalBetAmount"] : null;
            this.totalValidBetAmount = data["TotalValidBetAmount"] !== undefined ? data["TotalValidBetAmount"] : null;
            this.totalPayoutAmount = data["TotalPayoutAmount"] !== undefined ? data["TotalPayoutAmount"] : null;
            this.totalAmount = data["TotalAmount"] !== undefined ? data["TotalAmount"] : null;
            this.mainBalanceBefore = data["MainBalanceBefore"] !== undefined ? data["MainBalanceBefore"] : null;
            this.mainBalanceAfter = data["MainBalanceAfter"] !== undefined ? data["MainBalanceAfter"] : null;
            this.gameDevBalanceBefore = data["GameDevBalanceBefore"] !== undefined ? data["GameDevBalanceBefore"] : null;
            this.gameDevBalanceAfter = data["GameDevBalanceAfter"] !== undefined ? data["GameDevBalanceAfter"] : null;
            this.betTime = data["BetTime"] ? new Date(data["BetTime"].toString()) : null;
            this.settleTime = data["SettleTime"] ? new Date(data["SettleTime"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
            this.paymentGatewayReferenceNo = data["PaymentGatewayReferenceNo"] !== undefined ? data["PaymentGatewayReferenceNo"] : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
            this.topTransactionMasterTypeId = data["TopTransactionMasterTypeId"] !== undefined ? data["TopTransactionMasterTypeId"] : null;
            this.topTransactionMasterType = data["TopTransactionMasterType"] !== undefined ? data["TopTransactionMasterType"] : null;
            this.transactionType = data["TransactionType"] !== undefined ? data["TransactionType"] : null;
            this.detail = data["Detail"] !== undefined ? data["Detail"] : null;
            this.betType = data["BetType"] !== undefined ? data["BetType"] : null;
            this.gameType = data["GameType"] !== undefined ? data["GameType"] : null;
            this.sessionNo = data["SessionNo"] !== undefined ? data["SessionNo"] : null;
            this.transactionStatusId = data["TransactionStatusId"] !== undefined ? data["TransactionStatusId"] : null;
            this.transactionTypeId = data["TransactionTypeId"] !== undefined ? data["TransactionTypeId"] : null;
            this.transactionStatus = data["TransactionStatus"] !== undefined ? data["TransactionStatus"] : null;
        }
    }

    static fromJS(data: any): PlayerTransactionItem {
        return new PlayerTransactionItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["PlayerAmountRecordTypeId"] = this.playerAmountRecordTypeId !== undefined ? this.playerAmountRecordTypeId : null;
        data["Platform"] = this.platform !== undefined ? this.platform : null;
        data["TotalBetAmount"] = this.totalBetAmount !== undefined ? this.totalBetAmount : null;
        data["TotalValidBetAmount"] = this.totalValidBetAmount !== undefined ? this.totalValidBetAmount : null;
        data["TotalPayoutAmount"] = this.totalPayoutAmount !== undefined ? this.totalPayoutAmount : null;
        data["TotalAmount"] = this.totalAmount !== undefined ? this.totalAmount : null;
        data["MainBalanceBefore"] = this.mainBalanceBefore !== undefined ? this.mainBalanceBefore : null;
        data["MainBalanceAfter"] = this.mainBalanceAfter !== undefined ? this.mainBalanceAfter : null;
        data["GameDevBalanceBefore"] = this.gameDevBalanceBefore !== undefined ? this.gameDevBalanceBefore : null;
        data["GameDevBalanceAfter"] = this.gameDevBalanceAfter !== undefined ? this.gameDevBalanceAfter : null;
        data["BetTime"] = this.betTime ? this.betTime.toISOString() : null;
        data["SettleTime"] = this.settleTime ? this.settleTime.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        data["PaymentGatewayReferenceNo"] = this.paymentGatewayReferenceNo !== undefined ? this.paymentGatewayReferenceNo : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        data["TopTransactionMasterTypeId"] = this.topTransactionMasterTypeId !== undefined ? this.topTransactionMasterTypeId : null;
        data["TopTransactionMasterType"] = this.topTransactionMasterType !== undefined ? this.topTransactionMasterType : null;
        data["TransactionType"] = this.transactionType !== undefined ? this.transactionType : null;
        data["Detail"] = this.detail !== undefined ? this.detail : null;
        data["BetType"] = this.betType !== undefined ? this.betType : null;
        data["GameType"] = this.gameType !== undefined ? this.gameType : null;
        data["SessionNo"] = this.sessionNo !== undefined ? this.sessionNo : null;
        data["TransactionStatusId"] = this.transactionStatusId !== undefined ? this.transactionStatusId : null;
        data["TransactionTypeId"] = this.transactionTypeId !== undefined ? this.transactionTypeId : null;
        data["TransactionStatus"] = this.transactionStatus !== undefined ? this.transactionStatus : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerTransactionItem(JSON.parse(json));
    }
}

export class PlayerTransactionListGroupByUsernameRequest { 
    startDate: Date; 
    endDate: Date; 
    masterTransactionTypeList: NewTransactionMasterTypeId[]; 
    lobbyReferenceGroupId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            if (data["MasterTransactionTypeList"] && data["MasterTransactionTypeList"].constructor === Array) {
                this.masterTransactionTypeList = [];
                for (let item of data["MasterTransactionTypeList"])
                    this.masterTransactionTypeList.push(item);
            }
            this.lobbyReferenceGroupId = data["LobbyReferenceGroupId"] !== undefined ? data["LobbyReferenceGroupId"] : null;
        }
    }

    static fromJS(data: any): PlayerTransactionListGroupByUsernameRequest {
        return new PlayerTransactionListGroupByUsernameRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        if (this.masterTransactionTypeList && this.masterTransactionTypeList.constructor === Array) {
            data["MasterTransactionTypeList"] = [];
            for (let item of this.masterTransactionTypeList)
                data["MasterTransactionTypeList"].push(item);
        }
        data["LobbyReferenceGroupId"] = this.lobbyReferenceGroupId !== undefined ? this.lobbyReferenceGroupId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerTransactionListGroupByUsernameRequest(JSON.parse(json));
    }
}

export class StandardResultOfIEnumerableOfPlayerTransactionListGroupByUserDao { 
    isSuccess: boolean; 
    payload: PlayerTransactionListGroupByUserDao[]; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            if (data["Payload"] && data["Payload"].constructor === Array) {
                this.payload = [];
                for (let item of data["Payload"])
                    this.payload.push(PlayerTransactionListGroupByUserDao.fromJS(item));
            }
            if (data["Errors"] && data["Errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["Errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResultOfIEnumerableOfPlayerTransactionListGroupByUserDao {
        return new StandardResultOfIEnumerableOfPlayerTransactionListGroupByUserDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.payload && this.payload.constructor === Array) {
            data["Payload"] = [];
            for (let item of this.payload)
                data["Payload"].push(item.toJS());
        }
        if (this.errors && this.errors.constructor === Array) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResultOfIEnumerableOfPlayerTransactionListGroupByUserDao(JSON.parse(json));
    }
}

export class PlayerTransactionListGroupByUserDao { 
    playerName: string; 
    lobbyReferenceGroupIds: number[]; 
    lobbyReferenceGroupName: string; 
    phoneNo: string; 
    registrationDate: Date; 
    agentCode: string; 
    playerGroupName: string; 
    latestDspositDate: Date; 
    depositCount: number; 
    depositAmount: number; 
    adminDepositCount: number; 
    adminDepositAmount: number; 
    withdrawCount: number; 
    withdrawAmount: number; 
    betCount: number; 
    betAmount: number; 
    validBetAmount: number; 
    payoutAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            if (data["LobbyReferenceGroupIds"] && data["LobbyReferenceGroupIds"].constructor === Array) {
                this.lobbyReferenceGroupIds = [];
                for (let item of data["LobbyReferenceGroupIds"])
                    this.lobbyReferenceGroupIds.push(item);
            }
            this.lobbyReferenceGroupName = data["LobbyReferenceGroupName"] !== undefined ? data["LobbyReferenceGroupName"] : null;
            this.phoneNo = data["PhoneNo"] !== undefined ? data["PhoneNo"] : null;
            this.registrationDate = data["RegistrationDate"] ? new Date(data["RegistrationDate"].toString()) : null;
            this.agentCode = data["AgentCode"] !== undefined ? data["AgentCode"] : null;
            this.playerGroupName = data["PlayerGroupName"] !== undefined ? data["PlayerGroupName"] : null;
            this.latestDspositDate = data["LatestDspositDate"] ? new Date(data["LatestDspositDate"].toString()) : null;
            this.depositCount = data["DepositCount"] !== undefined ? data["DepositCount"] : null;
            this.depositAmount = data["DepositAmount"] !== undefined ? data["DepositAmount"] : null;
            this.adminDepositCount = data["AdminDepositCount"] !== undefined ? data["AdminDepositCount"] : null;
            this.adminDepositAmount = data["AdminDepositAmount"] !== undefined ? data["AdminDepositAmount"] : null;
            this.withdrawCount = data["WithdrawCount"] !== undefined ? data["WithdrawCount"] : null;
            this.withdrawAmount = data["WithdrawAmount"] !== undefined ? data["WithdrawAmount"] : null;
            this.betCount = data["BetCount"] !== undefined ? data["BetCount"] : null;
            this.betAmount = data["BetAmount"] !== undefined ? data["BetAmount"] : null;
            this.validBetAmount = data["ValidBetAmount"] !== undefined ? data["ValidBetAmount"] : null;
            this.payoutAmount = data["PayoutAmount"] !== undefined ? data["PayoutAmount"] : null;
        }
    }

    static fromJS(data: any): PlayerTransactionListGroupByUserDao {
        return new PlayerTransactionListGroupByUserDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        if (this.lobbyReferenceGroupIds && this.lobbyReferenceGroupIds.constructor === Array) {
            data["LobbyReferenceGroupIds"] = [];
            for (let item of this.lobbyReferenceGroupIds)
                data["LobbyReferenceGroupIds"].push(item);
        }
        data["LobbyReferenceGroupName"] = this.lobbyReferenceGroupName !== undefined ? this.lobbyReferenceGroupName : null;
        data["PhoneNo"] = this.phoneNo !== undefined ? this.phoneNo : null;
        data["RegistrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : null;
        data["AgentCode"] = this.agentCode !== undefined ? this.agentCode : null;
        data["PlayerGroupName"] = this.playerGroupName !== undefined ? this.playerGroupName : null;
        data["LatestDspositDate"] = this.latestDspositDate ? this.latestDspositDate.toISOString() : null;
        data["DepositCount"] = this.depositCount !== undefined ? this.depositCount : null;
        data["DepositAmount"] = this.depositAmount !== undefined ? this.depositAmount : null;
        data["AdminDepositCount"] = this.adminDepositCount !== undefined ? this.adminDepositCount : null;
        data["AdminDepositAmount"] = this.adminDepositAmount !== undefined ? this.adminDepositAmount : null;
        data["WithdrawCount"] = this.withdrawCount !== undefined ? this.withdrawCount : null;
        data["WithdrawAmount"] = this.withdrawAmount !== undefined ? this.withdrawAmount : null;
        data["BetCount"] = this.betCount !== undefined ? this.betCount : null;
        data["BetAmount"] = this.betAmount !== undefined ? this.betAmount : null;
        data["ValidBetAmount"] = this.validBetAmount !== undefined ? this.validBetAmount : null;
        data["PayoutAmount"] = this.payoutAmount !== undefined ? this.payoutAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerTransactionListGroupByUserDao(JSON.parse(json));
    }
}

export class PlayerBankAccountItemDao { 
    id: number; 
    playerId: number; 
    playerUserName: string; 
    playerRealName: string; 
    bankAccountNo: string; 
    bankCode: string; 
    displayName: string; 
    lobbyBankId: number; 
    lobbyBankName: string; 
    province: string; 
    city: string; 
    isEnable: boolean; 
    isDelete: boolean; 
    createDate: Date; 
    updateDate: Date; 
    updateBy: number; 
    updateByName: string; 
    isDefault: boolean; 
    branch: string; 
    bankNo: BankNo; 
    currencyId: CurrencyId; 
    currencyName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.playerUserName = data["PlayerUserName"] !== undefined ? data["PlayerUserName"] : null;
            this.playerRealName = data["PlayerRealName"] !== undefined ? data["PlayerRealName"] : null;
            this.bankAccountNo = data["BankAccountNo"] !== undefined ? data["BankAccountNo"] : null;
            this.bankCode = data["BankCode"] !== undefined ? data["BankCode"] : null;
            this.displayName = data["DisplayName"] !== undefined ? data["DisplayName"] : null;
            this.lobbyBankId = data["LobbyBankId"] !== undefined ? data["LobbyBankId"] : null;
            this.lobbyBankName = data["LobbyBankName"] !== undefined ? data["LobbyBankName"] : null;
            this.province = data["Province"] !== undefined ? data["Province"] : null;
            this.city = data["City"] !== undefined ? data["City"] : null;
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
            this.isDelete = data["IsDelete"] !== undefined ? data["IsDelete"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.updateByName = data["UpdateByName"] !== undefined ? data["UpdateByName"] : null;
            this.isDefault = data["IsDefault"] !== undefined ? data["IsDefault"] : null;
            this.branch = data["Branch"] !== undefined ? data["Branch"] : null;
            this.bankNo = data["BankNo"] !== undefined ? data["BankNo"] : null;
            this.currencyId = data["CurrencyId"] !== undefined ? data["CurrencyId"] : null;
            this.currencyName = data["CurrencyName"] !== undefined ? data["CurrencyName"] : null;
        }
    }

    static fromJS(data: any): PlayerBankAccountItemDao {
        return new PlayerBankAccountItemDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["PlayerUserName"] = this.playerUserName !== undefined ? this.playerUserName : null;
        data["PlayerRealName"] = this.playerRealName !== undefined ? this.playerRealName : null;
        data["BankAccountNo"] = this.bankAccountNo !== undefined ? this.bankAccountNo : null;
        data["BankCode"] = this.bankCode !== undefined ? this.bankCode : null;
        data["DisplayName"] = this.displayName !== undefined ? this.displayName : null;
        data["LobbyBankId"] = this.lobbyBankId !== undefined ? this.lobbyBankId : null;
        data["LobbyBankName"] = this.lobbyBankName !== undefined ? this.lobbyBankName : null;
        data["Province"] = this.province !== undefined ? this.province : null;
        data["City"] = this.city !== undefined ? this.city : null;
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        data["IsDelete"] = this.isDelete !== undefined ? this.isDelete : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["UpdateByName"] = this.updateByName !== undefined ? this.updateByName : null;
        data["IsDefault"] = this.isDefault !== undefined ? this.isDefault : null;
        data["Branch"] = this.branch !== undefined ? this.branch : null;
        data["BankNo"] = this.bankNo !== undefined ? this.bankNo : null;
        data["CurrencyId"] = this.currencyId !== undefined ? this.currencyId : null;
        data["CurrencyName"] = this.currencyName !== undefined ? this.currencyName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerBankAccountItemDao(JSON.parse(json));
    }
}

export enum BankNo {
    Agricultural_Bank_of_China = 1, 
    China_Construction_Bank = 2, 
    Industrial_and_Commercial_Bank_of_China = 3, 
    Bank_of_China = 4, 
    Bank_of_Communications = 5, 
    China_Merchants_Bank = 6, 
    China_Minsheng_Bank = 7, 
    China_Guangfa_Bank = 8, 
    China_Everbright_Bank = 9, 
    Hua_Xia_Bank = 10, 
    Industrial_Bank = 11, 
    Shenzhen_Develop_Bank = 12, 
    Pudong_Development_Bank = 13, 
    Bank_of_Beijing = 14, 
    Bank_of_Shanghai = 15, 
    Bank_of_DongGuan = 16, 
    Bank_of_Guangzhou = 17, 
    Bank_of_Hangzhou = 18, 
    China_Bohai_Bank = 19, 
    Hang_Seng_Bank = 20, 
    China_Citic_Bank = 21, 
    Postal_Savings_Bank_of_China = 22, 
    Ping_An_Bank = 23, 
    Other = 24, 
    Shanghai_Nongshang_Bank = 25, 
    China_UnionPay_CNP = 26, 
    China_UnionPay_Others = 27, 
    Bank_of_Tianjin = 28, 
    Bank_Of_Nanjing_Co = 29, 
    Bank_of_East_Asia = 30, 
    Zheshang_Bank = 31, 
    Guangzhou_Rural_Commercial_Bank = 32, 
    Beijing_Rural_Commercial_Bank = 33, 
    China_UnionPay = 34, 
    Bank_of_Ningbo = 35, 
    Huishang_Bank = 36, 
    QQ_wallet = 37, 
    HengFeng_Bank = 38, 
    KBANK = 39, 
    BANGKOK_BANK = 40, 
    KRUNGTHAI_BANK = 41, 
    SIAM_COMMERCIAL_BANK = 42, 
    Bank_of_Dalian = 43, 
    Xiamen_Bank = 44, 
    Bank_of_Chongqing = 45, 
    Bank_of_Jiangsu = 46, 
    Bank_of_Jining = 47, 
    Bank_of_Taizhou = 48, 
    ShengJing_Bank = 49, 
    ChongQing_Rural_Commercial_Bank = 50, 
    Shanghai_Rural_Commercial_Bank = 51, 
    Guangzhou_Rural_Commercial_Bank_2 = 52, 
    HaiXia_Bank_Of_FuJian = 53, 
    Bank_Of_SuZhou = 54, 
    Bank_Of_NingXia = 55, 
    Bank_Of_JinZhou = 56, 
    HarbinBank = 57, 
    Bank_Of_LanZhou = 58, 
    JiangXi_Bank = 59, 
    Bank_Of_JiuJiang = 60, 
    Bank_Of_WeiFang = 61, 
    Bank_Of_QuanZhou = 62, 
    Bank_Of_JiaXing = 63, 
    Bank_Of_LangFang = 64, 
    Zhejiang_Tailong_Commercial_Bank = 65, 
    Bank_of_Huzhou = 66, 
    Baoshang_Bank = 67, 
    GuiLin_Bank = 68, 
    Chongqing_Three_Gorges_Bank = 69, 
    Jinzhong_Bank = 70, 
    Ningbo_Commerce_Bank = 71, 
    Kunshan_Rural_Commercial_Bank = 72, 
    WuJiang_Rural_Commercial_Bank = 73, 
    Fu_Dian_Bank = 74, 
    GuangDong_NanYue_Bank = 75, 
    Hankou_Bank = 76, 
    Guangdong_Development_Bank = 77, 
    Shanghai_Pudong_Development_Bank = 78, 
    Beijing_Rural_Commercial_Bank_2 = 79, 
    Nanyang_Commercial_Bank = 80, 
    Bank_Of_Hebei = 81, 
    Bank_Of_Chengdu = 82, 
    Guangxi_Rural_Commercial = 83, 
    Chongqing_Rural_Commercial_Bank = 84, 
    The_Hongkong_and_Shanghai_Banking_Corporation_Limited = 85, 
    Guangdong_Rural_Commercial = 86, 
    Dongguan_Rural_Commercial_Bank = 87, 
    QingYuan_QingXin_HuiMin_Village_Bank = 88, 
    HuaRong_XiangJiang_Bank = 89, 
    Bank_Of_ChangSha = 90, 
    SPD_Rural_Bank = 91, 
    Hunan_Rural_Credit_Cooperatives_Union = 92, 
    JinShang_Bank = 93, 
    Bank_Of_ZhengZhou = 94, 
    Anqiu_Beihai_Rural_Bank = 95, 
    Shenzhen_Rural_Commercial_Bank = 96, 
    HSBC_China = 97, 
    BANK_FOR_AGRICULTURE_AND_AGRICULTURAL_COOPERATIVES = 98, 
    BANGKOK_BANK_PUBLIC_COMPANY_LTD = 99, 
    CIMB_THAI_BANK_PUBLIC_COMPANY_LTD = 100, 
    GOVERNMENT_SAVING_BANK = 101, 
    KIATNAKIN_BANK_PUBLIC_COMPANY_LIMITED = 102, 
    BANK_OF_AYUDHYA = 103, 
    KASIKORNBANK_PUBLIC_COMPANY_LIMITED = 104, 
    KRUNG_THAI_BANK_PUBLIC_COMPANY_LTD = 105, 
    SIAM_COMMERCIAL_BANK_PUBLIC_COMPANY_LTD = 106, 
    TMB_BANK_PUBLIC_COMPANY_LIMITED = 107, 
    Thanachart_Bank_Public_Company_Limited = 108, 
    UNITED_OVERSEAS_BANK_THAI_PUBLIC_COMPANY_LTD = 109, 
    ACB = 110, 
    BIDV = 111, 
    SACOMBANK = 112, 
    VIETINBANK = 113, 
    TECHCOMBANK = 114, 
    VIETCOMBANK = 115, 
    EXIMBANK = 116, 
    MOMOPAY = 117, 
    ZALOPAY = 118, 
    MBBANK = 119, 
    VPBANK = 120, 
    AGRIBANK = 121, 
    VIB = 122, 
    SHB = 123, 
    ABBANK = 124, 
    SCB = 125, 
    EIB = 126, 
    STB = 127, 
    DONGABANK = 128, 
    GPBank = 129, 
    Saigonbank = 130, 
    PG_Bank = 131, 
    Oceanbank = 132, 
    NamABank = 133, 
    TPB = 134, 
    HDB = 135, 
    VAB = 136, 
    Kien_Long_Bank = 137, 
    Bac_A_Bank = 138, 
    Viet_Capital_Bank = 139, 
    Lien_Viet_Post_Bank = 140, 
    Maritime_Bank = 141, 
    OCB = 142, 
    KASIKORNBANK_PCL = 143, 
    BANGKOK_BANK_PUBLIC_COMPANY_LTD_2 = 144, 
    BANK_OF_AMERICA_NT_SA = 145, 
    BANK_OF_AYUDHAYA_PUBLIC_COMPANY_LTD = 146, 
    Bank_of_China_Thai_PCL = 147, 
    BNP_PARIBAS_BANGKOK_BRANCH = 148, 
    CIMB_THAI_BANK_PUBLIC_COMPANY_LTD_2 = 149, 
    CITI_BANK_NA = 150, 
    Deutsche_Bank_AG = 151, 
    GOVERNMENT_HOUSING_BANK = 152, 
    INDUSTRIAL_AND_COMMERCIAL_BANK_OF_CHINA_THAI_PCL = 153, 
    ISLAMIC_BANK_OF_THAILAND = 154, 
    JPMorgan_Chase_Bank = 155, 
    _Bangkok_Branch = 155, 
    KIATNAKIN_BANK_PCL = 156, 
    Land_and_Houses_Bank = 157, 
    MEGA__INTERNATIONAL_COMMERCIAL_BANK = 158, 
    MIZUHO_CORPORATE_BANK = 159, 
    STANDARD_CHARTERED_BANK_THAI_PCL = 160, 
    Sumitomo_Mitsui_Trust_Bank_Thai_PCL = 161, 
    THE_GOVERNMENT_SAVING_BANK = 162, 
    THE_HONGKONG_SHANGHAI_CORPORATION_LTD = 163, 
    THE_SIAM_COMMERCIAL_BANK_PUBLIC_COMPANY = 164, 
    THE_SUMITOMO_MITSU_BANKING_CORPORATION = 165, 
    THE_THAI_CREDIT_RETAIL_BANK = 166, 
    TISCO_Bank_PCL = 167, 
    TMB_BANK_PUBLIC_COMPANY_LTD = 168, 
    TMB_THANACHART_BANK = 169, 
    STANDARD_CHARTERED_BANK = 170, 
    JOINT_DEVELOPMENT_BANK = 171, 
    BANQUE_POUR_LE_COMMERCE = 172, 
    TRUE_WALLET = 173, 
}

export class StandardResponseOfPlayerBankAccountGetByPlayerNameResponse { 
    isSuccess: boolean; 
    payload: PlayerBankAccountGetByPlayerNameResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? PlayerBankAccountGetByPlayerNameResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfPlayerBankAccountGetByPlayerNameResponse {
        return new StandardResponseOfPlayerBankAccountGetByPlayerNameResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfPlayerBankAccountGetByPlayerNameResponse(JSON.parse(json));
    }
}

export class PlayerBankAccountGetByPlayerNameResponse { 
    playerId: number; 
    playerUserName: string; 
    playerRealName: string; 
    playerBankAccounts: PlayerBankAccountItemDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.playerUserName = data["PlayerUserName"] !== undefined ? data["PlayerUserName"] : null;
            this.playerRealName = data["PlayerRealName"] !== undefined ? data["PlayerRealName"] : null;
            if (data["PlayerBankAccounts"] && data["PlayerBankAccounts"].constructor === Array) {
                this.playerBankAccounts = [];
                for (let item of data["PlayerBankAccounts"])
                    this.playerBankAccounts.push(PlayerBankAccountItemDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerBankAccountGetByPlayerNameResponse {
        return new PlayerBankAccountGetByPlayerNameResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["PlayerUserName"] = this.playerUserName !== undefined ? this.playerUserName : null;
        data["PlayerRealName"] = this.playerRealName !== undefined ? this.playerRealName : null;
        if (this.playerBankAccounts && this.playerBankAccounts.constructor === Array) {
            data["PlayerBankAccounts"] = [];
            for (let item of this.playerBankAccounts)
                data["PlayerBankAccounts"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerBankAccountGetByPlayerNameResponse(JSON.parse(json));
    }
}

export class PlayerBankAccountCreateRequestDao { 
    playerId: number; 
    bankAccountNo: string; 
    displayName: string; 
    lobbyBankId: number; 
    province: string; 
    city: string; 
    isEnable: boolean; 
    branch: string; 
    playerRealName: string; 
    currencyId: CurrencyId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.bankAccountNo = data["BankAccountNo"] !== undefined ? data["BankAccountNo"] : null;
            this.displayName = data["DisplayName"] !== undefined ? data["DisplayName"] : null;
            this.lobbyBankId = data["LobbyBankId"] !== undefined ? data["LobbyBankId"] : null;
            this.province = data["Province"] !== undefined ? data["Province"] : null;
            this.city = data["City"] !== undefined ? data["City"] : null;
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
            this.branch = data["Branch"] !== undefined ? data["Branch"] : null;
            this.playerRealName = data["PlayerRealName"] !== undefined ? data["PlayerRealName"] : null;
            this.currencyId = data["CurrencyId"] !== undefined ? data["CurrencyId"] : null;
        }
    }

    static fromJS(data: any): PlayerBankAccountCreateRequestDao {
        return new PlayerBankAccountCreateRequestDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["BankAccountNo"] = this.bankAccountNo !== undefined ? this.bankAccountNo : null;
        data["DisplayName"] = this.displayName !== undefined ? this.displayName : null;
        data["LobbyBankId"] = this.lobbyBankId !== undefined ? this.lobbyBankId : null;
        data["Province"] = this.province !== undefined ? this.province : null;
        data["City"] = this.city !== undefined ? this.city : null;
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        data["Branch"] = this.branch !== undefined ? this.branch : null;
        data["PlayerRealName"] = this.playerRealName !== undefined ? this.playerRealName : null;
        data["CurrencyId"] = this.currencyId !== undefined ? this.currencyId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerBankAccountCreateRequestDao(JSON.parse(json));
    }
}

export class StandardResponseOfPlayerBankAccountGetForAddResponse { 
    isSuccess: boolean; 
    payload: PlayerBankAccountGetForAddResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? PlayerBankAccountGetForAddResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfPlayerBankAccountGetForAddResponse {
        return new StandardResponseOfPlayerBankAccountGetForAddResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfPlayerBankAccountGetForAddResponse(JSON.parse(json));
    }
}

export class PlayerBankAccountGetForAddResponse { 
    playerBankAccountOptions: CmsSelectionOptionDao[]; 
    currencyOptions: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["PlayerBankAccountOptions"] && data["PlayerBankAccountOptions"].constructor === Array) {
                this.playerBankAccountOptions = [];
                for (let item of data["PlayerBankAccountOptions"])
                    this.playerBankAccountOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["CurrencyOptions"] && data["CurrencyOptions"].constructor === Array) {
                this.currencyOptions = [];
                for (let item of data["CurrencyOptions"])
                    this.currencyOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerBankAccountGetForAddResponse {
        return new PlayerBankAccountGetForAddResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.playerBankAccountOptions && this.playerBankAccountOptions.constructor === Array) {
            data["PlayerBankAccountOptions"] = [];
            for (let item of this.playerBankAccountOptions)
                data["PlayerBankAccountOptions"].push(item.toJS());
        }
        if (this.currencyOptions && this.currencyOptions.constructor === Array) {
            data["CurrencyOptions"] = [];
            for (let item of this.currencyOptions)
                data["CurrencyOptions"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerBankAccountGetForAddResponse(JSON.parse(json));
    }
}

export class PlayerDetailsResponse { 
    id: number; 
    currency: number; 
    userId: string; 
    name: string; 
    amount: number; 
    playerLevelId: number; 
    playerGroupId: number; 
    giftPointAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.currency = data["Currency"] !== undefined ? data["Currency"] : null;
            this.userId = data["UserId"] !== undefined ? data["UserId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.playerLevelId = data["PlayerLevelId"] !== undefined ? data["PlayerLevelId"] : null;
            this.playerGroupId = data["PlayerGroupId"] !== undefined ? data["PlayerGroupId"] : null;
            this.giftPointAmount = data["GiftPointAmount"] !== undefined ? data["GiftPointAmount"] : null;
        }
    }

    static fromJS(data: any): PlayerDetailsResponse {
        return new PlayerDetailsResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Currency"] = this.currency !== undefined ? this.currency : null;
        data["UserId"] = this.userId !== undefined ? this.userId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["PlayerLevelId"] = this.playerLevelId !== undefined ? this.playerLevelId : null;
        data["PlayerGroupId"] = this.playerGroupId !== undefined ? this.playerGroupId : null;
        data["GiftPointAmount"] = this.giftPointAmount !== undefined ? this.giftPointAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerDetailsResponse(JSON.parse(json));
    }
}

export class PlayerGetForSectionsResponse { 
    lobbyPlayerLevelSection: CmsSelectionOptionDao[]; 
    lobbyPlayerGroupSection: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["LobbyPlayerLevelSection"] && data["LobbyPlayerLevelSection"].constructor === Array) {
                this.lobbyPlayerLevelSection = [];
                for (let item of data["LobbyPlayerLevelSection"])
                    this.lobbyPlayerLevelSection.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["LobbyPlayerGroupSection"] && data["LobbyPlayerGroupSection"].constructor === Array) {
                this.lobbyPlayerGroupSection = [];
                for (let item of data["LobbyPlayerGroupSection"])
                    this.lobbyPlayerGroupSection.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerGetForSectionsResponse {
        return new PlayerGetForSectionsResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.lobbyPlayerLevelSection && this.lobbyPlayerLevelSection.constructor === Array) {
            data["LobbyPlayerLevelSection"] = [];
            for (let item of this.lobbyPlayerLevelSection)
                data["LobbyPlayerLevelSection"].push(item.toJS());
        }
        if (this.lobbyPlayerGroupSection && this.lobbyPlayerGroupSection.constructor === Array) {
            data["LobbyPlayerGroupSection"] = [];
            for (let item of this.lobbyPlayerGroupSection)
                data["LobbyPlayerGroupSection"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGetForSectionsResponse(JSON.parse(json));
    }
}

export class FilterRequest { 
    startDate: Date; 
    endDate: Date; 
    username: string; 
    personalName: string; 
    email: string; 
    phoneNumber: string; 
    filterOptionId: number; 
    promotionCode: string; 
    playerPromoCode: string; 
    bankAccountNo: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.username = data["Username"] !== undefined ? data["Username"] : null;
            this.personalName = data["PersonalName"] !== undefined ? data["PersonalName"] : null;
            this.email = data["Email"] !== undefined ? data["Email"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.filterOptionId = data["FilterOptionId"] !== undefined ? data["FilterOptionId"] : null;
            this.promotionCode = data["PromotionCode"] !== undefined ? data["PromotionCode"] : null;
            this.playerPromoCode = data["PlayerPromoCode"] !== undefined ? data["PlayerPromoCode"] : null;
            this.bankAccountNo = data["BankAccountNo"] !== undefined ? data["BankAccountNo"] : null;
        }
    }

    static fromJS(data: any): FilterRequest {
        return new FilterRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["Username"] = this.username !== undefined ? this.username : null;
        data["PersonalName"] = this.personalName !== undefined ? this.personalName : null;
        data["Email"] = this.email !== undefined ? this.email : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["FilterOptionId"] = this.filterOptionId !== undefined ? this.filterOptionId : null;
        data["PromotionCode"] = this.promotionCode !== undefined ? this.promotionCode : null;
        data["PlayerPromoCode"] = this.playerPromoCode !== undefined ? this.playerPromoCode : null;
        data["BankAccountNo"] = this.bankAccountNo !== undefined ? this.bankAccountNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new FilterRequest(JSON.parse(json));
    }
}

export class PlayerItem { 
    id: number; 
    name: string; 
    personalName: string; 
    email: string; 
    phoneNumber: string; 
    currency: string; 
    amount: number; 
    playerLevelId: number; 
    playerLevelName: string; 
    playerGroupId: number; 
    playerGroupName: string; 
    playerGroupColor: string; 
    sex: string; 
    registerDate: Date; 
    registerIP: string; 
    latestLoginDate: Date; 
    latestLoginIP: string; 
    isEnableLogin: boolean; 
    isEnablePlay: boolean; 
    dOB: Date; 
    lobbyAgentId: number; 
    lobbyAgentName: string; 
    promotionCode: string; 
    promotionUrl: string; 
    lobbyAgentUrl: string; 
    lobbyAgentNameWithPromotionCode: string; 
    playerPromoCode: string; 
    isUpdatePlayerLevelGroupId: boolean; 
    latestSettleDepositDate: Date; 
    registerFromDomain: string; 
    isEnableLogin_Readonly: boolean; 
    isEnablePlay_Readonly: boolean; 
    isEnablePlay_ByPlatform_Readonly: boolean; 
    isCompletePhoneNumber: boolean; 
    deviceTypeIdFrom: UserDeviceTypeId; 
    deviceTypeFrom: string; 
    latestDeviceTypeIdFrom: UserDeviceTypeId; 
    latestDeviceTypeFrom: string; 
    expLvId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.personalName = data["PersonalName"] !== undefined ? data["PersonalName"] : null;
            this.email = data["Email"] !== undefined ? data["Email"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.currency = data["Currency"] !== undefined ? data["Currency"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.playerLevelId = data["PlayerLevelId"] !== undefined ? data["PlayerLevelId"] : null;
            this.playerLevelName = data["PlayerLevelName"] !== undefined ? data["PlayerLevelName"] : null;
            this.playerGroupId = data["PlayerGroupId"] !== undefined ? data["PlayerGroupId"] : null;
            this.playerGroupName = data["PlayerGroupName"] !== undefined ? data["PlayerGroupName"] : null;
            this.playerGroupColor = data["PlayerGroupColor"] !== undefined ? data["PlayerGroupColor"] : null;
            this.sex = data["Sex"] !== undefined ? data["Sex"] : null;
            this.registerDate = data["RegisterDate"] ? new Date(data["RegisterDate"].toString()) : null;
            this.registerIP = data["RegisterIP"] !== undefined ? data["RegisterIP"] : null;
            this.latestLoginDate = data["LatestLoginDate"] ? new Date(data["LatestLoginDate"].toString()) : null;
            this.latestLoginIP = data["LatestLoginIP"] !== undefined ? data["LatestLoginIP"] : null;
            this.isEnableLogin = data["IsEnableLogin"] !== undefined ? data["IsEnableLogin"] : null;
            this.isEnablePlay = data["IsEnablePlay"] !== undefined ? data["IsEnablePlay"] : null;
            this.dOB = data["DOB"] ? new Date(data["DOB"].toString()) : null;
            this.lobbyAgentId = data["LobbyAgentId"] !== undefined ? data["LobbyAgentId"] : null;
            this.lobbyAgentName = data["LobbyAgentName"] !== undefined ? data["LobbyAgentName"] : null;
            this.promotionCode = data["PromotionCode"] !== undefined ? data["PromotionCode"] : null;
            this.promotionUrl = data["PromotionUrl"] !== undefined ? data["PromotionUrl"] : null;
            this.lobbyAgentUrl = data["LobbyAgentUrl"] !== undefined ? data["LobbyAgentUrl"] : null;
            this.lobbyAgentNameWithPromotionCode = data["LobbyAgentNameWithPromotionCode"] !== undefined ? data["LobbyAgentNameWithPromotionCode"] : null;
            this.playerPromoCode = data["PlayerPromoCode"] !== undefined ? data["PlayerPromoCode"] : null;
            this.isUpdatePlayerLevelGroupId = data["IsUpdatePlayerLevelGroupId"] !== undefined ? data["IsUpdatePlayerLevelGroupId"] : null;
            this.latestSettleDepositDate = data["LatestSettleDepositDate"] ? new Date(data["LatestSettleDepositDate"].toString()) : null;
            this.registerFromDomain = data["RegisterFromDomain"] !== undefined ? data["RegisterFromDomain"] : null;
            this.isEnableLogin_Readonly = data["IsEnableLogin_Readonly"] !== undefined ? data["IsEnableLogin_Readonly"] : null;
            this.isEnablePlay_Readonly = data["IsEnablePlay_Readonly"] !== undefined ? data["IsEnablePlay_Readonly"] : null;
            this.isEnablePlay_ByPlatform_Readonly = data["IsEnablePlay_ByPlatform_Readonly"] !== undefined ? data["IsEnablePlay_ByPlatform_Readonly"] : null;
            this.isCompletePhoneNumber = data["IsCompletePhoneNumber"] !== undefined ? data["IsCompletePhoneNumber"] : null;
            this.deviceTypeIdFrom = data["DeviceTypeIdFrom"] !== undefined ? data["DeviceTypeIdFrom"] : null;
            this.deviceTypeFrom = data["DeviceTypeFrom"] !== undefined ? data["DeviceTypeFrom"] : null;
            this.latestDeviceTypeIdFrom = data["LatestDeviceTypeIdFrom"] !== undefined ? data["LatestDeviceTypeIdFrom"] : null;
            this.latestDeviceTypeFrom = data["LatestDeviceTypeFrom"] !== undefined ? data["LatestDeviceTypeFrom"] : null;
            this.expLvId = data["ExpLvId"] !== undefined ? data["ExpLvId"] : null;
        }
    }

    static fromJS(data: any): PlayerItem {
        return new PlayerItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["PersonalName"] = this.personalName !== undefined ? this.personalName : null;
        data["Email"] = this.email !== undefined ? this.email : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["Currency"] = this.currency !== undefined ? this.currency : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["PlayerLevelId"] = this.playerLevelId !== undefined ? this.playerLevelId : null;
        data["PlayerLevelName"] = this.playerLevelName !== undefined ? this.playerLevelName : null;
        data["PlayerGroupId"] = this.playerGroupId !== undefined ? this.playerGroupId : null;
        data["PlayerGroupName"] = this.playerGroupName !== undefined ? this.playerGroupName : null;
        data["PlayerGroupColor"] = this.playerGroupColor !== undefined ? this.playerGroupColor : null;
        data["Sex"] = this.sex !== undefined ? this.sex : null;
        data["RegisterDate"] = this.registerDate ? this.registerDate.toISOString() : null;
        data["RegisterIP"] = this.registerIP !== undefined ? this.registerIP : null;
        data["LatestLoginDate"] = this.latestLoginDate ? this.latestLoginDate.toISOString() : null;
        data["LatestLoginIP"] = this.latestLoginIP !== undefined ? this.latestLoginIP : null;
        data["IsEnableLogin"] = this.isEnableLogin !== undefined ? this.isEnableLogin : null;
        data["IsEnablePlay"] = this.isEnablePlay !== undefined ? this.isEnablePlay : null;
        data["DOB"] = this.dOB ? this.dOB.toISOString() : null;
        data["LobbyAgentId"] = this.lobbyAgentId !== undefined ? this.lobbyAgentId : null;
        data["LobbyAgentName"] = this.lobbyAgentName !== undefined ? this.lobbyAgentName : null;
        data["PromotionCode"] = this.promotionCode !== undefined ? this.promotionCode : null;
        data["PromotionUrl"] = this.promotionUrl !== undefined ? this.promotionUrl : null;
        data["LobbyAgentUrl"] = this.lobbyAgentUrl !== undefined ? this.lobbyAgentUrl : null;
        data["LobbyAgentNameWithPromotionCode"] = this.lobbyAgentNameWithPromotionCode !== undefined ? this.lobbyAgentNameWithPromotionCode : null;
        data["PlayerPromoCode"] = this.playerPromoCode !== undefined ? this.playerPromoCode : null;
        data["IsUpdatePlayerLevelGroupId"] = this.isUpdatePlayerLevelGroupId !== undefined ? this.isUpdatePlayerLevelGroupId : null;
        data["LatestSettleDepositDate"] = this.latestSettleDepositDate ? this.latestSettleDepositDate.toISOString() : null;
        data["RegisterFromDomain"] = this.registerFromDomain !== undefined ? this.registerFromDomain : null;
        data["IsEnableLogin_Readonly"] = this.isEnableLogin_Readonly !== undefined ? this.isEnableLogin_Readonly : null;
        data["IsEnablePlay_Readonly"] = this.isEnablePlay_Readonly !== undefined ? this.isEnablePlay_Readonly : null;
        data["IsEnablePlay_ByPlatform_Readonly"] = this.isEnablePlay_ByPlatform_Readonly !== undefined ? this.isEnablePlay_ByPlatform_Readonly : null;
        data["IsCompletePhoneNumber"] = this.isCompletePhoneNumber !== undefined ? this.isCompletePhoneNumber : null;
        data["DeviceTypeIdFrom"] = this.deviceTypeIdFrom !== undefined ? this.deviceTypeIdFrom : null;
        data["DeviceTypeFrom"] = this.deviceTypeFrom !== undefined ? this.deviceTypeFrom : null;
        data["LatestDeviceTypeIdFrom"] = this.latestDeviceTypeIdFrom !== undefined ? this.latestDeviceTypeIdFrom : null;
        data["LatestDeviceTypeFrom"] = this.latestDeviceTypeFrom !== undefined ? this.latestDeviceTypeFrom : null;
        data["ExpLvId"] = this.expLvId !== undefined ? this.expLvId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerItem(JSON.parse(json));
    }
}

export class GetForPlayerEditResponse { 
    lobbyPlayerLevelOptions: CmsSelectionOptionDao[]; 
    lobbyPlayerGroupOptions: CmsSelectionOptionDao[]; 
    countryOptions: CmsSelectionOptionDao[]; 
    player: PlayerInfo; 
    playerBankAccounts: BankCard[]; 
    playerCryptocurrencyAddresses: GetForPlayerEditCryptocurrency[]; 
    lobbyReferenceGroupOptions: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["LobbyPlayerLevelOptions"] && data["LobbyPlayerLevelOptions"].constructor === Array) {
                this.lobbyPlayerLevelOptions = [];
                for (let item of data["LobbyPlayerLevelOptions"])
                    this.lobbyPlayerLevelOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["LobbyPlayerGroupOptions"] && data["LobbyPlayerGroupOptions"].constructor === Array) {
                this.lobbyPlayerGroupOptions = [];
                for (let item of data["LobbyPlayerGroupOptions"])
                    this.lobbyPlayerGroupOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["CountryOptions"] && data["CountryOptions"].constructor === Array) {
                this.countryOptions = [];
                for (let item of data["CountryOptions"])
                    this.countryOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
            this.player = data["Player"] ? PlayerInfo.fromJS(data["Player"]) : null;
            if (data["PlayerBankAccounts"] && data["PlayerBankAccounts"].constructor === Array) {
                this.playerBankAccounts = [];
                for (let item of data["PlayerBankAccounts"])
                    this.playerBankAccounts.push(BankCard.fromJS(item));
            }
            if (data["PlayerCryptocurrencyAddresses"] && data["PlayerCryptocurrencyAddresses"].constructor === Array) {
                this.playerCryptocurrencyAddresses = [];
                for (let item of data["PlayerCryptocurrencyAddresses"])
                    this.playerCryptocurrencyAddresses.push(GetForPlayerEditCryptocurrency.fromJS(item));
            }
            if (data["LobbyReferenceGroupOptions"] && data["LobbyReferenceGroupOptions"].constructor === Array) {
                this.lobbyReferenceGroupOptions = [];
                for (let item of data["LobbyReferenceGroupOptions"])
                    this.lobbyReferenceGroupOptions.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetForPlayerEditResponse {
        return new GetForPlayerEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.lobbyPlayerLevelOptions && this.lobbyPlayerLevelOptions.constructor === Array) {
            data["LobbyPlayerLevelOptions"] = [];
            for (let item of this.lobbyPlayerLevelOptions)
                data["LobbyPlayerLevelOptions"].push(item.toJS());
        }
        if (this.lobbyPlayerGroupOptions && this.lobbyPlayerGroupOptions.constructor === Array) {
            data["LobbyPlayerGroupOptions"] = [];
            for (let item of this.lobbyPlayerGroupOptions)
                data["LobbyPlayerGroupOptions"].push(item.toJS());
        }
        if (this.countryOptions && this.countryOptions.constructor === Array) {
            data["CountryOptions"] = [];
            for (let item of this.countryOptions)
                data["CountryOptions"].push(item.toJS());
        }
        data["Player"] = this.player ? this.player.toJS() : null;
        if (this.playerBankAccounts && this.playerBankAccounts.constructor === Array) {
            data["PlayerBankAccounts"] = [];
            for (let item of this.playerBankAccounts)
                data["PlayerBankAccounts"].push(item.toJS());
        }
        if (this.playerCryptocurrencyAddresses && this.playerCryptocurrencyAddresses.constructor === Array) {
            data["PlayerCryptocurrencyAddresses"] = [];
            for (let item of this.playerCryptocurrencyAddresses)
                data["PlayerCryptocurrencyAddresses"].push(item.toJS());
        }
        if (this.lobbyReferenceGroupOptions && this.lobbyReferenceGroupOptions.constructor === Array) {
            data["LobbyReferenceGroupOptions"] = [];
            for (let item of this.lobbyReferenceGroupOptions)
                data["LobbyReferenceGroupOptions"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetForPlayerEditResponse(JSON.parse(json));
    }
}

export class PlayerInfo { 
    id: number; 
    username: string; 
    playerAccount: number; 
    lobbyPlayerLevelId: number; 
    lobbyPlayerGroupId: number; 
    personalName: string; 
    dOB: Date; 
    sex: string; 
    countryId: number; 
    phoneNumber: string; 
    email: string; 
    registerIP: string; 
    registerTime: Date; 
    latestLoginIP: string; 
    latestLoginTime: Date; 
    isEnableLogin: boolean; 
    isEnablePlay: boolean; 
    isEnableAutoRebate: boolean; 
    promoCode: string; 
    balanceAmount: number; 
    depositTotalAmount: number; 
    withdrawTotalAmount: number; 
    registerFromDomain: string; 
    emailConfirmed: boolean; 
    phoneNumberConfirmed: boolean; 
    latestSettleDepositDate: Date; 
    remark: string; 
    expLvId: number; 
    latestSettleDepositTransactionNo: string; 
    latestSettleWithdrawTransactionNo: string; 
    inProgessingAutoPromotionName: string; 
    isAutoPromotionByPassPlayerWithdrawApplyChecking: boolean; 
    lobbyReferenceGroupIds: number[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.username = data["Username"] !== undefined ? data["Username"] : null;
            this.playerAccount = data["playerAccount"] !== undefined ? data["playerAccount"] : null;
            this.lobbyPlayerLevelId = data["LobbyPlayerLevelId"] !== undefined ? data["LobbyPlayerLevelId"] : null;
            this.lobbyPlayerGroupId = data["LobbyPlayerGroupId"] !== undefined ? data["LobbyPlayerGroupId"] : null;
            this.personalName = data["PersonalName"] !== undefined ? data["PersonalName"] : null;
            this.dOB = data["DOB"] ? new Date(data["DOB"].toString()) : null;
            this.sex = data["Sex"] !== undefined ? data["Sex"] : null;
            this.countryId = data["CountryId"] !== undefined ? data["CountryId"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.email = data["Email"] !== undefined ? data["Email"] : null;
            this.registerIP = data["RegisterIP"] !== undefined ? data["RegisterIP"] : null;
            this.registerTime = data["RegisterTime"] ? new Date(data["RegisterTime"].toString()) : null;
            this.latestLoginIP = data["LatestLoginIP"] !== undefined ? data["LatestLoginIP"] : null;
            this.latestLoginTime = data["LatestLoginTime"] ? new Date(data["LatestLoginTime"].toString()) : null;
            this.isEnableLogin = data["IsEnableLogin"] !== undefined ? data["IsEnableLogin"] : null;
            this.isEnablePlay = data["IsEnablePlay"] !== undefined ? data["IsEnablePlay"] : null;
            this.isEnableAutoRebate = data["IsEnableAutoRebate"] !== undefined ? data["IsEnableAutoRebate"] : null;
            this.promoCode = data["PromoCode"] !== undefined ? data["PromoCode"] : null;
            this.balanceAmount = data["BalanceAmount"] !== undefined ? data["BalanceAmount"] : null;
            this.depositTotalAmount = data["DepositTotalAmount"] !== undefined ? data["DepositTotalAmount"] : null;
            this.withdrawTotalAmount = data["WithdrawTotalAmount"] !== undefined ? data["WithdrawTotalAmount"] : null;
            this.registerFromDomain = data["RegisterFromDomain"] !== undefined ? data["RegisterFromDomain"] : null;
            this.emailConfirmed = data["EmailConfirmed"] !== undefined ? data["EmailConfirmed"] : null;
            this.phoneNumberConfirmed = data["PhoneNumberConfirmed"] !== undefined ? data["PhoneNumberConfirmed"] : null;
            this.latestSettleDepositDate = data["LatestSettleDepositDate"] ? new Date(data["LatestSettleDepositDate"].toString()) : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.expLvId = data["ExpLvId"] !== undefined ? data["ExpLvId"] : null;
            this.latestSettleDepositTransactionNo = data["LatestSettleDepositTransactionNo"] !== undefined ? data["LatestSettleDepositTransactionNo"] : null;
            this.latestSettleWithdrawTransactionNo = data["LatestSettleWithdrawTransactionNo"] !== undefined ? data["LatestSettleWithdrawTransactionNo"] : null;
            this.inProgessingAutoPromotionName = data["InProgessingAutoPromotionName"] !== undefined ? data["InProgessingAutoPromotionName"] : null;
            this.isAutoPromotionByPassPlayerWithdrawApplyChecking = data["IsAutoPromotionByPassPlayerWithdrawApplyChecking"] !== undefined ? data["IsAutoPromotionByPassPlayerWithdrawApplyChecking"] : null;
            if (data["LobbyReferenceGroupIds"] && data["LobbyReferenceGroupIds"].constructor === Array) {
                this.lobbyReferenceGroupIds = [];
                for (let item of data["LobbyReferenceGroupIds"])
                    this.lobbyReferenceGroupIds.push(item);
            }
        }
    }

    static fromJS(data: any): PlayerInfo {
        return new PlayerInfo(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Username"] = this.username !== undefined ? this.username : null;
        data["playerAccount"] = this.playerAccount !== undefined ? this.playerAccount : null;
        data["LobbyPlayerLevelId"] = this.lobbyPlayerLevelId !== undefined ? this.lobbyPlayerLevelId : null;
        data["LobbyPlayerGroupId"] = this.lobbyPlayerGroupId !== undefined ? this.lobbyPlayerGroupId : null;
        data["PersonalName"] = this.personalName !== undefined ? this.personalName : null;
        data["DOB"] = this.dOB ? this.dOB.toISOString() : null;
        data["Sex"] = this.sex !== undefined ? this.sex : null;
        data["CountryId"] = this.countryId !== undefined ? this.countryId : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["Email"] = this.email !== undefined ? this.email : null;
        data["RegisterIP"] = this.registerIP !== undefined ? this.registerIP : null;
        data["RegisterTime"] = this.registerTime ? this.registerTime.toISOString() : null;
        data["LatestLoginIP"] = this.latestLoginIP !== undefined ? this.latestLoginIP : null;
        data["LatestLoginTime"] = this.latestLoginTime ? this.latestLoginTime.toISOString() : null;
        data["IsEnableLogin"] = this.isEnableLogin !== undefined ? this.isEnableLogin : null;
        data["IsEnablePlay"] = this.isEnablePlay !== undefined ? this.isEnablePlay : null;
        data["IsEnableAutoRebate"] = this.isEnableAutoRebate !== undefined ? this.isEnableAutoRebate : null;
        data["PromoCode"] = this.promoCode !== undefined ? this.promoCode : null;
        data["BalanceAmount"] = this.balanceAmount !== undefined ? this.balanceAmount : null;
        data["DepositTotalAmount"] = this.depositTotalAmount !== undefined ? this.depositTotalAmount : null;
        data["WithdrawTotalAmount"] = this.withdrawTotalAmount !== undefined ? this.withdrawTotalAmount : null;
        data["RegisterFromDomain"] = this.registerFromDomain !== undefined ? this.registerFromDomain : null;
        data["EmailConfirmed"] = this.emailConfirmed !== undefined ? this.emailConfirmed : null;
        data["PhoneNumberConfirmed"] = this.phoneNumberConfirmed !== undefined ? this.phoneNumberConfirmed : null;
        data["LatestSettleDepositDate"] = this.latestSettleDepositDate ? this.latestSettleDepositDate.toISOString() : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["ExpLvId"] = this.expLvId !== undefined ? this.expLvId : null;
        data["LatestSettleDepositTransactionNo"] = this.latestSettleDepositTransactionNo !== undefined ? this.latestSettleDepositTransactionNo : null;
        data["LatestSettleWithdrawTransactionNo"] = this.latestSettleWithdrawTransactionNo !== undefined ? this.latestSettleWithdrawTransactionNo : null;
        data["InProgessingAutoPromotionName"] = this.inProgessingAutoPromotionName !== undefined ? this.inProgessingAutoPromotionName : null;
        data["IsAutoPromotionByPassPlayerWithdrawApplyChecking"] = this.isAutoPromotionByPassPlayerWithdrawApplyChecking !== undefined ? this.isAutoPromotionByPassPlayerWithdrawApplyChecking : null;
        if (this.lobbyReferenceGroupIds && this.lobbyReferenceGroupIds.constructor === Array) {
            data["LobbyReferenceGroupIds"] = [];
            for (let item of this.lobbyReferenceGroupIds)
                data["LobbyReferenceGroupIds"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerInfo(JSON.parse(json));
    }
}

export class BankCard { 
    bankCardName: string; 
    bankCardNo: string; 
    isDefault: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.bankCardName = data["BankCardName"] !== undefined ? data["BankCardName"] : null;
            this.bankCardNo = data["BankCardNo"] !== undefined ? data["BankCardNo"] : null;
            this.isDefault = data["IsDefault"] !== undefined ? data["IsDefault"] : null;
        }
    }

    static fromJS(data: any): BankCard {
        return new BankCard(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["BankCardName"] = this.bankCardName !== undefined ? this.bankCardName : null;
        data["BankCardNo"] = this.bankCardNo !== undefined ? this.bankCardNo : null;
        data["IsDefault"] = this.isDefault !== undefined ? this.isDefault : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new BankCard(JSON.parse(json));
    }
}

export class GetForPlayerEditCryptocurrency { 
    id: number; 
    currency: string; 
    address: string; 
    isDefault: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.currency = data["Currency"] !== undefined ? data["Currency"] : null;
            this.address = data["Address"] !== undefined ? data["Address"] : null;
            this.isDefault = data["IsDefault"] !== undefined ? data["IsDefault"] : null;
        }
    }

    static fromJS(data: any): GetForPlayerEditCryptocurrency {
        return new GetForPlayerEditCryptocurrency(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Currency"] = this.currency !== undefined ? this.currency : null;
        data["Address"] = this.address !== undefined ? this.address : null;
        data["IsDefault"] = this.isDefault !== undefined ? this.isDefault : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetForPlayerEditCryptocurrency(JSON.parse(json));
    }
}

export class LobbyPlayerLevelLanguageResponse { 
    id: number; 
    lobbyPlayerLevelId: number; 
    languageId: number; 
    name: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.lobbyPlayerLevelId = data["LobbyPlayerLevelId"] !== undefined ? data["LobbyPlayerLevelId"] : null;
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
        }
    }

    static fromJS(data: any): LobbyPlayerLevelLanguageResponse {
        return new LobbyPlayerLevelLanguageResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["LobbyPlayerLevelId"] = this.lobbyPlayerLevelId !== undefined ? this.lobbyPlayerLevelId : null;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerLevelLanguageResponse(JSON.parse(json));
    }
}

export class LobbyPlayerGroupResponse { 
    id: number; 
    lobbyId: number; 
    name: string; 
    isDefault: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.isDefault = data["IsDefault"] !== undefined ? data["IsDefault"] : null;
        }
    }

    static fromJS(data: any): LobbyPlayerGroupResponse {
        return new LobbyPlayerGroupResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["IsDefault"] = this.isDefault !== undefined ? this.isDefault : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyPlayerGroupResponse(JSON.parse(json));
    }
}

export class EditPlayerRequest { 
    playerId: number; 
    newPassword: string; 
    confirmNewPassword: string; 
    lobbyPlayerGroupId: number; 
    lobbyPlayerLevelId: number; 
    personalName: string; 
    dOB: Date; 
    sex: string; 
    countryId: number; 
    phoneNumber: string; 
    email: string; 
    newWithdrawPassword: string; 
    confirmNewWithdrawPassword: string; 
    isEnableLogin: boolean; 
    isEnablePlay: boolean; 
    isEnableAutoRebate: boolean; 
    emailConfirmed: boolean; 
    phoneNumberConfirmed: boolean; 
    remark: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.newPassword = data["NewPassword"] !== undefined ? data["NewPassword"] : null;
            this.confirmNewPassword = data["ConfirmNewPassword"] !== undefined ? data["ConfirmNewPassword"] : null;
            this.lobbyPlayerGroupId = data["LobbyPlayerGroupId"] !== undefined ? data["LobbyPlayerGroupId"] : null;
            this.lobbyPlayerLevelId = data["LobbyPlayerLevelId"] !== undefined ? data["LobbyPlayerLevelId"] : null;
            this.personalName = data["PersonalName"] !== undefined ? data["PersonalName"] : null;
            this.dOB = data["DOB"] ? new Date(data["DOB"].toString()) : null;
            this.sex = data["Sex"] !== undefined ? data["Sex"] : null;
            this.countryId = data["CountryId"] !== undefined ? data["CountryId"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.email = data["Email"] !== undefined ? data["Email"] : null;
            this.newWithdrawPassword = data["NewWithdrawPassword"] !== undefined ? data["NewWithdrawPassword"] : null;
            this.confirmNewWithdrawPassword = data["ConfirmNewWithdrawPassword"] !== undefined ? data["ConfirmNewWithdrawPassword"] : null;
            this.isEnableLogin = data["IsEnableLogin"] !== undefined ? data["IsEnableLogin"] : null;
            this.isEnablePlay = data["IsEnablePlay"] !== undefined ? data["IsEnablePlay"] : null;
            this.isEnableAutoRebate = data["IsEnableAutoRebate"] !== undefined ? data["IsEnableAutoRebate"] : null;
            this.emailConfirmed = data["EmailConfirmed"] !== undefined ? data["EmailConfirmed"] : null;
            this.phoneNumberConfirmed = data["PhoneNumberConfirmed"] !== undefined ? data["PhoneNumberConfirmed"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
        }
    }

    static fromJS(data: any): EditPlayerRequest {
        return new EditPlayerRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["NewPassword"] = this.newPassword !== undefined ? this.newPassword : null;
        data["ConfirmNewPassword"] = this.confirmNewPassword !== undefined ? this.confirmNewPassword : null;
        data["LobbyPlayerGroupId"] = this.lobbyPlayerGroupId !== undefined ? this.lobbyPlayerGroupId : null;
        data["LobbyPlayerLevelId"] = this.lobbyPlayerLevelId !== undefined ? this.lobbyPlayerLevelId : null;
        data["PersonalName"] = this.personalName !== undefined ? this.personalName : null;
        data["DOB"] = this.dOB ? this.dOB.toISOString() : null;
        data["Sex"] = this.sex !== undefined ? this.sex : null;
        data["CountryId"] = this.countryId !== undefined ? this.countryId : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["Email"] = this.email !== undefined ? this.email : null;
        data["NewWithdrawPassword"] = this.newWithdrawPassword !== undefined ? this.newWithdrawPassword : null;
        data["ConfirmNewWithdrawPassword"] = this.confirmNewWithdrawPassword !== undefined ? this.confirmNewWithdrawPassword : null;
        data["IsEnableLogin"] = this.isEnableLogin !== undefined ? this.isEnableLogin : null;
        data["IsEnablePlay"] = this.isEnablePlay !== undefined ? this.isEnablePlay : null;
        data["IsEnableAutoRebate"] = this.isEnableAutoRebate !== undefined ? this.isEnableAutoRebate : null;
        data["EmailConfirmed"] = this.emailConfirmed !== undefined ? this.emailConfirmed : null;
        data["PhoneNumberConfirmed"] = this.phoneNumberConfirmed !== undefined ? this.phoneNumberConfirmed : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new EditPlayerRequest(JSON.parse(json));
    }
}

export class PlayerSetEnableLoginRequest { 
    playerId: number; 
    isEnableLogin: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.isEnableLogin = data["IsEnableLogin"] !== undefined ? data["IsEnableLogin"] : null;
        }
    }

    static fromJS(data: any): PlayerSetEnableLoginRequest {
        return new PlayerSetEnableLoginRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["IsEnableLogin"] = this.isEnableLogin !== undefined ? this.isEnableLogin : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerSetEnableLoginRequest(JSON.parse(json));
    }
}

export class PlayerSetEnablePlayRequest { 
    playerId: number; 
    isEnablePlay: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.isEnablePlay = data["IsEnablePlay"] !== undefined ? data["IsEnablePlay"] : null;
        }
    }

    static fromJS(data: any): PlayerSetEnablePlayRequest {
        return new PlayerSetEnablePlayRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["IsEnablePlay"] = this.isEnablePlay !== undefined ? this.isEnablePlay : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerSetEnablePlayRequest(JSON.parse(json));
    }
}

export class ResetPlayerAutoPasswordRequest { 
    lobbyId: number; 
    playerId: number; 
    countryId: number; 
    language: LanguageCode; 
    messageMethodTypeId: MessageMethodTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.countryId = data["CountryId"] !== undefined ? data["CountryId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.messageMethodTypeId = data["messageMethodTypeId"] !== undefined ? data["messageMethodTypeId"] : null;
        }
    }

    static fromJS(data: any): ResetPlayerAutoPasswordRequest {
        return new ResetPlayerAutoPasswordRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["CountryId"] = this.countryId !== undefined ? this.countryId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["messageMethodTypeId"] = this.messageMethodTypeId !== undefined ? this.messageMethodTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ResetPlayerAutoPasswordRequest(JSON.parse(json));
    }
}

export enum MessageMethodTypeId {
    All = 0, 
    Sms = 1, 
    Web = 2, 
    Email = 3, 
}

export class SendSMSResult { 
    isSuccess: boolean; 
    phoneNumber: string; 
    errorMsg: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.errorMsg = data["ErrorMsg"] !== undefined ? data["ErrorMsg"] : null;
        }
    }

    static fromJS(data: any): SendSMSResult {
        return new SendSMSResult(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["ErrorMsg"] = this.errorMsg !== undefined ? this.errorMsg : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SendSMSResult(JSON.parse(json));
    }
}

export class SendEmailResult { 
    isSuccess: boolean; 
    email: string; 
    errorMsg: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            this.email = data["Email"] !== undefined ? data["Email"] : null;
            this.errorMsg = data["ErrorMsg"] !== undefined ? data["ErrorMsg"] : null;
        }
    }

    static fromJS(data: any): SendEmailResult {
        return new SendEmailResult(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["Email"] = this.email !== undefined ? this.email : null;
        data["ErrorMsg"] = this.errorMsg !== undefined ? this.errorMsg : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SendEmailResult(JSON.parse(json));
    }
}

export class ResetPlayerManualPasswordRequest { 
    lobbyId: number; 
    playerId: number; 
    newPassword: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.newPassword = data["NewPassword"] !== undefined ? data["NewPassword"] : null;
        }
    }

    static fromJS(data: any): ResetPlayerManualPasswordRequest {
        return new ResetPlayerManualPasswordRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["NewPassword"] = this.newPassword !== undefined ? this.newPassword : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ResetPlayerManualPasswordRequest(JSON.parse(json));
    }
}

export class ResetPlayerAutoPasswordRespone { 
    userId: number; 
    newPassword: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.userId = data["UserId"] !== undefined ? data["UserId"] : null;
            this.newPassword = data["NewPassword"] !== undefined ? data["NewPassword"] : null;
        }
    }

    static fromJS(data: any): ResetPlayerAutoPasswordRespone {
        return new ResetPlayerAutoPasswordRespone(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["UserId"] = this.userId !== undefined ? this.userId : null;
        data["NewPassword"] = this.newPassword !== undefined ? this.newPassword : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ResetPlayerAutoPasswordRespone(JSON.parse(json));
    }
}

export class ResetWithdrawAutoPasswordRequest { 
    lobbyId: number; 
    playerId: number; 
    countryId: number; 
    language: LanguageCode; 
    messageMethodTypeId: MessageMethodTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.countryId = data["CountryId"] !== undefined ? data["CountryId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.messageMethodTypeId = data["messageMethodTypeId"] !== undefined ? data["messageMethodTypeId"] : null;
        }
    }

    static fromJS(data: any): ResetWithdrawAutoPasswordRequest {
        return new ResetWithdrawAutoPasswordRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["CountryId"] = this.countryId !== undefined ? this.countryId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["messageMethodTypeId"] = this.messageMethodTypeId !== undefined ? this.messageMethodTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ResetWithdrawAutoPasswordRequest(JSON.parse(json));
    }
}

export class ResetWithdrawManualPasswordRequest { 
    lobbyId: number; 
    playerId: number; 
    newPassword: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.newPassword = data["NewPassword"] !== undefined ? data["NewPassword"] : null;
        }
    }

    static fromJS(data: any): ResetWithdrawManualPasswordRequest {
        return new ResetWithdrawManualPasswordRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["NewPassword"] = this.newPassword !== undefined ? this.newPassword : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ResetWithdrawManualPasswordRequest(JSON.parse(json));
    }
}

export class ResetWithdrawAutoPasswordRespone { 
    userId: number; 
    newPassword: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.userId = data["UserId"] !== undefined ? data["UserId"] : null;
            this.newPassword = data["NewPassword"] !== undefined ? data["NewPassword"] : null;
        }
    }

    static fromJS(data: any): ResetWithdrawAutoPasswordRespone {
        return new ResetWithdrawAutoPasswordRespone(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["UserId"] = this.userId !== undefined ? this.userId : null;
        data["NewPassword"] = this.newPassword !== undefined ? this.newPassword : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ResetWithdrawAutoPasswordRespone(JSON.parse(json));
    }
}

export class PlayerIsPhoneNumberExistsExcludeUserRequest { 
    playerId: number; 
    lobbyId: number; 
    phoneNumber: string; 
    countryId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.countryId = data["CountryId"] !== undefined ? data["CountryId"] : null;
        }
    }

    static fromJS(data: any): PlayerIsPhoneNumberExistsExcludeUserRequest {
        return new PlayerIsPhoneNumberExistsExcludeUserRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["CountryId"] = this.countryId !== undefined ? this.countryId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerIsPhoneNumberExistsExcludeUserRequest(JSON.parse(json));
    }
}

export class PlayerGetLoginLogByUserIdAndDateRequest { 
    lobbyId: number; 
    username: string; 
    startDate: Date; 
    endDate: Date; 
    userLoginCodeId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.username = data["Username"] !== undefined ? data["Username"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.userLoginCodeId = data["UserLoginCodeId"] !== undefined ? data["UserLoginCodeId"] : null;
        }
    }

    static fromJS(data: any): PlayerGetLoginLogByUserIdAndDateRequest {
        return new PlayerGetLoginLogByUserIdAndDateRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Username"] = this.username !== undefined ? this.username : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["UserLoginCodeId"] = this.userLoginCodeId !== undefined ? this.userLoginCodeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGetLoginLogByUserIdAndDateRequest(JSON.parse(json));
    }
}

export class PlayerGetLoginLogByUserIdAndDateResponse { 
    id: number; 
    userId: number; 
    loginTime: Date; 
    iP: string; 
    deviceTypeId: UserDeviceTypeId; 
    gameDevId: GameDevId; 
    gameDevName: string; 
    userLoginCodeId: UserLoginCodeId; 
    userLoginMessage: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.userId = data["UserId"] !== undefined ? data["UserId"] : null;
            this.loginTime = data["LoginTime"] ? new Date(data["LoginTime"].toString()) : null;
            this.iP = data["IP"] !== undefined ? data["IP"] : null;
            this.deviceTypeId = data["DeviceTypeId"] !== undefined ? data["DeviceTypeId"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
            this.userLoginCodeId = data["UserLoginCodeId"] !== undefined ? data["UserLoginCodeId"] : null;
            this.userLoginMessage = data["UserLoginMessage"] !== undefined ? data["UserLoginMessage"] : null;
        }
    }

    static fromJS(data: any): PlayerGetLoginLogByUserIdAndDateResponse {
        return new PlayerGetLoginLogByUserIdAndDateResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["UserId"] = this.userId !== undefined ? this.userId : null;
        data["LoginTime"] = this.loginTime ? this.loginTime.toISOString() : null;
        data["IP"] = this.iP !== undefined ? this.iP : null;
        data["DeviceTypeId"] = this.deviceTypeId !== undefined ? this.deviceTypeId : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        data["UserLoginCodeId"] = this.userLoginCodeId !== undefined ? this.userLoginCodeId : null;
        data["UserLoginMessage"] = this.userLoginMessage !== undefined ? this.userLoginMessage : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGetLoginLogByUserIdAndDateResponse(JSON.parse(json));
    }
}

export enum UserLoginCodeId {
    SUCCESS = 0, 
    FAILURE = 2, 
}

export class PlayerGetLoginLogRequest { 
    lobbyId: number; 
    username: string; 
    startDate: Date; 
    endDate: Date; 
    userLoginCodeId: UserLoginCodeId; 
    iP: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.username = data["Username"] !== undefined ? data["Username"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.userLoginCodeId = data["UserLoginCodeId"] !== undefined ? data["UserLoginCodeId"] : null;
            this.iP = data["IP"] !== undefined ? data["IP"] : null;
        }
    }

    static fromJS(data: any): PlayerGetLoginLogRequest {
        return new PlayerGetLoginLogRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Username"] = this.username !== undefined ? this.username : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["UserLoginCodeId"] = this.userLoginCodeId !== undefined ? this.userLoginCodeId : null;
        data["IP"] = this.iP !== undefined ? this.iP : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGetLoginLogRequest(JSON.parse(json));
    }
}

export class PlayerGetLoginLogResponse { 
    id: number; 
    userId: number; 
    userName: string; 
    loginTime: Date; 
    iP: string; 
    deviceTypeId: UserDeviceTypeId; 
    gameDevId: GameDevId; 
    gameDevName: string; 
    userLoginCodeId: UserLoginCodeId; 
    userLoginMessage: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.userId = data["UserId"] !== undefined ? data["UserId"] : null;
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
            this.loginTime = data["LoginTime"] ? new Date(data["LoginTime"].toString()) : null;
            this.iP = data["IP"] !== undefined ? data["IP"] : null;
            this.deviceTypeId = data["DeviceTypeId"] !== undefined ? data["DeviceTypeId"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
            this.userLoginCodeId = data["UserLoginCodeId"] !== undefined ? data["UserLoginCodeId"] : null;
            this.userLoginMessage = data["UserLoginMessage"] !== undefined ? data["UserLoginMessage"] : null;
        }
    }

    static fromJS(data: any): PlayerGetLoginLogResponse {
        return new PlayerGetLoginLogResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["UserId"] = this.userId !== undefined ? this.userId : null;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        data["LoginTime"] = this.loginTime ? this.loginTime.toISOString() : null;
        data["IP"] = this.iP !== undefined ? this.iP : null;
        data["DeviceTypeId"] = this.deviceTypeId !== undefined ? this.deviceTypeId : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        data["UserLoginCodeId"] = this.userLoginCodeId !== undefined ? this.userLoginCodeId : null;
        data["UserLoginMessage"] = this.userLoginMessage !== undefined ? this.userLoginMessage : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGetLoginLogResponse(JSON.parse(json));
    }
}

export class BatchUpdatePlayerLobbyPlayerLevelGroupRequest { 
    playerIds: number[]; 
    newPlayerLevelId: number; 
    newPlayerGroupId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["playerIds"] && data["playerIds"].constructor === Array) {
                this.playerIds = [];
                for (let item of data["playerIds"])
                    this.playerIds.push(item);
            }
            this.newPlayerLevelId = data["newPlayerLevelId"] !== undefined ? data["newPlayerLevelId"] : null;
            this.newPlayerGroupId = data["newPlayerGroupId"] !== undefined ? data["newPlayerGroupId"] : null;
        }
    }

    static fromJS(data: any): BatchUpdatePlayerLobbyPlayerLevelGroupRequest {
        return new BatchUpdatePlayerLobbyPlayerLevelGroupRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.playerIds && this.playerIds.constructor === Array) {
            data["playerIds"] = [];
            for (let item of this.playerIds)
                data["playerIds"].push(item);
        }
        data["newPlayerLevelId"] = this.newPlayerLevelId !== undefined ? this.newPlayerLevelId : null;
        data["newPlayerGroupId"] = this.newPlayerGroupId !== undefined ? this.newPlayerGroupId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new BatchUpdatePlayerLobbyPlayerLevelGroupRequest(JSON.parse(json));
    }
}

export class GetPhoneNumberRespone { 
    countryCode: string; 
    phoneNumber: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.countryCode = data["CountryCode"] !== undefined ? data["CountryCode"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
        }
    }

    static fromJS(data: any): GetPhoneNumberRespone {
        return new GetPhoneNumberRespone(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["CountryCode"] = this.countryCode !== undefined ? this.countryCode : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetPhoneNumberRespone(JSON.parse(json));
    }
}

export class ImportPlayerGroup_Response { 
    errorMessages: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["errorMessages"] && data["errorMessages"].constructor === Array) {
                this.errorMessages = [];
                for (let item of data["errorMessages"])
                    this.errorMessages.push(item);
            }
        }
    }

    static fromJS(data: any): ImportPlayerGroup_Response {
        return new ImportPlayerGroup_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.errorMessages && this.errorMessages.constructor === Array) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ImportPlayerGroup_Response(JSON.parse(json));
    }
}

export class CreatePlayerRequest { 
    multipleTimes: number; 
    prefix: string; 
    userName: string; 
    password: string; 
    agentCode: string; 
    lobbyPlayerLevelId: number; 
    lobbyPlayerGroupId: number; 
    remark: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.multipleTimes = data["MultipleTimes"] !== undefined ? data["MultipleTimes"] : null;
            this.prefix = data["Prefix"] !== undefined ? data["Prefix"] : null;
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
            this.password = data["Password"] !== undefined ? data["Password"] : null;
            this.agentCode = data["AgentCode"] !== undefined ? data["AgentCode"] : null;
            this.lobbyPlayerLevelId = data["LobbyPlayerLevelId"] !== undefined ? data["LobbyPlayerLevelId"] : null;
            this.lobbyPlayerGroupId = data["LobbyPlayerGroupId"] !== undefined ? data["LobbyPlayerGroupId"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
        }
    }

    static fromJS(data: any): CreatePlayerRequest {
        return new CreatePlayerRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["MultipleTimes"] = this.multipleTimes !== undefined ? this.multipleTimes : null;
        data["Prefix"] = this.prefix !== undefined ? this.prefix : null;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        data["Password"] = this.password !== undefined ? this.password : null;
        data["AgentCode"] = this.agentCode !== undefined ? this.agentCode : null;
        data["LobbyPlayerLevelId"] = this.lobbyPlayerLevelId !== undefined ? this.lobbyPlayerLevelId : null;
        data["LobbyPlayerGroupId"] = this.lobbyPlayerGroupId !== undefined ? this.lobbyPlayerGroupId : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CreatePlayerRequest(JSON.parse(json));
    }
}

export class GetPlayerTotalDepositAndWithdrawAmountRequest { 
    playerName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
        }
    }

    static fromJS(data: any): GetPlayerTotalDepositAndWithdrawAmountRequest {
        return new GetPlayerTotalDepositAndWithdrawAmountRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetPlayerTotalDepositAndWithdrawAmountRequest(JSON.parse(json));
    }
}

export class StandardResponseOfGetPlayerTotalDepositAndWithdrawAmountResponse { 
    isSuccess: boolean; 
    payload: GetPlayerTotalDepositAndWithdrawAmountResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? GetPlayerTotalDepositAndWithdrawAmountResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfGetPlayerTotalDepositAndWithdrawAmountResponse {
        return new StandardResponseOfGetPlayerTotalDepositAndWithdrawAmountResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfGetPlayerTotalDepositAndWithdrawAmountResponse(JSON.parse(json));
    }
}

export class GetPlayerTotalDepositAndWithdrawAmountResponse { 
    playerName: string; 
    depositTotalAmount: number; 
    withdrawTotalAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.depositTotalAmount = data["DepositTotalAmount"] !== undefined ? data["DepositTotalAmount"] : null;
            this.withdrawTotalAmount = data["WithdrawTotalAmount"] !== undefined ? data["WithdrawTotalAmount"] : null;
        }
    }

    static fromJS(data: any): GetPlayerTotalDepositAndWithdrawAmountResponse {
        return new GetPlayerTotalDepositAndWithdrawAmountResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["DepositTotalAmount"] = this.depositTotalAmount !== undefined ? this.depositTotalAmount : null;
        data["WithdrawTotalAmount"] = this.withdrawTotalAmount !== undefined ? this.withdrawTotalAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetPlayerTotalDepositAndWithdrawAmountResponse(JSON.parse(json));
    }
}

export class StandardResponseOfGetAllPlayerListReportUrlResponse { 
    isSuccess: boolean; 
    payload: GetAllPlayerListReportUrlResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? GetAllPlayerListReportUrlResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfGetAllPlayerListReportUrlResponse {
        return new StandardResponseOfGetAllPlayerListReportUrlResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfGetAllPlayerListReportUrlResponse(JSON.parse(json));
    }
}

export class GetAllPlayerListReportUrlResponse { 
    randomCode: string; 
    filePath: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.randomCode = data["RandomCode"] !== undefined ? data["RandomCode"] : null;
            this.filePath = data["FilePath"] !== undefined ? data["FilePath"] : null;
        }
    }

    static fromJS(data: any): GetAllPlayerListReportUrlResponse {
        return new GetAllPlayerListReportUrlResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["RandomCode"] = this.randomCode !== undefined ? this.randomCode : null;
        data["FilePath"] = this.filePath !== undefined ? this.filePath : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetAllPlayerListReportUrlResponse(JSON.parse(json));
    }
}

export class PCCA_Create_Request { 
    playerId: number; 
    currencyId: CurrencyId; 
    address: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["playerId"] !== undefined ? data["playerId"] : null;
            this.currencyId = data["currencyId"] !== undefined ? data["currencyId"] : null;
            this.address = data["address"] !== undefined ? data["address"] : null;
        }
    }

    static fromJS(data: any): PCCA_Create_Request {
        return new PCCA_Create_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["playerId"] = this.playerId !== undefined ? this.playerId : null;
        data["currencyId"] = this.currencyId !== undefined ? this.currencyId : null;
        data["address"] = this.address !== undefined ? this.address : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PCCA_Create_Request(JSON.parse(json));
    }
}

export class PCCA_Delete_Request { 
    id: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
        }
    }

    static fromJS(data: any): PCCA_Delete_Request {
        return new PCCA_Delete_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PCCA_Delete_Request(JSON.parse(json));
    }
}

export class DepositGetAddPointsRecordByDateRangeRequest { 
    lobbyId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date; 
    transactionNo: string; 
    playerLoginName: string; 
    transactionMasterTypeIds: NewTransactionMasterTypeId[]; 
    depositMethodId: number; 
    transactionStatusId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
            this.playerLoginName = data["PlayerLoginName"] !== undefined ? data["PlayerLoginName"] : null;
            if (data["transactionMasterTypeIds"] && data["transactionMasterTypeIds"].constructor === Array) {
                this.transactionMasterTypeIds = [];
                for (let item of data["transactionMasterTypeIds"])
                    this.transactionMasterTypeIds.push(item);
            }
            this.depositMethodId = data["DepositMethodId"] !== undefined ? data["DepositMethodId"] : null;
            this.transactionStatusId = data["TransactionStatusId"] !== undefined ? data["TransactionStatusId"] : null;
        }
    }

    static fromJS(data: any): DepositGetAddPointsRecordByDateRangeRequest {
        return new DepositGetAddPointsRecordByDateRangeRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        data["PlayerLoginName"] = this.playerLoginName !== undefined ? this.playerLoginName : null;
        if (this.transactionMasterTypeIds && this.transactionMasterTypeIds.constructor === Array) {
            data["transactionMasterTypeIds"] = [];
            for (let item of this.transactionMasterTypeIds)
                data["transactionMasterTypeIds"].push(item);
        }
        data["DepositMethodId"] = this.depositMethodId !== undefined ? this.depositMethodId : null;
        data["TransactionStatusId"] = this.transactionStatusId !== undefined ? this.transactionStatusId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DepositGetAddPointsRecordByDateRangeRequest(JSON.parse(json));
    }
}

export class GetAddPointsRecordByDateRangeResponse { 
    depositGetByDateRangeResponse: DepositGetByDateRangeResponse[]; 
    depositStatusSection: CmsSelectionOptionDao[]; 
    autoPromotionStatusSection: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["depositGetByDateRangeResponse"] && data["depositGetByDateRangeResponse"].constructor === Array) {
                this.depositGetByDateRangeResponse = [];
                for (let item of data["depositGetByDateRangeResponse"])
                    this.depositGetByDateRangeResponse.push(DepositGetByDateRangeResponse.fromJS(item));
            }
            if (data["depositStatusSection"] && data["depositStatusSection"].constructor === Array) {
                this.depositStatusSection = [];
                for (let item of data["depositStatusSection"])
                    this.depositStatusSection.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["autoPromotionStatusSection"] && data["autoPromotionStatusSection"].constructor === Array) {
                this.autoPromotionStatusSection = [];
                for (let item of data["autoPromotionStatusSection"])
                    this.autoPromotionStatusSection.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetAddPointsRecordByDateRangeResponse {
        return new GetAddPointsRecordByDateRangeResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.depositGetByDateRangeResponse && this.depositGetByDateRangeResponse.constructor === Array) {
            data["depositGetByDateRangeResponse"] = [];
            for (let item of this.depositGetByDateRangeResponse)
                data["depositGetByDateRangeResponse"].push(item.toJS());
        }
        if (this.depositStatusSection && this.depositStatusSection.constructor === Array) {
            data["depositStatusSection"] = [];
            for (let item of this.depositStatusSection)
                data["depositStatusSection"].push(item.toJS());
        }
        if (this.autoPromotionStatusSection && this.autoPromotionStatusSection.constructor === Array) {
            data["autoPromotionStatusSection"] = [];
            for (let item of this.autoPromotionStatusSection)
                data["autoPromotionStatusSection"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetAddPointsRecordByDateRangeResponse(JSON.parse(json));
    }
}

export class DepositGetByDateRangeResponse { 
    id: number; 
    transactionNo: string; 
    currency: string; 
    playerLoginName: string; 
    depositType: string; 
    actualAmount: number; 
    amount: number; 
    gameDevName: string; 
    lobbyBankAccount: string; 
    lobbyBankAccBankName: string; 
    lobbyBankAccName: string; 
    lobbyBankAccNo: string; 
    playerBank: string; 
    depositMethod: string; 
    depositDate: Date; 
    topTransactionMasterType: string; 
    topTransactionMasterTypeId: NewTransactionMasterTypeId; 
    transactionType: string; 
    playerDepositStatusId: number; 
    depositStatus: string; 
    isComplete: boolean; 
    isPendingPay: boolean; 
    ip: string; 
    createDate: Date; 
    updateDate: Date; 
    updateBy: string; 
    remark: string; 
    remarkByAdmin: string; 
    rejectReason: string; 
    promotion: string; 
    gameTypeTranslationString: string; 
    gameType: string; 
    languageId: LanguageCode; 
    lobbyPromotionMaxAmount: number; 
    playerId: number; 
    playerBankAccountNo: string; 
    playerBankAccountUsername: string; 
    agentCode: string; 
    playerLevel: string; 
    paymentPlatformId: PaymentGatewayPlatformId; 
    paymentPlatformName: string; 
    receiptImagePath: string; 
    autoPromotionStatusId: AutoPromotionStatusId; 
    autoPromotionStatusName: string; 
    playerGroup: string; 
    paymentGatewayPlatformId: number; 
    paymentGatewayPlatformName: string; 
    thirdPartyTransactionNo: string; 
    billedCurrencyId: CurrencyId; 
    billedCurrencyName: string; 
    billedAmount: number; 
    rate: number; 
    lobbyDigitalWalletName: string; 
    lobbyDigitalWalletAccountNo: string; 
    lobbyPlayerGroupId: number; 
    isFirstDeposit: boolean; 
    firstDepositStr: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
            this.currency = data["Currency"] !== undefined ? data["Currency"] : null;
            this.playerLoginName = data["PlayerLoginName"] !== undefined ? data["PlayerLoginName"] : null;
            this.depositType = data["DepositType"] !== undefined ? data["DepositType"] : null;
            this.actualAmount = data["ActualAmount"] !== undefined ? data["ActualAmount"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
            this.lobbyBankAccount = data["LobbyBankAccount"] !== undefined ? data["LobbyBankAccount"] : null;
            this.lobbyBankAccBankName = data["LobbyBankAccBankName"] !== undefined ? data["LobbyBankAccBankName"] : null;
            this.lobbyBankAccName = data["LobbyBankAccName"] !== undefined ? data["LobbyBankAccName"] : null;
            this.lobbyBankAccNo = data["LobbyBankAccNo"] !== undefined ? data["LobbyBankAccNo"] : null;
            this.playerBank = data["PlayerBank"] !== undefined ? data["PlayerBank"] : null;
            this.depositMethod = data["DepositMethod"] !== undefined ? data["DepositMethod"] : null;
            this.depositDate = data["DepositDate"] ? new Date(data["DepositDate"].toString()) : null;
            this.topTransactionMasterType = data["TopTransactionMasterType"] !== undefined ? data["TopTransactionMasterType"] : null;
            this.topTransactionMasterTypeId = data["TopTransactionMasterTypeId"] !== undefined ? data["TopTransactionMasterTypeId"] : null;
            this.transactionType = data["TransactionType"] !== undefined ? data["TransactionType"] : null;
            this.playerDepositStatusId = data["PlayerDepositStatusId"] !== undefined ? data["PlayerDepositStatusId"] : null;
            this.depositStatus = data["DepositStatus"] !== undefined ? data["DepositStatus"] : null;
            this.isComplete = data["IsComplete"] !== undefined ? data["IsComplete"] : null;
            this.isPendingPay = data["IsPendingPay"] !== undefined ? data["IsPendingPay"] : null;
            this.ip = data["Ip"] !== undefined ? data["Ip"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.remarkByAdmin = data["RemarkByAdmin"] !== undefined ? data["RemarkByAdmin"] : null;
            this.rejectReason = data["RejectReason"] !== undefined ? data["RejectReason"] : null;
            this.promotion = data["Promotion"] !== undefined ? data["Promotion"] : null;
            this.gameTypeTranslationString = data["GameTypeTranslationString"] !== undefined ? data["GameTypeTranslationString"] : null;
            this.gameType = data["GameType"] !== undefined ? data["GameType"] : null;
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.lobbyPromotionMaxAmount = data["LobbyPromotionMaxAmount"] !== undefined ? data["LobbyPromotionMaxAmount"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.playerBankAccountNo = data["PlayerBankAccountNo"] !== undefined ? data["PlayerBankAccountNo"] : null;
            this.playerBankAccountUsername = data["PlayerBankAccountUsername"] !== undefined ? data["PlayerBankAccountUsername"] : null;
            this.agentCode = data["AgentCode"] !== undefined ? data["AgentCode"] : null;
            this.playerLevel = data["PlayerLevel"] !== undefined ? data["PlayerLevel"] : null;
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.paymentPlatformName = data["PaymentPlatformName"] !== undefined ? data["PaymentPlatformName"] : null;
            this.receiptImagePath = data["ReceiptImagePath"] !== undefined ? data["ReceiptImagePath"] : null;
            this.autoPromotionStatusId = data["AutoPromotionStatusId"] !== undefined ? data["AutoPromotionStatusId"] : null;
            this.autoPromotionStatusName = data["AutoPromotionStatusName"] !== undefined ? data["AutoPromotionStatusName"] : null;
            this.playerGroup = data["PlayerGroup"] !== undefined ? data["PlayerGroup"] : null;
            this.paymentGatewayPlatformId = data["PaymentGatewayPlatformId"] !== undefined ? data["PaymentGatewayPlatformId"] : null;
            this.paymentGatewayPlatformName = data["PaymentGatewayPlatformName"] !== undefined ? data["PaymentGatewayPlatformName"] : null;
            this.thirdPartyTransactionNo = data["ThirdPartyTransactionNo"] !== undefined ? data["ThirdPartyTransactionNo"] : null;
            this.billedCurrencyId = data["BilledCurrencyId"] !== undefined ? data["BilledCurrencyId"] : null;
            this.billedCurrencyName = data["BilledCurrencyName"] !== undefined ? data["BilledCurrencyName"] : null;
            this.billedAmount = data["BilledAmount"] !== undefined ? data["BilledAmount"] : null;
            this.rate = data["Rate"] !== undefined ? data["Rate"] : null;
            this.lobbyDigitalWalletName = data["LobbyDigitalWalletName"] !== undefined ? data["LobbyDigitalWalletName"] : null;
            this.lobbyDigitalWalletAccountNo = data["LobbyDigitalWalletAccountNo"] !== undefined ? data["LobbyDigitalWalletAccountNo"] : null;
            this.lobbyPlayerGroupId = data["LobbyPlayerGroupId"] !== undefined ? data["LobbyPlayerGroupId"] : null;
            this.isFirstDeposit = data["IsFirstDeposit"] !== undefined ? data["IsFirstDeposit"] : null;
            this.firstDepositStr = data["FirstDepositStr"] !== undefined ? data["FirstDepositStr"] : null;
        }
    }

    static fromJS(data: any): DepositGetByDateRangeResponse {
        return new DepositGetByDateRangeResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        data["Currency"] = this.currency !== undefined ? this.currency : null;
        data["PlayerLoginName"] = this.playerLoginName !== undefined ? this.playerLoginName : null;
        data["DepositType"] = this.depositType !== undefined ? this.depositType : null;
        data["ActualAmount"] = this.actualAmount !== undefined ? this.actualAmount : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        data["LobbyBankAccount"] = this.lobbyBankAccount !== undefined ? this.lobbyBankAccount : null;
        data["LobbyBankAccBankName"] = this.lobbyBankAccBankName !== undefined ? this.lobbyBankAccBankName : null;
        data["LobbyBankAccName"] = this.lobbyBankAccName !== undefined ? this.lobbyBankAccName : null;
        data["LobbyBankAccNo"] = this.lobbyBankAccNo !== undefined ? this.lobbyBankAccNo : null;
        data["PlayerBank"] = this.playerBank !== undefined ? this.playerBank : null;
        data["DepositMethod"] = this.depositMethod !== undefined ? this.depositMethod : null;
        data["DepositDate"] = this.depositDate ? this.depositDate.toISOString() : null;
        data["TopTransactionMasterType"] = this.topTransactionMasterType !== undefined ? this.topTransactionMasterType : null;
        data["TopTransactionMasterTypeId"] = this.topTransactionMasterTypeId !== undefined ? this.topTransactionMasterTypeId : null;
        data["TransactionType"] = this.transactionType !== undefined ? this.transactionType : null;
        data["PlayerDepositStatusId"] = this.playerDepositStatusId !== undefined ? this.playerDepositStatusId : null;
        data["DepositStatus"] = this.depositStatus !== undefined ? this.depositStatus : null;
        data["IsComplete"] = this.isComplete !== undefined ? this.isComplete : null;
        data["IsPendingPay"] = this.isPendingPay !== undefined ? this.isPendingPay : null;
        data["Ip"] = this.ip !== undefined ? this.ip : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["RemarkByAdmin"] = this.remarkByAdmin !== undefined ? this.remarkByAdmin : null;
        data["RejectReason"] = this.rejectReason !== undefined ? this.rejectReason : null;
        data["Promotion"] = this.promotion !== undefined ? this.promotion : null;
        data["GameTypeTranslationString"] = this.gameTypeTranslationString !== undefined ? this.gameTypeTranslationString : null;
        data["GameType"] = this.gameType !== undefined ? this.gameType : null;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["LobbyPromotionMaxAmount"] = this.lobbyPromotionMaxAmount !== undefined ? this.lobbyPromotionMaxAmount : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["PlayerBankAccountNo"] = this.playerBankAccountNo !== undefined ? this.playerBankAccountNo : null;
        data["PlayerBankAccountUsername"] = this.playerBankAccountUsername !== undefined ? this.playerBankAccountUsername : null;
        data["AgentCode"] = this.agentCode !== undefined ? this.agentCode : null;
        data["PlayerLevel"] = this.playerLevel !== undefined ? this.playerLevel : null;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["PaymentPlatformName"] = this.paymentPlatformName !== undefined ? this.paymentPlatformName : null;
        data["ReceiptImagePath"] = this.receiptImagePath !== undefined ? this.receiptImagePath : null;
        data["AutoPromotionStatusId"] = this.autoPromotionStatusId !== undefined ? this.autoPromotionStatusId : null;
        data["AutoPromotionStatusName"] = this.autoPromotionStatusName !== undefined ? this.autoPromotionStatusName : null;
        data["PlayerGroup"] = this.playerGroup !== undefined ? this.playerGroup : null;
        data["PaymentGatewayPlatformId"] = this.paymentGatewayPlatformId !== undefined ? this.paymentGatewayPlatformId : null;
        data["PaymentGatewayPlatformName"] = this.paymentGatewayPlatformName !== undefined ? this.paymentGatewayPlatformName : null;
        data["ThirdPartyTransactionNo"] = this.thirdPartyTransactionNo !== undefined ? this.thirdPartyTransactionNo : null;
        data["BilledCurrencyId"] = this.billedCurrencyId !== undefined ? this.billedCurrencyId : null;
        data["BilledCurrencyName"] = this.billedCurrencyName !== undefined ? this.billedCurrencyName : null;
        data["BilledAmount"] = this.billedAmount !== undefined ? this.billedAmount : null;
        data["Rate"] = this.rate !== undefined ? this.rate : null;
        data["LobbyDigitalWalletName"] = this.lobbyDigitalWalletName !== undefined ? this.lobbyDigitalWalletName : null;
        data["LobbyDigitalWalletAccountNo"] = this.lobbyDigitalWalletAccountNo !== undefined ? this.lobbyDigitalWalletAccountNo : null;
        data["LobbyPlayerGroupId"] = this.lobbyPlayerGroupId !== undefined ? this.lobbyPlayerGroupId : null;
        data["IsFirstDeposit"] = this.isFirstDeposit !== undefined ? this.isFirstDeposit : null;
        data["FirstDepositStr"] = this.firstDepositStr !== undefined ? this.firstDepositStr : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DepositGetByDateRangeResponse(JSON.parse(json));
    }
}

export enum AutoPromotionStatusId {
    InProgress = 1, 
    Settled = 2, 
    Cancelled = 3, 
    SendbBack = 4, 
}

export class GetBankTransferRecordByDateRangeWithLobbyAgentIdRequest { 
    lobbyId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date; 
    playerLoginName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.playerLoginName = data["PlayerLoginName"] !== undefined ? data["PlayerLoginName"] : null;
        }
    }

    static fromJS(data: any): GetBankTransferRecordByDateRangeWithLobbyAgentIdRequest {
        return new GetBankTransferRecordByDateRangeWithLobbyAgentIdRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["PlayerLoginName"] = this.playerLoginName !== undefined ? this.playerLoginName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetBankTransferRecordByDateRangeWithLobbyAgentIdRequest(JSON.parse(json));
    }
}

export class ManualDepositGetByDateRangeRequest { 
    lobbyId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date; 
    transactionNo: string; 
    playerName: string; 
    lobbyBankId: number; 
    statusId: NewTransactionStatusId; 
    morethanAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.lobbyBankId = data["LobbyBankId"] !== undefined ? data["LobbyBankId"] : null;
            this.statusId = data["StatusId"] !== undefined ? data["StatusId"] : null;
            this.morethanAmount = data["MorethanAmount"] !== undefined ? data["MorethanAmount"] : null;
        }
    }

    static fromJS(data: any): ManualDepositGetByDateRangeRequest {
        return new ManualDepositGetByDateRangeRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["LobbyBankId"] = this.lobbyBankId !== undefined ? this.lobbyBankId : null;
        data["StatusId"] = this.statusId !== undefined ? this.statusId : null;
        data["MorethanAmount"] = this.morethanAmount !== undefined ? this.morethanAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ManualDepositGetByDateRangeRequest(JSON.parse(json));
    }
}

export class DepositGetForSectionsResponse { 
    lobbyDepositMethodSection: CmsSelectionOptionDao[]; 
    playerDepositTypeSection: CmsSelectionOptionDao[]; 
    playerDepositStatusSection: CmsSelectionOptionDao[]; 
    lobbyBankSection: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["LobbyDepositMethodSection"] && data["LobbyDepositMethodSection"].constructor === Array) {
                this.lobbyDepositMethodSection = [];
                for (let item of data["LobbyDepositMethodSection"])
                    this.lobbyDepositMethodSection.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["PlayerDepositTypeSection"] && data["PlayerDepositTypeSection"].constructor === Array) {
                this.playerDepositTypeSection = [];
                for (let item of data["PlayerDepositTypeSection"])
                    this.playerDepositTypeSection.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["PlayerDepositStatusSection"] && data["PlayerDepositStatusSection"].constructor === Array) {
                this.playerDepositStatusSection = [];
                for (let item of data["PlayerDepositStatusSection"])
                    this.playerDepositStatusSection.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["LobbyBankSection"] && data["LobbyBankSection"].constructor === Array) {
                this.lobbyBankSection = [];
                for (let item of data["LobbyBankSection"])
                    this.lobbyBankSection.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepositGetForSectionsResponse {
        return new DepositGetForSectionsResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.lobbyDepositMethodSection && this.lobbyDepositMethodSection.constructor === Array) {
            data["LobbyDepositMethodSection"] = [];
            for (let item of this.lobbyDepositMethodSection)
                data["LobbyDepositMethodSection"].push(item.toJS());
        }
        if (this.playerDepositTypeSection && this.playerDepositTypeSection.constructor === Array) {
            data["PlayerDepositTypeSection"] = [];
            for (let item of this.playerDepositTypeSection)
                data["PlayerDepositTypeSection"].push(item.toJS());
        }
        if (this.playerDepositStatusSection && this.playerDepositStatusSection.constructor === Array) {
            data["PlayerDepositStatusSection"] = [];
            for (let item of this.playerDepositStatusSection)
                data["PlayerDepositStatusSection"].push(item.toJS());
        }
        if (this.lobbyBankSection && this.lobbyBankSection.constructor === Array) {
            data["LobbyBankSection"] = [];
            for (let item of this.lobbyBankSection)
                data["LobbyBankSection"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DepositGetForSectionsResponse(JSON.parse(json));
    }
}

export class DepositRejectRequest { 
    id: number; 
    rejectReason: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.rejectReason = data["RejectReason"] !== undefined ? data["RejectReason"] : null;
        }
    }

    static fromJS(data: any): DepositRejectRequest {
        return new DepositRejectRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["RejectReason"] = this.rejectReason !== undefined ? this.rejectReason : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DepositRejectRequest(JSON.parse(json));
    }
}

export class PromotionRejectRequest { 
    id: number; 
    rejectReason: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.rejectReason = data["RejectReason"] !== undefined ? data["RejectReason"] : null;
        }
    }

    static fromJS(data: any): PromotionRejectRequest {
        return new PromotionRejectRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["RejectReason"] = this.rejectReason !== undefined ? this.rejectReason : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PromotionRejectRequest(JSON.parse(json));
    }
}

export class DepositFormGetFormDataResponse { 
    bankAccountSelections: SelectionOption[]; 
    depositMethodSelections: SelectionOption[]; 
    playerBankSelections: SelectionOption[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["BankAccountSelections"] && data["BankAccountSelections"].constructor === Array) {
                this.bankAccountSelections = [];
                for (let item of data["BankAccountSelections"])
                    this.bankAccountSelections.push(SelectionOption.fromJS(item));
            }
            if (data["DepositMethodSelections"] && data["DepositMethodSelections"].constructor === Array) {
                this.depositMethodSelections = [];
                for (let item of data["DepositMethodSelections"])
                    this.depositMethodSelections.push(SelectionOption.fromJS(item));
            }
            if (data["PlayerBankSelections"] && data["PlayerBankSelections"].constructor === Array) {
                this.playerBankSelections = [];
                for (let item of data["PlayerBankSelections"])
                    this.playerBankSelections.push(SelectionOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepositFormGetFormDataResponse {
        return new DepositFormGetFormDataResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.bankAccountSelections && this.bankAccountSelections.constructor === Array) {
            data["BankAccountSelections"] = [];
            for (let item of this.bankAccountSelections)
                data["BankAccountSelections"].push(item.toJS());
        }
        if (this.depositMethodSelections && this.depositMethodSelections.constructor === Array) {
            data["DepositMethodSelections"] = [];
            for (let item of this.depositMethodSelections)
                data["DepositMethodSelections"].push(item.toJS());
        }
        if (this.playerBankSelections && this.playerBankSelections.constructor === Array) {
            data["PlayerBankSelections"] = [];
            for (let item of this.playerBankSelections)
                data["PlayerBankSelections"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DepositFormGetFormDataResponse(JSON.parse(json));
    }
}

export class DepositByAdminSubmitRequest { 
    playerId: number; 
    amount: number; 
    depositDate: Date; 
    remark: string; 
    lobbyPromotionId: number; 
    dateKey: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.depositDate = data["DepositDate"] ? new Date(data["DepositDate"].toString()) : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.dateKey = data["DateKey"] !== undefined ? data["DateKey"] : null;
        }
    }

    static fromJS(data: any): DepositByAdminSubmitRequest {
        return new DepositByAdminSubmitRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["DepositDate"] = this.depositDate ? this.depositDate.toISOString() : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["DateKey"] = this.dateKey !== undefined ? this.dateKey : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DepositByAdminSubmitRequest(JSON.parse(json));
    }
}

export class StandardResultOfCreatePointsToBlukPlayerByAdminResponse { 
    isSuccess: boolean; 
    payload: CreatePointsToBlukPlayerByAdminResponse; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            this.payload = data["Payload"] ? CreatePointsToBlukPlayerByAdminResponse.fromJS(data["Payload"]) : null;
            if (data["Errors"] && data["Errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["Errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResultOfCreatePointsToBlukPlayerByAdminResponse {
        return new StandardResultOfCreatePointsToBlukPlayerByAdminResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["Payload"] = this.payload ? this.payload.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResultOfCreatePointsToBlukPlayerByAdminResponse(JSON.parse(json));
    }
}

export class CreatePointsToBlukPlayerByAdminResponse { 
    successPlayers: string[]; 
    failPlayers: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["SuccessPlayers"] && data["SuccessPlayers"].constructor === Array) {
                this.successPlayers = [];
                for (let item of data["SuccessPlayers"])
                    this.successPlayers.push(item);
            }
            if (data["FailPlayers"] && data["FailPlayers"].constructor === Array) {
                this.failPlayers = [];
                for (let item of data["FailPlayers"])
                    this.failPlayers.push(item);
            }
        }
    }

    static fromJS(data: any): CreatePointsToBlukPlayerByAdminResponse {
        return new CreatePointsToBlukPlayerByAdminResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.successPlayers && this.successPlayers.constructor === Array) {
            data["SuccessPlayers"] = [];
            for (let item of this.successPlayers)
                data["SuccessPlayers"].push(item);
        }
        if (this.failPlayers && this.failPlayers.constructor === Array) {
            data["FailPlayers"] = [];
            for (let item of this.failPlayers)
                data["FailPlayers"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CreatePointsToBlukPlayerByAdminResponse(JSON.parse(json));
    }
}

export class CreateBankTransferByAdminRequest { 
    playerId: number; 
    amount: number; 
    depositDate: Date; 
    lobbyBankAccountId: number; 
    lobbyDepositMethodId: number; 
    playerBankId: number; 
    remark: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.depositDate = data["DepositDate"] ? new Date(data["DepositDate"].toString()) : null;
            this.lobbyBankAccountId = data["LobbyBankAccountId"] !== undefined ? data["LobbyBankAccountId"] : null;
            this.lobbyDepositMethodId = data["LobbyDepositMethodId"] !== undefined ? data["LobbyDepositMethodId"] : null;
            this.playerBankId = data["PlayerBankId"] !== undefined ? data["PlayerBankId"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
        }
    }

    static fromJS(data: any): CreateBankTransferByAdminRequest {
        return new CreateBankTransferByAdminRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["DepositDate"] = this.depositDate ? this.depositDate.toISOString() : null;
        data["LobbyBankAccountId"] = this.lobbyBankAccountId !== undefined ? this.lobbyBankAccountId : null;
        data["LobbyDepositMethodId"] = this.lobbyDepositMethodId !== undefined ? this.lobbyDepositMethodId : null;
        data["PlayerBankId"] = this.playerBankId !== undefined ? this.playerBankId : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CreateBankTransferByAdminRequest(JSON.parse(json));
    }
}

export class EventCompleteRequest { 
    id: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
        }
    }

    static fromJS(data: any): EventCompleteRequest {
        return new EventCompleteRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new EventCompleteRequest(JSON.parse(json));
    }
}

export class EventCancelRequest { 
    id: number; 
    amount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
        }
    }

    static fromJS(data: any): EventCancelRequest {
        return new EventCancelRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new EventCancelRequest(JSON.parse(json));
    }
}

export class SettleAutoPromotionRequest { 
    playerAmountRecordId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerAmountRecordId = data["PlayerAmountRecordId"] !== undefined ? data["PlayerAmountRecordId"] : null;
        }
    }

    static fromJS(data: any): SettleAutoPromotionRequest {
        return new SettleAutoPromotionRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerAmountRecordId"] = this.playerAmountRecordId !== undefined ? this.playerAmountRecordId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SettleAutoPromotionRequest(JSON.parse(json));
    }
}

export class CancelAutoPromotionRequest { 
    playerAmountRecordId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerAmountRecordId = data["PlayerAmountRecordId"] !== undefined ? data["PlayerAmountRecordId"] : null;
        }
    }

    static fromJS(data: any): CancelAutoPromotionRequest {
        return new CancelAutoPromotionRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerAmountRecordId"] = this.playerAmountRecordId !== undefined ? this.playerAmountRecordId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CancelAutoPromotionRequest(JSON.parse(json));
    }
}

export class CheckPlayerEnoughTurnoverRequest { 
    playerId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
        }
    }

    static fromJS(data: any): CheckPlayerEnoughTurnoverRequest {
        return new CheckPlayerEnoughTurnoverRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CheckPlayerEnoughTurnoverRequest(JSON.parse(json));
    }
}

export class StandardResultOfCheckPlayerEnoughTurnoverForDepositResponse { 
    isSuccess: boolean; 
    payload: CheckPlayerEnoughTurnoverForDepositResponse; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            this.payload = data["Payload"] ? CheckPlayerEnoughTurnoverForDepositResponse.fromJS(data["Payload"]) : null;
            if (data["Errors"] && data["Errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["Errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResultOfCheckPlayerEnoughTurnoverForDepositResponse {
        return new StandardResultOfCheckPlayerEnoughTurnoverForDepositResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["Payload"] = this.payload ? this.payload.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResultOfCheckPlayerEnoughTurnoverForDepositResponse(JSON.parse(json));
    }
}

export class CheckPlayerEnoughTurnoverForDepositResponse { 
    depositTransactionNos: string[]; 
    requiredTurnover: number; 
    currentTotalTurnover: number;

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["DepositTransactionNos"] && data["DepositTransactionNos"].constructor === Array) {
                this.depositTransactionNos = [];
                for (let item of data["DepositTransactionNos"])
                    this.depositTransactionNos.push(item);
            }
            this.requiredTurnover = data["RequiredTurnover"] !== undefined ? data["RequiredTurnover"] : null;
            this.currentTotalTurnover = data["CurrentTotalTurnover"] !== undefined ? data["CurrentTotalTurnover"] : null;
        }
    }

    static fromJS(data: any): CheckPlayerEnoughTurnoverForDepositResponse {
        return new CheckPlayerEnoughTurnoverForDepositResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.depositTransactionNos && this.depositTransactionNos.constructor === Array) {
            data["DepositTransactionNos"] = [];
            for (let item of this.depositTransactionNos)
                data["DepositTransactionNos"].push(item);
        }
        data["RequiredTurnover"] = this.requiredTurnover !== undefined ? this.requiredTurnover : null;
        data["CurrentTotalTurnover"] = this.currentTotalTurnover !== undefined ? this.currentTotalTurnover : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CheckPlayerEnoughTurnoverForDepositResponse(JSON.parse(json));
    }
}

export class StandardResultOfCheckPlayerEnoughTurnoverForAutoPromotionResponse { 
    isSuccess: boolean; 
    payload: CheckPlayerEnoughTurnoverForAutoPromotionResponse; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            this.payload = data["Payload"] ? CheckPlayerEnoughTurnoverForAutoPromotionResponse.fromJS(data["Payload"]) : null;
            if (data["Errors"] && data["Errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["Errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResultOfCheckPlayerEnoughTurnoverForAutoPromotionResponse {
        return new StandardResultOfCheckPlayerEnoughTurnoverForAutoPromotionResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["Payload"] = this.payload ? this.payload.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResultOfCheckPlayerEnoughTurnoverForAutoPromotionResponse(JSON.parse(json));
    }
}

export class CheckPlayerEnoughTurnoverForAutoPromotionResponse { 
    requiredTurnover: number; 
    currentTotalTurnover: number; 
    promotionTransactionNo: string; 
    promotionAmount: number; 
    promotionDepositTransactionNo: string; 
    promotionDepositAmount: number; 
    validBetAmountMultiple: number; 
    depositAmountRequiredValidBetMultiple: number; 
    depositAfterPromotionList: DepositTransactionInfo[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.requiredTurnover = data["RequiredTurnover"] !== undefined ? data["RequiredTurnover"] : null;
            this.currentTotalTurnover = data["CurrentTotalTurnover"] !== undefined ? data["CurrentTotalTurnover"] : null;
            this.promotionTransactionNo = data["PromotionTransactionNo"] !== undefined ? data["PromotionTransactionNo"] : null;
            this.promotionAmount = data["PromotionAmount"] !== undefined ? data["PromotionAmount"] : null;
            this.promotionDepositTransactionNo = data["PromotionDepositTransactionNo"] !== undefined ? data["PromotionDepositTransactionNo"] : null;
            this.promotionDepositAmount = data["PromotionDepositAmount"] !== undefined ? data["PromotionDepositAmount"] : null;
            this.validBetAmountMultiple = data["ValidBetAmountMultiple"] !== undefined ? data["ValidBetAmountMultiple"] : null;
            this.depositAmountRequiredValidBetMultiple = data["DepositAmountRequiredValidBetMultiple"] !== undefined ? data["DepositAmountRequiredValidBetMultiple"] : null;
            if (data["DepositAfterPromotionList"] && data["DepositAfterPromotionList"].constructor === Array) {
                this.depositAfterPromotionList = [];
                for (let item of data["DepositAfterPromotionList"])
                    this.depositAfterPromotionList.push(DepositTransactionInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CheckPlayerEnoughTurnoverForAutoPromotionResponse {
        return new CheckPlayerEnoughTurnoverForAutoPromotionResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["RequiredTurnover"] = this.requiredTurnover !== undefined ? this.requiredTurnover : null;
        data["CurrentTotalTurnover"] = this.currentTotalTurnover !== undefined ? this.currentTotalTurnover : null;
        data["PromotionTransactionNo"] = this.promotionTransactionNo !== undefined ? this.promotionTransactionNo : null;
        data["PromotionAmount"] = this.promotionAmount !== undefined ? this.promotionAmount : null;
        data["PromotionDepositTransactionNo"] = this.promotionDepositTransactionNo !== undefined ? this.promotionDepositTransactionNo : null;
        data["PromotionDepositAmount"] = this.promotionDepositAmount !== undefined ? this.promotionDepositAmount : null;
        data["ValidBetAmountMultiple"] = this.validBetAmountMultiple !== undefined ? this.validBetAmountMultiple : null;
        data["DepositAmountRequiredValidBetMultiple"] = this.depositAmountRequiredValidBetMultiple !== undefined ? this.depositAmountRequiredValidBetMultiple : null;
        if (this.depositAfterPromotionList && this.depositAfterPromotionList.constructor === Array) {
            data["DepositAfterPromotionList"] = [];
            for (let item of this.depositAfterPromotionList)
                data["DepositAfterPromotionList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CheckPlayerEnoughTurnoverForAutoPromotionResponse(JSON.parse(json));
    }
}

export class DepositTransactionInfo { 
    transactionNo: string; 
    amount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
        }
    }

    static fromJS(data: any): DepositTransactionInfo {
        return new DepositTransactionInfo(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DepositTransactionInfo(JSON.parse(json));
    }
}

export class AddManualDepositByAddmin_Request { 
    playerName: string; 
    amount: number; 
    lobbyDepositMethodId: number; 
    remark: string; 
    bankAccountUsername: string; 
    bankAccountNo: string; 
    base64Image: string; 
    billedCurrencyId: CurrencyId; 
    lobbyBankAccountId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.lobbyDepositMethodId = data["LobbyDepositMethodId"] !== undefined ? data["LobbyDepositMethodId"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.bankAccountUsername = data["BankAccountUsername"] !== undefined ? data["BankAccountUsername"] : null;
            this.bankAccountNo = data["BankAccountNo"] !== undefined ? data["BankAccountNo"] : null;
            this.base64Image = data["Base64Image"] !== undefined ? data["Base64Image"] : null;
            this.billedCurrencyId = data["BilledCurrencyId"] !== undefined ? data["BilledCurrencyId"] : null;
            this.lobbyBankAccountId = data["LobbyBankAccountId"] !== undefined ? data["LobbyBankAccountId"] : null;
        }
    }

    static fromJS(data: any): AddManualDepositByAddmin_Request {
        return new AddManualDepositByAddmin_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["LobbyDepositMethodId"] = this.lobbyDepositMethodId !== undefined ? this.lobbyDepositMethodId : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["BankAccountUsername"] = this.bankAccountUsername !== undefined ? this.bankAccountUsername : null;
        data["BankAccountNo"] = this.bankAccountNo !== undefined ? this.bankAccountNo : null;
        data["Base64Image"] = this.base64Image !== undefined ? this.base64Image : null;
        data["BilledCurrencyId"] = this.billedCurrencyId !== undefined ? this.billedCurrencyId : null;
        data["LobbyBankAccountId"] = this.lobbyBankAccountId !== undefined ? this.lobbyBankAccountId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AddManualDepositByAddmin_Request(JSON.parse(json));
    }
}

export class AddDigitalDepositByAddmin_Request { 
    playerName: string; 
    amount: number; 
    lobbyDigitalWalletAccountId: number; 
    platformTrsactionNo: string; 
    base64Image: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.lobbyDigitalWalletAccountId = data["LobbyDigitalWalletAccountId"] !== undefined ? data["LobbyDigitalWalletAccountId"] : null;
            this.platformTrsactionNo = data["PlatformTrsactionNo"] !== undefined ? data["PlatformTrsactionNo"] : null;
            this.base64Image = data["Base64Image"] !== undefined ? data["Base64Image"] : null;
        }
    }

    static fromJS(data: any): AddDigitalDepositByAddmin_Request {
        return new AddDigitalDepositByAddmin_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["LobbyDigitalWalletAccountId"] = this.lobbyDigitalWalletAccountId !== undefined ? this.lobbyDigitalWalletAccountId : null;
        data["PlatformTrsactionNo"] = this.platformTrsactionNo !== undefined ? this.platformTrsactionNo : null;
        data["Base64Image"] = this.base64Image !== undefined ? this.base64Image : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AddDigitalDepositByAddmin_Request(JSON.parse(json));
    }
}

export class DepositOnlineGetByDateRangeRequest { 
    lobbyId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date; 
    orderId: string; 
    orderReferenceNo: string; 
    bankId: number; 
    username: string; 
    amountLargerThan: number; 
    paymentGatewayPlatformIds: PaymentGatewayPlatformId; 
    showAllNotComplete: boolean; 
    newTransactionTypeId: NewTransactionTypeId; 
    transactionStatusId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.orderId = data["OrderId"] !== undefined ? data["OrderId"] : null;
            this.orderReferenceNo = data["OrderReferenceNo"] !== undefined ? data["OrderReferenceNo"] : null;
            this.bankId = data["BankId"] !== undefined ? data["BankId"] : null;
            this.username = data["Username"] !== undefined ? data["Username"] : null;
            this.amountLargerThan = data["AmountLargerThan"] !== undefined ? data["AmountLargerThan"] : null;
            this.paymentGatewayPlatformIds = data["PaymentGatewayPlatformIds"] !== undefined ? data["PaymentGatewayPlatformIds"] : null;
            this.showAllNotComplete = data["showAllNotComplete"] !== undefined ? data["showAllNotComplete"] : null;
            this.newTransactionTypeId = data["NewTransactionTypeId"] !== undefined ? data["NewTransactionTypeId"] : null;
            this.transactionStatusId = data["TransactionStatusId"] !== undefined ? data["TransactionStatusId"] : null;
        }
    }

    static fromJS(data: any): DepositOnlineGetByDateRangeRequest {
        return new DepositOnlineGetByDateRangeRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["OrderId"] = this.orderId !== undefined ? this.orderId : null;
        data["OrderReferenceNo"] = this.orderReferenceNo !== undefined ? this.orderReferenceNo : null;
        data["BankId"] = this.bankId !== undefined ? this.bankId : null;
        data["Username"] = this.username !== undefined ? this.username : null;
        data["AmountLargerThan"] = this.amountLargerThan !== undefined ? this.amountLargerThan : null;
        data["PaymentGatewayPlatformIds"] = this.paymentGatewayPlatformIds !== undefined ? this.paymentGatewayPlatformIds : null;
        data["showAllNotComplete"] = this.showAllNotComplete !== undefined ? this.showAllNotComplete : null;
        data["NewTransactionTypeId"] = this.newTransactionTypeId !== undefined ? this.newTransactionTypeId : null;
        data["TransactionStatusId"] = this.transactionStatusId !== undefined ? this.transactionStatusId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DepositOnlineGetByDateRangeRequest(JSON.parse(json));
    }
}

export class PlayerDepositOnlinePaymentResponse { 
    playerTransactionId: number; 
    orderId: string; 
    transactionNo: string; 
    referenceNo: string; 
    username: string; 
    depositMethod: string; 
    bankName: string; 
    plannedAmount: number; 
    amount: number; 
    depositTime: Date; 
    isComplete: boolean; 
    playerDepositStatusId: number; 
    transactionStatusId: NewTransactionStatusId; 
    depositStatus: string; 
    iPAddress: string; 
    updateTime: Date; 
    updateBy: string; 
    topTransactionMasterType: string; 
    topTransactionMasterTypeId: NewTransactionMasterTypeId; 
    transactionType: string; 
    paymentGatewayPlatformId: number; 
    paymentGatewayPlatformName: string; 
    agentCode: string; 
    cardNo: string; 
    expiryDate: string; 
    billedCurrencyId: CurrencyId; 
    billedCurrencyName: string; 
    billedAmount: number; 
    rate: number; 
    plannedBillAmount: number; 
    remark: string; 
    remarkByAdmin: string; 
    fee: number; 
    address: string; 
    transactionHashId: string; 
    transactionHashUrl: string; 
    playerGroup: string; 
    createDate: Date; 
    lobbyBankAccBankName: string; 
    lobbyBankAccName: string; 
    lobbyBankAccNo: string; 
    playerLevel: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerTransactionId = data["PlayerTransactionId"] !== undefined ? data["PlayerTransactionId"] : null;
            this.orderId = data["OrderId"] !== undefined ? data["OrderId"] : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
            this.referenceNo = data["ReferenceNo"] !== undefined ? data["ReferenceNo"] : null;
            this.username = data["Username"] !== undefined ? data["Username"] : null;
            this.depositMethod = data["DepositMethod"] !== undefined ? data["DepositMethod"] : null;
            this.bankName = data["BankName"] !== undefined ? data["BankName"] : null;
            this.plannedAmount = data["PlannedAmount"] !== undefined ? data["PlannedAmount"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.depositTime = data["DepositTime"] ? new Date(data["DepositTime"].toString()) : null;
            this.isComplete = data["IsComplete"] !== undefined ? data["IsComplete"] : null;
            this.playerDepositStatusId = data["PlayerDepositStatusId"] !== undefined ? data["PlayerDepositStatusId"] : null;
            this.transactionStatusId = data["TransactionStatusId"] !== undefined ? data["TransactionStatusId"] : null;
            this.depositStatus = data["DepositStatus"] !== undefined ? data["DepositStatus"] : null;
            this.iPAddress = data["IPAddress"] !== undefined ? data["IPAddress"] : null;
            this.updateTime = data["UpdateTime"] ? new Date(data["UpdateTime"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.topTransactionMasterType = data["TopTransactionMasterType"] !== undefined ? data["TopTransactionMasterType"] : null;
            this.topTransactionMasterTypeId = data["TopTransactionMasterTypeId"] !== undefined ? data["TopTransactionMasterTypeId"] : null;
            this.transactionType = data["TransactionType"] !== undefined ? data["TransactionType"] : null;
            this.paymentGatewayPlatformId = data["PaymentGatewayPlatformId"] !== undefined ? data["PaymentGatewayPlatformId"] : null;
            this.paymentGatewayPlatformName = data["PaymentGatewayPlatformName"] !== undefined ? data["PaymentGatewayPlatformName"] : null;
            this.agentCode = data["AgentCode"] !== undefined ? data["AgentCode"] : null;
            this.cardNo = data["CardNo"] !== undefined ? data["CardNo"] : null;
            this.expiryDate = data["ExpiryDate"] !== undefined ? data["ExpiryDate"] : null;
            this.billedCurrencyId = data["BilledCurrencyId"] !== undefined ? data["BilledCurrencyId"] : null;
            this.billedCurrencyName = data["BilledCurrencyName"] !== undefined ? data["BilledCurrencyName"] : null;
            this.billedAmount = data["BilledAmount"] !== undefined ? data["BilledAmount"] : null;
            this.rate = data["Rate"] !== undefined ? data["Rate"] : null;
            this.plannedBillAmount = data["PlannedBillAmount"] !== undefined ? data["PlannedBillAmount"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.remarkByAdmin = data["RemarkByAdmin"] !== undefined ? data["RemarkByAdmin"] : null;
            this.fee = data["Fee"] !== undefined ? data["Fee"] : null;
            this.address = data["Address"] !== undefined ? data["Address"] : null;
            this.transactionHashId = data["TransactionHashId"] !== undefined ? data["TransactionHashId"] : null;
            this.transactionHashUrl = data["TransactionHashUrl"] !== undefined ? data["TransactionHashUrl"] : null;
            this.playerGroup = data["PlayerGroup"] !== undefined ? data["PlayerGroup"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.lobbyBankAccBankName = data["LobbyBankAccBankName"] !== undefined ? data["LobbyBankAccBankName"] : null;
            this.lobbyBankAccName = data["LobbyBankAccName"] !== undefined ? data["LobbyBankAccName"] : null;
            this.lobbyBankAccNo = data["LobbyBankAccNo"] !== undefined ? data["LobbyBankAccNo"] : null;
            this.playerLevel = data["PlayerLevel"] !== undefined ? data["PlayerLevel"] : null;
        }
    }

    static fromJS(data: any): PlayerDepositOnlinePaymentResponse {
        return new PlayerDepositOnlinePaymentResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerTransactionId"] = this.playerTransactionId !== undefined ? this.playerTransactionId : null;
        data["OrderId"] = this.orderId !== undefined ? this.orderId : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        data["ReferenceNo"] = this.referenceNo !== undefined ? this.referenceNo : null;
        data["Username"] = this.username !== undefined ? this.username : null;
        data["DepositMethod"] = this.depositMethod !== undefined ? this.depositMethod : null;
        data["BankName"] = this.bankName !== undefined ? this.bankName : null;
        data["PlannedAmount"] = this.plannedAmount !== undefined ? this.plannedAmount : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["DepositTime"] = this.depositTime ? this.depositTime.toISOString() : null;
        data["IsComplete"] = this.isComplete !== undefined ? this.isComplete : null;
        data["PlayerDepositStatusId"] = this.playerDepositStatusId !== undefined ? this.playerDepositStatusId : null;
        data["TransactionStatusId"] = this.transactionStatusId !== undefined ? this.transactionStatusId : null;
        data["DepositStatus"] = this.depositStatus !== undefined ? this.depositStatus : null;
        data["IPAddress"] = this.iPAddress !== undefined ? this.iPAddress : null;
        data["UpdateTime"] = this.updateTime ? this.updateTime.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["TopTransactionMasterType"] = this.topTransactionMasterType !== undefined ? this.topTransactionMasterType : null;
        data["TopTransactionMasterTypeId"] = this.topTransactionMasterTypeId !== undefined ? this.topTransactionMasterTypeId : null;
        data["TransactionType"] = this.transactionType !== undefined ? this.transactionType : null;
        data["PaymentGatewayPlatformId"] = this.paymentGatewayPlatformId !== undefined ? this.paymentGatewayPlatformId : null;
        data["PaymentGatewayPlatformName"] = this.paymentGatewayPlatformName !== undefined ? this.paymentGatewayPlatformName : null;
        data["AgentCode"] = this.agentCode !== undefined ? this.agentCode : null;
        data["CardNo"] = this.cardNo !== undefined ? this.cardNo : null;
        data["ExpiryDate"] = this.expiryDate !== undefined ? this.expiryDate : null;
        data["BilledCurrencyId"] = this.billedCurrencyId !== undefined ? this.billedCurrencyId : null;
        data["BilledCurrencyName"] = this.billedCurrencyName !== undefined ? this.billedCurrencyName : null;
        data["BilledAmount"] = this.billedAmount !== undefined ? this.billedAmount : null;
        data["Rate"] = this.rate !== undefined ? this.rate : null;
        data["PlannedBillAmount"] = this.plannedBillAmount !== undefined ? this.plannedBillAmount : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["RemarkByAdmin"] = this.remarkByAdmin !== undefined ? this.remarkByAdmin : null;
        data["Fee"] = this.fee !== undefined ? this.fee : null;
        data["Address"] = this.address !== undefined ? this.address : null;
        data["TransactionHashId"] = this.transactionHashId !== undefined ? this.transactionHashId : null;
        data["TransactionHashUrl"] = this.transactionHashUrl !== undefined ? this.transactionHashUrl : null;
        data["PlayerGroup"] = this.playerGroup !== undefined ? this.playerGroup : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["LobbyBankAccBankName"] = this.lobbyBankAccBankName !== undefined ? this.lobbyBankAccBankName : null;
        data["LobbyBankAccName"] = this.lobbyBankAccName !== undefined ? this.lobbyBankAccName : null;
        data["LobbyBankAccNo"] = this.lobbyBankAccNo !== undefined ? this.lobbyBankAccNo : null;
        data["PlayerLevel"] = this.playerLevel !== undefined ? this.playerLevel : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerDepositOnlinePaymentResponse(JSON.parse(json));
    }
}

export class DepositOnlinePaymentGetForSectionsResponse { 
    bankSelection: CmsSelectionOptionDao[]; 
    paymentPlatformSection: CmsSelectionOptionDao[]; 
    transactionTypeSection: CmsSelectionOptionDao[]; 
    playerDepositStatusSection: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["BankSelection"] && data["BankSelection"].constructor === Array) {
                this.bankSelection = [];
                for (let item of data["BankSelection"])
                    this.bankSelection.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["PaymentPlatformSection"] && data["PaymentPlatformSection"].constructor === Array) {
                this.paymentPlatformSection = [];
                for (let item of data["PaymentPlatformSection"])
                    this.paymentPlatformSection.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["TransactionTypeSection"] && data["TransactionTypeSection"].constructor === Array) {
                this.transactionTypeSection = [];
                for (let item of data["TransactionTypeSection"])
                    this.transactionTypeSection.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["PlayerDepositStatusSection"] && data["PlayerDepositStatusSection"].constructor === Array) {
                this.playerDepositStatusSection = [];
                for (let item of data["PlayerDepositStatusSection"])
                    this.playerDepositStatusSection.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepositOnlinePaymentGetForSectionsResponse {
        return new DepositOnlinePaymentGetForSectionsResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.bankSelection && this.bankSelection.constructor === Array) {
            data["BankSelection"] = [];
            for (let item of this.bankSelection)
                data["BankSelection"].push(item.toJS());
        }
        if (this.paymentPlatformSection && this.paymentPlatformSection.constructor === Array) {
            data["PaymentPlatformSection"] = [];
            for (let item of this.paymentPlatformSection)
                data["PaymentPlatformSection"].push(item.toJS());
        }
        if (this.transactionTypeSection && this.transactionTypeSection.constructor === Array) {
            data["TransactionTypeSection"] = [];
            for (let item of this.transactionTypeSection)
                data["TransactionTypeSection"].push(item.toJS());
        }
        if (this.playerDepositStatusSection && this.playerDepositStatusSection.constructor === Array) {
            data["PlayerDepositStatusSection"] = [];
            for (let item of this.playerDepositStatusSection)
                data["PlayerDepositStatusSection"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DepositOnlinePaymentGetForSectionsResponse(JSON.parse(json));
    }
}

export class OnlinePaymentGetByIdRequest { 
    playerTransactionId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerTransactionId = data["playerTransactionId"] !== undefined ? data["playerTransactionId"] : null;
        }
    }

    static fromJS(data: any): OnlinePaymentGetByIdRequest {
        return new OnlinePaymentGetByIdRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["playerTransactionId"] = this.playerTransactionId !== undefined ? this.playerTransactionId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new OnlinePaymentGetByIdRequest(JSON.parse(json));
    }
}

export class ProcessCheckOrderStatusResponse { 
    isCompleted: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.isCompleted = data["isCompleted"] !== undefined ? data["isCompleted"] : null;
        }
    }

    static fromJS(data: any): ProcessCheckOrderStatusResponse {
        return new ProcessCheckOrderStatusResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isCompleted"] = this.isCompleted !== undefined ? this.isCompleted : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ProcessCheckOrderStatusResponse(JSON.parse(json));
    }
}

export class PDOP_ApprovePaymentRequest { 
    orderId: string; 
    playerTransactionId: number; 
    adjustedCryptoDepositAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.orderId = data["orderId"] !== undefined ? data["orderId"] : null;
            this.playerTransactionId = data["playerTransactionId"] !== undefined ? data["playerTransactionId"] : null;
            this.adjustedCryptoDepositAmount = data["adjustedCryptoDepositAmount"] !== undefined ? data["adjustedCryptoDepositAmount"] : null;
        }
    }

    static fromJS(data: any): PDOP_ApprovePaymentRequest {
        return new PDOP_ApprovePaymentRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["orderId"] = this.orderId !== undefined ? this.orderId : null;
        data["playerTransactionId"] = this.playerTransactionId !== undefined ? this.playerTransactionId : null;
        data["adjustedCryptoDepositAmount"] = this.adjustedCryptoDepositAmount !== undefined ? this.adjustedCryptoDepositAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PDOP_ApprovePaymentRequest(JSON.parse(json));
    }
}

export class PDOP_AddPaymentByAdminRequest { 
    paymentPlatformId: PaymentGatewayPlatformId; 
    transactionTypeId: NewTransactionTypeId; 
    playerName: string; 
    amount: number; 
    playerBankAccountId: number; 
    lobbyBankAccountId: number; 
    paymentTransactionDate: Date; 
    thirdPartyOrderNo: string; 
    remark: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformId = data["paymentPlatformId"] !== undefined ? data["paymentPlatformId"] : null;
            this.transactionTypeId = data["transactionTypeId"] !== undefined ? data["transactionTypeId"] : null;
            this.playerName = data["playerName"] !== undefined ? data["playerName"] : null;
            this.amount = data["amount"] !== undefined ? data["amount"] : null;
            this.playerBankAccountId = data["playerBankAccountId"] !== undefined ? data["playerBankAccountId"] : null;
            this.lobbyBankAccountId = data["lobbyBankAccountId"] !== undefined ? data["lobbyBankAccountId"] : null;
            this.paymentTransactionDate = data["paymentTransactionDate"] ? new Date(data["paymentTransactionDate"].toString()) : null;
            this.thirdPartyOrderNo = data["thirdPartyOrderNo"] !== undefined ? data["thirdPartyOrderNo"] : null;
            this.remark = data["remark"] !== undefined ? data["remark"] : null;
        }
    }

    static fromJS(data: any): PDOP_AddPaymentByAdminRequest {
        return new PDOP_AddPaymentByAdminRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["paymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["transactionTypeId"] = this.transactionTypeId !== undefined ? this.transactionTypeId : null;
        data["playerName"] = this.playerName !== undefined ? this.playerName : null;
        data["amount"] = this.amount !== undefined ? this.amount : null;
        data["playerBankAccountId"] = this.playerBankAccountId !== undefined ? this.playerBankAccountId : null;
        data["lobbyBankAccountId"] = this.lobbyBankAccountId !== undefined ? this.lobbyBankAccountId : null;
        data["paymentTransactionDate"] = this.paymentTransactionDate ? this.paymentTransactionDate.toISOString() : null;
        data["thirdPartyOrderNo"] = this.thirdPartyOrderNo !== undefined ? this.thirdPartyOrderNo : null;
        data["remark"] = this.remark !== undefined ? this.remark : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PDOP_AddPaymentByAdminRequest(JSON.parse(json));
    }
}

export class StandardResponseOfOnlinePaymentGetForAddResponse { 
    isSuccess: boolean; 
    payload: OnlinePaymentGetForAddResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? OnlinePaymentGetForAddResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfOnlinePaymentGetForAddResponse {
        return new StandardResponseOfOnlinePaymentGetForAddResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfOnlinePaymentGetForAddResponse(JSON.parse(json));
    }
}

export class OnlinePaymentGetForAddResponse { 
    paymentPlatforms: PaymentPlatform[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["paymentPlatforms"] && data["paymentPlatforms"].constructor === Array) {
                this.paymentPlatforms = [];
                for (let item of data["paymentPlatforms"])
                    this.paymentPlatforms.push(PaymentPlatform.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OnlinePaymentGetForAddResponse {
        return new OnlinePaymentGetForAddResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.paymentPlatforms && this.paymentPlatforms.constructor === Array) {
            data["paymentPlatforms"] = [];
            for (let item of this.paymentPlatforms)
                data["paymentPlatforms"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new OnlinePaymentGetForAddResponse(JSON.parse(json));
    }
}

export class PaymentPlatform { 
    paymentPlatformId: PaymentGatewayPlatformId; 
    paymentPlatformName: string; 
    transactionTypeOptions: TransactionTypeOption[]; 
    lobbyBankAccounts: LobbyBankAccountOption[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentPlatformId = data["paymentPlatformId"] !== undefined ? data["paymentPlatformId"] : null;
            this.paymentPlatformName = data["paymentPlatformName"] !== undefined ? data["paymentPlatformName"] : null;
            if (data["transactionTypeOptions"] && data["transactionTypeOptions"].constructor === Array) {
                this.transactionTypeOptions = [];
                for (let item of data["transactionTypeOptions"])
                    this.transactionTypeOptions.push(TransactionTypeOption.fromJS(item));
            }
            if (data["lobbyBankAccounts"] && data["lobbyBankAccounts"].constructor === Array) {
                this.lobbyBankAccounts = [];
                for (let item of data["lobbyBankAccounts"])
                    this.lobbyBankAccounts.push(LobbyBankAccountOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentPlatform {
        return new PaymentPlatform(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["paymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["paymentPlatformName"] = this.paymentPlatformName !== undefined ? this.paymentPlatformName : null;
        if (this.transactionTypeOptions && this.transactionTypeOptions.constructor === Array) {
            data["transactionTypeOptions"] = [];
            for (let item of this.transactionTypeOptions)
                data["transactionTypeOptions"].push(item.toJS());
        }
        if (this.lobbyBankAccounts && this.lobbyBankAccounts.constructor === Array) {
            data["lobbyBankAccounts"] = [];
            for (let item of this.lobbyBankAccounts)
                data["lobbyBankAccounts"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PaymentPlatform(JSON.parse(json));
    }
}

export class TransactionTypeOption { 
    transactionTypeId: NewTransactionTypeId; 
    transactionTpeName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.transactionTypeId = data["transactionTypeId"] !== undefined ? data["transactionTypeId"] : null;
            this.transactionTpeName = data["transactionTpeName"] !== undefined ? data["transactionTpeName"] : null;
        }
    }

    static fromJS(data: any): TransactionTypeOption {
        return new TransactionTypeOption(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["transactionTypeId"] = this.transactionTypeId !== undefined ? this.transactionTypeId : null;
        data["transactionTpeName"] = this.transactionTpeName !== undefined ? this.transactionTpeName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new TransactionTypeOption(JSON.parse(json));
    }
}

export class LobbyBankAccountOption { 
    lobbyBankAccountId: number; 
    lobbyBankAccountNo: string; 
    lobbyBankUserName: string; 
    lobbyBankName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyBankAccountId = data["lobbyBankAccountId"] !== undefined ? data["lobbyBankAccountId"] : null;
            this.lobbyBankAccountNo = data["lobbyBankAccountNo"] !== undefined ? data["lobbyBankAccountNo"] : null;
            this.lobbyBankUserName = data["lobbyBankUserName"] !== undefined ? data["lobbyBankUserName"] : null;
            this.lobbyBankName = data["lobbyBankName"] !== undefined ? data["lobbyBankName"] : null;
        }
    }

    static fromJS(data: any): LobbyBankAccountOption {
        return new LobbyBankAccountOption(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["lobbyBankAccountId"] = this.lobbyBankAccountId !== undefined ? this.lobbyBankAccountId : null;
        data["lobbyBankAccountNo"] = this.lobbyBankAccountNo !== undefined ? this.lobbyBankAccountNo : null;
        data["lobbyBankUserName"] = this.lobbyBankUserName !== undefined ? this.lobbyBankUserName : null;
        data["lobbyBankName"] = this.lobbyBankName !== undefined ? this.lobbyBankName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbyBankAccountOption(JSON.parse(json));
    }
}

export class GetForCreateRequest { 
    playerId: number; 
    lobbyId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
        }
    }

    static fromJS(data: any): GetForCreateRequest {
        return new GetForCreateRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetForCreateRequest(JSON.parse(json));
    }
}

export class GetForCreateResponse { 
    playerId: number; 
    playerName: string; 
    gameDevIdGameDevNames: GameDevIdGameDevName[]; 
    gameDevBehaviorIds: GameDevBehaviorId[]; 
    gameDevBehaviorStatuses: GameDevBehaviorStatus[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            if (data["GameDevIdGameDevNames"] && data["GameDevIdGameDevNames"].constructor === Array) {
                this.gameDevIdGameDevNames = [];
                for (let item of data["GameDevIdGameDevNames"])
                    this.gameDevIdGameDevNames.push(GameDevIdGameDevName.fromJS(item));
            }
            if (data["GameDevBehaviorIds"] && data["GameDevBehaviorIds"].constructor === Array) {
                this.gameDevBehaviorIds = [];
                for (let item of data["GameDevBehaviorIds"])
                    this.gameDevBehaviorIds.push(item);
            }
            if (data["GameDevBehaviorStatuses"] && data["GameDevBehaviorStatuses"].constructor === Array) {
                this.gameDevBehaviorStatuses = [];
                for (let item of data["GameDevBehaviorStatuses"])
                    this.gameDevBehaviorStatuses.push(GameDevBehaviorStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetForCreateResponse {
        return new GetForCreateResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        if (this.gameDevIdGameDevNames && this.gameDevIdGameDevNames.constructor === Array) {
            data["GameDevIdGameDevNames"] = [];
            for (let item of this.gameDevIdGameDevNames)
                data["GameDevIdGameDevNames"].push(item.toJS());
        }
        if (this.gameDevBehaviorIds && this.gameDevBehaviorIds.constructor === Array) {
            data["GameDevBehaviorIds"] = [];
            for (let item of this.gameDevBehaviorIds)
                data["GameDevBehaviorIds"].push(item);
        }
        if (this.gameDevBehaviorStatuses && this.gameDevBehaviorStatuses.constructor === Array) {
            data["GameDevBehaviorStatuses"] = [];
            for (let item of this.gameDevBehaviorStatuses)
                data["GameDevBehaviorStatuses"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetForCreateResponse(JSON.parse(json));
    }
}

export class GameDevIdGameDevName { 
    gameDevId: GameDevId; 
    gameDevName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
        }
    }

    static fromJS(data: any): GameDevIdGameDevName {
        return new GameDevIdGameDevName(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GameDevIdGameDevName(JSON.parse(json));
    }
}

export enum GameDevBehaviorId {
    LiveGame = 1, 
    SlotGame = 2, 
    VS = 3, 
    Sportbook = 4, 
    TransferAmount = 5, 
    Lottery = 6, 
    PokerGame = 7, 
}

export class GameDevBehaviorStatus { 
    gameDevId: GameDevId; 
    gameDevBehaviorId: GameDevBehaviorId; 
    isBlock: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.gameDevBehaviorId = data["GameDevBehaviorId"] !== undefined ? data["GameDevBehaviorId"] : null;
            this.isBlock = data["IsBlock"] !== undefined ? data["IsBlock"] : null;
        }
    }

    static fromJS(data: any): GameDevBehaviorStatus {
        return new GameDevBehaviorStatus(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["GameDevBehaviorId"] = this.gameDevBehaviorId !== undefined ? this.gameDevBehaviorId : null;
        data["IsBlock"] = this.isBlock !== undefined ? this.isBlock : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GameDevBehaviorStatus(JSON.parse(json));
    }
}

export class UpdateBlockItemRequest { 
    playerId: number; 
    gameDevBehaviorStatuses: GameDevBehaviorStatus[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            if (data["GameDevBehaviorStatuses"] && data["GameDevBehaviorStatuses"].constructor === Array) {
                this.gameDevBehaviorStatuses = [];
                for (let item of data["GameDevBehaviorStatuses"])
                    this.gameDevBehaviorStatuses.push(GameDevBehaviorStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateBlockItemRequest {
        return new UpdateBlockItemRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        if (this.gameDevBehaviorStatuses && this.gameDevBehaviorStatuses.constructor === Array) {
            data["GameDevBehaviorStatuses"] = [];
            for (let item of this.gameDevBehaviorStatuses)
                data["GameDevBehaviorStatuses"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new UpdateBlockItemRequest(JSON.parse(json));
    }
}

export class PlayerGiftPointGetByIdRequest { 
    playerGiftPointId: number; 
    language: LanguageCode;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerGiftPointId = data["PlayerGiftPointId"] !== undefined ? data["PlayerGiftPointId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
        }
    }

    static fromJS(data: any): PlayerGiftPointGetByIdRequest {
        return new PlayerGiftPointGetByIdRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerGiftPointId"] = this.playerGiftPointId !== undefined ? this.playerGiftPointId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGiftPointGetByIdRequest(JSON.parse(json));
    }
}

export class PlayerGiftPointItem { 
    id: number; 
    transactionNo: string; 
    playerId: number; 
    playerName: string; 
    amount: number; 
    giftPointBefore: number; 
    giftPointAfter: number; 
    giftPointTypeId: number; 
    giftPointTypeName: string; 
    giftPointStatusId: number; 
    giftPointStatusName: string; 
    remark: string; 
    remarkByAdmin: string; 
    createDate: Date; 
    updateDate: Date; 
    updateBy: string; 
    isComplete: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.giftPointBefore = data["GiftPointBefore"] !== undefined ? data["GiftPointBefore"] : null;
            this.giftPointAfter = data["GiftPointAfter"] !== undefined ? data["GiftPointAfter"] : null;
            this.giftPointTypeId = data["GiftPointTypeId"] !== undefined ? data["GiftPointTypeId"] : null;
            this.giftPointTypeName = data["GiftPointTypeName"] !== undefined ? data["GiftPointTypeName"] : null;
            this.giftPointStatusId = data["GiftPointStatusId"] !== undefined ? data["GiftPointStatusId"] : null;
            this.giftPointStatusName = data["GiftPointStatusName"] !== undefined ? data["GiftPointStatusName"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.remarkByAdmin = data["RemarkByAdmin"] !== undefined ? data["RemarkByAdmin"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.isComplete = data["IsComplete"] !== undefined ? data["IsComplete"] : null;
        }
    }

    static fromJS(data: any): PlayerGiftPointItem {
        return new PlayerGiftPointItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["GiftPointBefore"] = this.giftPointBefore !== undefined ? this.giftPointBefore : null;
        data["GiftPointAfter"] = this.giftPointAfter !== undefined ? this.giftPointAfter : null;
        data["GiftPointTypeId"] = this.giftPointTypeId !== undefined ? this.giftPointTypeId : null;
        data["GiftPointTypeName"] = this.giftPointTypeName !== undefined ? this.giftPointTypeName : null;
        data["GiftPointStatusId"] = this.giftPointStatusId !== undefined ? this.giftPointStatusId : null;
        data["GiftPointStatusName"] = this.giftPointStatusName !== undefined ? this.giftPointStatusName : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["RemarkByAdmin"] = this.remarkByAdmin !== undefined ? this.remarkByAdmin : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["IsComplete"] = this.isComplete !== undefined ? this.isComplete : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGiftPointItem(JSON.parse(json));
    }
}

export class PlayerGiftPointGetByDateRangeRequest { 
    lobbyId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date; 
    showAllNotComplete: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.showAllNotComplete = data["showAllNotComplete"] !== undefined ? data["showAllNotComplete"] : null;
        }
    }

    static fromJS(data: any): PlayerGiftPointGetByDateRangeRequest {
        return new PlayerGiftPointGetByDateRangeRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["showAllNotComplete"] = this.showAllNotComplete !== undefined ? this.showAllNotComplete : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGiftPointGetByDateRangeRequest(JSON.parse(json));
    }
}

export class PlayerGiftPointListResponse { 
    items: PlayerGiftPointItem[]; 
    playerGiftPointStatusSection: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["Items"] && data["Items"].constructor === Array) {
                this.items = [];
                for (let item of data["Items"])
                    this.items.push(PlayerGiftPointItem.fromJS(item));
            }
            if (data["PlayerGiftPointStatusSection"] && data["PlayerGiftPointStatusSection"].constructor === Array) {
                this.playerGiftPointStatusSection = [];
                for (let item of data["PlayerGiftPointStatusSection"])
                    this.playerGiftPointStatusSection.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerGiftPointListResponse {
        return new PlayerGiftPointListResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.items && this.items.constructor === Array) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJS());
        }
        if (this.playerGiftPointStatusSection && this.playerGiftPointStatusSection.constructor === Array) {
            data["PlayerGiftPointStatusSection"] = [];
            for (let item of this.playerGiftPointStatusSection)
                data["PlayerGiftPointStatusSection"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGiftPointListResponse(JSON.parse(json));
    }
}

export class PlayerGiftPointGetByPlayerIdRequest { 
    lobbyId: number; 
    language: LanguageCode; 
    playerName: string; 
    startDate: Date; 
    endDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
        }
    }

    static fromJS(data: any): PlayerGiftPointGetByPlayerIdRequest {
        return new PlayerGiftPointGetByPlayerIdRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGiftPointGetByPlayerIdRequest(JSON.parse(json));
    }
}

export class PlayerGiftPointGetByPlayerIdResponse { 
    playerId: number; 
    playerName: string; 
    playerRealName: string; 
    playerGiftPointAmount: number; 
    playerGiftPointRecord: PlayerGiftPointItem[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.playerRealName = data["PlayerRealName"] !== undefined ? data["PlayerRealName"] : null;
            this.playerGiftPointAmount = data["PlayerGiftPointAmount"] !== undefined ? data["PlayerGiftPointAmount"] : null;
            if (data["PlayerGiftPointRecord"] && data["PlayerGiftPointRecord"].constructor === Array) {
                this.playerGiftPointRecord = [];
                for (let item of data["PlayerGiftPointRecord"])
                    this.playerGiftPointRecord.push(PlayerGiftPointItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerGiftPointGetByPlayerIdResponse {
        return new PlayerGiftPointGetByPlayerIdResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["PlayerRealName"] = this.playerRealName !== undefined ? this.playerRealName : null;
        data["PlayerGiftPointAmount"] = this.playerGiftPointAmount !== undefined ? this.playerGiftPointAmount : null;
        if (this.playerGiftPointRecord && this.playerGiftPointRecord.constructor === Array) {
            data["PlayerGiftPointRecord"] = [];
            for (let item of this.playerGiftPointRecord)
                data["PlayerGiftPointRecord"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGiftPointGetByPlayerIdResponse(JSON.parse(json));
    }
}

export class PlayerGiftPointAddPointRequest { 
    playerId: number; 
    amount: number; 
    remark: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
        }
    }

    static fromJS(data: any): PlayerGiftPointAddPointRequest {
        return new PlayerGiftPointAddPointRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGiftPointAddPointRequest(JSON.parse(json));
    }
}

export class PlayerGiftPointDeducePointRequest { 
    playerId: number; 
    amount: number; 
    remark: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
        }
    }

    static fromJS(data: any): PlayerGiftPointDeducePointRequest {
        return new PlayerGiftPointDeducePointRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGiftPointDeducePointRequest(JSON.parse(json));
    }
}

export class PlayerGiftPointCreateRecordRequest { 
    playerId: number; 
    amount: number; 
    statusId: GiftPointStatusId; 
    remark: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.statusId = data["statusId"] !== undefined ? data["statusId"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
        }
    }

    static fromJS(data: any): PlayerGiftPointCreateRecordRequest {
        return new PlayerGiftPointCreateRecordRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["statusId"] = this.statusId !== undefined ? this.statusId : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGiftPointCreateRecordRequest(JSON.parse(json));
    }
}

export enum GiftPointStatusId {
    Penging = 1, 
    Rejected = 2, 
    Settle = 4, 
}

export class PlayerGiftPointRecordHandleRequest { 
    playerGiftPointId: number; 
    remarkByAdmin: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerGiftPointId = data["PlayerGiftPointId"] !== undefined ? data["PlayerGiftPointId"] : null;
            this.remarkByAdmin = data["RemarkByAdmin"] !== undefined ? data["RemarkByAdmin"] : null;
        }
    }

    static fromJS(data: any): PlayerGiftPointRecordHandleRequest {
        return new PlayerGiftPointRecordHandleRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerGiftPointId"] = this.playerGiftPointId !== undefined ? this.playerGiftPointId : null;
        data["RemarkByAdmin"] = this.remarkByAdmin !== undefined ? this.remarkByAdmin : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGiftPointRecordHandleRequest(JSON.parse(json));
    }
}

export class PlayerPromotionGetPlayerPromotionRequest { 
    lobbyId: number; 
    language: LanguageCode; 
    playerName: string; 
    startDate: Date; 
    endDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["lobbyId"] !== undefined ? data["lobbyId"] : null;
            this.language = data["language"] !== undefined ? data["language"] : null;
            this.playerName = data["playerName"] !== undefined ? data["playerName"] : null;
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : null;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : null;
        }
    }

    static fromJS(data: any): PlayerPromotionGetPlayerPromotionRequest {
        return new PlayerPromotionGetPlayerPromotionRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["lobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["language"] = this.language !== undefined ? this.language : null;
        data["playerName"] = this.playerName !== undefined ? this.playerName : null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerPromotionGetPlayerPromotionRequest(JSON.parse(json));
    }
}

export class PlayerPromotionGetPlayerPromotionResponse { 
    playerId: number; 
    playerName: string; 
    playerRealName: string; 
    playerBalance: number; 
    playerPromotionRecord: PlayerPromotionRecord[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["playerId"] !== undefined ? data["playerId"] : null;
            this.playerName = data["playerName"] !== undefined ? data["playerName"] : null;
            this.playerRealName = data["playerRealName"] !== undefined ? data["playerRealName"] : null;
            this.playerBalance = data["playerBalance"] !== undefined ? data["playerBalance"] : null;
            if (data["playerPromotionRecord"] && data["playerPromotionRecord"].constructor === Array) {
                this.playerPromotionRecord = [];
                for (let item of data["playerPromotionRecord"])
                    this.playerPromotionRecord.push(PlayerPromotionRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerPromotionGetPlayerPromotionResponse {
        return new PlayerPromotionGetPlayerPromotionResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["playerId"] = this.playerId !== undefined ? this.playerId : null;
        data["playerName"] = this.playerName !== undefined ? this.playerName : null;
        data["playerRealName"] = this.playerRealName !== undefined ? this.playerRealName : null;
        data["playerBalance"] = this.playerBalance !== undefined ? this.playerBalance : null;
        if (this.playerPromotionRecord && this.playerPromotionRecord.constructor === Array) {
            data["playerPromotionRecord"] = [];
            for (let item of this.playerPromotionRecord)
                data["playerPromotionRecord"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerPromotionGetPlayerPromotionResponse(JSON.parse(json));
    }
}

export class PlayerPromotionRecord { 
    playerAmountRecordId: number; 
    lobbyPromotionId: number; 
    lobbyPromotionName: string; 
    amount: number; 
    playerDepositStatusId: PlayerDepositStatusId; 
    createDate: Date; 
    updateBy: number; 
    updateUser: string; 
    autoPromotionStatusId: AutoPromotionStatusId; 
    autoPromotionStatusName: string; 
    transactionNo: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerAmountRecordId = data["playerAmountRecordId"] !== undefined ? data["playerAmountRecordId"] : null;
            this.lobbyPromotionId = data["lobbyPromotionId"] !== undefined ? data["lobbyPromotionId"] : null;
            this.lobbyPromotionName = data["lobbyPromotionName"] !== undefined ? data["lobbyPromotionName"] : null;
            this.amount = data["amount"] !== undefined ? data["amount"] : null;
            this.playerDepositStatusId = data["playerDepositStatusId"] !== undefined ? data["playerDepositStatusId"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.updateUser = data["UpdateUser"] !== undefined ? data["UpdateUser"] : null;
            this.autoPromotionStatusId = data["AutoPromotionStatusId"] !== undefined ? data["AutoPromotionStatusId"] : null;
            this.autoPromotionStatusName = data["AutoPromotionStatusName"] !== undefined ? data["AutoPromotionStatusName"] : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
        }
    }

    static fromJS(data: any): PlayerPromotionRecord {
        return new PlayerPromotionRecord(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["playerAmountRecordId"] = this.playerAmountRecordId !== undefined ? this.playerAmountRecordId : null;
        data["lobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["lobbyPromotionName"] = this.lobbyPromotionName !== undefined ? this.lobbyPromotionName : null;
        data["amount"] = this.amount !== undefined ? this.amount : null;
        data["playerDepositStatusId"] = this.playerDepositStatusId !== undefined ? this.playerDepositStatusId : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["UpdateUser"] = this.updateUser !== undefined ? this.updateUser : null;
        data["AutoPromotionStatusId"] = this.autoPromotionStatusId !== undefined ? this.autoPromotionStatusId : null;
        data["AutoPromotionStatusName"] = this.autoPromotionStatusName !== undefined ? this.autoPromotionStatusName : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerPromotionRecord(JSON.parse(json));
    }
}

export enum PlayerDepositStatusId {
    PENDING = 1, 
    REJECTED = 2, 
    SETTLE = 4, 
    XB_BEFORE_DEPOSIT = 5, 
    ECPSS_BEFORE_DEPOSIT = 6, 
    RFU_BEFORE_DEPOSIT = 7, 
    XB_WECHAT_BEFORE_DEPOSIT = 8, 
    MMPAY_BEFORE_DEPOSIT = 9, 
    MMPAY_WECHAT_BEFORE_DEPOSIT = 10, 
    MMPAY_ALIPAY_BEFORE_DEPOSIT = 11, 
    UNPAY_BEFORE_DEPOSIT = 12, 
    UNPAY_WECHAT_BEFORE_DEPOSIT = 13, 
    UNPAY_ALIPAY_BEFORE_DEPOSIT = 14, 
    SDPAY_BEFORE_DEPOSIT = 15, 
    XB_QQ_BEFORE_DEPOSIT = 16, 
    MMPAY_QQ_BEFORE_DEPOSIT = 17, 
    UNPAY_QQ_BEFORE_DEPOSIT = 18, 
    MMPAY_JDPAY_BEFORE_DEPOSIT = 19, 
    XLPAY_BEFORE_DEPOSIT = 20, 
    XLPAY_WECHAT_BEFORE_DEPOSIT = 21, 
    XLPAY_QQ_BEFORE_DEPOSIT = 22, 
    XLPAY_ALIPAY_BEFORE_DEPOSIT = 23, 
    XB_JDPAY_BEFORE_DEPOSIT = 24, 
    XB_UNIONPAY_BEFORE_DEPOSIT = 25, 
    ANY_BEFORE_DEPOSIT = 26, 
}

export class PromotionCancelRequest { 
    playerAmountRecordId: number; 
    rejectReason: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerAmountRecordId = data["PlayerAmountRecordId"] !== undefined ? data["PlayerAmountRecordId"] : null;
            this.rejectReason = data["RejectReason"] !== undefined ? data["RejectReason"] : null;
        }
    }

    static fromJS(data: any): PromotionCancelRequest {
        return new PromotionCancelRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerAmountRecordId"] = this.playerAmountRecordId !== undefined ? this.playerAmountRecordId : null;
        data["RejectReason"] = this.rejectReason !== undefined ? this.rejectReason : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PromotionCancelRequest(JSON.parse(json));
    }
}

export class RebateImportHistory { 
    id: number; 
    remark: string; 
    createDate: Date; 
    createBy: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.createBy = data["CreateBy"] !== undefined ? data["CreateBy"] : null;
        }
    }

    static fromJS(data: any): RebateImportHistory {
        return new RebateImportHistory(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["CreateBy"] = this.createBy !== undefined ? this.createBy : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new RebateImportHistory(JSON.parse(json));
    }
}

export class PlayerPromotionGetChoiceRecordRequest { 
    playerName: string; 
    startDate: Date; 
    endDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerName = data["playerName"] !== undefined ? data["playerName"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
        }
    }

    static fromJS(data: any): PlayerPromotionGetChoiceRecordRequest {
        return new PlayerPromotionGetChoiceRecordRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["playerName"] = this.playerName !== undefined ? this.playerName : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerPromotionGetChoiceRecordRequest(JSON.parse(json));
    }
}

export class PlayerPromotionGetChoiceRecordResponse { 
    autoPromotionId: number; 
    autoPromotionName: string; 
    userId: number; 
    dateKey: string; 
    lobbyPromotionId: number; 
    lobbyPromotionName: string; 
    isJoin: boolean; 
    createDate: Date; 
    status: string; 
    statusId: PlayerPromotionChoiceRecordStatusId; 
    updateDate: Date; 
    updateBy: string; 
    transactionNo: string; 
    depositTransactionNo: string; 
    sendBackTransactionNo: string; 
    purchaseTransactionNo: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.autoPromotionId = data["AutoPromotionId"] !== undefined ? data["AutoPromotionId"] : null;
            this.autoPromotionName = data["AutoPromotionName"] !== undefined ? data["AutoPromotionName"] : null;
            this.userId = data["UserId"] !== undefined ? data["UserId"] : null;
            this.dateKey = data["DateKey"] !== undefined ? data["DateKey"] : null;
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.lobbyPromotionName = data["LobbyPromotionName"] !== undefined ? data["LobbyPromotionName"] : null;
            this.isJoin = data["IsJoin"] !== undefined ? data["IsJoin"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.status = data["Status"] !== undefined ? data["Status"] : null;
            this.statusId = data["StatusId"] !== undefined ? data["StatusId"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
            this.depositTransactionNo = data["DepositTransactionNo"] !== undefined ? data["DepositTransactionNo"] : null;
            this.sendBackTransactionNo = data["SendBackTransactionNo"] !== undefined ? data["SendBackTransactionNo"] : null;
            this.purchaseTransactionNo = data["PurchaseTransactionNo"] !== undefined ? data["PurchaseTransactionNo"] : null;
        }
    }

    static fromJS(data: any): PlayerPromotionGetChoiceRecordResponse {
        return new PlayerPromotionGetChoiceRecordResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["AutoPromotionId"] = this.autoPromotionId !== undefined ? this.autoPromotionId : null;
        data["AutoPromotionName"] = this.autoPromotionName !== undefined ? this.autoPromotionName : null;
        data["UserId"] = this.userId !== undefined ? this.userId : null;
        data["DateKey"] = this.dateKey !== undefined ? this.dateKey : null;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["LobbyPromotionName"] = this.lobbyPromotionName !== undefined ? this.lobbyPromotionName : null;
        data["IsJoin"] = this.isJoin !== undefined ? this.isJoin : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["Status"] = this.status !== undefined ? this.status : null;
        data["StatusId"] = this.statusId !== undefined ? this.statusId : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        data["DepositTransactionNo"] = this.depositTransactionNo !== undefined ? this.depositTransactionNo : null;
        data["SendBackTransactionNo"] = this.sendBackTransactionNo !== undefined ? this.sendBackTransactionNo : null;
        data["PurchaseTransactionNo"] = this.purchaseTransactionNo !== undefined ? this.purchaseTransactionNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerPromotionGetChoiceRecordResponse(JSON.parse(json));
    }
}

export enum PlayerPromotionChoiceRecordStatusId {
    Pending = 1, 
    RedeemSuccess = 2, 
    Expired = 3, 
    DepositAmountNotEnough = 4, 
    RedeemSendBack = 5, 
    PromotionLimitReached = 6, 
    PendingRedeemManualy = 7, 
    PromotionRequirementNotReached = 8, 
    WaitingBetRecord = 9, 
}

export class PlayerPromotionChoiceRecordGetRequest { 
    statusId: PlayerPromotionChoiceRecordStatusId; 
    lobbyPromotionId: number; 
    startDate: Date; 
    endDate: Date; 
    autoPromotionDistributeMethodId: AutoPromotionDistributeMethodId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.statusId = data["StatusId"] !== undefined ? data["StatusId"] : null;
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.autoPromotionDistributeMethodId = data["AutoPromotionDistributeMethodId"] !== undefined ? data["AutoPromotionDistributeMethodId"] : null;
        }
    }

    static fromJS(data: any): PlayerPromotionChoiceRecordGetRequest {
        return new PlayerPromotionChoiceRecordGetRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["StatusId"] = this.statusId !== undefined ? this.statusId : null;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["AutoPromotionDistributeMethodId"] = this.autoPromotionDistributeMethodId !== undefined ? this.autoPromotionDistributeMethodId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerPromotionChoiceRecordGetRequest(JSON.parse(json));
    }
}

export enum AutoPromotionDistributeMethodId {
    Auto = 1, 
    ManualGiveOut = 2, 
    PlayerClickToGet = 3, 
    ImportPromotion = 4, 
}

export class StandardResultOfIEnumerableOfPlayerPromotionChoiceRecordGetResponse { 
    isSuccess: boolean; 
    payload: PlayerPromotionChoiceRecordGetResponse[]; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            if (data["Payload"] && data["Payload"].constructor === Array) {
                this.payload = [];
                for (let item of data["Payload"])
                    this.payload.push(PlayerPromotionChoiceRecordGetResponse.fromJS(item));
            }
            if (data["Errors"] && data["Errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["Errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResultOfIEnumerableOfPlayerPromotionChoiceRecordGetResponse {
        return new StandardResultOfIEnumerableOfPlayerPromotionChoiceRecordGetResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.payload && this.payload.constructor === Array) {
            data["Payload"] = [];
            for (let item of this.payload)
                data["Payload"].push(item.toJS());
        }
        if (this.errors && this.errors.constructor === Array) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResultOfIEnumerableOfPlayerPromotionChoiceRecordGetResponse(JSON.parse(json));
    }
}

export class PlayerPromotionChoiceRecordGetResponse { 
    createDate: Date; 
    playerName: string; 
    lobbyPromotionId: number; 
    lobbyPromotionName: string; 
    status: string; 
    statusId: PlayerPromotionChoiceRecordStatusId; 
    expectedSettlementDate: Date; 
    updateBy: string; 
    promotionTransactionNo: string; 
    promotionPayoutAmount: number; 
    depositTransactionNo: string; 
    purchaseTransactionNo: string; 
    sendBackTransactionNo: string; 
    remark: string; 
    playerId: number; 
    autoPromotionId: AutoPromotionId; 
    betTransactionNo: string; 
    gamePlatformBetTransactionNo: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.lobbyPromotionName = data["LobbyPromotionName"] !== undefined ? data["LobbyPromotionName"] : null;
            this.status = data["Status"] !== undefined ? data["Status"] : null;
            this.statusId = data["StatusId"] !== undefined ? data["StatusId"] : null;
            this.expectedSettlementDate = data["ExpectedSettlementDate"] ? new Date(data["ExpectedSettlementDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.promotionTransactionNo = data["PromotionTransactionNo"] !== undefined ? data["PromotionTransactionNo"] : null;
            this.promotionPayoutAmount = data["PromotionPayoutAmount"] !== undefined ? data["PromotionPayoutAmount"] : null;
            this.depositTransactionNo = data["DepositTransactionNo"] !== undefined ? data["DepositTransactionNo"] : null;
            this.purchaseTransactionNo = data["PurchaseTransactionNo"] !== undefined ? data["PurchaseTransactionNo"] : null;
            this.sendBackTransactionNo = data["SendBackTransactionNo"] !== undefined ? data["SendBackTransactionNo"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.autoPromotionId = data["AutoPromotionId"] !== undefined ? data["AutoPromotionId"] : null;
            this.betTransactionNo = data["BetTransactionNo"] !== undefined ? data["BetTransactionNo"] : null;
            this.gamePlatformBetTransactionNo = data["GamePlatformBetTransactionNo"] !== undefined ? data["GamePlatformBetTransactionNo"] : null;
        }
    }

    static fromJS(data: any): PlayerPromotionChoiceRecordGetResponse {
        return new PlayerPromotionChoiceRecordGetResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["LobbyPromotionName"] = this.lobbyPromotionName !== undefined ? this.lobbyPromotionName : null;
        data["Status"] = this.status !== undefined ? this.status : null;
        data["StatusId"] = this.statusId !== undefined ? this.statusId : null;
        data["ExpectedSettlementDate"] = this.expectedSettlementDate ? this.expectedSettlementDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["PromotionTransactionNo"] = this.promotionTransactionNo !== undefined ? this.promotionTransactionNo : null;
        data["PromotionPayoutAmount"] = this.promotionPayoutAmount !== undefined ? this.promotionPayoutAmount : null;
        data["DepositTransactionNo"] = this.depositTransactionNo !== undefined ? this.depositTransactionNo : null;
        data["PurchaseTransactionNo"] = this.purchaseTransactionNo !== undefined ? this.purchaseTransactionNo : null;
        data["SendBackTransactionNo"] = this.sendBackTransactionNo !== undefined ? this.sendBackTransactionNo : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["AutoPromotionId"] = this.autoPromotionId !== undefined ? this.autoPromotionId : null;
        data["BetTransactionNo"] = this.betTransactionNo !== undefined ? this.betTransactionNo : null;
        data["GamePlatformBetTransactionNo"] = this.gamePlatformBetTransactionNo !== undefined ? this.gamePlatformBetTransactionNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerPromotionChoiceRecordGetResponse(JSON.parse(json));
    }
}

export class PlayerPromotionGetRecordForRedeemRequest { 
    lobbyPromotionId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
        }
    }

    static fromJS(data: any): PlayerPromotionGetRecordForRedeemRequest {
        return new PlayerPromotionGetRecordForRedeemRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerPromotionGetRecordForRedeemRequest(JSON.parse(json));
    }
}

export class StandardResultOfIEnumerableOfPlayerPromotionGetRecordForRedeemesponse { 
    isSuccess: boolean; 
    payload: PlayerPromotionGetRecordForRedeemesponse[]; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            if (data["Payload"] && data["Payload"].constructor === Array) {
                this.payload = [];
                for (let item of data["Payload"])
                    this.payload.push(PlayerPromotionGetRecordForRedeemesponse.fromJS(item));
            }
            if (data["Errors"] && data["Errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["Errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResultOfIEnumerableOfPlayerPromotionGetRecordForRedeemesponse {
        return new StandardResultOfIEnumerableOfPlayerPromotionGetRecordForRedeemesponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.payload && this.payload.constructor === Array) {
            data["Payload"] = [];
            for (let item of this.payload)
                data["Payload"].push(item.toJS());
        }
        if (this.errors && this.errors.constructor === Array) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResultOfIEnumerableOfPlayerPromotionGetRecordForRedeemesponse(JSON.parse(json));
    }
}

export class PlayerPromotionGetRecordForRedeemesponse { 
    autoPromotionId: AutoPromotionId; 
    playerId: number; 
    dateKey: string; 
    createDate: Date; 
    playerName: string; 
    lobbyPromotionId: number; 
    lobbyPromotionName: string; 
    insuredPercentage: number; 
    expectedSettlementDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.autoPromotionId = data["AutoPromotionId"] !== undefined ? data["AutoPromotionId"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.dateKey = data["DateKey"] !== undefined ? data["DateKey"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.lobbyPromotionName = data["LobbyPromotionName"] !== undefined ? data["LobbyPromotionName"] : null;
            this.insuredPercentage = data["InsuredPercentage"] !== undefined ? data["InsuredPercentage"] : null;
            this.expectedSettlementDate = data["ExpectedSettlementDate"] ? new Date(data["ExpectedSettlementDate"].toString()) : null;
        }
    }

    static fromJS(data: any): PlayerPromotionGetRecordForRedeemesponse {
        return new PlayerPromotionGetRecordForRedeemesponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["AutoPromotionId"] = this.autoPromotionId !== undefined ? this.autoPromotionId : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["DateKey"] = this.dateKey !== undefined ? this.dateKey : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["LobbyPromotionName"] = this.lobbyPromotionName !== undefined ? this.lobbyPromotionName : null;
        data["InsuredPercentage"] = this.insuredPercentage !== undefined ? this.insuredPercentage : null;
        data["ExpectedSettlementDate"] = this.expectedSettlementDate ? this.expectedSettlementDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerPromotionGetRecordForRedeemesponse(JSON.parse(json));
    }
}

export class PlayerPromotionGetEstimatedManualRedeemAmountRequest { 
    autoPromotionId: AutoPromotionId; 
    playerId: number; 
    dateKey: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.autoPromotionId = data["AutoPromotionId"] !== undefined ? data["AutoPromotionId"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.dateKey = data["DateKey"] !== undefined ? data["DateKey"] : null;
        }
    }

    static fromJS(data: any): PlayerPromotionGetEstimatedManualRedeemAmountRequest {
        return new PlayerPromotionGetEstimatedManualRedeemAmountRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["AutoPromotionId"] = this.autoPromotionId !== undefined ? this.autoPromotionId : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["DateKey"] = this.dateKey !== undefined ? this.dateKey : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerPromotionGetEstimatedManualRedeemAmountRequest(JSON.parse(json));
    }
}

export class StandardResultOfPlayerPromotionGetEstimatedManualRedeemAmountResponse { 
    isSuccess: boolean; 
    payload: PlayerPromotionGetEstimatedManualRedeemAmountResponse; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            this.payload = data["Payload"] ? PlayerPromotionGetEstimatedManualRedeemAmountResponse.fromJS(data["Payload"]) : null;
            if (data["Errors"] && data["Errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["Errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResultOfPlayerPromotionGetEstimatedManualRedeemAmountResponse {
        return new StandardResultOfPlayerPromotionGetEstimatedManualRedeemAmountResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["Payload"] = this.payload ? this.payload.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResultOfPlayerPromotionGetEstimatedManualRedeemAmountResponse(JSON.parse(json));
    }
}

export class PlayerPromotionGetEstimatedManualRedeemAmountResponse { 
    autoPromotionEstimateMethodId: AutoPromotionEstimateMethodId; 
    autoPromotionId: AutoPromotionId; 
    playerId: number; 
    dateKey: string; 
    createDate: Date; 
    playerName: string; 
    lobbyPromotionId: number; 
    lobbyPromotionName: string; 
    eGameWinLose: number; 
    fishGameWinLose: number; 
    insuredPercentage: number; 
    expectedSettlementDate: Date; 
    depositTransactionNo: string; 
    depositAmount: number; 
    gameDevId: GameDevId; 
    gameDevName: string; 
    platformTransactionNo: string; 
    betTransactionNo: string; 
    betAmount: number; 
    betDateTime: Date; 
    betPayoutAmount: number; 
    betPayoutTime: Date; 
    betWinLoseAmount: number; 
    expectedPromotionPayoutAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.autoPromotionEstimateMethodId = data["AutoPromotionEstimateMethodId"] !== undefined ? data["AutoPromotionEstimateMethodId"] : null;
            this.autoPromotionId = data["AutoPromotionId"] !== undefined ? data["AutoPromotionId"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.dateKey = data["DateKey"] !== undefined ? data["DateKey"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.lobbyPromotionName = data["LobbyPromotionName"] !== undefined ? data["LobbyPromotionName"] : null;
            this.eGameWinLose = data["EGameWinLose"] !== undefined ? data["EGameWinLose"] : null;
            this.fishGameWinLose = data["FishGameWinLose"] !== undefined ? data["FishGameWinLose"] : null;
            this.insuredPercentage = data["InsuredPercentage"] !== undefined ? data["InsuredPercentage"] : null;
            this.expectedSettlementDate = data["ExpectedSettlementDate"] ? new Date(data["ExpectedSettlementDate"].toString()) : null;
            this.depositTransactionNo = data["DepositTransactionNo"] !== undefined ? data["DepositTransactionNo"] : null;
            this.depositAmount = data["DepositAmount"] !== undefined ? data["DepositAmount"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
            this.platformTransactionNo = data["PlatformTransactionNo"] !== undefined ? data["PlatformTransactionNo"] : null;
            this.betTransactionNo = data["BetTransactionNo"] !== undefined ? data["BetTransactionNo"] : null;
            this.betAmount = data["BetAmount"] !== undefined ? data["BetAmount"] : null;
            this.betDateTime = data["BetDateTime"] ? new Date(data["BetDateTime"].toString()) : null;
            this.betPayoutAmount = data["BetPayoutAmount"] !== undefined ? data["BetPayoutAmount"] : null;
            this.betPayoutTime = data["BetPayoutTime"] ? new Date(data["BetPayoutTime"].toString()) : null;
            this.betWinLoseAmount = data["BetWinLoseAmount"] !== undefined ? data["BetWinLoseAmount"] : null;
            this.expectedPromotionPayoutAmount = data["ExpectedPromotionPayoutAmount"] !== undefined ? data["ExpectedPromotionPayoutAmount"] : null;
        }
    }

    static fromJS(data: any): PlayerPromotionGetEstimatedManualRedeemAmountResponse {
        return new PlayerPromotionGetEstimatedManualRedeemAmountResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["AutoPromotionEstimateMethodId"] = this.autoPromotionEstimateMethodId !== undefined ? this.autoPromotionEstimateMethodId : null;
        data["AutoPromotionId"] = this.autoPromotionId !== undefined ? this.autoPromotionId : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["DateKey"] = this.dateKey !== undefined ? this.dateKey : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["LobbyPromotionName"] = this.lobbyPromotionName !== undefined ? this.lobbyPromotionName : null;
        data["EGameWinLose"] = this.eGameWinLose !== undefined ? this.eGameWinLose : null;
        data["FishGameWinLose"] = this.fishGameWinLose !== undefined ? this.fishGameWinLose : null;
        data["InsuredPercentage"] = this.insuredPercentage !== undefined ? this.insuredPercentage : null;
        data["ExpectedSettlementDate"] = this.expectedSettlementDate ? this.expectedSettlementDate.toISOString() : null;
        data["DepositTransactionNo"] = this.depositTransactionNo !== undefined ? this.depositTransactionNo : null;
        data["DepositAmount"] = this.depositAmount !== undefined ? this.depositAmount : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        data["PlatformTransactionNo"] = this.platformTransactionNo !== undefined ? this.platformTransactionNo : null;
        data["BetTransactionNo"] = this.betTransactionNo !== undefined ? this.betTransactionNo : null;
        data["BetAmount"] = this.betAmount !== undefined ? this.betAmount : null;
        data["BetDateTime"] = this.betDateTime ? this.betDateTime.toISOString() : null;
        data["BetPayoutAmount"] = this.betPayoutAmount !== undefined ? this.betPayoutAmount : null;
        data["BetPayoutTime"] = this.betPayoutTime ? this.betPayoutTime.toISOString() : null;
        data["BetWinLoseAmount"] = this.betWinLoseAmount !== undefined ? this.betWinLoseAmount : null;
        data["ExpectedPromotionPayoutAmount"] = this.expectedPromotionPayoutAmount !== undefined ? this.expectedPromotionPayoutAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerPromotionGetEstimatedManualRedeemAmountResponse(JSON.parse(json));
    }
}

export class PlayerPromotionManualRedeemChoiceRecordRequest { 
    redeemRecordList: RedeemRecord[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["RedeemRecordList"] && data["RedeemRecordList"].constructor === Array) {
                this.redeemRecordList = [];
                for (let item of data["RedeemRecordList"])
                    this.redeemRecordList.push(RedeemRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerPromotionManualRedeemChoiceRecordRequest {
        return new PlayerPromotionManualRedeemChoiceRecordRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.redeemRecordList && this.redeemRecordList.constructor === Array) {
            data["RedeemRecordList"] = [];
            for (let item of this.redeemRecordList)
                data["RedeemRecordList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerPromotionManualRedeemChoiceRecordRequest(JSON.parse(json));
    }
}

export class RedeemRecord { 
    playerId: number; 
    lobbyPromotionId: number; 
    autoPromotionId: AutoPromotionId; 
    dateKey: string; 
    redeemAmount: number; 
    remark: string; 
    betTransactionNo: string; 
    gamePlatformBetTransactionNo: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.autoPromotionId = data["AutoPromotionId"] !== undefined ? data["AutoPromotionId"] : null;
            this.dateKey = data["DateKey"] !== undefined ? data["DateKey"] : null;
            this.redeemAmount = data["RedeemAmount"] !== undefined ? data["RedeemAmount"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.betTransactionNo = data["BetTransactionNo"] !== undefined ? data["BetTransactionNo"] : null;
            this.gamePlatformBetTransactionNo = data["GamePlatformBetTransactionNo"] !== undefined ? data["GamePlatformBetTransactionNo"] : null;
        }
    }

    static fromJS(data: any): RedeemRecord {
        return new RedeemRecord(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["AutoPromotionId"] = this.autoPromotionId !== undefined ? this.autoPromotionId : null;
        data["DateKey"] = this.dateKey !== undefined ? this.dateKey : null;
        data["RedeemAmount"] = this.redeemAmount !== undefined ? this.redeemAmount : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["BetTransactionNo"] = this.betTransactionNo !== undefined ? this.betTransactionNo : null;
        data["GamePlatformBetTransactionNo"] = this.gamePlatformBetTransactionNo !== undefined ? this.gamePlatformBetTransactionNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new RedeemRecord(JSON.parse(json));
    }
}

export class PlayerPromotionGetAllStatusSectionRequest { 
    statusIdList: PlayerPromotionChoiceRecordStatusId[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["statusIdList"] && data["statusIdList"].constructor === Array) {
                this.statusIdList = [];
                for (let item of data["statusIdList"])
                    this.statusIdList.push(item);
            }
        }
    }

    static fromJS(data: any): PlayerPromotionGetAllStatusSectionRequest {
        return new PlayerPromotionGetAllStatusSectionRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.statusIdList && this.statusIdList.constructor === Array) {
            data["statusIdList"] = [];
            for (let item of this.statusIdList)
                data["statusIdList"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerPromotionGetAllStatusSectionRequest(JSON.parse(json));
    }
}

export class StandardResultOfListOfCmsSelectionOptionDao { 
    isSuccess: boolean; 
    payload: CmsSelectionOptionDao[]; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            if (data["Payload"] && data["Payload"].constructor === Array) {
                this.payload = [];
                for (let item of data["Payload"])
                    this.payload.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["Errors"] && data["Errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["Errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResultOfListOfCmsSelectionOptionDao {
        return new StandardResultOfListOfCmsSelectionOptionDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.payload && this.payload.constructor === Array) {
            data["Payload"] = [];
            for (let item of this.payload)
                data["Payload"].push(item.toJS());
        }
        if (this.errors && this.errors.constructor === Array) {
            data["Errors"] = [];
            for (let item of this.errors)
                data["Errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResultOfListOfCmsSelectionOptionDao(JSON.parse(json));
    }
}

export class PlayerRankingGetListRequest { 
    lobbyId: number; 
    startDate: Date; 
    endDate: Date; 
    size: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["lobbyId"] !== undefined ? data["lobbyId"] : null;
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : null;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : null;
            this.size = data["size"] !== undefined ? data["size"] : null;
        }
    }

    static fromJS(data: any): PlayerRankingGetListRequest {
        return new PlayerRankingGetListRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["lobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["size"] = this.size !== undefined ? this.size : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerRankingGetListRequest(JSON.parse(json));
    }
}

export class PlayerRankingGetListResponse { 
    userId: number; 
    username: string; 
    rollingAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.userId = data["userId"] !== undefined ? data["userId"] : null;
            this.username = data["username"] !== undefined ? data["username"] : null;
            this.rollingAmount = data["rollingAmount"] !== undefined ? data["rollingAmount"] : null;
        }
    }

    static fromJS(data: any): PlayerRankingGetListResponse {
        return new PlayerRankingGetListResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["userId"] = this.userId !== undefined ? this.userId : null;
        data["username"] = this.username !== undefined ? this.username : null;
        data["rollingAmount"] = this.rollingAmount !== undefined ? this.rollingAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerRankingGetListResponse(JSON.parse(json));
    }
}

export class PlayerRankingCreateByListRequest { 
    lobbyId: number; 
    username: string; 
    rollingAmount: number; 
    recordDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["lobbyId"] !== undefined ? data["lobbyId"] : null;
            this.username = data["username"] !== undefined ? data["username"] : null;
            this.rollingAmount = data["rollingAmount"] !== undefined ? data["rollingAmount"] : null;
            this.recordDate = data["recordDate"] ? new Date(data["recordDate"].toString()) : null;
        }
    }

    static fromJS(data: any): PlayerRankingCreateByListRequest {
        return new PlayerRankingCreateByListRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["lobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["username"] = this.username !== undefined ? this.username : null;
        data["rollingAmount"] = this.rollingAmount !== undefined ? this.rollingAmount : null;
        data["recordDate"] = this.recordDate ? this.recordDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerRankingCreateByListRequest(JSON.parse(json));
    }
}

export class PlayerRankingItem { 
    lobbyId: number; 
    username: string; 
    rollingAmount: number; 
    recordDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["lobbyId"] !== undefined ? data["lobbyId"] : null;
            this.username = data["username"] !== undefined ? data["username"] : null;
            this.rollingAmount = data["rollingAmount"] !== undefined ? data["rollingAmount"] : null;
            this.recordDate = data["recordDate"] ? new Date(data["recordDate"].toString()) : null;
        }
    }

    static fromJS(data: any): PlayerRankingItem {
        return new PlayerRankingItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["lobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["username"] = this.username !== undefined ? this.username : null;
        data["rollingAmount"] = this.rollingAmount !== undefined ? this.rollingAmount : null;
        data["recordDate"] = this.recordDate ? this.recordDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerRankingItem(JSON.parse(json));
    }
}

export class PlayerReferenceGroupGetRequest { 
    lobbyReferenceGroupId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyReferenceGroupId = data["LobbyReferenceGroupId"] !== undefined ? data["LobbyReferenceGroupId"] : null;
        }
    }

    static fromJS(data: any): PlayerReferenceGroupGetRequest {
        return new PlayerReferenceGroupGetRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyReferenceGroupId"] = this.lobbyReferenceGroupId !== undefined ? this.lobbyReferenceGroupId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerReferenceGroupGetRequest(JSON.parse(json));
    }
}

export class StandardResponseOfIEnumerableOfPlayerReferenceGroupGetResponse { 
    isSuccess: boolean; 
    payload: PlayerReferenceGroupGetResponse[]; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            if (data["payload"] && data["payload"].constructor === Array) {
                this.payload = [];
                for (let item of data["payload"])
                    this.payload.push(PlayerReferenceGroupGetResponse.fromJS(item));
            }
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfIEnumerableOfPlayerReferenceGroupGetResponse {
        return new StandardResponseOfIEnumerableOfPlayerReferenceGroupGetResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.payload && this.payload.constructor === Array) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item.toJS());
        }
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfIEnumerableOfPlayerReferenceGroupGetResponse(JSON.parse(json));
    }
}

export class PlayerReferenceGroupGetResponse { 
    playerId: number; 
    userName: string; 
    lobbyReferenceGroupId: number; 
    createDate: Date; 
    createBy: string; 
    updateDate: Date; 
    updateBy: string; 
    isActive: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
            this.lobbyReferenceGroupId = data["LobbyReferenceGroupId"] !== undefined ? data["LobbyReferenceGroupId"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.createBy = data["CreateBy"] !== undefined ? data["CreateBy"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.isActive = data["IsActive"] !== undefined ? data["IsActive"] : null;
        }
    }

    static fromJS(data: any): PlayerReferenceGroupGetResponse {
        return new PlayerReferenceGroupGetResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        data["LobbyReferenceGroupId"] = this.lobbyReferenceGroupId !== undefined ? this.lobbyReferenceGroupId : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["CreateBy"] = this.createBy !== undefined ? this.createBy : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["IsActive"] = this.isActive !== undefined ? this.isActive : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerReferenceGroupGetResponse(JSON.parse(json));
    }
}

export class PlayerReferenceGroupUpdateRequest { 
    lobbyReferenceGroupId: number; 
    isActive: boolean; 
    playerIds: number[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyReferenceGroupId = data["LobbyReferenceGroupId"] !== undefined ? data["LobbyReferenceGroupId"] : null;
            this.isActive = data["IsActive"] !== undefined ? data["IsActive"] : null;
            if (data["PlayerIds"] && data["PlayerIds"].constructor === Array) {
                this.playerIds = [];
                for (let item of data["PlayerIds"])
                    this.playerIds.push(item);
            }
        }
    }

    static fromJS(data: any): PlayerReferenceGroupUpdateRequest {
        return new PlayerReferenceGroupUpdateRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyReferenceGroupId"] = this.lobbyReferenceGroupId !== undefined ? this.lobbyReferenceGroupId : null;
        data["IsActive"] = this.isActive !== undefined ? this.isActive : null;
        if (this.playerIds && this.playerIds.constructor === Array) {
            data["PlayerIds"] = [];
            for (let item of this.playerIds)
                data["PlayerIds"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerReferenceGroupUpdateRequest(JSON.parse(json));
    }
}

export class PromotionCreateRequestDao { 
    lobbyId: number; 
    name: string; 
    publishDate: Date; 
    isPublish: boolean; 
    lobbyPromotionTypeId: number; 
    promotionTranslations: PromotionTranslationDao[]; 
    isEnable: boolean; 
    maxAmount: number; 
    lobbyPromotionGroupIdList: number[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.publishDate = data["PublishDate"] ? new Date(data["PublishDate"].toString()) : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
            this.lobbyPromotionTypeId = data["LobbyPromotionTypeId"] !== undefined ? data["LobbyPromotionTypeId"] : null;
            if (data["PromotionTranslations"] && data["PromotionTranslations"].constructor === Array) {
                this.promotionTranslations = [];
                for (let item of data["PromotionTranslations"])
                    this.promotionTranslations.push(PromotionTranslationDao.fromJS(item));
            }
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
            this.maxAmount = data["MaxAmount"] !== undefined ? data["MaxAmount"] : null;
            if (data["LobbyPromotionGroupIdList"] && data["LobbyPromotionGroupIdList"].constructor === Array) {
                this.lobbyPromotionGroupIdList = [];
                for (let item of data["LobbyPromotionGroupIdList"])
                    this.lobbyPromotionGroupIdList.push(item);
            }
        }
    }

    static fromJS(data: any): PromotionCreateRequestDao {
        return new PromotionCreateRequestDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["PublishDate"] = this.publishDate ? this.publishDate.toISOString() : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        data["LobbyPromotionTypeId"] = this.lobbyPromotionTypeId !== undefined ? this.lobbyPromotionTypeId : null;
        if (this.promotionTranslations && this.promotionTranslations.constructor === Array) {
            data["PromotionTranslations"] = [];
            for (let item of this.promotionTranslations)
                data["PromotionTranslations"].push(item.toJS());
        }
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        data["MaxAmount"] = this.maxAmount !== undefined ? this.maxAmount : null;
        if (this.lobbyPromotionGroupIdList && this.lobbyPromotionGroupIdList.constructor === Array) {
            data["LobbyPromotionGroupIdList"] = [];
            for (let item of this.lobbyPromotionGroupIdList)
                data["LobbyPromotionGroupIdList"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PromotionCreateRequestDao(JSON.parse(json));
    }
}

export class PromotionTranslationDao { 
    languageId: number; 
    languageName: string; 
    title: string; 
    titleDescription: string; 
    description: string; 
    coverImagePath: string; 
    coverImagePathMobile: string; 
    detailImagePath: string; 
    detailImagePathMobile: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.languageName = data["LanguageName"] !== undefined ? data["LanguageName"] : null;
            this.title = data["Title"] !== undefined ? data["Title"] : null;
            this.titleDescription = data["TitleDescription"] !== undefined ? data["TitleDescription"] : null;
            this.description = data["Description"] !== undefined ? data["Description"] : null;
            this.coverImagePath = data["CoverImagePath"] !== undefined ? data["CoverImagePath"] : null;
            this.coverImagePathMobile = data["CoverImagePathMobile"] !== undefined ? data["CoverImagePathMobile"] : null;
            this.detailImagePath = data["DetailImagePath"] !== undefined ? data["DetailImagePath"] : null;
            this.detailImagePathMobile = data["DetailImagePathMobile"] !== undefined ? data["DetailImagePathMobile"] : null;
        }
    }

    static fromJS(data: any): PromotionTranslationDao {
        return new PromotionTranslationDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["LanguageName"] = this.languageName !== undefined ? this.languageName : null;
        data["Title"] = this.title !== undefined ? this.title : null;
        data["TitleDescription"] = this.titleDescription !== undefined ? this.titleDescription : null;
        data["Description"] = this.description !== undefined ? this.description : null;
        data["CoverImagePath"] = this.coverImagePath !== undefined ? this.coverImagePath : null;
        data["CoverImagePathMobile"] = this.coverImagePathMobile !== undefined ? this.coverImagePathMobile : null;
        data["DetailImagePath"] = this.detailImagePath !== undefined ? this.detailImagePath : null;
        data["DetailImagePathMobile"] = this.detailImagePathMobile !== undefined ? this.detailImagePathMobile : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PromotionTranslationDao(JSON.parse(json));
    }
}

export class StandardResponseOfPromotionGetForAddResponse { 
    isSuccess: boolean; 
    payload: PromotionGetForAddResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? PromotionGetForAddResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfPromotionGetForAddResponse {
        return new StandardResponseOfPromotionGetForAddResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfPromotionGetForAddResponse(JSON.parse(json));
    }
}

export class PromotionGetForAddResponse { 
    languageList: LobbyLanguageResponse[]; 
    lobbyPromotionGroupList: SelectionOption[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["LanguageList"] && data["LanguageList"].constructor === Array) {
                this.languageList = [];
                for (let item of data["LanguageList"])
                    this.languageList.push(LobbyLanguageResponse.fromJS(item));
            }
            if (data["LobbyPromotionGroupList"] && data["LobbyPromotionGroupList"].constructor === Array) {
                this.lobbyPromotionGroupList = [];
                for (let item of data["LobbyPromotionGroupList"])
                    this.lobbyPromotionGroupList.push(SelectionOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionGetForAddResponse {
        return new PromotionGetForAddResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.languageList && this.languageList.constructor === Array) {
            data["LanguageList"] = [];
            for (let item of this.languageList)
                data["LanguageList"].push(item.toJS());
        }
        if (this.lobbyPromotionGroupList && this.lobbyPromotionGroupList.constructor === Array) {
            data["LobbyPromotionGroupList"] = [];
            for (let item of this.lobbyPromotionGroupList)
                data["LobbyPromotionGroupList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PromotionGetForAddResponse(JSON.parse(json));
    }
}

export class PromotionEditRequestDao { 
    lobbyPromotionId: number; 
    name: string; 
    publishDate: Date; 
    isPublish: boolean; 
    lobbyPromotionTypeId: number; 
    promotionTranslations: PromotionTranslationDao[]; 
    isEnable: boolean; 
    maxAmount: number; 
    lobbyPromotionGroupIdList: number[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPromotionId = data["LobbyPromotionId"] !== undefined ? data["LobbyPromotionId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.publishDate = data["PublishDate"] ? new Date(data["PublishDate"].toString()) : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
            this.lobbyPromotionTypeId = data["LobbyPromotionTypeId"] !== undefined ? data["LobbyPromotionTypeId"] : null;
            if (data["PromotionTranslations"] && data["PromotionTranslations"].constructor === Array) {
                this.promotionTranslations = [];
                for (let item of data["PromotionTranslations"])
                    this.promotionTranslations.push(PromotionTranslationDao.fromJS(item));
            }
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
            this.maxAmount = data["MaxAmount"] !== undefined ? data["MaxAmount"] : null;
            if (data["LobbyPromotionGroupIdList"] && data["LobbyPromotionGroupIdList"].constructor === Array) {
                this.lobbyPromotionGroupIdList = [];
                for (let item of data["LobbyPromotionGroupIdList"])
                    this.lobbyPromotionGroupIdList.push(item);
            }
        }
    }

    static fromJS(data: any): PromotionEditRequestDao {
        return new PromotionEditRequestDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPromotionId"] = this.lobbyPromotionId !== undefined ? this.lobbyPromotionId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["PublishDate"] = this.publishDate ? this.publishDate.toISOString() : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        data["LobbyPromotionTypeId"] = this.lobbyPromotionTypeId !== undefined ? this.lobbyPromotionTypeId : null;
        if (this.promotionTranslations && this.promotionTranslations.constructor === Array) {
            data["PromotionTranslations"] = [];
            for (let item of this.promotionTranslations)
                data["PromotionTranslations"].push(item.toJS());
        }
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        data["MaxAmount"] = this.maxAmount !== undefined ? this.maxAmount : null;
        if (this.lobbyPromotionGroupIdList && this.lobbyPromotionGroupIdList.constructor === Array) {
            data["LobbyPromotionGroupIdList"] = [];
            for (let item of this.lobbyPromotionGroupIdList)
                data["LobbyPromotionGroupIdList"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PromotionEditRequestDao(JSON.parse(json));
    }
}

export class PromotionResponse { 
    id: number; 
    name: string; 
    publishDate: Date; 
    isPublish: boolean; 
    isEditable: boolean; 
    title: string; 
    isEnable: boolean; 
    seq: number; 
    type: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.publishDate = data["PublishDate"] ? new Date(data["PublishDate"].toString()) : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
            this.isEditable = data["IsEditable"] !== undefined ? data["IsEditable"] : null;
            this.title = data["Title"] !== undefined ? data["Title"] : null;
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
            this.seq = data["Seq"] !== undefined ? data["Seq"] : null;
            this.type = data["Type"] !== undefined ? data["Type"] : null;
        }
    }

    static fromJS(data: any): PromotionResponse {
        return new PromotionResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["PublishDate"] = this.publishDate ? this.publishDate.toISOString() : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        data["IsEditable"] = this.isEditable !== undefined ? this.isEditable : null;
        data["Title"] = this.title !== undefined ? this.title : null;
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        data["Seq"] = this.seq !== undefined ? this.seq : null;
        data["Type"] = this.type !== undefined ? this.type : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PromotionResponse(JSON.parse(json));
    }
}

export class PromotionGetRequest { 
    lobbyPromotionGroupId: number; 
    autoPromotionGroupId: number; 
    isEnable: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPromotionGroupId = data["LobbyPromotionGroupId"] !== undefined ? data["LobbyPromotionGroupId"] : null;
            this.autoPromotionGroupId = data["AutoPromotionGroupId"] !== undefined ? data["AutoPromotionGroupId"] : null;
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
        }
    }

    static fromJS(data: any): PromotionGetRequest {
        return new PromotionGetRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPromotionGroupId"] = this.lobbyPromotionGroupId !== undefined ? this.lobbyPromotionGroupId : null;
        data["AutoPromotionGroupId"] = this.autoPromotionGroupId !== undefined ? this.autoPromotionGroupId : null;
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PromotionGetRequest(JSON.parse(json));
    }
}

export class StandardResponseOfPromotionGetResponse { 
    isSuccess: boolean; 
    payload: PromotionGetResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? PromotionGetResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfPromotionGetResponse {
        return new StandardResponseOfPromotionGetResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfPromotionGetResponse(JSON.parse(json));
    }
}

export class PromotionGetResponse { 
    promotionList: PromotionItem[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["PromotionList"] && data["PromotionList"].constructor === Array) {
                this.promotionList = [];
                for (let item of data["PromotionList"])
                    this.promotionList.push(PromotionItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionGetResponse {
        return new PromotionGetResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.promotionList && this.promotionList.constructor === Array) {
            data["PromotionList"] = [];
            for (let item of this.promotionList)
                data["PromotionList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PromotionGetResponse(JSON.parse(json));
    }
}

export class PromotionItem { 
    id: number; 
    name: string; 
    publishDate: Date; 
    isPublish: boolean; 
    isEditable: boolean; 
    title: string; 
    isEnable: boolean; 
    type: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.publishDate = data["PublishDate"] ? new Date(data["PublishDate"].toString()) : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
            this.isEditable = data["IsEditable"] !== undefined ? data["IsEditable"] : null;
            this.title = data["Title"] !== undefined ? data["Title"] : null;
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
            this.type = data["Type"] !== undefined ? data["Type"] : null;
        }
    }

    static fromJS(data: any): PromotionItem {
        return new PromotionItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["PublishDate"] = this.publishDate ? this.publishDate.toISOString() : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        data["IsEditable"] = this.isEditable !== undefined ? this.isEditable : null;
        data["Title"] = this.title !== undefined ? this.title : null;
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        data["Type"] = this.type !== undefined ? this.type : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PromotionItem(JSON.parse(json));
    }
}

export class StandardResponseOfPromotionEditResponse { 
    isSuccess: boolean; 
    payload: PromotionEditResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? PromotionEditResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfPromotionEditResponse {
        return new StandardResponseOfPromotionEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfPromotionEditResponse(JSON.parse(json));
    }
}

export class PromotionEditResponse { 
    id: number; 
    name: string; 
    publishDate: Date; 
    isPublish: boolean; 
    lobbyPromotionTypeId: number; 
    promotionTranslations: PromotionTranslationDao[]; 
    isEnable: boolean; 
    maxAmount: number; 
    allLobbyPromotionGroupIdList: SelectionOption[]; 
    lobbyPromotionGroupIdList: number[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.publishDate = data["PublishDate"] ? new Date(data["PublishDate"].toString()) : null;
            this.isPublish = data["IsPublish"] !== undefined ? data["IsPublish"] : null;
            this.lobbyPromotionTypeId = data["LobbyPromotionTypeId"] !== undefined ? data["LobbyPromotionTypeId"] : null;
            if (data["PromotionTranslations"] && data["PromotionTranslations"].constructor === Array) {
                this.promotionTranslations = [];
                for (let item of data["PromotionTranslations"])
                    this.promotionTranslations.push(PromotionTranslationDao.fromJS(item));
            }
            this.isEnable = data["IsEnable"] !== undefined ? data["IsEnable"] : null;
            this.maxAmount = data["MaxAmount"] !== undefined ? data["MaxAmount"] : null;
            if (data["AllLobbyPromotionGroupIdList"] && data["AllLobbyPromotionGroupIdList"].constructor === Array) {
                this.allLobbyPromotionGroupIdList = [];
                for (let item of data["AllLobbyPromotionGroupIdList"])
                    this.allLobbyPromotionGroupIdList.push(SelectionOption.fromJS(item));
            }
            if (data["LobbyPromotionGroupIdList"] && data["LobbyPromotionGroupIdList"].constructor === Array) {
                this.lobbyPromotionGroupIdList = [];
                for (let item of data["LobbyPromotionGroupIdList"])
                    this.lobbyPromotionGroupIdList.push(item);
            }
        }
    }

    static fromJS(data: any): PromotionEditResponse {
        return new PromotionEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["PublishDate"] = this.publishDate ? this.publishDate.toISOString() : null;
        data["IsPublish"] = this.isPublish !== undefined ? this.isPublish : null;
        data["LobbyPromotionTypeId"] = this.lobbyPromotionTypeId !== undefined ? this.lobbyPromotionTypeId : null;
        if (this.promotionTranslations && this.promotionTranslations.constructor === Array) {
            data["PromotionTranslations"] = [];
            for (let item of this.promotionTranslations)
                data["PromotionTranslations"].push(item.toJS());
        }
        data["IsEnable"] = this.isEnable !== undefined ? this.isEnable : null;
        data["MaxAmount"] = this.maxAmount !== undefined ? this.maxAmount : null;
        if (this.allLobbyPromotionGroupIdList && this.allLobbyPromotionGroupIdList.constructor === Array) {
            data["AllLobbyPromotionGroupIdList"] = [];
            for (let item of this.allLobbyPromotionGroupIdList)
                data["AllLobbyPromotionGroupIdList"].push(item.toJS());
        }
        if (this.lobbyPromotionGroupIdList && this.lobbyPromotionGroupIdList.constructor === Array) {
            data["LobbyPromotionGroupIdList"] = [];
            for (let item of this.lobbyPromotionGroupIdList)
                data["LobbyPromotionGroupIdList"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PromotionEditResponse(JSON.parse(json));
    }
}

export class SetSortByListRequest { 
    lobbyPromotionGroupId: number; 
    autoPromotionGroupId: number; 
    promotionSortItemList: PromotionSortItem[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPromotionGroupId = data["LobbyPromotionGroupId"] !== undefined ? data["LobbyPromotionGroupId"] : null;
            this.autoPromotionGroupId = data["AutoPromotionGroupId"] !== undefined ? data["AutoPromotionGroupId"] : null;
            if (data["PromotionSortItemList"] && data["PromotionSortItemList"].constructor === Array) {
                this.promotionSortItemList = [];
                for (let item of data["PromotionSortItemList"])
                    this.promotionSortItemList.push(PromotionSortItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SetSortByListRequest {
        return new SetSortByListRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPromotionGroupId"] = this.lobbyPromotionGroupId !== undefined ? this.lobbyPromotionGroupId : null;
        data["AutoPromotionGroupId"] = this.autoPromotionGroupId !== undefined ? this.autoPromotionGroupId : null;
        if (this.promotionSortItemList && this.promotionSortItemList.constructor === Array) {
            data["PromotionSortItemList"] = [];
            for (let item of this.promotionSortItemList)
                data["PromotionSortItemList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SetSortByListRequest(JSON.parse(json));
    }
}

export class PromotionSortItem { 
    id: number; 
    sortNo: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.sortNo = data["SortNo"] !== undefined ? data["SortNo"] : null;
        }
    }

    static fromJS(data: any): PromotionSortItem {
        return new PromotionSortItem(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["SortNo"] = this.sortNo !== undefined ? this.sortNo : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PromotionSortItem(JSON.parse(json));
    }
}

export class PromotionGetForSortingRequest { 
    lobbyPromotionGroupId: number; 
    autoPromotionGroupId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyPromotionGroupId = data["LobbyPromotionGroupId"] !== undefined ? data["LobbyPromotionGroupId"] : null;
            this.autoPromotionGroupId = data["AutoPromotionGroupId"] !== undefined ? data["AutoPromotionGroupId"] : null;
        }
    }

    static fromJS(data: any): PromotionGetForSortingRequest {
        return new PromotionGetForSortingRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyPromotionGroupId"] = this.lobbyPromotionGroupId !== undefined ? this.lobbyPromotionGroupId : null;
        data["AutoPromotionGroupId"] = this.autoPromotionGroupId !== undefined ? this.autoPromotionGroupId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PromotionGetForSortingRequest(JSON.parse(json));
    }
}

export class StandardResponseOfPromotionGetForSortingResponse { 
    isSuccess: boolean; 
    payload: PromotionGetForSortingResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? PromotionGetForSortingResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfPromotionGetForSortingResponse {
        return new StandardResponseOfPromotionGetForSortingResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfPromotionGetForSortingResponse(JSON.parse(json));
    }
}

export class PromotionGetForSortingResponse { 
    groupName: string; 
    promotionList: PromotionResponse[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.groupName = data["GroupName"] !== undefined ? data["GroupName"] : null;
            if (data["PromotionList"] && data["PromotionList"].constructor === Array) {
                this.promotionList = [];
                for (let item of data["PromotionList"])
                    this.promotionList.push(PromotionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionGetForSortingResponse {
        return new PromotionGetForSortingResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["GroupName"] = this.groupName !== undefined ? this.groupName : null;
        if (this.promotionList && this.promotionList.constructor === Array) {
            data["PromotionList"] = [];
            for (let item of this.promotionList)
                data["PromotionList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PromotionGetForSortingResponse(JSON.parse(json));
    }
}

export class StandardResponseOfPromotionGetForIndexResponse { 
    isSuccess: boolean; 
    payload: PromotionGetForIndexResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? PromotionGetForIndexResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfPromotionGetForIndexResponse {
        return new StandardResponseOfPromotionGetForIndexResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfPromotionGetForIndexResponse(JSON.parse(json));
    }
}

export class PromotionGetForIndexResponse { 
    promotionTypeList: SelectionOption[]; 
    lobbyPromotionGroupList: SelectionOption[]; 
    autoPromotionGroupList: SelectionOption[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["PromotionTypeList"] && data["PromotionTypeList"].constructor === Array) {
                this.promotionTypeList = [];
                for (let item of data["PromotionTypeList"])
                    this.promotionTypeList.push(SelectionOption.fromJS(item));
            }
            if (data["LobbyPromotionGroupList"] && data["LobbyPromotionGroupList"].constructor === Array) {
                this.lobbyPromotionGroupList = [];
                for (let item of data["LobbyPromotionGroupList"])
                    this.lobbyPromotionGroupList.push(SelectionOption.fromJS(item));
            }
            if (data["AutoPromotionGroupList"] && data["AutoPromotionGroupList"].constructor === Array) {
                this.autoPromotionGroupList = [];
                for (let item of data["AutoPromotionGroupList"])
                    this.autoPromotionGroupList.push(SelectionOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PromotionGetForIndexResponse {
        return new PromotionGetForIndexResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.promotionTypeList && this.promotionTypeList.constructor === Array) {
            data["PromotionTypeList"] = [];
            for (let item of this.promotionTypeList)
                data["PromotionTypeList"].push(item.toJS());
        }
        if (this.lobbyPromotionGroupList && this.lobbyPromotionGroupList.constructor === Array) {
            data["LobbyPromotionGroupList"] = [];
            for (let item of this.lobbyPromotionGroupList)
                data["LobbyPromotionGroupList"].push(item.toJS());
        }
        if (this.autoPromotionGroupList && this.autoPromotionGroupList.constructor === Array) {
            data["AutoPromotionGroupList"] = [];
            for (let item of this.autoPromotionGroupList)
                data["AutoPromotionGroupList"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PromotionGetForIndexResponse(JSON.parse(json));
    }
}

export class RebateActiveDao { 
    gameDevId: number; 
    gameDevName: string; 
    gameTypeId: number; 
    gameTypeName: string; 
    rebateRate: number; 
    effectiveDateFrom: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
            this.gameTypeId = data["GameTypeId"] !== undefined ? data["GameTypeId"] : null;
            this.gameTypeName = data["GameTypeName"] !== undefined ? data["GameTypeName"] : null;
            this.rebateRate = data["RebateRate"] !== undefined ? data["RebateRate"] : null;
            this.effectiveDateFrom = data["EffectiveDateFrom"] ? new Date(data["EffectiveDateFrom"].toString()) : null;
        }
    }

    static fromJS(data: any): RebateActiveDao {
        return new RebateActiveDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        data["GameTypeId"] = this.gameTypeId !== undefined ? this.gameTypeId : null;
        data["GameTypeName"] = this.gameTypeName !== undefined ? this.gameTypeName : null;
        data["RebateRate"] = this.rebateRate !== undefined ? this.rebateRate : null;
        data["EffectiveDateFrom"] = this.effectiveDateFrom ? this.effectiveDateFrom.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new RebateActiveDao(JSON.parse(json));
    }
}

export class RebateRateIndividualDao { 
    id: number; 
    gameDevId: number; 
    gameDevName: string; 
    gameTypeId: number; 
    gameTypeName: string; 
    rebateRate: number; 
    effectiveDateFrom: Date; 
    rebateRateInUse: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
            this.gameTypeId = data["GameTypeId"] !== undefined ? data["GameTypeId"] : null;
            this.gameTypeName = data["GameTypeName"] !== undefined ? data["GameTypeName"] : null;
            this.rebateRate = data["RebateRate"] !== undefined ? data["RebateRate"] : null;
            this.effectiveDateFrom = data["EffectiveDateFrom"] ? new Date(data["EffectiveDateFrom"].toString()) : null;
            this.rebateRateInUse = data["RebateRateInUse"] !== undefined ? data["RebateRateInUse"] : null;
        }
    }

    static fromJS(data: any): RebateRateIndividualDao {
        return new RebateRateIndividualDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        data["GameTypeId"] = this.gameTypeId !== undefined ? this.gameTypeId : null;
        data["GameTypeName"] = this.gameTypeName !== undefined ? this.gameTypeName : null;
        data["RebateRate"] = this.rebateRate !== undefined ? this.rebateRate : null;
        data["EffectiveDateFrom"] = this.effectiveDateFrom ? this.effectiveDateFrom.toISOString() : null;
        data["RebateRateInUse"] = this.rebateRateInUse !== undefined ? this.rebateRateInUse : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new RebateRateIndividualDao(JSON.parse(json));
    }
}

export class RebateRateAddRequest { 
    lobbyId: number; 
    gameDevId: number; 
    gameTypeId: number; 
    rebateRate: number; 
    effectiveDateFrom: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.gameTypeId = data["GameTypeId"] !== undefined ? data["GameTypeId"] : null;
            this.rebateRate = data["RebateRate"] !== undefined ? data["RebateRate"] : null;
            this.effectiveDateFrom = data["EffectiveDateFrom"] ? new Date(data["EffectiveDateFrom"].toString()) : null;
        }
    }

    static fromJS(data: any): RebateRateAddRequest {
        return new RebateRateAddRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["GameTypeId"] = this.gameTypeId !== undefined ? this.gameTypeId : null;
        data["RebateRate"] = this.rebateRate !== undefined ? this.rebateRate : null;
        data["EffectiveDateFrom"] = this.effectiveDateFrom ? this.effectiveDateFrom.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new RebateRateAddRequest(JSON.parse(json));
    }
}

export class RebateRateEditResponse { 
    id: number; 
    gameDevId: number; 
    gameTypeId: number; 
    rebateRate: number; 
    effectiveDateFrom: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.gameTypeId = data["GameTypeId"] !== undefined ? data["GameTypeId"] : null;
            this.rebateRate = data["RebateRate"] !== undefined ? data["RebateRate"] : null;
            this.effectiveDateFrom = data["EffectiveDateFrom"] ? new Date(data["EffectiveDateFrom"].toString()) : null;
        }
    }

    static fromJS(data: any): RebateRateEditResponse {
        return new RebateRateEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["GameTypeId"] = this.gameTypeId !== undefined ? this.gameTypeId : null;
        data["RebateRate"] = this.rebateRate !== undefined ? this.rebateRate : null;
        data["EffectiveDateFrom"] = this.effectiveDateFrom ? this.effectiveDateFrom.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new RebateRateEditResponse(JSON.parse(json));
    }
}

export class RebateRateEditRequest { 
    id: number; 
    rebateRate: number; 
    effectiveDateFrom: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.rebateRate = data["RebateRate"] !== undefined ? data["RebateRate"] : null;
            this.effectiveDateFrom = data["EffectiveDateFrom"] ? new Date(data["EffectiveDateFrom"].toString()) : null;
        }
    }

    static fromJS(data: any): RebateRateEditRequest {
        return new RebateRateEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["RebateRate"] = this.rebateRate !== undefined ? this.rebateRate : null;
        data["EffectiveDateFrom"] = this.effectiveDateFrom ? this.effectiveDateFrom.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new RebateRateEditRequest(JSON.parse(json));
    }
}

export class LR_ImportMemberData_Response { 
    errorMessages: string[]; 
    playerGiftPointExportDatas: PlayerGiftPointExportData[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["errorMessages"] && data["errorMessages"].constructor === Array) {
                this.errorMessages = [];
                for (let item of data["errorMessages"])
                    this.errorMessages.push(item);
            }
            if (data["playerGiftPointExportDatas"] && data["playerGiftPointExportDatas"].constructor === Array) {
                this.playerGiftPointExportDatas = [];
                for (let item of data["playerGiftPointExportDatas"])
                    this.playerGiftPointExportDatas.push(PlayerGiftPointExportData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LR_ImportMemberData_Response {
        return new LR_ImportMemberData_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.errorMessages && this.errorMessages.constructor === Array) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        if (this.playerGiftPointExportDatas && this.playerGiftPointExportDatas.constructor === Array) {
            data["playerGiftPointExportDatas"] = [];
            for (let item of this.playerGiftPointExportDatas)
                data["playerGiftPointExportDatas"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LR_ImportMemberData_Response(JSON.parse(json));
    }
}

export class PlayerGiftPointExportData { 
    username: string; 
    giftPoint: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.username = data["username"] !== undefined ? data["username"] : null;
            this.giftPoint = data["giftPoint"] !== undefined ? data["giftPoint"] : null;
        }
    }

    static fromJS(data: any): PlayerGiftPointExportData {
        return new PlayerGiftPointExportData(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["username"] = this.username !== undefined ? this.username : null;
        data["giftPoint"] = this.giftPoint !== undefined ? this.giftPoint : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerGiftPointExportData(JSON.parse(json));
    }
}

export class AutoRebateReportRequest { 
    startDate: Date; 
    endDate: Date; 
    lobbyId: number; 
    language: LanguageCode;

    constructor(data?: any) {
        if (data !== undefined) {
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
        }
    }

    static fromJS(data: any): AutoRebateReportRequest {
        return new AutoRebateReportRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AutoRebateReportRequest(JSON.parse(json));
    }
}

export class AutoRebateReport { 
    count: number; 
    totalValidBet: number; 
    totalAutoRebateValidBetAmount: number; 
    totalRebate: number; 
    processedValidBet: number; 
    processedRebate: number; 
    totalBetAmount: number; 
    totalPayoutAmount: number; 
    totalResultAmount: number; 
    nextRebateAmount: number; 
    nextValidBetAmount: number; 
    minRebateRate: number; 
    maxRebateRate: number; 
    autoRebateReportGameDev: AutoRebateReportGameDev[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.count = data["Count"] !== undefined ? data["Count"] : null;
            this.totalValidBet = data["TotalValidBet"] !== undefined ? data["TotalValidBet"] : null;
            this.totalAutoRebateValidBetAmount = data["TotalAutoRebateValidBetAmount"] !== undefined ? data["TotalAutoRebateValidBetAmount"] : null;
            this.totalRebate = data["TotalRebate"] !== undefined ? data["TotalRebate"] : null;
            this.processedValidBet = data["ProcessedValidBet"] !== undefined ? data["ProcessedValidBet"] : null;
            this.processedRebate = data["ProcessedRebate"] !== undefined ? data["ProcessedRebate"] : null;
            this.totalBetAmount = data["TotalBetAmount"] !== undefined ? data["TotalBetAmount"] : null;
            this.totalPayoutAmount = data["TotalPayoutAmount"] !== undefined ? data["TotalPayoutAmount"] : null;
            this.totalResultAmount = data["TotalResultAmount"] !== undefined ? data["TotalResultAmount"] : null;
            this.nextRebateAmount = data["NextRebateAmount"] !== undefined ? data["NextRebateAmount"] : null;
            this.nextValidBetAmount = data["NextValidBetAmount"] !== undefined ? data["NextValidBetAmount"] : null;
            this.minRebateRate = data["MinRebateRate"] !== undefined ? data["MinRebateRate"] : null;
            this.maxRebateRate = data["MaxRebateRate"] !== undefined ? data["MaxRebateRate"] : null;
            if (data["AutoRebateReportGameDev"] && data["AutoRebateReportGameDev"].constructor === Array) {
                this.autoRebateReportGameDev = [];
                for (let item of data["AutoRebateReportGameDev"])
                    this.autoRebateReportGameDev.push(AutoRebateReportGameDev.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AutoRebateReport {
        return new AutoRebateReport(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Count"] = this.count !== undefined ? this.count : null;
        data["TotalValidBet"] = this.totalValidBet !== undefined ? this.totalValidBet : null;
        data["TotalAutoRebateValidBetAmount"] = this.totalAutoRebateValidBetAmount !== undefined ? this.totalAutoRebateValidBetAmount : null;
        data["TotalRebate"] = this.totalRebate !== undefined ? this.totalRebate : null;
        data["ProcessedValidBet"] = this.processedValidBet !== undefined ? this.processedValidBet : null;
        data["ProcessedRebate"] = this.processedRebate !== undefined ? this.processedRebate : null;
        data["TotalBetAmount"] = this.totalBetAmount !== undefined ? this.totalBetAmount : null;
        data["TotalPayoutAmount"] = this.totalPayoutAmount !== undefined ? this.totalPayoutAmount : null;
        data["TotalResultAmount"] = this.totalResultAmount !== undefined ? this.totalResultAmount : null;
        data["NextRebateAmount"] = this.nextRebateAmount !== undefined ? this.nextRebateAmount : null;
        data["NextValidBetAmount"] = this.nextValidBetAmount !== undefined ? this.nextValidBetAmount : null;
        data["MinRebateRate"] = this.minRebateRate !== undefined ? this.minRebateRate : null;
        data["MaxRebateRate"] = this.maxRebateRate !== undefined ? this.maxRebateRate : null;
        if (this.autoRebateReportGameDev && this.autoRebateReportGameDev.constructor === Array) {
            data["AutoRebateReportGameDev"] = [];
            for (let item of this.autoRebateReportGameDev)
                data["AutoRebateReportGameDev"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AutoRebateReport(JSON.parse(json));
    }
}

export class AutoRebateReportGameDev { 
    count: number; 
    subGameDevId: GameDevId; 
    subGameDevName: string; 
    totalValidBet: number; 
    totalAutoRebateValidBetAmount: number; 
    totalRebate: number; 
    processedValidBet: number; 
    processedRebate: number; 
    totalPayoutAmount: number; 
    totalBetAmount: number; 
    totalResultAmount: number; 
    nextRebateAmount: number; 
    nextValidBetAmount: number; 
    minRebateRate: number; 
    maxRebateRate: number; 
    autoRebateReportGameType: AutoRebateReportGameType[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.count = data["Count"] !== undefined ? data["Count"] : null;
            this.subGameDevId = data["SubGameDevId"] !== undefined ? data["SubGameDevId"] : null;
            this.subGameDevName = data["SubGameDevName"] !== undefined ? data["SubGameDevName"] : null;
            this.totalValidBet = data["TotalValidBet"] !== undefined ? data["TotalValidBet"] : null;
            this.totalAutoRebateValidBetAmount = data["TotalAutoRebateValidBetAmount"] !== undefined ? data["TotalAutoRebateValidBetAmount"] : null;
            this.totalRebate = data["TotalRebate"] !== undefined ? data["TotalRebate"] : null;
            this.processedValidBet = data["ProcessedValidBet"] !== undefined ? data["ProcessedValidBet"] : null;
            this.processedRebate = data["ProcessedRebate"] !== undefined ? data["ProcessedRebate"] : null;
            this.totalPayoutAmount = data["TotalPayoutAmount"] !== undefined ? data["TotalPayoutAmount"] : null;
            this.totalBetAmount = data["TotalBetAmount"] !== undefined ? data["TotalBetAmount"] : null;
            this.totalResultAmount = data["TotalResultAmount"] !== undefined ? data["TotalResultAmount"] : null;
            this.nextRebateAmount = data["NextRebateAmount"] !== undefined ? data["NextRebateAmount"] : null;
            this.nextValidBetAmount = data["NextValidBetAmount"] !== undefined ? data["NextValidBetAmount"] : null;
            this.minRebateRate = data["MinRebateRate"] !== undefined ? data["MinRebateRate"] : null;
            this.maxRebateRate = data["MaxRebateRate"] !== undefined ? data["MaxRebateRate"] : null;
            if (data["AutoRebateReportGameType"] && data["AutoRebateReportGameType"].constructor === Array) {
                this.autoRebateReportGameType = [];
                for (let item of data["AutoRebateReportGameType"])
                    this.autoRebateReportGameType.push(AutoRebateReportGameType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AutoRebateReportGameDev {
        return new AutoRebateReportGameDev(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Count"] = this.count !== undefined ? this.count : null;
        data["SubGameDevId"] = this.subGameDevId !== undefined ? this.subGameDevId : null;
        data["SubGameDevName"] = this.subGameDevName !== undefined ? this.subGameDevName : null;
        data["TotalValidBet"] = this.totalValidBet !== undefined ? this.totalValidBet : null;
        data["TotalAutoRebateValidBetAmount"] = this.totalAutoRebateValidBetAmount !== undefined ? this.totalAutoRebateValidBetAmount : null;
        data["TotalRebate"] = this.totalRebate !== undefined ? this.totalRebate : null;
        data["ProcessedValidBet"] = this.processedValidBet !== undefined ? this.processedValidBet : null;
        data["ProcessedRebate"] = this.processedRebate !== undefined ? this.processedRebate : null;
        data["TotalPayoutAmount"] = this.totalPayoutAmount !== undefined ? this.totalPayoutAmount : null;
        data["TotalBetAmount"] = this.totalBetAmount !== undefined ? this.totalBetAmount : null;
        data["TotalResultAmount"] = this.totalResultAmount !== undefined ? this.totalResultAmount : null;
        data["NextRebateAmount"] = this.nextRebateAmount !== undefined ? this.nextRebateAmount : null;
        data["NextValidBetAmount"] = this.nextValidBetAmount !== undefined ? this.nextValidBetAmount : null;
        data["MinRebateRate"] = this.minRebateRate !== undefined ? this.minRebateRate : null;
        data["MaxRebateRate"] = this.maxRebateRate !== undefined ? this.maxRebateRate : null;
        if (this.autoRebateReportGameType && this.autoRebateReportGameType.constructor === Array) {
            data["AutoRebateReportGameType"] = [];
            for (let item of this.autoRebateReportGameType)
                data["AutoRebateReportGameType"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AutoRebateReportGameDev(JSON.parse(json));
    }
}

export class AutoRebateReportGameType { 
    count: number; 
    subGameDevId: GameDevId; 
    subGameDevName: string; 
    gameTypeId: PlayerAmountRecordGameTypeId; 
    gameTypeName: string; 
    totalValidBet: number; 
    totalAutoRebateValidBetAmount: number; 
    totalRebate: number; 
    totalResultAmount: number; 
    processedValidBet: number; 
    processedRebate: number; 
    totalPayoutAmount: number; 
    totalBetAmount: number; 
    nextValidBetAmount: number; 
    nextRebateAmount: number; 
    minRebateRate: number; 
    maxRebateRate: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.count = data["Count"] !== undefined ? data["Count"] : null;
            this.subGameDevId = data["SubGameDevId"] !== undefined ? data["SubGameDevId"] : null;
            this.subGameDevName = data["SubGameDevName"] !== undefined ? data["SubGameDevName"] : null;
            this.gameTypeId = data["GameTypeId"] !== undefined ? data["GameTypeId"] : null;
            this.gameTypeName = data["GameTypeName"] !== undefined ? data["GameTypeName"] : null;
            this.totalValidBet = data["TotalValidBet"] !== undefined ? data["TotalValidBet"] : null;
            this.totalAutoRebateValidBetAmount = data["TotalAutoRebateValidBetAmount"] !== undefined ? data["TotalAutoRebateValidBetAmount"] : null;
            this.totalRebate = data["TotalRebate"] !== undefined ? data["TotalRebate"] : null;
            this.totalResultAmount = data["TotalResultAmount"] !== undefined ? data["TotalResultAmount"] : null;
            this.processedValidBet = data["ProcessedValidBet"] !== undefined ? data["ProcessedValidBet"] : null;
            this.processedRebate = data["ProcessedRebate"] !== undefined ? data["ProcessedRebate"] : null;
            this.totalPayoutAmount = data["TotalPayoutAmount"] !== undefined ? data["TotalPayoutAmount"] : null;
            this.totalBetAmount = data["TotalBetAmount"] !== undefined ? data["TotalBetAmount"] : null;
            this.nextValidBetAmount = data["NextValidBetAmount"] !== undefined ? data["NextValidBetAmount"] : null;
            this.nextRebateAmount = data["NextRebateAmount"] !== undefined ? data["NextRebateAmount"] : null;
            this.minRebateRate = data["MinRebateRate"] !== undefined ? data["MinRebateRate"] : null;
            this.maxRebateRate = data["MaxRebateRate"] !== undefined ? data["MaxRebateRate"] : null;
        }
    }

    static fromJS(data: any): AutoRebateReportGameType {
        return new AutoRebateReportGameType(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Count"] = this.count !== undefined ? this.count : null;
        data["SubGameDevId"] = this.subGameDevId !== undefined ? this.subGameDevId : null;
        data["SubGameDevName"] = this.subGameDevName !== undefined ? this.subGameDevName : null;
        data["GameTypeId"] = this.gameTypeId !== undefined ? this.gameTypeId : null;
        data["GameTypeName"] = this.gameTypeName !== undefined ? this.gameTypeName : null;
        data["TotalValidBet"] = this.totalValidBet !== undefined ? this.totalValidBet : null;
        data["TotalAutoRebateValidBetAmount"] = this.totalAutoRebateValidBetAmount !== undefined ? this.totalAutoRebateValidBetAmount : null;
        data["TotalRebate"] = this.totalRebate !== undefined ? this.totalRebate : null;
        data["TotalResultAmount"] = this.totalResultAmount !== undefined ? this.totalResultAmount : null;
        data["ProcessedValidBet"] = this.processedValidBet !== undefined ? this.processedValidBet : null;
        data["ProcessedRebate"] = this.processedRebate !== undefined ? this.processedRebate : null;
        data["TotalPayoutAmount"] = this.totalPayoutAmount !== undefined ? this.totalPayoutAmount : null;
        data["TotalBetAmount"] = this.totalBetAmount !== undefined ? this.totalBetAmount : null;
        data["NextValidBetAmount"] = this.nextValidBetAmount !== undefined ? this.nextValidBetAmount : null;
        data["NextRebateAmount"] = this.nextRebateAmount !== undefined ? this.nextRebateAmount : null;
        data["MinRebateRate"] = this.minRebateRate !== undefined ? this.minRebateRate : null;
        data["MaxRebateRate"] = this.maxRebateRate !== undefined ? this.maxRebateRate : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AutoRebateReportGameType(JSON.parse(json));
    }
}

export class AutoRebateReportDetailRequest { 
    startDate: Date; 
    endDate: Date; 
    lobbyId: number; 
    gameDevId: GameDevId; 
    gameTypeId: PlayerAmountRecordGameTypeId; 
    language: LanguageCode;

    constructor(data?: any) {
        if (data !== undefined) {
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.gameTypeId = data["GameTypeId"] !== undefined ? data["GameTypeId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
        }
    }

    static fromJS(data: any): AutoRebateReportDetailRequest {
        return new AutoRebateReportDetailRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["GameTypeId"] = this.gameTypeId !== undefined ? this.gameTypeId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AutoRebateReportDetailRequest(JSON.parse(json));
    }
}

export class AutoRebatePlayerDetail { 
    playerId: number; 
    username: string; 
    personalName: string; 
    agentPromotionCode: string; 
    subGameDevId: GameDevId; 
    subGameDevName: string; 
    gameTypeId: PlayerAmountRecordGameTypeId; 
    gameTypeName: string; 
    count: number; 
    totalBetAmount: number; 
    totalValidBetAmount: number; 
    totalAutoRebateValidBetAmount: number; 
    totalRebateAmount: number; 
    totalPayoutAmount: number; 
    totalResultAmount: number; 
    processedRebate: number; 
    processedValidBet: number; 
    nextValidBetAmount: number; 
    nextRebateAmount: number; 
    minRebateRate: number; 
    maxRebateRate: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.username = data["Username"] !== undefined ? data["Username"] : null;
            this.personalName = data["PersonalName"] !== undefined ? data["PersonalName"] : null;
            this.agentPromotionCode = data["AgentPromotionCode"] !== undefined ? data["AgentPromotionCode"] : null;
            this.subGameDevId = data["SubGameDevId"] !== undefined ? data["SubGameDevId"] : null;
            this.subGameDevName = data["SubGameDevName"] !== undefined ? data["SubGameDevName"] : null;
            this.gameTypeId = data["GameTypeId"] !== undefined ? data["GameTypeId"] : null;
            this.gameTypeName = data["GameTypeName"] !== undefined ? data["GameTypeName"] : null;
            this.count = data["Count"] !== undefined ? data["Count"] : null;
            this.totalBetAmount = data["TotalBetAmount"] !== undefined ? data["TotalBetAmount"] : null;
            this.totalValidBetAmount = data["TotalValidBetAmount"] !== undefined ? data["TotalValidBetAmount"] : null;
            this.totalAutoRebateValidBetAmount = data["TotalAutoRebateValidBetAmount"] !== undefined ? data["TotalAutoRebateValidBetAmount"] : null;
            this.totalRebateAmount = data["TotalRebateAmount"] !== undefined ? data["TotalRebateAmount"] : null;
            this.totalPayoutAmount = data["TotalPayoutAmount"] !== undefined ? data["TotalPayoutAmount"] : null;
            this.totalResultAmount = data["TotalResultAmount"] !== undefined ? data["TotalResultAmount"] : null;
            this.processedRebate = data["ProcessedRebate"] !== undefined ? data["ProcessedRebate"] : null;
            this.processedValidBet = data["ProcessedValidBet"] !== undefined ? data["ProcessedValidBet"] : null;
            this.nextValidBetAmount = data["NextValidBetAmount"] !== undefined ? data["NextValidBetAmount"] : null;
            this.nextRebateAmount = data["NextRebateAmount"] !== undefined ? data["NextRebateAmount"] : null;
            this.minRebateRate = data["MinRebateRate"] !== undefined ? data["MinRebateRate"] : null;
            this.maxRebateRate = data["MaxRebateRate"] !== undefined ? data["MaxRebateRate"] : null;
        }
    }

    static fromJS(data: any): AutoRebatePlayerDetail {
        return new AutoRebatePlayerDetail(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["Username"] = this.username !== undefined ? this.username : null;
        data["PersonalName"] = this.personalName !== undefined ? this.personalName : null;
        data["AgentPromotionCode"] = this.agentPromotionCode !== undefined ? this.agentPromotionCode : null;
        data["SubGameDevId"] = this.subGameDevId !== undefined ? this.subGameDevId : null;
        data["SubGameDevName"] = this.subGameDevName !== undefined ? this.subGameDevName : null;
        data["GameTypeId"] = this.gameTypeId !== undefined ? this.gameTypeId : null;
        data["GameTypeName"] = this.gameTypeName !== undefined ? this.gameTypeName : null;
        data["Count"] = this.count !== undefined ? this.count : null;
        data["TotalBetAmount"] = this.totalBetAmount !== undefined ? this.totalBetAmount : null;
        data["TotalValidBetAmount"] = this.totalValidBetAmount !== undefined ? this.totalValidBetAmount : null;
        data["TotalAutoRebateValidBetAmount"] = this.totalAutoRebateValidBetAmount !== undefined ? this.totalAutoRebateValidBetAmount : null;
        data["TotalRebateAmount"] = this.totalRebateAmount !== undefined ? this.totalRebateAmount : null;
        data["TotalPayoutAmount"] = this.totalPayoutAmount !== undefined ? this.totalPayoutAmount : null;
        data["TotalResultAmount"] = this.totalResultAmount !== undefined ? this.totalResultAmount : null;
        data["ProcessedRebate"] = this.processedRebate !== undefined ? this.processedRebate : null;
        data["ProcessedValidBet"] = this.processedValidBet !== undefined ? this.processedValidBet : null;
        data["NextValidBetAmount"] = this.nextValidBetAmount !== undefined ? this.nextValidBetAmount : null;
        data["NextRebateAmount"] = this.nextRebateAmount !== undefined ? this.nextRebateAmount : null;
        data["MinRebateRate"] = this.minRebateRate !== undefined ? this.minRebateRate : null;
        data["MaxRebateRate"] = this.maxRebateRate !== undefined ? this.maxRebateRate : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AutoRebatePlayerDetail(JSON.parse(json));
    }
}

export class DoAutoRebateRequest extends AutoRebateReportRequest { 
    gameDevsToDo: string[];

    constructor(data?: any) {
        super(data);
        if (data !== undefined) {
            if (data["GameDevsToDo"] && data["GameDevsToDo"].constructor === Array) {
                this.gameDevsToDo = [];
                for (let item of data["GameDevsToDo"])
                    this.gameDevsToDo.push(item);
            }
        }
    }

    static fromJS(data: any): DoAutoRebateRequest {
        return new DoAutoRebateRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.gameDevsToDo && this.gameDevsToDo.constructor === Array) {
            data["GameDevsToDo"] = [];
            for (let item of this.gameDevsToDo)
                data["GameDevsToDo"].push(item);
        }
        super.toJS(data);
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DoAutoRebateRequest(JSON.parse(json));
    }
}

export class GetAutoRebateSettingRequest { 
    lobbyId: number; 
    startDate: Date; 
    endDate: Date; 
    language: LanguageCode;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
        }
    }

    static fromJS(data: any): GetAutoRebateSettingRequest {
        return new GetAutoRebateSettingRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetAutoRebateSettingRequest(JSON.parse(json));
    }
}

export class AutoRebateSetting { 
    gameDevName: string; 
    gameDevId: number; 
    id: string; 
    playerAmountRecordGameTypeId: number; 
    playerAmountRecordGameType: string; 
    rate: string; 
    boDiffHour: number; 
    timeType: string; 
    totalVaildBet: number; 
    totalRebate: number; 
    processedVaildBet: number; 
    processedRebate: number; 
    nextValidBetAmount: number; 
    nextRebateAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.gameDevName = data["GameDevName"] !== undefined ? data["GameDevName"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.playerAmountRecordGameTypeId = data["PlayerAmountRecordGameTypeId"] !== undefined ? data["PlayerAmountRecordGameTypeId"] : null;
            this.playerAmountRecordGameType = data["PlayerAmountRecordGameType"] !== undefined ? data["PlayerAmountRecordGameType"] : null;
            this.rate = data["Rate"] !== undefined ? data["Rate"] : null;
            this.boDiffHour = data["BoDiffHour"] !== undefined ? data["BoDiffHour"] : null;
            this.timeType = data["TimeType"] !== undefined ? data["TimeType"] : null;
            this.totalVaildBet = data["TotalVaildBet"] !== undefined ? data["TotalVaildBet"] : null;
            this.totalRebate = data["TotalRebate"] !== undefined ? data["TotalRebate"] : null;
            this.processedVaildBet = data["ProcessedVaildBet"] !== undefined ? data["ProcessedVaildBet"] : null;
            this.processedRebate = data["ProcessedRebate"] !== undefined ? data["ProcessedRebate"] : null;
            this.nextValidBetAmount = data["NextValidBetAmount"] !== undefined ? data["NextValidBetAmount"] : null;
            this.nextRebateAmount = data["NextRebateAmount"] !== undefined ? data["NextRebateAmount"] : null;
        }
    }

    static fromJS(data: any): AutoRebateSetting {
        return new AutoRebateSetting(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["GameDevName"] = this.gameDevName !== undefined ? this.gameDevName : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["PlayerAmountRecordGameTypeId"] = this.playerAmountRecordGameTypeId !== undefined ? this.playerAmountRecordGameTypeId : null;
        data["PlayerAmountRecordGameType"] = this.playerAmountRecordGameType !== undefined ? this.playerAmountRecordGameType : null;
        data["Rate"] = this.rate !== undefined ? this.rate : null;
        data["BoDiffHour"] = this.boDiffHour !== undefined ? this.boDiffHour : null;
        data["TimeType"] = this.timeType !== undefined ? this.timeType : null;
        data["TotalVaildBet"] = this.totalVaildBet !== undefined ? this.totalVaildBet : null;
        data["TotalRebate"] = this.totalRebate !== undefined ? this.totalRebate : null;
        data["ProcessedVaildBet"] = this.processedVaildBet !== undefined ? this.processedVaildBet : null;
        data["ProcessedRebate"] = this.processedRebate !== undefined ? this.processedRebate : null;
        data["NextValidBetAmount"] = this.nextValidBetAmount !== undefined ? this.nextValidBetAmount : null;
        data["NextRebateAmount"] = this.nextRebateAmount !== undefined ? this.nextRebateAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new AutoRebateSetting(JSON.parse(json));
    }
}

export class DisableRebateSetting { 
    players: Player[]; 
    inprgressNotRebatePromotionPlayers: Player[]; 
    eGames: EGame[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["Players"] && data["Players"].constructor === Array) {
                this.players = [];
                for (let item of data["Players"])
                    this.players.push(Player.fromJS(item));
            }
            if (data["InprgressNotRebatePromotionPlayers"] && data["InprgressNotRebatePromotionPlayers"].constructor === Array) {
                this.inprgressNotRebatePromotionPlayers = [];
                for (let item of data["InprgressNotRebatePromotionPlayers"])
                    this.inprgressNotRebatePromotionPlayers.push(Player.fromJS(item));
            }
            if (data["EGames"] && data["EGames"].constructor === Array) {
                this.eGames = [];
                for (let item of data["EGames"])
                    this.eGames.push(EGame.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DisableRebateSetting {
        return new DisableRebateSetting(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.players && this.players.constructor === Array) {
            data["Players"] = [];
            for (let item of this.players)
                data["Players"].push(item.toJS());
        }
        if (this.inprgressNotRebatePromotionPlayers && this.inprgressNotRebatePromotionPlayers.constructor === Array) {
            data["InprgressNotRebatePromotionPlayers"] = [];
            for (let item of this.inprgressNotRebatePromotionPlayers)
                data["InprgressNotRebatePromotionPlayers"].push(item.toJS());
        }
        if (this.eGames && this.eGames.constructor === Array) {
            data["EGames"] = [];
            for (let item of this.eGames)
                data["EGames"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DisableRebateSetting(JSON.parse(json));
    }
}

export class Player { 
    id: number; 
    name: string; 
    realName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.realName = data["RealName"] !== undefined ? data["RealName"] : null;
        }
    }

    static fromJS(data: any): Player {
        return new Player(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["RealName"] = this.realName !== undefined ? this.realName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new Player(JSON.parse(json));
    }
}

export class EGame { 
    id: number; 
    gameDevEGameId: number; 
    name: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.gameDevEGameId = data["GameDevEGameId"] !== undefined ? data["GameDevEGameId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
        }
    }

    static fromJS(data: any): EGame {
        return new EGame(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["GameDevEGameId"] = this.gameDevEGameId !== undefined ? this.gameDevEGameId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new EGame(JSON.parse(json));
    }
}

export class OnlinePaymentRequest { 
    lobbyId: number; 
    languageId: LanguageCode; 
    startDate: Date; 
    endDate: Date; 
    paymentGatewayPlatformId: PaymentGatewayPlatformId; 
    transactionTypeId: NewTransactionTypeId;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.paymentGatewayPlatformId = data["PaymentGatewayPlatformId"] !== undefined ? data["PaymentGatewayPlatformId"] : null;
            this.transactionTypeId = data["TransactionTypeId"] !== undefined ? data["TransactionTypeId"] : null;
        }
    }

    static fromJS(data: any): OnlinePaymentRequest {
        return new OnlinePaymentRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["PaymentGatewayPlatformId"] = this.paymentGatewayPlatformId !== undefined ? this.paymentGatewayPlatformId : null;
        data["TransactionTypeId"] = this.transactionTypeId !== undefined ? this.transactionTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new OnlinePaymentRequest(JSON.parse(json));
    }
}

export class OnlinePaymentGateway { 
    paymentGatewayPlatformId: PaymentGatewayPlatformId; 
    transactionTypeId: NewTransactionTypeId; 
    name: string; 
    noOfTransactions: number; 
    totalAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.paymentGatewayPlatformId = data["PaymentGatewayPlatformId"] !== undefined ? data["PaymentGatewayPlatformId"] : null;
            this.transactionTypeId = data["TransactionTypeId"] !== undefined ? data["TransactionTypeId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.noOfTransactions = data["NoOfTransactions"] !== undefined ? data["NoOfTransactions"] : null;
            this.totalAmount = data["TotalAmount"] !== undefined ? data["TotalAmount"] : null;
        }
    }

    static fromJS(data: any): OnlinePaymentGateway {
        return new OnlinePaymentGateway(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PaymentGatewayPlatformId"] = this.paymentGatewayPlatformId !== undefined ? this.paymentGatewayPlatformId : null;
        data["TransactionTypeId"] = this.transactionTypeId !== undefined ? this.transactionTypeId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["NoOfTransactions"] = this.noOfTransactions !== undefined ? this.noOfTransactions : null;
        data["TotalAmount"] = this.totalAmount !== undefined ? this.totalAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new OnlinePaymentGateway(JSON.parse(json));
    }
}

export class ReportDepositByUserAndDateVm { 
    createDate: Date; 
    playerId: number; 
    playerName: string; 
    noOfTransactions: number; 
    amount: number; 
    totalAmount: number; 
    depositMethodName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.noOfTransactions = data["NoOfTransactions"] !== undefined ? data["NoOfTransactions"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.totalAmount = data["TotalAmount"] !== undefined ? data["TotalAmount"] : null;
            this.depositMethodName = data["DepositMethodName"] !== undefined ? data["DepositMethodName"] : null;
        }
    }

    static fromJS(data: any): ReportDepositByUserAndDateVm {
        return new ReportDepositByUserAndDateVm(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["NoOfTransactions"] = this.noOfTransactions !== undefined ? this.noOfTransactions : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["TotalAmount"] = this.totalAmount !== undefined ? this.totalAmount : null;
        data["DepositMethodName"] = this.depositMethodName !== undefined ? this.depositMethodName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ReportDepositByUserAndDateVm(JSON.parse(json));
    }
}

export class ReportDepositDetailVm { 
    createDate: Date; 
    playerId: number; 
    playerName: string; 
    amount: number; 
    depositMethodName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.depositMethodName = data["DepositMethodName"] !== undefined ? data["DepositMethodName"] : null;
        }
    }

    static fromJS(data: any): ReportDepositDetailVm {
        return new ReportDepositDetailVm(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["DepositMethodName"] = this.depositMethodName !== undefined ? this.depositMethodName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ReportDepositDetailVm(JSON.parse(json));
    }
}

export class ReportRebateRequest { 
    lobbyId: number; 
    languageId: LanguageCode; 
    startDate: Date; 
    endDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["lobbyId"] !== undefined ? data["lobbyId"] : null;
            this.languageId = data["languageId"] !== undefined ? data["languageId"] : null;
            this.startDate = data["startDate"] ? new Date(data["startDate"].toString()) : null;
            this.endDate = data["endDate"] ? new Date(data["endDate"].toString()) : null;
        }
    }

    static fromJS(data: any): ReportRebateRequest {
        return new ReportRebateRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["lobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["languageId"] = this.languageId !== undefined ? this.languageId : null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ReportRebateRequest(JSON.parse(json));
    }
}

export class ReportRebateResposne { 
    rebateDate: Date; 
    rebateDateString: string; 
    noOfRebates: number; 
    totalValidBetAmount: number; 
    totalRebateAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.rebateDate = data["RebateDate"] ? new Date(data["RebateDate"].toString()) : null;
            this.rebateDateString = data["RebateDateString"] !== undefined ? data["RebateDateString"] : null;
            this.noOfRebates = data["NoOfRebates"] !== undefined ? data["NoOfRebates"] : null;
            this.totalValidBetAmount = data["TotalValidBetAmount"] !== undefined ? data["TotalValidBetAmount"] : null;
            this.totalRebateAmount = data["TotalRebateAmount"] !== undefined ? data["TotalRebateAmount"] : null;
        }
    }

    static fromJS(data: any): ReportRebateResposne {
        return new ReportRebateResposne(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["RebateDate"] = this.rebateDate ? this.rebateDate.toISOString() : null;
        data["RebateDateString"] = this.rebateDateString !== undefined ? this.rebateDateString : null;
        data["NoOfRebates"] = this.noOfRebates !== undefined ? this.noOfRebates : null;
        data["TotalValidBetAmount"] = this.totalValidBetAmount !== undefined ? this.totalValidBetAmount : null;
        data["TotalRebateAmount"] = this.totalRebateAmount !== undefined ? this.totalRebateAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ReportRebateResposne(JSON.parse(json));
    }
}

export class ReportRebateDetailResposne { 
    rebateDate: Date; 
    playerName: string; 
    gamePlatformName: string; 
    gameTypeName: string; 
    validBetAmount: number; 
    rebateAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.rebateDate = data["RebateDate"] ? new Date(data["RebateDate"].toString()) : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.gamePlatformName = data["GamePlatformName"] !== undefined ? data["GamePlatformName"] : null;
            this.gameTypeName = data["GameTypeName"] !== undefined ? data["GameTypeName"] : null;
            this.validBetAmount = data["ValidBetAmount"] !== undefined ? data["ValidBetAmount"] : null;
            this.rebateAmount = data["RebateAmount"] !== undefined ? data["RebateAmount"] : null;
        }
    }

    static fromJS(data: any): ReportRebateDetailResposne {
        return new ReportRebateDetailResposne(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["RebateDate"] = this.rebateDate ? this.rebateDate.toISOString() : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["GamePlatformName"] = this.gamePlatformName !== undefined ? this.gamePlatformName : null;
        data["GameTypeName"] = this.gameTypeName !== undefined ? this.gameTypeName : null;
        data["ValidBetAmount"] = this.validBetAmount !== undefined ? this.validBetAmount : null;
        data["RebateAmount"] = this.rebateAmount !== undefined ? this.rebateAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ReportRebateDetailResposne(JSON.parse(json));
    }
}

export class RegistrationLoginRequest { 
    lobbyId: number; 
    startDate: Date; 
    endDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
        }
    }

    static fromJS(data: any): RegistrationLoginRequest {
        return new RegistrationLoginRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new RegistrationLoginRequest(JSON.parse(json));
    }
}

export class RegistrationLoginResponse { 
    recordsByMonth: GroupedRecord[]; 
    recordsByDay: GroupedRecord[]; 
    recordsByHour: GroupedRecord[]; 
    recordsByIp: GroupedRecord[]; 
    recordsByDayDetail: GroupedRecord[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["RecordsByMonth"] && data["RecordsByMonth"].constructor === Array) {
                this.recordsByMonth = [];
                for (let item of data["RecordsByMonth"])
                    this.recordsByMonth.push(GroupedRecord.fromJS(item));
            }
            if (data["RecordsByDay"] && data["RecordsByDay"].constructor === Array) {
                this.recordsByDay = [];
                for (let item of data["RecordsByDay"])
                    this.recordsByDay.push(GroupedRecord.fromJS(item));
            }
            if (data["RecordsByHour"] && data["RecordsByHour"].constructor === Array) {
                this.recordsByHour = [];
                for (let item of data["RecordsByHour"])
                    this.recordsByHour.push(GroupedRecord.fromJS(item));
            }
            if (data["RecordsByIp"] && data["RecordsByIp"].constructor === Array) {
                this.recordsByIp = [];
                for (let item of data["RecordsByIp"])
                    this.recordsByIp.push(GroupedRecord.fromJS(item));
            }
            if (data["RecordsByDayDetail"] && data["RecordsByDayDetail"].constructor === Array) {
                this.recordsByDayDetail = [];
                for (let item of data["RecordsByDayDetail"])
                    this.recordsByDayDetail.push(GroupedRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegistrationLoginResponse {
        return new RegistrationLoginResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.recordsByMonth && this.recordsByMonth.constructor === Array) {
            data["RecordsByMonth"] = [];
            for (let item of this.recordsByMonth)
                data["RecordsByMonth"].push(item.toJS());
        }
        if (this.recordsByDay && this.recordsByDay.constructor === Array) {
            data["RecordsByDay"] = [];
            for (let item of this.recordsByDay)
                data["RecordsByDay"].push(item.toJS());
        }
        if (this.recordsByHour && this.recordsByHour.constructor === Array) {
            data["RecordsByHour"] = [];
            for (let item of this.recordsByHour)
                data["RecordsByHour"].push(item.toJS());
        }
        if (this.recordsByIp && this.recordsByIp.constructor === Array) {
            data["RecordsByIp"] = [];
            for (let item of this.recordsByIp)
                data["RecordsByIp"].push(item.toJS());
        }
        if (this.recordsByDayDetail && this.recordsByDayDetail.constructor === Array) {
            data["RecordsByDayDetail"] = [];
            for (let item of this.recordsByDayDetail)
                data["RecordsByDayDetail"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new RegistrationLoginResponse(JSON.parse(json));
    }
}

export class GroupedRecord { 
    groupBy: string; 
    totalNumberOfRegister: number; 
    numberOfRegister_mobile: number; 
    totalNumberOfUserLogin: number; 
    numberOfUserLogin_mobile: number; 
    totalNumberOfLogin: number; 
    numberOfLogin_mobile: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.groupBy = data["GroupBy"] !== undefined ? data["GroupBy"] : null;
            this.totalNumberOfRegister = data["TotalNumberOfRegister"] !== undefined ? data["TotalNumberOfRegister"] : null;
            this.numberOfRegister_mobile = data["NumberOfRegister_mobile"] !== undefined ? data["NumberOfRegister_mobile"] : null;
            this.totalNumberOfUserLogin = data["TotalNumberOfUserLogin"] !== undefined ? data["TotalNumberOfUserLogin"] : null;
            this.numberOfUserLogin_mobile = data["NumberOfUserLogin_mobile"] !== undefined ? data["NumberOfUserLogin_mobile"] : null;
            this.totalNumberOfLogin = data["TotalNumberOfLogin"] !== undefined ? data["TotalNumberOfLogin"] : null;
            this.numberOfLogin_mobile = data["NumberOfLogin_mobile"] !== undefined ? data["NumberOfLogin_mobile"] : null;
        }
    }

    static fromJS(data: any): GroupedRecord {
        return new GroupedRecord(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["GroupBy"] = this.groupBy !== undefined ? this.groupBy : null;
        data["TotalNumberOfRegister"] = this.totalNumberOfRegister !== undefined ? this.totalNumberOfRegister : null;
        data["NumberOfRegister_mobile"] = this.numberOfRegister_mobile !== undefined ? this.numberOfRegister_mobile : null;
        data["TotalNumberOfUserLogin"] = this.totalNumberOfUserLogin !== undefined ? this.totalNumberOfUserLogin : null;
        data["NumberOfUserLogin_mobile"] = this.numberOfUserLogin_mobile !== undefined ? this.numberOfUserLogin_mobile : null;
        data["TotalNumberOfLogin"] = this.totalNumberOfLogin !== undefined ? this.totalNumberOfLogin : null;
        data["NumberOfLogin_mobile"] = this.numberOfLogin_mobile !== undefined ? this.numberOfLogin_mobile : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GroupedRecord(JSON.parse(json));
    }
}

export class RegistrationLoginResponseNew { 
    registerCounts: GroupedRecord2; 
    userLoginCounts: GroupedRecord2; 
    loginTimesCounts: GroupedRecord2;

    constructor(data?: any) {
        if (data !== undefined) {
            this.registerCounts = data["RegisterCounts"] ? GroupedRecord2.fromJS(data["RegisterCounts"]) : null;
            this.userLoginCounts = data["UserLoginCounts"] ? GroupedRecord2.fromJS(data["UserLoginCounts"]) : null;
            this.loginTimesCounts = data["LoginTimesCounts"] ? GroupedRecord2.fromJS(data["LoginTimesCounts"]) : null;
        }
    }

    static fromJS(data: any): RegistrationLoginResponseNew {
        return new RegistrationLoginResponseNew(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["RegisterCounts"] = this.registerCounts ? this.registerCounts.toJS() : null;
        data["UserLoginCounts"] = this.userLoginCounts ? this.userLoginCounts.toJS() : null;
        data["LoginTimesCounts"] = this.loginTimesCounts ? this.loginTimesCounts.toJS() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new RegistrationLoginResponseNew(JSON.parse(json));
    }
}

export class GroupedRecord2 { 
    recordsByMonth: Record[]; 
    recordsByDay: Record[]; 
    recordsByHour: Record[]; 
    recordsByIp: Record[]; 
    recordsByDayDetail: Record[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["RecordsByMonth"] && data["RecordsByMonth"].constructor === Array) {
                this.recordsByMonth = [];
                for (let item of data["RecordsByMonth"])
                    this.recordsByMonth.push(Record.fromJS(item));
            }
            if (data["RecordsByDay"] && data["RecordsByDay"].constructor === Array) {
                this.recordsByDay = [];
                for (let item of data["RecordsByDay"])
                    this.recordsByDay.push(Record.fromJS(item));
            }
            if (data["RecordsByHour"] && data["RecordsByHour"].constructor === Array) {
                this.recordsByHour = [];
                for (let item of data["RecordsByHour"])
                    this.recordsByHour.push(Record.fromJS(item));
            }
            if (data["RecordsByIp"] && data["RecordsByIp"].constructor === Array) {
                this.recordsByIp = [];
                for (let item of data["RecordsByIp"])
                    this.recordsByIp.push(Record.fromJS(item));
            }
            if (data["RecordsByDayDetail"] && data["RecordsByDayDetail"].constructor === Array) {
                this.recordsByDayDetail = [];
                for (let item of data["RecordsByDayDetail"])
                    this.recordsByDayDetail.push(Record.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupedRecord2 {
        return new GroupedRecord2(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.recordsByMonth && this.recordsByMonth.constructor === Array) {
            data["RecordsByMonth"] = [];
            for (let item of this.recordsByMonth)
                data["RecordsByMonth"].push(item.toJS());
        }
        if (this.recordsByDay && this.recordsByDay.constructor === Array) {
            data["RecordsByDay"] = [];
            for (let item of this.recordsByDay)
                data["RecordsByDay"].push(item.toJS());
        }
        if (this.recordsByHour && this.recordsByHour.constructor === Array) {
            data["RecordsByHour"] = [];
            for (let item of this.recordsByHour)
                data["RecordsByHour"].push(item.toJS());
        }
        if (this.recordsByIp && this.recordsByIp.constructor === Array) {
            data["RecordsByIp"] = [];
            for (let item of this.recordsByIp)
                data["RecordsByIp"].push(item.toJS());
        }
        if (this.recordsByDayDetail && this.recordsByDayDetail.constructor === Array) {
            data["RecordsByDayDetail"] = [];
            for (let item of this.recordsByDayDetail)
                data["RecordsByDayDetail"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GroupedRecord2(JSON.parse(json));
    }
}

export class Record { 
    groupBy: string; 
    deviceTypeCounts: DeviceTypeCount[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.groupBy = data["GroupBy"] !== undefined ? data["GroupBy"] : null;
            if (data["DeviceTypeCounts"] && data["DeviceTypeCounts"].constructor === Array) {
                this.deviceTypeCounts = [];
                for (let item of data["DeviceTypeCounts"])
                    this.deviceTypeCounts.push(DeviceTypeCount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Record {
        return new Record(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["GroupBy"] = this.groupBy !== undefined ? this.groupBy : null;
        if (this.deviceTypeCounts && this.deviceTypeCounts.constructor === Array) {
            data["DeviceTypeCounts"] = [];
            for (let item of this.deviceTypeCounts)
                data["DeviceTypeCounts"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new Record(JSON.parse(json));
    }
}

export class DeviceTypeCount { 
    userDeviceTypeId: UserDeviceTypeId; 
    count: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.userDeviceTypeId = data["UserDeviceTypeId"] !== undefined ? data["UserDeviceTypeId"] : null;
            this.count = data["Count"] !== undefined ? data["Count"] : null;
        }
    }

    static fromJS(data: any): DeviceTypeCount {
        return new DeviceTypeCount(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["UserDeviceTypeId"] = this.userDeviceTypeId !== undefined ? this.userDeviceTypeId : null;
        data["Count"] = this.count !== undefined ? this.count : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DeviceTypeCount(JSON.parse(json));
    }
}

export class RegistrationLoginDetailRequest { 
    lobbyId: number; 
    searchBy: SearchBy; 
    startDate: Date; 
    endDate: Date; 
    groupBy: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.searchBy = data["SearchBy"] !== undefined ? data["SearchBy"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.groupBy = data["GroupBy"] !== undefined ? data["GroupBy"] : null;
        }
    }

    static fromJS(data: any): RegistrationLoginDetailRequest {
        return new RegistrationLoginDetailRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["SearchBy"] = this.searchBy !== undefined ? this.searchBy : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["GroupBy"] = this.groupBy !== undefined ? this.groupBy : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new RegistrationLoginDetailRequest(JSON.parse(json));
    }
}

export enum SearchBy {
    Month = 0, 
    Day = 1, 
    Hour = 2, 
    Ip = 3, 
    DayDetail = 4, 
}

export class RegistrationLoginDetailResponse { 
    playerName: string; 
    date: Date; 
    deviceTypeId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.date = data["Date"] ? new Date(data["Date"].toString()) : null;
            this.deviceTypeId = data["DeviceTypeId"] !== undefined ? data["DeviceTypeId"] : null;
        }
    }

    static fromJS(data: any): RegistrationLoginDetailResponse {
        return new RegistrationLoginDetailResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["Date"] = this.date ? this.date.toISOString() : null;
        data["DeviceTypeId"] = this.deviceTypeId !== undefined ? this.deviceTypeId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new RegistrationLoginDetailResponse(JSON.parse(json));
    }
}

export class LobbySmsMessageTemplateGetForIndexResponse { 
    id: number; 
    name: string; 
    message: string; 
    updateDate: Date; 
    updateBy: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.message = data["Message"] !== undefined ? data["Message"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
        }
    }

    static fromJS(data: any): LobbySmsMessageTemplateGetForIndexResponse {
        return new LobbySmsMessageTemplateGetForIndexResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["Message"] = this.message !== undefined ? this.message : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbySmsMessageTemplateGetForIndexResponse(JSON.parse(json));
    }
}

export class LobbySmsMessageTemplateGetForAddResponse { 
    languageId: number; 
    languageName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.languageName = data["LanguageName"] !== undefined ? data["LanguageName"] : null;
        }
    }

    static fromJS(data: any): LobbySmsMessageTemplateGetForAddResponse {
        return new LobbySmsMessageTemplateGetForAddResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["LanguageName"] = this.languageName !== undefined ? this.languageName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbySmsMessageTemplateGetForAddResponse(JSON.parse(json));
    }
}

export class LobbySmsMessageTemplateGetForEditResponse { 
    languageId: number; 
    languageName: string; 
    name: string; 
    message: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.languageName = data["LanguageName"] !== undefined ? data["LanguageName"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.message = data["Message"] !== undefined ? data["Message"] : null;
        }
    }

    static fromJS(data: any): LobbySmsMessageTemplateGetForEditResponse {
        return new LobbySmsMessageTemplateGetForEditResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["LanguageName"] = this.languageName !== undefined ? this.languageName : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["Message"] = this.message !== undefined ? this.message : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbySmsMessageTemplateGetForEditResponse(JSON.parse(json));
    }
}

export class LobbySmsMessageTemplateCreateRequest { 
    smsMessageTemplateLanguage: LobbySmsMessgeTemplateLanguageCreateEditDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["smsMessageTemplateLanguage"] && data["smsMessageTemplateLanguage"].constructor === Array) {
                this.smsMessageTemplateLanguage = [];
                for (let item of data["smsMessageTemplateLanguage"])
                    this.smsMessageTemplateLanguage.push(LobbySmsMessgeTemplateLanguageCreateEditDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbySmsMessageTemplateCreateRequest {
        return new LobbySmsMessageTemplateCreateRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.smsMessageTemplateLanguage && this.smsMessageTemplateLanguage.constructor === Array) {
            data["smsMessageTemplateLanguage"] = [];
            for (let item of this.smsMessageTemplateLanguage)
                data["smsMessageTemplateLanguage"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbySmsMessageTemplateCreateRequest(JSON.parse(json));
    }
}

export class LobbySmsMessgeTemplateLanguageCreateEditDao { 
    languageId: number; 
    name: string; 
    message: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.message = data["Message"] !== undefined ? data["Message"] : null;
        }
    }

    static fromJS(data: any): LobbySmsMessgeTemplateLanguageCreateEditDao {
        return new LobbySmsMessgeTemplateLanguageCreateEditDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["Message"] = this.message !== undefined ? this.message : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbySmsMessgeTemplateLanguageCreateEditDao(JSON.parse(json));
    }
}

export class LobbySmsMessageTemplateEditRequest { 
    lobbySmsMessgeTemplateId: number; 
    smsMessageTemplateLanguage: LobbySmsMessgeTemplateLanguageCreateEditDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbySmsMessgeTemplateId = data["LobbySmsMessgeTemplateId"] !== undefined ? data["LobbySmsMessgeTemplateId"] : null;
            if (data["smsMessageTemplateLanguage"] && data["smsMessageTemplateLanguage"].constructor === Array) {
                this.smsMessageTemplateLanguage = [];
                for (let item of data["smsMessageTemplateLanguage"])
                    this.smsMessageTemplateLanguage.push(LobbySmsMessgeTemplateLanguageCreateEditDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LobbySmsMessageTemplateEditRequest {
        return new LobbySmsMessageTemplateEditRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbySmsMessgeTemplateId"] = this.lobbySmsMessgeTemplateId !== undefined ? this.lobbySmsMessgeTemplateId : null;
        if (this.smsMessageTemplateLanguage && this.smsMessageTemplateLanguage.constructor === Array) {
            data["smsMessageTemplateLanguage"] = [];
            for (let item of this.smsMessageTemplateLanguage)
                data["smsMessageTemplateLanguage"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbySmsMessageTemplateEditRequest(JSON.parse(json));
    }
}

export class LobbySmsMessageTemplateGetRequest { 
    smsMessgeTemplateId: number; 
    languageId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.smsMessgeTemplateId = data["SmsMessgeTemplateId"] !== undefined ? data["SmsMessgeTemplateId"] : null;
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
        }
    }

    static fromJS(data: any): LobbySmsMessageTemplateGetRequest {
        return new LobbySmsMessageTemplateGetRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["SmsMessgeTemplateId"] = this.smsMessgeTemplateId !== undefined ? this.smsMessgeTemplateId : null;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbySmsMessageTemplateGetRequest(JSON.parse(json));
    }
}

export class LobbySmsMessageTemplateGetResponse { 
    lobbySmsMessgeTemplateId: number; 
    lobbyId: number; 
    isDelete: boolean; 
    message: string; 
    name: string; 
    createDate: Date; 
    createBy: string; 
    updateDate: Date; 
    updateBy: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbySmsMessgeTemplateId = data["LobbySmsMessgeTemplateId"] !== undefined ? data["LobbySmsMessgeTemplateId"] : null;
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.isDelete = data["IsDelete"] !== undefined ? data["IsDelete"] : null;
            this.message = data["Message"] !== undefined ? data["Message"] : null;
            this.name = data["Name"] !== undefined ? data["Name"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.createBy = data["CreateBy"] !== undefined ? data["CreateBy"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
        }
    }

    static fromJS(data: any): LobbySmsMessageTemplateGetResponse {
        return new LobbySmsMessageTemplateGetResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbySmsMessgeTemplateId"] = this.lobbySmsMessgeTemplateId !== undefined ? this.lobbySmsMessgeTemplateId : null;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["IsDelete"] = this.isDelete !== undefined ? this.isDelete : null;
        data["Message"] = this.message !== undefined ? this.message : null;
        data["Name"] = this.name !== undefined ? this.name : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["CreateBy"] = this.createBy !== undefined ? this.createBy : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new LobbySmsMessageTemplateGetResponse(JSON.parse(json));
    }
}

export class GetAdminCreatePlayerRecordRequest { 
    userName: string; 
    startTime: Date; 
    endTime: Date; 
    isSuccess: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
            this.startTime = data["StartTime"] ? new Date(data["StartTime"].toString()) : null;
            this.endTime = data["EndTime"] ? new Date(data["EndTime"].toString()) : null;
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
        }
    }

    static fromJS(data: any): GetAdminCreatePlayerRecordRequest {
        return new GetAdminCreatePlayerRecordRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        data["StartTime"] = this.startTime ? this.startTime.toISOString() : null;
        data["EndTime"] = this.endTime ? this.endTime.toISOString() : null;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetAdminCreatePlayerRecordRequest(JSON.parse(json));
    }
}

export class StandardResponseOfListOfGetAdminCreatePlayerRecordResponse { 
    isSuccess: boolean; 
    payload: GetAdminCreatePlayerRecordResponse[]; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            if (data["payload"] && data["payload"].constructor === Array) {
                this.payload = [];
                for (let item of data["payload"])
                    this.payload.push(GetAdminCreatePlayerRecordResponse.fromJS(item));
            }
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfListOfGetAdminCreatePlayerRecordResponse {
        return new StandardResponseOfListOfGetAdminCreatePlayerRecordResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.payload && this.payload.constructor === Array) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item.toJS());
        }
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfListOfGetAdminCreatePlayerRecordResponse(JSON.parse(json));
    }
}

export class GetAdminCreatePlayerRecordResponse { 
    playerName: string; 
    createdByAdminName: string; 
    createdDate: Date; 
    remark: string; 
    phoneNumber: string; 
    errorMessage: string; 
    isSuccess: boolean;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.createdByAdminName = data["CreatedByAdminName"] !== undefined ? data["CreatedByAdminName"] : null;
            this.createdDate = data["CreatedDate"] ? new Date(data["CreatedDate"].toString()) : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.errorMessage = data["ErrorMessage"] !== undefined ? data["ErrorMessage"] : null;
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
        }
    }

    static fromJS(data: any): GetAdminCreatePlayerRecordResponse {
        return new GetAdminCreatePlayerRecordResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["CreatedByAdminName"] = this.createdByAdminName !== undefined ? this.createdByAdminName : null;
        data["CreatedDate"] = this.createdDate ? this.createdDate.toISOString() : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["ErrorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetAdminCreatePlayerRecordResponse(JSON.parse(json));
    }
}

export class Telemarketing_GetOwnedPlayerRequest { 
    userName: string; 
    userPersonalName: string; 
    phoneNumber: string; 
    numberOfExcludedDays: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
            this.userPersonalName = data["UserPersonalName"] !== undefined ? data["UserPersonalName"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.numberOfExcludedDays = data["NumberOfExcludedDays"] !== undefined ? data["NumberOfExcludedDays"] : null;
        }
    }

    static fromJS(data: any): Telemarketing_GetOwnedPlayerRequest {
        return new Telemarketing_GetOwnedPlayerRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        data["UserPersonalName"] = this.userPersonalName !== undefined ? this.userPersonalName : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["NumberOfExcludedDays"] = this.numberOfExcludedDays !== undefined ? this.numberOfExcludedDays : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new Telemarketing_GetOwnedPlayerRequest(JSON.parse(json));
    }
}

export class StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse { 
    isSuccess: boolean; 
    payload: GetTeleMarketingPlayerResponse[]; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            if (data["payload"] && data["payload"].constructor === Array) {
                this.payload = [];
                for (let item of data["payload"])
                    this.payload.push(GetTeleMarketingPlayerResponse.fromJS(item));
            }
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse {
        return new StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.payload && this.payload.constructor === Array) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item.toJS());
        }
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfIEnumerableOfGetTeleMarketingPlayerResponse(JSON.parse(json));
    }
}

export class GetTeleMarketingPlayerResponse { 
    id: number; 
    userId: number; 
    userName: string; 
    userPersonalName: string; 
    adminName: string; 
    numberOfLatestDepositDayFromNow: number; 
    latestDepositDate: Date; 
    latestSendSmsDate: Date; 
    latestSendSmsContent: string; 
    latestSendSmsBy: string; 
    latestPhoneCallDate: Date; 
    updateBy: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.userId = data["UserId"] !== undefined ? data["UserId"] : null;
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
            this.userPersonalName = data["UserPersonalName"] !== undefined ? data["UserPersonalName"] : null;
            this.adminName = data["AdminName"] !== undefined ? data["AdminName"] : null;
            this.numberOfLatestDepositDayFromNow = data["NumberOfLatestDepositDayFromNow"] !== undefined ? data["NumberOfLatestDepositDayFromNow"] : null;
            this.latestDepositDate = data["LatestDepositDate"] ? new Date(data["LatestDepositDate"].toString()) : null;
            this.latestSendSmsDate = data["LatestSendSmsDate"] ? new Date(data["LatestSendSmsDate"].toString()) : null;
            this.latestSendSmsContent = data["LatestSendSmsContent"] !== undefined ? data["LatestSendSmsContent"] : null;
            this.latestSendSmsBy = data["LatestSendSmsBy"] !== undefined ? data["LatestSendSmsBy"] : null;
            this.latestPhoneCallDate = data["LatestPhoneCallDate"] ? new Date(data["LatestPhoneCallDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
        }
    }

    static fromJS(data: any): GetTeleMarketingPlayerResponse {
        return new GetTeleMarketingPlayerResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["UserId"] = this.userId !== undefined ? this.userId : null;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        data["UserPersonalName"] = this.userPersonalName !== undefined ? this.userPersonalName : null;
        data["AdminName"] = this.adminName !== undefined ? this.adminName : null;
        data["NumberOfLatestDepositDayFromNow"] = this.numberOfLatestDepositDayFromNow !== undefined ? this.numberOfLatestDepositDayFromNow : null;
        data["LatestDepositDate"] = this.latestDepositDate ? this.latestDepositDate.toISOString() : null;
        data["LatestSendSmsDate"] = this.latestSendSmsDate ? this.latestSendSmsDate.toISOString() : null;
        data["LatestSendSmsContent"] = this.latestSendSmsContent !== undefined ? this.latestSendSmsContent : null;
        data["LatestSendSmsBy"] = this.latestSendSmsBy !== undefined ? this.latestSendSmsBy : null;
        data["LatestPhoneCallDate"] = this.latestPhoneCallDate ? this.latestPhoneCallDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetTeleMarketingPlayerResponse(JSON.parse(json));
    }
}

export class Telemarketing_GetNotAssignedPlayerRequest { 
    userName: string; 
    userPersonalName: string; 
    phoneNumber: string; 
    numberOfExcludedDays: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
            this.userPersonalName = data["UserPersonalName"] !== undefined ? data["UserPersonalName"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.numberOfExcludedDays = data["NumberOfExcludedDays"] !== undefined ? data["NumberOfExcludedDays"] : null;
        }
    }

    static fromJS(data: any): Telemarketing_GetNotAssignedPlayerRequest {
        return new Telemarketing_GetNotAssignedPlayerRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        data["UserPersonalName"] = this.userPersonalName !== undefined ? this.userPersonalName : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["NumberOfExcludedDays"] = this.numberOfExcludedDays !== undefined ? this.numberOfExcludedDays : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new Telemarketing_GetNotAssignedPlayerRequest(JSON.parse(json));
    }
}

export class Telemarketing_GetAllAssignedPlayerRequest { 
    adminId: number; 
    userName: string; 
    userPersonalName: string; 
    phoneNumber: string; 
    numberOfExcludedDays: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.adminId = data["AdminId"] !== undefined ? data["AdminId"] : null;
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
            this.userPersonalName = data["UserPersonalName"] !== undefined ? data["UserPersonalName"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.numberOfExcludedDays = data["NumberOfExcludedDays"] !== undefined ? data["NumberOfExcludedDays"] : null;
        }
    }

    static fromJS(data: any): Telemarketing_GetAllAssignedPlayerRequest {
        return new Telemarketing_GetAllAssignedPlayerRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["AdminId"] = this.adminId !== undefined ? this.adminId : null;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        data["UserPersonalName"] = this.userPersonalName !== undefined ? this.userPersonalName : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["NumberOfExcludedDays"] = this.numberOfExcludedDays !== undefined ? this.numberOfExcludedDays : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new Telemarketing_GetAllAssignedPlayerRequest(JSON.parse(json));
    }
}

export class StandardResponseOfIEnumerableOfGetTelemarketAdminResponse { 
    isSuccess: boolean; 
    payload: GetTelemarketAdminResponse[]; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            if (data["payload"] && data["payload"].constructor === Array) {
                this.payload = [];
                for (let item of data["payload"])
                    this.payload.push(GetTelemarketAdminResponse.fromJS(item));
            }
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfIEnumerableOfGetTelemarketAdminResponse {
        return new StandardResponseOfIEnumerableOfGetTelemarketAdminResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        if (this.payload && this.payload.constructor === Array) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item.toJS());
        }
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfIEnumerableOfGetTelemarketAdminResponse(JSON.parse(json));
    }
}

export class GetTelemarketAdminResponse { 
    id: number; 
    userName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
        }
    }

    static fromJS(data: any): GetTelemarketAdminResponse {
        return new GetTelemarketAdminResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new GetTelemarketAdminResponse(JSON.parse(json));
    }
}

export class StandardResponseOfCreateTeleMarketingPlayerResponse { 
    isSuccess: boolean; 
    payload: CreateTeleMarketingPlayerResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? CreateTeleMarketingPlayerResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfCreateTeleMarketingPlayerResponse {
        return new StandardResponseOfCreateTeleMarketingPlayerResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfCreateTeleMarketingPlayerResponse(JSON.parse(json));
    }
}

export class CreateTeleMarketingPlayerResponse { 
    id: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
        }
    }

    static fromJS(data: any): CreateTeleMarketingPlayerResponse {
        return new CreateTeleMarketingPlayerResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new CreateTeleMarketingPlayerResponse(JSON.parse(json));
    }
}

export class Telemarketing_AssignRequest { 
    adminId: number; 
    playerId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.adminId = data["AdminId"] !== undefined ? data["AdminId"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
        }
    }

    static fromJS(data: any): Telemarketing_AssignRequest {
        return new Telemarketing_AssignRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["AdminId"] = this.adminId !== undefined ? this.adminId : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new Telemarketing_AssignRequest(JSON.parse(json));
    }
}

export class Telemarketing_ReassignRequest { 
    id: number; 
    adminId: number; 
    playerId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.adminId = data["AdminId"] !== undefined ? data["AdminId"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
        }
    }

    static fromJS(data: any): Telemarketing_ReassignRequest {
        return new Telemarketing_ReassignRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["AdminId"] = this.adminId !== undefined ? this.adminId : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new Telemarketing_ReassignRequest(JSON.parse(json));
    }
}

export class StandardResponseOfGetTeleMarketingPlayerResponse { 
    isSuccess: boolean; 
    payload: GetTeleMarketingPlayerResponse; 
    error: StandardResponseErrorOfErrorId; 
    errors: string[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["isSuccess"] !== undefined ? data["isSuccess"] : null;
            this.payload = data["payload"] ? GetTeleMarketingPlayerResponse.fromJS(data["payload"]) : null;
            this.error = data["error"] ? StandardResponseErrorOfErrorId.fromJS(data["error"]) : null;
            if (data["errors"] && data["errors"].constructor === Array) {
                this.errors = [];
                for (let item of data["errors"])
                    this.errors.push(item);
            }
        }
    }

    static fromJS(data: any): StandardResponseOfGetTeleMarketingPlayerResponse {
        return new StandardResponseOfGetTeleMarketingPlayerResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["isSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["payload"] = this.payload ? this.payload.toJS() : null;
        data["error"] = this.error ? this.error.toJS() : null;
        if (this.errors && this.errors.constructor === Array) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new StandardResponseOfGetTeleMarketingPlayerResponse(JSON.parse(json));
    }
}

export class SubscriptionMessageIndexResponse { 
    id: number; 
    title: string; 
    lobbyMessageNotificationTypeName: string; 
    plainTextContent: string; 
    htmlContent: string; 
    createDate: Date; 
    createby: string; 
    receivedUser: string; 
    lobbyPlayerLevelName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.title = data["Title"] !== undefined ? data["Title"] : null;
            this.lobbyMessageNotificationTypeName = data["LobbyMessageNotificationTypeName"] !== undefined ? data["LobbyMessageNotificationTypeName"] : null;
            this.plainTextContent = data["PlainTextContent"] !== undefined ? data["PlainTextContent"] : null;
            this.htmlContent = data["HtmlContent"] !== undefined ? data["HtmlContent"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.createby = data["Createby"] !== undefined ? data["Createby"] : null;
            this.receivedUser = data["ReceivedUser"] !== undefined ? data["ReceivedUser"] : null;
            this.lobbyPlayerLevelName = data["LobbyPlayerLevelName"] !== undefined ? data["LobbyPlayerLevelName"] : null;
        }
    }

    static fromJS(data: any): SubscriptionMessageIndexResponse {
        return new SubscriptionMessageIndexResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["Title"] = this.title !== undefined ? this.title : null;
        data["LobbyMessageNotificationTypeName"] = this.lobbyMessageNotificationTypeName !== undefined ? this.lobbyMessageNotificationTypeName : null;
        data["PlainTextContent"] = this.plainTextContent !== undefined ? this.plainTextContent : null;
        data["HtmlContent"] = this.htmlContent !== undefined ? this.htmlContent : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["Createby"] = this.createby !== undefined ? this.createby : null;
        data["ReceivedUser"] = this.receivedUser !== undefined ? this.receivedUser : null;
        data["LobbyPlayerLevelName"] = this.lobbyPlayerLevelName !== undefined ? this.lobbyPlayerLevelName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SubscriptionMessageIndexResponse(JSON.parse(json));
    }
}

export class SubscriptionMessageSendRequest { 
    lobbyId: number; 
    toUserIds: number[]; 
    toLobbyPlayerLevelIds: number[]; 
    lobbyMessageNotificationTypeId: number; 
    title: string; 
    htmlContent: string; 
    plainTextContent: string; 
    languageId: LanguageCode;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            if (data["ToUserIds"] && data["ToUserIds"].constructor === Array) {
                this.toUserIds = [];
                for (let item of data["ToUserIds"])
                    this.toUserIds.push(item);
            }
            if (data["ToLobbyPlayerLevelIds"] && data["ToLobbyPlayerLevelIds"].constructor === Array) {
                this.toLobbyPlayerLevelIds = [];
                for (let item of data["ToLobbyPlayerLevelIds"])
                    this.toLobbyPlayerLevelIds.push(item);
            }
            this.lobbyMessageNotificationTypeId = data["LobbyMessageNotificationTypeId"] !== undefined ? data["LobbyMessageNotificationTypeId"] : null;
            this.title = data["Title"] !== undefined ? data["Title"] : null;
            this.htmlContent = data["HtmlContent"] !== undefined ? data["HtmlContent"] : null;
            this.plainTextContent = data["PlainTextContent"] !== undefined ? data["PlainTextContent"] : null;
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
        }
    }

    static fromJS(data: any): SubscriptionMessageSendRequest {
        return new SubscriptionMessageSendRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        if (this.toUserIds && this.toUserIds.constructor === Array) {
            data["ToUserIds"] = [];
            for (let item of this.toUserIds)
                data["ToUserIds"].push(item);
        }
        if (this.toLobbyPlayerLevelIds && this.toLobbyPlayerLevelIds.constructor === Array) {
            data["ToLobbyPlayerLevelIds"] = [];
            for (let item of this.toLobbyPlayerLevelIds)
                data["ToLobbyPlayerLevelIds"].push(item);
        }
        data["LobbyMessageNotificationTypeId"] = this.lobbyMessageNotificationTypeId !== undefined ? this.lobbyMessageNotificationTypeId : null;
        data["Title"] = this.title !== undefined ? this.title : null;
        data["HtmlContent"] = this.htmlContent !== undefined ? this.htmlContent : null;
        data["PlainTextContent"] = this.plainTextContent !== undefined ? this.plainTextContent : null;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SubscriptionMessageSendRequest(JSON.parse(json));
    }
}

export class SubscriptionMessageGetForSendResponse { 
    playerLevelSelections: CmsSelectionOptionDao[]; 
    playerSelections: CmsSelectionOptionDao[]; 
    lobbyMessageNotificationTypeSections: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["PlayerLevelSelections"] && data["PlayerLevelSelections"].constructor === Array) {
                this.playerLevelSelections = [];
                for (let item of data["PlayerLevelSelections"])
                    this.playerLevelSelections.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["PlayerSelections"] && data["PlayerSelections"].constructor === Array) {
                this.playerSelections = [];
                for (let item of data["PlayerSelections"])
                    this.playerSelections.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["LobbyMessageNotificationTypeSections"] && data["LobbyMessageNotificationTypeSections"].constructor === Array) {
                this.lobbyMessageNotificationTypeSections = [];
                for (let item of data["LobbyMessageNotificationTypeSections"])
                    this.lobbyMessageNotificationTypeSections.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionMessageGetForSendResponse {
        return new SubscriptionMessageGetForSendResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.playerLevelSelections && this.playerLevelSelections.constructor === Array) {
            data["PlayerLevelSelections"] = [];
            for (let item of this.playerLevelSelections)
                data["PlayerLevelSelections"].push(item.toJS());
        }
        if (this.playerSelections && this.playerSelections.constructor === Array) {
            data["PlayerSelections"] = [];
            for (let item of this.playerSelections)
                data["PlayerSelections"].push(item.toJS());
        }
        if (this.lobbyMessageNotificationTypeSections && this.lobbyMessageNotificationTypeSections.constructor === Array) {
            data["LobbyMessageNotificationTypeSections"] = [];
            for (let item of this.lobbyMessageNotificationTypeSections)
                data["LobbyMessageNotificationTypeSections"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SubscriptionMessageGetForSendResponse(JSON.parse(json));
    }
}

export class TransferWalletGetBalanceReponse { 
    userName: string; 
    gameDevId: GameDevId; 
    balance: number; 
    isMaintaining: boolean; 
    gameDevUsername: string; 
    unsettleBetAmount: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
            this.gameDevId = data["GameDevId"] !== undefined ? data["GameDevId"] : null;
            this.balance = data["Balance"] !== undefined ? data["Balance"] : null;
            this.isMaintaining = data["IsMaintaining"] !== undefined ? data["IsMaintaining"] : null;
            this.gameDevUsername = data["GameDevUsername"] !== undefined ? data["GameDevUsername"] : null;
            this.unsettleBetAmount = data["UnsettleBetAmount"] !== undefined ? data["UnsettleBetAmount"] : null;
        }
    }

    static fromJS(data: any): TransferWalletGetBalanceReponse {
        return new TransferWalletGetBalanceReponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        data["GameDevId"] = this.gameDevId !== undefined ? this.gameDevId : null;
        data["Balance"] = this.balance !== undefined ? this.balance : null;
        data["IsMaintaining"] = this.isMaintaining !== undefined ? this.isMaintaining : null;
        data["GameDevUsername"] = this.gameDevUsername !== undefined ? this.gameDevUsername : null;
        data["UnsettleBetAmount"] = this.unsettleBetAmount !== undefined ? this.unsettleBetAmount : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new TransferWalletGetBalanceReponse(JSON.parse(json));
    }
}

export class PhoneCallLogResponse { 
    id: number; 
    adminName: string; 
    playerName: string; 
    createDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["id"] !== undefined ? data["id"] : null;
            this.adminName = data["AdminName"] !== undefined ? data["AdminName"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
        }
    }

    static fromJS(data: any): PhoneCallLogResponse {
        return new PhoneCallLogResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["id"] = this.id !== undefined ? this.id : null;
        data["AdminName"] = this.adminName !== undefined ? this.adminName : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PhoneCallLogResponse(JSON.parse(json));
    }
}

export class SendSmsToPlayerRequest { 
    lobbySmsMessgeTemplateId: number; 
    taskName: string; 
    message: string; 
    playerId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbySmsMessgeTemplateId = data["LobbySmsMessgeTemplateId"] !== undefined ? data["LobbySmsMessgeTemplateId"] : null;
            this.taskName = data["TaskName"] !== undefined ? data["TaskName"] : null;
            this.message = data["Message"] !== undefined ? data["Message"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
        }
    }

    static fromJS(data: any): SendSmsToPlayerRequest {
        return new SendSmsToPlayerRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbySmsMessgeTemplateId"] = this.lobbySmsMessgeTemplateId !== undefined ? this.lobbySmsMessgeTemplateId : null;
        data["TaskName"] = this.taskName !== undefined ? this.taskName : null;
        data["Message"] = this.message !== undefined ? this.message : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SendSmsToPlayerRequest(JSON.parse(json));
    }
}

export class SendSmsResponse { 
    isSuccess: boolean; 
    errorMessage: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            this.errorMessage = data["ErrorMessage"] !== undefined ? data["ErrorMessage"] : null;
        }
    }

    static fromJS(data: any): SendSmsResponse {
        return new SendSmsResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["ErrorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SendSmsResponse(JSON.parse(json));
    }
}

export class SendMutipleSmsResponse { 
    isSuccess: boolean; 
    errorMessage: string; 
    invalidPhoneNumbers: string[]; 
    addedMessage: SmsMessageGetForIndexResponse;

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            this.errorMessage = data["ErrorMessage"] !== undefined ? data["ErrorMessage"] : null;
            if (data["InvalidPhoneNumbers"] && data["InvalidPhoneNumbers"].constructor === Array) {
                this.invalidPhoneNumbers = [];
                for (let item of data["InvalidPhoneNumbers"])
                    this.invalidPhoneNumbers.push(item);
            }
            this.addedMessage = data["AddedMessage"] ? SmsMessageGetForIndexResponse.fromJS(data["AddedMessage"]) : null;
        }
    }

    static fromJS(data: any): SendMutipleSmsResponse {
        return new SendMutipleSmsResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["ErrorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null;
        if (this.invalidPhoneNumbers && this.invalidPhoneNumbers.constructor === Array) {
            data["InvalidPhoneNumbers"] = [];
            for (let item of this.invalidPhoneNumbers)
                data["InvalidPhoneNumbers"].push(item);
        }
        data["AddedMessage"] = this.addedMessage ? this.addedMessage.toJS() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SendMutipleSmsResponse(JSON.parse(json));
    }
}

export class SmsMessageGetForIndexResponse { 
    id: number; 
    createDate: Date; 
    taskName: string; 
    message: string; 
    totalMessageLog: number; 
    successMessageLog: number; 
    failMessageLog: number; 
    pendingMessageLog: number; 
    createBy: string; 
    updateBy: string; 
    updateDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.taskName = data["TaskName"] !== undefined ? data["TaskName"] : null;
            this.message = data["Message"] !== undefined ? data["Message"] : null;
            this.totalMessageLog = data["TotalMessageLog"] !== undefined ? data["TotalMessageLog"] : null;
            this.successMessageLog = data["SuccessMessageLog"] !== undefined ? data["SuccessMessageLog"] : null;
            this.failMessageLog = data["FailMessageLog"] !== undefined ? data["FailMessageLog"] : null;
            this.pendingMessageLog = data["PendingMessageLog"] !== undefined ? data["PendingMessageLog"] : null;
            this.createBy = data["CreateBy"] !== undefined ? data["CreateBy"] : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
        }
    }

    static fromJS(data: any): SmsMessageGetForIndexResponse {
        return new SmsMessageGetForIndexResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["TaskName"] = this.taskName !== undefined ? this.taskName : null;
        data["Message"] = this.message !== undefined ? this.message : null;
        data["TotalMessageLog"] = this.totalMessageLog !== undefined ? this.totalMessageLog : null;
        data["SuccessMessageLog"] = this.successMessageLog !== undefined ? this.successMessageLog : null;
        data["FailMessageLog"] = this.failMessageLog !== undefined ? this.failMessageLog : null;
        data["PendingMessageLog"] = this.pendingMessageLog !== undefined ? this.pendingMessageLog : null;
        data["CreateBy"] = this.createBy !== undefined ? this.createBy : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SmsMessageGetForIndexResponse(JSON.parse(json));
    }
}

export class ReSendSmsRequest { 
    smsMessageId: number; 
    phoneNumber: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.smsMessageId = data["SmsMessageId"] !== undefined ? data["SmsMessageId"] : null;
            this.phoneNumber = data["phoneNumber"] !== undefined ? data["phoneNumber"] : null;
        }
    }

    static fromJS(data: any): ReSendSmsRequest {
        return new ReSendSmsRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["SmsMessageId"] = this.smsMessageId !== undefined ? this.smsMessageId : null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ReSendSmsRequest(JSON.parse(json));
    }
}

export class ReSendSmsResponse { 
    isSuccess: boolean; 
    errorMessage: string; 
    messageSendLog: SmsMessageSendLog;

    constructor(data?: any) {
        if (data !== undefined) {
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            this.errorMessage = data["ErrorMessage"] !== undefined ? data["ErrorMessage"] : null;
            this.messageSendLog = data["MessageSendLog"] ? SmsMessageSendLog.fromJS(data["MessageSendLog"]) : null;
        }
    }

    static fromJS(data: any): ReSendSmsResponse {
        return new ReSendSmsResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["ErrorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null;
        data["MessageSendLog"] = this.messageSendLog ? this.messageSendLog.toJS() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new ReSendSmsResponse(JSON.parse(json));
    }
}

export class SmsMessageSendLog { 
    smsMessageId: number; 
    phoneNumber: string; 
    phoneNumberWithPrefix: string; 
    isSuccess: boolean; 
    errorMessage: string; 
    updateDate: Date; 
    updateBy: string; 
    playerName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.smsMessageId = data["SmsMessageId"] !== undefined ? data["SmsMessageId"] : null;
            this.phoneNumber = data["PhoneNumber"] !== undefined ? data["PhoneNumber"] : null;
            this.phoneNumberWithPrefix = data["PhoneNumberWithPrefix"] !== undefined ? data["PhoneNumberWithPrefix"] : null;
            this.isSuccess = data["IsSuccess"] !== undefined ? data["IsSuccess"] : null;
            this.errorMessage = data["ErrorMessage"] !== undefined ? data["ErrorMessage"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
        }
    }

    static fromJS(data: any): SmsMessageSendLog {
        return new SmsMessageSendLog(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["SmsMessageId"] = this.smsMessageId !== undefined ? this.smsMessageId : null;
        data["PhoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null;
        data["PhoneNumberWithPrefix"] = this.phoneNumberWithPrefix !== undefined ? this.phoneNumberWithPrefix : null;
        data["IsSuccess"] = this.isSuccess !== undefined ? this.isSuccess : null;
        data["ErrorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SmsMessageSendLog(JSON.parse(json));
    }
}

export class SetFailTaskToPendingRequest { 
    smsMessageId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.smsMessageId = data["SmsMessageId"] !== undefined ? data["SmsMessageId"] : null;
        }
    }

    static fromJS(data: any): SetFailTaskToPendingRequest {
        return new SetFailTaskToPendingRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["SmsMessageId"] = this.smsMessageId !== undefined ? this.smsMessageId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SetFailTaskToPendingRequest(JSON.parse(json));
    }
}

export class SmsMessageGetForIndexRequest { 
    startDate: Date; 
    endDate: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
        }
    }

    static fromJS(data: any): SmsMessageGetForIndexRequest {
        return new SmsMessageGetForIndexRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SmsMessageGetForIndexRequest(JSON.parse(json));
    }
}

export class SmsMessageGetForAddResponse { 
    phoneNumberPrefixOptions: SelectionOption[]; 
    languageOptions: SelectionOption[]; 
    templateOptions: SelectionOption[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["PhoneNumberPrefixOptions"] && data["PhoneNumberPrefixOptions"].constructor === Array) {
                this.phoneNumberPrefixOptions = [];
                for (let item of data["PhoneNumberPrefixOptions"])
                    this.phoneNumberPrefixOptions.push(SelectionOption.fromJS(item));
            }
            if (data["LanguageOptions"] && data["LanguageOptions"].constructor === Array) {
                this.languageOptions = [];
                for (let item of data["LanguageOptions"])
                    this.languageOptions.push(SelectionOption.fromJS(item));
            }
            if (data["TemplateOptions"] && data["TemplateOptions"].constructor === Array) {
                this.templateOptions = [];
                for (let item of data["TemplateOptions"])
                    this.templateOptions.push(SelectionOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SmsMessageGetForAddResponse {
        return new SmsMessageGetForAddResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.phoneNumberPrefixOptions && this.phoneNumberPrefixOptions.constructor === Array) {
            data["PhoneNumberPrefixOptions"] = [];
            for (let item of this.phoneNumberPrefixOptions)
                data["PhoneNumberPrefixOptions"].push(item.toJS());
        }
        if (this.languageOptions && this.languageOptions.constructor === Array) {
            data["LanguageOptions"] = [];
            for (let item of this.languageOptions)
                data["LanguageOptions"].push(item.toJS());
        }
        if (this.templateOptions && this.templateOptions.constructor === Array) {
            data["TemplateOptions"] = [];
            for (let item of this.templateOptions)
                data["TemplateOptions"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SmsMessageGetForAddResponse(JSON.parse(json));
    }
}

export class SmsMessageGetForDetailRequest { 
    smsMessageId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.smsMessageId = data["SmsMessageId"] !== undefined ? data["SmsMessageId"] : null;
        }
    }

    static fromJS(data: any): SmsMessageGetForDetailRequest {
        return new SmsMessageGetForDetailRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["SmsMessageId"] = this.smsMessageId !== undefined ? this.smsMessageId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SmsMessageGetForDetailRequest(JSON.parse(json));
    }
}

export class SmsMessageGetForDetailResponse { 
    id: number; 
    taskName: string; 
    message: string; 
    createDate: Date; 
    createBy: string; 
    sendLogs: SmsMessageSendLog[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.taskName = data["TaskName"] !== undefined ? data["TaskName"] : null;
            this.message = data["Message"] !== undefined ? data["Message"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            this.createBy = data["CreateBy"] !== undefined ? data["CreateBy"] : null;
            if (data["SendLogs"] && data["SendLogs"].constructor === Array) {
                this.sendLogs = [];
                for (let item of data["SendLogs"])
                    this.sendLogs.push(SmsMessageSendLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SmsMessageGetForDetailResponse {
        return new SmsMessageGetForDetailResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["TaskName"] = this.taskName !== undefined ? this.taskName : null;
        data["Message"] = this.message !== undefined ? this.message : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        data["CreateBy"] = this.createBy !== undefined ? this.createBy : null;
        if (this.sendLogs && this.sendLogs.constructor === Array) {
            data["SendLogs"] = [];
            for (let item of this.sendLogs)
                data["SendLogs"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new SmsMessageGetForDetailResponse(JSON.parse(json));
    }
}

export class UserMessageFormDataResponse { 
    playerGroupSelections: CmsSelectionOption[]; 
    languages: LobbyLanguageResponse[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["PlayerGroupSelections"] && data["PlayerGroupSelections"].constructor === Array) {
                this.playerGroupSelections = [];
                for (let item of data["PlayerGroupSelections"])
                    this.playerGroupSelections.push(CmsSelectionOption.fromJS(item));
            }
            if (data["languages"] && data["languages"].constructor === Array) {
                this.languages = [];
                for (let item of data["languages"])
                    this.languages.push(LobbyLanguageResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserMessageFormDataResponse {
        return new UserMessageFormDataResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.playerGroupSelections && this.playerGroupSelections.constructor === Array) {
            data["PlayerGroupSelections"] = [];
            for (let item of this.playerGroupSelections)
                data["PlayerGroupSelections"].push(item.toJS());
        }
        if (this.languages && this.languages.constructor === Array) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new UserMessageFormDataResponse(JSON.parse(json));
    }
}

export class UserMessageSendRequest { 
    lobbyId: LobbyId; 
    toUserIds: number[]; 
    toLobbyPlayerLevelIds: number[]; 
    userMessageTranslations: UserMessageTranslationDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            if (data["ToUserIds"] && data["ToUserIds"].constructor === Array) {
                this.toUserIds = [];
                for (let item of data["ToUserIds"])
                    this.toUserIds.push(item);
            }
            if (data["ToLobbyPlayerLevelIds"] && data["ToLobbyPlayerLevelIds"].constructor === Array) {
                this.toLobbyPlayerLevelIds = [];
                for (let item of data["ToLobbyPlayerLevelIds"])
                    this.toLobbyPlayerLevelIds.push(item);
            }
            if (data["UserMessageTranslations"] && data["UserMessageTranslations"].constructor === Array) {
                this.userMessageTranslations = [];
                for (let item of data["UserMessageTranslations"])
                    this.userMessageTranslations.push(UserMessageTranslationDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserMessageSendRequest {
        return new UserMessageSendRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        if (this.toUserIds && this.toUserIds.constructor === Array) {
            data["ToUserIds"] = [];
            for (let item of this.toUserIds)
                data["ToUserIds"].push(item);
        }
        if (this.toLobbyPlayerLevelIds && this.toLobbyPlayerLevelIds.constructor === Array) {
            data["ToLobbyPlayerLevelIds"] = [];
            for (let item of this.toLobbyPlayerLevelIds)
                data["ToLobbyPlayerLevelIds"].push(item);
        }
        if (this.userMessageTranslations && this.userMessageTranslations.constructor === Array) {
            data["UserMessageTranslations"] = [];
            for (let item of this.userMessageTranslations)
                data["UserMessageTranslations"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new UserMessageSendRequest(JSON.parse(json));
    }
}

export class UserMessageTranslationDao { 
    languageId: LanguageCode; 
    title: string; 
    message: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.title = data["Title"] !== undefined ? data["Title"] : null;
            this.message = data["Message"] !== undefined ? data["Message"] : null;
        }
    }

    static fromJS(data: any): UserMessageTranslationDao {
        return new UserMessageTranslationDao(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["Title"] = this.title !== undefined ? this.title : null;
        data["Message"] = this.message !== undefined ? this.message : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new UserMessageTranslationDao(JSON.parse(json));
    }
}

export class UserMessageIndexRequest { 
    lobbyId: number; 
    language: LanguageCode; 
    startDate: Date; 
    endDate: Date; 
    playerName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.lobbyId = data["LobbyId"] !== undefined ? data["LobbyId"] : null;
            this.language = data["Language"] !== undefined ? data["Language"] : null;
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
        }
    }

    static fromJS(data: any): UserMessageIndexRequest {
        return new UserMessageIndexRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LobbyId"] = this.lobbyId !== undefined ? this.lobbyId : null;
        data["Language"] = this.language !== undefined ? this.language : null;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new UserMessageIndexRequest(JSON.parse(json));
    }
}

export class UserMessageIndexResponse { 
    id: number; 
    toUser: string; 
    title: string; 
    message: string; 
    date: Date;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.toUser = data["ToUser"] !== undefined ? data["ToUser"] : null;
            this.title = data["Title"] !== undefined ? data["Title"] : null;
            this.message = data["Message"] !== undefined ? data["Message"] : null;
            this.date = data["Date"] ? new Date(data["Date"].toString()) : null;
        }
    }

    static fromJS(data: any): UserMessageIndexResponse {
        return new UserMessageIndexResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["ToUser"] = this.toUser !== undefined ? this.toUser : null;
        data["Title"] = this.title !== undefined ? this.title : null;
        data["Message"] = this.message !== undefined ? this.message : null;
        data["Date"] = this.date ? this.date.toISOString() : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new UserMessageIndexResponse(JSON.parse(json));
    }
}

export class UM_GetDetail_Response { 
    toUser: string; 
    title: string; 
    message: string; 
    createDate: Date; 
    detailTranslations: UM_DetailTranslation[];

    constructor(data?: any) {
        if (data !== undefined) {
            this.toUser = data["ToUser"] !== undefined ? data["ToUser"] : null;
            this.title = data["Title"] !== undefined ? data["Title"] : null;
            this.message = data["Message"] !== undefined ? data["Message"] : null;
            this.createDate = data["CreateDate"] ? new Date(data["CreateDate"].toString()) : null;
            if (data["DetailTranslations"] && data["DetailTranslations"].constructor === Array) {
                this.detailTranslations = [];
                for (let item of data["DetailTranslations"])
                    this.detailTranslations.push(UM_DetailTranslation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UM_GetDetail_Response {
        return new UM_GetDetail_Response(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["ToUser"] = this.toUser !== undefined ? this.toUser : null;
        data["Title"] = this.title !== undefined ? this.title : null;
        data["Message"] = this.message !== undefined ? this.message : null;
        data["CreateDate"] = this.createDate ? this.createDate.toISOString() : null;
        if (this.detailTranslations && this.detailTranslations.constructor === Array) {
            data["DetailTranslations"] = [];
            for (let item of this.detailTranslations)
                data["DetailTranslations"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new UM_GetDetail_Response(JSON.parse(json));
    }
}

export class UM_DetailTranslation { 
    languageId: number; 
    languageName: string; 
    title: string; 
    message: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.languageName = data["LanguageName"] !== undefined ? data["LanguageName"] : null;
            this.title = data["Title"] !== undefined ? data["Title"] : null;
            this.message = data["Message"] !== undefined ? data["Message"] : null;
        }
    }

    static fromJS(data: any): UM_DetailTranslation {
        return new UM_DetailTranslation(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["LanguageName"] = this.languageName !== undefined ? this.languageName : null;
        data["Title"] = this.title !== undefined ? this.title : null;
        data["Message"] = this.message !== undefined ? this.message : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new UM_DetailTranslation(JSON.parse(json));
    }
}

export class WithdrawGetPlayerSummaryRequest { 
    playerId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
        }
    }

    static fromJS(data: any): WithdrawGetPlayerSummaryRequest {
        return new WithdrawGetPlayerSummaryRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new WithdrawGetPlayerSummaryRequest(JSON.parse(json));
    }
}

export class PlayerSummaryDetail { 
    depositAmount: number; 
    withdrawAmount: number; 
    betAmount: number; 
    validBetAmount: number; 
    rebateAmount: number; 
    promotionGainAmount: number; 
    netWinLoss: number; 
    netWinLossPercentage: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.depositAmount = data["DepositAmount"] !== undefined ? data["DepositAmount"] : null;
            this.withdrawAmount = data["WithdrawAmount"] !== undefined ? data["WithdrawAmount"] : null;
            this.betAmount = data["BetAmount"] !== undefined ? data["BetAmount"] : null;
            this.validBetAmount = data["ValidBetAmount"] !== undefined ? data["ValidBetAmount"] : null;
            this.rebateAmount = data["RebateAmount"] !== undefined ? data["RebateAmount"] : null;
            this.promotionGainAmount = data["PromotionGainAmount"] !== undefined ? data["PromotionGainAmount"] : null;
            this.netWinLoss = data["NetWinLoss"] !== undefined ? data["NetWinLoss"] : null;
            this.netWinLossPercentage = data["NetWinLossPercentage"] !== undefined ? data["NetWinLossPercentage"] : null;
        }
    }

    static fromJS(data: any): PlayerSummaryDetail {
        return new PlayerSummaryDetail(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["DepositAmount"] = this.depositAmount !== undefined ? this.depositAmount : null;
        data["WithdrawAmount"] = this.withdrawAmount !== undefined ? this.withdrawAmount : null;
        data["BetAmount"] = this.betAmount !== undefined ? this.betAmount : null;
        data["ValidBetAmount"] = this.validBetAmount !== undefined ? this.validBetAmount : null;
        data["RebateAmount"] = this.rebateAmount !== undefined ? this.rebateAmount : null;
        data["PromotionGainAmount"] = this.promotionGainAmount !== undefined ? this.promotionGainAmount : null;
        data["NetWinLoss"] = this.netWinLoss !== undefined ? this.netWinLoss : null;
        data["NetWinLossPercentage"] = this.netWinLossPercentage !== undefined ? this.netWinLossPercentage : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerSummaryDetail(JSON.parse(json));
    }
}

export class PlayerSummary extends PlayerSummaryDetail { 
    playerName: string; 
    playerRealName: string; 
    registerDate: Date; 
    registerDays: number; 
    winDays: number; 
    loseDays: number; 
    betDays: number; 
    monthDetails: MonthDetail[];

    constructor(data?: any) {
        super(data);
        if (data !== undefined) {
            this.playerName = data["PlayerName"] !== undefined ? data["PlayerName"] : null;
            this.playerRealName = data["PlayerRealName"] !== undefined ? data["PlayerRealName"] : null;
            this.registerDate = data["RegisterDate"] ? new Date(data["RegisterDate"].toString()) : null;
            this.registerDays = data["RegisterDays"] !== undefined ? data["RegisterDays"] : null;
            this.winDays = data["WinDays"] !== undefined ? data["WinDays"] : null;
            this.loseDays = data["LoseDays"] !== undefined ? data["LoseDays"] : null;
            this.betDays = data["BetDays"] !== undefined ? data["BetDays"] : null;
            if (data["MonthDetails"] && data["MonthDetails"].constructor === Array) {
                this.monthDetails = [];
                for (let item of data["MonthDetails"])
                    this.monthDetails.push(MonthDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlayerSummary {
        return new PlayerSummary(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerName"] = this.playerName !== undefined ? this.playerName : null;
        data["PlayerRealName"] = this.playerRealName !== undefined ? this.playerRealName : null;
        data["RegisterDate"] = this.registerDate ? this.registerDate.toISOString() : null;
        data["RegisterDays"] = this.registerDays !== undefined ? this.registerDays : null;
        data["WinDays"] = this.winDays !== undefined ? this.winDays : null;
        data["LoseDays"] = this.loseDays !== undefined ? this.loseDays : null;
        data["BetDays"] = this.betDays !== undefined ? this.betDays : null;
        if (this.monthDetails && this.monthDetails.constructor === Array) {
            data["MonthDetails"] = [];
            for (let item of this.monthDetails)
                data["MonthDetails"].push(item.toJS());
        }
        super.toJS(data);
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new PlayerSummary(JSON.parse(json));
    }
}

export class MonthDetail extends PlayerSummaryDetail { 
    year: number; 
    month: number; 
    dayDetails: DayDetail[];

    constructor(data?: any) {
        super(data);
        if (data !== undefined) {
            this.year = data["Year"] !== undefined ? data["Year"] : null;
            this.month = data["Month"] !== undefined ? data["Month"] : null;
            if (data["DayDetails"] && data["DayDetails"].constructor === Array) {
                this.dayDetails = [];
                for (let item of data["DayDetails"])
                    this.dayDetails.push(DayDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonthDetail {
        return new MonthDetail(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Year"] = this.year !== undefined ? this.year : null;
        data["Month"] = this.month !== undefined ? this.month : null;
        if (this.dayDetails && this.dayDetails.constructor === Array) {
            data["DayDetails"] = [];
            for (let item of this.dayDetails)
                data["DayDetails"].push(item.toJS());
        }
        super.toJS(data);
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new MonthDetail(JSON.parse(json));
    }
}

export class DayDetail extends PlayerSummaryDetail { 
    date: Date;

    constructor(data?: any) {
        super(data);
        if (data !== undefined) {
            this.date = data["Date"] ? new Date(data["Date"].toString()) : null;
        }
    }

    static fromJS(data: any): DayDetail {
        return new DayDetail(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Date"] = this.date ? this.date.toISOString() : null;
        super.toJS(data);
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new DayDetail(JSON.parse(json));
    }
}

export class WithdrawGetByDateRangeRequest { 
    startDate: Date; 
    endDate: Date; 
    showAllNotComplete: boolean; 
    transactionStatusId: number; 
    transactionTypeId: NewTransactionTypeId; 
    userName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.showAllNotComplete = data["showAllNotComplete"] !== undefined ? data["showAllNotComplete"] : null;
            this.transactionStatusId = data["transactionStatusId"] !== undefined ? data["transactionStatusId"] : null;
            this.transactionTypeId = data["transactionTypeId"] !== undefined ? data["transactionTypeId"] : null;
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
        }
    }

    static fromJS(data: any): WithdrawGetByDateRangeRequest {
        return new WithdrawGetByDateRangeRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["showAllNotComplete"] = this.showAllNotComplete !== undefined ? this.showAllNotComplete : null;
        data["transactionStatusId"] = this.transactionStatusId !== undefined ? this.transactionStatusId : null;
        data["transactionTypeId"] = this.transactionTypeId !== undefined ? this.transactionTypeId : null;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new WithdrawGetByDateRangeRequest(JSON.parse(json));
    }
}

export class WithdrawListResponse { 
    items: WithdrawListItemResponse[]; 
    isSupportOnlineWithdraw: boolean; 
    playerWithdrawStatusSection: CmsSelectionOptionDao[]; 
    transcationTypeSection: CmsSelectionOptionDao[]; 
    fundoutStatus: FundOutStatusId;

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["Items"] && data["Items"].constructor === Array) {
                this.items = [];
                for (let item of data["Items"])
                    this.items.push(WithdrawListItemResponse.fromJS(item));
            }
            this.isSupportOnlineWithdraw = data["IsSupportOnlineWithdraw"] !== undefined ? data["IsSupportOnlineWithdraw"] : null;
            if (data["PlayerWithdrawStatusSection"] && data["PlayerWithdrawStatusSection"].constructor === Array) {
                this.playerWithdrawStatusSection = [];
                for (let item of data["PlayerWithdrawStatusSection"])
                    this.playerWithdrawStatusSection.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["TranscationTypeSection"] && data["TranscationTypeSection"].constructor === Array) {
                this.transcationTypeSection = [];
                for (let item of data["TranscationTypeSection"])
                    this.transcationTypeSection.push(CmsSelectionOptionDao.fromJS(item));
            }
            this.fundoutStatus = data["FundoutStatus"] !== undefined ? data["FundoutStatus"] : null;
        }
    }

    static fromJS(data: any): WithdrawListResponse {
        return new WithdrawListResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.items && this.items.constructor === Array) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJS());
        }
        data["IsSupportOnlineWithdraw"] = this.isSupportOnlineWithdraw !== undefined ? this.isSupportOnlineWithdraw : null;
        if (this.playerWithdrawStatusSection && this.playerWithdrawStatusSection.constructor === Array) {
            data["PlayerWithdrawStatusSection"] = [];
            for (let item of this.playerWithdrawStatusSection)
                data["PlayerWithdrawStatusSection"].push(item.toJS());
        }
        if (this.transcationTypeSection && this.transcationTypeSection.constructor === Array) {
            data["TranscationTypeSection"] = [];
            for (let item of this.transcationTypeSection)
                data["TranscationTypeSection"].push(item.toJS());
        }
        data["FundoutStatus"] = this.fundoutStatus !== undefined ? this.fundoutStatus : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new WithdrawListResponse(JSON.parse(json));
    }
}

export class WithdrawListItemResponse { 
    id: number; 
    playerWithdrawStatusId: PlayerWithdrawStatusId; 
    transactionNo: string; 
    currency: string; 
    playerId: number; 
    playerLoginName: string; 
    status: string; 
    amount: number; 
    bankAccountNo: string; 
    bankAccountUsername: string; 
    playerBank: string; 
    province: string; 
    city: string; 
    branch: string; 
    remark: string; 
    remarkByAdmin: string; 
    isComplete: boolean; 
    withdrawDate: Date; 
    ip: string; 
    updateDate: Date; 
    updateBy: string; 
    rejectReason: string; 
    languageId: LanguageCode; 
    playerGroupColor: string; 
    agentCode: string; 
    paymentPlatformId: PaymentGatewayPlatformId; 
    paymentPlatformName: string; 
    thirdPartyTransactionId: string; 
    playerGroup: string; 
    playerLevel: string; 
    latestSettleDepositDate: Date; 
    billedAmount: number; 
    actualAmount: number; 
    billedCurrencyId: CurrencyId; 
    billedCurrency: string; 
    address: string; 
    rate: number; 
    fee: number; 
    transactionHashId: string; 
    transactionHashUrl: string; 
    lobbyPlayerGroupId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.playerWithdrawStatusId = data["PlayerWithdrawStatusId"] !== undefined ? data["PlayerWithdrawStatusId"] : null;
            this.transactionNo = data["TransactionNo"] !== undefined ? data["TransactionNo"] : null;
            this.currency = data["Currency"] !== undefined ? data["Currency"] : null;
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.playerLoginName = data["PlayerLoginName"] !== undefined ? data["PlayerLoginName"] : null;
            this.status = data["Status"] !== undefined ? data["Status"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.bankAccountNo = data["BankAccountNo"] !== undefined ? data["BankAccountNo"] : null;
            this.bankAccountUsername = data["BankAccountUsername"] !== undefined ? data["BankAccountUsername"] : null;
            this.playerBank = data["PlayerBank"] !== undefined ? data["PlayerBank"] : null;
            this.province = data["Province"] !== undefined ? data["Province"] : null;
            this.city = data["City"] !== undefined ? data["City"] : null;
            this.branch = data["Branch"] !== undefined ? data["Branch"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
            this.remarkByAdmin = data["RemarkByAdmin"] !== undefined ? data["RemarkByAdmin"] : null;
            this.isComplete = data["IsComplete"] !== undefined ? data["IsComplete"] : null;
            this.withdrawDate = data["WithdrawDate"] ? new Date(data["WithdrawDate"].toString()) : null;
            this.ip = data["Ip"] !== undefined ? data["Ip"] : null;
            this.updateDate = data["UpdateDate"] ? new Date(data["UpdateDate"].toString()) : null;
            this.updateBy = data["UpdateBy"] !== undefined ? data["UpdateBy"] : null;
            this.rejectReason = data["RejectReason"] !== undefined ? data["RejectReason"] : null;
            this.languageId = data["LanguageId"] !== undefined ? data["LanguageId"] : null;
            this.playerGroupColor = data["PlayerGroupColor"] !== undefined ? data["PlayerGroupColor"] : null;
            this.agentCode = data["AgentCode"] !== undefined ? data["AgentCode"] : null;
            this.paymentPlatformId = data["PaymentPlatformId"] !== undefined ? data["PaymentPlatformId"] : null;
            this.paymentPlatformName = data["PaymentPlatformName"] !== undefined ? data["PaymentPlatformName"] : null;
            this.thirdPartyTransactionId = data["ThirdPartyTransactionId"] !== undefined ? data["ThirdPartyTransactionId"] : null;
            this.playerGroup = data["PlayerGroup"] !== undefined ? data["PlayerGroup"] : null;
            this.playerLevel = data["PlayerLevel"] !== undefined ? data["PlayerLevel"] : null;
            this.latestSettleDepositDate = data["LatestSettleDepositDate"] ? new Date(data["LatestSettleDepositDate"].toString()) : null;
            this.billedAmount = data["BilledAmount"] !== undefined ? data["BilledAmount"] : null;
            this.actualAmount = data["ActualAmount"] !== undefined ? data["ActualAmount"] : null;
            this.billedCurrencyId = data["BilledCurrencyId"] !== undefined ? data["BilledCurrencyId"] : null;
            this.billedCurrency = data["BilledCurrency"] !== undefined ? data["BilledCurrency"] : null;
            this.address = data["Address"] !== undefined ? data["Address"] : null;
            this.rate = data["Rate"] !== undefined ? data["Rate"] : null;
            this.fee = data["Fee"] !== undefined ? data["Fee"] : null;
            this.transactionHashId = data["TransactionHashId"] !== undefined ? data["TransactionHashId"] : null;
            this.transactionHashUrl = data["TransactionHashUrl"] !== undefined ? data["TransactionHashUrl"] : null;
            this.lobbyPlayerGroupId = data["LobbyPlayerGroupId"] !== undefined ? data["LobbyPlayerGroupId"] : null;
        }
    }

    static fromJS(data: any): WithdrawListItemResponse {
        return new WithdrawListItemResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["PlayerWithdrawStatusId"] = this.playerWithdrawStatusId !== undefined ? this.playerWithdrawStatusId : null;
        data["TransactionNo"] = this.transactionNo !== undefined ? this.transactionNo : null;
        data["Currency"] = this.currency !== undefined ? this.currency : null;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["PlayerLoginName"] = this.playerLoginName !== undefined ? this.playerLoginName : null;
        data["Status"] = this.status !== undefined ? this.status : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["BankAccountNo"] = this.bankAccountNo !== undefined ? this.bankAccountNo : null;
        data["BankAccountUsername"] = this.bankAccountUsername !== undefined ? this.bankAccountUsername : null;
        data["PlayerBank"] = this.playerBank !== undefined ? this.playerBank : null;
        data["Province"] = this.province !== undefined ? this.province : null;
        data["City"] = this.city !== undefined ? this.city : null;
        data["Branch"] = this.branch !== undefined ? this.branch : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        data["RemarkByAdmin"] = this.remarkByAdmin !== undefined ? this.remarkByAdmin : null;
        data["IsComplete"] = this.isComplete !== undefined ? this.isComplete : null;
        data["WithdrawDate"] = this.withdrawDate ? this.withdrawDate.toISOString() : null;
        data["Ip"] = this.ip !== undefined ? this.ip : null;
        data["UpdateDate"] = this.updateDate ? this.updateDate.toISOString() : null;
        data["UpdateBy"] = this.updateBy !== undefined ? this.updateBy : null;
        data["RejectReason"] = this.rejectReason !== undefined ? this.rejectReason : null;
        data["LanguageId"] = this.languageId !== undefined ? this.languageId : null;
        data["PlayerGroupColor"] = this.playerGroupColor !== undefined ? this.playerGroupColor : null;
        data["AgentCode"] = this.agentCode !== undefined ? this.agentCode : null;
        data["PaymentPlatformId"] = this.paymentPlatformId !== undefined ? this.paymentPlatformId : null;
        data["PaymentPlatformName"] = this.paymentPlatformName !== undefined ? this.paymentPlatformName : null;
        data["ThirdPartyTransactionId"] = this.thirdPartyTransactionId !== undefined ? this.thirdPartyTransactionId : null;
        data["PlayerGroup"] = this.playerGroup !== undefined ? this.playerGroup : null;
        data["PlayerLevel"] = this.playerLevel !== undefined ? this.playerLevel : null;
        data["LatestSettleDepositDate"] = this.latestSettleDepositDate ? this.latestSettleDepositDate.toISOString() : null;
        data["BilledAmount"] = this.billedAmount !== undefined ? this.billedAmount : null;
        data["ActualAmount"] = this.actualAmount !== undefined ? this.actualAmount : null;
        data["BilledCurrencyId"] = this.billedCurrencyId !== undefined ? this.billedCurrencyId : null;
        data["BilledCurrency"] = this.billedCurrency !== undefined ? this.billedCurrency : null;
        data["Address"] = this.address !== undefined ? this.address : null;
        data["Rate"] = this.rate !== undefined ? this.rate : null;
        data["Fee"] = this.fee !== undefined ? this.fee : null;
        data["TransactionHashId"] = this.transactionHashId !== undefined ? this.transactionHashId : null;
        data["TransactionHashUrl"] = this.transactionHashUrl !== undefined ? this.transactionHashUrl : null;
        data["LobbyPlayerGroupId"] = this.lobbyPlayerGroupId !== undefined ? this.lobbyPlayerGroupId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new WithdrawListItemResponse(JSON.parse(json));
    }
}

export enum PlayerWithdrawStatusId {
    PENDING = 1, 
    REJECTED = 2, 
    SETTLE = 4, 
    UNDER_REVIEW = 5, 
    FOLLOWING = 6, 
    PAYMENT_FUNDOUT = 7, 
    FAIL = 8, 
}

export class WithdrawGetCryptocurrencyByDateRangeRequest { 
    startDate: Date; 
    endDate: Date; 
    showAllNotComplete: boolean; 
    transactionStatusId: number; 
    userName: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.startDate = data["StartDate"] ? new Date(data["StartDate"].toString()) : null;
            this.endDate = data["EndDate"] ? new Date(data["EndDate"].toString()) : null;
            this.showAllNotComplete = data["showAllNotComplete"] !== undefined ? data["showAllNotComplete"] : null;
            this.transactionStatusId = data["transactionStatusId"] !== undefined ? data["transactionStatusId"] : null;
            this.userName = data["UserName"] !== undefined ? data["UserName"] : null;
        }
    }

    static fromJS(data: any): WithdrawGetCryptocurrencyByDateRangeRequest {
        return new WithdrawGetCryptocurrencyByDateRangeRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["StartDate"] = this.startDate ? this.startDate.toISOString() : null;
        data["EndDate"] = this.endDate ? this.endDate.toISOString() : null;
        data["showAllNotComplete"] = this.showAllNotComplete !== undefined ? this.showAllNotComplete : null;
        data["transactionStatusId"] = this.transactionStatusId !== undefined ? this.transactionStatusId : null;
        data["UserName"] = this.userName !== undefined ? this.userName : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new WithdrawGetCryptocurrencyByDateRangeRequest(JSON.parse(json));
    }
}

export class WithdrawCryptocurrencyResponse { 
    items: WithdrawListItemResponse[]; 
    playerWithdrawStatusSection: CmsSelectionOptionDao[]; 
    transcationTypeSection: CmsSelectionOptionDao[];

    constructor(data?: any) {
        if (data !== undefined) {
            if (data["Items"] && data["Items"].constructor === Array) {
                this.items = [];
                for (let item of data["Items"])
                    this.items.push(WithdrawListItemResponse.fromJS(item));
            }
            if (data["PlayerWithdrawStatusSection"] && data["PlayerWithdrawStatusSection"].constructor === Array) {
                this.playerWithdrawStatusSection = [];
                for (let item of data["PlayerWithdrawStatusSection"])
                    this.playerWithdrawStatusSection.push(CmsSelectionOptionDao.fromJS(item));
            }
            if (data["TranscationTypeSection"] && data["TranscationTypeSection"].constructor === Array) {
                this.transcationTypeSection = [];
                for (let item of data["TranscationTypeSection"])
                    this.transcationTypeSection.push(CmsSelectionOptionDao.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WithdrawCryptocurrencyResponse {
        return new WithdrawCryptocurrencyResponse(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        if (this.items && this.items.constructor === Array) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJS());
        }
        if (this.playerWithdrawStatusSection && this.playerWithdrawStatusSection.constructor === Array) {
            data["PlayerWithdrawStatusSection"] = [];
            for (let item of this.playerWithdrawStatusSection)
                data["PlayerWithdrawStatusSection"].push(item.toJS());
        }
        if (this.transcationTypeSection && this.transcationTypeSection.constructor === Array) {
            data["TranscationTypeSection"] = [];
            for (let item of this.transcationTypeSection)
                data["TranscationTypeSection"].push(item.toJS());
        }
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new WithdrawCryptocurrencyResponse(JSON.parse(json));
    }
}

export class W_ResetAndSettle_Request { 
    playerAmountRecordId: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerAmountRecordId = data["PlayerAmountRecordId"] !== undefined ? data["PlayerAmountRecordId"] : null;
        }
    }

    static fromJS(data: any): W_ResetAndSettle_Request {
        return new W_ResetAndSettle_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerAmountRecordId"] = this.playerAmountRecordId !== undefined ? this.playerAmountRecordId : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new W_ResetAndSettle_Request(JSON.parse(json));
    }
}

export class W_Settle_Request { 
    id: number;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["id"] !== undefined ? data["id"] : null;
        }
    }

    static fromJS(data: any): W_Settle_Request {
        return new W_Settle_Request(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["id"] = this.id !== undefined ? this.id : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new W_Settle_Request(JSON.parse(json));
    }
}

export class WithdrawRejectRequest { 
    id: number; 
    rejectReason: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.rejectReason = data["RejectReason"] !== undefined ? data["RejectReason"] : null;
        }
    }

    static fromJS(data: any): WithdrawRejectRequest {
        return new WithdrawRejectRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["RejectReason"] = this.rejectReason !== undefined ? this.rejectReason : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new WithdrawRejectRequest(JSON.parse(json));
    }
}

export class WithdrawReviewRequest { 
    id: number; 
    reviewReason: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.id = data["Id"] !== undefined ? data["Id"] : null;
            this.reviewReason = data["ReviewReason"] !== undefined ? data["ReviewReason"] : null;
        }
    }

    static fromJS(data: any): WithdrawReviewRequest {
        return new WithdrawReviewRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["Id"] = this.id !== undefined ? this.id : null;
        data["ReviewReason"] = this.reviewReason !== undefined ? this.reviewReason : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new WithdrawReviewRequest(JSON.parse(json));
    }
}

export class WithdrawByAdminSubmitRequest { 
    playerId: number; 
    amount: number; 
    bankAccountNo: string; 
    bankAccountUsername: string; 
    lobbyBankId: number; 
    province: string; 
    city: string; 
    remark: string;

    constructor(data?: any) {
        if (data !== undefined) {
            this.playerId = data["PlayerId"] !== undefined ? data["PlayerId"] : null;
            this.amount = data["Amount"] !== undefined ? data["Amount"] : null;
            this.bankAccountNo = data["BankAccountNo"] !== undefined ? data["BankAccountNo"] : null;
            this.bankAccountUsername = data["BankAccountUsername"] !== undefined ? data["BankAccountUsername"] : null;
            this.lobbyBankId = data["LobbyBankId"] !== undefined ? data["LobbyBankId"] : null;
            this.province = data["Province"] !== undefined ? data["Province"] : null;
            this.city = data["City"] !== undefined ? data["City"] : null;
            this.remark = data["Remark"] !== undefined ? data["Remark"] : null;
        }
    }

    static fromJS(data: any): WithdrawByAdminSubmitRequest {
        return new WithdrawByAdminSubmitRequest(data);
    }

    toJS(data?: any) {
        data = data === undefined ? {} : data;
        data["PlayerId"] = this.playerId !== undefined ? this.playerId : null;
        data["Amount"] = this.amount !== undefined ? this.amount : null;
        data["BankAccountNo"] = this.bankAccountNo !== undefined ? this.bankAccountNo : null;
        data["BankAccountUsername"] = this.bankAccountUsername !== undefined ? this.bankAccountUsername : null;
        data["LobbyBankId"] = this.lobbyBankId !== undefined ? this.lobbyBankId : null;
        data["Province"] = this.province !== undefined ? this.province : null;
        data["City"] = this.city !== undefined ? this.city : null;
        data["Remark"] = this.remark !== undefined ? this.remark : null;
        return data; 
    }

    toJSON() {
        return JSON.stringify(this.toJS());
    }

    clone() {
        const json = this.toJSON();
        return new WithdrawByAdminSubmitRequest(JSON.parse(json));
    }
}

export enum Response {
    Promo_LobbyPromotionTypeId = 1, 
    Promo_DetailImage = 2, 
    Promo_DetailImageMobile = 3, 
    BankAccountToPlayerLevel = 4, 
    BankAccountToPlayerGroup = 5, 
}

export interface FileParameter
{
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    result?: any; 

    constructor(message: string, status: number, response: string, result?: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.result = result;
    }
}